/*! For license information please see checkout.lib.js.LICENSE.txt */
!function(root, factory) {
    "object" == typeof exports && "object" == typeof module ? module.exports = factory() : "function" == typeof define && define.amd ? define("paypal", [], factory) : "object" == typeof exports ? exports.paypal = factory() : root.paypal = factory();
}("undefined" != typeof self ? self : this, (function() {
    return function(modules) {
        var installedModules = {};
        function __webpack_require__(moduleId) {
            if (installedModules[moduleId]) return installedModules[moduleId].exports;
            var module = installedModules[moduleId] = {
                i: moduleId,
                l: !1,
                exports: {}
            };
            modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            module.l = !0;
            return module.exports;
        }
        __webpack_require__.m = modules;
        __webpack_require__.c = installedModules;
        __webpack_require__.d = function(exports, name, getter) {
            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
                enumerable: !0,
                get: getter
            });
        };
        __webpack_require__.r = function(exports) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            Object.defineProperty(exports, "__esModule", {
                value: !0
            });
        };
        __webpack_require__.t = function(value, mode) {
            1 & mode && (value = __webpack_require__(value));
            if (8 & mode) return value;
            if (4 & mode && "object" == typeof value && value && value.__esModule) return value;
            var ns = Object.create(null);
            __webpack_require__.r(ns);
            Object.defineProperty(ns, "default", {
                enumerable: !0,
                value: value
            });
            if (2 & mode && "string" != typeof value) for (var key in value) __webpack_require__.d(ns, key, function(key) {
                return value[key];
            }.bind(null, key));
            return ns;
        };
        __webpack_require__.n = function(module) {
            var getter = module && module.__esModule ? function() {
                return module.default;
            } : function() {
                return module;
            };
            __webpack_require__.d(getter, "a", getter);
            return getter;
        };
        __webpack_require__.o = function(object, property) {
            return {}.hasOwnProperty.call(object, property);
        };
        __webpack_require__.p = "";
        return __webpack_require__(__webpack_require__.s = 48);
    }([ function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "m", (function() {
            return BUTTON_STYLE_OPTIONS;
        }));
        __webpack_require__.d(__webpack_exports__, "f", (function() {
            return BUTTON_LABEL;
        }));
        __webpack_require__.d(__webpack_exports__, "e", (function() {
            return BUTTON_COLOR;
        }));
        __webpack_require__.d(__webpack_exports__, "i", (function() {
            return BUTTON_LOGO_COLOR;
        }));
        __webpack_require__.d(__webpack_exports__, "l", (function() {
            return BUTTON_SIZE;
        }));
        __webpack_require__.d(__webpack_exports__, "n", (function() {
            return BUTTON_TAGLINE_COLOR;
        }));
        __webpack_require__.d(__webpack_exports__, "k", (function() {
            return BUTTON_SHAPE;
        }));
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return BUTTON_BRANDING;
        }));
        __webpack_require__.d(__webpack_exports__, "g", (function() {
            return BUTTON_LAYOUT;
        }));
        __webpack_require__.d(__webpack_exports__, "j", (function() {
            return BUTTON_NUMBER;
        }));
        __webpack_require__.d(__webpack_exports__, "h", (function() {
            return BUTTON_LOGO;
        }));
        __webpack_require__.d(__webpack_exports__, "q", (function() {
            return CHECKOUT_OVERLAY_COLOR;
        }));
        __webpack_require__.d(__webpack_exports__, "v", (function() {
            return FUNDING;
        }));
        __webpack_require__.d(__webpack_exports__, "w", (function() {
            return FUNDING_BRAND_LABEL;
        }));
        __webpack_require__.d(__webpack_exports__, "o", (function() {
            return CARD;
        }));
        __webpack_require__.d(__webpack_exports__, "x", (function() {
            return FUNDING_ELIGIBILITY_REASON;
        }));
        __webpack_require__.d(__webpack_exports__, "p", (function() {
            return CARD_PRIORITY;
        }));
        __webpack_require__.d(__webpack_exports__, "u", (function() {
            return FPTI;
        }));
        __webpack_require__.d(__webpack_exports__, "r", (function() {
            return COUNTRY;
        }));
        __webpack_require__.d(__webpack_exports__, "y", (function() {
            return LANG;
        }));
        __webpack_require__.d(__webpack_exports__, "z", (function() {
            return LANG_TO_DEFAULT_COUNTRY;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return ALLOWED_INSTALLMENT_COUNTRIES;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return ALLOWED_INSTALLMENT_PERIOD;
        }));
        __webpack_require__.d(__webpack_exports__, "t", (function() {
            return ENV;
        }));
        __webpack_require__.d(__webpack_exports__, "G", (function() {
            return USERS;
        }));
        __webpack_require__.d(__webpack_exports__, "F", (function() {
            return SOURCE;
        }));
        __webpack_require__.d(__webpack_exports__, "B", (function() {
            return LOG_LEVEL;
        }));
        __webpack_require__.d(__webpack_exports__, "C", (function() {
            return PAYMENT_TYPE;
        }));
        __webpack_require__.d(__webpack_exports__, "E", (function() {
            return PPTM_ID;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return ATTRIBUTE;
        }));
        __webpack_require__.d(__webpack_exports__, "D", (function() {
            return PLATFORM;
        }));
        __webpack_require__.d(__webpack_exports__, "s", (function() {
            return DEFAULT;
        }));
        __webpack_require__.d(__webpack_exports__, "A", (function() {
            return LOCALE;
        }));
        var BUTTON_STYLE_OPTIONS = {
            LABEL: "label",
            SIZE: "size",
            SHAPE: "shape",
            COLOR: "color",
            LAYOUT: "layout",
            MAXBUTTONS: "maxbuttons",
            FUNDINGICONS: "fundingicons",
            BRANDING: "branding",
            TAGLINE: "tagline",
            HEIGHT: "height",
            INSTALLMENTPERIOD: "installmentperiod"
        };
        var BUTTON_LABEL = {
            PAYPAL: "paypal",
            CHECKOUT: "checkout",
            PAY: "pay",
            CREDIT: "credit",
            CARD: "card",
            BUYNOW: "buynow",
            INSTALLMENT: "installment",
            VENMO: "venmo",
            ITAU: "itau",
            IDEAL: "ideal",
            ELV: "elv",
            BANCONTACT: "bancontact",
            GIROPAY: "giropay",
            SOFORT: "sofort",
            EPS: "eps",
            MYBANK: "mybank",
            P24: "p24",
            BLIK: "blik",
            MAXIMA: "maxima",
            BOLETO: "boleto",
            OXXO: "oxxo",
            MERCADOPAGO: "mercadopago"
        };
        var BUTTON_COLOR = {
            GOLD: "gold",
            BLUE: "blue",
            SILVER: "silver",
            BLACK: "black",
            DARKBLUE: "darkblue",
            WHITE: "white",
            TRANSPARENT: "transparent"
        };
        var BUTTON_LOGO_COLOR = {
            BLUE: "blue",
            WHITE: "white",
            BLACK: "black",
            ANY: "any"
        };
        var BUTTON_SIZE = {
            TINY: "tiny",
            SMALL: "small",
            MEDIUM: "medium",
            LARGE: "large",
            HUGE: "huge",
            RESPONSIVE: "responsive"
        };
        var BUTTON_TAGLINE_COLOR = {
            BLACK: "black",
            BLUE: "blue"
        };
        var BUTTON_SHAPE = {
            PILL: "pill",
            RECT: "rect"
        };
        var BUTTON_BRANDING = {
            BRANDED: "branded",
            UNBRANDED: "unbranded"
        };
        var BUTTON_LAYOUT = {
            HORIZONTAL: "horizontal",
            VERTICAL: "vertical"
        };
        var BUTTON_NUMBER = {
            SINGLE: "single",
            MULTIPLE: "multiple"
        };
        var BUTTON_LOGO = {
            PP: "pp",
            PAYPAL: "paypal",
            VENMO: "venmo",
            ITAU: "itau",
            CREDIT: "credit",
            IDEAL: "ideal",
            ELV: "elv",
            BANCONTACT: "bancontact",
            GIROPAY: "giropay",
            SOFORT: "sofort",
            EPS: "eps",
            MYBANK: "mybank",
            P24: "p24",
            BLIK: "blik",
            MAXIMA: "maxima",
            BOLETO: "boleto",
            OXXO: "oxxo",
            MERCADOPAGO: "mercadopago"
        };
        var CHECKOUT_OVERLAY_COLOR = {
            BLACK: "black",
            WHITE: "white"
        };
        var FUNDING = {
            PAYPAL: "paypal",
            VENMO: "venmo",
            ITAU: "itau",
            CREDIT: "credit",
            CARD: "card",
            IDEAL: "ideal",
            ELV: "elv",
            BANCONTACT: "bancontact",
            GIROPAY: "giropay",
            SOFORT: "sofort",
            EPS: "eps",
            MYBANK: "mybank",
            P24: "p24",
            ZIMPLER: "zimpler",
            BLIK: "blik",
            MAXIMA: "maxima",
            BOLETO: "boleto",
            OXXO: "oxxo",
            MERCADOPAGO: "mercadopago"
        };
        var FUNDING_BRAND_LABEL = {
            PAYPAL: "PayPal",
            CREDIT: "PayPal Credit",
            CARD: "Debit or Credit Card"
        };
        var CARD = {
            VISA: "visa",
            MASTERCARD: "mastercard",
            AMEX: "amex",
            DISCOVER: "discover",
            SWITCH: "switch",
            MAESTRO: "maestro",
            HIPER: "hiper",
            ELO: "elo",
            JCB: "jcb",
            CUP: "cup",
            COFINOGA: "cofinoga",
            COFIDIS: "cofidis",
            CETELEM: "cetelem",
            CBNATIONALE: "cbnationale"
        };
        var FUNDING_ELIGIBILITY_REASON = {
            PRIMARY: "The funding source is the primary source",
            NOT_ENABLED: "The funding source is not currently enabled for use",
            SECONDARY_DISALLOWED: "The funding source is disallowed as a secondary button",
            OPT_OUT: "The funding source was disallowed in funding.disallowed",
            OPT_IN: "The funding source was allowed in funding.allowed",
            DISALLOWED_COUNTRY: "The funding source is not enabled for the current locale",
            DEFAULT_COUNTRY: "The funding source is enabled by default for the current locale",
            DEFAULT: "The funding source is enabled by default for all users",
            REMEMBERED: "The funding source was remembered for the current user",
            NEED_OPT_IN: "The funding source needs to be allowed in funding.allowed",
            COMMIT_NOT_SET: "The funding source is not enabled when commit is not set as true",
            INVALID_ENV: "The funding source is not supported in this environment"
        };
        var CARD_PRIORITY = [ CARD.VISA, CARD.MASTERCARD, CARD.AMEX, CARD.DISCOVER, CARD.SWITCH, CARD.MAESTRO, CARD.HIPER, CARD.ELO, CARD.JCB, CARD.CUP, CARD.COFINOGA, CARD.COFIDIS, CARD.CETELEM, CARD.CBNATIONALE ];
        var ENV = {
            LOCAL: "local",
            STAGE: "stage",
            SANDBOX: "sandbox",
            PRODUCTION: "production",
            TEST: "test",
            DEMO: "demo"
        };
        var USERS = {
            ALL: "all",
            REMEMBERED: "remembered"
        };
        var SOURCE = {
            MANUAL: "manual",
            BUTTON_FACTORY: "button_factory"
        };
        var LOG_LEVEL = {
            DEBUG: "debug",
            INFO: "info",
            WARN: "warn",
            ERROR: "error"
        };
        var PAYMENT_TYPE = {
            EC_TOKEN: "ec_token",
            BA_TOKEN: "ba_token",
            PAY_ID: "pay_id"
        };
        var PPTM_ID = "xo-pptm";
        var ATTRIBUTE = {
            BUTTON: "data-button",
            FUNDING_SOURCE: "data-funding-source",
            CARD: "data-card",
            VERSION: "data-version",
            LAYOUT: "data-layout",
            SIZE: "data-size",
            SMART_BUTTON_VERSION: "data-paypal-smart-button-version"
        };
        var PLATFORM = {
            DESKTOP: "desktop",
            MOBILE: "mobile"
        };
        var DEFAULT = "default";
        var _CONTEXT_TYPE;
        var FPTI = {
            KEY: {
                FEED: "feed_name",
                STATE: "state_name",
                TRANSITION: "transition_name",
                BUTTON_TYPE: "button_type",
                SESSION_UID: "page_session_id",
                BUTTON_SESSION_UID: "button_session_id",
                TOKEN: "token",
                CONTEXT_ID: "context_id",
                CONTEXT_TYPE: "context_type",
                REFERER: "referer_url",
                PAY_ID: "pay_id",
                SELLER_ID: "seller_id",
                DATA_SOURCE: "serverside_data_source",
                BUTTON_SOURCE: "button_source",
                ERROR_CODE: "ext_error_code",
                ERROR_DESC: "ext_error_desc",
                PAGE_LOAD_TIME: "page_load_time",
                EXPERIMENT_NAME: "pxp_exp_id",
                TREATMENT_NAME: "pxp_trtmnt_id",
                TRANSITION_TIME: "transition_time",
                FUNDING_LIST: "eligible_payment_methods",
                FUNDING_COUNT: "eligible_payment_count",
                CHOSEN_FUNDING: "selected_payment_method",
                BUTTON_LAYOUT: "button_layout",
                BUTTON_COLOR: "button_color",
                BUTTON_SIZE: "button_size",
                BUTTON_SHAPE: "button_shape",
                BUTTON_LABEL: "button_label",
                BUTTON_WIDTH: "button_width",
                VERSION: "checkoutjs_version",
                MAX_BUTTONS: "max_buttons",
                FUNDING_REMEMBERED: "funding_remembered",
                BUTTON_TAGLINE_ENABLED: "button_tagline_enabled",
                RESPONSE_DURATION: "response_duration",
                PAYMENT_FLOW: "payment_flow",
                BUTTON_VERSION: "button_version",
                PAGE_TYPE: "pp_placement",
                TIMESTAMP: "t"
            },
            BUTTON_TYPE: {
                IFRAME: "iframe",
                HTML: "html",
                CUSTOM: "custom"
            },
            DATA_SOURCE: {
                CHECKOUT: "checkout"
            },
            CONTEXT_TYPE: (_CONTEXT_TYPE = {
                BUTTON_SESSION_ID: "button_session_id"
            }, _CONTEXT_TYPE[PAYMENT_TYPE.PAY_ID] = "Pay-ID", _CONTEXT_TYPE[PAYMENT_TYPE.EC_TOKEN] = "EC-Token", 
            _CONTEXT_TYPE[PAYMENT_TYPE.BA_TOKEN] = "EC-Token", _CONTEXT_TYPE),
            FEED: {
                CHECKOUTJS: "checkoutjs"
            },
            STATE: {
                LOAD: "checkoutjs_load",
                BUTTON: "checkoutjs_button",
                CHECKOUT: "checkoutjs_checkout",
                PPTM: "checkoutjs_pptm"
            },
            TRANSITION: {
                SCRIPT_LOAD: "process_script_load",
                BUTTON_RENDER: "process_button_render",
                BUTTON_LOAD: "process_button_load",
                BUTTON_CLICK: "process_button_click",
                BUTTON_RENDER_INTRANET_MODE: "process_button_render_intranet_mode",
                BUTTON_CLICK_INTRANET_MODE: "process_button_click_intranet_mode",
                CREATE_PAYMENT: "process_create_payment",
                RECIEVE_PAYMENT: "process_recieve_payment",
                CHECKOUT_INIT: "process_checkout_init",
                CHECKOUT_APPROVE: "process_checkout_approve",
                CHECKOUT_SHIPPING_CHANGE: "process_checkout_shipping_change",
                CHECKOUT_CANCEL: "process_checkout_cancel",
                CHECKOUT_ERROR: "process_checkout_error",
                EXTERNAL_EXPERIMENT: "process_external_experiment",
                EXTERNAL_EXPERIMENT_COMPLETE: "process_external_experiment_complete",
                PPTM_LOAD: "process_pptm_load",
                PPTM_LOADED: "process_pptm_loaded"
            }
        };
        var _LANG_TO_DEFAULT_COUN;
        var COUNTRY = {
            AD: "AD",
            AE: "AE",
            AG: "AG",
            AI: "AI",
            AL: "AL",
            AM: "AM",
            AN: "AN",
            AO: "AO",
            AR: "AR",
            AT: "AT",
            AU: "AU",
            AW: "AW",
            AZ: "AZ",
            BA: "BA",
            BB: "BB",
            BE: "BE",
            BF: "BF",
            BG: "BG",
            BH: "BH",
            BI: "BI",
            BJ: "BJ",
            BM: "BM",
            BN: "BN",
            BO: "BO",
            BR: "BR",
            BS: "BS",
            BT: "BT",
            BW: "BW",
            BY: "BY",
            BZ: "BZ",
            C2: "C2",
            CA: "CA",
            CD: "CD",
            CG: "CG",
            CH: "CH",
            CI: "CI",
            CK: "CK",
            CL: "CL",
            CM: "CM",
            CN: "CN",
            CO: "CO",
            CR: "CR",
            CV: "CV",
            CY: "CY",
            CZ: "CZ",
            DE: "DE",
            DJ: "DJ",
            DK: "DK",
            DM: "DM",
            DO: "DO",
            DZ: "DZ",
            EC: "EC",
            EE: "EE",
            EG: "EG",
            ER: "ER",
            ES: "ES",
            ET: "ET",
            FI: "FI",
            FJ: "FJ",
            FK: "FK",
            FM: "FM",
            FO: "FO",
            FR: "FR",
            GA: "GA",
            GB: "GB",
            GD: "GD",
            GE: "GE",
            GF: "GF",
            GI: "GI",
            GL: "GL",
            GM: "GM",
            GN: "GN",
            GP: "GP",
            GR: "GR",
            GT: "GT",
            GW: "GW",
            GY: "GY",
            HK: "HK",
            HN: "HN",
            HR: "HR",
            HU: "HU",
            ID: "ID",
            IE: "IE",
            IL: "IL",
            IN: "IN",
            IS: "IS",
            IT: "IT",
            JM: "JM",
            JO: "JO",
            JP: "JP",
            KE: "KE",
            KG: "KG",
            KH: "KH",
            KI: "KI",
            KM: "KM",
            KN: "KN",
            KR: "KR",
            KW: "KW",
            KY: "KY",
            KZ: "KZ",
            LA: "LA",
            LC: "LC",
            LI: "LI",
            LK: "LK",
            LS: "LS",
            LT: "LT",
            LU: "LU",
            LV: "LV",
            MA: "MA",
            MC: "MC",
            MD: "MD",
            ME: "ME",
            MG: "MG",
            MH: "MH",
            MK: "MK",
            ML: "ML",
            MN: "MN",
            MQ: "MQ",
            MR: "MR",
            MS: "MS",
            MT: "MT",
            MU: "MU",
            MV: "MV",
            MW: "MW",
            MX: "MX",
            MY: "MY",
            MZ: "MZ",
            NA: "NA",
            NC: "NC",
            NE: "NE",
            NF: "NF",
            NG: "NG",
            NI: "NI",
            NL: "NL",
            NO: "NO",
            NP: "NP",
            NR: "NR",
            NU: "NU",
            NZ: "NZ",
            OM: "OM",
            PA: "PA",
            PE: "PE",
            PF: "PF",
            PG: "PG",
            PH: "PH",
            PL: "PL",
            PM: "PM",
            PN: "PN",
            PT: "PT",
            PW: "PW",
            PY: "PY",
            QA: "QA",
            RE: "RE",
            RO: "RO",
            RS: "RS",
            RU: "RU",
            RW: "RW",
            SA: "SA",
            SB: "SB",
            SC: "SC",
            SE: "SE",
            SG: "SG",
            SH: "SH",
            SI: "SI",
            SJ: "SJ",
            SK: "SK",
            SL: "SL",
            SM: "SM",
            SN: "SN",
            SO: "SO",
            SR: "SR",
            ST: "ST",
            SV: "SV",
            SZ: "SZ",
            TC: "TC",
            TD: "TD",
            TG: "TG",
            TH: "TH",
            TJ: "TJ",
            TM: "TM",
            TN: "TN",
            TO: "TO",
            TR: "TR",
            TT: "TT",
            TV: "TV",
            TW: "TW",
            TZ: "TZ",
            UA: "UA",
            UG: "UG",
            US: "US",
            UY: "UY",
            VA: "VA",
            VC: "VC",
            VE: "VE",
            VG: "VG",
            VN: "VN",
            VU: "VU",
            WF: "WF",
            WS: "WS",
            YE: "YE",
            YT: "YT",
            ZA: "ZA",
            ZM: "ZM",
            ZW: "ZW"
        };
        var LANG = {
            AR: "ar",
            CS: "cs",
            DA: "da",
            DE: "de",
            EL: "el",
            EN: "en",
            ES: "es",
            FI: "fi",
            FR: "fr",
            HE: "he",
            HU: "hu",
            ID: "id",
            IT: "it",
            JA: "ja",
            KO: "ko",
            NL: "nl",
            NO: "no",
            PL: "pl",
            PT: "pt",
            RU: "ru",
            SK: "sk",
            SV: "sv",
            TH: "th",
            TR: "tr",
            ZH: "zh"
        };
        var LANG_TO_DEFAULT_COUNTRY = ((_LANG_TO_DEFAULT_COUN = {})[LANG.AR] = COUNTRY.SA, 
        _LANG_TO_DEFAULT_COUN[LANG.CS] = COUNTRY.CZ, _LANG_TO_DEFAULT_COUN[LANG.DA] = COUNTRY.DK, 
        _LANG_TO_DEFAULT_COUN[LANG.DE] = COUNTRY.DE, _LANG_TO_DEFAULT_COUN[LANG.EL] = COUNTRY.GR, 
        _LANG_TO_DEFAULT_COUN[LANG.EN] = COUNTRY.US, _LANG_TO_DEFAULT_COUN[LANG.ES] = COUNTRY.ES, 
        _LANG_TO_DEFAULT_COUN[LANG.FI] = COUNTRY.FI, _LANG_TO_DEFAULT_COUN[LANG.FR] = COUNTRY.FR, 
        _LANG_TO_DEFAULT_COUN[LANG.HE] = COUNTRY.IL, _LANG_TO_DEFAULT_COUN[LANG.HU] = COUNTRY.HU, 
        _LANG_TO_DEFAULT_COUN[LANG.ID] = COUNTRY.ID, _LANG_TO_DEFAULT_COUN[LANG.IT] = COUNTRY.IT, 
        _LANG_TO_DEFAULT_COUN[LANG.JA] = COUNTRY.JP, _LANG_TO_DEFAULT_COUN[LANG.KO] = COUNTRY.KR, 
        _LANG_TO_DEFAULT_COUN[LANG.NL] = COUNTRY.NL, _LANG_TO_DEFAULT_COUN[LANG.NO] = COUNTRY.NO, 
        _LANG_TO_DEFAULT_COUN[LANG.PL] = COUNTRY.PL, _LANG_TO_DEFAULT_COUN[LANG.PT] = COUNTRY.PT, 
        _LANG_TO_DEFAULT_COUN[LANG.RU] = COUNTRY.RU, _LANG_TO_DEFAULT_COUN[LANG.SK] = COUNTRY.SK, 
        _LANG_TO_DEFAULT_COUN[LANG.SV] = COUNTRY.SE, _LANG_TO_DEFAULT_COUN[LANG.TH] = COUNTRY.TH, 
        _LANG_TO_DEFAULT_COUN[LANG.TR] = COUNTRY.TR, _LANG_TO_DEFAULT_COUN[LANG.ZH] = COUNTRY.CN, 
        _LANG_TO_DEFAULT_COUN);
        var ALLOWED_INSTALLMENT_COUNTRIES = [ COUNTRY.BR, COUNTRY.MX ];
        var ALLOWED_INSTALLMENT_PERIOD = {
            BR: [ 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12 ],
            MX: [ 3, 6, 9, 12 ]
        };
        var _LOCALE;
        var LOCALE = ((_LOCALE = {})[COUNTRY.AD] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.AE] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH, LANG.AR ], _LOCALE[COUNTRY.AG] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.AI] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.AL] = [ LANG.EN ], 
        _LOCALE[COUNTRY.AM] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.AN] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.AO] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.AR] = [ LANG.ES, LANG.EN ], 
        _LOCALE[COUNTRY.AT] = [ LANG.DE, LANG.EN ], _LOCALE[COUNTRY.AU] = [ LANG.EN ], _LOCALE[COUNTRY.AW] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.AZ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.BA] = [ LANG.EN ], 
        _LOCALE[COUNTRY.BB] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.BE] = [ LANG.EN, LANG.NL, LANG.FR ], 
        _LOCALE[COUNTRY.BF] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.BG] = [ LANG.EN ], 
        _LOCALE[COUNTRY.BH] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.BI] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.BJ] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.BM] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.BN] = [ LANG.EN ], _LOCALE[COUNTRY.BO] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.BR] = [ LANG.PT, LANG.EN ], _LOCALE[COUNTRY.BS] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.BT] = [ LANG.EN ], _LOCALE[COUNTRY.BW] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.BY] = [ LANG.EN ], _LOCALE[COUNTRY.BZ] = [ LANG.EN, LANG.ES, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.C2] = [ LANG.ZH, LANG.EN ], _LOCALE[COUNTRY.CA] = [ LANG.EN, LANG.FR ], 
        _LOCALE[COUNTRY.CD] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.CG] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.CH] = [ LANG.DE, LANG.FR, LANG.EN ], _LOCALE[COUNTRY.CI] = [ LANG.FR, LANG.EN ], 
        _LOCALE[COUNTRY.CK] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.CL] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.CM] = [ LANG.FR, LANG.EN ], _LOCALE[COUNTRY.CN] = [ LANG.ZH ], _LOCALE[COUNTRY.CO] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.CR] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], _LOCALE[COUNTRY.CV] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.CY] = [ LANG.EN ], _LOCALE[COUNTRY.CZ] = [ LANG.CS, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.DE] = [ LANG.DE, LANG.EN ], _LOCALE[COUNTRY.DJ] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.DK] = [ LANG.DA, LANG.EN ], _LOCALE[COUNTRY.DM] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.DO] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], _LOCALE[COUNTRY.DZ] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.EC] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], _LOCALE[COUNTRY.EE] = [ LANG.EN, LANG.RU, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.EG] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.ER] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.ES] = [ LANG.ES, LANG.EN ], _LOCALE[COUNTRY.ET] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.FI] = [ LANG.FI, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.FJ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.FK] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.FM] = [ LANG.EN ], 
        _LOCALE[COUNTRY.FO] = [ LANG.DA, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.FR] = [ LANG.FR, LANG.EN ], 
        _LOCALE[COUNTRY.GA] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.GB] = [ LANG.EN ], 
        _LOCALE[COUNTRY.GD] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.GE] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.GF] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.GI] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.GL] = [ LANG.DA, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.GM] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.GN] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.GP] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.GR] = [ LANG.EL, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.GT] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.GW] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.GY] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.HK] = [ LANG.EN, LANG.ZH ], _LOCALE[COUNTRY.HN] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.HR] = [ LANG.EN ], _LOCALE[COUNTRY.HU] = [ LANG.HU, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.ID] = [ LANG.ID, LANG.EN ], _LOCALE[COUNTRY.IE] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.IL] = [ LANG.HE, LANG.EN ], _LOCALE[COUNTRY.IN] = [ LANG.EN ], _LOCALE[COUNTRY.IS] = [ LANG.EN ], 
        _LOCALE[COUNTRY.IT] = [ LANG.IT, LANG.EN ], _LOCALE[COUNTRY.JM] = [ LANG.EN, LANG.ES, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.JO] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.JP] = [ LANG.JA, LANG.EN ], 
        _LOCALE[COUNTRY.KE] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.KG] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.KH] = [ LANG.EN ], _LOCALE[COUNTRY.KI] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.KM] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.KN] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.KR] = [ LANG.KO, LANG.EN ], _LOCALE[COUNTRY.KW] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.KY] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.KZ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.LA] = [ LANG.EN ], _LOCALE[COUNTRY.LC] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.LI] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.LK] = [ LANG.EN ], 
        _LOCALE[COUNTRY.LS] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.LT] = [ LANG.EN, LANG.RU, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.LU] = [ LANG.EN, LANG.DE, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.LV] = [ LANG.EN, LANG.RU, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.MA] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.MC] = [ LANG.FR, LANG.EN ], 
        _LOCALE[COUNTRY.MD] = [ LANG.EN ], _LOCALE[COUNTRY.ME] = [ LANG.EN ], _LOCALE[COUNTRY.MG] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.MH] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.MK] = [ LANG.EN ], 
        _LOCALE[COUNTRY.ML] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.MN] = [ LANG.EN ], 
        _LOCALE[COUNTRY.MQ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.MR] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.MS] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.MT] = [ LANG.EN ], 
        _LOCALE[COUNTRY.MU] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.MV] = [ LANG.EN ], 
        _LOCALE[COUNTRY.MW] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.MX] = [ LANG.ES, LANG.EN ], 
        _LOCALE[COUNTRY.MY] = [ LANG.EN ], _LOCALE[COUNTRY.MZ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.NA] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.NC] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.NE] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.NF] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.NG] = [ LANG.EN ], _LOCALE[COUNTRY.NI] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.NL] = [ LANG.NL, LANG.EN ], _LOCALE[COUNTRY.NO] = [ LANG.NO, LANG.EN ], 
        _LOCALE[COUNTRY.NP] = [ LANG.EN ], _LOCALE[COUNTRY.NR] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.NU] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.NZ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.OM] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.PA] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.PE] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], _LOCALE[COUNTRY.PF] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.PG] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.PH] = [ LANG.EN ], 
        _LOCALE[COUNTRY.PL] = [ LANG.PL, LANG.EN ], _LOCALE[COUNTRY.PM] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.PN] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.PT] = [ LANG.PT, LANG.EN ], 
        _LOCALE[COUNTRY.PW] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.PY] = [ LANG.ES, LANG.EN ], 
        _LOCALE[COUNTRY.QA] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH, LANG.AR ], _LOCALE[COUNTRY.RE] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.RO] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.RS] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.RU] = [ LANG.RU, LANG.EN ], _LOCALE[COUNTRY.RW] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.SA] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.SB] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.SC] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.SE] = [ LANG.SV, LANG.EN ], 
        _LOCALE[COUNTRY.SG] = [ LANG.EN ], _LOCALE[COUNTRY.SH] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.SI] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.SJ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.SK] = [ LANG.SK, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.SL] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.SM] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.SN] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.SO] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.SR] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.ST] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.SV] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.SZ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.TC] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.TD] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.TG] = [ LANG.FR, LANG.EN, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.TH] = [ LANG.TH, LANG.EN ], _LOCALE[COUNTRY.TJ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.TM] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.TN] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.TO] = [ LANG.EN ], _LOCALE[COUNTRY.TR] = [ LANG.TR, LANG.EN ], _LOCALE[COUNTRY.TT] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.TV] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.TW] = [ LANG.ZH, LANG.EN ], 
        _LOCALE[COUNTRY.TZ] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.UA] = [ LANG.EN, LANG.RU, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.UG] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.US] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.UY] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], _LOCALE[COUNTRY.VA] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.VC] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.VE] = [ LANG.ES, LANG.EN, LANG.FR, LANG.ZH ], 
        _LOCALE[COUNTRY.VG] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.VN] = [ LANG.EN ], 
        _LOCALE[COUNTRY.VU] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.WF] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.WS] = [ LANG.EN ], _LOCALE[COUNTRY.YE] = [ LANG.AR, LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.YT] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.ZA] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], 
        _LOCALE[COUNTRY.ZM] = [ LANG.EN, LANG.FR, LANG.ES, LANG.ZH ], _LOCALE[COUNTRY.ZW] = [ LANG.EN ], 
        _LOCALE);
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return JsxHTMLNodeContainer;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return jsxToHTML;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return jsxRender;
        }));
        var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21);
        var _util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14);
        function htmlEncode(html) {
            void 0 === html && (html = "");
            return html.toString().replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/\//g, "&#x2F;");
        }
        var JsxHTMLNode = function() {
            function JsxHTMLNode(name, props, children) {
                this.name = void 0;
                this.props = void 0;
                this.children = void 0;
                this.name = name;
                this.props = props;
                this.children = children;
            }
            var _proto = JsxHTMLNode.prototype;
            _proto.toString = function() {
                return "<" + this.name + (this.props ? " " : "") + (this.props ? this.propsToString() : "") + ">" + this.childrenToString() + "</" + this.name + ">";
            };
            _proto.propsToString = function() {
                var props = this.props;
                return props ? Object.keys(props).filter((function(key) {
                    return "innerHTML" !== key && props && !1 !== props[key];
                })).map((function(key) {
                    return props && !0 === props[key] ? "" + htmlEncode(key) : props ? htmlEncode(key) + '="' + htmlEncode(props[key]) + '"' : "";
                })).join(" ") : "";
            };
            _proto.childrenToString = function() {
                if (this.props && this.props.innerHTML) return this.props.innerHTML;
                if (!this.children) return "";
                var result = "";
                !function iterate(children) {
                    for (var _i2 = 0; _i2 < children.length; _i2++) {
                        var child = children[_i2];
                        null != child && (Array.isArray(child) ? iterate(child) : result += child instanceof JsxHTMLNode ? child.toString() : htmlEncode(child));
                    }
                }(this.children);
                return result;
            };
            return JsxHTMLNode;
        }();
        var JsxHTMLNodeContainer = function(_JsxHTMLNode) {
            Object(_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__.a)(JsxHTMLNodeContainer, _JsxHTMLNode);
            function JsxHTMLNodeContainer(children) {
                return _JsxHTMLNode.call(this, "", {}, children) || this;
            }
            JsxHTMLNodeContainer.prototype.toString = function() {
                return this.childrenToString();
            };
            return JsxHTMLNodeContainer;
        }(JsxHTMLNode);
        function jsxToHTML(name, props) {
            for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) children[_key - 2] = arguments[_key];
            return new JsxHTMLNode(name, props, children);
        }
        function jsxRender(template, renderers) {
            var nodes = Object(_util__WEBPACK_IMPORTED_MODULE_1__.n)(template, /\{\s*([a-z]+)(?::\s*([^} ]+))?\s*\}|([^${}]+)/g, (function(match, type, value, text) {
                if (type) {
                    if (!renderers[type]) throw new Error("Can not render type: " + type);
                    return renderers[type](value);
                }
                return text && text.trim() && renderers.text ? /<br>/.test(text) ? renderers.break(text) : renderers.text(text) : text;
            }));
            return new JsxHTMLNodeContainer(nodes);
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return promise_ZalgoPromise;
        }));
        function utils_isPromise(item) {
            try {
                if (!item) return !1;
                if ("undefined" != typeof Promise && item instanceof Promise) return !0;
                if ("undefined" != typeof window && "function" == typeof window.Window && item instanceof window.Window) return !1;
                if ("undefined" != typeof window && "function" == typeof window.constructor && item instanceof window.constructor) return !1;
                var _toString = {}.toString;
                if (_toString) {
                    var name = _toString.call(item);
                    if ("[object Window]" === name || "[object global]" === name || "[object DOMWindow]" === name) return !1;
                }
                if ("function" == typeof item.then) return !0;
            } catch (err) {
                return !1;
            }
            return !1;
        }
        var dispatchedErrors = [];
        var possiblyUnhandledPromiseHandlers = [];
        var activeCount = 0;
        var flushPromise;
        function flushActive() {
            if (!activeCount && flushPromise) {
                var promise = flushPromise;
                flushPromise = null;
                promise.resolve();
            }
        }
        function startActive() {
            activeCount += 1;
        }
        function endActive() {
            activeCount -= 1;
            flushActive();
        }
        var promise_ZalgoPromise = function() {
            function ZalgoPromise(handler) {
                var _this = this;
                this.resolved = void 0;
                this.rejected = void 0;
                this.errorHandled = void 0;
                this.value = void 0;
                this.error = void 0;
                this.handlers = void 0;
                this.dispatching = void 0;
                this.stack = void 0;
                this.resolved = !1;
                this.rejected = !1;
                this.errorHandled = !1;
                this.handlers = [];
                if (handler) {
                    var _result;
                    var _error;
                    var resolved = !1;
                    var rejected = !1;
                    var isAsync = !1;
                    startActive();
                    try {
                        handler((function(res) {
                            if (isAsync) _this.resolve(res); else {
                                resolved = !0;
                                _result = res;
                            }
                        }), (function(err) {
                            if (isAsync) _this.reject(err); else {
                                rejected = !0;
                                _error = err;
                            }
                        }));
                    } catch (err) {
                        endActive();
                        this.reject(err);
                        return;
                    }
                    endActive();
                    isAsync = !0;
                    resolved ? this.resolve(_result) : rejected && this.reject(_error);
                }
            }
            var _proto = ZalgoPromise.prototype;
            _proto.resolve = function(result) {
                if (this.resolved || this.rejected) return this;
                if (utils_isPromise(result)) throw new Error("Can not resolve promise with another promise");
                this.resolved = !0;
                this.value = result;
                this.dispatch();
                return this;
            };
            _proto.reject = function(error) {
                var _this2 = this;
                if (this.resolved || this.rejected) return this;
                if (utils_isPromise(error)) throw new Error("Can not reject promise with another promise");
                if (!error) {
                    var _err = error && "function" == typeof error.toString ? error.toString() : {}.toString.call(error);
                    error = new Error("Expected reject to be called with Error, got " + _err);
                }
                this.rejected = !0;
                this.error = error;
                this.errorHandled || setTimeout((function() {
                    _this2.errorHandled || function(err, promise) {
                        if (-1 === dispatchedErrors.indexOf(err)) {
                            dispatchedErrors.push(err);
                            setTimeout((function() {
                                throw err;
                            }), 1);
                            for (var j = 0; j < possiblyUnhandledPromiseHandlers.length; j++) possiblyUnhandledPromiseHandlers[j](err, promise);
                        }
                    }(error, _this2);
                }), 1);
                this.dispatch();
                return this;
            };
            _proto.asyncReject = function(error) {
                this.errorHandled = !0;
                this.reject(error);
                return this;
            };
            _proto.dispatch = function() {
                var resolved = this.resolved, rejected = this.rejected, handlers = this.handlers;
                if (!this.dispatching && (resolved || rejected)) {
                    this.dispatching = !0;
                    startActive();
                    var chain = function(firstPromise, secondPromise) {
                        return firstPromise.then((function(res) {
                            secondPromise.resolve(res);
                        }), (function(err) {
                            secondPromise.reject(err);
                        }));
                    };
                    for (var i = 0; i < handlers.length; i++) {
                        var _handlers$i = handlers[i], onSuccess = _handlers$i.onSuccess, onError = _handlers$i.onError, promise = _handlers$i.promise;
                        var _result2 = void 0;
                        if (resolved) try {
                            _result2 = onSuccess ? onSuccess(this.value) : this.value;
                        } catch (err) {
                            promise.reject(err);
                            continue;
                        } else if (rejected) {
                            if (!onError) {
                                promise.reject(this.error);
                                continue;
                            }
                            try {
                                _result2 = onError(this.error);
                            } catch (err) {
                                promise.reject(err);
                                continue;
                            }
                        }
                        if (_result2 instanceof ZalgoPromise && (_result2.resolved || _result2.rejected)) {
                            var promiseResult = _result2;
                            promiseResult.resolved ? promise.resolve(promiseResult.value) : promise.reject(promiseResult.error);
                            promiseResult.errorHandled = !0;
                        } else utils_isPromise(_result2) ? _result2 instanceof ZalgoPromise && (_result2.resolved || _result2.rejected) ? _result2.resolved ? promise.resolve(_result2.value) : promise.reject(_result2.error) : chain(_result2, promise) : promise.resolve(_result2);
                    }
                    handlers.length = 0;
                    this.dispatching = !1;
                    endActive();
                }
            };
            _proto.then = function(onSuccess, onError) {
                if (onSuccess && "function" != typeof onSuccess && !onSuccess.call) throw new Error("Promise.then expected a function for success handler");
                if (onError && "function" != typeof onError && !onError.call) throw new Error("Promise.then expected a function for error handler");
                var promise = new ZalgoPromise;
                this.handlers.push({
                    promise: promise,
                    onSuccess: onSuccess,
                    onError: onError
                });
                this.errorHandled = !0;
                this.dispatch();
                return promise;
            };
            _proto.catch = function(onError) {
                return this.then(void 0, onError);
            };
            _proto.finally = function(onFinally) {
                if (onFinally && "function" != typeof onFinally && !onFinally.call) throw new Error("Promise.finally expected a function");
                return this.then((function(result) {
                    return ZalgoPromise.try(onFinally).then((function() {
                        return result;
                    }));
                }), (function(err) {
                    return ZalgoPromise.try(onFinally).then((function() {
                        throw err;
                    }));
                }));
            };
            _proto.timeout = function(time, err) {
                var _this3 = this;
                if (this.resolved || this.rejected) return this;
                var timeout = setTimeout((function() {
                    _this3.resolved || _this3.rejected || _this3.reject(err || new Error("Promise timed out after " + time + "ms"));
                }), time);
                return this.then((function(result) {
                    clearTimeout(timeout);
                    return result;
                }));
            };
            _proto.toPromise = function() {
                if ("undefined" == typeof Promise) throw new TypeError("Could not find Promise");
                return Promise.resolve(this);
            };
            ZalgoPromise.resolve = function(value) {
                return value instanceof ZalgoPromise ? value : utils_isPromise(value) ? new ZalgoPromise((function(resolve, reject) {
                    return value.then(resolve, reject);
                })) : (new ZalgoPromise).resolve(value);
            };
            ZalgoPromise.reject = function(error) {
                return (new ZalgoPromise).reject(error);
            };
            ZalgoPromise.asyncReject = function(error) {
                return (new ZalgoPromise).asyncReject(error);
            };
            ZalgoPromise.all = function(promises) {
                var promise = new ZalgoPromise;
                var count = promises.length;
                var results = [].slice();
                if (!count) {
                    promise.resolve(results);
                    return promise;
                }
                var chain = function(i, firstPromise, secondPromise) {
                    return firstPromise.then((function(res) {
                        results[i] = res;
                        0 == (count -= 1) && promise.resolve(results);
                    }), (function(err) {
                        secondPromise.reject(err);
                    }));
                };
                for (var i = 0; i < promises.length; i++) {
                    var prom = promises[i];
                    if (prom instanceof ZalgoPromise) {
                        if (prom.resolved) {
                            results[i] = prom.value;
                            count -= 1;
                            continue;
                        }
                    } else if (!utils_isPromise(prom)) {
                        results[i] = prom;
                        count -= 1;
                        continue;
                    }
                    chain(i, ZalgoPromise.resolve(prom), promise);
                }
                0 === count && promise.resolve(results);
                return promise;
            };
            ZalgoPromise.hash = function(promises) {
                var result = {};
                var awaitPromises = [];
                var _loop = function(key) {
                    if (promises.hasOwnProperty(key)) {
                        var value = promises[key];
                        utils_isPromise(value) ? awaitPromises.push(value.then((function(res) {
                            result[key] = res;
                        }))) : result[key] = value;
                    }
                };
                for (var key in promises) _loop(key);
                return ZalgoPromise.all(awaitPromises).then((function() {
                    return result;
                }));
            };
            ZalgoPromise.map = function(items, method) {
                return ZalgoPromise.all(items.map(method));
            };
            ZalgoPromise.onPossiblyUnhandledException = function(handler) {
                return function(handler) {
                    possiblyUnhandledPromiseHandlers.push(handler);
                    return {
                        cancel: function() {
                            possiblyUnhandledPromiseHandlers.splice(possiblyUnhandledPromiseHandlers.indexOf(handler), 1);
                        }
                    };
                }(handler);
            };
            ZalgoPromise.try = function(method, context, args) {
                if (method && "function" != typeof method && !method.call) throw new Error("Promise.try expected a function");
                var result;
                startActive();
                try {
                    result = method.apply(context, args || []);
                } catch (err) {
                    endActive();
                    return ZalgoPromise.reject(err);
                }
                endActive();
                return ZalgoPromise.resolve(result);
            };
            ZalgoPromise.delay = function(_delay) {
                return new ZalgoPromise((function(resolve) {
                    setTimeout(resolve, _delay);
                }));
            };
            ZalgoPromise.isPromise = function(value) {
                return !!(value && value instanceof ZalgoPromise) || utils_isPromise(value);
            };
            ZalgoPromise.flush = function() {
                return function(Zalgo) {
                    var promise = flushPromise = flushPromise || new Zalgo;
                    flushActive();
                    return promise;
                }(ZalgoPromise);
            };
            return ZalgoPromise;
        }();
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return config;
        }));
        var constants = __webpack_require__(0);
        var _altpayUris, _guestUris, _billingUris, _buttonUris, _inlinedCardFieldUris, _postBridgeUris, _legacyCheckoutUris, _buttonJSUrls;
        var config = {
            locales: constants.A,
            scriptUrl: "//www.paypalobjects.com/api/checkout.lib.js",
            paypal_domain_regex: /^(https?|mock):\/\/[a-zA-Z0-9_.-]+\.paypal\.com(:\d+)?$/,
            version: "4.0.331",
            cors: !0,
            env: "undefined" == typeof window || void 0 === window.location ? constants.t.PRODUCTION : -1 !== window.location.host.indexOf("localhost.paypal.com") ? constants.t.LOCAL : -1 !== window.location.host.indexOf("qa.paypal.com") ? constants.t.STAGE : -1 !== window.location.host.indexOf("sandbox.paypal.com") ? constants.t.SANDBOX : "production",
            state: "checkoutjs",
            locale: {
                country: constants.r.US,
                lang: constants.y.EN
            },
            stage: "msmaster",
            stageDomain: "qa.paypal.com",
            get stageUrl() {
                return "www." + config.stage + "." + config.stageDomain;
            },
            get apiStageUrl() {
                return "www." + config.apiStage + "." + config.stageDomain;
            },
            get localSDKUrl() {
                var scripts = [].slice.call(document.getElementsByTagName("script"));
                for (var _i2 = 0; _i2 < scripts.length; _i2++) {
                    var script = scripts[_i2];
                    if (config.env === constants.t.LOCAL && script.src.match(/checkout(\.min)?\.js$/)) return script.src;
                }
            },
            get localSDKDomain() {
                var localSDKUrl = config.localSDKUrl;
                if (localSDKUrl) return new URL(localSDKUrl).origin;
            },
            get localhostUrl() {
                return config.localSDKDomain || "http://localhost.paypal.com:" + config.ports.default;
            },
            set localhostUrl(val) {
                delete this.localhostUrl;
                this.localhostUrl = val;
            },
            merchantID: "",
            authCode: "",
            logLevel: "warn",
            throttles: {
                v4_mobile_device: 0
            },
            domain_settings: {
                "walmart.com": {
                    ie_full_page: !1,
                    allow_full_page_fallback: !0,
                    memoize_payment: !0,
                    force_bridge: !0,
                    log_authorize: !0
                },
                "ulta.com": {
                    disable_venmo: !0
                },
                "barnesandnoble.com": {
                    disable_venmo: !0
                },
                "bn.com": {
                    disable_venmo: !0
                },
                "agoratix.com": {
                    disable_venmo: !0
                },
                "tractorsupply.com": {
                    disable_venmo: !0
                },
                "etsy.com": {
                    ie_full_page: !1,
                    allow_full_page_fallback: !0,
                    memoize_payment: !0,
                    force_bridge: !0,
                    log_authorize: !0
                },
                "ticketmaster.com": {
                    disable_venmo: !0
                },
                "livenation.com": {
                    disable_venmo: !0
                },
                "frontgatetickets.com": {
                    disable_venmo: !0
                },
                "williams-sonoma.com": {
                    disable_venmo: !0
                },
                "westelm.com": {
                    disable_venmo: !0
                },
                "markandgraham.com": {
                    disable_venmo: !0
                },
                "potterybarn.com": {
                    disable_venmo: !0
                },
                "potterybarnkids.com": {
                    disable_venmo: !0
                },
                "pbteen.com": {
                    disable_venmo: !0
                },
                "beallsflorida.com": {
                    disable_venmo: !0
                },
                "therealreal.com": {
                    disable_venmo: !0
                },
                "liveaquaria.com": {
                    disable_venmo: !0
                },
                "drsfostersmith.com": {
                    disable_venmo: !0
                },
                "boxed.com": {
                    disable_venmo: !0
                },
                "bevisible.com": {
                    disable_venmo: !0
                },
                "moeller.org": {
                    disable_venmo: !0
                },
                "searshometownstores.com": {
                    disable_venmo: !0
                },
                "searshardwarestores.com": {
                    disable_venmo: !0
                },
                "searshomeapplianceshowroom.com": {
                    disable_venmo: !0
                },
                "barkshop.com": {
                    disable_venmo: !0
                },
                "vividseats.com": {
                    disable_venmo: !0
                },
                "getcargo.today": {
                    disable_venmo: !0
                },
                "smartdestinations.com": {
                    disable_venmo: !0
                },
                "philadelphiapass.com": {
                    disable_venmo: !0
                },
                "thesydneypass.com": {
                    disable_venmo: !0
                },
                "3secondlash.com": {
                    disable_venmo: !0
                },
                "newyorkpass.com": {
                    disable_venmo: !0
                },
                "dndbeyond.com": {
                    disable_venmo: !0
                },
                "app.zapbuy.it": {
                    disable_venmo: !0
                },
                "gamersaloon.com": {
                    disable_venmo: !0
                },
                "1800contacts.com": {
                    disable_venmo: !0
                },
                "shopchatters.ca": {
                    disable_venmo: !0
                },
                "shopguyswin.ca": {
                    disable_venmo: !0
                },
                "jjill.com": {
                    disable_venmo: !0
                },
                "qvc.com": {
                    disable_venmo: !0
                },
                "stelladot.com": {
                    disable_venmo: !0
                },
                "keepcollective.com": {
                    disable_venmo: !0
                },
                "everskin.com": {
                    disable_venmo: !0
                },
                "zulily.com": {
                    disable_venmo: !0
                },
                "freshly.com": {
                    disable_venmo: !0
                },
                "buypeticare.com": {
                    disable_venmo: !0
                },
                "getownzone.com": {
                    disable_venmo: !0
                },
                "uncommongoods.com": {
                    disable_venmo: !0
                },
                "onegold.com": {
                    disable_venmo: !0
                },
                "universitytees.com": {
                    disable_venmo: !0
                },
                "revolve.com": {
                    disable_venmo: !0
                },
                "functionofbeauty.com": {
                    disable_venmo: !0
                },
                "givebutter.com": {
                    disable_venmo: !0
                },
                "hausmart.com": {
                    disable_venmo: !0
                },
                "derbyjackpot.com": {
                    disable_venmo: !0
                },
                "ancestry.com": {
                    disable_venmo: !0
                },
                "boats.net": {
                    disable_venmo: !0
                },
                "partzilla.com": {
                    disable_venmo: !0
                },
                "firedog.com": {
                    disable_venmo: !0
                },
                "chick-fil-a.com": {
                    disable_venmo: !0
                },
                "roku.com": {
                    disable_venmo: !0
                },
                "barkbox.com": {
                    disable_venmo: !0
                },
                "neimanmarcus.com": {
                    disable_venmo: !0
                },
                "lastcall.com": {
                    disable_venmo: !0
                },
                "horchow.com": {
                    disable_venmo: !0
                },
                "bergdorfgoodman.com": {
                    disable_venmo: !0
                },
                "fwrd.com": {
                    disable_venmo: !0
                },
                "plunderdesign.com": {
                    disable_venmo: !0
                },
                "stitchfix.com": {
                    disable_venmo: !0
                },
                "revzilla.com": {
                    disable_venmo: !0
                },
                "cyclegear.com": {
                    disable_venmo: !0
                },
                "chegg.com": {
                    disable_venmo: !0
                },
                "youniqueproducts.com": {
                    disable_venmo: !0
                },
                "archives.com": {
                    disable_venmo: !0
                },
                "hautelook.com": {
                    disable_venmo: !0
                },
                "nordstromrack.com": {
                    disable_venmo: !0
                },
                "motherhoodcanada.ca": {
                    disable_venmo: !0
                },
                "atomtickets.com": {
                    disable_venmo: !0
                },
                "trademore.com": {
                    disable_venmo: !0
                },
                "lasheaseoffer.com": {
                    disable_venmo: !0
                },
                "rookie.paypalsixthman.com": {
                    disable_venmo: !0
                },
                "1800Contacts.com": {
                    disable_venmo: !0
                },
                "hulu.com": {
                    disable_venmo: !0
                },
                "grubhub.com": {
                    disable_venmo: !0
                },
                "eat24.com": {
                    disable_venmo: !0
                },
                "seamless.com": {
                    disable_venmo: !0
                },
                "freshfeetscrubber.com": {
                    disable_venmo: !0
                },
                "opensky.com": {
                    disable_venmo: !0
                },
                "dotandbo.com": {
                    disable_venmo: !0
                },
                "storenvy.com": {
                    disable_venmo: !0
                },
                "gemafina.com": {
                    disable_venmo: !0
                },
                "pickperfect.com": {
                    disable_venmo: !0
                },
                "55mulberry.com": {
                    disable_venmo: !0
                },
                "hollar.com": {
                    disable_venmo: !0
                },
                "bjs.com": {
                    disable_venmo: !0
                },
                "playsugarhouse.com": {
                    disable_venmo: !0
                },
                "lakeshorelearning.com": {
                    disable_venmo: !0
                },
                "llmhq.com": {
                    disable_venmo: !0
                },
                "gainful.com": {
                    disable_venmo: !0
                },
                "modaoperandi.com": {
                    disable_venmo: !0
                },
                "play.jackpocket.com": {
                    disable_venmo: !0
                },
                "crepeerase.com": {
                    disable_venmo: !0
                },
                "specificbeauty.com": {
                    disable_venmo: !0
                },
                "meaningfulbeauty.com": {
                    disable_venmo: !0
                },
                "smileactives.com ": {
                    disable_venmo: !0
                },
                "mally.com": {
                    disable_venmo: !0
                },
                "westmorebeauty.com": {
                    disable_venmo: !0
                },
                "subd.com": {
                    disable_venmo: !0
                },
                "seacalmskin.com": {
                    disable_venmo: !0
                },
                "whittier.edu": {
                    disable_venmo: !0
                },
                "curology.com": {
                    disable_venmo: !0
                },
                "monoprice.com": {
                    disable_venmo: !0
                },
                "dominos.com": {
                    disable_venmo: !0
                },
                "audiobooks.com": {
                    disable_venmo: !0
                },
                "1aauto.com": {
                    disable_venmo: !0
                },
                "greatwolf.com": {
                    disable_venmo: !0
                },
                "cvs.com": {
                    disable_venmo: !0
                },
                "gilt.com": {
                    disable_venmo: !0
                },
                "ruelala.com": {
                    disable_venmo: !0
                },
                "shopdisney.com": {
                    disable_venmo: !0
                },
                "disneyland.disney.go.com": {
                    disable_venmo: !0
                },
                "disneyworld.disney.go.com": {
                    disable_venmo: !0
                },
                "disneyaulani.com": {
                    disable_venmo: !0
                },
                "6abc.com": {
                    disable_venmo: !0
                },
                "abc30.com": {
                    disable_venmo: !0
                },
                "abc7.com": {
                    disable_venmo: !0
                },
                "abc7chicago.com": {
                    disable_venmo: !0
                },
                "abcnewsvideosource.com": {
                    disable_venmo: !0
                },
                "aetndigital.com": {
                    disable_venmo: !0
                },
                "araca.com.au": {
                    disable_venmo: !0
                },
                "disney.com": {
                    disable_venmo: !0
                },
                "espncustomercare.com": {
                    disable_venmo: !0
                },
                "makerstudios.com": {
                    disable_venmo: !0
                },
                "abc.org": {
                    disable_venmo: !0
                },
                "dclnews.com": {
                    disable_venmo: !0
                },
                "disneyanimation.com": {
                    disable_venmo: !0
                },
                "espncricinfo.com": {
                    disable_venmo: !0
                },
                "fort-pierce.net": {
                    disable_venmo: !0
                },
                "nationalgeographic.com": {
                    disable_venmo: !0
                },
                "nhl.tv": {
                    disable_venmo: !0
                },
                "pixar.com": {
                    disable_venmo: !0
                },
                "xgames.com": {
                    disable_venmo: !0
                },
                "espnwsummit.com": {
                    disable_venmo: !0
                },
                "plus.espn.com": {
                    disable_venmo: !0
                },
                "disneyplus.com": {
                    disable_venmo: !0
                }
            },
            creditTestDomains: [ "bluesuncorp.co.uk", "nationsphotolab.com", "plexusworldwide.com", "nshss.org", "bissell.com", "mobstub.com", "vuoriclothing.com", "tape4backup.com", "avivamiento.com", "rhododendron.org", "whiterabbitjapan.com", "atsracing.net", "thehilltopgallery.com", "weedtraqr.com", "worldpantry.com", "ciraconnect.com", "mymalls.com", "prowinch.com", "zodiacpoolsystems.com", "everlywell.com", "candlewarmers.com", "chop.edu", "incruises.com", "flikn.com", "didforsale.com", "mcc.org", "sygu.net", "merchbar.com", "eduinconline.com", "us.livebetterwith.com", "bakemeawish.com", "judolaunch.com", "eventcartel.com", "tapatalk.com", "telescope.com", "covenant.edu", "aquatruwater.com", "spingo.com", "usu.edu", "getcelerity.com", "brandless.com", "saberigniter.com", "euromodeltrains.com", "gofasttrader.com", "megamodzplanet.com", "draftanalyzer.com", "lovewithoutboundaries.com", "filterpop.com", "seekverify.com", "photoandgo.com", "sightseeingpass.com", "bigoanddukes.com", "thethirstyduck.com", "thebrushguys.com", "907delivery.com", "mauisails.com", "drive.net", "channelmax.net", "modernrebelco.com", "enchanteddiamonds.com", "ibabbleon.com", "fullgenomes.com", "conn-comp.com", "wingware.com", "paradigmgoods.com", "theneptunegroup.com", "kidzartworks.com", "unirealm.com", "ncfarmsinc.com", "oneofakindantiques.com", "servers4less.com", "stumpthespread.com", "marketwagon.com", "monsterhouseplans.com", "canterburychoral.org", "teacupnordic.org", "thethirstyduck.com", "medialoot.com", "theartistunion.com", "yourglamourzone.com", "breckstables.com", "mackephotography.com", "dsaj.org", "massluminosity.com", "tespa.org", "versatilearts.net", "yecup.org", "divinebusinessmanagement.com", "captivatebeautyservices.com", "class4me.com", "wcsonlineuniversity.com", "pvplive.com", "kyneteks.com", "rare-paper.com", "bpg.bpgsim.biz", "geodegallery.com", "way.com", "kringle.com", "talentedmrsalas.ph", "litcharts.com", "purpletreephotography.com", "apache.org", "neopackage.com", "globaldance.tv", "integral.studio", "airdoctorpro.com", "ivoryandiron.com", "yuengling.com", "averysbranchfarms.com", "amberreinink.com", "skinnymechocolate.com", "bmbl.net", "ncwatercolor.net", "astrograph.com", "localadventures.mx", "ripcurl.com", "worldfootbrakechallenge.com", "shespeakssales.com", "obrienguitars.com", "jadenikkolephoto.com", "americavoice.com", "cassiexie.com", "aamastateconvention.org", "rellesflorist.com", "passionnobby.com", "bodybyheidi.com", "roqos.com", "prijector.com", "maryswanson.net", "tsghobbies.com", "erinlaytonphotography.com", "darter.org", "fountainpenhospital.com", "myzestfullife.com", "pcog.org", "alisabethdesigns.com", "katiemathisphoto.com", "strictlybellaphotography.com", "maptools.com", "sites.google.com", "gallerr.com", "southfloridatrikke.com", "caviar.tv", "mintingmasters.com", "prospectorsguild.com", "inktale.com", "prettygirlgoods.com", "laceycahill.com", "daniellenowak.com", "t212.org", "scmsinc.com", "babypaloozanc.com", "tetrisonline.com", "grdd.net", "cdspg.info", "airshipapparel.com", "waft.com", "extendpets.com", "supplyhub.com", "hlbsusa.com", "jaderollerbeauty.com", "theparentingjunkie.com", "schagringas.com", "yourscribemate.com", "sportscollectibles.com", "thedivinenoise.com", "hometeamsonline.com", "trademarkpress.com", "destinationenglish.us", "jacquesflowers.com", "aliszhatchphotography.com", "rusticfoundry.com", "ahhhmassage.net", "frezzor.com", "mandelininc.com", "kayleejackson.com", "monkinstitute.org", "eddiebsbbq.com", "morningstarmediaservices.com", "kinevative.com", "orivet.com", "digitalprinthouse.net", "dynamicgenius.com", "allpartsusa.com", "flowersbydavid.net", "nwvoices.org", "leaptrade.com", "tulsaschoolpics.com", "alioth.io", "windowflair.com", "vitcom.net", "simplybeautifulfashions.com", "christinabenton.com", "fromthedaughter.com", "hometowngraphics.net", "fibanalysis.com", "creativejobscentral.com", "sandbox.gg", "jt-digitalmedia.com", "kodable.com", "birthingstone.com", "taranicholephoto.com", "hillyfieldsflorist.com", "charitynoelphoto.com", "auxdelicesfoods.com", "terilynnphotography.com", "folieadeuxevents.com", "karensfloral.com", "montgomerydiveclub.com", "rainbowplastics.com", "confettionthedancefloor.com", "vomozmedia.com", "neatmod.com", "getnaturafled.com", "callingpost.com", "iamfamily.org", "pedigreeonline.com", "typeboost.io", "in-n-outpetdoor.com", "nerdstockgc.com", "keiadmin.com", "createdbykaui.com", "aikophoto.com", "lonestar.ink", "stlfurs.com", "treasurelistings.com", "thecubicle.us", "redclaypaper.com", "blushhousemedia.com", "documentsanddesigns.com", "whitneyleighphotography.shootproof.com", "amaryllisday.com", "hermanproav.com", "felicemedia.com", "withloveplacenta.com", "store.brgadgets.co", "klowephoto.com", "spenceraustinconsulting.com", "sno-eagles.org", "dsatallahassee.org", "bakupages.com", "neswc.com", "josiebrooksphotography.com", "brisksale.com", "legalwhoosh.com", "jasmineeaster.com", "swatstudios.com", "facebook.com", "shakershell.com", "alexiswinslow.com", "mixeddimensions.com", "sweetpproductions.com", "lbeaphotography.com", "otlseatfillers.com", "jdtickets.com", "catholicar.com", "masque.com", "smalltownstudio.net", "goherbalife.com", "itzyourz.com", "magazinespeedloader.com", "dreammachines.io", "dallasdieteticalliance.org", "http:", "medair.org", "unbridledambition.com", "sarasprints.com", "wiperecord.com", "showmyrabbit.com", "cctrendsshop.com", "rachelalessandra.com", "otherworld-apothecary.com", "melissaannphoto.com", "girlceo.co", "seasidemexico.com", "telosid.com", "instin.com", "marinecorpsmustang.org", "lancityconnect.com", "hps1.org", "karenware.com", "livecurriculum.com", "spellingstars.com", "vektorfootball.com", "zaltv.com", "nebraskamayflower.org", "ethiopianspices.com", "immitranslate.com", "rafaelmagic.com.com", "bahc1.org", "newenamel.com", "bhchp.org", "buybulkamerica.com", "sourcepoint.com", "squarestripsports.com", "wix.com", "wilderootsphotography.com", "goodsalt.com", "systemongrid.com", "designmil.org", "freshtrendhq.com", "valisimofashions.com", "buyneatly.com", "getbeauty.us", "intellimidia.com" ],
            customCountry: !1,
            SUPPORTED_BROWSERS: {
                msie: "11",
                firefox: "43",
                chrome: "41",
                safari: "8",
                opera: "23",
                msedge: "14",
                samsungBrowser: "2.1",
                silk: "59.3",
                ucbrowser: "10.0.0.488",
                vivaldi: "1.91"
            },
            session_uid_lifetime: 3e5,
            _apiStage: "",
            get apiStage() {
                return config._apiStage || config.stage;
            },
            set apiStage(value) {
                config._apiStage = value;
            },
            ports: {
                default: 8e3,
                button: 8e3,
                checkout: 8e3,
                guest: 8001,
                altpay: 3e3
            },
            get paypalUrls() {
                var _ref;
                return (_ref = {})[constants.t.LOCAL] = config.localhostUrl, _ref[constants.t.STAGE] = "https://" + config.stageUrl, 
                _ref[constants.t.SANDBOX] = "https://www.sandbox.paypal.com", _ref[constants.t.PRODUCTION] = "https://www.paypal.com", 
                _ref[constants.t.TEST] = window.location.protocol + "//" + window.location.host, 
                _ref[constants.t.DEMO] = window.location.protocol + "//localhost.paypal.com:" + window.location.port, 
                _ref;
            },
            get paypalDomains() {
                var _ref2;
                return (_ref2 = {})[constants.t.LOCAL] = config.localhostUrl, _ref2[constants.t.STAGE] = "https://" + config.stageUrl, 
                _ref2[constants.t.SANDBOX] = "https://www.sandbox.paypal.com", _ref2[constants.t.PRODUCTION] = "https://www.paypal.com", 
                _ref2[constants.t.TEST] = "mock://www.paypal.com", _ref2[constants.t.DEMO] = window.location.protocol + "//localhost.paypal.com:" + window.location.port, 
                _ref2;
            },
            get wwwApiUrls() {
                var _ref3;
                return (_ref3 = {})[constants.t.LOCAL] = config.localSDKDomain || "https://" + config.stageUrl, 
                _ref3[constants.t.STAGE] = "https://" + config.stageUrl, _ref3[constants.t.SANDBOX] = "https://www.sandbox.paypal.com", 
                _ref3[constants.t.PRODUCTION] = "https://www.paypal.com", _ref3[constants.t.TEST] = window.location.protocol + "//" + window.location.host, 
                _ref3;
            },
            get corsApiUrls() {
                var _ref4;
                return (_ref4 = {})[constants.t.LOCAL] = "https://" + config.stageUrl, _ref4[constants.t.STAGE] = "https://" + config.apiStageUrl + ":12326", 
                _ref4[constants.t.SANDBOX] = "https://cors.api.sandbox.paypal.com", _ref4[constants.t.PRODUCTION] = "https://cors.api.paypal.com", 
                _ref4[constants.t.TEST] = window.location.protocol + "//" + window.location.host, 
                _ref4;
            },
            get apiUrls() {
                var _ref5;
                var domain = window.location.protocol + "//" + window.location.host;
                var corsApiUrls = config.corsApiUrls;
                var wwwApiUrls = config.wwwApiUrls;
                return (_ref5 = {})[constants.t.LOCAL] = domain === wwwApiUrls.local ? wwwApiUrls.local : corsApiUrls.local, 
                _ref5[constants.t.STAGE] = domain === wwwApiUrls.stage ? wwwApiUrls.stage : corsApiUrls.stage, 
                _ref5[constants.t.SANDBOX] = domain === wwwApiUrls.sandbox ? wwwApiUrls.sandbox : corsApiUrls.sandbox, 
                _ref5[constants.t.PRODUCTION] = domain === wwwApiUrls.production ? wwwApiUrls.production : corsApiUrls.production, 
                _ref5[constants.t.TEST] = domain === wwwApiUrls.test ? wwwApiUrls.test : corsApiUrls.test, 
                _ref5;
            },
            get checkoutUri() {
                return null;
            },
            set checkoutUri(val) {
                delete this.checkoutUri;
                this.checkoutUri = val;
            },
            get checkoutUris() {
                var _ref7;
                if (config.checkoutUri) {
                    var _ref6;
                    return (_ref6 = {})[constants.t.LOCAL] = config.checkoutUri, _ref6[constants.t.STAGE] = config.checkoutUri, 
                    _ref6[constants.t.SANDBOX] = config.checkoutUri, _ref6[constants.t.PRODUCTION] = config.checkoutUri, 
                    _ref6[constants.t.TEST] = config.checkoutUri, _ref6[constants.t.DEMO] = config.checkoutUri, 
                    _ref6;
                }
                return (_ref7 = {})[constants.t.LOCAL] = "/webapps/hermes", _ref7[constants.t.STAGE] = "/webapps/hermes", 
                _ref7[constants.t.SANDBOX] = "/checkoutnow", _ref7[constants.t.PRODUCTION] = "/checkoutnow", 
                _ref7[constants.t.TEST] = "/base/test/windows/checkout/index.htm?checkouturl=true", 
                _ref7[constants.t.DEMO] = "/demo/dev/checkout.htm", _ref7;
            },
            altpayUris: (_altpayUris = {}, _altpayUris[constants.t.LOCAL] = "/latinumcheckout", 
            _altpayUris[constants.t.STAGE] = "/latinumcheckout", _altpayUris[constants.t.SANDBOX] = "/latinumcheckout", 
            _altpayUris[constants.t.PRODUCTION] = "/latinumcheckout", _altpayUris[constants.t.TEST] = "/base/test/windows/checkout/index.htm?checkouturl=true", 
            _altpayUris[constants.t.DEMO] = "/demo/dev/checkout.htm", _altpayUris),
            guestUris: (_guestUris = {}, _guestUris[constants.t.LOCAL] = "/webapps/xoonboarding", 
            _guestUris[constants.t.STAGE] = "/webapps/xoonboarding", _guestUris[constants.t.SANDBOX] = "/webapps/xoonboarding", 
            _guestUris[constants.t.PRODUCTION] = "/webapps/xoonboarding", _guestUris[constants.t.TEST] = "/base/test/windows/checkout/index.htm?guesturl=true", 
            _guestUris[constants.t.DEMO] = "/demo/dev/guest.htm", _guestUris),
            billingUris: (_billingUris = {}, _billingUris[constants.t.LOCAL] = "/webapps/hermes/agreements", 
            _billingUris[constants.t.STAGE] = "/webapps/hermes/agreements", _billingUris[constants.t.SANDBOX] = "/agreements/approve", 
            _billingUris[constants.t.PRODUCTION] = "/agreements/approve", _billingUris[constants.t.TEST] = "/base/test/windows/checkout/index.htm?billingurl=true", 
            _billingUris[constants.t.DEMO] = "/demo/dev/checkout.htm", _billingUris),
            buttonUris: (_buttonUris = {}, _buttonUris[constants.t.LOCAL] = "/smart/button", 
            _buttonUris[constants.t.STAGE] = "/smart/button", _buttonUris[constants.t.SANDBOX] = "/smart/button", 
            _buttonUris[constants.t.PRODUCTION] = "/smart/button", _buttonUris[constants.t.TEST] = "/base/test/windows/button/index.htm", 
            _buttonUris[constants.t.DEMO] = "/demo/dev/button.htm", _buttonUris),
            inlinedCardFieldUris: (_inlinedCardFieldUris = {}, _inlinedCardFieldUris[constants.t.LOCAL] = "/smart/card-fields", 
            _inlinedCardFieldUris[constants.t.STAGE] = "/smart/card-fields", _inlinedCardFieldUris[constants.t.SANDBOX] = "/smart/card-fields", 
            _inlinedCardFieldUris[constants.t.PRODUCTION] = "/smart/card-fields", _inlinedCardFieldUris[constants.t.TEST] = "/base/test/windows/card-fields/index.htm", 
            _inlinedCardFieldUris[constants.t.DEMO] = "/demo/dev/card.htm", _inlinedCardFieldUris),
            postBridgeUris: (_postBridgeUris = {}, _postBridgeUris[constants.t.LOCAL] = "/webapps/hermes/component-meta", 
            _postBridgeUris[constants.t.STAGE] = "/webapps/hermes/component-meta", _postBridgeUris[constants.t.SANDBOX] = "/webapps/hermes/component-meta", 
            _postBridgeUris[constants.t.PRODUCTION] = "/webapps/hermes/component-meta", _postBridgeUris[constants.t.TEST] = "/base/test/windows/component-meta/index.htm", 
            _postBridgeUris[constants.t.DEMO] = "/demo/dev/bridge.htm", _postBridgeUris),
            legacyCheckoutUris: (_legacyCheckoutUris = {}, _legacyCheckoutUris[constants.t.LOCAL] = "/cgi-bin/webscr?cmd=_express-checkout&xo_node_fallback=true", 
            _legacyCheckoutUris[constants.t.STAGE] = "/cgi-bin/webscr?cmd=_express-checkout&xo_node_fallback=true", 
            _legacyCheckoutUris[constants.t.SANDBOX] = "/cgi-bin/webscr?cmd=_express-checkout&xo_node_fallback=true", 
            _legacyCheckoutUris[constants.t.PRODUCTION] = "/cgi-bin/webscr?cmd=_express-checkout&xo_node_fallback=true", 
            _legacyCheckoutUris[constants.t.TEST] = "#fallback", _legacyCheckoutUris),
            buttonJSUrls: (_buttonJSUrls = {}, _buttonJSUrls[constants.t.LOCAL] = "https://www.paypalobjects.com/api/button.js", 
            _buttonJSUrls[constants.t.STAGE] = "https://www.paypalobjects.com/api/button.js", 
            _buttonJSUrls[constants.t.SANDBOX] = "https://www.paypalobjects.com/api/button.js", 
            _buttonJSUrls[constants.t.PRODUCTION] = "https://www.paypalobjects.com/api/button.js", 
            _buttonJSUrls[constants.t.TEST] = "/base/test/lib/button.js", _buttonJSUrls[constants.t.DEMO] = "https://www.paypalobjects.com/api/button.js", 
            _buttonJSUrls),
            get buttonJSUrl() {
                return config.buttonJSUrls[config.env];
            },
            loginUri: "/signin/",
            hermesLoggerUri: "/webapps/hermes/api/logger",
            loggerUri: "/xoplatform/logger/api/logger",
            loggerThrottlePercentage: 1,
            pptmUri: "/tagmanager/pptm.js",
            get postBridgeUri() {
                return config.postBridgeUris[config.env] + "?xcomponent=1";
            },
            paymentStandardUri: "/webapps/xorouter?cmd=_s-xclick",
            authApiUri: "/v1/oauth2/token",
            paymentApiUri: "/v1/payments/payment",
            orderApiUri: "/v2/checkout/orders",
            billingApiUri: "/v1/billing-agreements/agreement-tokens",
            experienceApiUri: "/v1/payment-experience/web-profiles",
            trackingApiUri: "/v1/risk/transaction-contexts",
            get checkoutUrls() {
                var _ref8;
                var paypalUrls = config.paypalUrls;
                return (_ref8 = {})[constants.t.LOCAL] = "" + paypalUrls.local + config.checkoutUris.local.replace(":" + config.ports.default, ":" + config.ports.checkout), 
                _ref8[constants.t.STAGE] = "" + paypalUrls.stage + config.checkoutUris.stage, _ref8[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.checkoutUris.sandbox, 
                _ref8[constants.t.PRODUCTION] = "" + paypalUrls.production + config.checkoutUris.production, 
                _ref8[constants.t.TEST] = "" + paypalUrls.test + config.checkoutUris.test, _ref8[constants.t.DEMO] = "" + paypalUrls.test + config.checkoutUris.demo, 
                _ref8;
            },
            get guestUrls() {
                var _ref9;
                var paypalUrls = config.paypalUrls;
                return (_ref9 = {})[constants.t.LOCAL] = "" + paypalUrls.local.replace(":" + config.ports.default, ":" + config.ports.guest) + config.guestUris.local, 
                _ref9[constants.t.STAGE] = "" + paypalUrls.stage + config.guestUris.stage, _ref9[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.guestUris.sandbox, 
                _ref9[constants.t.PRODUCTION] = "" + paypalUrls.production + config.guestUris.production, 
                _ref9[constants.t.TEST] = "" + paypalUrls.test + config.guestUris.test, _ref9[constants.t.DEMO] = "" + paypalUrls.test + config.guestUris.demo, 
                _ref9;
            },
            get altpayUrls() {
                var _ref10;
                var paypalUrls = config.paypalUrls;
                return (_ref10 = {})[constants.t.LOCAL] = "" + paypalUrls.local.replace(":" + config.ports.default, ":" + config.ports.altpay) + config.altpayUris.local, 
                _ref10[constants.t.STAGE] = "" + paypalUrls.stage + config.altpayUris.stage, _ref10[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.altpayUris.sandbox, 
                _ref10[constants.t.PRODUCTION] = "" + paypalUrls.production + config.altpayUris.production, 
                _ref10[constants.t.TEST] = "" + paypalUrls.test + config.altpayUris.test, _ref10[constants.t.DEMO] = "" + paypalUrls.test + config.altpayUris.demo, 
                _ref10;
            },
            get billingUrls() {
                var _ref11;
                var paypalUrls = config.paypalUrls;
                return (_ref11 = {})[constants.t.LOCAL] = "" + paypalUrls.local.replace(":" + config.ports.default, ":" + config.ports.checkout) + config.billingUris.local, 
                _ref11[constants.t.STAGE] = "" + paypalUrls.stage + config.billingUris.stage, _ref11[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.billingUris.sandbox, 
                _ref11[constants.t.PRODUCTION] = "" + paypalUrls.production + config.billingUris.production, 
                _ref11[constants.t.TEST] = "" + paypalUrls.test + config.billingUris.test, _ref11[constants.t.DEMO] = "" + paypalUrls.test + config.billingUris.demo, 
                _ref11;
            },
            get buttonUrls() {
                var _ref12;
                var paypalUrls = config.paypalUrls;
                return (_ref12 = {})[constants.t.LOCAL] = "" + paypalUrls.local.replace(":" + config.ports.default, ":" + config.ports.button) + config.buttonUris.local, 
                _ref12[constants.t.STAGE] = "" + paypalUrls.stage + config.buttonUris.stage, _ref12[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.buttonUris.sandbox, 
                _ref12[constants.t.PRODUCTION] = "" + paypalUrls.production + config.buttonUris.production, 
                _ref12[constants.t.TEST] = "" + paypalUrls.test + config.buttonUris.test, _ref12[constants.t.DEMO] = "" + paypalUrls.demo + config.buttonUris.demo, 
                _ref12;
            },
            get inlinedCardFieldUrls() {
                var _ref13;
                var paypalUrls = config.paypalUrls;
                return (_ref13 = {})[constants.t.LOCAL] = "" + paypalUrls.local.replace(":" + config.ports.default, ":" + config.ports.button) + config.inlinedCardFieldUris.local, 
                _ref13[constants.t.STAGE] = "" + paypalUrls.stage + config.inlinedCardFieldUris.stage, 
                _ref13[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.inlinedCardFieldUris.sandbox, 
                _ref13[constants.t.PRODUCTION] = "" + paypalUrls.production + config.inlinedCardFieldUris.production, 
                _ref13[constants.t.TEST] = "" + paypalUrls.test + config.inlinedCardFieldUris.test, 
                _ref13[constants.t.DEMO] = "" + paypalUrls.demo + config.inlinedCardFieldUris.demo, 
                _ref13;
            },
            get loginUrls() {
                var _ref14;
                var paypalUrls = config.paypalUrls;
                return (_ref14 = {})[constants.t.LOCAL] = "" + paypalUrls.stage + config.loginUri, 
                _ref14[constants.t.STAGE] = "" + paypalUrls.stage + config.loginUri, _ref14[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.loginUri, 
                _ref14[constants.t.PRODUCTION] = "" + paypalUrls.production + config.loginUri, _ref14[constants.t.TEST] = "" + paypalUrls.test + config.loginUri, 
                _ref14;
            },
            get paymentsStandardUrls() {
                var _ref15;
                var paypalUrls = config.paypalUrls;
                return (_ref15 = {})[constants.t.LOCAL] = "" + paypalUrls.local + config.paymentStandardUri, 
                _ref15[constants.t.STAGE] = "" + paypalUrls.stage + config.paymentStandardUri, _ref15[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.paymentStandardUri, 
                _ref15[constants.t.PRODUCTION] = "" + paypalUrls.production + config.paymentStandardUri, 
                _ref15[constants.t.TEST] = "" + paypalUrls.test + config.paymentStandardUri, _ref15;
            },
            get metaFrameUrls() {
                var _ref16;
                var paypalUrls = config.paypalUrls;
                return (_ref16 = {})[constants.t.LOCAL] = "" + paypalUrls.local + config.postBridgeUri + "&env=local", 
                _ref16[constants.t.STAGE] = "" + paypalUrls.stage + config.postBridgeUri + "&env=stage&stage=" + config.stage, 
                _ref16[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.postBridgeUri + "&env=sandbox", 
                _ref16[constants.t.PRODUCTION] = "" + paypalUrls.production + config.postBridgeUri + "&env=production", 
                _ref16[constants.t.TEST] = "" + paypalUrls.test + config.postBridgeUri + "&env=test", 
                _ref16[constants.t.DEMO] = "" + paypalUrls.demo + config.postBridgeUri + "&env=demo", 
                _ref16;
            },
            get legacyCheckoutUrls() {
                var _ref17;
                var paypalUrls = config.paypalUrls;
                return (_ref17 = {})[constants.t.LOCAL] = "" + paypalUrls.stage + config.legacyCheckoutUris.local, 
                _ref17[constants.t.STAGE] = "" + paypalUrls.stage + config.legacyCheckoutUris.stage, 
                _ref17[constants.t.SANDBOX] = "" + paypalUrls.sandbox + config.legacyCheckoutUris.sandbox, 
                _ref17[constants.t.PRODUCTION] = "" + paypalUrls.production + config.legacyCheckoutUris.production, 
                _ref17[constants.t.TEST] = "" + paypalUrls.test + config.legacyCheckoutUris.test, 
                _ref17;
            },
            get authApiUrls() {
                var _ref18;
                var apiUrls = config.apiUrls;
                var authApiUri = config.authApiUri;
                return (_ref18 = {})[constants.t.LOCAL] = "" + apiUrls.local + authApiUri, _ref18[constants.t.STAGE] = "" + apiUrls.stage + authApiUri, 
                _ref18[constants.t.SANDBOX] = "" + apiUrls.sandbox + authApiUri, _ref18[constants.t.PRODUCTION] = "" + apiUrls.production + authApiUri, 
                _ref18[constants.t.TEST] = "" + apiUrls.test + authApiUri, _ref18;
            },
            get paymentApiUrls() {
                var _ref19;
                var apiUrls = config.apiUrls;
                var paymentApiUri = config.paymentApiUri;
                return (_ref19 = {})[constants.t.LOCAL] = "" + apiUrls.local + paymentApiUri, _ref19[constants.t.STAGE] = "" + apiUrls.stage + paymentApiUri, 
                _ref19[constants.t.SANDBOX] = "" + apiUrls.sandbox + paymentApiUri, _ref19[constants.t.PRODUCTION] = "" + apiUrls.production + paymentApiUri, 
                _ref19[constants.t.TEST] = "" + apiUrls.test + paymentApiUri, _ref19;
            },
            get orderApiUrls() {
                var _ref20;
                var apiUrls = config.apiUrls;
                var orderApiUri = config.orderApiUri;
                return (_ref20 = {})[constants.t.LOCAL] = "" + apiUrls.local + orderApiUri, _ref20[constants.t.STAGE] = "" + apiUrls.stage + orderApiUri, 
                _ref20[constants.t.SANDBOX] = "" + apiUrls.sandbox + orderApiUri, _ref20[constants.t.PRODUCTION] = "" + apiUrls.production + orderApiUri, 
                _ref20[constants.t.TEST] = "" + apiUrls.test + orderApiUri, _ref20;
            },
            get billingApiUrls() {
                var _ref21;
                var apiUrls = config.apiUrls;
                var billingApiUri = config.billingApiUri;
                return (_ref21 = {})[constants.t.LOCAL] = "" + apiUrls.local + billingApiUri, _ref21[constants.t.STAGE] = "" + apiUrls.stage + billingApiUri, 
                _ref21[constants.t.SANDBOX] = "" + apiUrls.sandbox + billingApiUri, _ref21[constants.t.PRODUCTION] = "" + apiUrls.production + billingApiUri, 
                _ref21[constants.t.TEST] = "" + apiUrls.test + billingApiUri, _ref21;
            },
            get experienceApiUrls() {
                var _ref22;
                var apiUrls = config.apiUrls;
                var experienceApiUri = config.experienceApiUri;
                return (_ref22 = {})[constants.t.LOCAL] = "" + apiUrls.local + experienceApiUri, 
                _ref22[constants.t.STAGE] = "" + apiUrls.stage + experienceApiUri, _ref22[constants.t.SANDBOX] = "" + apiUrls.sandbox + experienceApiUri, 
                _ref22[constants.t.PRODUCTION] = "" + apiUrls.production + experienceApiUri, _ref22[constants.t.TEST] = "" + apiUrls.test + experienceApiUri, 
                _ref22;
            },
            get trackingApiUrls() {
                var _ref23;
                var apiUrls = config.apiUrls;
                var trackingApiUri = config.trackingApiUri;
                return (_ref23 = {})[constants.t.LOCAL] = "" + apiUrls.local + trackingApiUri, _ref23[constants.t.STAGE] = "" + apiUrls.stage + trackingApiUri, 
                _ref23[constants.t.SANDBOX] = "" + apiUrls.sandbox + trackingApiUri, _ref23[constants.t.PRODUCTION] = "" + apiUrls.production + trackingApiUri, 
                _ref23[constants.t.TEST] = "" + apiUrls.test + trackingApiUri, _ref23;
            },
            _paypalUrl: "",
            get paypalUrl() {
                return this._paypalUrl || config.paypalUrls[config.env];
            },
            set paypalUrl(value) {
                this._paypalUrl = value;
            },
            get paypalDomain() {
                return config.paypalDomains[config.env];
            },
            get corsApiUrl() {
                return config.corsApiUrls[config.env];
            },
            get wwwApiUrl() {
                return config.wwwApiUrls[config.env];
            },
            get apiUrl() {
                var domain = window.location.protocol + "//" + window.location.host;
                var wwwApiUrl = config.wwwApiUrl;
                return domain === wwwApiUrl ? wwwApiUrl : config.corsApiUrl;
            },
            get checkoutUrl() {
                return "" + config.paypalUrl + config.checkoutUris[config.env];
            },
            get billingUrl() {
                return "" + config.paypalUrl + config.billingUris[config.env];
            },
            get buttonUrl() {
                return "" + config.paypalUrl + config.buttonUris[config.env];
            },
            get legacyCheckoutUrl() {
                return config.legacyCheckoutUrls[config.env];
            },
            get postBridgeUrl() {
                return "" + config.paypalUrl + config.postBridgeUri;
            },
            get postBridgeDomain() {
                return "" + config.paypalDomain;
            },
            get loggerUrl() {
                var isTestExperiment = Math.random() < config.loggerThrottlePercentage;
                return "" + config.paypalUrl + (isTestExperiment ? config.loggerUri : config.hermesLoggerUri);
            },
            get pptmUrl() {
                return "" + config.paypalUrls[config.env] + config.pptmUri;
            },
            get authApiUrl() {
                return "" + config.apiUrl + config.authApiUri;
            },
            get paymentApiUrl() {
                return "" + config.apiUrl + config.paymentApiUri;
            },
            get orderApiUrl() {
                return "" + config.apiUrl + config.orderApiUri;
            },
            get billingApiUrl() {
                return "" + config.apiUrl + config.billingApiUri;
            },
            get experienceApiUrl() {
                return "" + config.apiUrl + config.experienceApiUri;
            },
            defaultLocale: {
                country: constants.r.US,
                lang: constants.y.EN
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "F", (function() {
            return isSupportedNativeBrowser;
        }));
        __webpack_require__.d(__webpack_exports__, "I", (function() {
            return util.j;
        }));
        __webpack_require__.d(__webpack_exports__, "K", (function() {
            return util.k;
        }));
        __webpack_require__.d(__webpack_exports__, "V", (function() {
            return util.s;
        }));
        __webpack_require__.d(__webpack_exports__, "H", (function() {
            return util.i;
        }));
        __webpack_require__.d(__webpack_exports__, "R", (function() {
            return util.o;
        }));
        __webpack_require__.d(__webpack_exports__, "e", (function() {
            return util.c;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return util.a;
        }));
        __webpack_require__.d(__webpack_exports__, "T", (function() {
            return util.q;
        }));
        __webpack_require__.d(__webpack_exports__, "U", (function() {
            return util.r;
        }));
        __webpack_require__.d(__webpack_exports__, "M", (function() {
            return util.l;
        }));
        __webpack_require__.d(__webpack_exports__, "f", (function() {
            return util.d;
        }));
        __webpack_require__.d(__webpack_exports__, "A", (function() {
            return initLogger;
        }));
        __webpack_require__.d(__webpack_exports__, "S", (function() {
            return setLogLevel;
        }));
        __webpack_require__.d(__webpack_exports__, "h", (function() {
            return getBrowser;
        }));
        __webpack_require__.d(__webpack_exports__, "C", (function() {
            return isEligible;
        }));
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return checkRecognizedBrowser;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return checkForCommonErrors;
        }));
        __webpack_require__.d(__webpack_exports__, "G", (function() {
            return loadScript;
        }));
        __webpack_require__.d(__webpack_exports__, "n", (function() {
            return getElement;
        }));
        __webpack_require__.d(__webpack_exports__, "o", (function() {
            return getElements;
        }));
        __webpack_require__.d(__webpack_exports__, "J", (function() {
            return onDocumentReady;
        }));
        __webpack_require__.d(__webpack_exports__, "q", (function() {
            return getQueryParam;
        }));
        __webpack_require__.d(__webpack_exports__, "W", (function() {
            return urlWillRedirectPage;
        }));
        __webpack_require__.d(__webpack_exports__, "g", (function() {
            return extendUrl;
        }));
        __webpack_require__.d(__webpack_exports__, "O", (function() {
            return redirect;
        }));
        __webpack_require__.d(__webpack_exports__, "i", (function() {
            return getBrowserLocale;
        }));
        __webpack_require__.d(__webpack_exports__, "B", (function() {
            return isElementVisible;
        }));
        __webpack_require__.d(__webpack_exports__, "p", (function() {
            return getPageRenderTime;
        }));
        __webpack_require__.d(__webpack_exports__, "t", (function() {
            return getResourceLoadTime;
        }));
        __webpack_require__.d(__webpack_exports__, "Q", (function() {
            return request;
        }));
        __webpack_require__.d(__webpack_exports__, "z", (function() {
            return getThrottle;
        }));
        __webpack_require__.d(__webpack_exports__, "u", (function() {
            return getReturnToken;
        }));
        __webpack_require__.d(__webpack_exports__, "y", (function() {
            return getStorageID;
        }));
        __webpack_require__.d(__webpack_exports__, "x", (function() {
            return getSessionState;
        }));
        __webpack_require__.d(__webpack_exports__, "w", (function() {
            return getSessionID;
        }));
        __webpack_require__.d(__webpack_exports__, "j", (function() {
            return getButtonSessionID;
        }));
        __webpack_require__.d(__webpack_exports__, "L", (function() {
            return openMetaFrame;
        }));
        __webpack_require__.d(__webpack_exports__, "r", (function() {
            return getRememberedFunding;
        }));
        __webpack_require__.d(__webpack_exports__, "P", (function() {
            return rememberFunding;
        }));
        __webpack_require__.d(__webpack_exports__, "D", (function() {
            return isFundingRemembered;
        }));
        __webpack_require__.d(__webpack_exports__, "N", (function() {
            return precacheRememberedFunding;
        }));
        __webpack_require__.d(__webpack_exports__, "s", (function() {
            return getRenderedButtons;
        }));
        __webpack_require__.d(__webpack_exports__, "k", (function() {
            return getCurrentScript;
        }));
        __webpack_require__.d(__webpack_exports__, "v", (function() {
            return getScriptVersion;
        }));
        __webpack_require__.d(__webpack_exports__, "l", (function() {
            return getCurrentScriptUrl;
        }));
        __webpack_require__.d(__webpack_exports__, "m", (function() {
            return getDomainSetting;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return allowIframe;
        }));
        __webpack_require__.d(__webpack_exports__, "E", (function() {
            return isPayPalDomain;
        }));
        var cross_domain_utils_src = __webpack_require__(7);
        var belter_src = __webpack_require__(11);
        function isSupportedNativeBrowser() {
            var userAgent = Object(belter_src.c)();
            return !(!Object(belter_src.t)(userAgent) || Object(belter_src.n)() || (!Object(belter_src.l)() || !Object(belter_src.o)()) && (!Object(belter_src.f)() || !Object(belter_src.g)()));
        }
        var util = __webpack_require__(14);
        var post_robot_src = __webpack_require__(15);
        var client = __webpack_require__(5);
        var config = __webpack_require__(3);
        var constants = __webpack_require__(0);
        var zalgo_promise_src = __webpack_require__(2);
        function isDocumentReady() {
            return Boolean(document.body) && "complete" === document.readyState;
        }
        var documentReady = new zalgo_promise_src.a((function(resolve) {
            if (isDocumentReady()) return resolve();
            var interval = setInterval((function() {
                if (isDocumentReady()) {
                    clearInterval(interval);
                    return resolve();
                }
            }), 10);
        }));
        documentReady.then((function() {
            if (document.body) return document.body;
            throw new Error("Document ready but document.body not present");
        }));
        function loadScript(src, timeout, attrs) {
            void 0 === timeout && (timeout = 0);
            void 0 === attrs && (attrs = {});
            return new zalgo_promise_src.a((function(resolve, reject) {
                var script = document.createElement("script");
                script.addEventListener("load", (function() {
                    resolve();
                }));
                script.onreadystatechange = function() {
                    "complete" !== this.readyState && "loaded" !== this.readyState || resolve();
                };
                var scriptLoadError = new Error("script_loading_error");
                script.addEventListener("error", (function() {
                    return reject(scriptLoadError);
                }));
                timeout && setTimeout((function() {
                    return reject(new Error("script_loading_timed_out"));
                }), timeout);
                for (var _i2 = 0, _Object$keys2 = Object.keys(attrs); _i2 < _Object$keys2.length; _i2++) {
                    var attr = _Object$keys2[_i2];
                    script.setAttribute(attr, attrs[attr]);
                }
                script.setAttribute("src", src);
                document.getElementsByTagName("head")[0].appendChild(script);
            }));
        }
        function getElement(item) {
            if (item) {
                if (item instanceof HTMLElement) return item;
                if ("string" == typeof item) {
                    if (document.querySelector) {
                        var result = document.querySelector(item);
                        if (result) return result;
                    }
                    return document.getElementById(item);
                }
            }
        }
        function getElements(collection) {
            if (!collection) return [];
            if (collection instanceof HTMLElement || "string" == typeof collection) {
                var element = getElement(collection);
                return element ? [ element ] : [];
            }
            if (Array.isArray(collection) || collection instanceof NodeList || collection instanceof HTMLCollection) {
                var result = [];
                for (var i = 0; i < collection.length; i++) {
                    var el = getElement(collection[i]);
                    el && result.push(el);
                }
                return result;
            }
            return [];
        }
        function onDocumentReady(method) {
            return documentReady.then(method);
        }
        var parseQuery = Object(util.i)((function(queryString) {
            var params = {};
            if (!queryString) return params;
            if (-1 === queryString.indexOf("=")) return params;
            for (var _i4 = 0, _queryString$split2 = queryString.split("&"); _i4 < _queryString$split2.length; _i4++) {
                var pair = _queryString$split2[_i4];
                (pair = pair.split("="))[0] && pair[1] && (params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]));
            }
            return params;
        }));
        function getQueryParam(name) {
            return parseQuery(window.location.search.slice(1))[name];
        }
        function urlWillRedirectPage(url) {
            return -1 === url.indexOf("#") || 0 !== url.indexOf("#") && url.split("#")[0] !== window.location.href.split("#")[0];
        }
        function extendUrl(url, params) {
            void 0 === params && (params = {});
            var hasHash = url.indexOf("#") > 0;
            var _url$split = url.split("#"), serverUrl = _url$split[0], hash = _url$split[1];
            if (hash && !serverUrl) {
                var _ref = [ "#" + hash, "" ];
                serverUrl = _ref[0];
                hash = _ref[1];
            }
            var _serverUrl$split = serverUrl.split("?"), originalUrl = _serverUrl$split[0], originalQueryString = _serverUrl$split[1];
            if (originalQueryString) {
                var originalQuery = parseQuery(originalQueryString);
                for (var _key in originalQuery) params.hasOwnProperty(_key) || (params[_key] = originalQuery[_key]);
            }
            var newQueryString = Object.keys(params).filter((function(key) {
                return key && params[key];
            })).sort().map((function(key) {
                return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
            })).join("&");
            var newUrl = originalUrl;
            newQueryString && (newUrl = newUrl + "?" + newQueryString);
            hasHash && (newUrl = newUrl + "#" + (hash || ""));
            return newUrl;
        }
        function redirect(win, url) {
            void 0 === win && (win = window);
            return new zalgo_promise_src.a((function(resolve) {
                Object(client.k)("redirect", {
                    url: url
                });
                setTimeout((function() {
                    win.location = url;
                    urlWillRedirectPage(url) || resolve();
                }), 1);
            }));
        }
        function normalizeLocale(locale) {
            if (locale && locale.match(/^[a-z]{2}[-_][A-Z]{2}$/)) {
                var _locale$split = locale.split(/[-_]/), lang = _locale$split[0], country = _locale$split[1];
                if (constants.A[country] && -1 !== constants.A[country].indexOf(lang)) return {
                    country: country,
                    lang: lang
                };
            }
        }
        function normalizeLang(lang) {
            if (lang && lang.match(/^[a-z]{2}$/) && constants.z[lang]) return {
                country: constants.z[lang],
                lang: lang
            };
        }
        var getBrowserLocale = Object(util.i)((function() {
            var locales = function() {
                var nav = window.navigator;
                var locales = nav.languages ? [].slice.apply(nav.languages) : [];
                nav.language && locales.push(nav.language);
                nav.userLanguage && locales.push(nav.userLanguage);
                return locales;
            }();
            for (var _i6 = 0; _i6 < locales.length; _i6++) {
                var locale = locales[_i6];
                var loc = normalizeLocale(locale);
                if (loc) {
                    Object(client.k)("better_browser_locale_full");
                    return loc;
                }
                if (loc = normalizeLang(locale)) {
                    Object(client.k)("better_browser_locale_lang");
                    return loc;
                }
            }
            return config.a.defaultLocale;
        }));
        function isElementVisible(el) {
            return Boolean(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
        }
        var enablePerformance = Object(util.i)((function() {
            return Boolean(window.performance && performance.now && performance.timing && performance.timing.connectEnd && performance.timing.navigationStart && Math.abs(performance.now() - Date.now()) > 1e3 && performance.now() - (performance.timing.connectEnd - performance.timing.navigationStart) > 0);
        }));
        function getPageRenderTime() {
            return documentReady.then((function() {
                if (enablePerformance()) {
                    var timing = window.performance.timing;
                    return timing.connectEnd && timing.domInteractive ? timing.domInteractive - timing.connectEnd : void 0;
                }
            }));
        }
        function getResourceLoadTime(url) {
            if (enablePerformance() && window.performance && "function" == typeof window.performance.getEntries) {
                var entries = window.performance.getEntries();
                for (var i = 0; i < entries.length; i++) {
                    var entry = entries[i];
                    if (entry && entry.name === url && entry.duration && entry.duration >= 0 && entry.duration <= 6e4) return Math.floor(entry.duration);
                }
            }
        }
        function allowIframe() {
            if (!Object(belter_src.t)()) return !0;
            var parentWindow = Object(cross_domain_utils_src.n)(window);
            if (parentWindow && Object(cross_domain_utils_src.v)(parentWindow)) return !0;
            var parentComponentWindow = window.xchild && window.xchild.getParentComponentWindow();
            return !(!parentComponentWindow || !Object(cross_domain_utils_src.v)(parentComponentWindow));
        }
        function isPayPalDomain() {
            return Boolean((window.location.protocol + "//" + window.location.host).match(config.a.paypal_domain_regex)) || "mock://www.paypal.com" === window.mockDomain;
        }
        var accessedStorage;
        function getStorageState(handler) {
            var localStorageEnabled = Object(util.f)();
            var storage;
            accessedStorage && (storage = accessedStorage);
            if (!storage && localStorageEnabled) {
                var rawStorage = window.localStorage.getItem("__paypal_storage__");
                rawStorage && (storage = JSON.parse(rawStorage));
            }
            storage || (storage = window.__paypal_storage__);
            storage || (storage = {
                id: Object(util.s)()
            });
            storage.id || (storage.id = Object(util.s)());
            accessedStorage = storage;
            var result = handler(storage);
            localStorageEnabled ? window.localStorage.setItem("__paypal_storage__", JSON.stringify(storage)) : window.__paypal_storage__ = storage;
            accessedStorage = null;
            return result;
        }
        function getStorageID() {
            return getStorageState((function(storage) {
                return storage.id;
            }));
        }
        function getSession(handler) {
            return getStorageState((function(storage) {
                var session = storage.__paypal_session__;
                var now = Date.now();
                session && now - session.created > config.a.session_uid_lifetime && (session = null);
                session || (session = {
                    guid: Object(util.s)(),
                    created: now
                });
                storage.__paypal_session__ = session;
                return handler(session);
            }));
        }
        function getSessionState(handler) {
            return getSession((function(session) {
                session.state = session.state || {};
                return handler(session.state);
            }));
        }
        function getSessionID() {
            var xprops = window.xprops;
            if (xprops && xprops.sessionID) return xprops.sessionID;
            var querySessionID = getQueryParam("sessionID");
            return isPayPalDomain() && querySessionID ? querySessionID : getSession((function(session) {
                return session.guid;
            }));
        }
        function getButtonSessionID() {
            if (window.xprops && window.xprops.buttonSessionID) return window.xprops.buttonSessionID;
            var querySessionID = getQueryParam("buttonSessionID");
            return isPayPalDomain() && querySessionID ? querySessionID : void 0;
        }
        var PAGE_TYPES = {
            HOME: "home",
            PRODUCT: "product",
            CART: "cart",
            CHECKOUT: "checkout",
            PRODUCT_LISTING: "product-listing",
            SEARCH_RESULTS: "search-results",
            PRODUCT_DETAILS: "product-details",
            MINI_CART: "mini-cart"
        };
        var getCurrentScript = Object(util.i)((function() {
            var localSDKUrl = config.a.localSDKUrl;
            var scripts = [].slice.call(document.getElementsByTagName("script"));
            for (var _i2 = 0; _i2 < scripts.length; _i2++) {
                var script = scripts[_i2];
                if (script.src && (script.src.replace(/^https?:/, "").split("?")[0] === config.a.scriptUrl || script.hasAttribute("data-paypal-checkout"))) return script;
                if (script.src && -1 !== script.src.indexOf("paypal.checkout.v4.js")) return script;
                if (config.a.env === constants.t.LOCAL && localSDKUrl && script.src === localSDKUrl) return script;
            }
            document.currentScript && Object(client.f)("current_script_not_recognized", {
                src: document.currentScript.src
            });
        }));
        function getScriptVersion() {
            return "4.0.331";
        }
        function getCurrentScriptUrl() {
            var script = getCurrentScript();
            if (script && "string" == typeof script.src) {
                var scriptUrl = script.src;
                0 === scriptUrl.indexOf("http://www.paypalobjects.com") && (scriptUrl = scriptUrl.replace("http://", "https://"));
                0 === scriptUrl.indexOf("//www.paypalobjects.com") && (scriptUrl = "https:" + scriptUrl);
                return scriptUrl;
            }
            return "https://www.paypalobjects.com/api/checkout.4.0.331.js";
        }
        function getDomainSetting(name, def) {
            var hostname = window.xchild ? window.xchild.getParentDomain() : Object(cross_domain_utils_src.h)();
            if (config.a.domain_settings) for (var _i4 = 0, _Object$keys2 = Object.keys(config.a.domain_settings); _i4 < _Object$keys2.length; _i4++) {
                var domain = _Object$keys2[_i4];
                if (Object(util.b)(hostname, domain)) return config.a.domain_settings[domain][name];
            }
            return def;
        }
        function getRefererDomain() {
            return window.xchild && window.xchild.getParentDomain ? window.xchild.getParentDomain() : window.location.host;
        }
        var setupProxyLogTransport = Object(util.k)((function() {
            Object(client.o)(function(name, win, originalMethod) {
                if (win && Object(cross_domain_utils_src.h)() === config.a.paypalDomain && !Object(cross_domain_utils_src.v)(win)) {
                    win && Object(post_robot_src.send)(win, "proxy_log", {
                        originalMethod: originalMethod
                    }).catch(util.j);
                    return originalMethod;
                }
                var methods = [];
                Object(post_robot_src.on)("proxy_log", {
                    domain: config.a.paypal_domain_regex
                }, (function(_ref) {
                    methods.push(_ref.data.originalMethod);
                }));
                return function() {
                    var _arguments = arguments, _this = this;
                    return (methods = methods.filter((function(method) {
                        return !Object(cross_domain_utils_src.z)(method.source);
                    }))).length ? methods[methods.length - 1].apply(this, arguments).catch((function() {
                        return originalMethod.apply(_this, _arguments);
                    })) : originalMethod.apply(this, arguments);
                };
            }(0, Object(cross_domain_utils_src.n)(window), Object(client.i)()));
        }));
        function initLogger() {
            setupProxyLogTransport();
            Object(client.c)((function() {
                return {
                    referer: getRefererDomain(),
                    host: window.location.host,
                    path: window.location.pathname,
                    env: config.a.env,
                    country: config.a.locale.country,
                    lang: config.a.locale.lang,
                    uid: getSessionID(),
                    ver: "4.0.331"
                };
            }));
            Object(client.a)((function() {
                return {
                    "x-app-name": "checkoutjs"
                };
            }));
            Object(client.b)((function() {
                return {
                    state: config.a.state
                };
            }));
            Object(client.d)((function(payload) {
                var _ref;
                void 0 === payload && (payload = {});
                var sessionID = getSessionID();
                var paymentToken = function() {
                    if (window.root && window.root.token) return window.root.token;
                    if (isPayPalDomain()) {
                        var queryToken = getQueryParam("token");
                        if (queryToken) return queryToken;
                    }
                }();
                var buttonSessionID = payload[constants.u.KEY.BUTTON_SESSION_UID] || getButtonSessionID();
                var contextType;
                var contextID;
                if (paymentToken) {
                    contextType = constants.u.CONTEXT_TYPE[constants.C.EC_TOKEN];
                    contextID = paymentToken;
                } else if (buttonSessionID) {
                    contextType = constants.u.CONTEXT_TYPE.BUTTON_SESSION_ID;
                    contextID = buttonSessionID;
                } else {
                    contextType = payload[constants.u.KEY.CONTEXT_TYPE];
                    contextID = payload[constants.u.KEY.CONTEXT_ID];
                }
                return (_ref = {})[constants.u.KEY.FEED] = constants.u.FEED.CHECKOUTJS, _ref[constants.u.KEY.DATA_SOURCE] = constants.u.DATA_SOURCE.CHECKOUT, 
                _ref[constants.u.KEY.CONTEXT_TYPE] = contextType, _ref[constants.u.KEY.CONTEXT_ID] = contextID, 
                _ref[constants.u.KEY.SELLER_ID] = config.a.merchantID, _ref[constants.u.KEY.SESSION_UID] = sessionID, 
                _ref[constants.u.KEY.BUTTON_SESSION_UID] = buttonSessionID, _ref[constants.u.KEY.VERSION] = config.a.version, 
                _ref[constants.u.KEY.TOKEN] = paymentToken, _ref[constants.u.KEY.PAGE_TYPE] = function() {
                    var script = getCurrentScript();
                    if (script && script.hasAttribute("data-page-type")) {
                        var pageType = script.getAttribute("data-page-type").toLowerCase();
                        if (-1 === Object(belter_src.v)(PAGE_TYPES).indexOf(pageType) && pageType.length) throw new Error("Invalid page type, '" + pageType + "'");
                        return pageType;
                    }
                    return "";
                }(), _ref[constants.u.KEY.REFERER] = getRefererDomain(), _ref[constants.u.KEY.TIMESTAMP] = Date.now().toString(), 
                _ref;
            }));
            window.location.protocol !== cross_domain_utils_src.a.FILE && Object(client.l)({
                uri: config.a.loggerUrl,
                heartbeat: !1,
                logPerformance: !1,
                prefix: "ppxo",
                logLevel: "warn"
            });
        }
        function setLogLevel(logLevel) {
            if (-1 === client.m.indexOf(logLevel)) throw new Error("Invalid logLevel: " + logLevel);
            config.a.logLevel = logLevel;
            client.e.logLevel = logLevel;
            post_robot_src.CONFIG.LOG_LEVEL = logLevel;
            window.LOG_LEVEL = logLevel;
        }
        var bowserCache = {};
        function getBowser() {
            var userAgent = Object(belter_src.c)();
            if (bowserCache[userAgent]) return bowserCache[userAgent];
            delete __webpack_require__.c[42];
            var bowser = __webpack_require__(42);
            bowserCache[userAgent] = bowser;
            return bowser;
        }
        function getBrowser() {
            var bowser = getBowser();
            for (var _i2 = 0, _Object$keys2 = Object.keys(config.a.SUPPORTED_BROWSERS); _i2 < _Object$keys2.length; _i2++) {
                var browser = _Object$keys2[_i2];
                if (bowser[browser]) return {
                    browser: browser,
                    version: bowser.version
                };
            }
            return {};
        }
        var eligibilityResults = {};
        function isEligible() {
            if (Object(belter_src.k)()) return !1;
            var userAgent = window.navigator.userAgent;
            if (userAgent && eligibilityResults.hasOwnProperty(userAgent)) return eligibilityResults[userAgent];
            var result = function() {
                if (Object(belter_src.k)()) return !1;
                var bowser = getBowser();
                var _getBrowser = getBrowser(), browser = _getBrowser.browser, version = _getBrowser.version;
                return !browser || !version || -1 !== bowser.compareVersions([ version, config.a.SUPPORTED_BROWSERS[browser] ]);
            }();
            eligibilityResults[userAgent] = result;
            return result;
        }
        var checkRecognizedBrowser = Object(util.k)((function(state) {
            if (!getBrowser().browser) {
                var _getBowser = getBowser(), name = _getBowser.name, version = _getBowser.version, mobile = _getBowser.mobile, android = _getBowser.android, ios = _getBowser.ios;
                Object(client.k)("unrecognized_browser_" + state, {
                    name: name,
                    version: version,
                    mobile: mobile,
                    android: android,
                    ios: ios
                });
                Object(client.h)();
            }
        }));
        function logWarn(err) {
            if (window.console) {
                if (window.console.warn) return window.console.warn(err);
                if (window.console.log) return window.console.log(err);
            }
        }
        function checkForCommonErrors() {
            if ("[]" !== JSON.stringify([])) {
                logWarn([].toJSON ? "Custom Array.prototype.toJSON is causing incorrect json serialization of arrays. This is likely to cause issues. Probable cause is Prototype.js" : "JSON.stringify is doing incorrect serialization of arrays. This is likely to cause issues.");
                Object(client.q)("json_stringify_array_broken");
            }
            if ("{}" !== JSON.stringify({})) {
                logWarn("JSON.stringify is doing incorrect serialization of objects. This is likely to cause issues.");
                Object(client.q)("json_stringify_object_broken");
            }
            Object(belter_src.k)() && Object(client.q)("ie_intranet_mode");
            Object(belter_src.i)() && !Object(belter_src.j)() && Object(client.q)("ie_meta_compatibility_header_missing", {
                message: 'Drop tag: <meta http-equiv="X-UA-Compatible" content="IE=edge">'
            });
            3 !== function(bar, baz, zomg) {}.bind({
                a: 1
            }).length && Object(client.q)("function_bind_arrity_overwritten");
            window.opener && window.parent !== window && Object(client.q)("window_has_opener_and_parent");
            window.name && 0 === window.name.indexOf("__prerender") && Object(client.q)("prerender_running_checkoutjs");
            var context = {};
            (function() {
                return this;
            }).bind(context)() !== context && Object(client.q)("function_bind_broken");
            window.Window && window.constructor && window.Window !== window.constructor && Object(client.q)("window_constructor_does_not_match_window");
            Object.assign && JSON.stringify({
                a: 1,
                b: 2,
                c: 3
            }) != JSON.stringify({
                a: 1,
                b: 2,
                c: 3
            }) && Object(client.q)("object_assign_broken");
        }
        var esm_extends = __webpack_require__(13);
        var headerBuilders = [];
        var corrids = [];
        Object(client.c)((function() {
            return {
                prev_corr_ids: corrids.join(",")
            };
        }));
        function request(_ref) {
            var url = _ref.url, _ref$method = _ref.method, method = void 0 === _ref$method ? "get" : _ref$method, _ref$headers = _ref.headers, headers = void 0 === _ref$headers ? {} : _ref$headers, json = _ref.json, data = _ref.data, body = _ref.body, _ref$win = _ref.win, win = void 0 === _ref$win ? window : _ref$win, _ref$timeout = _ref.timeout, timeout = void 0 === _ref$timeout ? 0 : _ref$timeout;
            return "/demo/checkout/api/braintree/client-token/" === url ? zalgo_promise_src.a.resolve("eyJ2ZXJzaW9uIjoyLCJhdXRob3JpemF0aW9uRmluZ2VycHJpbnQiOiJjMDFhZmRkM2Y1OTJmNWVhNTNlMzE5MWQwYmIyMWVjYjM5NzNlZGM1MzkwNDZiMjJmNTA2ODEyNzIzZmRlMTJifGNsaWVudF9pZD1jbGllbnRfaWQkc2FuZGJveCQ0ZHByYmZjNnBoNTk1Y2NqXHUwMDI2Y3JlYXRlZF9hdD0yMDE3LTA0LTI2VDIzOjI2OjU5Ljg3OTA3ODYwNiswMDAwXHUwMDI2bWVyY2hhbnRfaWQ9M3cydHR2d2QyNDY1NDhoZCIsImNvbmZpZ1VybCI6Imh0dHBzOi8vYXBpLnNhbmRib3guYnJhaW50cmVlZ2F0ZXdheS5jb206NDQzL21lcmNoYW50cy8zdzJ0dHZ3ZDI0NjU0OGhkL2NsaWVudF9hcGkvdjEvY29uZmlndXJhdGlvbiIsImNoYWxsZW5nZXMiOltdLCJlbnZpcm9ubWVudCI6InNhbmRib3giLCJjbGllbnRBcGlVcmwiOiJodHRwczovL2FwaS5zYW5kYm94LmJyYWludHJlZWdhdGV3YXkuY29tOjQ0My9tZXJjaGFudHMvM3cydHR2d2QyNDY1NDhoZC9jbGllbnRfYXBpIiwiYXNzZXRzVXJsIjoiaHR0cHM6Ly9hc3NldHMuYnJhaW50cmVlZ2F0ZXdheS5jb20iLCJhdXRoVXJsIjoiaHR0cHM6Ly9hdXRoLnZlbm1vLnNhbmRib3guYnJhaW50cmVlZ2F0ZXdheS5jb20iLCJhbmFseXRpY3MiOnsidXJsIjoiaHR0cHM6Ly9jbGllbnQtYW5hbHl0aWNzLnNhbmRib3guYnJhaW50cmVlZ2F0ZXdheS5jb20vM3cydHR2d2QyNDY1NDhoZCJ9LCJ0aHJlZURTZWN1cmVFbmFibGVkIjpmYWxzZSwicGF5cGFsRW5hYmxlZCI6dHJ1ZSwicGF5cGFsIjp7ImRpc3BsYXlOYW1lIjoiYmFyY28uMDMtZmFjaWxpdGF0b3JAZ21haWwuY29tIiwiY2xpZW50SWQiOiJBV3VZdnFnMGtaN2Y5S0V4TVpqZU53T3RjQV8yZVhnOWpMZy1QSnBGX0pnYk44M0YyVml5aEdnV2JCNDg4RGU3MFpucGRBZEI2TUNqekNqSyIsInByaXZhY3lVcmwiOiJodHRwczovL2V4YW1wbGUuY29tIiwidXNlckFncmVlbWVudFVybCI6Imh0dHBzOi8vZXhhbXBsZS5jb20iLCJiYXNlVXJsIjoiaHR0cHM6Ly9hc3NldHMuYnJhaW50cmVlZ2F0ZXdheS5jb20iLCJhc3NldHNVcmwiOiJodHRwczovL2NoZWNrb3V0LnBheXBhbC5jb20iLCJkaXJlY3RCYXNlVXJsIjpudWxsLCJhbGxvd0h0dHAiOnRydWUsImVudmlyb25tZW50Tm9OZXR3b3JrIjpmYWxzZSwiZW52aXJvbm1lbnQiOiJvZmZsaW5lIiwidW52ZXR0ZWRNZXJjaGFudCI6ZmFsc2UsImJyYWludHJlZUNsaWVudElkIjoibWFzdGVyY2xpZW50MyIsImJpbGxpbmdBZ3JlZW1lbnRzRW5hYmxlZCI6dHJ1ZSwibWVyY2hhbnRBY2NvdW50SWQiOiJVU0QiLCJjdXJyZW5jeUlzb0NvZGUiOiJVU0QifSwiY29pbmJhc2VFbmFibGVkIjpmYWxzZSwibWVyY2hhbnRJZCI6IjN3MnR0dndkMjQ2NTQ4aGQiLCJ2ZW5tbyI6Im9mZiJ9") : new zalgo_promise_src.a((function(resolve, reject) {
                if (json && data || json && body || data && json) throw new Error("Only options.json or options.data or options.body should be passed");
                var normalizedHeaders = {};
                for (var _i4 = 0, _Object$keys2 = Object.keys(headers); _i4 < _Object$keys2.length; _i4++) {
                    var _key2 = _Object$keys2[_i4];
                    normalizedHeaders[_key2.toLowerCase()] = headers[_key2];
                }
                json ? normalizedHeaders["content-type"] = normalizedHeaders["content-type"] || "application/json" : (data || body) && (normalizedHeaders["content-type"] = normalizedHeaders["content-type"] || "application/x-www-form-urlencoded; charset=utf-8");
                normalizedHeaders.accept = normalizedHeaders.accept || "application/json";
                for (var _i6 = 0; _i6 < headerBuilders.length; _i6++) {
                    var builtHeaders = (0, headerBuilders[_i6])();
                    for (var _i8 = 0, _Object$keys4 = Object.keys(builtHeaders); _i8 < _Object$keys4.length; _i8++) {
                        var _key3 = _Object$keys4[_i8];
                        normalizedHeaders[_key3.toLowerCase()] = builtHeaders[_key3];
                    }
                }
                var xhr = new win.XMLHttpRequest;
                xhr.addEventListener("load", (function() {
                    var responseHeaders = function(rawHeaders) {
                        void 0 === rawHeaders && (rawHeaders = "");
                        var result = {};
                        for (var _i2 = 0, _rawHeaders$trim$spli2 = rawHeaders.trim().split("\n"); _i2 < _rawHeaders$trim$spli2.length; _i2++) {
                            var _line$split = _rawHeaders$trim$spli2[_i2].split(":"), _key = _line$split[0], values = _line$split.slice(1);
                            result[_key.toLowerCase()] = values.join(":").trim();
                        }
                        return result;
                    }(this.getAllResponseHeaders());
                    var corrID = responseHeaders["paypal-debug-id"] || "unknown";
                    responseHeaders["paypal-debug-id"] && corrids.push(responseHeaders["paypal-debug-id"]);
                    if (!this.status) return reject(new Error("Request to " + method.toLowerCase() + " " + url + " failed: no response status code. Correlation id: " + corrID));
                    var contentType = responseHeaders["content-type"];
                    var isJSON = contentType && (0 === contentType.indexOf("application/json") || 0 === contentType.indexOf("text/json"));
                    var res = this.responseText;
                    try {
                        res = JSON.parse(this.responseText);
                    } catch (err) {
                        if (isJSON) return reject(new Error("Invalid json: " + this.responseText + ". Correlation id: " + corrID));
                    }
                    if (this.status >= 400) {
                        var message = "Request to " + method.toLowerCase() + " " + url + " failed with " + this.status + " error. Correlation id: " + corrID;
                        if (res) {
                            "object" == typeof res && null !== res && (res = JSON.stringify(res, null, 4));
                            message = message + "\n\n" + res + "\n";
                        }
                        return reject(new Error(message));
                    }
                    return resolve(res);
                }), !1);
                xhr.addEventListener("error", (function(evt) {
                    var corrID = this.getResponseHeader("paypal-debug-id");
                    reject(new Error("Request to " + method.toLowerCase() + " " + url + " failed: " + evt.toString() + ". Correlation id: " + corrID));
                }), !1);
                xhr.open(method, url, !0);
                for (var _key4 in normalizedHeaders) normalizedHeaders.hasOwnProperty(_key4) && xhr.setRequestHeader(_key4, normalizedHeaders[_key4]);
                json ? body = JSON.stringify(json) : data && (body = Object.keys(data).map((function(key) {
                    return encodeURIComponent(key) + "=" + (data ? encodeURIComponent(data[key]) : "");
                })).join("&"));
                xhr.timeout = timeout;
                xhr.ontimeout = function() {
                    reject(new Error("Request to " + method.toLowerCase() + " " + url + " has timed out"));
                };
                xhr.send(body);
            }));
        }
        request.get = function(url, options) {
            void 0 === options && (options = {});
            return request(Object(esm_extends.a)({
                method: "get",
                url: url
            }, options));
        };
        request.post = function(url, data, options) {
            void 0 === options && (options = {});
            return request(Object(esm_extends.a)({
                method: "post",
                url: url,
                data: data
            }, options));
        };
        request.addHeaderBuilder = function(method) {
            headerBuilders.push(method);
        };
        function getThrottle(name, sample, sticky) {
            void 0 === sticky && (sticky = !0);
            var uid = getStorageID();
            var percentile = sticky ? function(name) {
                return getStorageState((function(storage) {
                    storage.throttlePercentiles = storage.throttlePercentiles || {};
                    storage.throttlePercentiles[name] = storage.throttlePercentiles[name] || Math.floor(100 * Math.random());
                    return storage.throttlePercentiles[name];
                }));
            }(name) : Math.floor(100 * Math.random());
            var group;
            var treatment = name + "_" + (group = percentile < sample ? "test" : sample >= 50 || sample <= percentile && percentile < 2 * sample ? "control" : "throttle");
            var started = !1;
            var forced = !1;
            try {
                window.localStorage && window.localStorage.getItem(name) && (forced = !0);
            } catch (err) {}
            return {
                isEnabled: function() {
                    return "test" === group || forced;
                },
                isDisabled: function() {
                    return "test" !== group && !forced;
                },
                getTreatment: function() {
                    return treatment;
                },
                log: function(checkpointName, payload) {
                    var _extends2;
                    void 0 === payload && (payload = {});
                    if (!started) return this;
                    var checkpoint = name + "_" + treatment + "_" + checkpointName;
                    Object(client.k)(checkpoint, Object(esm_extends.a)({}, payload, {
                        expuid: uid
                    }));
                    Object(client.p)(Object(esm_extends.a)(((_extends2 = {})[constants.u.KEY.EXPERIMENT_NAME] = name, 
                    _extends2[constants.u.KEY.TREATMENT_NAME] = treatment, _extends2), payload));
                    Object(client.h)();
                    return this;
                },
                logStart: function(payload) {
                    void 0 === payload && (payload = {});
                    started = !0;
                    return this.log("start", payload);
                },
                logComplete: function(payload) {
                    void 0 === payload && (payload = {});
                    return started ? this.log("complete", payload) : this;
                }
            };
        }
        function getReturnToken() {
            var token = Object(util.g)(window.location.href, /token=((EC-)?[A-Z0-9]+)/);
            var payer = Object(util.g)(window.location.href, /PayerID=([A-Z0-9]+)/);
            if (token && payer) return token;
        }
        var openMetaFrame = Object(util.i)((function(env) {
            void 0 === env && (env = config.a.env);
            return zalgo_promise_src.a.try((function() {
                if (Object(belter_src.k)()) return {
                    iframeEligible: !1,
                    iframeEligibleReason: "ie_intranet",
                    rememberedFunding: []
                };
                var metaFrameUrl = config.a.metaFrameUrls[env];
                var metaFrameDomain = config.a.paypalDomains[env];
                return zalgo_promise_src.a.try((function() {
                    if (!post_robot_src.bridge) throw new Error("Opening meta window without bridge support is not currently supported");
                    var metaListener = Object(post_robot_src.once)("meta", {
                        domain: metaFrameDomain
                    });
                    return post_robot_src.bridge.openBridge(extendUrl(metaFrameUrl, {
                        version: "4.0.331"
                    }), metaFrameDomain).then((function() {
                        return metaListener;
                    })).then((function(_ref) {
                        return _ref.data;
                    }));
                }));
            }));
        }));
        var button_props = __webpack_require__(26);
        function getRememberedFunding(handler) {
            void 0 === handler && (handler = util.e);
            return getStorageState((function(storage) {
                storage.rememberedFunding = storage.rememberedFunding || [];
                return handler(storage.rememberedFunding);
            }));
        }
        function hasRememberedFunding(source) {
            return !!getRememberedFunding((function(rememberedFunding) {
                return -1 !== rememberedFunding.indexOf(source);
            })) || !!getSessionState((function(session) {
                return session.recentlyCheckedRemembered;
            }));
        }
        function getRememberedFundingPromises() {
            return function(handler) {
                window.__paypal_global__ = window.__paypal_global__ || {};
                return function(global) {
                    global.rememberFundingPromises = global.rememberFundingPromises || {};
                    return global.rememberFundingPromises;
                }(window.__paypal_global__);
            }();
        }
        function getRememberedFundingPromise(source) {
            var promises = getRememberedFundingPromises();
            var promise = promises[source] = promises[source] || new zalgo_promise_src.a;
            hasRememberedFunding(source) && promise.resolve(function(source) {
                if (getRememberedFunding((function(rememberedFunding) {
                    return -1 !== rememberedFunding.indexOf(source);
                }))) return !0;
                if (getSessionState((function(session) {
                    return session.recentlyCheckedRemembered;
                }))) return !1;
                throw new Error("Can not find remembered funding result");
            }(source));
            return promise;
        }
        function rememberFunding(sources) {
            getRememberedFunding((function(rememberedFunding) {
                for (var _i4 = 0; _i4 < sources.length; _i4++) {
                    var source = sources[_i4];
                    source !== constants.v.VENMO && -1 === rememberedFunding.indexOf(source) && rememberedFunding.push(source);
                }
                !function() {
                    var promises = getRememberedFundingPromises();
                    var rememberedFunding = getRememberedFunding((function(sources) {
                        return sources;
                    }));
                    for (var _i2 = 0, _Object$keys2 = Object.keys(promises); _i2 < _Object$keys2.length; _i2++) {
                        var source = _Object$keys2[_i2];
                        promises[source].resolve(-1 !== rememberedFunding.indexOf(source));
                    }
                }();
            }));
            getSessionState((function(session) {
                session.recentlyCheckedRemembered = !0;
            }));
        }
        function loadMeta() {
            return openMetaFrame().then((function(_ref) {
                rememberFunding(_ref.rememberedFunding || []);
            }));
        }
        function isFundingRemembered(source) {
            void 0 === source && (source = constants.v.PAYPAL);
            return hasRememberedFunding(source) ? getRememberedFundingPromise(source) : loadMeta().then((function() {
                return getRememberedFundingPromise(source);
            }));
        }
        function precacheRememberedFunding() {
            return getSessionState((function(session) {
                return session.recentlyCheckedRemembered;
            })) ? zalgo_promise_src.a.resolve() : loadMeta();
        }
        function getRenderedButtons(props) {
            return Object(button_props.a)(props).sources.toString();
        }
        __webpack_require__(1);
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "i", (function() {
            return getTransport;
        }));
        __webpack_require__.d(__webpack_exports__, "o", (function() {
            return setTransport;
        }));
        __webpack_require__.d(__webpack_exports__, "j", (function() {
            return immediateFlush;
        }));
        __webpack_require__.d(__webpack_exports__, "h", (function() {
            return _flush;
        }));
        __webpack_require__.d(__webpack_exports__, "n", (function() {
            return prefix;
        }));
        __webpack_require__.d(__webpack_exports__, "f", (function() {
            return debug;
        }));
        __webpack_require__.d(__webpack_exports__, "k", (function() {
            return info;
        }));
        __webpack_require__.d(__webpack_exports__, "q", (function() {
            return warn;
        }));
        __webpack_require__.d(__webpack_exports__, "g", (function() {
            return error;
        }));
        __webpack_require__.d(__webpack_exports__, "p", (function() {
            return _track;
        }));
        __webpack_require__.d(__webpack_exports__, "l", (function() {
            return init;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return addPayloadBuilder;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return addMetaBuilder;
        }));
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return addTrackingBuilder;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return addHeaderBuilder;
        }));
        __webpack_require__.d(__webpack_exports__, "e", (function() {
            return config;
        }));
        __webpack_require__.d(__webpack_exports__, "m", (function() {
            return logLevels;
        }));
        var interface_namespaceObject = {};
        __webpack_require__.r(interface_namespaceObject);
        __webpack_require__.d(interface_namespaceObject, "buffer", (function() {
            return buffer;
        }));
        __webpack_require__.d(interface_namespaceObject, "tracking", (function() {
            return tracking;
        }));
        __webpack_require__.d(interface_namespaceObject, "getTransport", (function() {
            return getTransport;
        }));
        __webpack_require__.d(interface_namespaceObject, "setTransport", (function() {
            return setTransport;
        }));
        __webpack_require__.d(interface_namespaceObject, "print", (function() {
            return print;
        }));
        __webpack_require__.d(interface_namespaceObject, "immediateFlush", (function() {
            return immediateFlush;
        }));
        __webpack_require__.d(interface_namespaceObject, "flush", (function() {
            return _flush;
        }));
        __webpack_require__.d(interface_namespaceObject, "log", (function() {
            return log;
        }));
        __webpack_require__.d(interface_namespaceObject, "prefix", (function() {
            return prefix;
        }));
        __webpack_require__.d(interface_namespaceObject, "debug", (function() {
            return debug;
        }));
        __webpack_require__.d(interface_namespaceObject, "info", (function() {
            return info;
        }));
        __webpack_require__.d(interface_namespaceObject, "warn", (function() {
            return warn;
        }));
        __webpack_require__.d(interface_namespaceObject, "error", (function() {
            return error;
        }));
        __webpack_require__.d(interface_namespaceObject, "track", (function() {
            return _track;
        }));
        __webpack_require__.d(interface_namespaceObject, "init", (function() {
            return init;
        }));
        __webpack_require__.d(interface_namespaceObject, "startTransition", (function() {
            return startTransition;
        }));
        __webpack_require__.d(interface_namespaceObject, "endTransition", (function() {
            return endTransition;
        }));
        __webpack_require__.d(interface_namespaceObject, "transition", (function() {
            return transition;
        }));
        __webpack_require__.d(interface_namespaceObject, "payloadBuilders", (function() {
            return payloadBuilders;
        }));
        __webpack_require__.d(interface_namespaceObject, "metaBuilders", (function() {
            return metaBuilders;
        }));
        __webpack_require__.d(interface_namespaceObject, "trackingBuilders", (function() {
            return trackingBuilders;
        }));
        __webpack_require__.d(interface_namespaceObject, "headerBuilders", (function() {
            return headerBuilders;
        }));
        __webpack_require__.d(interface_namespaceObject, "addPayloadBuilder", (function() {
            return addPayloadBuilder;
        }));
        __webpack_require__.d(interface_namespaceObject, "addMetaBuilder", (function() {
            return addMetaBuilder;
        }));
        __webpack_require__.d(interface_namespaceObject, "addTrackingBuilder", (function() {
            return addTrackingBuilder;
        }));
        __webpack_require__.d(interface_namespaceObject, "addHeaderBuilder", (function() {
            return addHeaderBuilder;
        }));
        __webpack_require__.d(interface_namespaceObject, "config", (function() {
            return config;
        }));
        __webpack_require__.d(interface_namespaceObject, "logLevels", (function() {
            return logLevels;
        }));
        var src = __webpack_require__(2);
        function extend(dest, src, over) {
            void 0 === over && (over = !0);
            dest = dest || {};
            src = src || {};
            for (var i in src) src.hasOwnProperty(i) && (!over && dest.hasOwnProperty(i) || (dest[i] = src[i]));
            return dest;
        }
        function uniqueID() {
            var chars = "0123456789abcdef";
            return "xxxxxxxxxx".replace(/./g, (function() {
                return chars.charAt(Math.floor(Math.random() * chars.length));
            }));
        }
        var payloadBuilders = [];
        var metaBuilders = [];
        var trackingBuilders = [];
        var headerBuilders = [];
        function addPayloadBuilder(builder) {
            payloadBuilders.push(builder);
        }
        function addMetaBuilder(builder) {
            metaBuilders.push(builder);
        }
        function addTrackingBuilder(builder) {
            trackingBuilders.push(builder);
        }
        function addHeaderBuilder(builder) {
            headerBuilders.push(builder);
        }
        var config = {
            uri: "",
            prefix: "",
            initial_state_name: "init",
            flushInterval: 6e5,
            debounceInterval: 10,
            sizeLimit: 300,
            silent: !1,
            heartbeat: !0,
            heartbeatConsoleLog: !0,
            heartbeatInterval: 5e3,
            heartbeatTooBusy: !1,
            heartbeatTooBusyThreshold: 1e4,
            logLevel: "warn",
            autoLog: [ "warn", "error" ],
            logUnload: !0,
            logPerformance: !0
        };
        var logLevels = [ "error", "warn", "info", "debug" ];
        var buffer = [];
        var tracking = [];
        var logger_transport = function(headers, data, options) {
            return function(method, url, headers, data, _temp) {
                void 0 === headers && (headers = {});
                void 0 === data && (data = {});
                var _ref$fireAndForget = (void 0 === _temp ? {} : _temp).fireAndForget, fireAndForget = void 0 !== _ref$fireAndForget && _ref$fireAndForget;
                return new src.a((function(resolve) {
                    var XRequest = window.XMLHttpRequest || window.ActiveXObject;
                    if (window.XDomainRequest && !function(url) {
                        var match = url.match(/https?:\/\/[^/]+/);
                        return !match || match[0] === window.location.protocol + "//" + window.location.host;
                    }(url)) {
                        if (!function(url) {
                            return window.location.protocol === url.split("/")[0];
                        }(url)) return resolve();
                        XRequest = window.XDomainRequest;
                    }
                    var req = new XRequest("MSXML2.XMLHTTP.3.0");
                    req.open("post".toUpperCase(), url, !0);
                    if ("function" == typeof req.setRequestHeader) {
                        req.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                        req.setRequestHeader("Content-type", "application/json");
                        for (var headerName in headers) headers.hasOwnProperty(headerName) && req.setRequestHeader(headerName, headers[headerName]);
                    }
                    fireAndForget ? resolve() : req.onreadystatechange = function() {
                        req.readyState > 3 && resolve();
                    };
                    req.send(JSON.stringify(data).replace(/&/g, "%26"));
                }));
            }(0, config.uri, headers, data, options);
        };
        function getTransport() {
            return logger_transport;
        }
        function setTransport(newTransport) {
            logger_transport = newTransport;
        }
        var loaded = !1;
        setTimeout((function() {
            loaded = !0;
        }), 1);
        function print(level, event, payload) {
            if ("undefined" != typeof window && window.console && window.console.log) {
                if (!loaded) return setTimeout((function() {
                    return print(level, event, payload);
                }), 1);
                var logLevel = config.logLevel;
                window.LOG_LEVEL && (logLevel = window.LOG_LEVEL);
                if (!(logLevels.indexOf(level) > logLevels.indexOf(logLevel))) {
                    payload = payload || {};
                    var args = [ event ];
                    Boolean(window.document.documentMode) && (payload = JSON.stringify(payload));
                    args.push(payload);
                    (payload.error || payload.warning) && args.push("\n\n", payload.error || payload.warning);
                    try {
                        window.console[level] && window.console[level].apply ? window.console[level].apply(window.console, args) : window.console.log && window.console.log.apply && window.console.log.apply(window.console, args);
                    } catch (err) {}
                }
            }
        }
        function immediateFlush(_temp) {
            var _ref$fireAndForget = (void 0 === _temp ? {} : _temp).fireAndForget, fireAndForget = void 0 !== _ref$fireAndForget && _ref$fireAndForget;
            if ("undefined" != typeof window && config.uri && (buffer.length || tracking.length)) {
                var meta = {};
                for (var _i2 = 0; _i2 < metaBuilders.length; _i2++) {
                    var builder = metaBuilders[_i2];
                    try {
                        extend(meta, builder(meta), !1);
                    } catch (err) {
                        console.error("Error in custom meta builder:", err.stack || err.toString());
                    }
                }
                var headers = {};
                for (var _i4 = 0; _i4 < headerBuilders.length; _i4++) {
                    var _builder = headerBuilders[_i4];
                    try {
                        extend(headers, _builder(headers), !1);
                    } catch (err) {
                        console.error("Error in custom header builder:", err.stack || err.toString());
                    }
                }
                var req = logger_transport(headers, {
                    events: buffer,
                    meta: meta,
                    tracking: tracking
                }, {
                    fireAndForget: fireAndForget
                });
                buffer = [];
                tracking = [];
                return req;
            }
        }
        var _flush = (method = immediateFlush, interval = config.debounceInterval, debounce = {}, 
        function() {
            var args = arguments;
            if (debounce.timeout) {
                clearTimeout(debounce.timeout);
                delete debounce.timeout;
            }
            debounce.timeout = setTimeout((function() {
                var resolver = debounce.resolver;
                var rejector = debounce.rejector;
                delete debounce.promise;
                delete debounce.resolver;
                delete debounce.rejector;
                delete debounce.timeout;
                return src.a.resolve().then((function() {
                    return method.apply(null, args);
                })).then(resolver, rejector);
            }), interval);
            debounce.promise = debounce.promise || new src.a((function(resolver, rejector) {
                debounce.resolver = resolver;
                debounce.rejector = rejector;
            }));
            return debounce.promise;
        });
        var method, interval, debounce;
        function enqueue(level, event, payload) {
            buffer.push({
                level: level,
                event: event,
                payload: payload
            });
            config.autoLog.indexOf(level) > -1 && _flush();
        }
        function log(level, event, payload) {
            if ("undefined" != typeof window) {
                config.prefix && (event = config.prefix + "_" + event);
                "string" == typeof (payload = payload || {}) ? payload = {
                    message: payload
                } : payload instanceof Error && (payload = {
                    error: payload.stack || payload.toString()
                });
                try {
                    JSON.stringify(payload);
                } catch (err) {
                    return;
                }
                payload.timestamp = Date.now();
                for (var _i6 = 0; _i6 < payloadBuilders.length; _i6++) {
                    var builder = payloadBuilders[_i6];
                    try {
                        extend(payload, builder(payload), !1);
                    } catch (err) {
                        console.error("Error in custom payload builder:", err.stack || err.toString());
                    }
                }
                config.silent || print(level, event, payload);
                buffer.length === config.sizeLimit ? enqueue("info", "logger_max_buffer_length") : buffer.length < config.sizeLimit && enqueue(level, event, payload);
            }
        }
        function prefix(name) {
            return {
                debug: function(event, payload) {
                    return log("debug", name + "_" + event, payload);
                },
                info: function(event, payload) {
                    return log("info", name + "_" + event, payload);
                },
                warn: function(event, payload) {
                    return log("warn", name + "_" + event, payload);
                },
                error: function(event, payload) {
                    return log("error", name + "_" + event, payload);
                },
                track: function(payload) {
                    return _track(payload);
                },
                flush: function() {
                    return _flush();
                }
            };
        }
        function debug(event, payload) {
            return log("debug", event, payload);
        }
        function info(event, payload) {
            return log("info", event, payload);
        }
        function warn(event, payload) {
            return log("warn", event, payload);
        }
        function error(event, payload) {
            return log("error", event, payload);
        }
        function _track(payload) {
            if ("undefined" != typeof window && payload) {
                try {
                    JSON.stringify(payload);
                } catch (err) {
                    return;
                }
                for (var _i8 = 0; _i8 < trackingBuilders.length; _i8++) {
                    var builder = trackingBuilders[_i8];
                    try {
                        extend(payload, builder(payload), !1);
                    } catch (err) {
                        console.error("Error in custom tracking builder:", err.stack || err.toString());
                    }
                }
                print("debug", "tracking", payload);
                tracking.push(payload);
            }
        }
        var enablePerformance = window && window.performance && performance.now && performance.timing && performance.timing.connectEnd && performance.timing.navigationStart && Math.abs(performance.now() - Date.now()) > 1e3 && performance.now() - (performance.timing.connectEnd - performance.timing.navigationStart) > 0;
        function now() {
            return enablePerformance ? performance.now() : Date.now();
        }
        function timer(startTime) {
            return {
                startTime: startTime = void 0 !== startTime ? startTime : now(),
                elapsed: function() {
                    return parseInt(now() - startTime, 10);
                },
                reset: function() {
                    startTime = now();
                }
            };
        }
        function reqStartElapsed() {
            if (enablePerformance) {
                var timing = window.performance.timing;
                return parseInt(timing.connectEnd - timing.navigationStart, 10);
            }
        }
        var clientTimer = timer();
        var reqTimer = timer(reqStartElapsed());
        var initiated = !1;
        function init(conf) {
            extend(config, conf || {});
            if (!initiated) {
                initiated = !0;
                config.logPerformance && function() {
                    if (!enablePerformance) return info("no_performance_data");
                    addPayloadBuilder((function() {
                        var payload = {};
                        payload.client_elapsed = clientTimer.elapsed();
                        enablePerformance && (payload.req_elapsed = reqTimer.elapsed());
                        return payload;
                    }));
                    new src.a((function(resolve) {
                        "undefined" != typeof document && "complete" === document.readyState && resolve();
                        window.addEventListener("load", resolve);
                    })).then((function() {
                        var timing = {};
                        [ "connectEnd", "connectStart", "domComplete", "domContentLoadedEventEnd", "domContentLoadedEventStart", "domInteractive", "domLoading", "domainLookupEnd", "domainLookupStart", "fetchStart", "loadEventEnd", "loadEventStart", "navigationStart", "redirectEnd", "redirectStart", "requestStart", "responseEnd", "responseStart", "secureConnectionStart", "unloadEventEnd", "unloadEventStart" ].forEach((function(key) {
                            timing[key] = parseInt(window.performance.timing[key], 10) || 0;
                        }));
                        var offset = timing.connectEnd - timing.navigationStart;
                        timing.connectEnd && Object.keys(timing).forEach((function(name) {
                            var time = timing[name];
                            time && info("timing_" + name, {
                                client_elapsed: parseInt(time - timing.connectEnd - (clientTimer.startTime - offset), 10),
                                req_elapsed: parseInt(time - timing.connectEnd, 10)
                            });
                        }));
                        info("timing", timing);
                        info("memory", window.performance.memory);
                        info("navigation", window.performance.navigation);
                        window.performance.getEntries && window.performance.getEntries().forEach((function(resource) {
                            [ "link", "script", "img", "css" ].indexOf(resource.initiatorType) > -1 && info(resource.initiatorType, resource);
                        }));
                    }));
                }();
                config.heartbeat && (heartBeatTimer = timer(), heartbeatCount = 0, time = config.heartbeatInterval, 
                function loop() {
                    setTimeout((function() {
                        !function() {
                            if (!(config.heartbeatMaxThreshold && heartbeatCount > config.heartbeatMaxThreshold)) {
                                heartbeatCount += 1;
                                var elapsed = heartBeatTimer.elapsed();
                                var lag = elapsed - config.heartbeatInterval;
                                var heartbeatPayload = {
                                    count: heartbeatCount,
                                    elapsed: elapsed
                                };
                                if (config.heartbeatTooBusy) {
                                    heartbeatPayload.lag = lag;
                                    lag >= config.heartbeatTooBusyThreshold && info("toobusy", heartbeatPayload);
                                }
                                info("heartbeat", heartbeatPayload);
                            }
                        }();
                        loop();
                    }), time);
                }());
                if (config.logUnload) {
                    window.addEventListener("beforeunload", (function() {
                        info("window_beforeunload");
                        immediateFlush({
                            fireAndForget: !0
                        });
                    }));
                    window.addEventListener("unload", (function() {
                        info("window_unload");
                        immediateFlush({
                            fireAndForget: !0
                        });
                    }));
                }
                config.flushInterval && setInterval(_flush, config.flushInterval);
                if (window.beaverLogQueue) {
                    window.beaverLogQueue.forEach((function(payload) {
                        log(payload.level, payload.event, payload);
                    }));
                    delete window.beaverLogQueue;
                }
            }
            var heartBeatTimer, heartbeatCount, time;
        }
        var windowID = uniqueID();
        var pageID = uniqueID();
        var currentState = config.initial_state_name;
        var startTime;
        function startTransition() {
            startTime = now();
        }
        function endTransition(toState) {
            startTime = startTime || reqStartElapsed();
            var currentTime = now();
            var elapsedTime;
            void 0 !== startTime && (elapsedTime = parseInt(currentTime - startTime, 0));
            var transitionName = "transition_" + currentState + "_to_" + toState;
            info(transitionName, {
                duration: elapsedTime
            });
            _track({
                transition: transitionName,
                transition_time: elapsedTime
            });
            immediateFlush();
            startTime = currentTime;
            currentState = toState;
            pageID = uniqueID();
        }
        function transition(toState) {
            startTransition();
            endTransition(toState);
        }
        addPayloadBuilder((function() {
            return {
                windowID: windowID,
                pageID: pageID
            };
        }));
        addMetaBuilder((function() {
            return {
                state: "ui_" + currentState
            };
        }));
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return appendChild;
        }));
        __webpack_require__.d(__webpack_exports__, "u", (function() {
            return getElement;
        }));
        __webpack_require__.d(__webpack_exports__, "n", (function() {
            return elementReady;
        }));
        __webpack_require__.d(__webpack_exports__, "I", (function() {
            return popup;
        }));
        __webpack_require__.d(__webpack_exports__, "Y", (function() {
            return writeToWindow;
        }));
        __webpack_require__.d(__webpack_exports__, "X", (function() {
            return writeElementToWindow;
        }));
        __webpack_require__.d(__webpack_exports__, "e", (function() {
            return awaitFrameLoad;
        }));
        __webpack_require__.d(__webpack_exports__, "f", (function() {
            return awaitFrameWindow;
        }));
        __webpack_require__.d(__webpack_exports__, "y", (function() {
            return iframe;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return addEventListener;
        }));
        __webpack_require__.d(__webpack_exports__, "r", (function() {
            return extendUrl;
        }));
        __webpack_require__.d(__webpack_exports__, "Q", (function() {
            return showElement;
        }));
        __webpack_require__.d(__webpack_exports__, "x", (function() {
            return hideElement;
        }));
        __webpack_require__.d(__webpack_exports__, "l", (function() {
            return destroyElement;
        }));
        __webpack_require__.d(__webpack_exports__, "P", (function() {
            return showAndAnimate;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return animateAndHide;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return addClass;
        }));
        __webpack_require__.d(__webpack_exports__, "L", (function() {
            return removeClass;
        }));
        __webpack_require__.d(__webpack_exports__, "t", (function() {
            return getCurrentScriptDir;
        }));
        __webpack_require__.d(__webpack_exports__, "W", (function() {
            return watchElementForClose;
        }));
        __webpack_require__.d(__webpack_exports__, "J", (function() {
            return prefetchPage;
        }));
        __webpack_require__.d(__webpack_exports__, "C", (function() {
            return jsxDom;
        }));
        __webpack_require__.d(__webpack_exports__, "F", (function() {
            return noop;
        }));
        __webpack_require__.d(__webpack_exports__, "H", (function() {
            return once;
        }));
        __webpack_require__.d(__webpack_exports__, "D", (function() {
            return memoize;
        }));
        __webpack_require__.d(__webpack_exports__, "i", (function() {
            return debounce;
        }));
        __webpack_require__.d(__webpack_exports__, "N", (function() {
            return serializeFunctions;
        }));
        __webpack_require__.d(__webpack_exports__, "k", (function() {
            return deserializeFunctions;
        }));
        __webpack_require__.d(__webpack_exports__, "j", (function() {
            return denodeify;
        }));
        __webpack_require__.d(__webpack_exports__, "K", (function() {
            return promisify;
        }));
        __webpack_require__.d(__webpack_exports__, "h", (function() {
            return dasherizeToCamel;
        }));
        __webpack_require__.d(__webpack_exports__, "q", (function() {
            return extend;
        }));
        __webpack_require__.d(__webpack_exports__, "U", (function() {
            return uniqueID;
        }));
        __webpack_require__.d(__webpack_exports__, "s", (function() {
            return get;
        }));
        __webpack_require__.d(__webpack_exports__, "M", (function() {
            return replaceObject;
        }));
        __webpack_require__.d(__webpack_exports__, "g", (function() {
            return copyProp;
        }));
        __webpack_require__.d(__webpack_exports__, "m", (function() {
            return dotify;
        }));
        __webpack_require__.d(__webpack_exports__, "R", (function() {
            return stringify;
        }));
        __webpack_require__.d(__webpack_exports__, "S", (function() {
            return stringifyError;
        }));
        __webpack_require__.d(__webpack_exports__, "p", (function() {
            return eventEmitter;
        }));
        __webpack_require__.d(__webpack_exports__, "A", (function() {
            return isPerc;
        }));
        __webpack_require__.d(__webpack_exports__, "B", (function() {
            return isPx;
        }));
        __webpack_require__.d(__webpack_exports__, "T", (function() {
            return toCSS;
        }));
        __webpack_require__.d(__webpack_exports__, "G", (function() {
            return normalizeDimension;
        }));
        __webpack_require__.d(__webpack_exports__, "E", (function() {
            return memoized;
        }));
        __webpack_require__.d(__webpack_exports__, "O", (function() {
            return setLogLevel;
        }));
        __webpack_require__.d(__webpack_exports__, "z", (function() {
            return info;
        }));
        __webpack_require__.d(__webpack_exports__, "V", (function() {
            return warn;
        }));
        __webpack_require__.d(__webpack_exports__, "o", (function() {
            return logger_error;
        }));
        __webpack_require__.d(__webpack_exports__, "w", (function() {
            return globalFor;
        }));
        __webpack_require__.d(__webpack_exports__, "v", (function() {
            return global;
        }));
        var esm_extends = __webpack_require__(13);
        var src = __webpack_require__(7);
        var zalgo_promise_src = __webpack_require__(2);
        var cross_domain_safe_weakmap_src = __webpack_require__(18);
        var error = __webpack_require__(25);
        function urlEncode(str) {
            return str.replace(/\?/g, "%3F").replace(/&/g, "%26").replace(/#/g, "%23").replace(/\+/g, "%2B");
        }
        function dasherizeToCamel(string) {
            return string.replace(/-([a-z])/g, (function(g) {
                return g[1].toUpperCase();
            }));
        }
        function extend(obj, source) {
            if (!source) return obj;
            for (var key in source) source.hasOwnProperty(key) && (obj[key] = source[key]);
            return obj;
        }
        function uniqueID() {
            var chars = "0123456789abcdef";
            return "xxxxxxxxxx".replace(/./g, (function() {
                return chars.charAt(Math.floor(Math.random() * chars.length));
            }));
        }
        function get(item, path, def) {
            if (!path) return def;
            var pathParts = path.split(".");
            for (var i = 0; i < pathParts.length; i++) {
                if ("object" != typeof item || null === item) return def;
                item = item[pathParts[i]];
            }
            return void 0 === item ? def : item;
        }
        function replaceObject(item, replacers, fullKey) {
            void 0 === fullKey && (fullKey = "");
            if (Array.isArray(item)) {
                var _ret = function() {
                    var length = item.length;
                    var result = [];
                    var _loop = function(i) {
                        Object.defineProperty(result, i, {
                            configurable: !0,
                            enumerable: !0,
                            get: function() {
                                var itemKey = fullKey ? fullKey + "." + i : "" + i;
                                var child = item[i];
                                var replacer = replacers[typeof child];
                                if (replacer) {
                                    var replaced = replacer(child, i, itemKey);
                                    if (void 0 !== replaced) {
                                        result[i] = replaced;
                                        return result[i];
                                    }
                                }
                                if ("object" == typeof child && null !== child) {
                                    result[i] = replaceObject(child, replacers, itemKey);
                                    return result[i];
                                }
                                result[i] = child;
                                return result[i];
                            },
                            set: function(value) {
                                delete result[i];
                                result[i] = value;
                            }
                        });
                    };
                    for (var i = 0; i < length; i++) _loop(i);
                    return {
                        v: result
                    };
                }();
                if ("object" == typeof _ret) return _ret.v;
            } else {
                if ("object" != typeof item || null === item) throw new Error("Pass an object or array");
                var _ret2 = function() {
                    var result = {};
                    var _loop2 = function(key) {
                        if (!item.hasOwnProperty(key)) return "continue";
                        Object.defineProperty(result, key, {
                            configurable: !0,
                            enumerable: !0,
                            get: function() {
                                var itemKey = fullKey ? fullKey + "." + key : "" + key;
                                var child = item[key];
                                var replacer = replacers[typeof child];
                                if (replacer) {
                                    var replaced = replacer(child, key, itemKey);
                                    if (void 0 !== replaced) {
                                        result[key] = replaced;
                                        return result[key];
                                    }
                                }
                                if ("object" == typeof child && null !== child) {
                                    result[key] = replaceObject(child, replacers, itemKey);
                                    return result[key];
                                }
                                result[key] = child;
                                return result[key];
                            },
                            set: function(value) {
                                delete result[key];
                                result[key] = value;
                            }
                        });
                    };
                    for (var key in item) _loop2(key);
                    return {
                        v: result
                    };
                }();
                if ("object" == typeof _ret2) return _ret2.v;
            }
        }
        function copyProp(source, target, name, def) {
            if (source.hasOwnProperty(name)) {
                var descriptor = Object.getOwnPropertyDescriptor(source, name);
                Object.defineProperty(target, name, descriptor);
            } else target[name] = def;
        }
        function dotify(obj, prefix, newobj) {
            void 0 === prefix && (prefix = "");
            void 0 === newobj && (newobj = {});
            prefix = prefix ? prefix + "." : prefix;
            for (var key in obj) null != obj[key] && "function" != typeof obj[key] && (obj[key] && Array.isArray(obj[key]) && obj[key].length && obj[key].every((function(val) {
                return "object" != typeof val;
            })) ? newobj["" + prefix + key] = obj[key].join(",") : obj[key] && "object" == typeof obj[key] ? newobj = dotify(obj[key], "" + prefix + key, newobj) : newobj["" + prefix + key] = obj[key].toString());
            return newobj;
        }
        var objectIDs = new cross_domain_safe_weakmap_src.a;
        function getObjectID(obj) {
            if (null == obj || "object" != typeof obj && "function" != typeof obj) throw new Error("Invalid object");
            var uid = objectIDs.get(obj);
            if (!uid) {
                uid = typeof obj + ":" + uniqueID();
                objectIDs.set(obj, uid);
            }
            return uid;
        }
        function stringify(item) {
            return "string" == typeof item ? item : item && "function" == typeof item.toString ? item.toString() : {}.toString.call(item);
        }
        function stringifyError(err) {
            if (err) {
                var stack = err.stack, message = err.message;
                if ("string" == typeof stack) return stack;
                if ("string" == typeof message) return message;
            }
            return stringify(err);
        }
        function eventEmitter() {
            var triggered = {};
            var handlers = {};
            return {
                on: function(eventName, handler) {
                    var handlerList = handlers[eventName] = handlers[eventName] || [];
                    handlerList.push(handler);
                    var cancelled = !1;
                    return {
                        cancel: function() {
                            if (!cancelled) {
                                cancelled = !0;
                                handlerList.splice(handlerList.indexOf(handler), 1);
                            }
                        }
                    };
                },
                once: function(eventName, handler) {
                    var listener = this.on(eventName, (function() {
                        listener.cancel();
                        handler();
                    }));
                    return listener;
                },
                trigger: function(eventName) {
                    var handlerList = handlers[eventName];
                    if (handlerList) for (var _i3 = 0; _i3 < handlerList.length; _i3++) (0, handlerList[_i3])();
                },
                triggerOnce: function(eventName) {
                    if (!triggered[eventName]) {
                        triggered[eventName] = !0;
                        this.trigger(eventName);
                    }
                }
            };
        }
        function noop() {}
        function once(method) {
            var called = !1;
            var result;
            return function() {
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
                if (called) return result;
                called = !0;
                return result = method.apply(this, arguments);
            };
        }
        function memoize(method) {
            var results = {};
            return function() {
                for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) args[_key2] = arguments[_key2];
                var cacheKey;
                try {
                    cacheKey = JSON.stringify([].slice.call(arguments), (function(key, val) {
                        return "function" == typeof val ? "zoid:memoize[" + getObjectID(val) + "]" : val;
                    }));
                } catch (err) {
                    throw new Error("Arguments not serializable -- can not be used to memoize");
                }
                results.hasOwnProperty(cacheKey) || (results[cacheKey] = method.apply(this, arguments));
                return results[cacheKey];
            };
        }
        function debounce(method, time) {
            void 0 === time && (time = 100);
            var timeout;
            return function() {
                var _arguments = arguments, _this = this;
                clearTimeout(timeout);
                timeout = setTimeout((function() {
                    return method.apply(_this, _arguments);
                }), time);
            };
        }
        function serializeFunctions(obj) {
            return replaceObject(obj, {
                function: function() {
                    return {
                        __type__: "__function__"
                    };
                }
            });
        }
        function deserializeFunctions(obj, handler) {
            return replaceObject(obj, {
                object: function(value, key, fullKey) {
                    if (value && "__function__" === value.__type__) return function() {
                        return handler({
                            key: key,
                            fullKey: fullKey,
                            self: this,
                            args: arguments
                        });
                    };
                }
            });
        }
        function appendChild(container, child) {
            container.appendChild(child);
        }
        function getElementSafe(id) {
            if (function(element) {
                return element instanceof window.Element || null !== element && "object" == typeof element && 1 === element.nodeType && "object" == typeof element.style && "object" == typeof element.ownerDocument;
            }(id)) return id;
            if ("string" == typeof id) {
                var element = document.getElementById(id);
                if (element) return element;
                document.querySelector && (element = document.querySelector(id));
                if (element) return element;
            }
        }
        function getElement(id) {
            var element = getElementSafe(id);
            if (element) return element;
            throw new Error("Can not find element: " + stringify(id));
        }
        new zalgo_promise_src.a((function(resolve) {
            if ("complete" === window.document.readyState) return resolve(window.document);
            var interval = setInterval((function() {
                if ("complete" === window.document.readyState) {
                    clearInterval(interval);
                    return resolve(window.document);
                }
            }), 10);
        }));
        function isDocumentReady() {
            return "complete" === window.document.readyState;
        }
        function elementReady(id) {
            return new zalgo_promise_src.a((function(resolve, reject) {
                var name = stringify(id);
                var el = getElementSafe(id);
                if (el) return resolve(el);
                if (isDocumentReady()) return reject(new Error("Document is ready and element " + name + " does not exist"));
                var interval = setInterval((function() {
                    if (el = getElementSafe(id)) {
                        clearInterval(interval);
                        return resolve(el);
                    }
                    if (isDocumentReady()) {
                        clearInterval(interval);
                        return reject(new Error("Document is ready and element " + name + " does not exist"));
                    }
                }), 10);
            }));
        }
        function popup(url, options) {
            var params = Object.keys(options).map((function(key) {
                if (options[key]) return key + "=" + stringify(options[key]);
            })).filter(Boolean).join(",");
            var win;
            try {
                win = window.open(url, options.name, params, !0);
            } catch (err) {
                throw new error.b("Can not open popup window - " + (err.stack || err.message));
            }
            if (Object(src.z)(win)) {
                var err;
                throw new error.b("Can not open popup window - blocked");
            }
            return win;
        }
        function writeToWindow(win, html) {
            try {
                win.document.open();
                win.document.write(html);
                win.document.close();
            } catch (err) {
                try {
                    win.location = "javascript: document.open(); document.write(" + JSON.stringify(html) + "); document.close();";
                } catch (err2) {}
            }
        }
        function writeElementToWindow(win, el) {
            var tag = el.tagName.toLowerCase();
            if ("html" !== tag) throw new Error("Expected element to be html, got " + tag);
            var documentElement = win.document.documentElement;
            for (;documentElement.children && documentElement.children.length; ) documentElement.removeChild(documentElement.children[0]);
            for (;el.children.length; ) documentElement.appendChild(el.children[0]);
        }
        function setStyle(el, styleText, doc) {
            void 0 === doc && (doc = window.document);
            el.styleSheet ? el.styleSheet.cssText = styleText : el.appendChild(doc.createTextNode(styleText));
        }
        var awaitFrameLoadPromises = new cross_domain_safe_weakmap_src.a;
        function awaitFrameLoad(frame) {
            if (awaitFrameLoadPromises.has(frame)) {
                var _promise = awaitFrameLoadPromises.get(frame);
                if (_promise) return _promise;
            }
            var promise = new zalgo_promise_src.a((function(resolve, reject) {
                frame.addEventListener("load", (function() {
                    Object(src.A)(frame);
                    resolve(frame);
                }));
                frame.addEventListener("error", (function(err) {
                    frame.contentWindow ? resolve(frame) : reject(err);
                }));
            }));
            awaitFrameLoadPromises.set(frame, promise);
            return promise;
        }
        function awaitFrameWindow(frame) {
            return frame.contentWindow ? zalgo_promise_src.a.resolve(frame.contentWindow) : awaitFrameLoad(frame).then((function(loadedFrame) {
                if (!loadedFrame.contentWindow) throw new Error("Could not find window in iframe");
                return loadedFrame.contentWindow;
            }));
        }
        function iframe(options, container) {
            void 0 === options && (options = {});
            var el = getElement(container);
            var attributes = options.attributes || {};
            var style = options.style || {};
            var frame = function(tag, options, container) {
                void 0 === tag && (tag = "div");
                void 0 === options && (options = {});
                tag = tag.toLowerCase();
                var element = document.createElement(tag);
                options.style && extend(element.style, options.style);
                options.class && (element.className = options.class.join(" "));
                if (options.attributes) for (var _i2 = 0, _Object$keys2 = Object.keys(options.attributes); _i2 < _Object$keys2.length; _i2++) {
                    var key = _Object$keys2[_i2];
                    element.setAttribute(key, options.attributes[key]);
                }
                options.styleSheet && setStyle(element, options.styleSheet);
                if (options.html) {
                    if ("iframe" === tag) throw new Error("Iframe html can not be written unless container provided and iframe in DOM");
                    element.innerHTML = options.html;
                }
                return element;
            }("iframe", {
                attributes: Object(esm_extends.a)({
                    frameBorder: "0",
                    allowTransparency: "true"
                }, attributes),
                style: Object(esm_extends.a)({
                    backgroundColor: "transparent"
                }, style),
                html: options.html,
                class: options.class
            });
            awaitFrameLoad(frame);
            el.appendChild(frame);
            (options.url || window.navigator.userAgent.match(/MSIE|Edge/i)) && frame.setAttribute("src", options.url || "about:blank");
            return frame;
        }
        function addEventListener(obj, event, handler) {
            obj.addEventListener(event, handler);
            return {
                cancel: function() {
                    obj.removeEventListener(event, handler);
                }
            };
        }
        var parseQuery = memoize((function(queryString) {
            var params = {};
            if (!queryString) return params;
            if (-1 === queryString.indexOf("=")) throw new Error("Can not parse query string params: " + queryString);
            for (var _i4 = 0, _queryString$split2 = queryString.split("&"); _i4 < _queryString$split2.length; _i4++) {
                var pair = _queryString$split2[_i4];
                (pair = pair.split("="))[0] && pair[1] && (params[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]));
            }
            return params;
        }));
        function extendQuery(originalQuery, props) {
            void 0 === props && (props = {});
            return props && Object.keys(props).length ? function(obj) {
                void 0 === obj && (obj = {});
                return Object.keys(obj).filter((function(key) {
                    return "string" == typeof obj[key];
                })).map((function(key) {
                    return urlEncode(key) + "=" + urlEncode(obj[key]);
                })).join("&");
            }(Object(esm_extends.a)({}, parseQuery(originalQuery), props)) : originalQuery;
        }
        function extendUrl(url, options) {
            void 0 === options && (options = {});
            var query = options.query || {};
            var hash = options.hash || {};
            var originalUrl;
            var originalHash;
            var _url$split = url.split("#");
            originalHash = _url$split[1];
            var _originalUrl$split = (originalUrl = _url$split[0]).split("?");
            originalUrl = _originalUrl$split[0];
            var queryString = extendQuery(_originalUrl$split[1], query);
            var hashString = extendQuery(originalHash, hash);
            queryString && (originalUrl = originalUrl + "?" + queryString);
            hashString && (originalUrl = originalUrl + "#" + hashString);
            return originalUrl;
        }
        function bindEvents(element, eventNames, handler) {
            handler = once(handler);
            for (var _i8 = 0; _i8 < eventNames.length; _i8++) element.addEventListener(eventNames[_i8], handler);
            return {
                cancel: once((function() {
                    for (var _i10 = 0; _i10 < eventNames.length; _i10++) element.removeEventListener(eventNames[_i10], handler);
                }))
            };
        }
        var VENDOR_PREFIXES = [ "webkit", "moz", "ms", "o" ];
        function setVendorCSS(element, name, value) {
            element.style[name] = value;
            var capitalizedName = (string = name).charAt(0).toUpperCase() + string.slice(1).toLowerCase();
            var string;
            for (var _i12 = 0; _i12 < VENDOR_PREFIXES.length; _i12++) element.style["" + VENDOR_PREFIXES[_i12] + capitalizedName] = value;
        }
        var CSSRule = window.CSSRule;
        var KEYFRAMES_RULE = CSSRule.KEYFRAMES_RULE || CSSRule.WEBKIT_KEYFRAMES_RULE || CSSRule.MOZ_KEYFRAMES_RULE || CSSRule.O_KEYFRAMES_RULE || CSSRule.MS_KEYFRAMES_RULE;
        var ANIMATION_START_EVENTS = [ "animationstart", "webkitAnimationStart", "oAnimationStart", "MSAnimationStart" ];
        var ANIMATION_END_EVENTS = [ "animationend", "webkitAnimationEnd", "oAnimationEnd", "MSAnimationEnd" ];
        function animate(element, name, clean, timeout) {
            void 0 === timeout && (timeout = 1e3);
            return new zalgo_promise_src.a((function(resolve, reject) {
                var el = getElement(element);
                if (!el || !function(element, name) {
                    var stylesheets = element.ownerDocument.styleSheets;
                    try {
                        for (var i = 0; i < stylesheets.length; i++) {
                            var cssRules = stylesheets[i].cssRules;
                            if (cssRules) for (var j = 0; j < cssRules.length; j++) {
                                var cssRule = cssRules[j];
                                if (cssRule && cssRule.type === KEYFRAMES_RULE && cssRule.name === name) return !0;
                            }
                        }
                    } catch (err) {
                        return !1;
                    }
                    return !1;
                }(el, name)) return resolve();
                var hasStarted = !1;
                var startTimeout;
                var endTimeout;
                var startEvent;
                var endEvent;
                function cleanUp() {
                    setVendorCSS(el, "animationName", "");
                    clearTimeout(startTimeout);
                    clearTimeout(endTimeout);
                    startEvent.cancel();
                    endEvent.cancel();
                }
                startEvent = bindEvents(el, ANIMATION_START_EVENTS, (function(event) {
                    if (event.target === el && event.animationName === name) {
                        clearTimeout(startTimeout);
                        event.stopPropagation();
                        startEvent.cancel();
                        hasStarted = !0;
                        endTimeout = setTimeout((function() {
                            cleanUp();
                            resolve();
                        }), timeout);
                    }
                }));
                endEvent = bindEvents(el, ANIMATION_END_EVENTS, (function(event) {
                    if (event.target === el && event.animationName === name) {
                        cleanUp();
                        return "string" == typeof event.animationName && event.animationName !== name ? reject("Expected animation name to be " + name + ", found " + event.animationName) : resolve();
                    }
                }));
                setVendorCSS(el, "animationName", name);
                startTimeout = setTimeout((function() {
                    if (!hasStarted) {
                        cleanUp();
                        return resolve();
                    }
                }), 200);
                clean && clean(cleanUp);
            }));
        }
        function showElement(element) {
            element.style.setProperty("display", "");
        }
        function hideElement(element) {
            element.style.setProperty("display", "none", "important");
        }
        function destroyElement(element) {
            element.parentNode && element.parentNode.removeChild(element);
        }
        function showAndAnimate(element, name, clean) {
            var animation = animate(element, name, clean);
            showElement(element);
            return animation;
        }
        function animateAndHide(element, name, clean) {
            return animate(element, name, clean).then((function() {
                hideElement(element);
            }));
        }
        function addClass(element, name) {
            element.classList ? element.classList.add(name) : -1 === element.className.split(/\s+/).indexOf(name) && (element.className += " " + name);
        }
        function removeClass(element, name) {
            element.classList ? element.classList.remove(name) : -1 !== element.className.split(/\s+/).indexOf(name) && (element.className = element.className.replace(name, ""));
        }
        function getCurrentScriptDir() {
            console.warn("Do not use zoid.getCurrentScriptDir() in production -- browser support is limited");
            return document.currentScript ? document.currentScript.src.split("/").slice(0, -1).join("/") : ".";
        }
        function isElementClosed(el) {
            return !el || !el.parentNode;
        }
        function watchElementForClose(element, handler) {
            handler = once(handler);
            var interval;
            isElementClosed(element) ? handler() : interval = function(method, time) {
                var timeout;
                timeout = setTimeout((function runInterval() {
                    timeout = setTimeout(runInterval, 50);
                    method.call();
                }), 50);
                return {
                    cancel: function() {
                        clearTimeout(timeout);
                    }
                };
            }((function() {
                if (isElementClosed(element)) {
                    interval.cancel();
                    handler();
                }
            }));
            return {
                cancel: function() {
                    interval && interval.cancel();
                }
            };
        }
        function prefetchPage(url) {
            return function(url) {
                return function(contentType, url) {
                    return new zalgo_promise_src.a((function(resolve, reject) {
                        var req = new window.XMLHttpRequest;
                        req.open("GET", url);
                        req.setRequestHeader("Accept", "text/html");
                        req.send(null);
                        req.onload = function() {
                            resolve(req.responseText);
                        };
                        req.onerror = function() {
                            return reject(new Error("prefetch failed"));
                        };
                    }));
                }(0, url);
            }(url);
        }
        var JSX_EVENTS = {
            onClick: "click"
        };
        function fixScripts(el, doc) {
            void 0 === doc && (doc = window.document);
            for (var _i14 = 0, _querySelectorAll2 = function(el, selector) {
                return [].slice.call(el.querySelectorAll("script"));
            }(el); _i14 < _querySelectorAll2.length; _i14++) {
                var script = _querySelectorAll2[_i14];
                var newScript = doc.createElement("script");
                newScript.text = script.textContent;
                script.parentNode.replaceChild(newScript, script);
            }
        }
        function jsxDom(name, props, content) {
            name = name.toLowerCase();
            var doc = this && this.createElement ? this : window.document;
            var el = doc.createElement(name);
            for (var prop in props) if (prop in JSX_EVENTS) el.addEventListener(JSX_EVENTS[prop], props[prop]); else if ("innerHTML" === prop) {
                el.innerHTML = props[prop];
                fixScripts(el, doc);
            } else el.setAttribute(prop, props[prop]);
            if ("style" === name) {
                if ("string" != typeof content) throw new TypeError("Expected " + name + " tag content to be string, got " + typeof content);
                if (arguments.length > 3) throw new Error("Expected only text content for " + name + " tag");
                setStyle(el, content, doc);
            } else if ("iframe" === name) {
                if (arguments.length > 3) throw new Error("Expected only single child node for iframe");
                el.addEventListener("load", (function() {
                    var win = el.contentWindow;
                    if (!win) throw new Error("Expected frame to have contentWindow");
                    "string" == typeof content ? writeToWindow(win, content) : writeElementToWindow(win, content);
                }));
            } else if ("script" === name) {
                if ("string" != typeof content) throw new TypeError("Expected " + name + " tag content to be string, got " + typeof content);
                if (arguments.length > 3) throw new Error("Expected only text content for " + name + " tag");
                el.text = content;
            } else for (var i = 2; i < arguments.length; i++) if ("string" == typeof arguments[i]) {
                var textNode = doc.createTextNode(arguments[i]);
                appendChild(el, textNode);
            } else appendChild(el, arguments[i]);
            return el;
        }
        function denodeify(method) {
            return function() {
                var self = this;
                var args = [].slice.call(arguments);
                return args.length >= method.length ? zalgo_promise_src.a.resolve(method.apply(self, args)) : new zalgo_promise_src.a((function(resolve, reject) {
                    args.push((function(err, result) {
                        if (err && !(err instanceof Error)) throw new Error("Passed non-Error object in callback: [ " + err + " ] -- callbacks should either be called with callback(new Error(...)) or callback(null, result).");
                        return err ? reject(err) : resolve(result);
                    }));
                    method.apply(self, args);
                }));
            };
        }
        function promisify(method) {
            return function() {
                var _arguments = arguments, _this = this;
                return zalgo_promise_src.a.try((function() {
                    return method.apply(_this, _arguments);
                }));
            };
        }
        function isPerc(str) {
            return "string" == typeof str && /^[0-9]+%$/.test(str);
        }
        function isPx(str) {
            return "string" == typeof str && /^[0-9]+px$/.test(str);
        }
        function toNum(val) {
            if ("number" == typeof val) return val;
            var match = val.match(/^([0-9]+)(px|%)$/);
            if (!match) throw new Error("Could not match css value from " + val);
            return parseInt(match[1], 10);
        }
        function toPx(val) {
            return toNum(val) + "px";
        }
        function toCSS(val) {
            return "number" == typeof val ? toPx(val) : isPerc(val) ? val : toPx(val);
        }
        function normalizeDimension(dim, max) {
            if ("number" == typeof dim) return dim;
            if (isPerc(dim)) return parseInt(max * toNum(dim) / 100, 10);
            if (isPx(dim)) return toNum(dim);
            throw new Error("Can not normalize dimension: " + dim);
        }
        function memoized(target, name, descriptor) {
            var method = descriptor.value;
            descriptor.value = function() {
                this.__memoized__ = this.__memoized__ || {};
                this.__memoized__.hasOwnProperty(name) || (this.__memoized__[name] = method.apply(this, arguments));
                return this.__memoized__[name];
            };
            descriptor.value.displayName = name + ":memoized";
        }
        var post_robot_src = __webpack_require__(15);
        var client = __webpack_require__(5);
        function setLogLevel(logLevel) {
            if (-1 === client.m.indexOf(logLevel)) throw new Error("Invalid logLevel: " + logLevel);
            client.e.logLevel = logLevel;
            post_robot_src.CONFIG.LOG_LEVEL = logLevel;
            window.LOG_LEVEL = logLevel;
        }
        function info(name, event, payload) {
            void 0 === payload && (payload = {});
            Object(client.k)("xc_" + name + "_" + event, payload);
        }
        function warn(name, event, payload) {
            void 0 === payload && (payload = {});
            Object(client.q)("xc_" + name + "_" + event, payload);
        }
        function logger_error(name, event, payload) {
            void 0 === payload && (payload = {});
            Object(client.g)("xc_" + name + "_" + event, payload);
        }
        var constants = __webpack_require__(8);
        function globalFor(win) {
            if (Object(src.v)(win)) {
                win[constants.__ZOID__] || (win[constants.__ZOID__] = {});
                return win[constants.__ZOID__];
            }
        }
        var global = function() {
            var global = globalFor(window);
            if (!global) throw new Error("Could not get local global");
            return global;
        }();
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "n", (function() {
            return getParent;
        }));
        __webpack_require__.d(__webpack_exports__, "m", (function() {
            return getOpener;
        }));
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return getActualDomain;
        }));
        __webpack_require__.d(__webpack_exports__, "h", (function() {
            return getDomain;
        }));
        __webpack_require__.d(__webpack_exports__, "q", (function() {
            return isActuallySameDomain;
        }));
        __webpack_require__.d(__webpack_exports__, "v", (function() {
            return isSameDomain;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return assertSameDomain;
        }));
        __webpack_require__.d(__webpack_exports__, "k", (function() {
            return getFrames;
        }));
        __webpack_require__.d(__webpack_exports__, "o", (function() {
            return getTop;
        }));
        __webpack_require__.d(__webpack_exports__, "e", (function() {
            return getAllFramesInWindow;
        }));
        __webpack_require__.d(__webpack_exports__, "x", (function() {
            return isTop;
        }));
        __webpack_require__.d(__webpack_exports__, "z", (function() {
            return isWindowClosed;
        }));
        __webpack_require__.d(__webpack_exports__, "A", (function() {
            return linkFrameWindow;
        }));
        __webpack_require__.d(__webpack_exports__, "p", (function() {
            return getUserAgent;
        }));
        __webpack_require__.d(__webpack_exports__, "j", (function() {
            return getFrameByName;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return findFrameByName;
        }));
        __webpack_require__.d(__webpack_exports__, "t", (function() {
            return isOpener;
        }));
        __webpack_require__.d(__webpack_exports__, "f", (function() {
            return getAncestor;
        }));
        __webpack_require__.d(__webpack_exports__, "r", (function() {
            return isAncestor;
        }));
        __webpack_require__.d(__webpack_exports__, "u", (function() {
            return isPopup;
        }));
        __webpack_require__.d(__webpack_exports__, "s", (function() {
            return isIframe;
        }));
        __webpack_require__.d(__webpack_exports__, "g", (function() {
            return getDistanceFromTop;
        }));
        __webpack_require__.d(__webpack_exports__, "l", (function() {
            return getNthParentFromTop;
        }));
        __webpack_require__.d(__webpack_exports__, "w", (function() {
            return isSameTopWindow;
        }));
        __webpack_require__.d(__webpack_exports__, "B", (function() {
            return matchDomain;
        }));
        __webpack_require__.d(__webpack_exports__, "D", (function() {
            return stringifyDomainPattern;
        }));
        __webpack_require__.d(__webpack_exports__, "i", (function() {
            return getDomainFromUrl;
        }));
        __webpack_require__.d(__webpack_exports__, "C", (function() {
            return onCloseWindow;
        }));
        __webpack_require__.d(__webpack_exports__, "y", (function() {
            return isWindow;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return PROTOCOL;
        }));
        function isRegex(item) {
            return "[object RegExp]" === {}.toString.call(item);
        }
        var PROTOCOL = {
            MOCK: "mock:",
            FILE: "file:",
            ABOUT: "about:"
        };
        var IE_WIN_ACCESS_ERROR = "Call was rejected by callee.\r\n";
        function isAboutProtocol(win) {
            void 0 === win && (win = window);
            return win.location.protocol === PROTOCOL.ABOUT;
        }
        function getParent(win) {
            void 0 === win && (win = window);
            if (win) try {
                if (win.parent && win.parent !== win) return win.parent;
            } catch (err) {}
        }
        function getOpener(win) {
            void 0 === win && (win = window);
            if (win && !getParent(win)) try {
                return win.opener;
            } catch (err) {}
        }
        function canReadFromWindow(win) {
            try {
                return !0;
            } catch (err) {}
            return !1;
        }
        function getActualDomain(win) {
            void 0 === win && (win = window);
            var location = win.location;
            if (!location) throw new Error("Can not read window location");
            var protocol = location.protocol;
            if (!protocol) throw new Error("Can not read window protocol");
            if (protocol === PROTOCOL.FILE) return PROTOCOL.FILE + "//";
            if (protocol === PROTOCOL.ABOUT) {
                var parent = getParent(win);
                return parent && canReadFromWindow() ? getActualDomain(parent) : PROTOCOL.ABOUT + "//";
            }
            var host = location.host;
            if (!host) throw new Error("Can not read window host");
            return protocol + "//" + host;
        }
        function getDomain(win) {
            void 0 === win && (win = window);
            var domain = getActualDomain(win);
            return domain && win.mockDomain && 0 === win.mockDomain.indexOf(PROTOCOL.MOCK) ? win.mockDomain : domain;
        }
        function isActuallySameDomain(win) {
            try {
                if (win === window) return !0;
            } catch (err) {}
            try {
                var desc = Object.getOwnPropertyDescriptor(win, "location");
                if (desc && !1 === desc.enumerable) return !1;
            } catch (err) {}
            try {
                if (isAboutProtocol(win) && canReadFromWindow()) return !0;
            } catch (err) {}
            try {
                if (getActualDomain(win) === getActualDomain(window)) return !0;
            } catch (err) {}
            return !1;
        }
        function isSameDomain(win) {
            if (!isActuallySameDomain(win)) return !1;
            try {
                if (win === window) return !0;
                if (isAboutProtocol(win) && canReadFromWindow()) return !0;
                if (getDomain(window) === getDomain(win)) return !0;
            } catch (err) {}
            return !1;
        }
        function assertSameDomain(win) {
            if (!isSameDomain(win)) throw new Error("Expected window to be same domain");
            return win;
        }
        function isAncestorParent(parent, child) {
            if (!parent || !child) return !1;
            var childParent = getParent(child);
            return childParent ? childParent === parent : -1 !== function(win) {
                var result = [];
                try {
                    for (;win.parent !== win; ) {
                        result.push(win.parent);
                        win = win.parent;
                    }
                } catch (err) {}
                return result;
            }(child).indexOf(parent);
        }
        function getFrames(win) {
            var result = [];
            var frames;
            try {
                frames = win.frames;
            } catch (err) {
                frames = win;
            }
            var len;
            try {
                len = frames.length;
            } catch (err) {}
            if (0 === len) return result;
            if (len) {
                for (var i = 0; i < len; i++) {
                    var frame = void 0;
                    try {
                        frame = frames[i];
                    } catch (err) {
                        continue;
                    }
                    result.push(frame);
                }
                return result;
            }
            for (var _i = 0; _i < 100; _i++) {
                var _frame = void 0;
                try {
                    _frame = frames[_i];
                } catch (err) {
                    return result;
                }
                if (!_frame) return result;
                result.push(_frame);
            }
            return result;
        }
        function getAllChildFrames(win) {
            var result = [];
            for (var _i3 = 0, _getFrames2 = getFrames(win); _i3 < _getFrames2.length; _i3++) {
                var frame = _getFrames2[_i3];
                result.push(frame);
                for (var _i5 = 0, _getAllChildFrames2 = getAllChildFrames(frame); _i5 < _getAllChildFrames2.length; _i5++) result.push(_getAllChildFrames2[_i5]);
            }
            return result;
        }
        function getTop(win) {
            void 0 === win && (win = window);
            try {
                if (win.top) return win.top;
            } catch (err) {}
            if (getParent(win) === win) return win;
            try {
                if (isAncestorParent(window, win) && window.top) return window.top;
            } catch (err) {}
            try {
                if (isAncestorParent(win, window) && window.top) return window.top;
            } catch (err) {}
            for (var _i7 = 0, _getAllChildFrames4 = getAllChildFrames(win); _i7 < _getAllChildFrames4.length; _i7++) {
                var frame = _getAllChildFrames4[_i7];
                try {
                    if (frame.top) return frame.top;
                } catch (err) {}
                if (getParent(frame) === frame) return frame;
            }
        }
        function getAllFramesInWindow(win) {
            var top = getTop(win);
            if (!top) throw new Error("Can not determine top window");
            var result = [].concat(getAllChildFrames(top), [ top ]);
            -1 === result.indexOf(win) && (result = [].concat(result, [ win ], getAllChildFrames(win)));
            return result;
        }
        function isTop(win) {
            return win === getTop(win);
        }
        var iframeWindows = [];
        var iframeFrames = [];
        function isWindowClosed(win, allowMock) {
            void 0 === allowMock && (allowMock = !0);
            try {
                if (win === window) return !1;
            } catch (err) {
                return !0;
            }
            try {
                if (!win) return !0;
            } catch (err) {
                return !0;
            }
            try {
                if (win.closed) return !0;
            } catch (err) {
                return !err || err.message !== IE_WIN_ACCESS_ERROR;
            }
            if (allowMock && isSameDomain(win)) try {
                if (win.mockclosed) return !0;
            } catch (err) {}
            try {
                if (!win.parent || !win.top) return !0;
            } catch (err) {}
            var iframeIndex = function(collection, item) {
                for (var i = 0; i < collection.length; i++) try {
                    if (collection[i] === item) return i;
                } catch (err) {}
                return -1;
            }(iframeWindows, win);
            if (-1 !== iframeIndex) {
                var frame = iframeFrames[iframeIndex];
                if (frame && function(frame) {
                    if (!frame.contentWindow) return !0;
                    if (!frame.parentNode) return !0;
                    var doc = frame.ownerDocument;
                    if (doc && doc.documentElement && !doc.documentElement.contains(frame)) {
                        var parent = frame;
                        for (;parent.parentNode && parent.parentNode !== parent; ) parent = parent.parentNode;
                        if (!parent.host || !doc.documentElement.contains(parent.host)) return !0;
                    }
                    return !1;
                }(frame)) return !0;
            }
            return !1;
        }
        function linkFrameWindow(frame) {
            !function() {
                for (var i = 0; i < iframeWindows.length; i++) {
                    var closed = !1;
                    try {
                        closed = iframeWindows[i].closed;
                    } catch (err) {}
                    if (closed) {
                        iframeFrames.splice(i, 1);
                        iframeWindows.splice(i, 1);
                    }
                }
            }();
            if (frame && frame.contentWindow) try {
                iframeWindows.push(frame.contentWindow);
                iframeFrames.push(frame);
            } catch (err) {}
        }
        function getUserAgent(win) {
            return (win = win || window).navigator.mockUserAgent || win.navigator.userAgent;
        }
        function getFrameByName(win, name) {
            var winFrames = getFrames(win);
            for (var _i9 = 0; _i9 < winFrames.length; _i9++) {
                var childFrame = winFrames[_i9];
                try {
                    if (isSameDomain(childFrame) && childFrame.name === name && -1 !== winFrames.indexOf(childFrame)) return childFrame;
                } catch (err) {}
            }
            try {
                if (-1 !== winFrames.indexOf(win.frames[name])) return win.frames[name];
            } catch (err) {}
            try {
                if (-1 !== winFrames.indexOf(win[name])) return win[name];
            } catch (err) {}
        }
        function findFrameByName(win, name) {
            return getFrameByName(win, name) || function findChildFrameByName(win, name) {
                var frame = getFrameByName(win, name);
                if (frame) return frame;
                for (var _i11 = 0, _getFrames4 = getFrames(win); _i11 < _getFrames4.length; _i11++) {
                    var namedFrame = findChildFrameByName(_getFrames4[_i11], name);
                    if (namedFrame) return namedFrame;
                }
            }(getTop(win) || win, name);
        }
        function isOpener(parent, child) {
            return parent === getOpener(child);
        }
        function getAncestor(win) {
            void 0 === win && (win = window);
            return getOpener(win = win || window) || getParent(win) || void 0;
        }
        function isAncestor(parent, child) {
            var actualParent = getAncestor(child);
            if (actualParent) return actualParent === parent;
            if (child === parent) return !1;
            if (getTop(child) === child) return !1;
            for (var _i15 = 0, _getFrames8 = getFrames(parent); _i15 < _getFrames8.length; _i15++) if (_getFrames8[_i15] === child) return !0;
            return !1;
        }
        function isPopup(win) {
            void 0 === win && (win = window);
            return Boolean(getOpener(win));
        }
        function isIframe(win) {
            void 0 === win && (win = window);
            return Boolean(getParent(win));
        }
        function anyMatch(collection1, collection2) {
            for (var _i17 = 0; _i17 < collection1.length; _i17++) {
                var item1 = collection1[_i17];
                for (var _i19 = 0; _i19 < collection2.length; _i19++) if (item1 === collection2[_i19]) return !0;
            }
            return !1;
        }
        function getDistanceFromTop(win) {
            void 0 === win && (win = window);
            var distance = 0;
            var parent = win;
            for (;parent; ) (parent = getParent(parent)) && (distance += 1);
            return distance;
        }
        function getNthParentFromTop(win, n) {
            void 0 === n && (n = 1);
            return function(win, n) {
                void 0 === n && (n = 1);
                var parent = win;
                for (var i = 0; i < n; i++) {
                    if (!parent) return;
                    parent = getParent(parent);
                }
                return parent;
            }(win, getDistanceFromTop(win) - n);
        }
        function isSameTopWindow(win1, win2) {
            var top1 = getTop(win1) || win1;
            var top2 = getTop(win2) || win2;
            try {
                if (top1 && top2) return top1 === top2;
            } catch (err) {}
            var allFrames1 = getAllFramesInWindow(win1);
            var allFrames2 = getAllFramesInWindow(win2);
            if (anyMatch(allFrames1, allFrames2)) return !0;
            var opener1 = getOpener(top1);
            var opener2 = getOpener(top2);
            return opener1 && anyMatch(getAllFramesInWindow(opener1), allFrames2) || opener2 && anyMatch(getAllFramesInWindow(opener2), allFrames1), 
            !1;
        }
        function matchDomain(pattern, origin) {
            if ("string" == typeof pattern) {
                if ("string" == typeof origin) return "*" === pattern || origin === pattern;
                if (isRegex(origin)) return !1;
                if (Array.isArray(origin)) return !1;
            }
            return isRegex(pattern) ? isRegex(origin) ? pattern.toString() === origin.toString() : !Array.isArray(origin) && Boolean(origin.match(pattern)) : !!Array.isArray(pattern) && (Array.isArray(origin) ? JSON.stringify(pattern) === JSON.stringify(origin) : !isRegex(origin) && pattern.some((function(subpattern) {
                return matchDomain(subpattern, origin);
            })));
        }
        function stringifyDomainPattern(pattern) {
            return Array.isArray(pattern) ? "(" + pattern.join(" | ") + ")" : isRegex(pattern) ? "RegExp(" + pattern.toString() + ")" : pattern.toString();
        }
        function getDomainFromUrl(url) {
            return url.match(/^(https?|mock|file):\/\//) ? url.split("/").slice(0, 3).join("/") : getDomain();
        }
        function onCloseWindow(win, callback, delay, maxtime) {
            void 0 === delay && (delay = 1e3);
            void 0 === maxtime && (maxtime = 1 / 0);
            var timeout;
            !function check() {
                if (isWindowClosed(win)) {
                    timeout && clearTimeout(timeout);
                    return callback();
                }
                if (maxtime <= 0) clearTimeout(timeout); else {
                    maxtime -= delay;
                    timeout = setTimeout(check, delay);
                }
            }();
            return {
                cancel: function() {
                    timeout && clearTimeout(timeout);
                }
            };
        }
        function isWindow(obj) {
            try {
                if (obj === window) return !0;
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
            }
            try {
                if ("[object Window]" === {}.toString.call(obj)) return !0;
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
            }
            try {
                if (window.Window && obj instanceof window.Window) return !0;
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
            }
            try {
                if (obj && obj.self === obj) return !0;
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
            }
            try {
                if (obj && obj.parent === obj) return !0;
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
            }
            try {
                if (obj && obj.top === obj) return !0;
            } catch (err) {
                if (err && err.message === IE_WIN_ACCESS_ERROR) return !0;
            }
            try {
                if (obj && "__unlikely_value__" === obj.__cross_domain_utils_window_check__) return !1;
            } catch (err) {
                return !0;
            }
            try {
                if ("postMessage" in obj && "self" in obj && "location" in obj) return !0;
            } catch (err) {}
            return !1;
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        __webpack_require__.d(__webpack_exports__, "ZOID", (function() {
            return ZOID;
        }));
        __webpack_require__.d(__webpack_exports__, "__ZOID__", (function() {
            return __ZOID__;
        }));
        __webpack_require__.d(__webpack_exports__, "POST_MESSAGE", (function() {
            return POST_MESSAGE;
        }));
        __webpack_require__.d(__webpack_exports__, "PROP_TYPES", (function() {
            return PROP_TYPES;
        }));
        __webpack_require__.d(__webpack_exports__, "INITIAL_PROPS", (function() {
            return INITIAL_PROPS;
        }));
        __webpack_require__.d(__webpack_exports__, "WINDOW_REFERENCES", (function() {
            return WINDOW_REFERENCES;
        }));
        __webpack_require__.d(__webpack_exports__, "PROP_TYPES_LIST", (function() {
            return PROP_TYPES_LIST;
        }));
        __webpack_require__.d(__webpack_exports__, "CONTEXT_TYPES", (function() {
            return CONTEXT_TYPES;
        }));
        __webpack_require__.d(__webpack_exports__, "CLASS_NAMES", (function() {
            return CLASS_NAMES;
        }));
        __webpack_require__.d(__webpack_exports__, "EVENTS", (function() {
            return EVENTS;
        }));
        __webpack_require__.d(__webpack_exports__, "ATTRIBUTES", (function() {
            return ATTRIBUTES;
        }));
        __webpack_require__.d(__webpack_exports__, "ANIMATION_NAMES", (function() {
            return ANIMATION_NAMES;
        }));
        __webpack_require__.d(__webpack_exports__, "EVENT_NAMES", (function() {
            return EVENT_NAMES;
        }));
        __webpack_require__.d(__webpack_exports__, "CLOSE_REASONS", (function() {
            return CLOSE_REASONS;
        }));
        __webpack_require__.d(__webpack_exports__, "CONTEXT_TYPES_LIST", (function() {
            return CONTEXT_TYPES_LIST;
        }));
        __webpack_require__.d(__webpack_exports__, "DELEGATE", (function() {
            return DELEGATE;
        }));
        __webpack_require__.d(__webpack_exports__, "WILDCARD", (function() {
            return WILDCARD;
        }));
        __webpack_require__.d(__webpack_exports__, "DEFAULT_DIMENSIONS", (function() {
            return DEFAULT_DIMENSIONS;
        }));
        var ZOID = "zoid";
        var __ZOID__ = "__" + ZOID + "__";
        var POST_MESSAGE = {
            INIT: ZOID + "_init",
            PROPS: ZOID + "_props",
            PROP_CALLBACK: ZOID + "_prop_callback",
            CLOSE: ZOID + "_close",
            CHECK_CLOSE: ZOID + "_check_close",
            REDIRECT: ZOID + "_redirect",
            RESIZE: ZOID + "_resize",
            DELEGATE: ZOID + "_delegate",
            ALLOW_DELEGATE: ZOID + "_allow_delegate",
            ERROR: ZOID + "_error",
            HIDE: ZOID + "_hide",
            SHOW: ZOID + "_show"
        };
        var PROP_TYPES = {
            STRING: "string",
            OBJECT: "object",
            FUNCTION: "function",
            BOOLEAN: "boolean",
            NUMBER: "number"
        };
        var INITIAL_PROPS = {
            RAW: "raw",
            UID: "uid"
        };
        var WINDOW_REFERENCES = {
            OPENER: "opener",
            TOP: "top",
            PARENT: "parent",
            GLOBAL: "global"
        };
        var PROP_TYPES_LIST = Object.keys(PROP_TYPES).map((function(key) {
            return PROP_TYPES[key];
        }));
        var CONTEXT_TYPES = {
            IFRAME: "iframe",
            POPUP: "popup"
        };
        var CLASS_NAMES = {
            ZOID: "" + ZOID,
            OUTLET: ZOID + "-outlet",
            COMPONENT_FRAME: ZOID + "-component-frame",
            PRERENDER_FRAME: ZOID + "-prerender-frame",
            VISIBLE: ZOID + "-visible",
            INVISIBLE: ZOID + "-invisible"
        };
        var EVENTS = {
            CLOSE: ZOID + "-close"
        };
        var ATTRIBUTES = {
            IFRAME_PLACEHOLDER: "data-zoid-" + ZOID + "-placeholder"
        };
        var ANIMATION_NAMES = {
            SHOW_CONTAINER: ZOID + "-show-container",
            SHOW_COMPONENT: ZOID + "-show-component",
            HIDE_CONTAINER: ZOID + "-hide-container",
            HIDE_COMPONENT: ZOID + "-hide-component"
        };
        var EVENT_NAMES = {
            CLICK: "click"
        };
        var CLOSE_REASONS = {
            PARENT_CALL: "parent_call",
            CHILD_CALL: "child_call",
            CLOSE_DETECTED: "close_detected",
            USER_CLOSED: "user_closed",
            PARENT_CLOSE_DETECTED: "parent_close_detected"
        };
        var CONTEXT_TYPES_LIST = Object.keys(CONTEXT_TYPES).map((function(key) {
            return CONTEXT_TYPES[key];
        }));
        var DELEGATE = {
            CALL_ORIGINAL: "call_original",
            CALL_DELEGATE: "call_delegate"
        };
        var WILDCARD = "*";
        var DEFAULT_DIMENSIONS = {
            WIDTH: 300,
            HEIGHT: 150
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return global;
        }));
        var _conf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10);
        var global = window[_conf__WEBPACK_IMPORTED_MODULE_0__.b.WINDOW_PROPS.POSTROBOT] = window[_conf__WEBPACK_IMPORTED_MODULE_0__.b.WINDOW_PROPS.POSTROBOT] || {};
        global.registerSelf = function() {};
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return CONFIG;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return CONSTANTS;
        }));
        var CONSTANTS = {
            POST_MESSAGE_TYPE: {
                REQUEST: "postrobot_message_request",
                RESPONSE: "postrobot_message_response",
                ACK: "postrobot_message_ack"
            },
            POST_MESSAGE_ACK: {
                SUCCESS: "success",
                ERROR: "error"
            },
            POST_MESSAGE_NAMES: {
                METHOD: "postrobot_method",
                HELLO: "postrobot_ready",
                OPEN_TUNNEL: "postrobot_open_tunnel"
            },
            WINDOW_TYPES: {
                FULLPAGE: "fullpage",
                POPUP: "popup",
                IFRAME: "iframe"
            },
            WINDOW_PROPS: {
                POSTROBOT: "__postRobot__"
            },
            SERIALIZATION_TYPES: {
                METHOD: "postrobot_method",
                ERROR: "postrobot_error",
                PROMISE: "postrobot_promise",
                ZALGO_PROMISE: "postrobot_zalgo_promise",
                REGEX: "regex"
            },
            SEND_STRATEGIES: {
                POST_MESSAGE: "postrobot_post_message",
                BRIDGE: "postrobot_bridge",
                GLOBAL: "postrobot_global"
            },
            MOCK_PROTOCOL: "mock:",
            FILE_PROTOCOL: "file:",
            BRIDGE_NAME_PREFIX: "__postrobot_bridge__",
            POSTROBOT_PROXY: "__postrobot_proxy__",
            WILDCARD: "*"
        };
        var POST_MESSAGE_NAMES = {
            METHOD: "postrobot_method",
            HELLO: "postrobot_hello",
            OPEN_TUNNEL: "postrobot_open_tunnel"
        };
        Object.keys(POST_MESSAGE_NAMES).map((function(key) {
            return POST_MESSAGE_NAMES[key];
        }));
        var _ALLOWED_POST_MESSAGE;
        var CONFIG = {
            ALLOW_POSTMESSAGE_POPUP: !("__ALLOW_POSTMESSAGE_POPUP__" in window) || window.__ALLOW_POSTMESSAGE_POPUP__,
            BRIDGE_TIMEOUT: 5e3,
            CHILD_WINDOW_TIMEOUT: 5e3,
            ACK_TIMEOUT: -1 !== window.navigator.userAgent.match(/MSIE/i) ? 1e4 : 2e3,
            RES_TIMEOUT: -1,
            ALLOWED_POST_MESSAGE_METHODS: (_ALLOWED_POST_MESSAGE = {}, _ALLOWED_POST_MESSAGE[CONSTANTS.SEND_STRATEGIES.POST_MESSAGE] = !0, 
            _ALLOWED_POST_MESSAGE[CONSTANTS.SEND_STRATEGIES.BRIDGE] = !0, _ALLOWED_POST_MESSAGE[CONSTANTS.SEND_STRATEGIES.GLOBAL] = !0, 
            _ALLOWED_POST_MESSAGE),
            ALLOW_SAME_ORIGIN: !1
        };
        0 === window.location.href.indexOf(CONSTANTS.FILE_PROTOCOL) && (CONFIG.ALLOW_POSTMESSAGE_POPUP = !0);
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return getUserAgent;
        }));
        __webpack_require__.d(__webpack_exports__, "h", (function() {
            return isDevice;
        }));
        __webpack_require__.d(__webpack_exports__, "f", (function() {
            return isAndroid;
        }));
        __webpack_require__.d(__webpack_exports__, "l", (function() {
            return isIos;
        }));
        __webpack_require__.d(__webpack_exports__, "n", (function() {
            return isSFVC;
        }));
        __webpack_require__.d(__webpack_exports__, "i", (function() {
            return device_isIE;
        }));
        __webpack_require__.d(__webpack_exports__, "j", (function() {
            return isIECompHeader;
        }));
        __webpack_require__.d(__webpack_exports__, "k", (function() {
            return isIEIntranet;
        }));
        __webpack_require__.d(__webpack_exports__, "t", (function() {
            return supportsPopups;
        }));
        __webpack_require__.d(__webpack_exports__, "g", (function() {
            return isChrome;
        }));
        __webpack_require__.d(__webpack_exports__, "o", (function() {
            return isSafari;
        }));
        __webpack_require__.d(__webpack_exports__, "m", (function() {
            return isLocalStorageEnabled;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return getElementSafe;
        }));
        __webpack_require__.d(__webpack_exports__, "r", (function() {
            return onResize;
        }));
        __webpack_require__.d(__webpack_exports__, "p", (function() {
            return isShadowElement;
        }));
        __webpack_require__.d(__webpack_exports__, "e", (function() {
            return insertShadowSlot;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return base64encode;
        }));
        __webpack_require__.d(__webpack_exports__, "u", (function() {
            return uniqueID;
        }));
        __webpack_require__.d(__webpack_exports__, "q", (function() {
            return noop;
        }));
        __webpack_require__.d(__webpack_exports__, "s", (function() {
            return once;
        }));
        __webpack_require__.d(__webpack_exports__, "v", (function() {
            return values;
        }));
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return identity;
        }));
        var iPhoneScreenHeightMatrix = {
            926: {
                device: "iPhone 12 Pro Max",
                textSizeHeights: [ 752, 748, 744, 738 ],
                zoomHeight: {
                    1.15: [ 752, 747, 744, 738 ],
                    1.25: [ 753, 748, 744, 738 ],
                    1.5: [ 752, 749, 744, 738 ],
                    1.75: [ 753, 747, 744, 739 ],
                    2: [ 752, 748, 744 ],
                    2.5: [ 753, 748 ],
                    3: [ 753, 744 ]
                },
                maybeSafari: {
                    2: [ 738 ],
                    2.5: [ 745, 738 ],
                    3: [ 747, 738 ]
                }
            },
            896: {
                device: "iPhone XS Max, iPhone 11 Pro Max, iPhone XR, iPhone 11",
                textSizeHeights: [ 721, 717, 713, 707 ],
                zoomHeight: {
                    1.15: [ 721, 716, 713, 707 ],
                    1.25: [ 721, 718, 713, 708 ],
                    1.5: [ 722, 717, 713 ],
                    1.75: [ 721, 718, 712, 707 ],
                    2: [ 722, 718, 714, 708 ],
                    2.5: [ 720, 718, 713, 708 ],
                    3: [ 720, 717, 708 ]
                },
                maybeSafari: {
                    1.5: [ 707 ],
                    3: [ 714 ]
                }
            },
            844: {
                device: "iPhone 12, iPhone 12 Pro",
                textSizeHeights: [ 670, 666, 662, 656 ],
                zoomHeight: {
                    1.15: [ 670, 666, 662 ],
                    1.25: [ 670, 666, 663, 656 ],
                    1.5: [ 671, 666, 662 ],
                    1.75: [ 670, 667, 662, 656 ],
                    2: [ 670, 666, 662 ],
                    2.5: [ 670, 663 ],
                    3: [ 669, 666, 663, 657 ]
                },
                maybeSafari: {
                    1.15: [ 656 ],
                    1.5: [ 656 ],
                    2: [ 656 ],
                    2.5: [ 665, 655 ],
                    3: [ 663 ]
                }
            },
            812: {
                device: "iPhone X, iPhone XS, iPhone 11 Pro, iPhone 12 Mini",
                textSizeHeights: [ 641, 637, 633, 627 ],
                zoomHeight: {
                    1.15: [ 641, 637, 633, 627 ],
                    1.25: [ 641, 638, 633, 628 ],
                    1.5: [ 641, 638, 633, 627 ],
                    1.75: [ 641, 637, 634 ],
                    2: [ 642, 638, 634, 628 ],
                    2.5: [ 640, 638, 633, 628 ],
                    3: [ 642, 633 ]
                },
                maybeSafari: {
                    1.75: [ 627 ],
                    3: [ 636, 627 ]
                }
            },
            736: {
                device: "iPhone 6 Plus, iPhone 6S Plus, iPhone 7 Plus, iPhone 8 Plus",
                textSizeHeights: [ 628, 624, 620, 614 ],
                zoomHeight: {
                    1.15: [ 628, 624, 620, 614 ],
                    1.25: [ 628, 624, 620, 614 ],
                    1.5: [ 629, 624, 620 ],
                    1.75: [ 628, 625, 620, 614 ],
                    2: [ 628, 624, 620 ],
                    2.5: [ 628, 625, 620, 615 ],
                    3: [ 627, 624, 615 ]
                },
                maybeSafari: {
                    1.5: [ 614 ],
                    2: [ 614 ],
                    3: [ 621 ]
                }
            },
            667: {
                device: "iPhone 6, iPhone 6S, iPhone 7, iPhone 8,  iPhone SE2",
                textSizeHeights: [ 559, 555, 551, 545 ],
                zoomHeight: {
                    1.15: [ 559, 555, 551, 545 ],
                    1.25: [ 559, 555, 551, 545 ],
                    1.5: [ 560, 555, 551 ],
                    1.75: [ 558, 555, 551 ],
                    2: [ 560, 556, 552, 546 ],
                    2.5: [ 560, 555, 550 ],
                    3: [ 558, 555, 546 ]
                },
                maybeSafari: {
                    1.5: [ 545 ],
                    1.75: [ 544 ],
                    2.5: [ 545 ],
                    3: [ 552 ]
                }
            }
        };
        function getUserAgent() {
            return window.navigator.mockUserAgent || window.navigator.userAgent;
        }
        function isDevice(userAgent) {
            void 0 === userAgent && (userAgent = getUserAgent());
            return !!userAgent.match(/Android|webOS|iPhone|iPad|iPod|bada|Symbian|Palm|CriOS|BlackBerry|IEMobile|WindowsMobile|Opera Mini/i);
        }
        function isOperaMini(ua) {
            void 0 === ua && (ua = getUserAgent());
            return /Opera Mini/i.test(ua);
        }
        function isAndroid(ua) {
            void 0 === ua && (ua = getUserAgent());
            return /Android/.test(ua);
        }
        function isIos(ua) {
            void 0 === ua && (ua = getUserAgent());
            return /iPhone|iPod|iPad/.test(ua);
        }
        function isSFVC(ua) {
            void 0 === ua && (ua = getUserAgent());
            if (isIos(ua)) {
                var device = iPhoneScreenHeightMatrix[window.outerHeight];
                if (!device) return !1;
                var height = window.innerHeight;
                var scale = Math.round(window.screen.width / window.innerWidth * 100) / 100;
                var computedHeight = Math.round(height * scale);
                return scale > 1 && device.zoomHeight[scale] ? -1 !== device.zoomHeight[scale].indexOf(computedHeight) : -1 !== device.textSizeHeights.indexOf(computedHeight);
            }
            return !1;
        }
        function device_isIE() {
            return !!window.document.documentMode || Boolean(window.navigator && window.navigator.userAgent && /Edge|MSIE|rv:11/i.test(window.navigator.userAgent));
        }
        function isIECompHeader() {
            var mHttp = window.document.querySelector('meta[http-equiv="X-UA-Compatible"]');
            var mContent = window.document.querySelector('meta[content="IE=edge"]');
            return !(!mHttp || !mContent);
        }
        function isIEIntranet() {
            if (window.document.documentMode) try {
                var status = window.status;
                window.status = "testIntranetMode";
                if ("testIntranetMode" === window.status) {
                    window.status = status;
                    return !0;
                }
                return !1;
            } catch (err) {
                return !1;
            }
            return !1;
        }
        function supportsPopups(ua) {
            void 0 === ua && (ua = getUserAgent());
            return !(function(ua) {
                void 0 === ua && (ua = getUserAgent());
                return !!isIos(ua) && (!!function(ua) {
                    void 0 === ua && (ua = getUserAgent());
                    return /\bGSA\b/.test(ua);
                }(ua) || /.+AppleWebKit(?!.*Safari)|.*WKWebView/.test(ua));
            }(ua) || function(ua) {
                void 0 === ua && (ua = getUserAgent());
                return !!isAndroid(ua) && /Version\/[\d.]+/.test(ua) && !isOperaMini(ua);
            }(ua) || isOperaMini(ua) || function(ua) {
                void 0 === ua && (ua = getUserAgent());
                return /FxiOS/i.test(ua);
            }(ua) || function(ua) {
                void 0 === ua && (ua = getUserAgent());
                return /EdgiOS/i.test(ua);
            }(ua) || function(ua) {
                void 0 === ua && (ua = getUserAgent());
                return /FBAN/.test(ua) || /FBAV/.test(ua);
            }(ua) || function(ua) {
                void 0 === ua && (ua = getUserAgent());
                return /QQBrowser/.test(ua);
            }(ua) || "undefined" != typeof process && process.versions && process.versions.electron || (userAgent = getUserAgent(), 
            /Macintosh.*AppleWebKit(?!.*Safari)/i.test(userAgent)) || !0 === window.navigator.standalone || window.matchMedia("(display-mode: standalone)").matches);
            var userAgent;
        }
        function isChrome(ua) {
            void 0 === ua && (ua = getUserAgent());
            return /Chrome|Chromium|CriOS/.test(ua);
        }
        function isSafari(ua) {
            void 0 === ua && (ua = getUserAgent());
            return /Safari/.test(ua) && !isChrome(ua);
        }
        __webpack_require__(21);
        __webpack_require__(13);
        var zalgo_promise_src = __webpack_require__(2);
        __webpack_require__(7);
        var cross_domain_safe_weakmap_src = __webpack_require__(18);
        __webpack_require__(24);
        __webpack_require__(30);
        function getFunctionName(fn) {
            return fn.name || fn.__name__ || fn.displayName || "anonymous";
        }
        function setFunctionName(fn, name) {
            try {
                delete fn.name;
                fn.name = name;
            } catch (err) {}
            fn.__name__ = fn.displayName = name;
            return fn;
        }
        function base64encode(str) {
            if ("function" == typeof btoa) return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (function(m, p1) {
                return String.fromCharCode(parseInt(p1, 16));
            }))).replace(/[=]/g, "");
            if ("undefined" != typeof Buffer) return Buffer.from(str, "utf8").toString("base64").replace(/[=]/g, "");
            throw new Error("Can not find window.btoa or Buffer");
        }
        function uniqueID() {
            var chars = "0123456789abcdef";
            return "uid_" + "xxxxxxxxxx".replace(/./g, (function() {
                return chars.charAt(Math.floor(Math.random() * chars.length));
            })) + "_" + base64encode((new Date).toISOString().slice(11, 19).replace("T", ".")).replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
        }
        var objectIDs;
        function serializeArgs(args) {
            try {
                return JSON.stringify([].slice.call(args), (function(subkey, val) {
                    return "function" == typeof val ? "memoize[" + function(obj) {
                        objectIDs = objectIDs || new cross_domain_safe_weakmap_src.a;
                        if (null == obj || "object" != typeof obj && "function" != typeof obj) throw new Error("Invalid object");
                        var uid = objectIDs.get(obj);
                        if (!uid) {
                            uid = typeof obj + ":" + uniqueID();
                            objectIDs.set(obj, uid);
                        }
                        return uid;
                    }(val) + "]" : val;
                }));
            } catch (err) {
                throw new Error("Arguments not serializable -- can not be used to memoize");
            }
        }
        function getEmptyObject() {
            return {};
        }
        var memoizeGlobalIndex = 0;
        var memoizeGlobalIndexValidFrom = 0;
        function memoize(method, options) {
            void 0 === options && (options = {});
            var _options$thisNamespac = options.thisNamespace, thisNamespace = void 0 !== _options$thisNamespac && _options$thisNamespac, cacheTime = options.time;
            var simpleCache;
            var thisCache;
            var memoizeIndex = memoizeGlobalIndex;
            memoizeGlobalIndex += 1;
            var memoizedFunction = function() {
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
                if (memoizeIndex < memoizeGlobalIndexValidFrom) {
                    simpleCache = null;
                    thisCache = null;
                    memoizeIndex = memoizeGlobalIndex;
                    memoizeGlobalIndex += 1;
                }
                var cache;
                cache = thisNamespace ? (thisCache = thisCache || new cross_domain_safe_weakmap_src.a).getOrSet(this, getEmptyObject) : simpleCache = simpleCache || {};
                var cacheKey = serializeArgs(args);
                var cacheResult = cache[cacheKey];
                if (cacheResult && cacheTime && Date.now() - cacheResult.time < cacheTime) {
                    delete cache[cacheKey];
                    cacheResult = null;
                }
                if (cacheResult) return cacheResult.value;
                var time = Date.now();
                var value = method.apply(this, arguments);
                cache[cacheKey] = {
                    time: time,
                    value: value
                };
                return value;
            };
            memoizedFunction.reset = function() {
                simpleCache = null;
                thisCache = null;
            };
            return setFunctionName(memoizedFunction, (options.name || getFunctionName(method)) + "::memoized");
        }
        memoize.clear = function() {
            memoizeGlobalIndexValidFrom = memoizeGlobalIndex;
        };
        function noop() {}
        function once(method) {
            var called = !1;
            return setFunctionName((function() {
                if (!called) {
                    called = !0;
                    return method.apply(this, arguments);
                }
            }), getFunctionName(method) + "::once");
        }
        function values(obj) {
            if (Object.values) return Object.values(obj);
            var result = [];
            for (var key in obj) obj.hasOwnProperty(key) && result.push(obj[key]);
            return result;
        }
        memoize(values);
        function identity(item) {
            return item;
        }
        function safeInterval(method, time) {
            var timeout;
            !function loop() {
                timeout = setTimeout((function() {
                    method();
                    loop();
                }), time);
            }();
            return {
                cancel: function() {
                    clearTimeout(timeout);
                }
            };
        }
        Error;
        function isDocumentReady() {
            return Boolean(document.body) && "complete" === document.readyState;
        }
        function isDocumentInteractive() {
            return Boolean(document.body) && "interactive" === document.readyState;
        }
        memoize((function() {
            return new zalgo_promise_src.a((function(resolve) {
                if (isDocumentReady() || isDocumentInteractive()) return resolve();
                var interval = setInterval((function() {
                    if (isDocumentReady() || isDocumentInteractive()) {
                        clearInterval(interval);
                        return resolve();
                    }
                }), 10);
            }));
        }));
        function isLocalStorageEnabled() {
            return function(method, logic, args) {
                void 0 === args && (args = []);
                var cache = method.__inline_memoize_cache__ = method.__inline_memoize_cache__ || {};
                var key = serializeArgs(args);
                return cache.hasOwnProperty(key) ? cache[key] : cache[key] = function() {
                    try {
                        if ("undefined" == typeof window) return !1;
                        if (window.localStorage) {
                            var value = Math.random().toString();
                            window.localStorage.setItem("__test__localStorage__", value);
                            var result = window.localStorage.getItem("__test__localStorage__");
                            window.localStorage.removeItem("__test__localStorage__");
                            if (value === result) return !0;
                        }
                    } catch (err) {}
                    return !1;
                }.apply(void 0, args);
            }(isLocalStorageEnabled);
        }
        function getElementSafe(id, doc) {
            void 0 === doc && (doc = document);
            return (element = id) instanceof window.Element || null !== element && "object" == typeof element && 1 === element.nodeType && "object" == typeof element.style && "object" == typeof element.ownerDocument ? id : "string" == typeof id ? doc.querySelector(id) : void 0;
            var element;
        }
        function onResize(el, handler, _temp) {
            var _ref2 = void 0 === _temp ? {} : _temp, _ref2$width = _ref2.width, width = void 0 === _ref2$width || _ref2$width, _ref2$height = _ref2.height, height = void 0 === _ref2$height || _ref2$height, _ref2$interval = _ref2.interval, interval = void 0 === _ref2$interval ? 100 : _ref2$interval, _ref2$win = _ref2.win, win = void 0 === _ref2$win ? window : _ref2$win;
            var currentWidth = el.offsetWidth;
            var currentHeight = el.offsetHeight;
            var canceled = !1;
            handler({
                width: currentWidth,
                height: currentHeight
            });
            var check = function() {
                if (!canceled && function(el) {
                    return Boolean(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
                }(el)) {
                    var newWidth = el.offsetWidth;
                    var newHeight = el.offsetHeight;
                    (width && newWidth !== currentWidth || height && newHeight !== currentHeight) && handler({
                        width: newWidth,
                        height: newHeight
                    });
                    currentWidth = newWidth;
                    currentHeight = newHeight;
                }
            };
            var observer;
            var timeout;
            win.addEventListener("resize", check);
            if (void 0 !== win.ResizeObserver) {
                (observer = new win.ResizeObserver(check)).observe(el);
                timeout = safeInterval(check, 10 * interval);
            } else if (void 0 !== win.MutationObserver) {
                (observer = new win.MutationObserver(check)).observe(el, {
                    attributes: !0,
                    childList: !0,
                    subtree: !0,
                    characterData: !1
                });
                timeout = safeInterval(check, 10 * interval);
            } else timeout = safeInterval(check, interval);
            return {
                cancel: function() {
                    canceled = !0;
                    observer.disconnect();
                    window.removeEventListener("resize", check);
                    timeout.cancel();
                }
            };
        }
        function isShadowElement(element) {
            for (;element.parentNode; ) element = element.parentNode;
            return "[object ShadowRoot]" === element.toString();
        }
        function insertShadowSlot(element) {
            var shadowHost = function(element) {
                var shadowRoot = function(element) {
                    for (;element.parentNode; ) element = element.parentNode;
                    if (isShadowElement(element)) return element;
                }(element);
                if (shadowRoot && shadowRoot.host) return shadowRoot.host;
            }(element);
            if (!shadowHost) throw new Error("Element is not in shadow dom");
            var slotName = "shadow-slot-" + uniqueID();
            var slot = document.createElement("slot");
            slot.setAttribute("name", slotName);
            element.appendChild(slot);
            var slotProvider = document.createElement("div");
            slotProvider.setAttribute("slot", slotName);
            shadowHost.appendChild(slotProvider);
            return isShadowElement(shadowHost) ? insertShadowSlot(slotProvider) : slotProvider;
        }
        var currentScript = "undefined" != typeof document ? document.currentScript : null;
        var getCurrentScript = memoize((function() {
            if (currentScript) return currentScript;
            if (currentScript = function() {
                try {
                    var stack = function() {
                        try {
                            throw new Error("_");
                        } catch (err) {
                            return err.stack || "";
                        }
                    }();
                    var stackDetails = /.*at [^(]*\((.*):(.+):(.+)\)$/gi.exec(stack);
                    var scriptLocation = stackDetails && stackDetails[1];
                    if (!scriptLocation) return;
                    for (var _i22 = 0, _Array$prototype$slic2 = [].slice.call(document.getElementsByTagName("script")).reverse(); _i22 < _Array$prototype$slic2.length; _i22++) {
                        var script = _Array$prototype$slic2[_i22];
                        if (script.src && script.src === scriptLocation) return script;
                    }
                } catch (err) {}
            }()) return currentScript;
            throw new Error("Can not determine current script");
        }));
        var currentUID = uniqueID();
        memoize((function() {
            var script;
            try {
                script = getCurrentScript();
            } catch (err) {
                return currentUID;
            }
            var uid = script.getAttribute("data-uid");
            if (uid && "string" == typeof uid) return uid;
            if ((uid = script.getAttribute("data-uid-auto")) && "string" == typeof uid) return uid;
            if (script.src) {
                var hashedString = function(str) {
                    var hash = "";
                    for (var i = 0; i < str.length; i++) {
                        var total = str[i].charCodeAt(0) * i;
                        str[i + 1] && (total += str[i + 1].charCodeAt(0) * (i - 1));
                        hash += String.fromCharCode(97 + Math.abs(total) % 26);
                    }
                    return hash;
                }(JSON.stringify({
                    src: script.src,
                    dataset: script.dataset
                }));
                uid = "uid_" + hashedString.slice(hashedString.length - 30);
            } else uid = uniqueID();
            script.setAttribute("data-uid-auto", uid);
            return uid;
        }));
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return BUTTON_CONFIG;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return BUTTON_RELATIVE_STYLE;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return BUTTON_STYLE;
        }));
        __webpack_require__.d(__webpack_exports__, "f", (function() {
            return labelToFunding;
        }));
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return fundingToDefaultLabel;
        }));
        __webpack_require__.d(__webpack_exports__, "e", (function() {
            return getButtonConfig;
        }));
        var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
        var _logoColors, _tagLineColors, _secondaryColors, _logoColors2, _secondaryColors2, _logoColors3, _secondaryColors3, _logoColors4, _secondaryColors4, _logoColors5, _secondaryColors5, _logoColors6, _secondaryColors6, _logoColors7, _secondaryColors7, _logoColors8, _secondaryColors8, _logoColors9, _secondaryColors9, _logoColors10, _secondaryColors10, _logoColors11, _secondaryColors11, _logoColors12, _secondaryColors12, _logoColors13, _secondaryColors13, _logoColors14, _secondaryColors14, _logoColors15, _secondaryColors15, _logoColors16, _secondaryColors16, _logoColors17, _secondaryColors17, _logoColors18, _secondaryColors18, _BUTTON_CONFIG, _FUNDING_TO_DEFAULT_L, _LABEL_TO_FUNDING, _BUTTON_STYLE;
        var BUTTON_CONFIG = ((_BUTTON_CONFIG = {})[_constants__WEBPACK_IMPORTED_MODULE_0__.s] = {
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE, _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            sizes: [ _constants__WEBPACK_IMPORTED_MODULE_0__.l.SMALL, _constants__WEBPACK_IMPORTED_MODULE_0__.l.MEDIUM, _constants__WEBPACK_IMPORTED_MODULE_0__.l.LARGE, _constants__WEBPACK_IMPORTED_MODULE_0__.l.RESPONSIVE ],
            shapes: [ _constants__WEBPACK_IMPORTED_MODULE_0__.k.PILL, _constants__WEBPACK_IMPORTED_MODULE_0__.k.RECT ],
            layouts: [ _constants__WEBPACK_IMPORTED_MODULE_0__.g.HORIZONTAL, _constants__WEBPACK_IMPORTED_MODULE_0__.g.VERTICAL ],
            logoColors: (_logoColors = {}, _logoColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLUE, 
            _logoColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLUE, 
            _logoColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLUE, 
            _logoColors),
            tagLineColors: (_tagLineColors = {}, _tagLineColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.n.BLUE, 
            _tagLineColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.n.BLUE, 
            _tagLineColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.n.BLUE, 
            _tagLineColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.n.BLACK, 
            _tagLineColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.n.BLUE, 
            _tagLineColors),
            secondaryColors: (_secondaryColors = {}, _secondaryColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE, 
            _secondaryColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE, 
            _secondaryColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors),
            tag: "{ content: safer_tag }",
            dualTag: "{ content: dual_tag|safer_tag }",
            defaultLocale: {
                country: "US",
                lang: "en"
            },
            defaultLabel: _constants__WEBPACK_IMPORTED_MODULE_0__.f.CHECKOUT,
            defaultVerticalLabel: _constants__WEBPACK_IMPORTED_MODULE_0__.f.PAYPAL,
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD,
            defaultSize: _constants__WEBPACK_IMPORTED_MODULE_0__.l.SMALL,
            defaultVerticalSize: _constants__WEBPACK_IMPORTED_MODULE_0__.l.MEDIUM,
            defaultShape: _constants__WEBPACK_IMPORTED_MODULE_0__.k.PILL,
            defaultLayout: _constants__WEBPACK_IMPORTED_MODULE_0__.g.HORIZONTAL,
            defaultBranding: !0,
            defaultVerticalBranding: !0,
            defaultFundingIcons: !1,
            defaultTagline: !0,
            defaultDual: "",
            minimumSize: _constants__WEBPACK_IMPORTED_MODULE_0__.l.TINY,
            minimumVerticalSize: _constants__WEBPACK_IMPORTED_MODULE_0__.l.MEDIUM,
            maximumSize: _constants__WEBPACK_IMPORTED_MODULE_0__.l.HUGE,
            maximumVerticalSize: _constants__WEBPACK_IMPORTED_MODULE_0__.l.HUGE,
            minHorizontalButtons: 1,
            minVerticalButtons: 1,
            maxHorizontalButtons: 2,
            maxVerticalButtons: 6,
            allowUnbranded: !1,
            allowFundingIcons: !0,
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.PAYPAL] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PP + " } { logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PAYPAL + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PP + " } { logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PAYPAL + " }",
            allowPrimary: !0,
            allowPrimaryVertical: !0,
            allowPrimaryHorizontal: !0,
            title: "" + _constants__WEBPACK_IMPORTED_MODULE_0__.w.PAYPAL
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.CHECKOUT] = {
            label: "{ content: checkout }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PP + " } { logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PAYPAL + " }",
            allowPrimary: !0,
            allowPrimaryVertical: !0,
            allowPrimaryHorizontal: !0
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.PAY] = {
            label: "{ content: pay }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PAYPAL + " }",
            allowPrimary: !0,
            allowPrimaryVertical: !0,
            allowPrimaryHorizontal: !0
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.BUYNOW] = {
            label: "{ content: buynow }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PP + " } { logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PAYPAL + " }",
            defaultBranding: void 0,
            allowPrimary: !0,
            allowPrimaryVertical: !0,
            allowPrimaryHorizontal: !0,
            allowUnbranded: !0
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.INSTALLMENT] = {
            label: function(style) {
                return "{ content: " + (style.installmentperiod ? "installment_period" : "installment") + " }";
            },
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PP + " } { logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PAYPAL + " }",
            allowPrimary: !0,
            allowPrimaryVertical: !0,
            allowPrimaryHorizontal: !0,
            allowSecondaryVertical: !1,
            allowSecondaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.CREDIT] = {
            label: function(_ref) {
                return _ref.locale.country === _constants__WEBPACK_IMPORTED_MODULE_0__.r.DE ? "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.CREDIT + " }" : "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PP + " } { logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PAYPAL + " } { logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.CREDIT + " }";
            },
            logoLabel: function(_ref2) {
                return _ref2.locale.country === _constants__WEBPACK_IMPORTED_MODULE_0__.r.DE ? "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.CREDIT + " }" : "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PP + " } { logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.PAYPAL + " } { logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.CREDIT + " }";
            },
            tag: "{ content: later_tag }",
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors2 = {}, _logoColors2[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors2[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors2[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLUE, 
            _logoColors2),
            secondaryColors: (_secondaryColors2 = {}, _secondaryColors2[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE, 
            _secondaryColors2[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE, 
            _secondaryColors2[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE, 
            _secondaryColors2[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors2[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors2),
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE,
            allowPrimary: !0,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1,
            allowFundingIcons: !1,
            title: "" + _constants__WEBPACK_IMPORTED_MODULE_0__.w.CREDIT
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.VENMO] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.VENMO + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.VENMO + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE, _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors3 = {}, _logoColors3[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors3[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLUE, 
            _logoColors3[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors3[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLUE, 
            _logoColors3),
            secondaryColors: (_secondaryColors3 = {}, _secondaryColors3[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE, 
            _secondaryColors3[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors3[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE, 
            _secondaryColors3[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors3[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors3[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors3),
            allowPrimary: !0,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !0
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.ITAU] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.ITAU + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.ITAU + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK ],
            logoColors: (_logoColors4 = {}, _logoColors4[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors4[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors4[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors4),
            secondaryColors: (_secondaryColors4 = {}, _secondaryColors4[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE, 
            _secondaryColors4[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE, 
            _secondaryColors4[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE, 
            _secondaryColors4[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors4[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE, 
            _secondaryColors4[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE, 
            _secondaryColors4),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !0
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.IDEAL] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.IDEAL + " } Online betalen",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.IDEAL + " } Online betalen",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors5 = {}, _logoColors5[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors5[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors5[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors5),
            secondaryColors: (_secondaryColors5 = {}, _secondaryColors5[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors5[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors5[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors5[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors5[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors5[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors5),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.ELV] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.ELV + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.ELV + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors6 = {}, _logoColors6[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors6[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors6[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors6),
            secondaryColors: (_secondaryColors6 = {}, _secondaryColors6[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors6[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors6[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors6[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors6[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors6[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors6),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.BANCONTACT] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.BANCONTACT + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.BANCONTACT + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors7 = {}, _logoColors7[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors7[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors7[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors7),
            secondaryColors: (_secondaryColors7 = {}, _secondaryColors7[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors7[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors7[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors7[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors7[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors7[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors7),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.GIROPAY] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.GIROPAY + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.GIROPAY + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors8 = {}, _logoColors8[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors8[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors8[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors8),
            secondaryColors: (_secondaryColors8 = {}, _secondaryColors8[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors8[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors8[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors8[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors8[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors8[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors8),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.SOFORT] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.SOFORT + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.SOFORT + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors9 = {}, _logoColors9[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors9[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors9[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors9),
            secondaryColors: (_secondaryColors9 = {}, _secondaryColors9[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors9[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors9[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors9[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors9[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors9[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors9),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.EPS] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.EPS + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.EPS + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors10 = {}, _logoColors10[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors10[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors10[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors10),
            secondaryColors: (_secondaryColors10 = {}, _secondaryColors10[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors10[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors10[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors10[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors10[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors10[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors10),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.MYBANK] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.MYBANK + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.MYBANK + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors11 = {}, _logoColors11[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors11[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors11[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors11),
            secondaryColors: (_secondaryColors11 = {}, _secondaryColors11[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors11[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors11[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors11[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors11[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors11[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors11),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.P24] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.P24 + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.P24 + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors12 = {}, _logoColors12[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors12[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors12[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors12),
            secondaryColors: (_secondaryColors12 = {}, _secondaryColors12[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors12[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors12[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors12[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors12[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors12[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors12),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.BLIK] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.BLIK + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.BLIK + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors13 = {}, _logoColors13[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors13[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors13[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors13),
            secondaryColors: (_secondaryColors13 = {}, _secondaryColors13[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors13[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors13[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors13[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors13[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors13[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors13),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.MAXIMA] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.MAXIMA + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.MAXIMA + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors14 = {}, _logoColors14[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors14[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors14[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors14),
            secondaryColors: (_secondaryColors14 = {}, _secondaryColors14[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors14[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors14[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors14[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors14[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors14[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors14),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.BOLETO] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.BOLETO + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.BOLETO + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors15 = {}, _logoColors15[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors15[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors15[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors15),
            secondaryColors: (_secondaryColors15 = {}, _secondaryColors15[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors15[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors15[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors15[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors15[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors15[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors15),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.OXXO] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.OXXO + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.OXXO + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors16 = {}, _logoColors16[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors16[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors16[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors16),
            secondaryColors: (_secondaryColors16 = {}, _secondaryColors16[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors16[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors16[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors16[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors16[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors16[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors16),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.MERCADOPAGO] = {
            label: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.MERCADOPAGO + " }",
            logoLabel: "{ logo: " + _constants__WEBPACK_IMPORTED_MODULE_0__.h.MERCADOPAGO + " }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE ],
            logoColors: (_logoColors17 = {}, _logoColors17[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors17[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.WHITE, 
            _logoColors17[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors17),
            secondaryColors: (_secondaryColors17 = {}, _secondaryColors17[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors17[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors17[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors17[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK, 
            _secondaryColors17[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER, 
            _secondaryColors17[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE, 
            _secondaryColors17),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1
        }, _BUTTON_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.f.CARD] = {
            label: "{ cards }",
            logoLabel: "{ cards }",
            defaultColor: _constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER,
            colors: [ _constants__WEBPACK_IMPORTED_MODULE_0__.e.TRANSPARENT ],
            logoColors: (_logoColors18 = {}, _logoColors18[_constants__WEBPACK_IMPORTED_MODULE_0__.e.TRANSPARENT] = _constants__WEBPACK_IMPORTED_MODULE_0__.i.BLACK, 
            _logoColors18),
            secondaryColors: (_secondaryColors18 = {}, _secondaryColors18[_constants__WEBPACK_IMPORTED_MODULE_0__.e.GOLD] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.TRANSPARENT, 
            _secondaryColors18[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.TRANSPARENT, 
            _secondaryColors18[_constants__WEBPACK_IMPORTED_MODULE_0__.e.SILVER] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.TRANSPARENT, 
            _secondaryColors18[_constants__WEBPACK_IMPORTED_MODULE_0__.e.BLACK] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.TRANSPARENT, 
            _secondaryColors18[_constants__WEBPACK_IMPORTED_MODULE_0__.e.DARKBLUE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.TRANSPARENT, 
            _secondaryColors18[_constants__WEBPACK_IMPORTED_MODULE_0__.e.WHITE] = _constants__WEBPACK_IMPORTED_MODULE_0__.e.TRANSPARENT, 
            _secondaryColors18),
            allowPrimary: !1,
            allowPrimaryVertical: !1,
            allowPrimaryHorizontal: !1,
            title: "" + _constants__WEBPACK_IMPORTED_MODULE_0__.w.CARD
        }, _BUTTON_CONFIG);
        var FUNDING_TO_DEFAULT_LABEL = ((_FUNDING_TO_DEFAULT_L = {})[_constants__WEBPACK_IMPORTED_MODULE_0__.v.PAYPAL] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.PAYPAL, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.VENMO] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.VENMO, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.ITAU] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.ITAU, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.CARD] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.CARD, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.CREDIT] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.CREDIT, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.IDEAL] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.IDEAL, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.ELV] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.ELV, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.BANCONTACT] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.BANCONTACT, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.GIROPAY] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.GIROPAY, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.SOFORT] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.SOFORT, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.EPS] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.EPS, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.P24] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.P24, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.MYBANK] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.MYBANK, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.BLIK] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.BLIK, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.MAXIMA] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.MAXIMA, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.BOLETO] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.BOLETO, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.OXXO] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.OXXO, 
        _FUNDING_TO_DEFAULT_L[_constants__WEBPACK_IMPORTED_MODULE_0__.v.MERCADOPAGO] = _constants__WEBPACK_IMPORTED_MODULE_0__.f.MERCADOPAGO, 
        _FUNDING_TO_DEFAULT_L);
        var LABEL_TO_FUNDING = ((_LABEL_TO_FUNDING = {})[_constants__WEBPACK_IMPORTED_MODULE_0__.f.PAYPAL] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.PAYPAL, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.CHECKOUT] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.PAYPAL, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.PAY] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.PAYPAL, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.BUYNOW] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.PAYPAL, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.INSTALLMENT] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.PAYPAL, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.CARD] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.CARD, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.CREDIT] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.CREDIT, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.VENMO] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.VENMO, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.ITAU] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.ITAU, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.IDEAL] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.IDEAL, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.BANCONTACT] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.BANCONTACT, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.GIROPAY] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.GIROPAY, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.EPS] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.EPS, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.SOFORT] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.SOFORT, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.P24] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.P24, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.MYBANK] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.MYBANK, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.BLIK] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.BLIK, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.MAXIMA] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.MAXIMA, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.BOLETO] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.BOLETO, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.OXXO] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.OXXO, 
        _LABEL_TO_FUNDING[_constants__WEBPACK_IMPORTED_MODULE_0__.f.MERCADOPAGO] = _constants__WEBPACK_IMPORTED_MODULE_0__.v.MERCADOPAGO, 
        _LABEL_TO_FUNDING);
        var BUTTON_RELATIVE_STYLE = {
            FUNDINGICONS: 100,
            TAGLINE: 50,
            VERTICAL_MARGIN: 30
        };
        var BUTTON_STYLE = ((_BUTTON_STYLE = {})[_constants__WEBPACK_IMPORTED_MODULE_0__.l.TINY] = {
            defaultWidth: 75,
            defaultHeight: 25,
            minWidth: 75,
            maxWidth: 150,
            minHeight: 25,
            maxHeight: 30,
            buttonTextMargin: .5,
            allowFunding: !0,
            allowTagline: !1,
            byPayPalHeight: 0
        }, _BUTTON_STYLE[_constants__WEBPACK_IMPORTED_MODULE_0__.l.SMALL] = {
            defaultWidth: 150,
            defaultHeight: 25,
            minWidth: 150,
            maxWidth: 200,
            minHeight: 25,
            maxHeight: 55,
            buttonTextMargin: .5,
            allowFunding: !0,
            allowTagline: !0,
            byPayPalHeight: 0
        }, _BUTTON_STYLE[_constants__WEBPACK_IMPORTED_MODULE_0__.l.MEDIUM] = {
            defaultWidth: 250,
            defaultHeight: 35,
            minWidth: 200,
            maxWidth: 300,
            minHeight: 35,
            maxHeight: 55,
            buttonTextMargin: 1,
            allowFunding: !0,
            allowTagline: !0,
            byPayPalHeight: 30
        }, _BUTTON_STYLE[_constants__WEBPACK_IMPORTED_MODULE_0__.l.LARGE] = {
            defaultWidth: 350,
            defaultHeight: 45,
            minWidth: 300,
            maxWidth: 500,
            minHeight: 30,
            maxHeight: 55,
            buttonTextMargin: 1,
            allowFunding: !0,
            allowTagline: !0,
            byPayPalHeight: 30
        }, _BUTTON_STYLE[_constants__WEBPACK_IMPORTED_MODULE_0__.l.HUGE] = {
            defaultWidth: 500,
            defaultHeight: 55,
            minWidth: 500,
            maxWidth: 750,
            minHeight: 40,
            maxHeight: 55,
            buttonTextMargin: 1.25,
            allowFunding: !0,
            allowTagline: !0,
            byPayPalHeight: 30
        }, _BUTTON_STYLE);
        function labelToFunding(label) {
            return label ? LABEL_TO_FUNDING[label] : _constants__WEBPACK_IMPORTED_MODULE_0__.v.PAYPAL;
        }
        function fundingToDefaultLabel(funding) {
            return FUNDING_TO_DEFAULT_LABEL[funding];
        }
        function getButtonConfig(label, key, def) {
            return function(conf, category, key, def) {
                var categoryConfig = conf[category];
                if (categoryConfig && categoryConfig.hasOwnProperty(key)) return categoryConfig[key];
                if (conf[_constants__WEBPACK_IMPORTED_MODULE_0__.s] && conf[_constants__WEBPACK_IMPORTED_MODULE_0__.s].hasOwnProperty(key)) return conf[_constants__WEBPACK_IMPORTED_MODULE_0__.s][key];
                if (arguments.length >= 4) return def;
                throw new Error("No value found for " + category + ":" + key);
            }(BUTTON_CONFIG, label, key, def);
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return _extends;
        }));
        function _extends() {
            return (_extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) ({}).hasOwnProperty.call(source, key) && (target[key] = source[key]);
                }
                return target;
            }).apply(this, arguments);
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "i", (function() {
            return memoize;
        }));
        __webpack_require__.d(__webpack_exports__, "g", (function() {
            return match;
        }));
        __webpack_require__.d(__webpack_exports__, "o", (function() {
            return safeJSON;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return eventEmitter;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return awaitKey;
        }));
        __webpack_require__.d(__webpack_exports__, "q", (function() {
            return stringifyError;
        }));
        __webpack_require__.d(__webpack_exports__, "r", (function() {
            return stringifyErrorMessage;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return domainMatches;
        }));
        __webpack_require__.d(__webpack_exports__, "l", (function() {
            return patchMethod;
        }));
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return extend;
        }));
        __webpack_require__.d(__webpack_exports__, "p", (function() {
            return sortBy;
        }));
        __webpack_require__.d(__webpack_exports__, "e", (function() {
            return identity;
        }));
        __webpack_require__.d(__webpack_exports__, "t", (function() {
            return values;
        }));
        __webpack_require__.d(__webpack_exports__, "m", (function() {
            return perc;
        }));
        __webpack_require__.d(__webpack_exports__, "h", (function() {
            return max;
        }));
        __webpack_require__.d(__webpack_exports__, "n", (function() {
            return regexMap;
        }));
        var zalgo_promise_src__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
        var belter_src__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11);
        __webpack_require__.d(__webpack_exports__, "j", (function() {
            return belter_src__WEBPACK_IMPORTED_MODULE_1__.q;
        }));
        __webpack_require__.d(__webpack_exports__, "k", (function() {
            return belter_src__WEBPACK_IMPORTED_MODULE_1__.s;
        }));
        __webpack_require__.d(__webpack_exports__, "s", (function() {
            return belter_src__WEBPACK_IMPORTED_MODULE_1__.u;
        }));
        __webpack_require__.d(__webpack_exports__, "f", (function() {
            return belter_src__WEBPACK_IMPORTED_MODULE_1__.m;
        }));
        var moduleGlobal = {};
        function getGlobal() {
            return "undefined" != typeof window || "undefined" != typeof window ? window : moduleGlobal;
        }
        function memoize(method, options) {
            void 0 === options && (options = {});
            var cache = {};
            return function() {
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
                var key;
                try {
                    key = JSON.stringify([].slice.call(arguments));
                } catch (err) {
                    throw new Error("Arguments not serializable -- can not be used to memoize");
                }
                var time = options.time;
                cache[key] && time && Date.now() - cache[key].time < time && delete cache[key];
                var glob = getGlobal();
                glob.__CACHE_START_TIME__ && cache[key] && cache[key].time < glob.__CACHE_START_TIME__ && delete cache[key];
                if (cache[key]) return cache[key].value;
                cache[key] = {
                    time: Date.now(),
                    value: method.apply(this, arguments)
                };
                return cache[key].value;
            };
        }
        function match(str, pattern) {
            var regmatch = str.match(pattern);
            if (regmatch) return regmatch[1];
        }
        function safeJSON(item) {
            return JSON.stringify(item, (function(key, val) {
                if ("function" == typeof val) return "<" + typeof val + ">";
                try {
                    JSON.stringify(val);
                } catch (err) {
                    return "<" + typeof val + ">";
                }
                return val;
            }));
        }
        function eventEmitter() {
            var listeners = [];
            return {
                listen: function(method) {
                    listeners.push(method);
                    return {
                        cancel: function() {
                            listeners.splice(listeners.indexOf(method), 1);
                        }
                    };
                },
                once: function(method) {
                    var listener = this.listen((function() {
                        method.apply(null, arguments);
                        listener.cancel();
                    }));
                },
                trigger: function() {
                    for (var _i2 = 0; _i2 < listeners.length; _i2++) {
                        var listener = listeners[_i2];
                        listener.apply(void 0, arguments);
                    }
                }
            };
        }
        function awaitKey(obj, key) {
            return new zalgo_promise_src__WEBPACK_IMPORTED_MODULE_0__.a((function(resolve) {
                var value = obj[key];
                if (value) return resolve(value);
                delete obj[key];
                Object.defineProperty(obj, key, {
                    configurable: !0,
                    set: function(item) {
                        (value = item) && resolve(value);
                    },
                    get: function() {
                        return value;
                    }
                });
            }));
        }
        function stringifyError(err, level) {
            void 0 === level && (level = 1);
            if (level >= 3) return "stringifyError stack overflow";
            try {
                if (!err) return "<unknown error: " + {}.toString.call(err) + ">";
                if ("string" == typeof err) return err;
                if (err instanceof Error) {
                    var stack = err && err.stack;
                    var message = err && err.message;
                    if (stack && message) return -1 !== stack.indexOf(message) ? stack : message + "\n" + stack;
                    if (stack) return stack;
                    if (message) return message;
                }
                return "function" == typeof err.toString ? err.toString() : {}.toString.call(err);
            } catch (newErr) {
                return "Error while stringifying error: " + stringifyError(newErr, level + 1);
            }
        }
        function stringifyErrorMessage(err) {
            var defaultMessage = "<unknown error: " + {}.toString.call(err) + ">";
            return err ? err instanceof Error ? err.message || defaultMessage : "string" == typeof err.message && err.message || defaultMessage : defaultMessage;
        }
        function domainMatches(hostname, domain) {
            var index = (hostname = hostname.split("://")[1]).indexOf(domain);
            return -1 !== index && hostname.slice(index) === domain;
        }
        function patchMethod(obj, name, handler) {
            var original = obj[name];
            obj[name] = function() {
                var _arguments = arguments, _this = this;
                return handler({
                    context: this,
                    args: [].slice.call(arguments),
                    original: original,
                    callOriginal: function() {
                        return original.apply(_this, _arguments);
                    }
                });
            };
        }
        function extend(obj, source) {
            if (!source) return obj;
            if (Object.assign) return Object.assign(obj, source);
            for (var _key2 in source) source.hasOwnProperty(_key2) && (obj[_key2] = source[_key2]);
            return obj;
        }
        function sortBy(arr, order) {
            return arr.sort((function(a, b) {
                return order.indexOf(a) - order.indexOf(b);
            }));
        }
        function identity(item) {
            return item;
        }
        function values(obj) {
            var result = [];
            for (var _key6 in obj) obj.hasOwnProperty(_key6) && result.push(obj[_key6]);
            return result;
        }
        function perc(pixels, percentage) {
            return Math.round(pixels * percentage / 100);
        }
        function max() {
            return Math.max.apply(Math, arguments);
        }
        function regexMap(str, regex, handler) {
            var results = [];
            str.replace(regex, (function() {
                results.push(handler.apply(null, arguments));
            }));
            return results;
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        __webpack_require__.d(__webpack_exports__, "request", (function() {
            return request;
        }));
        __webpack_require__.d(__webpack_exports__, "send", (function() {
            return _send;
        }));
        __webpack_require__.d(__webpack_exports__, "sendToParent", (function() {
            return sendToParent;
        }));
        __webpack_require__.d(__webpack_exports__, "client", (function() {
            return client;
        }));
        __webpack_require__.d(__webpack_exports__, "listen", (function() {
            return listen;
        }));
        __webpack_require__.d(__webpack_exports__, "on", (function() {
            return _on;
        }));
        __webpack_require__.d(__webpack_exports__, "once", (function() {
            return once;
        }));
        __webpack_require__.d(__webpack_exports__, "listener", (function() {
            return server_listener;
        }));
        __webpack_require__.d(__webpack_exports__, "CONFIG", (function() {
            return conf.a;
        }));
        __webpack_require__.d(__webpack_exports__, "CONSTANTS", (function() {
            return conf.b;
        }));
        __webpack_require__.d(__webpack_exports__, "disable", (function() {
            return disable;
        }));
        __webpack_require__.d(__webpack_exports__, "parent", (function() {
            return public_parent;
        }));
        __webpack_require__.d(__webpack_exports__, "cleanUpWindow", (function() {
            return cleanUpWindow;
        }));
        __webpack_require__.d(__webpack_exports__, "Promise", (function() {
            return zalgo_promise_src.a;
        }));
        __webpack_require__.d(__webpack_exports__, "bridge", (function() {
            return bridge;
        }));
        __webpack_require__.d(__webpack_exports__, "init", (function() {
            return init;
        }));
        var interface_namespaceObject = {};
        __webpack_require__.r(interface_namespaceObject);
        __webpack_require__.d(interface_namespaceObject, "request", (function() {
            return request;
        }));
        __webpack_require__.d(interface_namespaceObject, "send", (function() {
            return _send;
        }));
        __webpack_require__.d(interface_namespaceObject, "sendToParent", (function() {
            return sendToParent;
        }));
        __webpack_require__.d(interface_namespaceObject, "client", (function() {
            return client;
        }));
        __webpack_require__.d(interface_namespaceObject, "listen", (function() {
            return listen;
        }));
        __webpack_require__.d(interface_namespaceObject, "on", (function() {
            return _on;
        }));
        __webpack_require__.d(interface_namespaceObject, "once", (function() {
            return once;
        }));
        __webpack_require__.d(interface_namespaceObject, "listener", (function() {
            return server_listener;
        }));
        __webpack_require__.d(interface_namespaceObject, "CONFIG", (function() {
            return conf.a;
        }));
        __webpack_require__.d(interface_namespaceObject, "CONSTANTS", (function() {
            return conf.b;
        }));
        __webpack_require__.d(interface_namespaceObject, "disable", (function() {
            return disable;
        }));
        __webpack_require__.d(interface_namespaceObject, "parent", (function() {
            return public_parent;
        }));
        __webpack_require__.d(interface_namespaceObject, "cleanUpWindow", (function() {
            return cleanUpWindow;
        }));
        __webpack_require__.d(interface_namespaceObject, "Promise", (function() {
            return zalgo_promise_src.a;
        }));
        __webpack_require__.d(interface_namespaceObject, "bridge", (function() {
            return bridge;
        }));
        __webpack_require__.d(interface_namespaceObject, "init", (function() {
            return init;
        }));
        var lib = __webpack_require__(16);
        var src = __webpack_require__(7);
        var conf = __webpack_require__(10);
        var global = __webpack_require__(9);
        var esm_extends = __webpack_require__(13);
        var zalgo_promise_src = __webpack_require__(2);
        var SEND_MESSAGE_STRATEGIES = {};
        SEND_MESSAGE_STRATEGIES[conf.b.SEND_STRATEGIES.POST_MESSAGE] = function(win, serializedMessage, domain) {
            try {
                __webpack_require__(43).emulateIERestrictions(window, win);
            } catch (err) {
                return;
            }
            (Array.isArray(domain) ? domain : "string" == typeof domain ? [ domain ] : [ conf.b.WILDCARD ]).map((function(dom) {
                if (0 === dom.indexOf(conf.b.MOCK_PROTOCOL)) {
                    if (window.location.protocol === conf.b.FILE_PROTOCOL) return conf.b.WILDCARD;
                    if (!Object(src.q)(win)) throw new Error("Attempting to send messsage to mock domain " + dom + ", but window is actually cross-domain");
                    return Object(src.d)(win);
                }
                return 0 === dom.indexOf(conf.b.FILE_PROTOCOL) ? conf.b.WILDCARD : dom;
            })).forEach((function(dom) {
                return win.postMessage(serializedMessage, dom);
            }));
        };
        var _require = __webpack_require__(23), sendBridgeMessage = _require.sendBridgeMessage, needsBridgeForBrowser = _require.needsBridgeForBrowser, isBridge = _require.isBridge;
        SEND_MESSAGE_STRATEGIES[conf.b.SEND_STRATEGIES.BRIDGE] = function(win, serializedMessage, domain) {
            if (needsBridgeForBrowser() || isBridge()) {
                if (Object(src.v)(win)) throw new Error("Post message through bridge disabled between same domain windows");
                if (!1 !== Object(src.w)(window, win)) throw new Error("Can only use bridge to communicate between two different windows, not between frames");
                return sendBridgeMessage(win, serializedMessage, domain);
            }
        };
        SEND_MESSAGE_STRATEGIES[conf.b.SEND_STRATEGIES.GLOBAL] = function(win, serializedMessage) {
            if (Object(lib.i)()) {
                if (!Object(src.v)(win)) throw new Error("Post message through global disabled between different domain windows");
                if (!1 !== Object(src.w)(window, win)) throw new Error("Can only use global to communicate between two different windows, not between frames");
                var foreignGlobal = win[conf.b.WINDOW_PROPS.POSTROBOT];
                if (!foreignGlobal) throw new Error("Can not find postRobot global on foreign window");
                return foreignGlobal.receiveMessage({
                    source: window,
                    origin: Object(src.h)(),
                    data: serializedMessage
                });
            }
        };
        function sendMessage(win, message, domain) {
            return zalgo_promise_src.a.try((function() {
                var _jsonStringify;
                message = function(win, message, options) {
                    void 0 === options && (options = {});
                    var id = Object(lib.q)();
                    var type = Object(lib.c)();
                    var sourceDomain = Object(src.h)(window);
                    return Object(esm_extends.a)({}, message, options, {
                        sourceDomain: sourceDomain,
                        id: message.id || id,
                        windowType: type
                    });
                }(0, message, {
                    data: Object(lib.o)(win, domain, message.data),
                    domain: domain
                });
                if (win === window && !conf.a.ALLOW_SAME_ORIGIN) throw new Error("Attemping to send message to self");
                if (Object(src.z)(win)) throw new Error("Window is closed");
                var messages = [];
                var serializedMessage = Object(lib.g)(((_jsonStringify = {})[conf.b.WINDOW_PROPS.POSTROBOT] = message, 
                _jsonStringify), null, 2);
                return zalgo_promise_src.a.map(Object.keys(SEND_MESSAGE_STRATEGIES), (function(strategyName) {
                    return zalgo_promise_src.a.try((function() {
                        if (!conf.a.ALLOWED_POST_MESSAGE_METHODS[strategyName]) throw new Error("Strategy disallowed: " + strategyName);
                        return SEND_MESSAGE_STRATEGIES[strategyName](win, serializedMessage, domain);
                    })).then((function() {
                        messages.push(strategyName + ": success");
                        return !0;
                    }), (function(err) {
                        messages.push(strategyName + ": " + Object(lib.p)(err) + "\n");
                        return !1;
                    }));
                })).then((function(results) {
                    var success = results.some(Boolean);
                    var status = message.type + " " + message.name + " " + (success ? "success" : "error") + ":\n  - " + messages.join("\n  - ") + "\n";
                    if (!success) throw new Error(status);
                }));
            }));
        }
        var cross_domain_safe_weakmap_src = __webpack_require__(18);
        global.a.responseListeners = global.a.responseListeners || {};
        global.a.requestListeners = global.a.requestListeners || {};
        global.a.WINDOW_WILDCARD = global.a.WINDOW_WILDCARD || new function() {};
        global.a.erroredResponseListeners = global.a.erroredResponseListeners || {};
        function getResponseListener(hash) {
            return global.a.responseListeners[hash];
        }
        function deleteResponseListener(hash) {
            delete global.a.responseListeners[hash];
        }
        function isResponseListenerErrored(hash) {
            return Boolean(global.a.erroredResponseListeners[hash]);
        }
        function getRequestListener(_ref) {
            var name = _ref.name, win = _ref.win, domain = _ref.domain;
            win === conf.b.WILDCARD && (win = null);
            domain === conf.b.WILDCARD && (domain = null);
            if (!name) throw new Error("Name required to get request listener");
            var nameListeners = global.a.requestListeners[name];
            if (nameListeners) for (var _i2 = 0, _ref3 = [ win, global.a.WINDOW_WILDCARD ]; _i2 < _ref3.length; _i2++) {
                var winQualifier = _ref3[_i2];
                var winListeners = winQualifier && nameListeners.get(winQualifier);
                if (winListeners) {
                    if (domain && "string" == typeof domain) {
                        if (winListeners[domain]) return winListeners[domain];
                        if (winListeners.__domain_regex__) for (var _i4 = 0, _winListeners$__DOMAI2 = winListeners.__domain_regex__; _i4 < _winListeners$__DOMAI2.length; _i4++) {
                            var _winListeners$__DOMAI3 = _winListeners$__DOMAI2[_i4], regex = _winListeners$__DOMAI3.regex, listener = _winListeners$__DOMAI3.listener;
                            if (Object(src.B)(regex, domain)) return listener;
                        }
                    }
                    if (winListeners[conf.b.WILDCARD]) return winListeners[conf.b.WILDCARD];
                }
            }
        }
        var _RECEIVE_MESSAGE_TYPE;
        var RECEIVE_MESSAGE_TYPES = ((_RECEIVE_MESSAGE_TYPE = {})[conf.b.POST_MESSAGE_TYPE.ACK] = function(source, origin, message) {
            if (!isResponseListenerErrored(message.hash)) {
                var options = getResponseListener(message.hash);
                if (!options) throw new Error("No handler found for post message ack for message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                if (!Object(src.B)(options.domain, origin)) throw new Error("Ack origin " + origin + " does not match domain " + options.domain.toString());
                options.ack = !0;
            }
        }, _RECEIVE_MESSAGE_TYPE[conf.b.POST_MESSAGE_TYPE.REQUEST] = function(source, origin, message) {
            var options = getRequestListener({
                name: message.name,
                win: source,
                domain: origin
            });
            function respond(data) {
                return message.fireAndForget || Object(src.z)(source) ? zalgo_promise_src.a.resolve() : sendMessage(source, Object(esm_extends.a)({
                    target: message.originalSource,
                    hash: message.hash,
                    name: message.name
                }, data), origin);
            }
            return zalgo_promise_src.a.all([ respond({
                type: conf.b.POST_MESSAGE_TYPE.ACK
            }), zalgo_promise_src.a.try((function() {
                if (!options) throw new Error("No handler found for post message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                if (!Object(src.B)(options.domain, origin)) throw new Error("Request origin " + origin + " does not match domain " + options.domain.toString());
                return options.handler({
                    source: source,
                    origin: origin,
                    data: message.data
                });
            })).then((function(data) {
                return respond({
                    type: conf.b.POST_MESSAGE_TYPE.RESPONSE,
                    ack: conf.b.POST_MESSAGE_ACK.SUCCESS,
                    data: data
                });
            }), (function(err) {
                var error = Object(lib.p)(err).replace(/^Error: /, "");
                return respond({
                    type: conf.b.POST_MESSAGE_TYPE.RESPONSE,
                    ack: conf.b.POST_MESSAGE_ACK.ERROR,
                    error: error,
                    code: err.code
                });
            })) ]).then(lib.j).catch((function(err) {
                if (options && options.handleError) return options.handleError(err);
                throw err;
            }));
        }, _RECEIVE_MESSAGE_TYPE[conf.b.POST_MESSAGE_TYPE.RESPONSE] = function(source, origin, message) {
            if (!isResponseListenerErrored(message.hash)) {
                var options = getResponseListener(message.hash);
                if (!options) throw new Error("No handler found for post message response for message: " + message.name + " from " + origin + " in " + window.location.protocol + "//" + window.location.host + window.location.pathname);
                if (!Object(src.B)(options.domain, origin)) throw new Error("Response origin " + origin + " does not match domain " + Object(src.D)(options.domain));
                deleteResponseListener(message.hash);
                if (message.ack === conf.b.POST_MESSAGE_ACK.ERROR) {
                    var err = new Error(message.error);
                    message.code && (err.code = message.code);
                    return options.respond(err, null);
                }
                if (message.ack === conf.b.POST_MESSAGE_ACK.SUCCESS) return options.respond(null, {
                    source: source,
                    origin: origin,
                    data: message.data || message.response
                });
            }
        }, _RECEIVE_MESSAGE_TYPE);
        global.a.receivedMessages = global.a.receivedMessages || [];
        function receiveMessage(event) {
            if (window && !window.closed) {
                try {
                    if (!event.source) return;
                } catch (err) {
                    return;
                }
                var source = event.source, origin = event.origin;
                var message = function(message) {
                    var parsedMessage;
                    try {
                        parsedMessage = Object(lib.f)(message);
                    } catch (err) {
                        return;
                    }
                    if (parsedMessage && "object" == typeof parsedMessage && null !== parsedMessage && (parsedMessage = parsedMessage[conf.b.WINDOW_PROPS.POSTROBOT]) && "object" == typeof parsedMessage && null !== parsedMessage && parsedMessage.type && "string" == typeof parsedMessage.type && RECEIVE_MESSAGE_TYPES[parsedMessage.type]) return parsedMessage;
                }(event.data);
                if (message) {
                    if (!message.sourceDomain || "string" != typeof message.sourceDomain) throw new Error("Expected message to have sourceDomain");
                    0 !== message.sourceDomain.indexOf(conf.b.MOCK_PROTOCOL) && 0 !== message.sourceDomain.indexOf(conf.b.FILE_PROTOCOL) || (origin = message.sourceDomain);
                    if (-1 === global.a.receivedMessages.indexOf(message.id)) {
                        global.a.receivedMessages.push(message.id);
                        if (!Object(src.z)(source) || message.fireAndForget) {
                            message.data && (message.data = Object(lib.b)(source, origin, message.data));
                            RECEIVE_MESSAGE_TYPES[message.type](source, origin, message);
                        }
                    }
                }
            }
        }
        function messageListener(event) {
            try {
                Object(lib.j)(event.source);
            } catch (err) {
                return;
            }
            var messageEvent = {
                source: event.source || event.sourceElement,
                origin: event.origin || event.originalEvent && event.originalEvent.origin,
                data: event.data
            };
            try {
                __webpack_require__(43).emulateIERestrictions(messageEvent.source, window);
            } catch (err) {
                return;
            }
            receiveMessage(messageEvent);
        }
        global.a.receiveMessage = receiveMessage;
        global.a.requestPromises = global.a.requestPromises || new cross_domain_safe_weakmap_src.a;
        function request(options) {
            return zalgo_promise_src.a.try((function() {
                if (!options.name) throw new Error("Expected options.name");
                var name = options.name;
                var targetWindow;
                var domain;
                if ("string" == typeof options.window) {
                    var el = document.getElementById(options.window);
                    if (!el) throw new Error("Expected options.window " + {}.toString.call(options.window) + " to be a valid element id");
                    if ("iframe" !== el.tagName.toLowerCase()) throw new Error("Expected options.window " + {}.toString.call(options.window) + " to be an iframe");
                    if (!el.contentWindow) throw new Error("Iframe must have contentWindow.  Make sure it has a src attribute and is in the DOM.");
                    targetWindow = el.contentWindow;
                } else if (options.window instanceof HTMLIFrameElement) {
                    if ("iframe" !== options.window.tagName.toLowerCase()) throw new Error("Expected options.window " + {}.toString.call(options.window) + " to be an iframe");
                    if (options.window && !options.window.contentWindow) throw new Error("Iframe must have contentWindow.  Make sure it has a src attribute and is in the DOM.");
                    options.window && options.window.contentWindow && (targetWindow = options.window.contentWindow);
                } else targetWindow = options.window;
                if (!targetWindow) throw new Error("Expected options.window to be a window object, iframe, or iframe element id.");
                var win = targetWindow;
                domain = options.domain || conf.b.WILDCARD;
                var hash = options.name + "_" + Object(lib.q)();
                if (Object(src.z)(win)) throw new Error("Target window is closed");
                var hasResult = !1;
                var requestPromises = global.a.requestPromises.get(win);
                requestPromises || global.a.requestPromises.set(win, requestPromises = []);
                var requestPromise = zalgo_promise_src.a.try((function() {
                    if (Object(src.r)(window, win)) return Object(lib.k)(win, options.timeout || conf.a.CHILD_WINDOW_TIMEOUT);
                })).then((function(_temp) {
                    var origin = (void 0 === _temp ? {} : _temp).origin;
                    if (Object(lib.e)(domain) && !origin) return Object(lib.n)(win);
                })).then((function(_temp2) {
                    var origin = (void 0 === _temp2 ? {} : _temp2).origin;
                    if (Object(lib.e)(domain)) {
                        if (!Object(src.B)(domain, origin)) throw new Error("Remote window domain " + origin + " does not match regex: " + domain.toString());
                        domain = origin;
                    }
                    if ("string" != typeof domain && !Array.isArray(domain)) throw new TypeError("Expected domain to be a string or array");
                    var actualDomain = domain;
                    return new zalgo_promise_src.a((function(resolve, reject) {
                        var responseListener;
                        options.fireAndForget || function(hash, listener) {
                            global.a.responseListeners[hash] = listener;
                        }(hash, responseListener = {
                            name: name,
                            window: win,
                            domain: actualDomain,
                            respond: function(err, result) {
                                if (!err) {
                                    hasResult = !0;
                                    requestPromises.splice(requestPromises.indexOf(requestPromise, 1));
                                }
                                err ? reject(err) : resolve(result);
                            }
                        });
                        sendMessage(win, {
                            type: conf.b.POST_MESSAGE_TYPE.REQUEST,
                            hash: hash,
                            name: name,
                            data: options.data,
                            fireAndForget: options.fireAndForget
                        }, actualDomain).catch(reject);
                        if (options.fireAndForget) return resolve();
                        var ackTimeout = conf.a.ACK_TIMEOUT;
                        var resTimeout = options.timeout || conf.a.RES_TIMEOUT;
                        var cycleTime = 100;
                        setTimeout((function cycle() {
                            if (!hasResult) {
                                if (Object(src.z)(win)) return reject(responseListener.ack ? new Error("Window closed for " + name + " before response") : new Error("Window closed for " + name + " before ack"));
                                ackTimeout = Math.max(ackTimeout - cycleTime, 0);
                                -1 !== resTimeout && (resTimeout = Math.max(resTimeout - cycleTime, 0));
                                if (responseListener.ack) {
                                    if (-1 === resTimeout) return;
                                    cycleTime = Math.min(resTimeout, 2e3);
                                } else {
                                    if (0 === ackTimeout) return reject(new Error("No ack for postMessage " + name + " in " + Object(src.h)() + " in " + conf.a.ACK_TIMEOUT + "ms"));
                                    if (0 === resTimeout) return reject(new Error("No response for postMessage " + name + " in " + Object(src.h)() + " in " + (options.timeout || conf.a.RES_TIMEOUT) + "ms"));
                                }
                                setTimeout(cycle, cycleTime);
                            }
                        }), cycleTime);
                    }));
                }));
                requestPromise.catch((function() {
                    !function(hash) {
                        global.a.erroredResponseListeners[hash] = !0;
                    }(hash);
                    deleteResponseListener(hash);
                }));
                requestPromises.push(requestPromise);
                return requestPromise;
            }));
        }
        function _send(window, name, data, options) {
            (options = options || {}).window = window;
            options.name = name;
            options.data = data;
            return request(options);
        }
        function sendToParent(name, data, options) {
            var win = Object(src.f)();
            return win ? _send(win, name, data, options) : new zalgo_promise_src.a((function(resolve, reject) {
                return reject(new Error("Window does not have a parent"));
            }));
        }
        function client(options) {
            void 0 === options && (options = {});
            if (!options.window) throw new Error("Expected options.window");
            var win = options.window;
            return {
                send: function(name, data) {
                    return _send(win, name, data, options);
                }
            };
        }
        global.a.send = _send;
        function listen(options) {
            if (!options.name) throw new Error("Expected options.name");
            if (!options.handler) throw new Error("Expected options.handler");
            var name = options.name;
            var win = options.window;
            var domain = options.domain;
            var listenerOptions = {
                handler: options.handler,
                handleError: options.errorHandler || function(err) {
                    throw err;
                },
                window: win,
                domain: domain || conf.b.WILDCARD,
                name: name
            };
            var requestListener = function addRequestListener(_ref4, listener) {
                var name = _ref4.name, win = _ref4.win, domain = _ref4.domain;
                if (!name || "string" != typeof name) throw new Error("Name required to add request listener");
                if (Array.isArray(win)) {
                    var listenersCollection = [];
                    for (var _i6 = 0, _win2 = win; _i6 < _win2.length; _i6++) listenersCollection.push(addRequestListener({
                        name: name,
                        domain: domain,
                        win: _win2[_i6]
                    }, listener));
                    return {
                        cancel: function() {
                            for (var _i8 = 0; _i8 < listenersCollection.length; _i8++) listenersCollection[_i8].cancel();
                        }
                    };
                }
                if (Array.isArray(domain)) {
                    var _listenersCollection = [];
                    for (var _i10 = 0, _domain2 = domain; _i10 < _domain2.length; _i10++) _listenersCollection.push(addRequestListener({
                        name: name,
                        win: win,
                        domain: _domain2[_i10]
                    }, listener));
                    return {
                        cancel: function() {
                            for (var _i12 = 0; _i12 < _listenersCollection.length; _i12++) _listenersCollection[_i12].cancel();
                        }
                    };
                }
                var existingListener = getRequestListener({
                    name: name,
                    win: win,
                    domain: domain
                });
                win && win !== conf.b.WILDCARD || (win = global.a.WINDOW_WILDCARD);
                domain = domain || conf.b.WILDCARD;
                if (existingListener) throw win && domain ? new Error("Request listener already exists for " + name + " on domain " + domain.toString() + " for " + (win === global.a.WINDOW_WILDCARD ? "wildcard" : "specified") + " window") : win ? new Error("Request listener already exists for " + name + " for " + (win === global.a.WINDOW_WILDCARD ? "wildcard" : "specified") + " window") : domain ? new Error("Request listener already exists for " + name + " on domain " + domain.toString()) : new Error("Request listener already exists for " + name);
                var requestListeners = global.a.requestListeners;
                var nameListeners = requestListeners[name];
                if (!nameListeners) {
                    nameListeners = new cross_domain_safe_weakmap_src.a;
                    requestListeners[name] = nameListeners;
                }
                var winListeners = nameListeners.get(win);
                winListeners || nameListeners.set(win, winListeners = {});
                var strDomain = domain.toString();
                var regexListeners = winListeners.__domain_regex__;
                var regexListener;
                if (Object(lib.e)(domain)) {
                    regexListeners || (winListeners.__domain_regex__ = regexListeners = []);
                    regexListeners.push(regexListener = {
                        regex: domain,
                        listener: listener
                    });
                } else winListeners[strDomain] = listener;
                return {
                    cancel: function() {
                        if (winListeners) {
                            delete winListeners[strDomain];
                            win && 0 === Object.keys(winListeners).length && nameListeners.delete(win);
                            regexListener && regexListeners.splice(regexListeners.indexOf(regexListener, 1));
                        }
                    }
                };
            }({
                name: name,
                win: win,
                domain: domain
            }, listenerOptions);
            if (options.once) {
                var _handler = listenerOptions.handler;
                listenerOptions.handler = Object(lib.l)((function() {
                    requestListener.cancel();
                    return _handler.apply(this, arguments);
                }));
            }
            if (listenerOptions.window && options.errorOnClose) var interval = Object(lib.m)((function() {
                if (win && "object" == typeof win && Object(src.z)(win)) {
                    interval.cancel();
                    listenerOptions.handleError(new Error("Post message target window is closed"));
                }
            }), 50);
            return {
                cancel: function() {
                    requestListener.cancel();
                }
            };
        }
        function _on(name, options, handler) {
            if ("function" == typeof options) {
                handler = options;
                options = {};
            }
            (options = options || {}).name = name;
            options.handler = handler || options.handler;
            return listen(options);
        }
        function once(name, options, handler) {
            void 0 === options && (options = {});
            if ("function" == typeof options) {
                handler = options;
                options = {};
            }
            options = options || {};
            handler = handler || options.handler;
            var errorHandler = options.errorHandler;
            var promise = new zalgo_promise_src.a((function(resolve, reject) {
                (options = options || {}).name = name;
                options.once = !0;
                options.handler = function(event) {
                    resolve(event);
                    if (handler) return handler(event);
                };
                options.errorHandler = function(err) {
                    reject(err);
                    if (errorHandler) return errorHandler(err);
                };
            }));
            var onceListener = listen(options);
            promise.cancel = onceListener.cancel;
            return promise;
        }
        function server_listener(options) {
            void 0 === options && (options = {});
            return {
                on: function(name, handler) {
                    return _on(name, options, handler);
                }
            };
        }
        global.a.on = _on;
        function disable() {
            delete window[conf.b.WINDOW_PROPS.POSTROBOT];
            window.removeEventListener("message", messageListener);
        }
        var public_parent = Object(src.f)();
        function cleanUpWindow(win) {
            var requestPromises = global.a.requestPromises.get(win);
            if (requestPromises) for (var _i2 = 0; _i2 < requestPromises.length; _i2++) requestPromises[_i2].reject(new Error("No response from window - cleaned up"));
            global.a.popupWindowsByWin && global.a.popupWindowsByWin.delete(win);
            global.a.remoteWindows && global.a.remoteWindows.delete(win);
            global.a.requestPromises.delete(win);
            global.a.methods.delete(win);
            global.a.readyPromises.delete(win);
        }
        var bridge = __webpack_require__(45);
        function init() {
            if (!global.a.initialized) {
                Object(lib.a)(window, "message", messageListener);
                __webpack_require__(23).openTunnelToOpener();
                Object(lib.d)();
                Object(lib.h)({
                    on: _on,
                    send: _send
                });
            }
            global.a.initialized = !0;
        }
        init();
        __webpack_exports__.default = interface_namespaceObject;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "p", (function() {
            return stringifyError;
        }));
        __webpack_require__.d(__webpack_exports__, "l", (function() {
            return once;
        }));
        __webpack_require__.d(__webpack_exports__, "j", (function() {
            return noop;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return addEventListener;
        }));
        __webpack_require__.d(__webpack_exports__, "q", (function() {
            return uniqueID;
        }));
        __webpack_require__.d(__webpack_exports__, "m", (function() {
            return safeInterval;
        }));
        __webpack_require__.d(__webpack_exports__, "e", (function() {
            return isRegex;
        }));
        __webpack_require__.d(__webpack_exports__, "r", (function() {
            return util_weakMapMemoize;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return getWindowType;
        }));
        __webpack_require__.d(__webpack_exports__, "g", (function() {
            return jsonStringify;
        }));
        __webpack_require__.d(__webpack_exports__, "f", (function() {
            return jsonParse;
        }));
        __webpack_require__.d(__webpack_exports__, "i", (function() {
            return needsGlobalMessagingForBrowser;
        }));
        __webpack_require__.d(__webpack_exports__, "h", (function() {
            return listenForMethods;
        }));
        __webpack_require__.d(__webpack_exports__, "o", (function() {
            return serializeMethods;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return deserializeMethods;
        }));
        __webpack_require__.d(__webpack_exports__, "n", (function() {
            return sayHello;
        }));
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return initOnReady;
        }));
        __webpack_require__.d(__webpack_exports__, "k", (function() {
            return onChildWindowReady;
        }));
        var src = __webpack_require__(18);
        var cross_domain_utils_src = __webpack_require__(7);
        var conf = __webpack_require__(10);
        function stringifyError(err, level) {
            void 0 === level && (level = 1);
            if (level >= 3) return "stringifyError stack overflow";
            try {
                if (!err) return "<unknown error: " + {}.toString.call(err) + ">";
                if ("string" == typeof err) return err;
                if (err instanceof Error) {
                    var stack = err && err.stack;
                    var message = err && err.message;
                    if (stack && message) return -1 !== stack.indexOf(message) ? stack : message + "\n" + stack;
                    if (stack) return stack;
                    if (message) return message;
                }
                return "function" == typeof err.toString ? err.toString() : {}.toString.call(err);
            } catch (newErr) {
                return "Error while stringifying error: " + stringifyError(newErr, level + 1);
            }
        }
        var once = function(method) {
            if (!method) return method;
            var called = !1;
            return function() {
                if (!called) {
                    called = !0;
                    return method.apply(this, arguments);
                }
            };
        };
        function noop() {}
        function addEventListener(obj, event, handler) {
            obj.addEventListener ? obj.addEventListener(event, handler) : obj.attachEvent("on" + event, handler);
            return {
                cancel: function() {
                    obj.removeEventListener ? obj.removeEventListener(event, handler) : obj.detachEvent("on" + event, handler);
                }
            };
        }
        function uniqueID() {
            var chars = "0123456789abcdef";
            return "xxxxxxxxxx".replace(/./g, (function() {
                return chars.charAt(Math.floor(Math.random() * chars.length));
            }));
        }
        function replaceObject(item, callback, depth) {
            void 0 === depth && (depth = 1);
            if (depth >= 100) throw new Error("Self-referential object passed, or object contained too many layers");
            var newobj;
            if ("object" != typeof item || null === item || Array.isArray(item)) {
                if (!Array.isArray(item)) throw new TypeError("Invalid type: " + typeof item);
                newobj = [];
            } else newobj = {};
            !function(item, callback) {
                Array.isArray(item) ? function(item, callback) {
                    for (var i = 0; i < item.length; i++) callback(item[i], i);
                }(item, callback) : "object" == typeof item && null !== item && function(item, callback) {
                    for (var _key in item) item.hasOwnProperty(_key) && callback(item[_key], _key);
                }(item, callback);
            }(item, (function(childItem, key) {
                var result = callback(childItem, key);
                newobj[key] = void 0 !== result ? result : "object" == typeof childItem && null !== childItem ? replaceObject(childItem, callback, depth + 1) : childItem;
            }));
            return newobj;
        }
        function safeInterval(method, time) {
            var timeout;
            timeout = setTimeout((function runInterval() {
                timeout = setTimeout(runInterval, time);
                method.call();
            }), time);
            return {
                cancel: function() {
                    clearTimeout(timeout);
                }
            };
        }
        function isRegex(item) {
            return "[object RegExp]" === {}.toString.call(item);
        }
        var util_weakMapMemoize = function(method) {
            var weakmap = new src.a;
            return function(arg) {
                var result = weakmap.get(arg);
                if (void 0 !== result) return result;
                void 0 !== (result = method.call(this, arg)) && weakmap.set(arg, result);
                return result;
            };
        };
        function getWindowType() {
            return Object(cross_domain_utils_src.u)() ? conf.b.WINDOW_TYPES.POPUP : Object(cross_domain_utils_src.s)() ? conf.b.WINDOW_TYPES.IFRAME : conf.b.WINDOW_TYPES.FULLPAGE;
        }
        function jsonStringify(obj, replacer, indent) {
            var objectToJSON;
            var arrayToJSON;
            try {
                if ("{}" !== JSON.stringify({})) {
                    objectToJSON = {}.toJSON;
                    delete Object.prototype.toJSON;
                }
                if ("{}" !== JSON.stringify({})) throw new Error("Can not correctly serialize JSON objects");
                if ("[]" !== JSON.stringify([])) {
                    arrayToJSON = [].toJSON;
                    delete Array.prototype.toJSON;
                }
                if ("[]" !== JSON.stringify([])) throw new Error("Can not correctly serialize JSON objects");
            } catch (err) {
                throw new Error("Can not repair JSON.stringify: " + err.message);
            }
            var result = JSON.stringify.call(this, obj, replacer, indent);
            try {
                objectToJSON && (Object.prototype.toJSON = objectToJSON);
                arrayToJSON && (Array.prototype.toJSON = arrayToJSON);
            } catch (err) {
                throw new Error("Can not repair JSON.stringify: " + err.message);
            }
            return result;
        }
        function jsonParse(item) {
            return JSON.parse(item);
        }
        function needsGlobalMessagingForBrowser() {
            return !!Object(cross_domain_utils_src.p)(window).match(/MSIE|trident|edge\/12|edge\/13/i) || !conf.a.ALLOW_POSTMESSAGE_POPUP;
        }
        var zalgo_promise_src = __webpack_require__(2);
        var global = __webpack_require__(9);
        global.a.methods = global.a.methods || new src.a;
        var listenForMethods = once((function() {
            global.a.on(conf.b.POST_MESSAGE_NAMES.METHOD, {
                origin: conf.b.WILDCARD
            }, (function(_ref) {
                var source = _ref.source, origin = _ref.origin, data = _ref.data;
                var methods = global.a.methods.get(source);
                if (!methods) throw new Error("Could not find any methods this window has privileges to call");
                var meth = methods[data.id];
                if (!meth) throw new Error("Could not find method with id: " + data.id);
                if (!Object(cross_domain_utils_src.B)(meth.domain, origin)) throw new Error("Method domain " + meth.domain + " does not match origin " + origin);
                return zalgo_promise_src.a.try((function() {
                    return meth.method.apply({
                        source: source,
                        origin: origin,
                        data: data
                    }, data.args);
                })).then((function(result) {
                    return {
                        result: result,
                        id: data.id,
                        name: data.name
                    };
                }));
            }));
        }));
        function isSerialized(item, type) {
            return "object" == typeof item && null !== item && item.__type__ === type;
        }
        function serializeMethod(destination, domain, method, name) {
            var id = uniqueID();
            var methods = global.a.methods.get(destination);
            methods || global.a.methods.set(destination, methods = {});
            methods[id] = {
                domain: domain,
                method: method
            };
            return {
                __type__: conf.b.SERIALIZATION_TYPES.METHOD,
                __id__: id,
                __name__: name
            };
        }
        function serializeMethods(destination, domain, obj) {
            return replaceObject({
                obj: obj
            }, (function(item, key) {
                return "function" == typeof item ? serializeMethod(destination, domain, item, key.toString()) : item instanceof Error ? {
                    __type__: conf.b.SERIALIZATION_TYPES.ERROR,
                    __message__: stringifyError(err = item),
                    __code__: err.code
                } : window.Promise && item instanceof window.Promise ? function(destination, domain, promise, name) {
                    return {
                        __type__: conf.b.SERIALIZATION_TYPES.PROMISE,
                        __then__: serializeMethod(destination, domain, (function(resolve, reject) {
                            return promise.then(resolve, reject);
                        }), name + ".then")
                    };
                }(destination, domain, item, key.toString()) : zalgo_promise_src.a.isPromise(item) ? function(destination, domain, promise, name) {
                    return {
                        __type__: conf.b.SERIALIZATION_TYPES.ZALGO_PROMISE,
                        __then__: serializeMethod(destination, domain, (function(resolve, reject) {
                            return promise.then(resolve, reject);
                        }), name + ".then")
                    };
                }(destination, domain, item, key.toString()) : isRegex(item) ? {
                    __type__: conf.b.SERIALIZATION_TYPES.REGEX,
                    __source__: item.source
                } : void 0;
                var err;
            })).obj;
        }
        function deserializeMethod(source, origin, obj) {
            function wrapper() {
                var args = [].slice.call(arguments);
                return global.a.send(source, conf.b.POST_MESSAGE_NAMES.METHOD, {
                    id: obj.__id__,
                    name: obj.__name__,
                    args: args
                }, {
                    domain: origin,
                    timeout: -1
                }).then((function(_ref2) {
                    return _ref2.data.result;
                }), (function(err) {
                    throw err;
                }));
            }
            wrapper.__name__ = obj.__name__;
            wrapper.__xdomain__ = !0;
            wrapper.source = source;
            wrapper.origin = origin;
            return wrapper;
        }
        function deserializeZalgoPromise(source, origin, prom) {
            return new zalgo_promise_src.a((function(resolve, reject) {
                return deserializeMethod(source, origin, prom.__then__)(resolve, reject);
            }));
        }
        function deserializeMethods(source, origin, obj) {
            return replaceObject({
                obj: obj
            }, (function(item) {
                if ("object" == typeof item && null !== item) return isSerialized(item, conf.b.SERIALIZATION_TYPES.METHOD) ? deserializeMethod(source, origin, item) : isSerialized(item, conf.b.SERIALIZATION_TYPES.ERROR) ? function(source, origin, obj) {
                    var err = new Error(obj.__message__);
                    obj.__code__ && (err.code = obj.__code__);
                    return err;
                }(0, 0, item) : isSerialized(item, conf.b.SERIALIZATION_TYPES.PROMISE) ? function(source, origin, prom) {
                    return window.Promise ? new window.Promise((function(resolve, reject) {
                        return deserializeMethod(source, origin, prom.__then__)(resolve, reject);
                    })) : deserializeZalgoPromise(source, origin, prom);
                }(source, origin, item) : isSerialized(item, conf.b.SERIALIZATION_TYPES.ZALGO_PROMISE) ? deserializeZalgoPromise(source, origin, item) : isSerialized(item, conf.b.SERIALIZATION_TYPES.REGEX) ? function(source, origin, item) {
                    return new RegExp(item.__source__);
                }(0, 0, item) : void 0;
            })).obj;
        }
        global.a.readyPromises = global.a.readyPromises || new src.a;
        function sayHello(win) {
            return global.a.send(win, conf.b.POST_MESSAGE_NAMES.HELLO, {}, {
                domain: conf.b.WILDCARD,
                timeout: -1
            }).then((function(_ref2) {
                return {
                    origin: _ref2.origin
                };
            }));
        }
        function initOnReady() {
            handler = function(_ref3) {
                var source = _ref3.source, origin = _ref3.origin;
                var promise = global.a.readyPromises.get(source) || new zalgo_promise_src.a;
                promise.resolve({
                    origin: origin
                });
                global.a.readyPromises.set(source, promise);
            }, global.a.on(conf.b.POST_MESSAGE_NAMES.HELLO, {
                domain: conf.b.WILDCARD
            }, (function(_ref) {
                return handler({
                    source: _ref.source,
                    origin: _ref.origin
                });
            }));
            var handler;
            var parent = Object(cross_domain_utils_src.f)();
            parent && sayHello(parent).catch(noop);
        }
        function onChildWindowReady(win, timeout, name) {
            void 0 === timeout && (timeout = 5e3);
            void 0 === name && (name = "Window");
            var promise = global.a.readyPromises.get(win);
            if (promise) return promise;
            promise = new zalgo_promise_src.a;
            global.a.readyPromises.set(win, promise);
            -1 !== timeout && setTimeout((function() {
                return promise.reject(new Error(name + " did not load after " + timeout + "ms"));
            }), timeout);
            return promise;
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return Checkout;
        }));
        var esm_extends = __webpack_require__(13);
        var src = __webpack_require__(2);
        var beaver_logger_client = __webpack_require__(5);
        var zoid_src = __webpack_require__(22);
        var belter_src = __webpack_require__(11);
        var lib = __webpack_require__(4);
        var config = __webpack_require__(3);
        var constants = __webpack_require__(0);
        var post_robot_src = __webpack_require__(15);
        function match(str, pattern) {
            var regmatch = str.match(pattern);
            if (regmatch) return regmatch[1];
        }
        var onAuthorize;
        Object(lib.E)() && Object(post_robot_src.on)("onLegacyPaymentAuthorize", {
            window: window.parent
        }, (function(_ref) {
            onAuthorize = _ref.data.method;
        }));
        function onLegacyPaymentAuthorize(method) {
            onAuthorize = method;
            return src.a.try((function() {
                if (post_robot_src.bridge && !Object(lib.E)()) return post_robot_src.bridge.openBridge(Object(lib.g)(config.a.postBridgeUrl, {
                    version: Object(lib.v)()
                }), config.a.postBridgeDomain).then((function(postBridge) {
                    return Object(post_robot_src.send)(postBridge, "onLegacyPaymentAuthorize", {
                        method: method
                    }, {
                        domain: config.a.paypalDomain
                    }).then(lib.I);
                }));
            }));
        }
        window.onLegacyPaymentAuthorize = onLegacyPaymentAuthorize;
        window.watchForLegacyFallback = function(win) {
            var interval = setInterval((function() {
                try {
                    if (-1 === win.document.body.innerHTML.indexOf("merchantpaymentweb") && -1 === win.document.body.innerHTML.indexOf("wapapp") || win.ppxoWatching || win.closed) return;
                    win.ppxoWatching = !0;
                    var XMLHttpRequestsend = win.XMLHttpRequest.prototype.send;
                    win.XMLHttpRequest.prototype.send = function() {
                        if (this._patched) return XMLHttpRequestsend.apply(this, arguments);
                        this._patched = !0;
                        var self = this;
                        var onload = this.onload;
                        function listener() {
                            if (self.readyState === self.DONE && 200 === self.status && self.responseText) try {
                                var response = JSON.parse(self.responseText.replace("while (1);", ""));
                                if ("redirect" === response.type && response.url && onAuthorize) {
                                    var url = response.url;
                                    clearInterval(interval);
                                    win.close();
                                    onAuthorize({
                                        returnUrl: url,
                                        paymentToken: match(url, /token=((EC-)?[A-Z0-9]+)/),
                                        billingToken: match(url, /ba_token=((BA-)?[A-Z0-9]+)/),
                                        payerID: match(url, /PayerID=([A-Z0-9]+)/),
                                        paymentID: match(url, /paymentId=((PAY-)?[A-Z0-9]+)/)
                                    });
                                    onAuthorize = null;
                                    win.PAYPAL && win.PAYPAL.Checkout && win.PAYPAL.Checkout.XhrResponse && win.PAYPAL.Checkout.XhrResponse.RESPONSE_TYPES && Object.defineProperty(win.PAYPAL.Checkout.XhrResponse.RESPONSE_TYPES, "Redirect", {
                                        value: Math.random().toString()
                                    });
                                    win.mob && win.mob.Xhr && win.mob.Xhr.prototype._xhrOnReady && (win.mob.Xhr.prototype._xhrOnReady = lib.I);
                                }
                            } catch (err) {
                                return;
                            }
                            if (onload) return onload.apply(this, arguments);
                        }
                        if (this.onload !== listener) try {
                            delete this.onload;
                            this.addEventListener("load", listener);
                            Object.defineProperty(this, "onload", {
                                get: function() {
                                    return listener;
                                },
                                set: function(handler) {
                                    onload = handler;
                                }
                            });
                        } catch (err) {}
                        return XMLHttpRequestsend.apply(this, arguments);
                    };
                } catch (err) {}
            }), 100);
        };
        window.onLegacyFallback = window.watchForLegacyFallback;
        var integrations = __webpack_require__(28);
        var template = __webpack_require__(31);
        var Checkout = Object(zoid_src.c)({
            tag: "paypal-checkout",
            name: "ppcheckout",
            scrolling: !0,
            buildUrl: function(props) {
                var env = props.env || config.a.env;
                if (!props.payment) throw new Error("Can not build url without payment prop");
                return props.payment().then((function(token) {
                    if (!token) throw new Error("Expected payment id or token to be passed, got " + token);
                    return Object(integrations.c)(env, props.fundingSource, token);
                }));
            },
            get unsafeRenderTo() {
                return config.a.env === constants.t.LOCAL;
            },
            get domain() {
                return Object(esm_extends.a)({}, config.a.paypalDomains);
            },
            get bridgeUrl() {
                return config.a.metaFrameUrls;
            },
            get bridgeDomain() {
                return config.a.paypalDomains;
            },
            contexts: {
                iframe: !Object(belter_src.t)(),
                popup: !0
            },
            get version() {
                return Object(lib.v)();
            },
            validate: function() {
                Object(lib.C)() || Object(beaver_logger_client.q)("checkout_render_ineligible");
            },
            prerenderTemplate: template.a,
            containerTemplate: template.b,
            props: {
                sessionID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.w)();
                    },
                    queryParam: !0
                },
                buttonSessionID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.j)();
                    },
                    queryParam: !0
                },
                env: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return config.a.env;
                    },
                    validate: function(env) {
                        if (!config.a.paypalUrls[env]) throw new Error("Invalid env: " + env);
                    }
                },
                meta: {
                    type: "object",
                    required: !1,
                    def: function() {
                        return window.xprops && window.xprops.meta || {};
                    }
                },
                stage: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function(props) {
                        var env = props.env || config.a.env;
                        if (env === constants.t.STAGE || env === constants.t.LOCAL) return config.a.stage;
                    }
                },
                stageUrl: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function(props) {
                        var env = props.env || config.a.env;
                        if (env === constants.t.STAGE || env === constants.t.LOCAL) return config.a.stageUrl;
                    }
                },
                authCode: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return config.a.authCode;
                    },
                    queryParam: "code"
                },
                localhostUrl: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function(props) {
                        if ((props.env || config.a.env) === constants.t.LOCAL) return config.a.localhostUrl;
                    }
                },
                checkoutUri: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return config.a.checkoutUri;
                    }
                },
                locale: {
                    type: "string",
                    required: !1,
                    queryParam: "locale.x",
                    allowDelegate: !0,
                    def: function() {
                        var _getBrowserLocale = Object(lib.i)();
                        return _getBrowserLocale.lang + "_" + _getBrowserLocale.country;
                    }
                },
                client: {
                    type: "object",
                    required: !1,
                    def: function() {
                        return {};
                    },
                    sendToChild: !1,
                    validate: function(client, props) {
                        var env = props.env || config.a.env;
                        if (!client[env]) throw new Error("Client ID not found for env: " + env);
                        if (client[env].match(/^(.)\1+$/)) throw new Error("Invalid client ID: " + client[env]);
                    }
                },
                payment: {
                    type: "function",
                    required: !1,
                    memoize: !0,
                    promisify: !0,
                    queryParam: function(payment) {
                        return payment().then((function(token) {
                            return Object(integrations.b)(token);
                        }));
                    },
                    queryValue: function(payment) {
                        return payment();
                    },
                    childDecorate: function(payment) {
                        var token = Object(lib.q)("token");
                        return token ? Object(lib.H)((function() {
                            return src.a.resolve(token);
                        })) : payment;
                    },
                    validate: function(payment, props) {
                        if (!payment && !props.url) throw new Error("Expected either props.payment or props.url to be passed");
                    },
                    alias: "billingAgreement"
                },
                style: {
                    type: "object",
                    required: !1,
                    allowDelegate: !0,
                    def: function() {
                        return {};
                    },
                    validate: function(style) {
                        if (style.overlayColor && style.overlayColor !== constants.q.BLACK && style.overlayColor !== constants.q.WHITE) throw new Error("Invalid background color: " + style.overlayColor);
                    }
                },
                commit: {
                    type: "boolean",
                    required: !1
                },
                experience: {
                    type: "object",
                    required: !1,
                    def: function() {
                        return {};
                    }
                },
                fundingSource: {
                    type: "string",
                    required: !1,
                    queryParam: !0
                },
                fundingOffered: {
                    type: "object",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return [].slice.call(document.querySelectorAll("[" + constants.c.FUNDING_SOURCE + "]")).map((function(el) {
                            return el.getAttribute(constants.c.FUNDING_SOURCE);
                        }));
                    },
                    queryValue: function(val) {
                        return val.join(",");
                    }
                },
                onAuthorize: {
                    type: "function",
                    required: !0,
                    once: !0,
                    decorate: function(original) {
                        if (original) return function(data, actions) {
                            var _this = this;
                            void 0 === actions && (actions = {});
                            data && !data.intent && Object(beaver_logger_client.q)("checkout_authorize_no_intent", {
                                paymentID: data.paymentID,
                                token: data.paymentToken
                            });
                            var close = function() {
                                return src.a.try((function() {
                                    if (actions.close) return actions.close();
                                })).then((function() {
                                    return _this.closeComponent();
                                }));
                            };
                            var redirect = function(win, url) {
                                return src.a.all([ Object(lib.O)(win || window.top, url || data.returnUrl), close() ]);
                            };
                            return src.a.try((function() {
                                try {
                                    var isButton = -1 !== window.location.href.indexOf("/smart/button");
                                    var isGuest = -1 !== _this.window.location.href.indexOf("/webapps/xoonboarding");
                                    if (isButton && isGuest) return Object(lib.Q)({
                                        win: _this.window,
                                        method: "get",
                                        url: "/webapps/xoonboarding/api/auth"
                                    }).then((function(result) {
                                        result && result.data && result.data.access_token && (window.$Api && window.$Api.addHeader && window.$Api.addHeader("x-paypal-internal-euat", result.data.access_token));
                                    })).catch((function() {}));
                                } catch (err) {}
                            })).then((function() {
                                return original.call(_this, data, Object(esm_extends.a)({}, actions, {
                                    close: close,
                                    redirect: redirect
                                }));
                            })).catch((function(err) {
                                return _this.error(err);
                            })).finally((function() {
                                return _this.close();
                            }));
                        };
                    }
                },
                onShippingChange: {
                    type: "function",
                    required: !1
                },
                onAuth: {
                    type: "function",
                    required: !1,
                    sameDomain: !0,
                    childDecorate: function(original) {
                        if (original) return function(data) {
                            "string" == typeof data && (data = {
                                accessToken: data
                            });
                            return original(data);
                        };
                    }
                },
                accessToken: {
                    type: "function",
                    required: !1
                },
                onCancel: {
                    type: "function",
                    required: !1,
                    once: !0,
                    noop: !0,
                    decorate: function(original) {
                        return function(data, actions) {
                            var _this2 = this;
                            void 0 === actions && (actions = {});
                            var close = function() {
                                return src.a.try((function() {
                                    if (actions.close) return actions.close();
                                })).then((function() {
                                    return _this2.closeComponent();
                                }));
                            };
                            var redirect = function(win, url) {
                                return src.a.all([ Object(lib.O)(win || window.top, url || data.cancelUrl), close() ]);
                            };
                            return src.a.try((function() {
                                return original.call(_this2, data, Object(esm_extends.a)({}, actions, {
                                    close: close,
                                    redirect: redirect
                                }));
                            })).finally((function() {
                                _this2.close();
                            }));
                        };
                    }
                },
                init: {
                    type: "function",
                    required: !1,
                    once: !0,
                    noop: !0,
                    decorate: function(original) {
                        return function(data) {
                            var _track;
                            Object(beaver_logger_client.k)("checkout_init");
                            Object(beaver_logger_client.p)(((_track = {})[constants.u.KEY.STATE] = constants.u.STATE.CHECKOUT, 
                            _track[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.CHECKOUT_INIT, _track[constants.u.KEY.CONTEXT_TYPE] = constants.u.CONTEXT_TYPE[constants.C.EC_TOKEN], 
                            _track[constants.u.KEY.TOKEN] = data.paymentToken, _track[constants.u.KEY.SELLER_ID] = data.merchantID, 
                            _track[constants.u.KEY.CONTEXT_ID] = data.paymentToken, _track));
                            Object(beaver_logger_client.h)();
                            this.paymentToken = data.paymentToken;
                            this.cancelUrl = data.cancelUrl;
                            return original.apply(this, arguments);
                        };
                    }
                },
                onClose: {
                    type: "function",
                    required: !1,
                    once: !0,
                    promisify: !0,
                    noop: !0,
                    decorate: function(original) {
                        return function(reason) {
                            var onClose = original.apply(this, arguments);
                            var CLOSE_REASONS = zoid_src.a.CLOSE_REASONS;
                            var shouldCancel = this.props.onCancel && -1 !== [ CLOSE_REASONS.CLOSE_DETECTED, CLOSE_REASONS.USER_CLOSED ].indexOf(reason);
                            if (shouldCancel) {
                                Object(beaver_logger_client.k)("close_trigger_cancel");
                                return this.props.onCancel({
                                    paymentToken: this.paymentToken,
                                    cancelUrl: this.cancelUrl
                                }).then((function() {
                                    return onClose;
                                }));
                            }
                            return onClose;
                        };
                    }
                },
                onError: {
                    type: "function",
                    required: !1,
                    promisify: !0,
                    noop: !0,
                    once: !0
                },
                fallback: {
                    type: "function",
                    required: !1,
                    once: !0,
                    def: function() {
                        return function(url) {
                            Object(beaver_logger_client.q)("fallback", {
                                url: url
                            });
                            if (Object(lib.m)("allow_full_page_fallback")) {
                                window.top.location = url;
                                return this.close();
                            }
                            return onLegacyPaymentAuthorize(this.props.onAuthorize);
                        };
                    }
                },
                logLevel: {
                    type: "string",
                    required: !1,
                    get value() {
                        return config.a.logLevel;
                    }
                },
                test: {
                    type: "object",
                    required: !1,
                    def: function() {
                        return window.__test__ || {
                            action: "checkout"
                        };
                    }
                },
                sdkMeta: {
                    type: "string",
                    queryParam: !0,
                    sendToChild: !1,
                    def: function() {
                        return Object(belter_src.a)(JSON.stringify({
                            url: Object(lib.l)()
                        }));
                    }
                }
            },
            get dimensions() {
                return Object(belter_src.h)() ? {
                    width: "100%",
                    height: "590px"
                } : {
                    width: "500px",
                    height: "590px"
                };
            }
        });
        if (Checkout.isChild() && Checkout.xchild && Checkout.xprops) {
            Checkout.xprops && Checkout.xprops.logLevel && Object(lib.S)(Checkout.xprops.logLevel);
            Checkout.xchild.onProps((function(xprops) {
                Object(lib.M)(xprops, "onAuthorize", (function(_ref) {
                    var callOriginal = _ref.callOriginal, data = _ref.args[0];
                    if (data && !data.intent) {
                        Object(beaver_logger_client.q)("hermes_authorize_no_intent", {
                            paymentID: data.paymentID,
                            token: data.paymentToken
                        });
                        try {
                            var intent = window.injector.get("$CheckoutCartModel").instance(data.paymentToken).payment_action;
                            Object(beaver_logger_client.q)("hermes_intent", {
                                paymentID: data.paymentID,
                                token: data.paymentToken,
                                intent: intent
                            });
                        } catch (err) {}
                        Object(beaver_logger_client.j)();
                    }
                    return callOriginal();
                }));
            }));
        }
        Object(lib.M)(Checkout, "init", (function(_ref2) {
            var _ref2$args = _ref2.args;
            return _ref2.original.call(_ref2.context, _ref2$args[0], _ref2$args[1], "body");
        }));
        Object(lib.M)(Checkout, "render", (function(_ref3) {
            return _ref3.original.call(_ref3.context, _ref3.args[0], "body");
        }));
        Object(lib.M)(Checkout, "renderTo", (function(_ref4) {
            var _ref4$args = _ref4.args, win = _ref4$args[0], props = _ref4$args[1], original = _ref4.original, context = _ref4.context;
            var payment = props.payment();
            props.payment = function() {
                return payment;
            };
            return original.call(context, win, props, "body").catch((function(err) {
                if (err instanceof zoid_src.b && Object(lib.E)()) {
                    Checkout.contexts.iframe = !0;
                    return original.call(context, win, props, "body");
                }
                throw err;
            }));
        }));
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return weakmap_CrossDomainSafeWeakMap;
        }));
        var src = __webpack_require__(7);
        function safeIndexOf(collection, item) {
            for (var i = 0; i < collection.length; i++) try {
                if (collection[i] === item) return i;
            } catch (err) {}
            return -1;
        }
        var weakmap_CrossDomainSafeWeakMap = function() {
            function CrossDomainSafeWeakMap() {
                this.name = void 0;
                this.weakmap = void 0;
                this.keys = void 0;
                this.values = void 0;
                this.name = "__weakmap_" + (1e9 * Math.random() >>> 0) + "__";
                if (function() {
                    if ("undefined" == typeof WeakMap) return !1;
                    if (void 0 === Object.freeze) return !1;
                    try {
                        var testWeakMap = new WeakMap;
                        var testKey = {};
                        Object.freeze(testKey);
                        testWeakMap.set(testKey, "__testvalue__");
                        return "__testvalue__" === testWeakMap.get(testKey);
                    } catch (err) {
                        return !1;
                    }
                }()) try {
                    this.weakmap = new WeakMap;
                } catch (err) {}
                this.keys = [];
                this.values = [];
            }
            var _proto = CrossDomainSafeWeakMap.prototype;
            _proto._cleanupClosedWindows = function() {
                var weakmap = this.weakmap;
                var keys = this.keys;
                for (var i = 0; i < keys.length; i++) {
                    var value = keys[i];
                    if (Object(src.y)(value) && Object(src.z)(value)) {
                        if (weakmap) try {
                            weakmap.delete(value);
                        } catch (err) {}
                        keys.splice(i, 1);
                        this.values.splice(i, 1);
                        i -= 1;
                    }
                }
            };
            _proto.isSafeToReadWrite = function(key) {
                return !Object(src.y)(key);
            };
            _proto.set = function(key, value) {
                if (!key) throw new Error("WeakMap expected key");
                var weakmap = this.weakmap;
                if (weakmap) try {
                    weakmap.set(key, value);
                } catch (err) {
                    delete this.weakmap;
                }
                if (this.isSafeToReadWrite(key)) try {
                    var name = this.name;
                    var entry = key[name];
                    entry && entry[0] === key ? entry[1] = value : Object.defineProperty(key, name, {
                        value: [ key, value ],
                        writable: !0
                    });
                    return;
                } catch (err) {}
                this._cleanupClosedWindows();
                var keys = this.keys;
                var values = this.values;
                var index = safeIndexOf(keys, key);
                if (-1 === index) {
                    keys.push(key);
                    values.push(value);
                } else values[index] = value;
            };
            _proto.get = function(key) {
                if (!key) throw new Error("WeakMap expected key");
                var weakmap = this.weakmap;
                if (weakmap) try {
                    if (weakmap.has(key)) return weakmap.get(key);
                } catch (err) {
                    delete this.weakmap;
                }
                if (this.isSafeToReadWrite(key)) try {
                    var entry = key[this.name];
                    return entry && entry[0] === key ? entry[1] : void 0;
                } catch (err) {}
                this._cleanupClosedWindows();
                var index = safeIndexOf(this.keys, key);
                if (-1 !== index) return this.values[index];
            };
            _proto.delete = function(key) {
                if (!key) throw new Error("WeakMap expected key");
                var weakmap = this.weakmap;
                if (weakmap) try {
                    weakmap.delete(key);
                } catch (err) {
                    delete this.weakmap;
                }
                if (this.isSafeToReadWrite(key)) try {
                    var entry = key[this.name];
                    entry && entry[0] === key && (entry[0] = entry[1] = void 0);
                } catch (err) {}
                this._cleanupClosedWindows();
                var keys = this.keys;
                var index = safeIndexOf(keys, key);
                if (-1 !== index) {
                    keys.splice(index, 1);
                    this.values.splice(index, 1);
                }
            };
            _proto.has = function(key) {
                if (!key) throw new Error("WeakMap expected key");
                var weakmap = this.weakmap;
                if (weakmap) try {
                    if (weakmap.has(key)) return !0;
                } catch (err) {
                    delete this.weakmap;
                }
                if (this.isSafeToReadWrite(key)) try {
                    var entry = key[this.name];
                    return !(!entry || entry[0] !== key);
                } catch (err) {}
                this._cleanupClosedWindows();
                return -1 !== safeIndexOf(this.keys, key);
            };
            _proto.getOrSet = function(key, getter) {
                if (this.has(key)) return this.get(key);
                var value = getter();
                this.set(key, value);
                return value;
            };
            return CrossDomainSafeWeakMap;
        }();
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return fundingLogos;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return cardLogos;
        }));
        var constants = __webpack_require__(0);
        var jsx = __webpack_require__(1);
        var _P24_LOGO_COLORS;
        var P24_LOGO_COLORS = ((_P24_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#ffffff",
            secondary: "#ffffff"
        }, _P24_LOGO_COLORS[constants.i.ANY] = {
            primary: "#d03238",
            secondary: "#b3b1b1"
        }, _P24_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#d03238",
            secondary: "#b3b1b1"
        }, _P24_LOGO_COLORS);
        var _SOFORT_LOGO_COLORS;
        var SOFORT_LOGO_COLORS = ((_SOFORT_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#2C2E2F",
            secondary: "#ffffff"
        }, _SOFORT_LOGO_COLORS[constants.i.ANY] = {
            primary: "#EB6F93",
            secondary: "#FFFFFF"
        }, _SOFORT_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#EB6F93",
            secondary: "#FFFFFF"
        }, _SOFORT_LOGO_COLORS);
        var _IDEAL_LOGO_COLORS;
        var IDEAL_LOGO_COLORS = ((_IDEAL_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#ffffff",
            secondary: "#ffffff",
            tertiary: "#2C2E2F"
        }, _IDEAL_LOGO_COLORS[constants.i.ANY] = {
            primary: "#000000",
            secondary: "#FFFFFF",
            tertiary: "#CD0067"
        }, _IDEAL_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#000000",
            secondary: "#FFFFFF",
            tertiary: "#CD0067"
        }, _IDEAL_LOGO_COLORS);
        var _GIROPAY_LOGO_COLORS;
        var GIROPAY_LOGO_COLORS = ((_GIROPAY_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#ffffff",
            secondary: "#000000",
            tertiary: "#2C2E2F"
        }, _GIROPAY_LOGO_COLORS[constants.i.ANY] = {
            primary: "#FFFFFF",
            secondary: "#003A7D",
            tertiary: "#ED1C24"
        }, _GIROPAY_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#FFFFFF",
            secondary: "#003A7D",
            tertiary: "#ED1C24"
        }, _GIROPAY_LOGO_COLORS);
        var _EPS_LOGO_COLORS;
        var EPS_LOGO_COLORS = ((_EPS_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#ffffff",
            secondary: "#ffffff",
            tertiary: "#ffffff"
        }, _EPS_LOGO_COLORS[constants.i.ANY] = {
            primary: "#71706F",
            secondary: "#FFFFFF",
            tertiary: "#C8036F"
        }, _EPS_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#71706F",
            secondary: "#FFFFFF",
            tertiary: "#C8036F"
        }, _EPS_LOGO_COLORS);
        var _MYBANK_LOGO_COLORS;
        var MYBANK_LOGO_COLORS = ((_MYBANK_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#ffffff",
            secondary: "#ffffff",
            tertiary: "#ffffff"
        }, _MYBANK_LOGO_COLORS[constants.i.ANY] = {
            primary: "#1A4B67",
            secondary: "#00C0EE",
            tertiary: "#FFFFFF"
        }, _MYBANK_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#1A4B67",
            secondary: "#00C0EE",
            tertiary: "#FFFFFF"
        }, _MYBANK_LOGO_COLORS);
        var _BANCONTACT_LOGO_COLO;
        var BANCONTACT_LOGO_COLORS = ((_BANCONTACT_LOGO_COLO = {})[constants.i.WHITE] = {
            primary: "#ffffff",
            secondary: "#ffffff"
        }, _BANCONTACT_LOGO_COLO[constants.i.ANY] = {
            primary: "#1A4B67",
            secondary: "#00C0EE"
        }, _BANCONTACT_LOGO_COLO[constants.i.BLACK] = {
            primary: "#005498",
            secondary: "#FFD800"
        }, _BANCONTACT_LOGO_COLO);
        var _BLIK_LOGO_COLORS;
        var BLIK_LOGO_COLORS = ((_BLIK_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#FFFFFF",
            secondary: "#FFFFFF",
            tertiary: "#000000",
            quaternary: "#000000",
            quinary: "#000000",
            senary: "#000000"
        }, _BLIK_LOGO_COLORS[constants.i.ANY] = {
            primary: "#4D4D4F",
            secondary: "#000000",
            tertiary: "#FF0000",
            quaternary: "#E83E49",
            quinary: "#FF00FF",
            senary: "#FFFFFF"
        }, _BLIK_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#4D4D4F",
            secondary: "#000000",
            tertiary: "#FF0000",
            quaternary: "#E83E49",
            quinary: "#FF00FF",
            senary: "#FFFFFF"
        }, _BLIK_LOGO_COLORS);
        var _MAXIMA_LOGO_COLORS;
        var MAXIMA_LOGO_COLORS = ((_MAXIMA_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#004A91",
            secondary: "#ED1921"
        }, _MAXIMA_LOGO_COLORS[constants.i.ANY] = {
            primary: "#004A91",
            secondary: "#ED1921"
        }, _MAXIMA_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#004A91",
            secondary: "#ED1921"
        }, _MAXIMA_LOGO_COLORS);
        var _BOLETO_LOGO_COLORS;
        var BOLETO_LOGO_COLORS = ((_BOLETO_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#1A1919",
            secondary: "#FFFFFE"
        }, _BOLETO_LOGO_COLORS[constants.i.ANY] = {
            primary: "#1A1919",
            secondary: "#FFFFFE"
        }, _BOLETO_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#1A1919",
            secondary: "#FFFFFE"
        }, _BOLETO_LOGO_COLORS);
        var _OXXO_LOGO_COLORS;
        var OXXO_LOGO_COLORS = ((_OXXO_LOGO_COLORS = {})[constants.i.WHITE] = {
            primary: "#EC1D24",
            secondary: "#EDA42D"
        }, _OXXO_LOGO_COLORS[constants.i.ANY] = {
            primary: "#EC1D24",
            secondary: "#EDA42D"
        }, _OXXO_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#EC1D24",
            secondary: "#EDA42D"
        }, _OXXO_LOGO_COLORS);
        var _MERCADOPAGO_LOGO_COL;
        var MERCADOPAGO_LOGO_COLORS = ((_MERCADOPAGO_LOGO_COL = {})[constants.i.WHITE] = {
            primary: "#FFFFFF",
            secondary: "#000000",
            tertiary: "#FFFFFF",
            quaternary: "#000000"
        }, _MERCADOPAGO_LOGO_COL[constants.i.ANY] = {
            primary: "#2D3277",
            secondary: "#FFFFFF",
            tertiary: "#009EE3",
            quaternary: "#009EE3"
        }, _MERCADOPAGO_LOGO_COL[constants.i.BLACK] = {
            primary: "#2D3277",
            secondary: "#FFFFFF",
            tertiary: "#009EE3",
            quaternary: "#009EE3"
        }, _MERCADOPAGO_LOGO_COL);
        var _PAYPAL_LOGO_COLORS;
        var PAYPAL_LOGO_COLORS = ((_PAYPAL_LOGO_COLORS = {})[constants.i.BLUE] = {
            primary: "#003087",
            secondary: "#009cde"
        }, _PAYPAL_LOGO_COLORS[constants.i.WHITE] = {
            primary: "#ffffff",
            secondary: "#ffffff"
        }, _PAYPAL_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#333030",
            secondary: "#636363"
        }, _PAYPAL_LOGO_COLORS);
        var _CREDIT_LOGO_COLORS;
        var CREDIT_LOGO_COLORS = ((_CREDIT_LOGO_COLORS = {})[constants.i.BLUE] = {
            primary: "#003087",
            secondary: "#009cde"
        }, _CREDIT_LOGO_COLORS[constants.i.WHITE] = {
            primary: "#ffffff",
            secondary: "#ffffff"
        }, _CREDIT_LOGO_COLORS[constants.i.BLACK] = {
            primary: "#333030",
            secondary: "#636363"
        }, _CREDIT_LOGO_COLORS);
        var _BUTTON_LOGO$PP, _BUTTON_LOGO$VENMO, _BUTTON_LOGO$ITAU, _BUTTON_LOGO$ELV, _fundingLogos;
        var fundingLogos = ((_fundingLogos = {})[constants.h.PP] = ((_BUTTON_LOGO$PP = {})[constants.i.WHITE] = '<svg width="24" height="32" viewBox="0 0 24 32" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">\n    <path fill="#ffffff" opacity="0.7" d="M 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.548 C 18.361 3.148 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 2.948 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 6.378 28.938 C 6.285 29.238 6.659 29.638 6.94 29.638 L 11.153 29.638 C 11.621 29.638 11.995 29.238 12.089 28.739 L 12.182 28.539 L 12.931 23.341 L 13.025 23.041 C 13.119 22.441 13.493 22.141 13.961 22.141 L 14.616 22.141 C 18.642 22.141 21.731 20.342 22.668 15.443 C 23.042 13.344 22.855 11.545 21.825 10.345 C 21.451 10.046 21.076 9.646 20.702 9.446 L 20.702 9.446"></path>\n    <path fill="#ffffff" opacity="0.7" d="M 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.548 C 18.361 3.148 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 2.948 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 7.97 18.342 L 7.876 18.642 C 8.063 18.043 8.438 17.643 9.093 17.643 L 11.433 17.643 C 16.021 17.643 19.578 15.643 20.608 9.946 C 20.608 9.746 20.608 9.546 20.702 9.446"></path>\n    <path fill="#ffffff" d="M 9.28 9.446 C 9.28 9.146 9.468 8.846 9.842 8.646 C 9.936 8.646 10.123 8.546 10.216 8.546 L 16.489 8.546 C 17.238 8.546 17.893 8.646 18.548 8.746 C 18.736 8.746 18.829 8.746 19.11 8.846 C 19.204 8.946 19.391 8.946 19.578 9.046 C 19.672 9.046 19.672 9.046 19.859 9.146 C 20.14 9.246 20.421 9.346 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.648 C 18.361 3.248 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 3.048 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 7.97 18.342 L 9.28 9.446 Z"></path>\n    <g transform="matrix(0.497737, 0, 0, 0.52612, 1.10144, 0.638654)" opacity="0.2">\n        <path fill="#231f20" d="M39.3 16.7c0.9 0.5 1.7 1.1 2.3 1.8 1 1.1 1.6 2.5 1.9 4.1 0.3-3.2-0.2-5.8-1.9-7.8-0.6-0.7-1.3-1.2-2.1-1.7C39.5 14.2 39.5 15.4 39.3 16.7z"></path>\n        <path fill="#231f20" d="M0.4 45.2L6.7 5.6C6.8 4.5 7.8 3.7 8.9 3.7h16c5.5 0 9.8 1.2 12.2 3.9 1.2 1.4 1.9 3 2.2 4.8 0.4-3.6-0.2-6.1-2.2-8.4C34.7 1.2 30.4 0 24.9 0H8.9c-1.1 0-2.1 0.8-2.3 1.9L0 44.1C0 44.5 0.1 44.9 0.4 45.2z"></path>\n        <path fill="#231f20" d="M10.7 49.4l-0.1 0.6c-0.1 0.4 0.1 0.8 0.4 1.1l0.3-1.7H10.7z"></path>\n    </g>\n</svg>\n', 
        _BUTTON_LOGO$PP[constants.i.BLUE] = '<svg width="24" height="32" viewBox="0 0 24 32" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">\n    <path fill="#009cde" d="M 20.905 9.5 C 21.185 7.4 20.905 6 19.782 4.7 C 18.564 3.3 16.411 2.6 13.697 2.6 L 5.739 2.6 C 5.271 2.6 4.71 3.1 4.615 3.6 L 1.339 25.8 C 1.339 26.2 1.62 26.7 2.088 26.7 L 6.956 26.7 L 6.675 28.9 C 6.581 29.3 6.862 29.6 7.236 29.6 L 11.356 29.6 C 11.825 29.6 12.292 29.3 12.386 28.8 L 12.386 28.5 L 13.228 23.3 L 13.228 23.1 C 13.322 22.6 13.79 22.2 14.258 22.2 L 14.821 22.2 C 18.845 22.2 21.935 20.5 22.871 15.5 C 23.339 13.4 23.153 11.7 22.029 10.5 C 21.748 10.1 21.279 9.8 20.905 9.5 L 20.905 9.5"></path>\n    <path fill="#012169" d="M 20.905 9.5 C 21.185 7.4 20.905 6 19.782 4.7 C 18.564 3.3 16.411 2.6 13.697 2.6 L 5.739 2.6 C 5.271 2.6 4.71 3.1 4.615 3.6 L 1.339 25.8 C 1.339 26.2 1.62 26.7 2.088 26.7 L 6.956 26.7 L 8.267 18.4 L 8.173 18.7 C 8.267 18.1 8.735 17.7 9.296 17.7 L 11.636 17.7 C 16.224 17.7 19.782 15.7 20.905 10.1 C 20.812 9.8 20.905 9.7 20.905 9.5"></path>\n    <path fill="#003087" d="M 9.485 9.5 C 9.577 9.2 9.765 8.9 10.046 8.7 C 10.232 8.7 10.326 8.6 10.513 8.6 L 16.692 8.6 C 17.442 8.6 18.189 8.7 18.753 8.8 C 18.939 8.8 19.127 8.8 19.314 8.9 C 19.501 9 19.688 9 19.782 9.1 C 19.875 9.1 19.968 9.1 20.063 9.1 C 20.343 9.2 20.624 9.4 20.905 9.5 C 21.185 7.4 20.905 6 19.782 4.6 C 18.658 3.2 16.506 2.6 13.79 2.6 L 5.739 2.6 C 5.271 2.6 4.71 3 4.615 3.6 L 1.339 25.8 C 1.339 26.2 1.62 26.7 2.088 26.7 L 6.956 26.7 L 8.267 18.4 L 9.485 9.5 Z"></path>\n</svg>\n', 
        _BUTTON_LOGO$PP[constants.i.BLACK] = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="24" height="32" viewBox="0 0 24 32" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path opacity="0.7" d="M 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.548 C 18.361 3.148 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 2.948 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 6.378 28.938 C 6.285 29.238 6.659 29.638 6.94 29.638 L 11.153 29.638 C 11.621 29.638 11.995 29.238 12.089 28.739 L 12.182 28.539 L 12.931 23.341 L 13.025 23.041 C 13.119 22.441 13.493 22.141 13.961 22.141 L 14.616 22.141 C 18.642 22.141 21.731 20.342 22.668 15.443 C 23.042 13.344 22.855 11.545 21.825 10.345 C 21.451 10.046 21.076 9.646 20.702 9.446 L 20.702 9.446" style="fill: rgb(99, 99, 99);"/>\n  <path opacity="0.7" d="M 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.548 C 18.361 3.148 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 2.948 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 7.97 18.342 L 7.876 18.642 C 8.063 18.043 8.438 17.643 9.093 17.643 L 11.433 17.643 C 16.021 17.643 19.578 15.643 20.608 9.946 C 20.608 9.746 20.608 9.546 20.702 9.446"/>\n  <path d="M 9.28 9.446 C 9.28 9.146 9.468 8.846 9.842 8.646 C 9.936 8.646 10.123 8.546 10.216 8.546 L 16.489 8.546 C 17.238 8.546 17.893 8.646 18.548 8.746 C 18.736 8.746 18.829 8.746 19.11 8.846 C 19.204 8.946 19.391 8.946 19.578 9.046 C 19.672 9.046 19.672 9.046 19.859 9.146 C 20.14 9.246 20.421 9.346 20.702 9.446 C 20.982 7.347 20.702 5.947 19.578 4.648 C 18.361 3.248 16.208 2.548 13.493 2.548 L 5.536 2.548 C 4.974 2.548 4.506 3.048 4.412 3.548 L 1.136 25.74 C 1.042 26.239 1.323 26.639 1.791 26.639 L 6.753 26.639 L 7.97 18.342 L 9.28 9.446 Z" style="fill: rgb(51, 48, 48);"/>\n  <g transform="matrix(0.497737, 0, 0, 0.52612, 1.10144, 0.638654)" opacity="0.2">\n    <path fill="#231f20" d="M39.3 16.7c0.9 0.5 1.7 1.1 2.3 1.8 1 1.1 1.6 2.5 1.9 4.1 0.3-3.2-0.2-5.8-1.9-7.8-0.6-0.7-1.3-1.2-2.1-1.7C39.5 14.2 39.5 15.4 39.3 16.7z"/>\n    <path fill="#231f20" d="M0.4 45.2L6.7 5.6C6.8 4.5 7.8 3.7 8.9 3.7h16c5.5 0 9.8 1.2 12.2 3.9 1.2 1.4 1.9 3 2.2 4.8 0.4-3.6-0.2-6.1-2.2-8.4C34.7 1.2 30.4 0 24.9 0H8.9c-1.1 0-2.1 0.8-2.3 1.9L0 44.1C0 44.5 0.1 44.9 0.4 45.2z"/>\n    <path fill="#231f20" d="M10.7 49.4l-0.1 0.6c-0.1 0.4 0.1 0.8 0.4 1.1l0.3-1.7H10.7z"/>\n  </g>\n</svg>', 
        _BUTTON_LOGO$PP), _fundingLogos[constants.h.PAYPAL] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!PAYPAL_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " paypal logo available");
            var _PAYPAL_LOGO_COLORS$l = PAYPAL_LOGO_COLORS[logoColor], primary = _PAYPAL_LOGO_COLORS$l.primary, secondary = _PAYPAL_LOGO_COLORS$l.secondary;
            return Object(jsx.c)("svg", {
                width: "100",
                height: "32",
                viewBox: "0 0 100 32",
                xmlns: "http://www.w3.org/2000/svg",
                preserveAspectRatio: "xMinYMin meet"
            }, Object(jsx.c)("path", {
                fill: primary,
                d: "M 12 4.917 L 4.2 4.917 C 3.7 4.917 3.2 5.317 3.1 5.817 L 0 25.817 C -0.1 26.217 0.2 26.517 0.6 26.517 L 4.3 26.517 C 4.8 26.517 5.3 26.117 5.4 25.617 L 6.2 20.217 C 6.3 19.717 6.7 19.317 7.3 19.317 L 9.8 19.317 C 14.9 19.317 17.9 16.817 18.7 11.917 C 19 9.817 18.7 8.117 17.7 6.917 C 16.6 5.617 14.6 4.917 12 4.917 Z M 12.9 12.217 C 12.5 15.017 10.3 15.017 8.3 15.017 L 7.1 15.017 L 7.9 9.817 C 7.9 9.517 8.2 9.317 8.5 9.317 L 9 9.317 C 10.4 9.317 11.7 9.317 12.4 10.117 C 12.9 10.517 13.1 11.217 12.9 12.217 Z"
            }), Object(jsx.c)("path", {
                fill: primary,
                d: "M 35.2 12.117 L 31.5 12.117 C 31.2 12.117 30.9 12.317 30.9 12.617 L 30.7 13.617 L 30.4 13.217 C 29.6 12.017 27.8 11.617 26 11.617 C 21.9 11.617 18.4 14.717 17.7 19.117 C 17.3 21.317 17.8 23.417 19.1 24.817 C 20.2 26.117 21.9 26.717 23.8 26.717 C 27.1 26.717 29 24.617 29 24.617 L 28.8 25.617 C 28.7 26.017 29 26.417 29.4 26.417 L 32.8 26.417 C 33.3 26.417 33.8 26.017 33.9 25.517 L 35.9 12.717 C 36 12.517 35.6 12.117 35.2 12.117 Z M 30.1 19.317 C 29.7 21.417 28.1 22.917 25.9 22.917 C 24.8 22.917 24 22.617 23.4 21.917 C 22.8 21.217 22.6 20.317 22.8 19.317 C 23.1 17.217 24.9 15.717 27 15.717 C 28.1 15.717 28.9 16.117 29.5 16.717 C 30 17.417 30.2 18.317 30.1 19.317 Z"
            }), Object(jsx.c)("path", {
                fill: primary,
                d: "M 55.1 12.117 L 51.4 12.117 C 51 12.117 50.7 12.317 50.5 12.617 L 45.3 20.217 L 43.1 12.917 C 43 12.417 42.5 12.117 42.1 12.117 L 38.4 12.117 C 38 12.117 37.6 12.517 37.8 13.017 L 41.9 25.117 L 38 30.517 C 37.7 30.917 38 31.517 38.5 31.517 L 42.2 31.517 C 42.6 31.517 42.9 31.317 43.1 31.017 L 55.6 13.017 C 55.9 12.717 55.6 12.117 55.1 12.117 Z"
            }), Object(jsx.c)("path", {
                fill: secondary,
                d: "M 67.5 4.917 L 59.7 4.917 C 59.2 4.917 58.7 5.317 58.6 5.817 L 55.5 25.717 C 55.4 26.117 55.7 26.417 56.1 26.417 L 60.1 26.417 C 60.5 26.417 60.8 26.117 60.8 25.817 L 61.7 20.117 C 61.8 19.617 62.2 19.217 62.8 19.217 L 65.3 19.217 C 70.4 19.217 73.4 16.717 74.2 11.817 C 74.5 9.717 74.2 8.017 73.2 6.817 C 72 5.617 70.1 4.917 67.5 4.917 Z M 68.4 12.217 C 68 15.017 65.8 15.017 63.8 15.017 L 62.6 15.017 L 63.4 9.817 C 63.4 9.517 63.7 9.317 64 9.317 L 64.5 9.317 C 65.9 9.317 67.2 9.317 67.9 10.117 C 68.4 10.517 68.5 11.217 68.4 12.217 Z"
            }), Object(jsx.c)("path", {
                fill: secondary,
                d: "M 90.7 12.117 L 87 12.117 C 86.7 12.117 86.4 12.317 86.4 12.617 L 86.2 13.617 L 85.9 13.217 C 85.1 12.017 83.3 11.617 81.5 11.617 C 77.4 11.617 73.9 14.717 73.2 19.117 C 72.8 21.317 73.3 23.417 74.6 24.817 C 75.7 26.117 77.4 26.717 79.3 26.717 C 82.6 26.717 84.5 24.617 84.5 24.617 L 84.3 25.617 C 84.2 26.017 84.5 26.417 84.9 26.417 L 88.3 26.417 C 88.8 26.417 89.3 26.017 89.4 25.517 L 91.4 12.717 C 91.4 12.517 91.1 12.117 90.7 12.117 Z M 85.5 19.317 C 85.1 21.417 83.5 22.917 81.3 22.917 C 80.2 22.917 79.4 22.617 78.8 21.917 C 78.2 21.217 78 20.317 78.2 19.317 C 78.5 17.217 80.3 15.717 82.4 15.717 C 83.5 15.717 84.3 16.117 84.9 16.717 C 85.5 17.417 85.7 18.317 85.5 19.317 Z"
            }), Object(jsx.c)("path", {
                fill: secondary,
                d: "M 95.1 5.417 L 91.9 25.717 C 91.8 26.117 92.1 26.417 92.5 26.417 L 95.7 26.417 C 96.2 26.417 96.7 26.017 96.8 25.517 L 100 5.617 C 100.1 5.217 99.8 4.917 99.4 4.917 L 95.8 4.917 C 95.4 4.917 95.2 5.117 95.1 5.417 Z"
            }));
        }, _fundingLogos[constants.h.CREDIT] = function(_ref) {
            var logoColor = _ref.logoColor, locale = _ref.locale;
            if (!CREDIT_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " credit logo available");
            var primary = CREDIT_LOGO_COLORS[logoColor].primary;
            switch ((locale || {}).country) {
              case constants.r.DE:
                return Object(jsx.c)("svg", {
                    width: "135",
                    height: "32",
                    viewBox: "0 0 135 32",
                    preserveAspectRatio: "xMinYMin meet",
                    xmlns: "http://www.w3.org/2000/svg"
                }, Object(jsx.c)("g", {
                    transform: "matrix(1.3333333,0,0,-1.3333333,10,40)",
                    fill: primary
                }, Object(jsx.c)("g", {
                    transform: "matrix(0.17016911,0,0,0.17819595,39.327112,22.053803)"
                }, Object(jsx.c)("path", {
                    d: "m 0,0 -1.35,-8.619 c -0.146,-0.929 -0.946,-1.613 -1.886,-1.613 h -40.935 c -0.922,0 -1.445,1.057 -0.884,1.79 l 29.853,39.007 h -19.237 c -0.683,0 -1.205,0.611 -1.099,1.286 l 1.35,8.619 c 0.145,0.929 0.945,1.613 1.885,1.613 H 7.112 c 0.922,0 1.444,-1.055 0.886,-1.788 L -21.724,1.286 H -1.1 C -0.416,1.286 0.106,0.675 0,0 m 203.3312,42.0833 c 0.684,0 1.206,-0.611 1.1,-1.287 l -4.446,-28.132 c -1.041,-6.73 -2.359,-13.391 -8.395,-18.456 -5.065,-4.302 -12.143,-5.828 -18.248,-5.828 -6.106,0 -12.767,1.526 -16.444,5.828 -4.371,5.065 -3.608,11.726 -2.567,18.456 l 4.394,27.808 c 0.146,0.928 0.946,1.611 1.885,1.611 h 10.668 c 0.683,0 1.205,-0.61 1.1,-1.285 l -4.101,-26.261 c -1.11,-6.799 -1.804,-14.223 6.938,-14.223 8.743,0 10.408,7.424 11.518,14.223 l 4.05,25.932 c 0.145,0.929 0.945,1.614 1.885,1.614 z m -361.2517,-52.3157 h -10.665 c -0.685,0 -1.207,0.611 -1.1,1.287 l 6.249,39.511 h -9.939 c -0.684,0 -1.206,0.61 -1.1,1.285 l 1.35,8.619 c 0.146,0.929 0.946,1.614 1.886,1.614 h 33.145 c 0.684,0 1.206,-0.611 1.1,-1.286 l -1.35,-8.619 c -0.145,-0.929 -0.945,-1.613 -1.885,-1.613 h -9.608 l -6.198,-39.188 c -0.147,-0.927 -0.946,-1.61 -1.885,-1.61 m -98.5277,28.8638 h 1.318 c 4.441,0 9.549,0.837 10.477,6.522 0.929,5.688 -2.034,6.505 -6.779,6.522 h -1.927 c -0.58,0 -1.075,-0.422 -1.166,-0.995 z m 23.345,-28.864 h -13.977 c -0.594,0 -1.136,0.341 -1.393,0.878 l -9.224,19.244 h -0.139 l -2.985,-18.819 c -0.119,-0.75 -0.766,-1.303 -1.526,-1.303 h -10.977 c -0.684,0 -1.206,0.611 -1.1,1.287 l 7.848,49.725 c 0.119,0.751 0.766,1.304 1.526,1.304 h 19.009 c 10.339,0 17.416,-4.926 15.681,-16.097 -1.179,-7.216 -6.175,-13.461 -13.807,-14.779 l 12.015,-19.748 c 0.451,-0.742 -0.083,-1.692 -0.951,-1.692 m 445.918,52.3159 h 11.349 c 0.385,0 0.743,-0.199 0.946,-0.526 l 19.517,-31.46 h 0.139 l 4.81,30.376 c 0.147,0.927 0.946,1.61 1.885,1.61 h 10.667 c 0.684,0 1.206,-0.611 1.099,-1.287 l -7.799,-49.418 c -0.147,-0.927 -0.946,-1.611 -1.886,-1.611 h -11.347 c -0.386,0 -0.744,0.2 -0.947,0.528 l -19.517,31.528 h -0.139 l -4.811,-30.445 c -0.146,-0.928 -0.946,-1.611 -1.885,-1.611 h -10.666 c -0.684,0 -1.206,0.611 -1.1,1.287 l 7.8,49.418 c 0.146,0.928 0.946,1.611 1.885,1.611 m -304.5422,0 h 11.349 c 0.385,0 0.743,-0.199 0.946,-0.526 l 19.517,-31.46 h 0.139 l 4.81,30.376 c 0.147,0.927 0.946,1.61 1.885,1.61 h 10.667 c 0.684,0 1.206,-0.611 1.099,-1.287 l -7.799,-49.418 c -0.147,-0.927 -0.946,-1.611 -1.886,-1.611 h -11.347 c -0.386,0 -0.744,0.2 -0.947,0.528 l -19.517,31.528 h -0.139 l -4.811,-30.445 c -0.146,-0.928 -0.946,-1.611 -1.885,-1.611 h -10.666 c -0.684,0 -1.206,0.611 -1.1,1.287 l 7.8,49.418 c 0.146,0.928 0.946,1.611 1.885,1.611 M 131.156,1.2855 h 15.004 c 0.684,0 1.206,-0.61 1.1,-1.286 l -1.35,-8.619 c -0.145,-0.928 -0.945,-1.613 -1.885,-1.613 h -26.969 c -0.685,0 -1.207,0.611 -1.1,1.287 l 7.799,49.418 c 0.147,0.927 0.946,1.611 1.885,1.611 h 10.666 c 0.684,0 1.206,-0.612 1.099,-1.287 z m -33.5321,20.607 2.937,18.58 c 0.147,0.928 0.946,1.611 1.885,1.611 h 10.666 c 0.684,0 1.206,-0.611 1.1,-1.287 l -7.8,-49.418 c -0.146,-0.927 -0.946,-1.611 -1.885,-1.611 h -10.664 c -0.685,0 -1.207,0.612 -1.1,1.288 l 3.196,20.152 h -19.636 l -3.145,-19.83 c -0.147,-0.927 -0.946,-1.61 -1.885,-1.61 h -10.666 c -0.685,0 -1.207,0.611 -1.1,1.287 l 7.799,49.418 c 0.147,0.928 0.946,1.611 1.885,1.611 h 10.666 c 0.684,0 1.206,-0.611 1.099,-1.287 l -2.988,-18.904 z m 221.8207,-2.9142 c 0.699,0 1.224,-0.638 1.094,-1.325 -1.342,-7.069 -3.07,-13.21 -8.427,-19.351 -6.245,-7.147 -14.432,-10.269 -23.175,-10.269 -16.444,0 -26.088,11.171 -23.521,27.615 2.706,16.999 15.958,28.17 32.819,28.17 10.373,0 17.776,-4.519 20.966,-13.617 0.198,-0.566 -0.087,-1.189 -0.644,-1.409 l -11.599,-4.569 c -0.598,-0.236 -1.275,0.081 -1.466,0.694 -1.354,4.349 -4.637,7.175 -9.686,7.175 -8.95,0 -14.987,-8.535 -16.236,-16.514 -1.318,-8.118 2.29,-16.374 11.24,-16.374 5.898,0 10.894,3.053 12.351,9.089 h -9.793 c -0.686,0 -1.209,0.614 -1.099,1.292 l 1.373,8.458 c 0.088,0.539 0.553,0.935 1.099,0.935 z m -438.1464,9.9777 -1.132,-7.133 h 14.032 c 0.684,0 1.206,-0.61 1.1,-1.285 l -1.35,-8.619 c -0.145,-0.929 -0.945,-1.613 -1.885,-1.613 h -12.076 c -0.937,0 -1.735,-0.68 -1.884,-1.605 l -1.198,-7.415 h 14.865 c 0.684,0 1.206,-0.611 1.1,-1.286 l -1.35,-8.619 c -0.145,-0.929 -0.945,-1.613 -1.885,-1.613 h -26.831 c -0.684,0 -1.206,0.611 -1.099,1.286 l 7.799,49.418 c 0.146,0.928 0.946,1.611 1.885,1.611 h 26.834 c 0.683,0 1.206,-0.61 1.1,-1.285 l -1.35,-8.619 c -0.146,-0.929 -0.946,-1.614 -1.886,-1.614 h -12.904 c -0.939,0 -1.738,-0.682 -1.885,-1.609 M 34.135,25.9168 H 33.996 L 25.739,9.2648 h 11.31 z m -13.807,-27.06 -4.747,-8.518 c -0.197,-0.353 -0.569,-0.571 -0.973,-0.571 H 2.701 c -0.844,0 -1.381,0.902 -0.979,1.644 l 27.171,50.089 c 0.194,0.359 0.57,0.583 0.978,0.583 h 13.29 c 0.523,0 0.976,-0.365 1.088,-0.876 L 55.21,-8.8812 c 0.152,-0.694 -0.377,-1.351 -1.088,-1.351 H 41.905 c -0.525,0 -0.979,0.367 -1.089,0.88 l -1.755,8.209 z m -216.5493,27.06 h -0.139 l -8.257,-16.652 h 11.31 z m -13.807,-27.06 -4.747,-8.518 c -0.197,-0.353 -0.569,-0.571 -0.973,-0.571 h -11.907 c -0.844,0 -1.381,0.902 -0.979,1.644 l 27.171,50.089 c 0.194,0.359 0.57,0.583 0.978,0.583 h 13.29 c 0.523,0 0.976,-0.365 1.088,-0.876 l 10.961,-50.089 c 0.152,-0.694 -0.377,-1.351 -1.088,-1.351 h -12.217 c -0.525,0 -0.979,0.367 -1.089,0.88 l -1.755,8.209 z m 517.9793,-39.4791 -6.146,-39.098 c -0.119,-0.757 0.467,-1.442 1.233,-1.442 h 6.181 c 1.024,0 1.896,0.745 2.055,1.756 l 6.06,38.396 c 0.119,0.757 -0.466,1.442 -1.233,1.442 h -6.917 c -0.614,0 -1.138,-0.447 -1.233,-1.054 m -77.0618,-12.7966 h -7.207 c -0.689,0 -1.334,-0.342 -1.721,-0.912 l -9.942,-14.642 -4.213,14.07 c -0.263,0.88 -1.073,1.484 -1.993,1.484 h -7.084 c -0.856,0 -1.457,-0.842 -1.182,-1.651 l 7.936,-23.294 -7.464,-10.531 c -0.586,-0.827 0.005,-1.97 1.018,-1.97 h 7.2 c 0.683,0 1.322,0.334 1.71,0.895 l 23.968,34.591 c 0.574,0.828 -0.019,1.96 -1.026,1.96 m 58.6183,-13.956 c -0.693,-4.097 -3.945,-6.847 -8.093,-6.847 -2.08,0 -3.744,0.669 -4.815,1.935 -1.06,1.256 -1.46,3.045 -1.123,5.037 0.645,4.06 3.95,6.899 8.035,6.899 2.036,0 3.689,-0.675 4.78,-1.954 1.099,-1.287 1.53,-3.088 1.216,-5.07 m 9.992,13.956 h -7.169 c -0.615,0 -1.138,-0.447 -1.234,-1.054 l -0.315,-2.004 -0.501,0.726 c -1.553,2.254 -5.014,3.007 -8.469,3.007 -7.922,0 -14.689,-6.003 -16.006,-14.422 -0.685,-4.201 0.288,-8.215 2.669,-11.016 2.189,-2.574 5.311,-3.646 9.031,-3.646 6.385,0 9.927,4.102 9.927,4.102 l -0.321,-1.993 c -0.12,-0.758 0.466,-1.443 1.233,-1.443 h 6.457 c 1.024,0 1.896,0.744 2.055,1.756 l 3.876,24.545 c 0.12,0.757 -0.466,1.442 -1.233,1.442 m -116.7913,-13.956 c -0.693,-4.097 -3.945,-6.847 -8.093,-6.847 -2.08,0 -3.744,0.669 -4.815,1.935 -1.06,1.256 -1.46,3.045 -1.123,5.037 0.645,4.06 3.95,6.899 8.035,6.899 2.036,0 3.689,-0.675 4.78,-1.954 1.099,-1.287 1.531,-3.088 1.216,-5.07 m 9.992,13.956 h -7.169 c -0.615,0 -1.138,-0.447 -1.233,-1.054 l -0.316,-2.004 -0.501,0.726 c -1.553,2.254 -5.014,3.007 -8.469,3.007 -7.921,0 -14.689,-6.003 -16.006,-14.422 -0.685,-4.201 0.288,-8.215 2.669,-11.016 2.189,-2.574 5.311,-3.646 9.031,-3.646 6.385,0 9.927,4.102 9.927,4.102 l -0.321,-1.993 c -0.12,-0.758 0.466,-1.443 1.233,-1.443 h 6.457 c 1.024,0 1.896,0.744 2.055,1.756 l 3.876,24.545 c 0.12,0.757 -0.466,1.442 -1.233,1.442 m -43.0269,-0.172 c -0.818,-5.375 -4.924,-5.375 -8.894,-5.375 h -2.259 l 1.585,10.035 c 0.096,0.607 0.618,1.054 1.233,1.054 h 1.035 c 2.703,0 5.256,0 6.572,-1.54 0.787,-0.922 1.026,-2.287 0.728,-4.174 m -1.728,14.023 h -14.974 c -1.024,0 -1.896,-0.745 -2.055,-1.756 l -6.055,-38.396 c -0.119,-0.757 0.466,-1.442 1.233,-1.442 h 7.149 c 1.024,0 1.896,0.745 2.055,1.756 l 1.634,10.358 c 0.16,1.012 1.031,1.757 2.055,1.757 h 4.739 c 9.863,0 15.555,4.773 17.043,14.233 0.669,4.138 0.027,7.389 -1.911,9.665 -2.129,2.502 -5.904,3.825 -10.913,3.825 m 108.5272,-14.023 c -0.818,-5.375 -4.923,-5.375 -8.894,-5.375 h -2.259 l 1.585,10.035 c 0.096,0.607 0.619,1.054 1.233,1.054 h 1.035 c 2.703,0 5.256,0 6.572,-1.54 0.787,-0.922 1.026,-2.287 0.728,-4.174 m -1.728,14.023 h -14.974 c -1.024,0 -1.896,-0.745 -2.055,-1.756 l -6.055,-38.396 c -0.119,-0.757 0.466,-1.442 1.233,-1.442 h 7.683 c 0.717,0 1.327,0.521 1.438,1.229 l 1.717,10.885 c 0.16,1.012 1.031,1.757 2.055,1.757 h 4.739 c 9.863,0 15.555,4.773 17.043,14.233 0.669,4.138 0.027,7.389 -1.911,9.665 -2.129,2.502 -5.903,3.825 -10.913,3.825 m -161.6161,-40.475 -4.55,18.557 h 3.561 l 3.442,-14.442 7.914,14.442 h 3.798 l -15.748,-27.656 h -3.758 z M 82.525,-65.6994 c -0.989,1.121 -2.328,1.681 -4.016,1.681 -1.319,0 -2.546,-0.356 -3.679,-1.068 -1.135,-0.712 -2.045,-1.701 -2.731,-2.967 -0.686,-1.267 -1.028,-2.691 -1.028,-4.274 0,-1.767 0.5,-3.205 1.503,-4.313 1.002,-1.107 2.242,-1.661 3.719,-1.661 1.346,0 2.612,0.369 3.799,1.108 1.187,0.738 2.136,1.746 2.848,3.026 0.713,1.28 1.069,2.672 1.069,4.175 0,1.74 -0.495,3.171 -1.484,4.293 m -8.527,12.206 -1.661,-10.604 c 0.791,0.976 1.806,1.761 3.047,2.354 1.239,0.594 2.65,0.891 4.233,0.891 1.529,0 2.908,-0.376 4.135,-1.128 1.226,-0.752 2.182,-1.787 2.868,-3.106 0.686,-1.319 1.029,-2.809 1.029,-4.472 0,-2.162 -0.515,-4.153 -1.543,-5.974 -1.029,-1.819 -2.388,-3.264 -4.075,-4.332 -1.689,-1.068 -3.469,-1.602 -5.342,-1.602 -1.635,0 -2.981,0.329 -4.036,0.988 -1.055,0.659 -1.912,1.623 -2.571,2.889 l -0.515,-3.205 h -3.403 l 4.313,27.301 z M 39.4576,-76.5416 c 0.976,-1.121 2.308,-1.681 3.996,-1.681 1.319,0 2.552,0.356 3.699,1.069 1.148,0.712 2.064,1.701 2.751,2.967 0.685,1.266 1.028,2.691 1.028,4.273 0,1.767 -0.501,3.198 -1.503,4.293 -1.003,1.095 -2.256,1.642 -3.759,1.642 -1.32,0 -2.572,-0.37 -3.759,-1.108 -1.187,-0.738 -2.136,-1.741 -2.849,-3.007 -0.712,-1.266 -1.068,-2.651 -1.068,-4.155 0,-1.741 0.488,-3.171 1.464,-4.293 m 9.892,-4.253 0.474,2.968 c -0.844,-1.108 -1.899,-1.986 -3.165,-2.631 -1.266,-0.647 -2.704,-0.969 -4.313,-0.969 -1.53,0 -2.902,0.369 -4.115,1.107 -1.214,0.738 -2.163,1.767 -2.848,3.086 -0.687,1.319 -1.029,2.823 -1.029,4.51 0,2.111 0.507,4.083 1.523,5.916 1.016,1.833 2.347,3.29 3.996,4.372 1.648,1.081 3.357,1.622 5.124,1.622 3.297,0 5.553,-1.279 6.766,-3.837 l 1.781,11.157 h 3.521 l -4.313,-27.301 z m -28.8284,15.3321 c -1.253,-1.094 -2.104,-2.421 -2.552,-3.976 h 11.474 c 0.026,0.21 0.04,0.501 0.04,0.87 0,1.478 -0.395,2.638 -1.187,3.482 -0.792,0.844 -1.913,1.266 -3.363,1.266 -1.688,0 -3.159,-0.548 -4.412,-1.642 m 10.406,2.454 c 1.306,-1.439 1.958,-3.305 1.958,-5.6 0,-0.764 -0.039,-1.397 -0.118,-1.899 -0.079,-0.501 -0.212,-1.095 -0.396,-1.78 h -14.877 c -0.079,-1.979 0.435,-3.502 1.543,-4.57 1.108,-1.068 2.612,-1.602 4.511,-1.602 1.319,0 2.519,0.164 3.601,0.494 1.081,0.33 2.149,0.824 3.205,1.484 l -0.476,-2.968 c -2.031,-1.371 -4.431,-2.057 -7.201,-2.057 -1.82,0 -3.396,0.39 -4.728,1.167 -1.332,0.777 -2.348,1.854 -3.046,3.225 -0.699,1.371 -1.049,2.914 -1.049,4.629 0,1.688 0.422,3.435 1.266,5.243 0.845,1.806 2.124,3.323 3.839,4.55 1.714,1.226 3.824,1.84 6.33,1.84 2.453,0 4.333,-0.719 5.638,-2.156 m -18.0138,-1.4448 c -1.556,0 -2.875,-0.561 -3.956,-1.681 -1.082,-1.122 -1.794,-2.751 -2.137,-4.888 l -1.543,-9.772 h -3.522 l 3.047,19.308 h 3.403 l -0.515,-3.283 c 1.583,2.268 3.483,3.402 5.698,3.402 0.554,0 1.068,-0.039 1.543,-0.119 l -0.475,-3.086 c -0.474,0.079 -0.989,0.119 -1.543,0.119 m -24.5657,-1.0092 c -1.253,-1.094 -2.104,-2.421 -2.552,-3.976 h 11.474 c 0.026,0.21 0.04,0.501 0.04,0.87 0,1.478 -0.396,2.638 -1.187,3.482 -0.792,0.844 -1.913,1.266 -3.363,1.266 -1.689,0 -3.159,-0.548 -4.412,-1.642 m 10.406,2.454 c 1.305,-1.439 1.958,-3.305 1.958,-5.6 0,-0.764 -0.039,-1.397 -0.118,-1.899 -0.079,-0.501 -0.212,-1.095 -0.396,-1.78 h -14.877 c -0.079,-1.979 0.435,-3.502 1.543,-4.57 1.108,-1.068 2.612,-1.602 4.511,-1.602 1.319,0 2.519,0.164 3.601,0.494 1.081,0.33 2.149,0.824 3.204,1.484 l -0.475,-2.968 c -2.031,-1.371 -4.431,-2.057 -7.201,-2.057 -1.82,0 -3.396,0.39 -4.728,1.167 -1.332,0.777 -2.348,1.854 -3.046,3.225 -0.699,1.371 -1.049,2.914 -1.049,4.629 0,1.688 0.422,3.435 1.266,5.243 0.844,1.806 2.124,3.323 3.838,4.55 1.715,1.226 3.824,1.84 6.331,1.84 2.453,0 4.333,-0.719 5.638,-2.156 m -24.4869,-17.7856 h -3.561 l -2.057,14.837 -6.766,-14.837 h -3.522 l -2.77,19.308 h 3.522 l 1.741,-15.193 6.805,15.193 h 3.324 l 2.017,-15.154 6.529,15.154 h 3.6 z M -59.063,-65.225 c -1.201,-0.778 -2.124,-1.807 -2.77,-3.086 -0.647,-1.28 -0.969,-2.619 -0.969,-4.017 0,-1.741 0.494,-3.171 1.484,-4.292 0.988,-1.122 2.261,-1.682 3.817,-1.682 1.53,0 2.889,0.402 4.076,1.207 1.187,0.805 2.11,1.852 2.769,3.146 0.659,1.292 0.99,2.637 0.99,4.035 0,1.715 -0.495,3.12 -1.484,4.215 -0.989,1.093 -2.262,1.641 -3.818,1.641 -1.53,0 -2.896,-0.389 -4.095,-1.167 M -50.28,-62 c 1.332,-0.766 2.368,-1.827 3.106,-3.185 0.738,-1.359 1.108,-2.896 1.108,-4.61 0,-1.952 -0.482,-3.825 -1.444,-5.618 -0.963,-1.794 -2.321,-3.251 -4.075,-4.372 -1.755,-1.122 -3.766,-1.682 -6.034,-1.682 -1.688,0 -3.199,0.383 -4.531,1.148 -1.331,0.764 -2.374,1.833 -3.125,3.205 -0.752,1.37 -1.128,2.914 -1.128,4.628 0,1.979 0.481,3.859 1.444,5.639 0.963,1.781 2.321,3.224 4.076,4.332 1.753,1.108 3.764,1.663 6.033,1.663 1.715,0 3.238,-0.383 4.57,-1.148 m -20.7559,4.1545 c -0.897,0.87 -2.255,1.305 -4.075,1.305 h -4.471 l -1.82,-11.513 h 4.668 c 2.401,0 4.175,0.639 5.322,1.919 1.148,1.279 1.721,2.894 1.721,4.847 0,1.424 -0.448,2.571 -1.345,3.442 m 3.027,2.373 c 1.464,-1.318 2.196,-3.112 2.196,-5.38 0,-3.113 -0.944,-5.599 -2.829,-7.459 -1.887,-1.859 -4.715,-2.789 -8.487,-2.789 h -4.748 l -1.543,-9.694 h -3.759 l 4.313,27.301 h 8.309 c 2.901,0 5.084,-0.66 6.548,-1.979"
                }))));

              default:
                return Object(jsx.c)("svg", {
                    width: "100",
                    height: "32",
                    viewBox: "0 0 95 32",
                    preserveAspectRatio: "xMinYMin meet",
                    xmlns: "http://www.w3.org/2000/svg"
                }, Object(jsx.c)("path", {
                    fill: primary,
                    d: "M 52.732 6.347 C 52.83 5.963 53.122 5.675 53.512 5.675 L 60.626 5.675 C 66.571 5.675 70.664 10.187 69.69 15.851 C 68.813 21.515 63.16 25.931 57.313 25.931 L 50.004 25.931 C 49.711 25.931 49.516 25.739 49.614 25.451 L 52.732 6.347 Z M 55.753 21.515 L 57.02 21.515 C 60.236 21.515 63.355 19.787 64.037 15.851 C 64.622 12.203 62.478 10.187 58.97 10.187 L 57.995 10.187 C 57.8 10.187 57.605 10.283 57.605 10.475 L 55.753 21.515 Z"
                }), Object(jsx.c)("path", {
                    fill: primary,
                    d: "M 43.571 10.763 L 43.084 13.547 L 48.737 13.547 C 49.029 13.547 49.224 13.739 49.224 14.027 L 48.639 17.387 C 48.542 17.771 48.249 17.963 47.859 17.963 L 42.987 17.963 C 42.597 17.963 42.304 18.251 42.207 18.635 L 41.72 21.515 L 47.762 21.515 C 48.054 21.515 48.249 21.707 48.152 21.995 L 47.665 25.355 C 47.567 25.643 47.275 25.931 46.885 25.931 L 36.067 25.931 C 35.775 25.931 35.58 25.643 35.58 25.451 L 38.699 6.347 C 38.796 5.963 39.186 5.675 39.478 5.675 L 50.393 5.675 C 50.588 5.675 50.881 5.963 50.783 6.155 L 50.296 9.515 C 50.198 9.899 49.906 10.091 49.516 10.091 L 44.254 10.091 C 43.864 10.187 43.571 10.379 43.571 10.763 Z"
                }), Object(jsx.c)("path", {
                    fill: primary,
                    d: "M 74.563 25.931 L 70.274 25.931 C 69.982 25.931 69.787 25.739 69.787 25.451 L 73.003 6.347 C 73.003 5.963 73.393 5.675 73.685 5.675 L 78.071 5.675 C 78.266 5.675 78.558 5.963 78.461 6.251 L 75.342 25.355 C 75.245 25.643 74.952 25.931 74.563 25.931 Z"
                }), Object(jsx.c)("path", {
                    fill: primary,
                    d: "M 34.118 25.931 L 28.466 25.931 C 28.173 25.931 27.978 25.835 27.881 25.643 L 24.178 18.155 L 24.08 18.155 L 22.911 25.451 C 22.813 25.739 22.618 25.931 22.326 25.931 L 17.843 25.931 C 17.551 25.931 17.356 25.739 17.453 25.451 L 20.572 6.251 C 20.669 5.963 20.864 5.675 21.156 5.675 L 28.855 5.675 C 33.046 5.675 35.97 7.595 35.288 11.915 C 34.8 14.699 32.754 17.195 29.635 17.675 L 34.508 25.355 C 34.703 25.547 34.411 25.931 34.118 25.931 Z M 24.665 14.795 L 25.152 14.795 C 27.004 14.795 29.05 14.411 29.44 12.203 C 29.83 10.091 28.661 9.707 26.711 9.707 L 25.932 9.707 C 25.639 9.707 25.445 9.899 25.445 10.091 L 24.665 14.795 Z"
                }), Object(jsx.c)("path", {
                    fill: primary,
                    d: "M 86.16 25.931 L 81.872 25.931 C 81.579 25.931 81.384 25.739 81.482 25.451 L 83.918 10.187 L 79.923 10.187 C 79.63 10.187 79.435 9.899 79.533 9.611 L 80.02 6.347 C 80.118 5.963 80.41 5.675 80.8 5.675 L 94.249 5.675 C 94.444 5.675 94.736 5.963 94.639 6.251 L 94.054 9.515 C 94.054 9.899 93.761 10.187 93.372 10.187 L 89.473 10.187 L 86.939 25.355 C 86.939 25.643 86.647 25.931 86.16 25.931 Z"
                }), Object(jsx.c)("path", {
                    fill: primary,
                    d: "M 17.648 11.435 C 17.648 11.819 17.161 12.011 16.868 11.723 C 15.894 10.763 14.529 10.283 13.068 10.283 C 9.657 10.283 7.025 12.779 6.441 15.851 C 5.953 19.019 7.902 21.323 11.313 21.323 C 12.678 21.323 14.237 20.843 15.407 19.979 C 15.796 19.787 16.284 20.075 16.186 20.459 L 15.407 25.067 C 15.309 25.355 15.114 25.547 14.822 25.643 C 13.165 26.123 11.898 26.507 10.339 26.507 C 1.178 26.507 -0.284 19.019 0.203 15.851 C 1.47 6.923 9.072 4.907 13.652 5.195 C 15.114 5.195 16.479 5.387 17.745 5.867 C 18.233 6.059 18.428 6.443 18.33 6.923 L 17.648 11.435 Z"
                }));
            }
        }, _fundingLogos[constants.h.VENMO] = ((_BUTTON_LOGO$VENMO = {})[constants.i.WHITE] = '<svg width="101" height="32" viewBox="0 0 101 32" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">\n    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g id="White" fill="#FFFFFF">\n            <g id="Logo" transform="translate(0.000000, 6.000000)">\n                <path d="M16.6660484,0.18 C17.3466626,1.3390991 17.6535069,2.53297297 17.6535069,4.04108108 C17.6535069,8.85117117 13.671346,15.0998198 10.439346,19.4875676 L3.05725952,19.4875676 L0.0966314879,1.23315315 L6.56045675,0.60036036 L8.12578201,13.5895495 C9.58835986,11.1326126 11.3932543,7.27153153 11.3932543,4.6390991 C11.3932543,3.1981982 11.1538599,2.21675676 10.7797405,1.40864865 L16.6660484,0.18 Z M24.9071592,11.6938739 C24.9071592,13.8367568 26.062718,14.6774775 27.5946678,14.6774775 C29.2629152,14.6774775 30.860218,14.2571171 32.9363097,13.1691892 L32.154346,18.6445045 C30.6915934,19.3814414 28.4119291,19.8731532 26.1991903,19.8731532 C20.5863512,19.8731532 18.5775346,16.3632432 18.5775346,11.9753153 C18.5775346,6.28810811 21.8451817,0.249369369 28.5819516,0.249369369 C32.2909931,0.249369369 34.3649879,2.39207207 34.3649879,5.37567568 C34.3653374,10.1855856 28.3783789,11.6590991 24.9071592,11.6938739 Z M25.0434567,8.2181982 C26.2329152,8.2181982 29.2274429,7.65711712 29.2274429,5.90216216 C29.2274429,5.05945946 28.6495761,4.6390991 27.9686125,4.6390991 C26.7772318,4.6390991 25.2138287,6.11225225 25.0434567,8.2181982 Z M53.0187093,4.4636036 C53.0187093,5.16558559 52.9154377,6.18378378 52.8126903,6.84918919 L50.8730709,19.4873874 L44.5790934,19.4873874 L46.3483408,7.90216216 C46.381891,7.58792793 46.4849879,6.95531532 46.4849879,6.60432432 C46.4849879,5.76162162 45.9743962,5.55135135 45.3605329,5.55135135 C44.5451938,5.55135135 43.7279325,5.93711712 43.1836159,6.21873874 L41.1768962,19.4875676 L34.8474464,19.4875676 L37.7390519,0.565945946 L43.2171661,0.565945946 L43.2865381,2.07621622 C44.5789187,1.19873874 46.2807163,0.24972973 48.6952803,0.24972973 C51.8942543,0.249369369 53.0187093,1.93495495 53.0187093,4.4636036 Z M71.7037093,2.32072072 C73.5063322,0.988108108 75.2084792,0.249369369 77.5554187,0.249369369 C80.7872439,0.249369369 81.9113495,1.93495495 81.9113495,4.4636036 C81.9113495,5.16558559 81.8084273,6.18378378 81.7056799,6.84918919 L79.7683322,19.4873874 L73.4726073,19.4873874 L75.2755796,7.6572973 C75.3087803,7.34108108 75.3785017,6.95531532 75.3785017,6.71063063 C75.3785017,5.7618018 74.8677353,5.55135135 74.2540467,5.55135135 C73.4722578,5.55135135 72.6908183,5.90234234 72.1106799,6.21873874 L70.1043097,19.4875676 L63.8101574,19.4875676 L65.6131298,7.65747748 C65.6463304,7.34126126 65.713955,6.9554955 65.713955,6.71081081 C65.713955,5.76198198 65.2030138,5.55153153 64.5914221,5.55153153 C63.7743356,5.55153153 62.9588218,5.9372973 62.4145052,6.21891892 L60.4062128,19.4877477 L54.0788599,19.4877477 L56.9701159,0.566126126 L62.3813045,0.566126126 L62.551327,2.14576577 C63.8101574,1.1990991 65.5105571,0.25009009 67.7900467,0.25009009 C69.7637405,0.249369369 71.0559464,1.12702703 71.7037093,2.32072072 Z M83.55059,11.7998198 C83.55059,5.83279279 86.6120433,0.249369369 93.6558322,0.249369369 C98.9633997,0.249369369 100.903543,3.47981982 100.903543,7.93873874 C100.903543,13.8365766 97.8751159,19.9443243 90.6614792,19.9443243 C85.3196626,19.9443243 83.55059,16.3281081 83.55059,11.7998198 Z M94.4374464,7.83279279 C94.4374464,6.28810811 94.0628028,5.23495495 92.9409689,5.23495495 C90.4570329,5.23495495 89.9469654,9.76306306 89.9469654,12.0794595 C89.9469654,13.8367568 90.4238322,14.9243243 91.5453166,14.9243243 C93.8931298,14.9243243 94.4374464,10.149009 94.4374464,7.83279279 Z"></path>\n            </g>\n        </g>\n    </g>\n</svg>\n', 
        _BUTTON_LOGO$VENMO[constants.i.BLUE] = '<svg width="101" height="32" viewBox="0 0 101 32" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">\n    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g id="Blue" fill="#3D93CE">\n            <g id="Logo" transform="translate(0.000000, 6.000000)">\n                <path d="M16.6660484,0.18 C17.3466626,1.3390991 17.6535069,2.53297297 17.6535069,4.04108108 C17.6535069,8.85117117 13.671346,15.0998198 10.439346,19.4875676 L3.05725952,19.4875676 L0.0966314879,1.23315315 L6.56045675,0.60036036 L8.12578201,13.5895495 C9.58835986,11.1326126 11.3932543,7.27153153 11.3932543,4.6390991 C11.3932543,3.1981982 11.1538599,2.21675676 10.7797405,1.40864865 L16.6660484,0.18 Z M24.9071592,11.6938739 C24.9071592,13.8367568 26.062718,14.6774775 27.5946678,14.6774775 C29.2629152,14.6774775 30.860218,14.2571171 32.9363097,13.1691892 L32.154346,18.6445045 C30.6915934,19.3814414 28.4119291,19.8731532 26.1991903,19.8731532 C20.5863512,19.8731532 18.5775346,16.3632432 18.5775346,11.9753153 C18.5775346,6.28810811 21.8451817,0.249369369 28.5819516,0.249369369 C32.2909931,0.249369369 34.3649879,2.39207207 34.3649879,5.37567568 C34.3653374,10.1855856 28.3783789,11.6590991 24.9071592,11.6938739 Z M25.0434567,8.2181982 C26.2329152,8.2181982 29.2274429,7.65711712 29.2274429,5.90216216 C29.2274429,5.05945946 28.6495761,4.6390991 27.9686125,4.6390991 C26.7772318,4.6390991 25.2138287,6.11225225 25.0434567,8.2181982 Z M53.0187093,4.4636036 C53.0187093,5.16558559 52.9154377,6.18378378 52.8126903,6.84918919 L50.8730709,19.4873874 L44.5790934,19.4873874 L46.3483408,7.90216216 C46.381891,7.58792793 46.4849879,6.95531532 46.4849879,6.60432432 C46.4849879,5.76162162 45.9743962,5.55135135 45.3605329,5.55135135 C44.5451938,5.55135135 43.7279325,5.93711712 43.1836159,6.21873874 L41.1768962,19.4875676 L34.8474464,19.4875676 L37.7390519,0.565945946 L43.2171661,0.565945946 L43.2865381,2.07621622 C44.5789187,1.19873874 46.2807163,0.24972973 48.6952803,0.24972973 C51.8942543,0.249369369 53.0187093,1.93495495 53.0187093,4.4636036 Z M71.7037093,2.32072072 C73.5063322,0.988108108 75.2084792,0.249369369 77.5554187,0.249369369 C80.7872439,0.249369369 81.9113495,1.93495495 81.9113495,4.4636036 C81.9113495,5.16558559 81.8084273,6.18378378 81.7056799,6.84918919 L79.7683322,19.4873874 L73.4726073,19.4873874 L75.2755796,7.6572973 C75.3087803,7.34108108 75.3785017,6.95531532 75.3785017,6.71063063 C75.3785017,5.7618018 74.8677353,5.55135135 74.2540467,5.55135135 C73.4722578,5.55135135 72.6908183,5.90234234 72.1106799,6.21873874 L70.1043097,19.4875676 L63.8101574,19.4875676 L65.6131298,7.65747748 C65.6463304,7.34126126 65.713955,6.9554955 65.713955,6.71081081 C65.713955,5.76198198 65.2030138,5.55153153 64.5914221,5.55153153 C63.7743356,5.55153153 62.9588218,5.9372973 62.4145052,6.21891892 L60.4062128,19.4877477 L54.0788599,19.4877477 L56.9701159,0.566126126 L62.3813045,0.566126126 L62.551327,2.14576577 C63.8101574,1.1990991 65.5105571,0.25009009 67.7900467,0.25009009 C69.7637405,0.249369369 71.0559464,1.12702703 71.7037093,2.32072072 Z M83.55059,11.7998198 C83.55059,5.83279279 86.6120433,0.249369369 93.6558322,0.249369369 C98.9633997,0.249369369 100.903543,3.47981982 100.903543,7.93873874 C100.903543,13.8365766 97.8751159,19.9443243 90.6614792,19.9443243 C85.3196626,19.9443243 83.55059,16.3281081 83.55059,11.7998198 Z M94.4374464,7.83279279 C94.4374464,6.28810811 94.0628028,5.23495495 92.9409689,5.23495495 C90.4570329,5.23495495 89.9469654,9.76306306 89.9469654,12.0794595 C89.9469654,13.8367568 90.4238322,14.9243243 91.5453166,14.9243243 C93.8931298,14.9243243 94.4374464,10.149009 94.4374464,7.83279279 Z"></path>\n            </g>\n        </g>\n    </g>\n</svg>\n', 
        _BUTTON_LOGO$VENMO), _fundingLogos[constants.h.ITAU] = ((_BUTTON_LOGO$ITAU = {})[constants.i.WHITE] = '<?xml version="1.0" encoding="UTF-8"?>\n\x3c!-- Generator: Adobe Illustrator 23.0.4, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --\x3e\n<svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 181 33" preserveAspectRatio="xMinYMin meet">\n   <path fill="#FF7900" d="M136.5,5.6L153,1.8c2.2-0.5,4.4,0.8,5,2.9l4,15.2c0.5,2.1-0.8,4.2-3,4.7l-16.5,3.8c-2.2,0.5-4.4-0.8-5-2.9  l-4-15.2C132.8,8.3,134.2,6.1,136.5,5.6z" />\n   <path fill="#004995" d="M144.5,6.1h10.1c1.5,0,2.7,1.2,2.7,2.5v9.7c0,1.3-1.2,2.5-2.7,2.5h-10.1c-1.5,0-2.7-1.2-2.7-2.5V8.6  C141.9,7.2,143.1,6.1,144.5,6.1z" />\n   <path fill="#FFFFFF" d="M108.2,19.9c-0.1-1-0.5-1.9-1.1-2.8c-1.1-1.3-2.8-2-4.6-1.9c-1.6,0.1-3.9,0.3-5.3,1.3L98,19  c0,0,1.3-1.1,3.9-1.1c1.1,0,2.1,0.6,2.3,1.3v0.2c-1.4,0-5.7,0.3-7.4,2.8c-2,3,1.1,5.8,3.1,5.8c1.6,0,3.2,0.1,4.6-1.3l0.2,1.1h3.4  v-7.3c0-0.1,0-0.2,0-0.2L108.2,19.9L108.2,19.9z M100.4,24.1c0.2-1.8,2.7-1.9,3.9-1.9v2.1C103,26,100.2,25.8,100.4,24.1z" />\n   <path fill="#FFFFFF" d="M95.2,16.1c0,0-7.6-2-10,3c-1.3,2.8-0.7,5.7,0.8,7.3c0.7,0.7,1.6,1.2,2.6,1.5c2,0.6,5.4,0.4,6.5-0.2l-0.4-2.8  c0,0-3.4,1.1-5.2-0.6c-2.2-2.2-0.2-5.7,2.1-5.7c2.3,0,3.1,0.4,3.1,0.4L95.2,16.1z" />\n   <rect fill="#FFFFFF" x="42.3" y="11.7" width="3.9" height="16.3" />\n   <path fill="#FFFFFF" d="M55.7,18.7v-3h-2.1v-4.1h-3.9v4.1h-2v3h2v6.2c0,1.7,1.3,3,3,3l0,0h3.1v-3h-1.1c-0.7,0-1.1-0.5-1.1-1.1l0,0v-5.2  L55.7,18.7L55.7,18.7z" />\n   <path fill="#FFFFFF" d="M69,19.9c-0.1-1-0.5-1.9-1.1-2.8c-1.2-1.3-2.8-2-4.6-1.9c-1.6,0.1-3.9,0.3-5.3,1.3l0.8,2.5c0,0,1.3-1.1,3.9-1.1  c1.1,0,2.1,0.6,2.3,1.3v0.2c-1.4,0-5.8,0.3-7.4,2.8c-2,3,1.1,5.8,3.1,5.8c1.6,0,3.2,0.1,4.6-1.3l0.2,1.1H69V19.9L69,19.9z   M61.1,24.1c0.2-1.8,2.7-1.9,3.9-1.9v2.1C63.8,26,60.9,25.8,61.1,24.1L61.1,24.1z" />\n   <path fill="#FFFFFF" d="M79.1,15.7v7.2c0,0.3-0.1,0.5-0.2,0.7c-0.5,0.7-1.1,1.3-2,1.3c-0.9,0.1-1.8-0.5-2.1-1.3  c-0.1-0.2-0.1-0.4-0.1-0.6v-7.3h-3.9V24c0,2.1,1.8,4.1,3.9,4.1c3.9,0.2,4.6-1.8,4.6-1.8v-0.1l0.4,1.5H83V15.6L79.1,15.7z" />\n   <rect fill="#FFF100" x="143.1" y="13.5" width="1.2" height="5" />\n   <path fill="#FFF100" d="M147.3,15.7v-0.9h-0.7v-1.3h-1.2v1.3h-0.6v0.9h0.6v1.9c0,0.5,0.4,0.9,1,0.9h1v-0.9H147c-0.2,0-0.4-0.2-0.4-0.3  l0,0v-1.6C146.6,15.7,147.3,15.7,147.3,15.7z" />\n   <path fill="#FFF100" d="M151.6,16c0-0.3-0.2-0.6-0.4-0.8c-0.4-0.4-0.9-0.6-1.5-0.6s-1.1,0.2-1.7,0.4l0.3,0.8c0.4-0.3,0.8-0.3,1.2-0.3  c0.3,0,0.6,0.2,0.7,0.3v0.1c-0.4,0-1.9,0.1-2.3,0.8c-0.4,0.6-0.2,1.3,0.4,1.6c0.2,0.1,0.4,0.2,0.5,0.2c0.5,0.1,1.1-0.1,1.5-0.3  l0.1,0.3h1.1L151.6,16L151.6,16z M149.1,17.3c0.1-0.6,0.9-0.6,1.2-0.6v0.7C149.9,17.9,149,17.8,149.1,17.3L149.1,17.3z" />\n   <path fill="#FFF100" d="M154.8,14.8V17c-0.1,0.3-0.4,0.4-0.7,0.5c-0.4,0-0.6-0.2-0.7-0.5v-2.3h-1.2v2.5c0,0.7,0.5,1.2,1.2,1.3  c1.2,0.1,1.5-0.5,1.5-0.5l0,0l0.2,0.4h1.1v-3.8L154.8,14.8L154.8,14.8z" />\n   <path fill="#FFFFFF" d="M113.5,17.9l-0.2-2.1H110V28h3.9v-6.8c0.4-0.8,1.2-2.1,3.4-2.1v-3.6C115.9,15.4,114.4,16.3,113.5,17.9z" />\n   <path fill="#FFFFFF" d="M128.1,10.4v6.4c-0.7-0.6-1.7-1.4-3.7-1.4c-3.6,0-6.1,3.2-6.1,6.8c-0.1,3.2,2.6,5.9,5.9,6  c1.5-0.1,3-0.6,4.2-1.4L129,28h3.1V10.5L128.1,10.4L128.1,10.4z M125.4,25.1c-2.3,0-2.8-1.9-2.8-3.4s0.7-3.2,2.8-3.2  c1.3,0,2.1,0.9,2.7,1.8v3C127.5,24.1,126.6,25.1,125.4,25.1z" />\n   <polygon fill="#FFF100" points="154.6,14.4 153.5,14.4 154.4,13.5 155.7,13.5 " />\n   <line fill="none" x1="35.6" y1="8.3" x2="35.6" y2="28.2" />\n   <rect fill="#D8D8D8" x="22.4" y="32.2" width="0.1" height="0.1" />\n   <path fill="#FFFFFF" opacity="0.7" enable-background="new    " d="M25.3,12.9c0.2-1.6,0-2.6-0.9-3.7s-2.6-1.5-4.6-1.5h-6.1c-0.4,0-0.8,0.3-0.9,0.8l-2.5,16.8  c-0.1,0.4,0.1,0.7,0.5,0.7h3.8l-0.3,1.7c-0.1,0.2,0.2,0.5,0.4,0.5H18c0.4,0,0.6-0.3,0.7-0.7l0.1-0.2l0.6-3.9l0.1-0.2  c0.1-0.5,0.4-0.7,0.7-0.7h0.5c3.1,0,5.4-1.4,6.1-5.1c0.3-1.6,0.1-2.9-0.6-3.8C25.9,13.4,25.6,13.1,25.3,12.9L25.3,12.9" />\n   <path fill="#FFFFFF" opacity="0.7" enable-background="new    " d="M25.3,12.9c0.2-1.6,0-2.6-0.9-3.7s-2.6-1.5-4.6-1.5h-6.1c-0.4,0-0.8,0.3-0.9,0.8l-2.5,16.8  c-0.1,0.4,0.1,0.7,0.5,0.7h3.8l0.9-6.3l-0.1,0.2c0.1-0.5,0.4-0.8,0.9-0.8h1.8c3.5,0,6.2-1.5,7-5.8C25.2,13.2,25.2,13,25.3,12.9" />\n   <path fill="#FFFFFF" d="M16.6,12.9c0-0.2,0.1-0.5,0.4-0.6c0.1,0,0.2-0.1,0.3-0.1h4.8c0.6,0,1.1,0.1,1.6,0.1c0.1,0,0.2,0,0.4,0.1  c0.1,0.1,0.2,0.1,0.4,0.2c0.1,0,0.1,0,0.2,0.1c0.2,0.1,0.4,0.2,0.6,0.2c0.2-1.6,0-2.6-0.9-3.6c-0.9-1.1-2.6-1.6-4.6-1.6h-6.1  c-0.4,0-0.8,0.4-0.9,0.8l-2.5,16.8c-0.1,0.4,0.1,0.7,0.5,0.7h3.8l0.9-6.3L16.6,12.9z" />\n   <g transform="matrix(0.379173, 0, 0, 0.397443, 9.686229, 4.778377)" opacity="0.2">\n      <path fill="#231F20" d="M41.1,20.5c0.9,0.5,1.7,1.1,2.3,1.8c1,1.1,1.6,2.5,1.9,4.1c0.3-3.2-0.2-5.8-1.9-7.8c-0.6-0.7-1.3-1.2-2.1-1.7   C41.3,18,41.3,19.2,41.1,20.5z" />\n      <path fill="#231F20" d="M2.2,49L8.5,9.4c0.1-1.1,1.1-1.9,2.2-1.9h16c5.5,0,9.8,1.2,12.2,3.9c1.2,1.4,1.9,3,2.2,4.8   c0.4-3.6-0.2-6.1-2.2-8.4c-2.4-2.8-6.7-4-12.2-4h-16c-1.1,0-2.1,0.8-2.3,1.9L1.8,47.9C1.8,48.3,1.9,48.7,2.2,49z" />\n      <path fill="#231F20" d="M12.5,53.2l-0.1,0.6c-0.1,0.4,0.1,0.8,0.4,1.1l0.3-1.7C13.1,53.2,12.5,53.2,12.5,53.2z" />\n   </g>\n   <rect fill="#FFFFFF" x="35.5" y="6.7" width="1.1" height="21.5" />\n</svg>', 
        _BUTTON_LOGO$ITAU), _fundingLogos[constants.h.IDEAL] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!IDEAL_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " ideal logo available");
            var _IDEAL_LOGO_COLORS$lo = IDEAL_LOGO_COLORS[logoColor], primary = _IDEAL_LOGO_COLORS$lo.primary, secondary = _IDEAL_LOGO_COLORS$lo.secondary, tertiary = _IDEAL_LOGO_COLORS$lo.tertiary;
            return Object(jsx.c)("svg", {
                width: "38",
                height: "32",
                viewBox: "0 0 38 32",
                preserveAspectRatio: "xMinYMin meet",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.c)("polygon", {
                fill: primary,
                points: "4.47 27.632 10.452 27.632 10.452 17.982 4.47 17.982"
            }), Object(jsx.c)("g", {
                transform: "matrix(0.952642, 0, 0, 0.930979, 0.31993, 0.181113)"
            }, Object(jsx.c)("path", {
                d: "M11.1102604,13.937999 C11.1102604,15.8893766 9.51859887,17.4723289 7.55546104,17.4723289 C5.59238806,17.4723289 4.00066169,15.8893766 4.00066169,13.937999 C4.00066169,11.9865569 5.59238806,10.4043136 7.55546104,10.4043136 C9.51859887,10.4043136 11.1102604,11.9865569 11.1102604,13.937999",
                fill: primary
            }), Object(jsx.c)("g", null, Object(jsx.c)("mask", {
                fill: secondary
            }, Object(jsx.c)("polygon", {
                points: "39.1898554 33.9678282 0 33.9678282 0 0.001572704 39.1898554 0.001572704",
                transform: "matrix(1, 0, 0, 1, 0, 0)"
            })), Object(jsx.c)("g", null), Object(jsx.c)("path", {
                d: "M22.1049929,2.25750057 C26.4717361,2.25750057 30.1110886,3.433548 32.6296578,5.65853743 C35.476843,8.17370364 36.9204068,11.9843525 36.9204068,16.9847134 C36.9204068,26.8945533 32.0742264,31.7119261 22.1049929,31.7119261 L2.26942909,31.7119261 L2.26942909,2.25750057 L22.1049929,2.25750057 Z M22.531325,0.001572704 L-1.9452416e-05,0.001572704 L-1.9452416e-05,33.967854 L22.531325,33.967854 L22.531325,33.9614085 C27.4529808,33.8947619 31.3518934,32.6793969 34.1187402,30.3394196 C37.4837488,27.4935988 39.1898554,23.0003706 39.1898554,16.9847134 C39.1898554,14.1090499 38.7410881,11.5297509 37.8560681,9.31836144 C37.0093692,7.2028812 35.758125,5.40419768 34.13722,3.97219912 C31.2823834,1.45020067 27.2749912,0.0865245021 22.531325,0.00904949351 L22.531325,0.001572704 Z",
                fill: primary
            })), Object(jsx.c)("path", {
                d: "M21.4851352,29.4975138 L13.5194356,29.4975138 L13.5194356,5.00387361 L21.4851352,5.00387361 L21.1636516,5.00387361 C27.8067813,5.00387361 34.8779291,7.60998594 34.8779291,17.282889 C34.8779291,27.5088167 27.8067813,29.4975138 21.1636516,29.4975138 L21.4851352,29.4975138 Z",
                fill: tertiary
            })), Object(jsx.c)("g", {
                transform: "matrix(0.952642, 0, 0, 0.930979, 11.685725, 10.562208)",
                fill: secondary
            }, Object(jsx.c)("path", {
                d: "M1.41115607,1.17495169 L1.41115607,5.07048794 L2.30681015,5.07048794 C2.64178075,5.07048794 2.88357428,5.05173151 3.03219074,5.0142831 C3.2267149,4.96613516 3.38810511,4.88459948 3.51649106,4.76961161 C3.64474732,4.65455929 3.749531,4.46538363 3.83058274,4.20189125 C3.91163447,3.93846333 3.95216034,3.57944852 3.95216034,3.12471792 C3.95216034,2.67005177 3.91163447,2.3210275 3.83058274,2.07764511 C3.749531,1.83426272 3.63605858,1.64437805 3.49016546,1.5079911 C3.34420749,1.37160414 3.15915018,1.27930447 2.93492866,1.23109207 C2.76737852,1.19370812 2.43915142,1.17495169 1.95018252,1.17495169 L1.41115607,1.17495169 Z M0.215675421,0.175897919 L2.40271056,0.175897919 C2.89589415,0.175897919 3.27190935,0.213410777 3.53069132,0.288436492 C3.878306,0.390275522 4.17612249,0.571265392 4.42407595,0.831212737 C4.67202941,1.09116008 4.86065301,1.40950373 4.99001157,1.78598587 C5.11937014,2.16253246 5.18408185,2.62686687 5.18408185,3.1789891 C5.18408185,3.66407805 5.12345515,4.08213371 5.00220176,4.433285 C4.85397434,4.86210466 4.6423969,5.20919527 4.36753426,5.47449239 C4.15997698,5.67552779 3.87966767,5.832347 3.52660632,5.94488558 C3.26244251,6.02796818 2.90938115,6.06954171 2.46742226,6.06954171 L0.215675421,6.06954171 L0.215675421,0.175897919 Z"
            }), Object(jsx.c)("path", {
                d: "M2.40271056,0.337035624 C2.87825729,0.337035624 3.24247136,0.372743739 3.48523751,0.443128689 C3.80302515,0.536201827 4.07944398,0.704171771 4.30645367,0.942075479 C4.53702965,1.18384649 4.7154083,1.48530291 4.83666169,1.83813003 C4.95966581,2.19611355 5.02197838,2.64723467 5.02197838,3.1789891 C5.02197838,3.64390361 4.96375081,4.04829479 4.84885188,4.38094747 C4.70970226,4.78359837 4.50973142,5.11264156 4.25458057,5.35892443 C4.06589213,5.54165459 3.80438682,5.68712971 3.47713234,5.79148248 C3.23060538,5.86895749 2.89070683,5.908404 2.46742226,5.908404 L0.377778888,5.908404 L0.377778888,0.337035624 L2.40271056,0.337035624 Z M0.0535719538,0.0147602138 L0.0535719538,6.23067941 L2.46742226,6.23067941 C2.92390562,6.23067941 3.2967436,6.18614095 3.57549672,6.09848204 C3.95157676,5.97866004 4.25594223,5.80759625 4.48061764,5.58993144 C4.77246872,5.30819828 4.9996081,4.93661473 5.15548679,4.48562252 C5.28205718,4.11919538 5.34618531,3.67954727 5.34618531,3.1789891 C5.34618531,2.61178438 5.27797217,2.12559969 5.1434263,1.73390616 C5.00706486,1.33699177 4.80456521,0.995959927 4.54169823,0.720349996 C4.27494076,0.440679396 3.9502151,0.243317935 3.57646934,0.133873205 C3.29992083,0.0536910833 2.91612466,0.0147602138 2.40271056,0.0147602138 L0.0535719538,0.0147602138 Z"
            }), Object(jsx.c)("path", {
                d: "M1.9501501,1.33608939 C2.54124418,1.33608939 2.79263424,1.36451409 2.899428,1.38836247 C3.09466542,1.43032272 3.25566658,1.50998921 3.37905974,1.6253638 C3.50439814,1.74254314 3.60457808,1.91180219 3.6766817,2.12824235 C3.75189771,2.35415741 3.79002445,2.68945275 3.79002445,3.12471792 C3.79002445,3.56127219 3.75150867,3.90784717 3.67551456,4.15477459 C3.60360546,4.38861762 3.51354078,4.55523401 3.40791416,4.64991853 C3.30014777,4.74647224 3.16054427,4.81647046 2.99299412,4.85797953 C2.85754047,4.89207627 2.62683481,4.90935023 2.30677773,4.90935023 L1.57329196,4.90935023 L1.57329196,1.33608939 L1.9501501,1.33608939 Z M1.24902018,1.01381398 L1.24902018,5.23162564 L2.30677773,5.23162564 C2.65860709,5.23162564 2.90889484,5.21158011 3.07203577,5.17052222 C3.29100514,5.1163155 3.47729444,5.02163098 3.62500312,4.88924025 C3.77699133,4.7529822 3.89493781,4.54356764 3.98558607,4.24900792 C4.07214932,3.96766148 4.11423138,3.59988078 4.11423138,3.12471792 C4.11423138,2.64833041 4.07176027,2.2893156 3.98441893,2.02698342 C3.89519718,1.75904364 3.76622766,1.54492386 3.60120633,1.39061839 C3.43423976,1.23450819 3.22162485,1.12789948 2.96919733,1.0736283 C2.78932733,1.03347278 2.45558871,1.01381398 1.9501501,1.01381398 L1.24902018,1.01381398 Z"
            }), Object(jsx.c)("polygon", {
                points: "6.53678989 6.06950948 6.53678989 0.175865691 10.9257088 0.175865691 10.9257088 1.17491946 7.73227054 1.17491946 7.73227054 2.48013487 10.702849 2.48013487 10.702849 3.47918864 7.73227054 3.47918864 7.73227054 5.07045571 11.0391813 5.07045571 11.0391813 6.06950948"
            }), Object(jsx.c)("path", {
                d: "M10.7636378,0.337035624 L10.7636378,1.01381398 L7.57019949,1.01381398 L7.57019949,2.64130481 L10.5407779,2.64130481 L10.5407779,3.31808317 L7.57019949,3.31808317 L7.57019949,5.23162564 L10.8771102,5.23162564 L10.8771102,5.908404 L6.69892578,5.908404 L6.69892578,0.337035624 L10.7636378,0.337035624 Z M6.37471884,0.0147602138 L6.37471884,6.23067941 L11.2013172,6.23067941 L11.2013172,4.90935023 L7.89440643,4.90935023 L7.89440643,3.64035858 L10.8649849,3.64035858 L10.8649849,2.3190294 L7.89440643,2.3190294 L7.89440643,1.33608939 L11.0878447,1.33608939 L11.0878447,0.0147602138 L6.37471884,0.0147602138 Z"
            }), Object(jsx.c)("path", {
                d: "M15.5303032,3.73301276 L14.7130424,1.54959685 L13.9121864,3.73301276 L15.5303032,3.73301276 Z M17.7341971,6.06950948 L16.431793,6.06950948 L15.9144884,4.73206653 L13.5458326,4.73206653 L13.055113,6.06950948 L11.7849999,6.06950948 L14.0890089,0.175865691 L15.363207,0.175865691 L17.7341971,6.06950948 Z"
            }), Object(jsx.c)("path", {
                d: "M15.2534629,0.337035624 C15.3291976,0.525244463 17.332991,5.50626875 17.4947703,5.908404 L16.5431581,5.908404 C16.4751395,5.73244163 16.0257887,4.57096105 16.0257887,4.57096105 L13.4323926,4.57096105 C13.4323926,4.57096105 13.0075518,5.72876769 12.9417378,5.908404 L12.0218979,5.908404 C12.1781008,5.50884695 14.1252876,0.527951577 14.1999201,0.337035624 L15.2534629,0.337035624 Z M13.9780328,0.0147602138 L11.5481019,6.23067941 L13.168553,6.23067941 C13.168553,6.23067941 13.5933289,5.07280832 13.6592077,4.89323646 L15.8031882,4.89323646 C15.871142,5.06913438 16.3204928,6.23067941 16.3204928,6.23067941 L17.9736239,6.23067941 L15.472951,0.0147602138 L13.9780328,0.0147602138 Z"
            }), Object(jsx.c)("path", {
                d: "M14.7145337,2.01579402 C14.8921991,2.49044124 15.1926093,3.29290701 15.2970039,3.57186861 L14.1437998,3.57186861 C14.2457305,3.2940672 14.5401752,2.49134361 14.7145337,2.01579402 L14.7145337,2.01579402 Z M13.680573,3.89414402 L15.7636025,3.89414402 L14.7114862,1.0833868 L13.680573,3.89414402 Z"
            }), Object(jsx.c)("polygon", {
                points: "18.7343171 6.06950948 18.7343171 0.224207003 19.9297978 0.224207003 19.9297978 5.07045571 22.9084814 5.07045571 22.9084814 6.06950948"
            }), Object(jsx.c)("path", {
                d: "M19.7677267,0.385376935 L19.7677267,5.23162564 L22.7464104,5.23162564 L22.7464104,5.908404 L18.8963882,5.908404 L18.8963882,0.385376935 L19.7677267,0.385376935 Z M18.5722461,0.0631015253 L18.5722461,6.23067941 L23.0706173,6.23067941 L23.0706173,4.90935023 L20.0919337,4.90935023 L20.0919337,0.0631015253 L18.5722461,0.0631015253 Z"
            })));
        }, _fundingLogos[constants.h.ELV] = ((_BUTTON_LOGO$ELV = {})[constants.i.ANY] = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="100" height="32" viewBox="0 0 100 32" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path fill="#005DA0" d="M 39.871 18.772 C 37.78 18.772 35.843 18.278 34.272 17.425 L 34.81 13.935 C 36.409 14.769 38.051 15.263 39.826 15.263 C 41.809 15.263 42.661 14.544 42.661 13.284 C 42.661 10.45 34.34 11.641 34.34 5.59 C 34.34 2.53 36.319 0.055 40.885 0.055 C 42.639 0.055 44.549 0.416 45.946 0.999 L 45.474 4.395 C 43.989 3.926 42.481 3.633 41.108 3.633 C 38.86 3.633 38.275 4.395 38.275 5.364 C 38.275 8.175 46.598 6.895 46.598 13.013 C 46.576 16.569 44.101 18.772 39.871 18.772 Z"/>\n  <path fill="#005DA0" d="M 62.233 14.881 L 62.233 18.413 L 49.951 18.413 L 49.951 0.345 L 62.233 0.345 L 62.233 3.946 L 54.022 3.946 L 54.022 7.549 L 60.705 7.549 L 60.705 10.787 L 54.022 10.787 L 54.022 14.905 L 62.233 14.905 Z"/>\n  <path fill="#005DA0" d="M 72.313 12.565 L 69.905 12.565 L 69.905 18.437 L 65.834 18.437 L 65.834 0.345 L 72.313 0.345 C 77.328 0.345 79.376 2.328 79.376 6.534 C 79.376 10.361 77.355 12.565 72.313 12.565 Z M 72.313 3.766 L 69.905 3.766 L 69.905 9.302 L 72.313 9.302 C 74.314 9.302 75.194 8.808 75.194 6.534 C 75.194 4.352 74.428 3.766 72.313 3.766 Z"/>\n  <path fill="#005DA0" d="M 91.797 14.924 L 85.246 14.924 L 84.234 18.437 L 79.939 18.437 L 86.193 0.345 L 91.031 0.345 L 97.352 18.437 L 92.808 18.437 L 91.797 14.924 Z M 88.04 5.318 L 86.238 11.506 L 90.85 11.506 L 89.118 5.318 L 88.645 3.408 L 88.578 3.408 L 88.04 5.318 Z"/>\n  <path fill="#005DA0" d="M 39.736 30.157 L 39.692 31.867 L 34.382 31.867 L 34.382 23.475 L 36.299 23.475 L 36.299 30.157 L 39.736 30.157 Z"/>\n  <path fill="#005DA0" d="M 44.798 31.215 L 44.778 31.215 C 44.371 31.71 43.722 31.977 42.931 31.977 C 41.648 31.977 40.818 31.257 40.818 29.727 C 40.818 28.468 41.695 27.613 43.222 27.613 C 43.722 27.613 44.168 27.68 44.527 27.796 L 44.527 27.411 C 44.527 26.736 44.168 26.421 43.244 26.421 C 42.505 26.421 42.007 26.534 41.382 26.782 L 41.245 25.387 C 41.919 25.095 42.707 24.936 43.563 24.936 C 45.563 24.936 46.263 25.792 46.263 27.658 L 46.263 31.867 L 44.933 31.867 L 44.798 31.215 Z M 44.549 28.966 C 44.393 28.896 44.056 28.828 43.583 28.828 C 42.819 28.828 42.46 29.12 42.46 29.727 C 42.46 30.38 42.842 30.63 43.427 30.63 C 44.012 30.63 44.549 30.271 44.549 29.842 L 44.549 28.966 Z"/>\n  <path fill="#005DA0" d="M 50.02 32.002 C 49.21 32.002 48.466 31.842 47.883 31.529 L 48.062 30.088 C 48.625 30.405 49.41 30.561 49.996 30.561 C 50.693 30.561 50.986 30.29 50.986 29.887 C 50.986 28.807 47.84 29.436 47.84 27.051 C 47.84 25.838 48.667 24.959 50.403 24.959 C 51.075 24.959 51.752 25.095 52.336 25.32 L 52.201 26.736 C 51.64 26.512 50.897 26.396 50.381 26.396 C 49.816 26.396 49.503 26.625 49.503 26.961 C 49.503 27.995 52.603 27.366 52.603 29.707 C 52.603 31.101 51.862 32.002 50.02 32.002 Z"/>\n  <path fill="#005DA0" d="M 56.026 26.375 L 56.026 29.842 C 56.026 30.36 56.295 30.582 56.836 30.582 C 57.014 30.582 57.239 30.561 57.374 30.514 L 57.464 31.776 C 57.239 31.888 56.789 31.956 56.295 31.956 C 54.946 31.956 54.27 31.169 54.27 29.887 L 54.27 26.352 L 53.506 26.352 L 53.506 25.095 L 54.337 25.095 L 54.631 23.562 L 56.002 23.451 L 56.002 25.116 L 57.51 25.116 L 57.51 26.421 L 56.026 26.421 Z"/>\n  <path fill="#005DA0" d="M 60.885 32.002 C 60.073 32.002 59.331 31.842 58.748 31.529 L 58.929 30.088 C 59.49 30.405 60.275 30.561 60.862 30.561 C 61.561 30.561 61.851 30.29 61.851 29.887 C 61.851 28.807 58.702 29.436 58.702 27.051 C 58.702 25.838 59.534 24.959 61.269 24.959 C 61.943 24.959 62.615 25.095 63.203 25.32 L 63.069 26.736 C 62.505 26.512 61.764 26.396 61.246 26.396 C 60.681 26.396 60.367 26.625 60.367 26.961 C 60.367 27.995 63.47 27.366 63.47 29.707 C 63.47 31.101 62.729 32.002 60.885 32.002 Z"/>\n  <path fill="#005DA0" d="M 69.365 26.736 C 69.028 26.625 68.603 26.534 68.22 26.534 C 66.958 26.534 66.53 27.051 66.53 28.49 C 66.53 29.954 67.116 30.514 68.174 30.514 C 68.623 30.514 69.05 30.425 69.41 30.271 L 69.525 31.616 C 69.119 31.867 68.511 32.002 67.792 32.002 C 65.787 32.002 64.732 30.854 64.732 28.49 C 64.732 26.242 65.653 24.981 67.835 24.981 C 68.397 24.981 69.05 25.095 69.479 25.276 L 69.365 26.736 Z"/>\n  <path fill="#005DA0" d="M 75.078 31.867 L 75.078 27.546 C 75.078 26.849 74.743 26.491 74.001 26.491 C 73.508 26.491 73.055 26.714 72.855 27.008 L 72.855 31.867 L 71.122 31.867 L 71.122 23.16 L 72.855 23.069 L 72.855 24.622 L 72.83 25.52 L 72.855 25.545 C 73.348 25.116 73.979 24.959 74.541 24.959 C 75.98 24.959 76.812 25.926 76.812 27.546 L 76.812 31.867 L 75.078 31.867 Z"/>\n  <path fill="#005DA0" d="M 78.658 31.867 L 78.658 25.139 L 80.052 25.072 L 80.21 26.199 L 80.231 26.199 C 80.66 25.387 81.313 24.981 82.098 24.981 C 82.39 24.981 82.663 25.028 82.84 25.072 L 82.731 26.782 C 82.528 26.714 82.257 26.667 81.985 26.667 C 81.088 26.667 80.413 27.321 80.413 28.468 L 80.413 31.867 L 78.658 31.867 Z"/>\n  <path fill="#005DA0" d="M 85.382 24.35 C 84.708 24.35 84.395 24.172 84.395 23.609 C 84.395 23.136 84.708 22.867 85.382 22.867 C 86.058 22.867 86.375 23.113 86.375 23.609 C 86.354 24.105 86.058 24.35 85.382 24.35 Z M 84.484 31.867 L 84.484 25.139 L 86.259 25.072 L 86.259 31.888 L 84.484 31.888 Z"/>\n  <path fill="#005DA0" d="M 88.757 31.867 L 88.757 26.375 L 87.902 26.375 L 87.902 25.095 L 88.757 25.095 L 88.757 24.798 C 88.757 23.79 89.454 22.935 91.076 22.935 C 91.459 22.935 91.885 22.979 92.178 23.069 L 92.063 24.195 C 91.863 24.147 91.636 24.126 91.411 24.126 C 90.738 24.126 90.466 24.399 90.466 24.825 L 90.466 25.072 L 91.907 25.072 L 91.907 26.352 L 90.466 26.352 L 90.466 31.842 L 88.757 31.842 Z"/>\n  <path fill="#005DA0" d="M 95.486 26.375 L 95.486 29.842 C 95.486 30.36 95.754 30.582 96.296 30.582 C 96.473 30.582 96.698 30.561 96.834 30.514 L 96.924 31.776 C 96.698 31.888 96.249 31.956 95.754 31.956 C 94.406 31.956 93.729 31.169 93.729 29.887 L 93.729 26.352 L 92.965 26.352 L 92.965 25.095 L 93.798 25.095 L 94.09 23.562 L 95.461 23.451 L 95.461 25.116 L 96.969 25.116 L 96.969 26.421 L 95.486 26.421 Z"/>\n  <path fill="#AEB1BC" d="M 20.357 8.826 L 15.368 5.081 L 10.379 1.334 C 10.033 1.074 9.54 1.146 9.281 1.493 L 4.883 7.322 C 4.811 7.409 4.768 7.51 4.754 7.624 C 4.68 7.93 4.782 8.248 5.043 8.45 L 8.022 10.677 L 12.042 13.698 L 15.021 15.926 C 15.281 16.13 15.629 16.13 15.888 15.97 C 15.991 15.912 16.062 15.854 16.136 15.752 L 20.531 9.91 C 20.763 9.578 20.706 9.087 20.357 8.826 Z M 10.047 1.769 L 13.012 3.995 L 13.012 3.995 L 15.021 5.5 L 17.046 7.017 L 17.046 7.017 L 20.025 9.245 C 20.142 9.332 20.156 9.491 20.082 9.607 L 19.374 10.591 L 16.005 8.058 L 12.36 5.326 L 8.976 2.809 L 9.684 1.826 C 9.772 1.709 9.931 1.682 10.047 1.769 Z M 15.673 15.463 C 15.629 15.507 15.585 15.536 15.528 15.55 C 15.469 15.564 15.398 15.55 15.339 15.507 L 12.345 13.265 L 8.34 10.257 L 5.361 8.001 C 5.302 7.958 5.275 7.9 5.259 7.842 C 5.259 7.785 5.259 7.726 5.302 7.669 L 6.113 6.585 C 6.113 6.585 7.009 5.427 7.791 4.386 L 11.16 6.917 L 14.804 9.65 L 18.173 12.181 C 17.393 13.222 16.496 14.379 16.496 14.379 L 15.673 15.463 Z"/>\n  <g transform="matrix(0.144619, 0, 0, 0.144619, -7.250457, -3.988513)">\n    <path fill="#005DA0" d="M197.1,150.4l52-69.6l5.3-7c0,0,0.1-0.2,0.2-0.2c0.4-0.5,0.3-1.2-0.2-1.6l-14.7-10.7&#10;&#9;&#9;&#9;c-0.5-0.4-1.2-0.2-1.6,0.3c-0.1,0.1-0.2,0.2-0.2,0.2l-2,2.5l-64.3,86l-70.8,0l-26.5,87.4h177.1l-25-87.4L197.1,150.4z M79.1,234.3&#10;&#9;&#9;&#9;l24.2-80.5l65.7,0l-5.7,7.6l-8.1,11.3l-0.9,1.7l-0.9,1.9l-0.9,2.2l-0.9,2.3l-0.9,2.5l-0.9,2.5l-0.8,2.5l-0.8,2.4l-0.7,2.3&#10;&#9;&#9;&#9;l-0.7,2.1l-0.6,1.9l-0.4,1.6l-0.3,1.2l-0.3,0.7c0,0-0.1,0.2-0.2,0.4c-0.2,0.2-1.2,1.1-2,0.5c-0.8-0.6-0.7-2.6-0.6-3.6&#10;&#9;&#9;&#9;c0.2-3,0.5-6,0.7-8.9c0.1-1-1.2-1.6-2-1.2c-3.6,2.1-5.8,4.6-7.8,7.5c0.2-0.7,0.4-1.4,0.6-2c0.8-3.1,2-6.2,2.5-9.4&#10;&#9;&#9;&#9;c0.3-1.8-0.2-3.9-2.3-4.3c-2.4-0.4-3.9,2.1-5.1,3.7c-3.5,5-5.6,11.2-9.9,15.5c-1.6,1.6-3.5,2.8-5.8,2.1c-2.7-0.8-3.8,2.4,1,2.9&#10;&#9;&#9;&#9;c4.7,0.4,8.3-4.6,10.4-8.1c1.6-2.5,2.9-5.2,4.5-7.8c0.7-1.2,1.5-2.4,2.3-3.6c0.4-0.5,1-1.8,1.7-2c0.8-0.2,0.6,0.3,0.6,0.9&#10;&#9;&#9;&#9;c-0.1,1.5-0.7,3-1.1,4.5c-0.4,1.6-0.9,3.2-1.3,4.7c-0.9,3.4-1.8,6.8-2.8,10.1c-0.4,1.5,1.6,2.2,2.5,1c3.4-4.8,5.1-8.9,9.2-12.1&#10;&#9;&#9;&#9;c-0.1,1.1-0.2,2.1-0.3,3.2c-0.1,1.7-0.5,3.6-0.4,5.3c0.2,2.9,2.4,4.8,5.1,3.6c1.4-0.7,2.4-1.7,2.4-1.7l0.2-0.1l0.6-0.4l1-0.7&#10;&#9;&#9;&#9;l1.4-1l1.6-1.2l1.7-1.2l2.1-1.4l2.1-1.5l2.1-1.5l2.1-1.5l2-1.5l1.9-1.4l1.8-1.4l1.5-1.2l1.2-1.1l1-0.9l0-0.1l0,0l6.5-7.6&#10;&#9;&#9;&#9;l16.6-22.1l29.4,0l22.9,80.5H79.1z"/>\n    <path fill="#005DA0" d="M261.1,77.1l-1.9-1.5c-0.4-0.3-0.9-0.2-1.2,0.2l-24.7,32.9c-0.3,0.4-0.2,0.9,0.2,1.2l1.9,1.5&#10;&#9;&#9;&#9;c0.4,0.3,0.9,0.2,1.2-0.2l24.7-32.9C261.5,77.9,261.5,77.4,261.1,77.1z"/>\n    <polygon fill="#005DA0" points="161.7,217.2 210.9,217.2 209.9,213.3 161.7,213.3 113.6,213.3 112.5,217.2 &#9;&#9;"/>\n  </g>\n</svg>', 
        _BUTTON_LOGO$ELV[constants.i.WHITE] = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="100" height="32" viewBox="0 0 100 32" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M 39.871 18.772 C 37.78 18.772 35.843 18.278 34.272 17.425 L 34.81 13.935 C 36.409 14.769 38.051 15.263 39.826 15.263 C 41.809 15.263 42.661 14.544 42.661 13.284 C 42.661 10.45 34.34 11.641 34.34 5.59 C 34.34 2.53 36.319 0.055 40.885 0.055 C 42.639 0.055 44.549 0.416 45.946 0.999 L 45.474 4.395 C 43.989 3.926 42.481 3.633 41.108 3.633 C 38.86 3.633 38.275 4.395 38.275 5.364 C 38.275 8.175 46.598 6.895 46.598 13.013 C 46.576 16.569 44.101 18.772 39.871 18.772 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 62.233 14.881 L 62.233 18.413 L 49.951 18.413 L 49.951 0.345 L 62.233 0.345 L 62.233 3.946 L 54.022 3.946 L 54.022 7.549 L 60.705 7.549 L 60.705 10.787 L 54.022 10.787 L 54.022 14.905 L 62.233 14.905 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 72.313 12.565 L 69.905 12.565 L 69.905 18.437 L 65.834 18.437 L 65.834 0.345 L 72.313 0.345 C 77.328 0.345 79.376 2.328 79.376 6.534 C 79.376 10.361 77.355 12.565 72.313 12.565 Z M 72.313 3.766 L 69.905 3.766 L 69.905 9.302 L 72.313 9.302 C 74.314 9.302 75.194 8.808 75.194 6.534 C 75.194 4.352 74.428 3.766 72.313 3.766 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 91.797 14.924 L 85.246 14.924 L 84.234 18.437 L 79.939 18.437 L 86.193 0.345 L 91.031 0.345 L 97.352 18.437 L 92.808 18.437 L 91.797 14.924 Z M 88.04 5.318 L 86.238 11.506 L 90.85 11.506 L 89.118 5.318 L 88.645 3.408 L 88.578 3.408 L 88.04 5.318 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 39.736 30.157 L 39.692 31.867 L 34.382 31.867 L 34.382 23.475 L 36.299 23.475 L 36.299 30.157 L 39.736 30.157 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 44.798 31.215 L 44.778 31.215 C 44.371 31.71 43.722 31.977 42.931 31.977 C 41.648 31.977 40.818 31.257 40.818 29.727 C 40.818 28.468 41.695 27.613 43.222 27.613 C 43.722 27.613 44.168 27.68 44.527 27.796 L 44.527 27.411 C 44.527 26.736 44.168 26.421 43.244 26.421 C 42.505 26.421 42.007 26.534 41.382 26.782 L 41.245 25.387 C 41.919 25.095 42.707 24.936 43.563 24.936 C 45.563 24.936 46.263 25.792 46.263 27.658 L 46.263 31.867 L 44.933 31.867 L 44.798 31.215 Z M 44.549 28.966 C 44.393 28.896 44.056 28.828 43.583 28.828 C 42.819 28.828 42.46 29.12 42.46 29.727 C 42.46 30.38 42.842 30.63 43.427 30.63 C 44.012 30.63 44.549 30.271 44.549 29.842 L 44.549 28.966 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 50.02 32.002 C 49.21 32.002 48.466 31.842 47.883 31.529 L 48.062 30.088 C 48.625 30.405 49.41 30.561 49.996 30.561 C 50.693 30.561 50.986 30.29 50.986 29.887 C 50.986 28.807 47.84 29.436 47.84 27.051 C 47.84 25.838 48.667 24.959 50.403 24.959 C 51.075 24.959 51.752 25.095 52.336 25.32 L 52.201 26.736 C 51.64 26.512 50.897 26.396 50.381 26.396 C 49.816 26.396 49.503 26.625 49.503 26.961 C 49.503 27.995 52.603 27.366 52.603 29.707 C 52.603 31.101 51.862 32.002 50.02 32.002 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 56.026 26.375 L 56.026 29.842 C 56.026 30.36 56.295 30.582 56.836 30.582 C 57.014 30.582 57.239 30.561 57.374 30.514 L 57.464 31.776 C 57.239 31.888 56.789 31.956 56.295 31.956 C 54.946 31.956 54.27 31.169 54.27 29.887 L 54.27 26.352 L 53.506 26.352 L 53.506 25.095 L 54.337 25.095 L 54.631 23.562 L 56.002 23.451 L 56.002 25.116 L 57.51 25.116 L 57.51 26.421 L 56.026 26.421 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 60.885 32.002 C 60.073 32.002 59.331 31.842 58.748 31.529 L 58.929 30.088 C 59.49 30.405 60.275 30.561 60.862 30.561 C 61.561 30.561 61.851 30.29 61.851 29.887 C 61.851 28.807 58.702 29.436 58.702 27.051 C 58.702 25.838 59.534 24.959 61.269 24.959 C 61.943 24.959 62.615 25.095 63.203 25.32 L 63.069 26.736 C 62.505 26.512 61.764 26.396 61.246 26.396 C 60.681 26.396 60.367 26.625 60.367 26.961 C 60.367 27.995 63.47 27.366 63.47 29.707 C 63.47 31.101 62.729 32.002 60.885 32.002 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 69.365 26.736 C 69.028 26.625 68.603 26.534 68.22 26.534 C 66.958 26.534 66.53 27.051 66.53 28.49 C 66.53 29.954 67.116 30.514 68.174 30.514 C 68.623 30.514 69.05 30.425 69.41 30.271 L 69.525 31.616 C 69.119 31.867 68.511 32.002 67.792 32.002 C 65.787 32.002 64.732 30.854 64.732 28.49 C 64.732 26.242 65.653 24.981 67.835 24.981 C 68.397 24.981 69.05 25.095 69.479 25.276 L 69.365 26.736 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 75.078 31.867 L 75.078 27.546 C 75.078 26.849 74.743 26.491 74.001 26.491 C 73.508 26.491 73.055 26.714 72.855 27.008 L 72.855 31.867 L 71.122 31.867 L 71.122 23.16 L 72.855 23.069 L 72.855 24.622 L 72.83 25.52 L 72.855 25.545 C 73.348 25.116 73.979 24.959 74.541 24.959 C 75.98 24.959 76.812 25.926 76.812 27.546 L 76.812 31.867 L 75.078 31.867 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 78.658 31.867 L 78.658 25.139 L 80.052 25.072 L 80.21 26.199 L 80.231 26.199 C 80.66 25.387 81.313 24.981 82.098 24.981 C 82.39 24.981 82.663 25.028 82.84 25.072 L 82.731 26.782 C 82.528 26.714 82.257 26.667 81.985 26.667 C 81.088 26.667 80.413 27.321 80.413 28.468 L 80.413 31.867 L 78.658 31.867 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 85.382 24.35 C 84.708 24.35 84.395 24.172 84.395 23.609 C 84.395 23.136 84.708 22.867 85.382 22.867 C 86.058 22.867 86.375 23.113 86.375 23.609 C 86.354 24.105 86.058 24.35 85.382 24.35 Z M 84.484 31.867 L 84.484 25.139 L 86.259 25.072 L 86.259 31.888 L 84.484 31.888 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 88.757 31.867 L 88.757 26.375 L 87.902 26.375 L 87.902 25.095 L 88.757 25.095 L 88.757 24.798 C 88.757 23.79 89.454 22.935 91.076 22.935 C 91.459 22.935 91.885 22.979 92.178 23.069 L 92.063 24.195 C 91.863 24.147 91.636 24.126 91.411 24.126 C 90.738 24.126 90.466 24.399 90.466 24.825 L 90.466 25.072 L 91.907 25.072 L 91.907 26.352 L 90.466 26.352 L 90.466 31.842 L 88.757 31.842 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 95.486 26.375 L 95.486 29.842 C 95.486 30.36 95.754 30.582 96.296 30.582 C 96.473 30.582 96.698 30.561 96.834 30.514 L 96.924 31.776 C 96.698 31.888 96.249 31.956 95.754 31.956 C 94.406 31.956 93.729 31.169 93.729 29.887 L 93.729 26.352 L 92.965 26.352 L 92.965 25.095 L 93.798 25.095 L 94.09 23.562 L 95.461 23.451 L 95.461 25.116 L 96.969 25.116 L 96.969 26.421 L 95.486 26.421 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 20.357 8.826 L 15.368 5.081 L 10.379 1.334 C 10.033 1.074 9.54 1.146 9.281 1.493 L 4.883 7.322 C 4.811 7.409 4.768 7.51 4.754 7.624 C 4.68 7.93 4.782 8.248 5.043 8.45 L 8.022 10.677 L 12.042 13.698 L 15.021 15.926 C 15.281 16.13 15.629 16.13 15.888 15.97 C 15.991 15.912 16.062 15.854 16.136 15.752 L 20.531 9.91 C 20.763 9.578 20.706 9.087 20.357 8.826 Z M 10.047 1.769 L 13.012 3.995 L 13.012 3.995 L 15.021 5.5 L 17.046 7.017 L 17.046 7.017 L 20.025 9.245 C 20.142 9.332 20.156 9.491 20.082 9.607 L 19.374 10.591 L 16.005 8.058 L 12.36 5.326 L 8.976 2.809 L 9.684 1.826 C 9.772 1.709 9.931 1.682 10.047 1.769 Z M 15.673 15.463 C 15.629 15.507 15.585 15.536 15.528 15.55 C 15.469 15.564 15.398 15.55 15.339 15.507 L 12.345 13.265 L 8.34 10.257 L 5.361 8.001 C 5.302 7.958 5.275 7.9 5.259 7.842 C 5.259 7.785 5.259 7.726 5.302 7.669 L 6.113 6.585 C 6.113 6.585 7.009 5.427 7.791 4.386 L 11.16 6.917 L 14.804 9.65 L 18.173 12.181 C 17.393 13.222 16.496 14.379 16.496 14.379 L 15.673 15.463 Z" style="fill: rgb(255, 255, 255);"/>\n  <g transform="matrix(0.144619, 0, 0, 0.144619, -7.250457, -3.988513)">\n    <path d="M197.1,150.4l52-69.6l5.3-7c0,0,0.1-0.2,0.2-0.2c0.4-0.5,0.3-1.2-0.2-1.6l-14.7-10.7&#10;&#9;&#9;&#9;c-0.5-0.4-1.2-0.2-1.6,0.3c-0.1,0.1-0.2,0.2-0.2,0.2l-2,2.5l-64.3,86l-70.8,0l-26.5,87.4h177.1l-25-87.4L197.1,150.4z M79.1,234.3&#10;&#9;&#9;&#9;l24.2-80.5l65.7,0l-5.7,7.6l-8.1,11.3l-0.9,1.7l-0.9,1.9l-0.9,2.2l-0.9,2.3l-0.9,2.5l-0.9,2.5l-0.8,2.5l-0.8,2.4l-0.7,2.3&#10;&#9;&#9;&#9;l-0.7,2.1l-0.6,1.9l-0.4,1.6l-0.3,1.2l-0.3,0.7c0,0-0.1,0.2-0.2,0.4c-0.2,0.2-1.2,1.1-2,0.5c-0.8-0.6-0.7-2.6-0.6-3.6&#10;&#9;&#9;&#9;c0.2-3,0.5-6,0.7-8.9c0.1-1-1.2-1.6-2-1.2c-3.6,2.1-5.8,4.6-7.8,7.5c0.2-0.7,0.4-1.4,0.6-2c0.8-3.1,2-6.2,2.5-9.4&#10;&#9;&#9;&#9;c0.3-1.8-0.2-3.9-2.3-4.3c-2.4-0.4-3.9,2.1-5.1,3.7c-3.5,5-5.6,11.2-9.9,15.5c-1.6,1.6-3.5,2.8-5.8,2.1c-2.7-0.8-3.8,2.4,1,2.9&#10;&#9;&#9;&#9;c4.7,0.4,8.3-4.6,10.4-8.1c1.6-2.5,2.9-5.2,4.5-7.8c0.7-1.2,1.5-2.4,2.3-3.6c0.4-0.5,1-1.8,1.7-2c0.8-0.2,0.6,0.3,0.6,0.9&#10;&#9;&#9;&#9;c-0.1,1.5-0.7,3-1.1,4.5c-0.4,1.6-0.9,3.2-1.3,4.7c-0.9,3.4-1.8,6.8-2.8,10.1c-0.4,1.5,1.6,2.2,2.5,1c3.4-4.8,5.1-8.9,9.2-12.1&#10;&#9;&#9;&#9;c-0.1,1.1-0.2,2.1-0.3,3.2c-0.1,1.7-0.5,3.6-0.4,5.3c0.2,2.9,2.4,4.8,5.1,3.6c1.4-0.7,2.4-1.7,2.4-1.7l0.2-0.1l0.6-0.4l1-0.7&#10;&#9;&#9;&#9;l1.4-1l1.6-1.2l1.7-1.2l2.1-1.4l2.1-1.5l2.1-1.5l2.1-1.5l2-1.5l1.9-1.4l1.8-1.4l1.5-1.2l1.2-1.1l1-0.9l0-0.1l0,0l6.5-7.6&#10;&#9;&#9;&#9;l16.6-22.1l29.4,0l22.9,80.5H79.1z" style="fill: rgb(255, 255, 255);"/>\n    <path d="M261.1,77.1l-1.9-1.5c-0.4-0.3-0.9-0.2-1.2,0.2l-24.7,32.9c-0.3,0.4-0.2,0.9,0.2,1.2l1.9,1.5&#10;&#9;&#9;&#9;c0.4,0.3,0.9,0.2,1.2-0.2l24.7-32.9C261.5,77.9,261.5,77.4,261.1,77.1z" style="fill: rgb(255, 255, 255);"/>\n    <polygon points="161.7,217.2 210.9,217.2 209.9,213.3 161.7,213.3 113.6,213.3 112.5,217.2 &#9;&#9;" style="fill: rgb(255, 255, 255);"/>\n  </g>\n</svg>', 
        _BUTTON_LOGO$ELV), _fundingLogos[constants.h.BANCONTACT] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!BANCONTACT_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " bancontact logo available");
            var _BANCONTACT_LOGO_COLO2 = BANCONTACT_LOGO_COLORS[logoColor], primary = _BANCONTACT_LOGO_COLO2.primary, secondary = _BANCONTACT_LOGO_COLO2.secondary;
            return Object(jsx.c)("svg", {
                version: "1.1",
                id: "Layer_1",
                x: "0px",
                y: "0px",
                width: "226px",
                height: "32px",
                viewBox: "36.09922790527344 36.68461608886719 226 32",
                style: "enable-background:new 0 0 476.9 123.4;",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.c)("g", {
                transform: "matrix(0.557769, 0, 0, 0.557769, 15.684875, 18.15871)"
            }, Object(jsx.c)("g", null, Object(jsx.c)("path", {
                fill: primary,
                d: "M147.6,50.2h-5.8h-26.9h-5.8l-3.9,4.4L92.5,68.9l0,0l-3.9,4.4h-6H56.2h-5.8l3.9-4.5l1.8-2.1l3.9-4.5h-5.8h-7.6 h-4.2c-3.2,0-5.8,2.7-5.8,6l0,0v11.5v1.1c0,3.3,2.6,6,5.8,6H44h61.1h4.4c3.2,0,7.6-2,9.7-4.4l10.2-11.6L147.6,50.2z"
            }), Object(jsx.c)("path", {
                fill: secondary,
                d: "M155.3,36.8c3.2,0,5.8,2.7,5.8,6v12.6c0,3.3-2.6,6-5.8,6h-3.2h-8.5h-5.8l3.9-4.4l0,0l1.9-2.2l3.9-4.4h-38.6 L88.3,73.6H50l27.5-31.1l1-1.2c2.2-2.4,6.5-4.4,9.7-4.4h1.4h65.7V36.8z"
            })), Object(jsx.c)("path", {
                fill: primary,
                d: "M 440.7 85.6 L 440.7 81.8 C 440.7 81.3 440.4 81 439.7 81 L 437.3 81 C 436.6 81 436.1 80.9 436 80.6 C 435.8 80.3 435.8 79.7 435.8 78.7 L 435.8 64.7 L 439.7 64.7 C 440 64.7 440.2 64.6 440.4 64.4 C 440.6 64.2 440.7 64 440.7 63.7 L 440.7 59.8 C 440.7 59.5 440.6 59.3 440.4 59.1 C 440.2 58.9 440 58.8 439.7 58.8 L 435.8 58.8 L 435.8 53.8 C 435.8 53.5 435.7 53.3 435.6 53.2 C 435.4 53.1 435.2 53 435 53 L 434.9 53 L 429.1 54 C 428.8 54.1 428.6 54.2 428.4 54.3 C 428.2 54.5 428.1 54.7 428.1 54.9 L 428.1 58.8 L 424.2 58.8 C 423.9 58.8 423.7 58.9 423.5 59.1 C 423.3 59.3 423.2 59.5 423.2 59.8 L 423.2 63 C 423.2 63.3 423.3 63.5 423.5 63.6 C 423.7 63.8 423.9 63.9 424.2 64 L 428.1 64.6 L 428.1 78.6 C 428.1 80.3 428.3 81.7 428.6 82.8 C 429 83.9 429.5 84.7 430.1 85.3 C 430.8 85.9 431.6 86.3 432.6 86.5 C 433.6 86.7 434.8 86.8 436.1 86.8 C 436.8 86.8 437.4 86.8 438 86.7 C 438.5 86.6 439.2 86.5 439.9 86.4 C 440.4 86.4 440.7 86.1 440.7 85.6 M 419.9 85.1 L 419.9 80.8 C 419.9 80.5 419.8 80.3 419.6 80.2 C 419.4 80.1 419.2 80 418.9 80 L 418.8 80 C 417.9 80.1 417 80.2 416.2 80.2 C 415.4 80.3 414.3 80.3 412.9 80.3 C 412.4 80.3 411.8 80.2 411.4 80 C 410.9 79.8 410.5 79.5 410.1 79.1 C 409.7 78.7 409.5 78.1 409.3 77.4 C 409.1 76.7 409 75.8 409 74.7 L 409 70.7 C 409 69.6 409.1 68.7 409.3 68 C 409.5 67.3 409.8 66.7 410.1 66.3 C 410.5 65.9 410.9 65.6 411.4 65.4 C 411.9 65.2 412.4 65.1 412.9 65.1 C 414.3 65.1 415.4 65.1 416.2 65.2 C 417 65.3 417.9 65.3 418.8 65.4 L 418.9 65.4 C 419.2 65.4 419.4 65.3 419.6 65.2 C 419.8 65.1 419.9 64.9 419.9 64.6 L 419.9 60.3 C 419.9 59.9 419.8 59.7 419.7 59.6 C 419.5 59.5 419.3 59.3 418.9 59.2 C 418.2 59 417.3 58.9 416.3 58.7 C 415.2 58.5 414 58.5 412.5 58.5 C 409.1 58.5 406.4 59.5 404.3 61.6 C 402.3 63.7 401.2 66.7 401.2 70.7 L 401.2 74.7 C 401.2 78.6 402.2 81.7 404.3 83.8 C 406.3 85.9 409.1 86.9 412.5 86.9 C 413.9 86.9 415.2 86.8 416.3 86.7 C 417.4 86.5 418.3 86.4 418.9 86.2 C 419.3 86.1 419.5 86 419.7 85.8 C 419.8 85.7 419.9 85.4 419.9 85.1 M 388.6 80 C 388 80.3 387.4 80.5 386.7 80.7 C 386 80.9 385.3 81 384.6 81 C 383.6 81 382.8 80.9 382.3 80.6 C 381.8 80.3 381.6 79.7 381.6 78.6 L 381.6 78.2 C 381.6 77.6 381.7 77.1 381.8 76.7 C 381.9 76.3 382.2 75.9 382.5 75.6 C 382.8 75.3 383.3 75.1 383.8 74.9 C 384.3 74.8 385 74.7 385.9 74.7 L 388.6 74.7 L 388.6 80 L 388.6 80 Z M 396.2 68.3 C 396.2 66.5 395.9 65 395.4 63.8 C 394.9 62.6 394.1 61.6 393.2 60.8 C 392.2 60 391.1 59.4 389.7 59.1 C 388.3 58.7 386.7 58.5 385 58.5 C 383.4 58.5 381.8 58.6 380.3 58.8 C 378.8 59 377.6 59.2 376.7 59.5 C 376.1 59.7 375.8 60 375.8 60.6 L 375.8 64.5 C 375.8 64.8 375.9 65 376 65.2 C 376.2 65.3 376.4 65.4 376.6 65.4 L 376.8 65.4 C 377.2 65.4 377.7 65.3 378.2 65.3 C 378.8 65.3 379.4 65.2 380.2 65.2 C 380.9 65.2 381.7 65.1 382.5 65.1 C 383.3 65.1 384.1 65.1 384.8 65.1 C 385.9 65.1 386.8 65.3 387.4 65.7 C 388 66.1 388.4 67 388.4 68.4 L 388.4 70.1 L 385.8 70.1 C 381.7 70.1 378.6 70.7 376.8 72 C 375 73.3 374 75.4 374 78.2 L 374 78.6 C 374 80.2 374.2 81.5 374.7 82.5 C 375.2 83.6 375.8 84.4 376.6 85.1 C 377.4 85.7 378.2 86.2 379.2 86.5 C 380.2 86.8 381.2 86.9 382.3 86.9 C 383.7 86.9 385 86.7 386 86.3 C 387 85.9 388 85.4 389 84.7 L 389 85.5 C 389 85.8 389.1 86 389.3 86.2 C 389.5 86.4 389.7 86.5 390 86.5 L 395.4 86.5 C 395.7 86.5 395.9 86.4 396.1 86.2 C 396.3 86 396.4 85.8 396.4 85.5 L 396.4 68.3 L 396.2 68.3 Z M 370.5 85.6 L 370.5 81.8 C 370.5 81.3 370.2 81 369.5 81 L 367.1 81 C 366.4 81 365.9 80.9 365.8 80.6 C 365.6 80.3 365.6 79.7 365.6 78.7 L 365.6 64.7 L 369.5 64.7 C 369.8 64.7 370 64.6 370.2 64.4 C 370.4 64.2 370.5 64 370.5 63.7 L 370.5 59.8 C 370.5 59.5 370.4 59.3 370.2 59.1 C 370 58.9 369.8 58.8 369.5 58.8 L 365.6 58.8 L 365.6 53.8 C 365.6 53.5 365.5 53.3 365.4 53.2 C 365.2 53.1 365 53 364.8 53 L 364.7 53 L 358.9 54 C 358.6 54.1 358.4 54.2 358.2 54.3 C 358 54.5 357.9 54.7 357.9 54.9 L 357.9 58.8 L 354 58.8 C 353.7 58.8 353.5 58.9 353.3 59.1 C 353.1 59.3 353 59.5 353 59.8 L 353 63 C 353 63.3 353.1 63.5 353.3 63.6 C 353.5 63.8 353.7 63.9 354 64 L 357.9 64.6 L 357.9 78.6 C 357.9 80.3 358.1 81.7 358.4 82.8 C 358.8 83.9 359.3 84.7 359.9 85.3 C 360.6 85.9 361.4 86.3 362.4 86.5 C 363.4 86.7 364.6 86.8 365.9 86.8 C 366.6 86.8 367.2 86.8 367.8 86.7 C 368.3 86.6 369 86.5 369.7 86.4 C 370.2 86.4 370.5 86.1 370.5 85.6 M 349.5 85.5 L 349.5 69.5 C 349.5 68 349.4 66.6 349.1 65.2 C 348.9 63.9 348.4 62.7 347.8 61.7 C 347.2 60.7 346.3 59.9 345.2 59.4 C 344.1 58.8 342.7 58.5 340.9 58.5 C 339.4 58.5 338 58.7 336.8 59.1 C 335.6 59.5 334.4 60.1 333 61.1 L 333 59.8 C 333 59.5 332.9 59.3 332.7 59.1 C 332.5 58.9 332.3 58.8 332 58.8 L 326.6 58.8 C 326.3 58.8 326.1 58.9 325.9 59.1 C 325.7 59.3 325.6 59.5 325.6 59.8 L 325.6 85.4 C 325.6 85.7 325.7 85.9 325.9 86.1 C 326.1 86.3 326.3 86.4 326.6 86.4 L 332.4 86.4 C 332.7 86.4 332.9 86.3 333.1 86.1 C 333.3 85.9 333.4 85.7 333.4 85.4 L 333.4 66.5 C 334.2 66.1 335 65.7 335.8 65.4 C 336.5 65.1 337.3 65 338 65 C 338.7 65 339.3 65.1 339.8 65.2 C 340.3 65.3 340.6 65.6 340.9 65.9 C 341.2 66.3 341.3 66.7 341.4 67.3 C 341.5 67.9 341.5 68.6 341.5 69.4 L 341.5 85.4 C 341.5 85.7 341.6 85.9 341.8 86.1 C 342 86.3 342.2 86.4 342.5 86.4 L 348.3 86.4 C 348.6 86.4 348.8 86.3 349 86.1 C 349.4 85.9 349.5 85.7 349.5 85.5 M 313.1 74.4 C 313.1 78.3 311.7 80.3 308.8 80.3 C 307.4 80.3 306.3 79.8 305.6 78.8 C 304.9 77.8 304.5 76.3 304.5 74.4 L 304.5 71 C 304.5 69 304.9 67.6 305.6 66.6 C 306.3 65.6 307.4 65.1 308.8 65.1 C 311.6 65.1 313.1 67.1 313.1 71 L 313.1 74.4 Z M 320.9 71 C 320.9 69.1 320.6 67.3 320.1 65.8 C 319.6 64.3 318.8 63 317.8 61.9 C 316.8 60.8 315.5 60 314 59.4 C 312.5 58.8 310.8 58.5 308.8 58.5 C 306.8 58.5 305.1 58.8 303.6 59.4 C 302.1 60 300.8 60.8 299.8 61.9 C 298.8 63 298 64.3 297.5 65.8 C 297 67.3 296.7 69.1 296.7 71 L 296.7 74.4 C 296.7 76.3 297 78.1 297.5 79.6 C 298 81.1 298.8 82.4 299.8 83.5 C 300.8 84.6 302.1 85.4 303.6 86 C 305.1 86.6 306.8 86.9 308.8 86.9 C 310.8 86.9 312.5 86.6 314 86 C 315.5 85.4 316.8 84.6 317.8 83.5 C 318.8 82.4 319.6 81.1 320.1 79.6 C 320.6 78.1 320.9 76.3 320.9 74.4 L 320.9 71 Z M 294.1 85.1 L 294.1 80.8 C 294.1 80.5 294 80.3 293.8 80.2 C 293.6 80.1 293.4 80 293.1 80 L 293 80 C 292.1 80.1 291.2 80.2 290.4 80.2 C 289.6 80.2 288.5 80.3 287.1 80.3 C 286.6 80.3 286 80.2 285.6 80 C 285.1 79.8 284.7 79.5 284.3 79.1 C 283.9 78.7 283.7 78.1 283.5 77.4 C 283.3 76.7 283.2 75.8 283.2 74.7 L 283.2 70.7 C 283.2 69.6 283.3 68.7 283.5 68 C 283.7 67.3 284 66.7 284.3 66.3 C 284.7 65.9 285.1 65.6 285.6 65.4 C 286.1 65.2 286.6 65.1 287.1 65.1 C 288.5 65.1 289.6 65.1 290.4 65.2 C 291.2 65.3 292.1 65.3 293 65.4 L 293.1 65.4 C 293.4 65.4 293.6 65.3 293.8 65.2 C 294 65.1 294.1 64.9 294.1 64.6 L 294.1 60.3 C 294.1 59.9 294 59.7 293.9 59.6 C 293.7 59.5 293.5 59.3 293.1 59.2 C 292.4 59 291.6 58.9 290.5 58.7 C 289.4 58.5 288.2 58.5 286.7 58.5 C 283.3 58.5 280.6 59.5 278.5 61.6 C 276.5 63.7 275.4 66.7 275.4 70.7 L 275.4 74.7 C 275.4 78.6 276.4 81.7 278.5 83.8 C 280.5 85.9 283.3 86.9 286.7 86.9 C 288.1 86.9 289.4 86.8 290.5 86.7 C 291.6 86.5 292.4 86.4 293.1 86.2 C 293.5 86.1 293.7 86 293.9 85.8 C 294 85.7 294.1 85.4 294.1 85.1 M 270.4 85.5 L 270.4 69.5 C 270.4 68 270.3 66.6 270 65.2 C 269.7 63.8 269.3 62.7 268.7 61.7 C 268.1 60.7 267.2 59.9 266.1 59.4 C 265 58.8 263.6 58.5 261.8 58.5 C 260.3 58.5 258.9 58.7 257.7 59.1 C 256.5 59.5 255.3 60.1 253.9 61.1 L 253.9 59.8 C 253.9 59.5 253.8 59.3 253.6 59.1 C 253.4 58.9 253.2 58.8 252.9 58.8 L 247.5 58.8 C 247.2 58.8 247 58.9 246.8 59.1 C 246.6 59.3 246.5 59.5 246.5 59.8 L 246.5 85.4 C 246.5 85.7 246.6 85.9 246.8 86.1 C 247 86.3 247.2 86.4 247.5 86.4 L 253.3 86.4 C 253.6 86.4 253.8 86.3 254 86.1 C 254.2 85.9 254.3 85.7 254.3 85.4 L 254.3 66.5 C 255.1 66.1 255.9 65.7 256.7 65.4 C 257.4 65.1 258.2 65 258.9 65 C 259.6 65 260.2 65.1 260.7 65.2 C 261.2 65.3 261.5 65.6 261.8 65.9 C 262.1 66.3 262.2 66.7 262.3 67.3 C 262.4 67.9 262.4 68.6 262.4 69.4 L 262.4 85.4 C 262.4 85.7 262.5 85.9 262.7 86.1 C 262.9 86.3 263.1 86.4 263.4 86.4 L 269.2 86.4 C 269.5 86.4 269.7 86.3 269.9 86.1 C 270.3 85.9 270.4 85.7 270.4 85.5 M 233.3 80 C 232.7 80.3 232.1 80.5 231.4 80.7 C 230.7 80.9 230 81 229.3 81 C 228.3 81 227.5 80.9 227 80.6 C 226.5 80.3 226.3 79.7 226.3 78.6 L 226.3 78.2 C 226.3 77.6 226.4 77.1 226.5 76.7 C 226.6 76.3 226.9 75.9 227.2 75.6 C 227.5 75.3 228 75.1 228.5 74.9 C 229 74.8 229.7 74.7 230.6 74.7 L 233.3 74.7 L 233.3 80 L 233.3 80 Z M 241 68.3 C 241 66.5 240.7 65 240.2 63.8 C 239.7 62.6 238.9 61.6 238 60.8 C 237 60 235.9 59.4 234.5 59.1 C 233.1 58.7 231.5 58.5 229.8 58.5 C 228.2 58.5 226.6 58.6 225.1 58.8 C 223.6 59 222.4 59.2 221.5 59.5 C 220.9 59.7 220.6 60 220.6 60.6 L 220.6 64.5 C 220.6 64.8 220.7 65 220.8 65.2 C 221 65.3 221.2 65.4 221.4 65.4 L 221.6 65.4 C 222 65.4 222.5 65.3 223 65.3 C 223.6 65.3 224.2 65.2 225 65.2 C 225.7 65.2 226.5 65.1 227.3 65.1 C 228.1 65.1 228.9 65.1 229.6 65.1 C 230.7 65.1 231.6 65.3 232.2 65.7 C 232.8 66.1 233.2 67 233.2 68.4 L 233.2 70.1 L 230.6 70.1 C 226.5 70.1 223.4 70.7 221.6 72 C 219.8 73.3 218.8 75.4 218.8 78.2 L 218.8 78.6 C 218.8 80.2 219 81.5 219.5 82.5 C 220 83.6 220.6 84.4 221.4 85.1 C 222.2 85.7 223 86.2 224 86.5 C 225 86.8 226 86.9 227.1 86.9 C 228.5 86.9 229.8 86.7 230.8 86.3 C 231.8 85.9 232.8 85.4 233.8 84.7 L 233.8 85.5 C 233.8 85.8 233.9 86 234.1 86.2 C 234.3 86.4 234.5 86.5 234.8 86.5 L 240.2 86.5 C 240.5 86.5 240.7 86.4 240.9 86.2 C 241.1 86 241.2 85.8 241.2 85.5 L 241.2 68.3 L 241 68.3 Z M 206.6 75.9 C 206.6 77.2 206.1 78.3 205.2 79 C 204.3 79.7 202.5 80.1 200.1 80.1 L 199.3 80.1 C 198.9 80.1 198.5 80.1 198.1 80.1 C 197.7 80.1 197.3 80.1 196.9 80.1 L 196.1 80.1 L 196.1 71.1 L 201.5 71.1 C 203.4 71.1 204.8 71.5 205.5 72.4 C 206.2 73.3 206.6 74.3 206.6 75.4 L 206.6 75.9 Z M 206.4 61.6 C 206.4 62.1 206.3 62.6 206.2 63.1 C 206 63.6 205.8 64 205.4 64.3 C 205 64.6 204.5 64.9 203.9 65.1 C 203.3 65.3 202.5 65.4 201.5 65.4 L 196.1 65.4 L 196.1 57.1 C 196.3 57.1 196.5 57.1 196.8 57.1 C 197.1 57.1 197.5 57.1 197.9 57.1 L 199 57.1 L 199.8 57.1 C 202.3 57.1 204 57.4 205 58 C 206 58.6 206.5 59.6 206.5 60.9 L 206.5 61.6 L 206.4 61.6 Z M 214.6 75.4 C 214.6 73.7 214.2 72.3 213.4 71.1 C 212.6 69.9 211.6 68.9 210.3 68.3 C 211.6 67.7 212.6 66.7 213.3 65.5 C 214 64.2 214.4 62.8 214.4 61.3 L 214.4 60.4 C 214.4 58.5 214 56.9 213.3 55.6 C 212.6 54.3 211.5 53.3 210.2 52.5 C 208.9 51.7 207.3 51.2 205.4 50.8 C 203.5 50.5 201.5 50.3 199.2 50.3 C 198.4 50.3 197.6 50.3 196.8 50.3 C 196 50.3 195.2 50.4 194.4 50.4 C 193.6 50.4 192.9 50.5 192.2 50.6 C 191.5 50.7 191 50.7 190.6 50.8 C 189.7 51 189 51.3 188.6 51.7 C 188.2 52.1 188 52.9 188 54 L 188 83.3 C 188 84.4 188.2 85.1 188.6 85.6 C 189 86 189.7 86.3 190.6 86.5 C 191.1 86.6 191.7 86.7 192.3 86.7 C 193 86.8 193.7 86.8 194.5 86.9 C 195.3 86.9 196.1 87 196.9 87 C 197.7 87 198.6 87 199.4 87 C 201.5 87 203.5 86.8 205.3 86.5 C 207.1 86.2 208.7 85.6 210.1 84.8 C 211.5 84 212.5 82.9 213.4 81.5 C 214.2 80.1 214.6 78.3 214.6 76.2 L 214.6 75.4 L 214.6 75.4 Z"
            })));
        }, _fundingLogos[constants.h.GIROPAY] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!GIROPAY_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " giropay logo available");
            var _GIROPAY_LOGO_COLORS$ = GIROPAY_LOGO_COLORS[logoColor], primary = _GIROPAY_LOGO_COLORS$.primary, secondary = _GIROPAY_LOGO_COLORS$.secondary, tertiary = _GIROPAY_LOGO_COLORS$.tertiary;
            return Object(jsx.c)("svg", {
                width: "75px",
                height: "32px",
                viewBox: "0 0 75 32",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.c)("g", {
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd",
                transform: "matrix(1.614571, 0, 0, 1.614571, -161.457123, -256.816772)"
            }, Object(jsx.c)("g", {
                transform: "translate(100.000000, 159.000000)"
            }, Object(jsx.c)("g", {
                transform: "translate(0.000000, 0.144715)"
            }, Object(jsx.c)("mask", {
                fill: primary
            }, Object(jsx.c)("polygon", {
                points: "0 0.017902439 46.0918699 0.017902439 46.0918699 19.8373984 0 19.8373984",
                transform: "matrix(1, 0, 0, 1, 0, 0)"
            })), Object(jsx.c)("path", {
                d: "M0,3.5735122 C0,1.60977236 1.5998374,0.017902439 3.57349593,0.017902439 L42.5182114,0.017902439 C44.4918699,0.017902439 46.0918699,1.60977236 46.0918699,3.5735122 L46.0918699,16.2818049 C46.0918699,18.2455447 44.4918699,19.8374146 42.5182114,19.8374146 L3.57349593,19.8374146 C1.5998374,19.8374146 0,18.2455447 0,16.2818049 L0,3.5735122 Z",
                fill: secondary
            })), Object(jsx.c)("path", {
                d: "M1.46738211,3.84021138 L1.46738211,16.3065528 C1.46738211,17.5338699 2.46738211,18.5288293 3.70087805,18.5288293 L24.1036423,18.5288293 L24.1036423,1.61793496 L3.70087805,1.61793496 C2.46738211,1.61793496 1.46738211,2.61289431 1.46738211,3.84021138",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M5.67102439,10.0205528 C5.67102439,9.34152846 6.00582114,8.77730081 6.64663415,8.77730081 C7.42126829,8.77730081 7.74630894,9.39892683 7.74630894,9.95356098 C7.74630894,10.7187642 7.25866667,11.235187 6.64663415,11.235187 C6.13004878,11.235187 5.67102439,10.795187 5.67102439,10.0205528 Z M9.41053659,7.57226016 L7.8515122,7.57226016 L7.8515122,8.47112195 L7.8324878,8.47112195 C7.46907317,7.85908943 6.87606504,7.45746341 6.13964228,7.45746341 C4.59021138,7.45746341 3.8921626,8.56689431 3.8921626,10.0491707 C3.8921626,11.5221789 4.74321951,12.5550244 6.11102439,12.5550244 C6.79964228,12.5550244 7.37346341,12.2872195 7.78468293,11.7038049 L7.80370732,11.7038049 L7.80370732,11.9716098 C7.80370732,12.9472195 7.26826016,13.4158374 6.27362602,13.4158374 C5.55622764,13.4158374 5.11622764,13.2628293 4.59021138,13.0046179 L4.50419512,14.3626667 C4.90582114,14.5060813 5.58500813,14.6782764 6.40744715,14.6782764 C8.41590244,14.6782764 9.41053659,14.0182764 9.41053659,11.9716098 L9.41053659,7.57226016 Z",
                fill: tertiary
            }), Object(jsx.c)("mask", {
                fill: primary
            }, Object(jsx.c)("polygon", {
                points: "0 19.9821138 46.0918699 19.9821138 46.0918699 0.162601626 0 0.162601626",
                transform: "matrix(1, 0, 0, 1, 0, 0)"
            })), Object(jsx.c)("path", {
                d: "M10.5985366,6.75918699 L12.32,6.75918699 L12.32,5.49674797 L10.5985366,5.49674797 L10.5985366,6.75918699 Z M10.598374,12.5549593 L12.3198374,12.5549593 L12.3198374,7.57219512 L10.598374,7.57219512 L10.598374,12.5549593 Z",
                id: "Fill-8",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M17.1133333,7.51479675 C16.9411382,7.48617886 16.7307317,7.45739837 16.5299187,7.45739837 C15.7839024,7.45739837 15.3534959,7.85918699 15.0570732,8.4904065 L15.0380488,8.4904065 L15.0380488,7.57219512 L13.4694309,7.57219512 L13.4694309,12.5549593 L15.1910569,12.5549593 L15.1910569,10.4508943 C15.1910569,9.47544715 15.6404878,8.89203252 16.4439024,8.89203252 C16.6447154,8.89203252 16.835935,8.89203252 17.0273171,8.94943089 L17.1133333,7.51479675 Z",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M20.0773496,11.4647154 C19.2835285,11.4647154 18.9583252,10.804878 18.9583252,10.0682927 C18.9583252,9.32243902 19.2835285,8.66243902 20.0773496,8.66243902 C20.8711707,8.66243902 21.196374,9.32243902 21.196374,10.0682927 C21.196374,10.804878 20.8711707,11.4647154 20.0773496,11.4647154 M20.0773496,12.6697561 C21.7223902,12.6697561 22.9752358,11.7133333 22.9752358,10.0682927 C22.9752358,8.41382114 21.7223902,7.45739837 20.0773496,7.45739837 C18.4323089,7.45739837 17.1794634,8.41382114 17.1794634,10.0682927 C17.1794634,11.7133333 18.4323089,12.6697561 20.0773496,12.6697561",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M29.3757073,10.0110244 C29.3757073,10.8048455 28.9836748,11.3500488 28.3332683,11.3500488 C27.7594472,11.3500488 27.2812358,10.8048455 27.2812358,10.0780163 C27.2812358,9.332 27.7020488,8.77720325 28.3332683,8.77720325 C29.0026992,8.77720325 29.3757073,9.35102439 29.3757073,10.0110244 Z M25.5597724,14.5633821 L27.2812358,14.5633821 L27.2812358,11.856878 L27.3002602,11.856878 C27.6254634,12.4498862 28.2758699,12.6697236 28.8783089,12.6697236 C30.360748,12.6697236 31.1545691,11.4456585 31.1545691,9.97265041 C31.1545691,8.76777236 30.399122,7.45736585 29.0218862,7.45736585 C28.2376585,7.45736585 27.5106667,7.77297561 27.166439,8.47118699 L27.147252,8.47118699 L27.147252,7.5721626 L25.5597724,7.5721626 L25.5597724,14.5633821 Z",
                id: "Fill-12",
                fill: primary,
                mask: "url(#mask-4)"
            }), Object(jsx.c)("path", {
                d: "M33.505252,10.9769919 C33.505252,10.4987805 33.9642764,10.3169919 34.5476911,10.3169919 C34.8059024,10.3169919 35.0546829,10.3361789 35.2745203,10.3457724 C35.2745203,10.929187 34.8633008,11.5221951 34.2128943,11.5221951 C33.8112683,11.5221951 33.505252,11.3212195 33.505252,10.9769919 Z M36.9769593,12.5550407 C36.900374,12.1628455 36.8813496,11.770813 36.8813496,11.3786179 L36.8813496,9.52317073 C36.8813496,8.00252033 35.7815122,7.45747967 34.5094797,7.45747967 C33.7730569,7.45747967 33.1322439,7.56268293 32.5202114,7.81130081 L32.5488293,8.97813008 C33.0270407,8.7103252 33.5816748,8.60512195 34.1364715,8.60512195 C34.7580976,8.60512195 35.2650894,8.78674797 35.2745203,9.46577236 C35.0546829,9.42756098 34.7485041,9.39894309 34.4711057,9.39894309 C33.5530569,9.39894309 31.8984228,9.58056911 31.8984228,11.1013821 C31.8984228,12.1820325 32.7784228,12.6698374 33.7634634,12.6698374 C34.4711057,12.6698374 34.9493171,12.392439 35.3415122,11.770813 L35.3606992,11.770813 C35.3606992,12.0290244 35.3893171,12.2872358 35.3989106,12.5550407 L36.9769593,12.5550407 Z",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M37.750748,14.5634634 C38.1045691,14.6398862 38.4583902,14.6782602 38.8218049,14.6782602 C40.3998537,14.6782602 40.7728618,13.463626 41.2606667,12.2107805 L43.0873333,7.5722439 L41.3658699,7.5722439 L40.3426179,10.8239512 L40.3234309,10.8239512 L39.2522114,7.5722439 L37.3967642,7.5722439 L39.414813,12.6698049 C39.2904228,13.1098049 38.9653821,13.3584228 38.5445691,13.3584228 C38.3053821,13.3584228 38.0949756,13.3296423 37.8655447,13.2532195 L37.750748,14.5634634 Z",
                fill: primary
            }))));
        }, _fundingLogos[constants.h.SOFORT] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!SOFORT_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " sofort logo available");
            var _SOFORT_LOGO_COLORS$l = SOFORT_LOGO_COLORS[logoColor], primary = _SOFORT_LOGO_COLORS$l.primary, secondary = _SOFORT_LOGO_COLORS$l.secondary;
            return Object(jsx.c)("svg", {
                width: "138px",
                height: "32px",
                viewBox: "0 0 138 44",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.c)("g", {
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd"
            }, Object(jsx.c)("g", {
                transform: "translate(-24.000000, -436.000000)"
            }, Object(jsx.c)("g", {
                transform: "translate(24.000000, 436.000000)"
            }, Object(jsx.c)("g", {
                "stroke-width": "1"
            }, Object(jsx.c)("g", {
                mask: "url(#mask-2)",
                "fill-rule": "evenodd",
                fill: primary
            }, Object(jsx.c)("rect", {
                x: "0",
                y: "0",
                width: "138",
                height: "44"
            })), Object(jsx.c)("g", {
                transform: "translate(16.000000, 5.000000)",
                "fill-rule": "nonzero",
                fill: secondary
            }, Object(jsx.c)("path", {
                d: "M8.55107133,24.0386247 C9.22879411,24.6861671 9.24327745,25.7425763 8.58354713,26.4073957 L8.45110904,26.5423627 C7.79086355,27.1983175 6.69897696,27.2144066 6.01224032,26.5722566 L2.17289107,22.8768054 C1.11590922,21.8458618 0.96410333,20.5754632 1.63678914,19.9042365 L1.77159366,19.7668966 C2.32598975,19.2126062 3.22970309,19.1541252 3.86016464,19.6360673 C4.15990129,19.8651943 4.59424066,19.8150784 4.83028878,19.5241303 C5.0663369,19.2331822 5.01470714,18.8115781 4.7149705,18.5824512 C3.5284497,17.675442 1.82767241,17.7855026 0.775688111,18.8373698 L0.64137931,18.9742146 C-0.604692328,20.2175294 -0.354282964,22.3130983 1.19683948,23.8259789 L5.04656839,27.5313427 C6.28726435,28.6915831 8.24857838,28.6626828 9.44549924,27.4733999 L9.58132339,27.3350447 C10.7636633,26.1435999 10.7376475,24.2460125 9.52028002,23.0828568 C9.24837962,22.8230647 8.81099605,22.8264175 8.54335646,23.0903455 C8.27571687,23.3542735 8.27917094,23.7788325 8.55107133,24.0386247 Z"
            }), Object(jsx.c)("path", {
                d: "M6.25316137,4.00463901 L7.82450265,16.5582851 C7.87051944,16.9259191 8.21485204,17.1877352 8.59359104,17.1430676 C8.97233003,17.0984001 9.24205468,16.7641637 9.19603789,16.3965297 L7.61982167,3.8039371 L7.60423898,3.7221812 C7.33535457,2.67817937 8.00377183,1.50751858 8.89431251,1.32322405 C9.39350944,1.21977105 9.9143927,1.3151232 10.3403167,1.58785163 C10.7662406,1.86058007 11.0615522,2.28785533 11.1600097,2.7738347 L13.8959914,14.1304918 C13.9828807,14.4910975 14.3544774,14.7150537 14.7259757,14.6307121 C15.097474,14.5463704 15.3281952,14.1856693 15.2413059,13.8250637 L12.5104951,2.49173037 C12.3457557,1.67638792 11.8361294,0.939028727 11.1011021,0.468374716 C10.3660749,-0.00227929421 9.46717414,-0.16683078 8.60603358,0.0116310396 C6.93120471,0.358231477 5.83076908,2.26447015 6.25316137,4.00463901 Z"
            }), Object(jsx.c)("path", {
                d: "M20.6946385,18.7562157 L23.8016655,3.70806757 C24.1627527,2.08823591 23.171098,0.461930237 21.5243733,-0.0131380565 C19.6806639,-0.465927398 17.8331452,0.588982967 17.3518411,2.34622562 L13.9119445,13.7963592 C13.8051409,14.1518899 14.01548,14.5241472 14.3817501,14.6278193 C14.7480201,14.7314913 15.1315221,14.5273196 15.2383257,14.1717889 L18.6826501,2.70623335 C18.9740354,1.64312835 20.0755418,1.01418179 21.1583367,1.27975309 C22.0849843,1.54768368 22.6596154,2.49007404 22.4491321,3.43451398 L19.3399561,18.4926732 C19.2649826,18.8557898 19.5074605,19.20915 19.8815457,19.2819253 C20.2556309,19.3547006 20.6196649,19.1193324 20.6946385,18.7562157 Z"
            }), Object(jsx.c)("path", {
                d: "M12.8691892,33.2538889 C7.94394615,33.2538889 3.83027027,29.7443025 3.83027027,24.757037 C3.83027027,24.3866994 3.52098374,24.0864815 3.13945946,24.0864815 C2.75793518,24.0864815 2.44864865,24.3866994 2.44864865,24.757037 C2.44864865,30.5262551 7.21772847,34.595 12.8691892,34.595 C13.2507135,34.595 13.56,34.2947821 13.56,33.9244444 C13.56,33.5541068 13.2507135,33.2538889 12.8691892,33.2538889 Z"
            }), Object(jsx.c)("path", {
                d: "M10.432735,21.523985 C10.32527,21.8997898 10.0848456,22.2268322 9.75367873,22.4476857 L9.6059963,22.5431752 C8.81135162,23.0620226 7.73737824,22.860771 7.20041193,22.0943828 L4.18000129,17.7280455 C3.35596459,16.5133712 3.46371228,15.2353866 4.25688098,14.7069262 L4.40481451,14.6112693 C5.42222949,14.0388226 6.28666557,14.4731364 7.17531296,15.7298428 L9.70102318,19.3822431 C9.91366027,19.6897297 10.3428334,19.7716746 10.6596081,19.5652723 C10.9763829,19.3588699 11.0608031,18.9422806 10.848166,18.634794 L8.31843628,14.9766458 C7.06906995,13.2097547 5.52101546,12.4319743 3.67452351,13.4735669 L3.48275305,13.5961381 C1.99799965,14.5853027 1.82065576,16.6887608 3.02954142,18.4706511 L6.05567438,22.8452879 C7.02249844,24.2252138 8.95163568,24.5867144 10.3747579,23.6575027 L10.5280578,23.5583063 C11.1349164,23.1536749 11.5696876,22.5622681 11.7640218,21.8826817 C11.8660652,21.5258361 11.650769,21.1562586 11.2831443,21.0572072 C10.9155196,20.9581559 10.5347784,21.1671394 10.432735,21.523985 Z"
            }), Object(jsx.c)("path", {
                d: "M15.0071132,23.7451482 C13.5716937,24.5235597 12.6792061,25.9892512 12.5683793,28.2063913 C12.5498892,28.5762937 12.8438232,28.8907086 13.2248991,28.9086565 C13.6059751,28.9266044 13.9298874,28.6412889 13.9483774,28.2713865 C14.048744,26.2635083 14.8525076,25.179561 16.152515,24.704555 C16.8482268,24.4503509 17.6046979,24.3996276 18.2711038,24.4684707 C18.3606758,24.477724 18.4201821,24.4863334 18.4442402,24.4906858 C19.3337661,24.6516105 19.6045203,23.3685934 18.7214531,23.1770635 L13.4090206,22.0248413 C10.9225036,21.3638621 10.5472361,20.4704561 11.0076227,18.9808309 C11.2064187,18.3317669 11.6147718,17.9986147 12.2306776,17.865687 C12.6373189,17.7779238 13.0941226,17.7888366 13.5282841,17.8626882 C13.6538003,17.8840387 13.7420731,17.9043308 13.7811352,17.9152244 L21.8451208,19.7433694 C21.8985237,19.7533496 21.9361525,19.763479 22.0020154,19.7924494 C22.1354002,19.8511201 22.2742678,19.9453829 22.4097247,20.0858789 C22.9502905,20.6465543 23.2485509,21.7041959 23.09758,23.4414127 C22.571614,29.5314735 19.6483005,33.3130406 12.7195863,33.2539148 C12.3380768,33.2506592 12.0260833,33.5482264 12.0227294,33.9185497 C12.0193755,34.288873 12.3259312,34.5917185 12.7074407,34.5949741 C20.4944029,34.6614237 23.8949457,30.262518 24.474342,23.5537955 C24.6558214,21.4655214 24.2521788,20.0341915 23.4184922,19.1694909 C22.9588119,18.69271 22.4737204,18.4793376 22.1015974,18.4267977 L14.1289333,16.6177417 C14.0788208,16.6028791 13.9434651,16.5717637 13.7667652,16.5417067 C13.169132,16.4400483 12.5401983,16.4250234 11.9308051,16.5565455 C10.8493625,16.7899475 10.0333579,17.4556796 9.68377867,18.5970598 C9.0191343,20.7475737 9.72889785,22.4373206 13.0761134,23.3260543 L15.0071132,23.7451482 Z"
            }))), Object(jsx.c)("path", {
                d: "M60.72,30.286 C63.712,30.286 66,28.284 66,25.336 C66,22.608 64.064,21.42 61.688,20.716 C60.17,20.276 59.224,19.946 59.224,18.868 C59.224,17.966 59.884,17.262 60.918,17.262 C61.798,17.262 62.458,17.768 62.92,18.538 L65.406,16.976 C64.636,15.26 62.898,14.38 61.006,14.38 C58.014,14.38 56.122,16.536 56.122,19.022 C56.122,21.002 57.31,22.542 60.258,23.4 C61.864,23.862 62.876,24.17 62.876,25.446 C62.876,26.634 62.018,27.382 60.764,27.382 C59.422,27.382 58.41,26.524 57.794,25.732 L55.726,27.822 C56.826,29.318 58.63,30.286 60.72,30.286 Z M73.546,30.286 C70.378,30.286 67.804,27.756 67.804,24.676 C67.804,21.596 70.378,19.066 73.546,19.066 C76.714,19.066 79.288,21.596 79.288,24.676 C79.288,27.756 76.714,30.286 73.546,30.286 Z M73.546,27.47 C75.086,27.47 76.296,26.26 76.296,24.676 C76.296,23.092 75.086,21.882 73.546,21.882 C72.006,21.882 70.796,23.092 70.796,24.676 C70.796,26.26 72.006,27.47 73.546,27.47 Z M87.428,17.416 L87.428,14.6 L86.988,14.6 C83.336,14.6 81.554,17.02 81.554,19.88 L81.554,30 L84.546,30 L84.546,25.556 C84.546,24.082 85.69,23.026 87.34,22.982 L87.34,20.122 C86.152,20.122 85.206,20.474 84.546,21.178 L84.546,20.034 C84.546,18.186 85.756,17.35 87.428,17.416 Z M95.018,30.286 C91.85,30.286 89.276,27.756 89.276,24.676 C89.276,21.596 91.85,19.066 95.018,19.066 C98.186,19.066 100.76,21.596 100.76,24.676 C100.76,27.756 98.186,30.286 95.018,30.286 Z M95.018,27.47 C96.558,27.47 97.768,26.26 97.768,24.676 C97.768,23.092 96.558,21.882 95.018,21.882 C93.478,21.882 92.268,23.092 92.268,24.676 C92.268,26.26 93.478,27.47 95.018,27.47 Z M106.018,20.562 L106.018,19.352 L103.114,19.352 L103.114,30 L106.106,30 L106.106,25.138 C106.106,23.378 107.14,22.388 108.944,22.388 L108.944,19.176 C107.58,19.132 106.612,19.594 106.018,20.562 Z M114.378,24.566 L114.378,21.97 C115.038,22.674 115.984,23.026 117.172,23.026 L117.172,20.166 C115.544,20.122 114.378,19.044 114.378,17.592 L114.378,15.92 L111.386,15.92 L111.386,24.72 C111.386,27.58 113.168,30 116.82,30 L117.26,30 L117.26,27.184 C115.588,27.25 114.378,26.414 114.378,24.566 Z M121.572,30.176 C122.672,30.176 123.574,29.274 123.574,28.174 C123.574,27.074 122.672,26.172 121.572,26.172 C120.472,26.172 119.57,27.074 119.57,28.174 C119.57,29.274 120.472,30.176 121.572,30.176 Z",
                fill: secondary
            })))));
        }, _fundingLogos[constants.h.EPS] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!EPS_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " eps logo available");
            var _EPS_LOGO_COLORS$logo = EPS_LOGO_COLORS[logoColor], primary = _EPS_LOGO_COLORS$logo.primary, secondary = _EPS_LOGO_COLORS$logo.secondary, tertiary = _EPS_LOGO_COLORS$logo.tertiary;
            return Object(jsx.c)("svg", {
                width: "52px",
                height: "32px",
                viewBox: "0 0 52 32",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.c)("g", {
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd",
                transform: "matrix(1.333759, 0, 0, 1.333759, 0.000008, -0.000005)"
            }, Object(jsx.c)("g", {
                transform: "translate(-100.000000, -159.000000)"
            }, Object(jsx.c)("g", {
                transform: "translate(100.000000, 159.000000)"
            }, Object(jsx.c)("path", {
                d: "M30.5812744,12.0000152 L27.4748661,12.0000152 C27.129394,12.0000152 26.8482796,11.7245987 26.8482796,11.3798207 C26.8482796,11.0350427 27.129394,10.7315163 27.4748661,10.7315163 L32.2041612,10.7315163 L32.2041612,8.39747822 L27.4748661,8.39747822 C25.824238,8.39747822 24.4812484,9.74381226 24.4812484,11.3911357 C24.4812484,13.0384592 25.824238,14.3847932 27.4748661,14.3847932 L30.5390793,14.3847932 C30.8846021,14.3847932 31.1657165,14.6590934 31.1657165,15.0038715 C31.1657165,15.3486495 30.8846021,15.6025522 30.5390793,15.6025522 L23.9683147,15.6025522 C23.4104473,16.6680913 22.8679974,17.5814106 21.7668179,18.0380702 L30.5812744,18.0380702 C32.2041612,18.0146791 33.5316827,16.6405903 33.5316827,15.0078292 C33.5316827,13.3751696 32.2041612,12.0234063 30.5812744,12.0000152",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M18.6731848,15.6025522 L16.2795788,15.6025522 L16.2795788,13.1992034 C16.2795788,11.8562182 17.3483005,10.7635839 18.6731848,10.7635839 C19.9980691,10.7635839 21.0759195,11.8562182 21.0759195,13.1992034 C21.0759195,14.5422393 19.9980691,15.6025522 18.6731848,15.6025522 M18.6731848,8.39747822 C16.0403551,8.39747822 13.8959637,10.5557023 13.8959637,13.2076262 L13.8959637,13.3091061 L13.8959637,23.2135459 L16.2795788,23.2135459 L16.2795788,18.0380702 L18.6682147,18.0380702 C21.3010951,18.0380702 23.4379299,15.8511273 23.4379299,13.1992034 C23.4379299,10.5472795 21.3060651,8.39747822 18.6731848,8.39747822",
                fill: primary
            }), Object(jsx.c)("g", {
                transform: "translate(0.000000, 6.842233)"
            }, Object(jsx.c)("mask", {
                fill: secondary
            }, Object(jsx.c)("polygon", {
                points: "0 0.0330469345 12.6787834 0.0330469345 12.6787834 12.7180364 0 12.7180364",
                transform: "matrix(1, 0, 0, 1, 0, 0)"
            })), Object(jsx.c)("path", {
                d: "M6.34967672,11.1958376 C4.09589259,11.1958376 2.20112146,9.58905539 1.68833992,7.48994334 C1.68833992,7.48994334 1.54020078,6.7959222 1.54020078,6.3389074 C1.54020078,5.8818926 1.68042835,5.18071712 1.68042835,5.18071712 C2.19686138,3.08678055 4.08935033,1.52754165 6.33943225,1.52754165 C8.98580286,1.52754165 11.1573269,3.67982918 11.1573269,6.32744017 L11.1573269,7.49182072 L4.12642315,7.49182072 C4.54162861,8.30366004 5.38137113,8.76031966 6.34967672,8.76031966 L12.6701111,8.76031966 L12.6787834,1.89423932 C12.6787834,0.870560677 11.8417287,0.0330469345 10.8185493,0.0330469345 L1.86031521,0.0330469345 C0.837135761,0.0330469345 -2.02860858e-05,0.845190698 -2.02860858e-05,1.86886934 L-2.02860858e-05,10.831474 C-2.02860858e-05,11.8551526 0.837135761,12.7180364 1.86031521,12.7180364 L10.8185493,12.7180364 C11.7367482,12.7180364 12.5027001,12.0584169 12.6506871,11.1958376 L6.34967672,11.1958376 Z",
                fill: tertiary
            })), Object(jsx.c)("path", {
                d: "M6.33943732,10.6481099 C5.37483394,10.6481099 4.53595358,11.238926 4.11907451,12.0000254 L8.55990156,12.0000254 C8.1430225,11.238926 7.30419285,10.6481099 6.33943732,10.6481099",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M10.396619,3.96072558 C10.396619,1.77327526 8.57959428,1.52219873e-05 6.33823537,1.52219873e-05 C4.134,1.52219873e-05 2.34126788,1.71527949 2.28238752,3.85259873 C2.28142393,3.86163044 2.28218466,3.87040846 2.28218466,3.87969387 L2.28218466,5.0699518 C2.28218466,5.21232812 2.39806892,5.35308076 2.54392588,5.35308076 L4.03703251,5.35308076 C4.18288947,5.35308076 4.31079324,5.21232812 4.31079324,5.0699518 L4.31079324,3.96072558 C4.31079324,2.86839577 5.22011704,1.97968541 6.33940182,1.97968541 C7.45868661,1.97968541 8.3680104,2.86839577 8.3680104,3.96072558 L8.3680104,5.0699518 C8.3680104,5.21232812 8.486329,5.35308076 8.63218596,5.35308076 L10.1253433,5.35308076 C10.2712003,5.35308076 10.396619,5.21232812 10.396619,5.0699518 L10.396619,3.96072558 Z",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M20.7598572,20.7474063 C20.7598572,20.8523366 20.8407987,20.9002858 20.9277753,20.9002858 C21.0206856,20.9002858 21.1436192,20.8253429 21.1436192,20.687381 C21.1436192,20.5884888 21.0716036,20.5345015 20.9907129,20.5345015 C20.8827909,20.5345015 20.7598572,20.6034063 20.7598572,20.7474063 Z M20.0403098,20.7504 C20.0403098,20.8523366 20.1183098,20.9002858 20.2022434,20.9002858 C20.3071732,20.9002858 20.4211303,20.8253429 20.4211303,20.6843873 C20.4211303,20.5854444 20.3550991,20.5345015 20.2681732,20.5345015 C20.160302,20.5345015 20.0403098,20.6034063 20.0403098,20.7504 Z M21.3474437,21.133233 L21.1315997,22.3559645 C21.0236778,22.9739772 20.6189196,23.2570047 20.0702824,23.2570047 C19.6056296,23.2570047 19.2458559,22.9539856 19.3508364,22.3569793 L19.5666296,21.133233 L19.8994736,21.133233 L19.6835282,22.3559645 C19.6175984,22.7370723 19.7885087,22.9540364 20.1122746,22.9540364 C20.4450679,22.9540364 20.7298845,22.7559983 20.7988065,22.3569793 L21.0146505,21.133233 L21.3474437,21.133233 Z",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M21.9179189,22.5590867 C21.9059501,22.8050233 22.0647901,22.9639915 22.2956458,22.9639915 C22.5864468,22.9639915 22.8682205,22.7389598 22.8862244,22.3971247 C22.898244,22.1481438 22.736361,22.0011501 22.511439,22.0011501 C22.2236302,22.0011501 21.9358213,22.2321691 21.9179189,22.5590867 Z M22.1517667,21.1331924 L22.0018525,21.9781142 C22.1307199,21.8042283 22.388556,21.7122368 22.5684429,21.7122368 C22.9401854,21.7122368 23.1980216,21.9302156 23.1980216,22.3350698 C23.1980216,22.9079746 22.7992479,23.2524989 22.2896614,23.2524989 C22.0917706,23.2524989 21.9238525,23.178926 21.8219657,22.9930148 L21.7650125,23.2135307 L21.4741607,23.2135307 L21.8429111,21.1331924 L22.1517667,21.1331924 Z",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M24.7516112,22.3509666 C24.7755995,22.0972668 24.6256853,21.994011 24.3768257,21.994011 C24.1520559,21.994011 23.9451886,22.0972668 23.8551691,22.3509666 L24.7516112,22.3509666 Z M23.804251,22.6046664 C23.7922315,22.8076262 23.9511222,22.9733429 24.2209779,22.9733429 C24.3708921,22.9733429 24.5686814,22.9146875 24.6766034,22.812751 L24.8445215,23.006882 C24.6616931,23.1747298 24.3918375,23.2582985 24.1640247,23.2582985 C23.7383212,23.2582985 23.4894616,23.0032288 23.4894616,22.6132922 C23.4894616,22.0943746 23.8971612,21.7076854 24.4188179,21.7076854 C24.895541,21.7076854 25.1653459,21.9957869 25.0034629,22.6046664 L23.804251,22.6046664 Z",
                id: "Fill-16",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M25.8283814,21.7420871 L25.8133697,21.9376896 C25.9573502,21.7485311 26.131202,21.7099687 26.290042,21.7099687 C26.4339718,21.7099687 26.5628391,21.7610638 26.6318118,21.8360068 L26.4459913,22.1059941 C26.3800108,22.0461717 26.314081,22.0161844 26.2001239,22.0161844 C25.9872215,22.0161844 25.7774633,22.1438968 25.729436,22.4168778 L25.5885999,23.2135459 L25.2797442,23.2135459 L25.5405726,21.7420871 L25.8283814,21.7420871 Z",
                fill: tertiary
            }), Object(jsx.c)("polygon", {
                fill: tertiary,
                points: "28.1192941 21.7420871 28.275142 22.9057573 28.8387909 21.7420871 29.1835529 21.7420871 28.4100952 23.2135459 28.0473293 23.2135459 27.900458 22.2428397 27.6635672 22.7250723 27.4057818 23.2135459 27.0460081 23.2135459 26.7851797 21.7420871 27.1329847 21.7420871 27.285891 22.9057573 27.8524307 21.7420871"
            }), Object(jsx.c)("path", {
                d: "M30.5274503,22.3509666 C30.5513879,22.0972668 30.4015244,21.994011 30.1526649,21.994011 C29.9278951,21.994011 29.7210277,22.0972668 29.6310082,22.3509666 L30.5274503,22.3509666 Z M29.5800901,22.6046664 C29.5680706,22.8076262 29.7269614,22.9733429 29.996817,22.9733429 C30.1467312,22.9733429 30.3445205,22.9146875 30.4524425,22.812751 L30.6203606,23.006882 C30.4375322,23.1747298 30.1676766,23.2582985 29.9398638,23.2582985 C29.5141603,23.2582985 29.2653008,23.0032288 29.2653008,22.6132922 C29.2653008,22.0943746 29.6730004,21.7076854 30.1946571,21.7076854 C30.6713801,21.7076854 30.941185,21.9957869 30.7793021,22.6046664 L29.5800901,22.6046664 Z",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M31.3524449,21.3412364 C31.3524449,21.4461666 31.4304449,21.5003569 31.5144293,21.5003569 C31.63432,21.5003569 31.7452342,21.4222173 31.7452342,21.2753759 C31.7452342,21.1762808 31.6702264,21.119249 31.5892849,21.119249 C31.4783707,21.119249 31.3524449,21.1913505 31.3524449,21.3412364 Z M31.625242,21.742082 L31.3645151,23.2135408 L31.0556594,23.2135408 L31.3164878,21.742082 L31.625242,21.742082 Z",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M32.9955925,22.1060753 C32.8996393,21.9981006 32.7767563,21.9681133 32.629885,21.9681133 C32.4259085,21.9681133 32.2820801,22.0371704 32.2820801,22.1661006 C32.2820801,22.2740753 32.398928,22.3191831 32.5728811,22.3341006 C32.8426861,22.3580499 33.1874481,22.4481133 33.1154832,22.8290182 C33.0645651,23.1049421 32.7887251,23.266904 32.4049631,23.266904 C32.1651815,23.266904 31.9342752,23.2129167 31.7784273,22.9939738 L31.9792596,22.7750309 C32.0901737,22.9279104 32.2850723,22.9909801 32.4589241,22.9939738 C32.6057953,22.9939738 32.7797485,22.9399865 32.806729,22.8020245 C32.8337095,22.6700499 32.7167602,22.619107 32.5009163,22.5979992 C32.2490645,22.5739992 31.9733259,22.481145 31.9733259,22.202126 C31.9733259,21.833145 32.3719475,21.7042148 32.6718265,21.7042148 C32.8996393,21.7042148 33.0675573,21.7551577 33.2055027,21.9022021 L32.9955925,22.1060753 Z",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M33.9703034,21.7420871 L33.8294672,22.534493 C33.7844828,22.7865184 33.8984399,22.9606579 34.1562254,22.9606579 C34.3990498,22.9606579 34.6059172,22.7593725 34.6478079,22.5134359 L34.7827104,21.7420871 L35.0915153,21.7420871 L34.8307884,23.2135459 L34.5519562,23.2135459 L34.5729016,23.0003366 C34.3990498,23.1652922 34.2280888,23.2430765 34.0213229,23.2430765 C33.658557,23.2430765 33.442713,22.982882 33.5206116,22.5361167 L33.6615492,21.7420871 L33.9703034,21.7420871 Z",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M36.4472345,23.2135459 L36.588172,22.4259603 C36.633055,22.1709412 36.5462813,22.0020279 36.2644061,22.0020279 C36.0185895,22.0020279 35.8116207,22.199863 35.7697299,22.4428059 L35.6348274,23.2135459 L35.3260225,23.2135459 L35.5869016,21.7420871 L35.8686246,21.7420871 L35.8476792,21.957123 C36.0185895,21.7981548 36.1953827,21.7197615 36.3872384,21.7197615 C36.7470121,21.7197615 36.9809614,21.9701632 36.9000199,22.4231696 L36.7590823,23.2135459 L36.4472345,23.2135459 Z",
                fill: tertiary
            }), Object(jsx.c)("g", {
                transform: "translate(37.174252, 21.709040)"
            }, Object(jsx.c)("mask", {
                fill: secondary
            }, Object(jsx.c)("polygon", {
                points: "0.0103575649 0.00128879493 1.81575683 0.00128879493 1.81575683 2.2832981 0.0103575649 2.2832981",
                transform: "matrix(1, 0, 0, 1, 0, 0)"
            })), Object(jsx.c)("path", {
                d: "M0.406639662,0.85909852 C0.406639662,1.11092093 0.571514824,1.26400338 0.808507022,1.26400338 C1.44691014,1.26400338 1.61787113,0.2832 0.979214434,0.2832 C0.676444603,0.2832 0.406639662,0.508028753 0.406639662,0.85909852 Z M0.319663069,1.70747061 C0.298717685,1.91043044 0.45456554,1.9925277 0.715495319,1.9925277 C0.943358778,1.9925277 1.18922614,1.86522114 1.24617932,1.54134799 L1.291113,1.288663 C1.15621053,1.4776186 0.910343173,1.55220634 0.72756554,1.55220634 C0.349686476,1.55220634 0.085916645,1.32717463 0.085916645,0.91912389 C0.085916645,0.337339535 0.517553836,0.00128879493 1.00619493,0.00128879493 C1.21316372,0.00128879493 1.39903498,0.099572093 1.46501547,0.267572093 L1.51598427,0.0330520085 L1.8157619,0.0330520085 L1.55787503,1.54824863 C1.46202328,2.1092296 1.04524564,2.28331839 0.664526528,2.28331839 C0.208748895,2.28331839 -0.0429507152,2.06265032 0.0198854356,1.70747061 L0.319663069,1.70747061 Z",
                fill: tertiary
            }))))));
        }, _fundingLogos[constants.h.MYBANK] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!MYBANK_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " mybank logo available");
            var _MYBANK_LOGO_COLORS$l = MYBANK_LOGO_COLORS[logoColor], primary = _MYBANK_LOGO_COLORS$l.primary, secondary = _MYBANK_LOGO_COLORS$l.secondary, tertiary = _MYBANK_LOGO_COLORS$l.tertiary;
            return Object(jsx.c)("svg", {
                width: "58px",
                height: "32px",
                viewBox: "0 0 58 32",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.c)("g", {
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd",
                transform: "matrix(1.333867, 0, 0, 1.333867, -0.00001, -0.00321)"
            }, Object(jsx.c)("g", {
                transform: "translate(-100.000000, -159.000000)"
            }, Object(jsx.c)("g", {
                transform: "translate(100.000000, 159.000000)"
            }, Object(jsx.c)("path", {
                d: "M29.010016,14.6206556 C29.010016,14.6206556 27.947442,14.8389924 27.9585564,14.0777038 C27.9698571,13.3164773 29.8942008,13.3619719 30.0914038,13.4236258 C30.0914038,13.4236258 30.1519432,14.2874637 29.010016,14.6206556 M29.3297879,9.81836571 C27.677716,9.80301439 26.9053582,10.753926 26.9053582,10.753926 C26.4037199,11.2864986 26.7253546,12.0076376 27.2173686,12.0597202 C27.924406,12.1345501 27.9170171,11.5413802 29.0022546,11.2784811 C29.9542434,11.0477763 29.9954723,11.9305703 29.9954723,11.9305703 C25.9352386,11.8295126 26.1290887,15.239929 27.5113104,15.9642377 C28.8367183,16.658714 30.0756326,15.7825701 30.0756326,15.7825701 C30.0756326,15.7825701 30.1222013,16.2545455 30.777951,16.2545455 C31.5283904,16.2545455 31.5272727,15.5049412 31.5272727,15.5049412 L31.5242302,12.1853897 C31.4748674,9.75671183 29.3297879,9.81836571 29.3297879,9.81836571",
                id: "Fill-1",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M42.4169651,14.9132636 L40.766254,12.4266353 L41.9794586,11.2784792 C41.9794586,11.2784792 42.5394372,10.7597112 42.0797024,10.2455911 C41.5701862,9.67606803 40.9629029,10.2382165 40.9629029,10.2382165 L39.4383789,11.6556411 L39.4383789,8.81056644 C39.4383789,8.40291433 39.1083605,8.07272727 38.7011934,8.07272727 C38.2936547,8.07272727 37.9636364,8.40291433 37.9636364,8.81056644 L37.9636364,15.5050966 C37.9636364,15.9126248 38.2936547,16.2429358 38.7011934,16.2429358 C39.1083605,16.2429358 39.4383789,15.9126248 39.4383789,15.5050966 L39.4383789,13.7227806 L39.7172538,13.4440304 L41.2106953,15.7865117 C41.2106953,15.7865117 41.697426,16.5998328 42.4143027,16.0821803 C42.9532914,15.6931198 42.4169651,14.9132636 42.4169651,14.9132636",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M37.0887651,12.0920353 C37.0887651,9.6760941 35.0962232,9.33568291 33.7411943,10.1020724 C33.7401529,10.1029393 33.7389278,10.1056016 33.7382539,10.1063446 C33.6363205,9.81249385 33.362313,9.6 33.0365425,9.6 C32.6248269,9.6 32.2909091,9.93768691 32.2909091,10.3541303 L32.2909091,15.3913243 C32.2909091,15.8078915 32.6248269,16.1454545 33.0365425,16.1454545 C33.4485644,16.1454545 33.7826048,15.8078915 33.7826048,15.3913243 L33.7723134,11.9929705 C33.7723134,11.9929705 33.9532086,11.7752139 34.2436332,11.5669922 C34.9412403,11.0671487 35.6063806,11.2374162 35.6063806,12.0917257 L35.6234716,15.4035835 C35.6234716,15.8135877 35.9518762,16.1454545 36.3573435,16.1454545 C36.7625045,16.1454545 37.0909091,15.8135877 37.0909091,15.4035835 L37.0887651,12.0920353 Z",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M15.5613016,16.2862697 C15.7330634,15.9971851 15.762994,15.7935853 15.762994,15.7935853 L14.0695172,11.3349218 C14.0695172,11.3349218 13.7622674,10.4721348 14.4393994,10.2166114 C15.1567468,9.94557914 15.4157136,10.6357839 15.4696009,10.7805123 C15.5234881,10.9252407 16.5395249,13.6504516 16.5395249,13.6504516 L17.5177483,10.7867779 C17.5177483,10.7867779 17.7979621,9.89638514 18.5815138,10.2138818 C19.2290232,10.4764773 18.8964002,11.3498103 18.8964002,11.3498103 C18.8964002,11.3498103 17.8952671,14.3335844 17.0561037,16.4983684 C16.5548597,17.7916804 16.1267792,17.9191009 15.6376676,18.0403799 C14.9830758,18.2027884 13.7454545,18.1223286 13.7454545,17.30247 C13.7454545,16.655814 14.4027561,16.615491 14.6992284,16.6251065 C14.7151175,16.6254167 15.3279543,16.6788911 15.5613016,16.2862697",
                fill: secondary
            }), Object(jsx.c)("path", {
                d: "M11.5669215,8.85710249 L10.0137262,13.1590392 L8.3203761,8.88327934 C8.3203761,8.88327934 8.06948196,8.07272727 7.36345596,8.07272727 C6.54545455,8.07272727 6.57202708,8.72317872 6.55361169,8.88327934 C6.53525811,9.04350403 6.55361169,15.569481 6.55361169,15.569481 C6.55361169,15.569481 6.54545455,16.2545455 7.29591229,16.2545455 C8.06280792,16.2545455 8.02603896,15.56334 8.03209502,15.56334 C8.03821288,15.56334 8.03209502,12.1182301 8.03209502,12.1182301 L9.27754342,15.56334 C9.27754342,15.56334 9.46151186,16.2407127 10.0381976,16.2283686 C10.6148833,16.2161486 10.7804982,15.56334 10.7804982,15.56334 L11.823501,12.1244331 L11.823501,15.56334 C11.823501,15.56334 11.823501,16.2545455 12.5780991,16.2545455 C13.3081022,16.2545455 13.3081022,15.56334 13.3081022,15.56334 L13.3090909,8.88948239 C13.3090909,8.88948239 13.3090909,8.07272727 12.5166733,8.07663519 C11.8595284,8.07973672 11.609932,8.71207526 11.5669215,8.85710249 C11.5619778,8.8740368 11.5596913,8.88327934 11.5596913,8.88327934",
                fill: secondary
            }), Object(jsx.c)("g", null, Object(jsx.c)("mask", {
                fill: tertiary
            }, Object(jsx.c)("polygon", {
                points: "3.086436e-05 0.00960615385 42.6159033 0.00960615385 42.6159033 24 3.086436e-05 24",
                transform: "matrix(1, 0, 0, 1, 0, 0)"
            })), Object(jsx.c)("g", null), Object(jsx.c)("path", {
                d: "M42.6159341,18.6971754 L29.5208652,18.6971754 L19.9057529,18.6956369 L19.9124196,18.7062215 C18.0119775,20.9263446 15.1892466,22.3382831 12.0318843,22.3382831 C6.30740974,22.3382831 1.66682976,17.7116369 1.66682976,12.0048677 C1.66682976,6.29803692 6.30740974,1.67182154 12.0318843,1.67182154 C15.2027652,1.67182154 18.0390147,3.09182154 19.9398272,5.32819077 L22.0210727,5.32819077 C19.8613082,2.12277538 16.1963507,0.00960615385 12.0318843,0.00960615385 C5.38703452,0.00960615385 3.086436e-05,5.38012923 3.086436e-05,12.0048677 C3.086436e-05,18.6296062 5.38703452,24.0000062 12.0318843,24.0000062 C15.5178286,24.0000062 18.6504994,22.5164985 20.846622,20.1542215 L41.6296327,20.1336062 L42.6159341,18.6971754 Z",
                fill: secondary
            })), Object(jsx.c)("path", {
                d: "M23.5642714,14.6942333 L21.476941,14.6942333 L21.476941,12.703212 L23.5642714,12.703212 C24.0691167,12.729228 24.5593003,12.986305 24.5593003,13.698846 C24.5593003,14.4306215 24.1135333,14.6942333 23.5642714,14.6942333 Z M21.476941,9.5856756 L23.4225205,9.5856756 C23.8122278,9.59572442 24.2213404,9.80372869 24.2213404,10.3852036 C24.2213404,10.9910915 23.8636056,11.1846082 23.4225205,11.1846082 L21.476941,11.1846082 L21.476941,9.5856756 Z M25.2086687,11.7878453 C25.2484033,11.7332241 25.7477042,11.3284357 25.7082776,10.252103 C25.6287468,8.0729285 23.7375637,8.09777311 23.3189641,8.08507338 C22.644646,8.06479081 22.2387368,8.0729285 21.0010496,8.08507338 C19.9559983,8.09543044 19.9636372,9.0459372 19.9636372,9.0459372 L19.9636364,16.1454545 L23.4862807,16.1454545 C25.3714882,16.1454545 26.0727273,15.1069128 26.0727273,13.6549518 C26.0727273,12.1940516 25.2086687,11.7878453 25.2086687,11.7878453 Z",
                fill: secondary
            })))));
        }, _fundingLogos[constants.h.P24] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!P24_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " p24 logo available");
            var _P24_LOGO_COLORS$logo = P24_LOGO_COLORS[logoColor], primary = _P24_LOGO_COLORS$logo.primary, secondary = _P24_LOGO_COLORS$logo.secondary;
            return Object(jsx.c)("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                version: "1.1",
                viewBox: "0 0 100 32",
                height: "32",
                width: "100",
                preserveAspectRatio: "xMinYMin meet"
            }, Object(jsx.c)("g", {
                transform: "matrix(1.2953205,0,0,1.4482638,-127.73674,-229.48747)"
            }, Object(jsx.c)("g", {
                transform: "translate(99,159)"
            }, Object(jsx.c)("path", {
                transform: "matrix(0.77200971,0,0,0.69048194,-0.38599675,-0.54304623)",
                d: "M 34.123047 14.666016 L 32.416016 14.667969 L 30.496094 27.771484 L 32.208984 27.773438 L 34.123047 14.666016 z M 2.4082031 14.669922 L 0.5 27.771484 L 2.2753906 27.773438 L 2.9785156 22.916016 L 6.421875 22.933594 C 6.421875 22.933594 7.7610468 22.994689 8.7128906 22.419922 C 9.6646511 21.844634 9.9179688 20.537109 9.9179688 20.537109 C 9.9179688 20.537109 10.021944 20.051453 10.107422 19.458984 C 10.201364 18.808401 10.297704 18.027313 10.347656 17.611328 C 10.369589 17.428799 10.382812 17.316406 10.382812 17.316406 C 10.382812 17.316406 10.406035 17.181738 10.408203 16.972656 C 10.411247 16.680039 10.373345 16.24144 10.173828 15.824219 C 10.107822 15.686199 10.023752 15.551336 9.9179688 15.423828 C 9.7749921 15.251532 9.573657 15.118146 9.3457031 15.015625 C 9.1093266 14.909344 8.8444066 14.836083 8.5878906 14.785156 C 8.2611582 14.720236 7.9481918 14.691729 7.7226562 14.679688 C 7.5151753 14.668598 7.3808594 14.669922 7.3808594 14.669922 L 4.5292969 14.669922 L 2.4082031 14.669922 z M 3.9023438 16.636719 L 6.5097656 16.644531 C 6.5097656 16.644531 6.6871684 16.640189 6.9335938 16.644531 C 7.2136679 16.6496 7.5842469 16.667097 7.8886719 16.712891 C 8.149399 16.752066 8.3620627 16.811675 8.4277344 16.90625 C 8.5143382 17.03109 8.5484972 17.190294 8.5605469 17.335938 C 8.5776425 17.542977 8.5477921 17.723762 8.546875 17.736328 C 8.5451652 17.758038 8.3882592 18.81021 8.1777344 20.056641 C 8.0971356 20.533644 7.7783765 20.790093 7.4101562 20.878906 C 6.8022654 21.025453 6.1484375 21 6.1484375 21 L 3.2695312 20.990234 L 3.9023438 16.636719 z M 27.246094 18.195312 C 26.565902 18.205016 26.253806 18.2403 26 18.302734 C 26 18.302734 24.790129 18.501565 24.103516 19.472656 C 23.416902 20.4437 23.212891 22.568359 23.212891 22.568359 C 23.212891 22.568359 22.804576 24.916796 22.923828 25.699219 C 23.042829 26.481642 23.256401 27.206424 24.033203 27.546875 C 24.810173 27.88723 25.46875 27.873047 25.46875 27.873047 C 25.46875 27.873047 26.853325 27.996517 27.896484 27.714844 C 28.939685 27.433792 29.490234 26.595703 29.490234 26.595703 C 29.490234 26.595703 29.735609 26.235379 29.912109 25.804688 C 30.088777 25.374043 30.140682 25.073949 30.148438 25.037109 L 30.257812 24.53125 L 28.484375 24.533203 C 28.484375 24.533203 28.385914 25.868868 27.429688 25.992188 C 26.473716 26.115218 25.960314 26.068498 25.775391 26.060547 C 25.593178 26.052871 24.567122 26.102566 24.650391 25.125 C 24.650808 25.111821 24.651179 25.091912 24.652344 25.064453 C 24.69996 23.94948 24.808594 23.660156 24.808594 23.660156 L 30.375 23.642578 L 30.613281 22.072266 C 30.883598 20.286624 30.683916 18.929319 29.257812 18.398438 C 28.779056 18.220288 27.947801 18.185366 27.246094 18.195312 z M 37.748047 18.197266 C 37.067855 18.206824 36.755758 18.242238 36.501953 18.304688 C 36.501953 18.304688 35.292082 18.503803 34.605469 19.474609 C 33.918854 20.445938 33.714844 22.570313 33.714844 22.570312 C 33.714844 22.570312 33.306572 24.918749 33.425781 25.701172 C 33.545028 26.483643 33.758145 27.207998 34.535156 27.548828 C 35.311959 27.889232 35.970703 27.875 35.970703 27.875 C 35.970703 27.875 37.355488 27.998135 38.398438 27.716797 C 39.441597 27.435412 39.992187 26.597656 39.992188 26.597656 C 39.992188 26.597656 40.237604 26.237189 40.414062 25.806641 C 40.590771 25.376138 40.642384 25.077855 40.650391 25.041016 L 40.759766 24.533203 L 38.986328 24.535156 C 38.986328 24.535156 38.887867 25.871106 37.931641 25.994141 C 36.975669 26.117315 36.462059 26.072303 36.277344 26.064453 C 36.095172 26.056777 35.06916 26.104467 35.152344 25.126953 C 35.152802 25.113774 35.153175 25.093967 35.154297 25.066406 C 35.201874 23.951433 35.310547 23.662109 35.310547 23.662109 L 40.876953 23.644531 L 41.115234 22.076172 C 41.385759 20.290531 41.185607 18.931462 39.759766 18.400391 C 39.280716 18.222193 38.449796 18.187223 37.748047 18.197266 z M 46.277344 18.304688 L 43.757812 24.96875 L 43.179688 18.316406 L 41.541016 18.318359 L 42.371094 27.773438 L 44.355469 27.765625 L 46.90625 21.148438 L 47.486328 27.765625 L 49.505859 27.765625 L 53.117188 18.316406 L 51.417969 18.318359 L 48.898438 24.996094 L 48.300781 18.3125 L 46.277344 18.304688 z M 11.253906 18.310547 L 9.7929688 27.720703 L 11.617188 27.720703 L 12.427734 22.507812 C 12.596271 21.449811 13.285209 20.144531 14.638672 20.144531 L 15.582031 20.140625 L 15.865234 18.310547 L 14.873047 18.310547 C 14.184891 18.310547 13.533952 18.621542 12.978516 18.96875 L 13.076172 18.310547 L 11.253906 18.310547 z M 23.574219 18.310547 L 17.048828 18.320312 L 16.789062 20.167969 L 20.960938 20.167969 L 15.732422 25.884766 L 15.451172 27.771484 L 22.191406 27.769531 L 22.457031 25.939453 L 17.880859 25.951172 L 23.335938 20.005859 L 23.574219 18.310547 z M 59.283203 18.3125 L 56.183594 25.228516 L 55.087891 18.320312 L 53.347656 18.316406 L 54.962891 27.882812 L 54.755859 28.283203 C 54.755859 28.283203 54.42297 29.081956 54.011719 29.267578 C 53.600426 29.452827 52.910156 29.304688 52.910156 29.304688 L 52.650391 31.068359 L 53.066406 31.152344 C 53.459811 31.231491 53.623329 31.198848 54.033203 31.152344 C 54.443329 31.10608 54.748768 30.903232 55.25 30.449219 C 55.751441 29.99568 56.560547 28.207031 56.560547 28.207031 L 61.027344 18.330078 L 59.283203 18.3125 z M 37.816406 20.023438 C 38.153219 20.022293 38.536406 20.045829 38.880859 20.126953 C 39.109271 20.180351 39.326106 20.327316 39.382812 20.544922 C 39.516491 21.058003 39.375 21.841797 39.375 21.841797 L 35.558594 21.835938 L 35.710938 21.144531 C 35.710938 21.144531 35.842858 20.605552 36.107422 20.375 C 36.372026 20.144305 36.710486 20.103629 37.029297 20.068359 C 37.188702 20.050872 37.479594 20.024582 37.816406 20.023438 z M 27.330078 20.027344 C 27.666911 20.026207 28.050203 20.04988 28.394531 20.130859 C 28.623194 20.184445 28.839945 20.329507 28.896484 20.546875 C 29.030121 21.059954 28.886719 21.84375 28.886719 21.84375 L 25.072266 21.839844 L 25.224609 21.148438 C 25.224609 21.148438 25.35653 20.607886 25.621094 20.376953 C 25.885906 20.146258 26.224367 20.107486 26.542969 20.072266 C 26.702373 20.054561 26.993245 20.028481 27.330078 20.027344 z ",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "m 18.656138,16.774358 c -0.0046,0.0239 -0.0083,0.04735 -0.01154,0.07058 -0.0065,0.118231 0.01306,-0.07708 0.01154,-0.07058",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "m 26.763669,16.775893 c -0.0046,0.02391 -0.0083,0.04743 -0.01154,0.07066 -0.0065,0.118089 0.01306,-0.07731 0.01154,-0.07066",
                fill: primary
            }), Object(jsx.c)("path", {
                transform: "matrix(0.77200971,0,0,0.69048194,-0.38599675,-0.54304623)",
                d: "M 51.226562 0.78710938 C 50.728893 0.78574323 50.439453 0.79296875 50.439453 0.79296875 L 48.318359 5.6542969 C 48.318359 5.6542969 49.531198 5.9719517 51.199219 6.5273438 C 54.144731 7.5791572 56.515625 9.2929688 56.515625 9.2929688 L 66.666016 3.234375 C 66.745656 3.1868271 63.084253 2.0998969 59.082031 1.3945312 C 56.08052 0.86568549 52.71957 0.7912078 51.226562 0.78710938 z M 47.589844 0.90820312 C 47.589844 0.90820313 43.781742 1.1966088 40.910156 1.8066406 C 38.038322 2.4166724 34.904297 3.3691406 34.904297 3.3691406 L 35.34375 6.2011719 C 35.34375 6.2011719 37.385444 5.5830734 39.835938 5.25 C 42.979007 4.7627651 46.330078 5.2851562 46.330078 5.2851562 L 47.589844 0.90820312 z M 32.949219 4.0429688 C 32.949219 4.0429687 31.321834 4.6211203 28.267578 6.0117188 C 25.213321 7.4021267 22.914062 8.8925781 22.914062 8.8925781 L 25.453125 10.84375 C 25.453125 10.84375 27.099522 9.6851386 28.839844 8.8378906 C 30.525001 7.9290065 33.464844 6.8066406 33.464844 6.8066406 L 32.949219 4.0429688 z M 71.046875 5.0175781 L 58.333984 10.615234 L 60.566406 12.546875 L 78.900391 12.546875 C 78.900391 12.546875 78.861436 11.867776 78.373047 10.908203 C 78.067288 10.306786 77.515959 9.6724399 76.935547 9.0117188 C 76.724772 8.771647 75.878829 8.0196942 75.248047 7.5527344 C 73.629269 6.3552786 72.725403 5.8908131 71.046875 5.0175781 z M 20.621094 10.361328 C 20.621094 10.361328 18.007768 12.208509 16.898438 13.080078 C 15.819753 13.883157 13.6875 15.744141 13.6875 15.744141 L 19.160156 15.744141 C 19.160156 15.744141 20.387652 14.611026 21.257812 13.884766 C 22.127974 13.158363 23.712891 12.011719 23.712891 12.011719 L 20.621094 10.361328 z M 66.779297 14.519531 C 65.231195 14.543948 64.467235 14.626145 63.683594 14.955078 C 62.899953 15.283726 62.446574 15.882838 62.158203 16.728516 C 61.840059 17.527168 61.65625 19.259766 61.65625 19.259766 L 63.453125 19.261719 L 63.560547 18.464844 C 63.560547 18.464844 63.753461 17.029388 64.181641 16.751953 C 64.31878 16.663088 64.538495 16.579747 64.792969 16.529297 C 65.262594 16.436347 65.860733 16.425312 66.345703 16.445312 C 67.093861 16.476103 67.374266 16.483376 68.134766 16.582031 C 68.895557 16.68089 68.701172 17.517578 68.701172 17.517578 L 68.552734 18.767578 C 68.552734 18.767578 68.488006 19.327955 68.3125 19.677734 C 68.157306 19.987057 67.733373 20.195678 67.488281 20.287109 C 66.896194 20.507571 64.871094 21.095703 64.871094 21.095703 L 63.275391 21.619141 C 63.275391 21.619141 62.297563 21.944394 61.748047 22.636719 C 61.19878 23.329281 60.983257 24.116118 60.908203 24.527344 C 60.833113 24.938283 60.412109 27.769531 60.412109 27.769531 L 69.009766 27.773438 L 69.296875 25.810547 L 62.496094 25.820312 L 62.619141 25.021484 C 62.619141 25.021484 62.697988 24.196554 62.990234 23.927734 C 63.082461 23.842591 63.127078 23.730658 63.669922 23.509766 C 63.993778 23.377829 65.103516 23.039062 65.103516 23.039062 L 67.669922 22.240234 C 67.669922 22.240234 69.069743 21.828553 69.621094 20.957031 C 70.172403 20.085747 70.384766 18.416016 70.384766 18.416016 C 70.384766 18.416016 70.533003 16.793571 70.419922 16.285156 C 70.307099 15.776804 69.886071 15.166455 69.375 14.90625 C 68.863719 14.646045 68.327565 14.495353 66.779297 14.519531 z ",
                fill: secondary
            }), Object(jsx.c)("g", {
                transform: "translate(53.596306,9.56338)"
            }, Object(jsx.c)("path", {
                d: "M 4.7408782,5.7106164 1.839113,5.7061141 5.3711256,1.8647573 Z M 6.112171,5.7095319 7.0417209,0.01876197 5.3948175,0.01774319 0.26289873,5.6444944 0.02981113,7.0693723 4.5178982,7.0688465 4.1894639,9.0682502 l 1.376733,0.00181 0.3251187,-2.001047 1.2714396,0.00269 0.2297076,-1.3639812 z",
                fill: secondary
            })))));
        }, _fundingLogos[constants.h.BLIK] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!BLIK_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " blik logo available");
            var _BLIK_LOGO_COLORS$log = BLIK_LOGO_COLORS[logoColor], primary = _BLIK_LOGO_COLORS$log.primary, secondary = _BLIK_LOGO_COLORS$log.secondary, tertiary = _BLIK_LOGO_COLORS$log.tertiary, quaternary = _BLIK_LOGO_COLORS$log.quaternary, quinary = _BLIK_LOGO_COLORS$log.quinary, senary = _BLIK_LOGO_COLORS$log.senary;
            return Object(jsx.c)("svg", {
                width: "58px",
                height: "30px",
                viewBox: "0 0 58 30",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.c)("defs", null, Object(jsx.c)("path", {
                d: "M4.81760131,0 C2.15699346,0 0,2.12049689 0,4.73608696 L0,4.73608696 L0,25.263913 C0,27.8795031 2.15699346,30 4.81760131,30 L4.81760131,30 L53.1823987,30 C55.8430065,30 58,27.8795031 58,25.263913 L58,25.263913 L58,4.73608696 C58,2.12049689 55.8430065,0 53.1823987,0 L53.1823987,0 L4.81760131,0 Z",
                id: "path-1"
            }), Object(jsx.c)("linearGradient", {
                x1: "50%",
                y1: "100%",
                x2: "50%",
                y2: "0%",
                id: "linearGradient-3"
            }, Object(jsx.c)("stop", {
                "stop-color": primary,
                offset: "0%"
            }), Object(jsx.c)("stop", {
                "stop-color": secondary,
                offset: "100%"
            })), Object(jsx.c)("radialGradient", {
                cx: "20.3705659%",
                cy: "18.0870534%",
                fx: "20.3705659%",
                fy: "18.0870534%",
                r: "117.639519%",
                gradientTransform: "translate(0.203706,0.180871),scale(0.983106,1.000000),rotate(54.479781),translate(-0.203706,-0.180871)",
                id: "radialGradient-4"
            }, Object(jsx.c)("stop", {
                "stop-color": tertiary,
                offset: "0%"
            }), Object(jsx.c)("stop", {
                "stop-color": quaternary,
                offset: "55.9042441%"
            }), Object(jsx.c)("stop", {
                "stop-color": quinary,
                offset: "100%"
            })), Object(jsx.c)("path", {
                d: "M3.67238562,6.95664596 C5.60913072,6.95664596 7.17892157,5.41322981 7.17892157,3.50925466 C7.17892157,1.60546584 5.60913072,0.0620496894 3.67238562,0.0620496894 C1.73564052,0.0620496894 0.165849673,1.60546584 0.165849673,3.50925466 C0.165849673,5.41322981 1.73564052,6.95664596 3.67238562,6.95664596 Z",
                id: "path-5"
            })), Object(jsx.c)("g", {
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd"
            }, Object(jsx.c)("g", {
                transform: "translate(-100.000000, -159.000000)"
            }, Object(jsx.c)("g", {
                transform: "translate(100.000000, 159.000000)"
            }, Object(jsx.c)("g", null, Object(jsx.c)("mask", {
                id: "mask-2",
                fill: "white"
            }, Object(jsx.c)("use", {
                href: "#path-1"
            })), Object(jsx.c)("g", {
                id: "Clip-2"
            }), Object(jsx.c)("path", {
                d: "M4.81760131,0 C2.15699346,0 0,2.12049689 0,4.73608696 L0,4.73608696 L0,25.263913 C0,27.8795031 2.15699346,30 4.81760131,30 L4.81760131,30 L53.1823987,30 C55.8430065,30 58,27.8795031 58,25.263913 L58,25.263913 L58,4.73608696 C58,2.12049689 55.8430065,0 53.1823987,0 L53.1823987,0 L4.81760131,0 Z",
                fill: "url(#linearGradient-3)",
                mask: "url(#mask-2)"
            })), Object(jsx.c)("g", {
                transform: "translate(6.254902, 4.472050)",
                fill: senary
            }, Object(jsx.c)("polygon", {
                points: "17.627451 21.6769565 21.5604575 21.6769565 21.5604575 0.0154658385 17.627451 0.0154658385"
            }), Object(jsx.c)("polygon", {
                points: "24.9248366 21.6769565 28.8578431 21.6769565 28.8578431 7.32913043 24.9248366 7.32913043"
            }), Object(jsx.c)("polygon", {
                points: "46.4852941 21.6770124 40.5751699 14.0838447 46.0114379 7.32918634 41.3676471 7.32918634 36.1552288 13.8822298 36.1552288 0.0155217391 32.2222222 0.0155217391 32.2222222 21.6770124 36.1552288 21.6770124 36.1552288 14.3106149 41.3676471 21.6770124"
            }), Object(jsx.c)("path", {
                d: "M7.60539216,17.9735963 C5.65575817,17.9735963 4.0751634,16.4197453 4.0751634,14.5030994 C4.0751634,12.5864534 5.65575817,11.0326025 7.60539216,11.0326025 C9.55502614,11.0326025 11.1356209,12.5864534 11.1356209,14.5030994 C11.1356209,16.4197453 9.55502614,17.9735963 7.60539216,17.9735963 M7.60539216,7.16614286 C6.3282549,7.16614286 5.12636601,7.4821677 4.0751634,8.03800621 L4.0751634,0.0155217391 L0.142156863,0.0155217391 L0.142156863,14.5030994 C0.142156863,18.5551491 3.48360131,21.8400559 7.60539216,21.8400559 C11.727183,21.8400559 15.0686275,18.5551491 15.0686275,14.5030994 C15.0686275,10.4510497 11.727183,7.16614286 7.60539216,7.16614286"
            })), Object(jsx.c)("g", {
                transform: "translate(14.026144, 3.354037)"
            }, Object(jsx.c)("mask", {
                id: "mask-6",
                fill: "white"
            }, Object(jsx.c)("use", {
                href: "#path-5"
            })), Object(jsx.c)("use", {
                fill: "url(#radialGradient-4)",
                href: "#path-5"
            }), Object(jsx.c)("path", {
                d: "M3.67238562,6.95664596 C5.60913072,6.95664596 7.17892157,5.41322981 7.17892157,3.50925466 C7.17892157,1.60546584 5.60913072,0.0620496894 3.67238562,0.0620496894 C1.73564052,0.0620496894 0.165849673,1.60546584 0.165849673,3.50925466 C0.165849673,5.41322981 1.73564052,6.95664596 3.67238562,6.95664596 Z",
                mask: "url(#mask-6)"
            }))))));
        }, _fundingLogos[constants.h.MAXIMA] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!MAXIMA_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " maxima logo available");
            var _MAXIMA_LOGO_COLORS$l = MAXIMA_LOGO_COLORS[logoColor], primary = _MAXIMA_LOGO_COLORS$l.primary, secondary = _MAXIMA_LOGO_COLORS$l.secondary;
            return Object(jsx.c)("svg", {
                width: "93px",
                height: "20px",
                viewBox: "0 0 93 20",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.c)("defs", null, Object(jsx.c)("polygon", {
                id: "path-1",
                points: "0.126046849 0.210564103 13.9960414 0.210564103 13.9960414 19.7435897 0.126046849 19.7435897"
            })), Object(jsx.c)("g", {
                id: "Page-1",
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd"
            }, Object(jsx.c)("g", {
                id: "SPB_&_AltPay_NewAssets",
                transform: "translate(-101.000000, -153.000000)"
            }, Object(jsx.c)("g", {
                id: "logo-maxima",
                transform: "translate(101.000000, 153.000000)"
            }, Object(jsx.c)("path", {
                d: "M24.7684479,3.31769231 L31.0927027,3.31769231 C31.6107,4.85923077 32.1393986,6.37589744 32.679563,7.86205128 C33.3708205,9.79794872 33.9293301,11.3192308 34.3477027,12.4258974 C34.4990507,12.8233333 34.6516726,13.2235897 34.8042945,13.6202564 L34.6631384,16.9894872 L30.5446397,16.9894872 C30.4111274,16.4687179 30.2518808,15.9366667 30.0765822,15.3917949 C29.8329986,14.6961538 29.656426,14.1761538 29.5481384,13.8374359 L24.6869137,13.8374359 L23.3049082,16.9894872 L17.5085877,16.9894872 C18.7168233,14.9294872 19.9696479,12.6705128 21.2706288,10.2146154 C22.4380973,8.01717949 23.6025082,5.72051282 24.7684479,3.31769231 Z M26.1713466,10.3571795 L28.6736836,10.3571795 L27.6769274,7.00128205 L26.1713466,10.3571795 Z",
                id: "Fill-1",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M81.6723452,3.31769231 L87.9971096,3.31769231 C88.5140877,4.85923077 89.0417671,6.37589744 89.5832055,7.86205128 C90.2754822,9.79794872 90.8309342,11.3192308 91.2516,12.4258974 C91.8325315,13.9528205 92.4188137,15.4738462 93,16.9894872 L87.4470082,16.9894872 C87.3114575,16.4687179 87.1555233,15.9366667 86.9781863,15.3917949 C86.7371507,14.6961538 86.5605781,14.1761538 86.4505068,13.8374359 L81.5915753,13.8374359 L80.2067671,16.9894872 L74.4119753,16.9894872 C75.618937,14.9294872 76.872526,12.6705128 78.174526,10.2146154 C79.3419945,8.01717949 80.5038575,5.72051282 81.6723452,3.31769231 Z M83.076263,10.3571795 L85.5747781,10.3571795 L84.5803151,7.00128205 L83.076263,10.3571795 Z",
                id: "Fill-3",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M58.2832529,3.31807692 L64.9953049,3.31807692 C65.0651186,3.78217949 65.2523926,4.97474359 65.5637515,6.89858974 C65.8231323,8.46730769 65.9920611,9.69115385 66.0746145,10.5621795 C66.3449515,9.41653846 66.7452337,7.9024359 67.2734227,6.01935897 C67.7088666,4.47730769 67.9565268,3.57576923 68.0248118,3.31807692 L74.8996775,3.31807692 C74.8996775,4.79141026 74.8619679,6.30371795 74.7875679,7.85192308 C74.7154611,9.39782051 74.6372392,11.0239744 74.5656419,12.7219231 C74.4904775,14.4196154 74.4530227,15.8429487 74.4530227,16.9888462 L69.9372995,16.9888462 C69.9372995,16.0196154 69.9696584,14.9288462 70.0379433,13.7142308 C70.202031,10.7967949 70.2830556,8.96705128 70.2830556,8.22884615 L67.8235241,16.9888462 L63.3681871,16.9888462 L61.9469433,8.22884615 C61.7958501,9.62141026 61.6679433,11.1034615 61.5588912,12.670641 C61.4498392,14.2398718 61.3950584,15.6798718 61.3950584,16.9888462 L57.1058474,16.9888462 C57.2806364,15.4737179 57.4635789,13.9188462 57.65442,12.3237179 C57.8439871,10.7267949 57.9960995,9.18371795 58.1097378,7.69730769 C58.2251597,6.21192308 58.2832529,4.75064103 58.2832529,3.31807692",
                id: "Fill-5",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M50.0900038,3.31807692 L55.5584038,3.31807692 C55.1650011,7.91525641 54.9698285,12.4742308 54.9698285,16.9888462 L50.1251655,16.9888462 L49.461171,16.3744872 C49.4754395,15.2557692 49.525634,14.0047436 49.6109901,12.6201282 C49.7131627,10.9747436 49.8178833,9.27397436 49.9259162,7.51397436 C50.0342038,5.75346154 50.0900038,4.355 50.0900038,3.31807692",
                id: "Fill-7",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M1.17743096,3.31807692 L7.8899926,3.31807692 C7.95878712,3.78217949 8.14631589,4.97474359 8.45869397,6.89858974 C8.71552685,8.46730769 8.88522,9.69115385 8.96726384,10.5621795 C9.23963918,9.41653846 9.6386474,7.9024359 10.1676008,6.01935897 C10.6030447,4.47730769 10.8507049,3.57576923 10.9194995,3.31807692 L17.7938556,3.31807692 C17.7938556,4.79141026 17.7556364,6.30371795 17.6812364,7.85192308 C17.6091296,9.39782051 17.5314173,11.0239744 17.4580364,12.7219231 C17.3836364,14.4196154 17.3464364,15.8429487 17.3464364,16.9888462 L12.8304584,16.9888462 C12.8304584,16.0196154 12.8630721,14.9288462 12.932631,13.7142308 C13.0949351,10.7967949 13.1764693,8.96705128 13.1764693,8.22884615 L10.716683,16.9888462 L6.26185562,16.9888462 L4.83882822,8.22884615 C4.68900904,9.62141026 4.56110219,11.1034615 4.45230493,12.670641 C4.3422337,14.2398718 4.29025562,15.6798718 4.29025562,16.9888462 L2.54794521e-05,16.9888462 C0.174050137,15.4737179 0.356992603,13.9188462 0.54732411,12.3237179 C0.737655616,10.7267949 0.890277534,9.18371795 1.00569945,7.69730769 C1.12010219,6.21192308 1.17743096,4.75064103 1.17743096,3.31807692",
                id: "Fill-9",
                fill: primary
            }), Object(jsx.c)("g", {
                id: "Group-13",
                transform: "translate(35.161644, 0.045846)"
            }, Object(jsx.c)("mask", {
                id: "mask-2",
                fill: "white"
            }, Object(jsx.c)("use", {
                href: "#path-1"
            })), Object(jsx.c)("g", {
                id: "Clip-12"
            }), Object(jsx.c)("path", {
                d: "M13.9960414,17.0754359 L13.5193208,17.5531282 C13.4044085,17.5285128 13.3037647,17.5190256 13.2135674,17.5190256 C13.0303701,17.5190256 12.8729071,17.6226154 12.7373564,17.828 C12.6698359,17.9638974 12.7513701,18.1431282 12.9760989,18.3746667 C13.065277,18.4656923 13.3167592,18.6572308 13.7239208,18.9572308 L13.7239208,19.0251795 C13.7239208,19.092359 13.7585729,19.3331282 13.825329,19.743641 C12.4433236,19.743641 11.2075701,19.4695385 10.1203619,18.9218462 C9.4420989,18.5805641 8.38674,17.8482564 6.95887151,16.7321026 C6.32596192,16.1867179 5.79955644,15.6851795 5.37940027,15.228 C4.95669616,14.7695385 4.52303589,14.2005641 4.07001123,13.5174872 L0.126046849,16.8015897 L0.228983836,14.338 L2.8113263,11.1905641 C2.33664411,10.6656923 1.91495918,10.0977436 1.55493452,9.48005128 C1.30345233,8.95466667 1.09961671,8.44979487 0.942663288,7.95825641 C0.784945479,7.46569231 0.670287945,6.96235897 0.602512603,6.4354359 C0.716660548,6.21005128 0.772460548,6.04748718 0.772460548,5.958 L0.670287945,5.51312821 L4.34085781,1.74953846 L7.26564411,6.57261538 L12.8387647,0.414666667 C12.9541866,0.27825641 13.0446386,0.210564103 13.11114,0.210564103 C13.2688578,0.210564103 13.3501373,0.518769231 13.3501373,1.13364103 C13.3501373,1.63441026 13.3167592,2.15928205 13.2484742,2.70697436 C13.1801893,3.25517949 13.1330523,3.63158974 13.11114,3.83748718 C12.907814,4.88312821 12.1250852,5.96723077 10.7655016,7.08671795 C9.8607263,7.83953846 9.20259205,8.49005128 8.79517562,9.03594872 C8.92970712,9.35133333 9.04461945,9.60441026 9.13379753,9.78902564 C9.67727425,10.9254359 10.1422742,11.8277436 10.5277784,12.4910769 C11.0931674,13.4482564 11.6287455,14.2572308 12.1250852,14.9192821 C12.6221893,15.578 13.2484742,16.2956923 13.9960414,17.0754359",
                id: "Fill-11",
                fill: secondary,
                mask: "url(#mask-2)"
            }))))));
        }, _fundingLogos[constants.h.BOLETO] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!BOLETO_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " boleto logo available");
            var _BOLETO_LOGO_COLORS$l = BOLETO_LOGO_COLORS[logoColor], primary = _BOLETO_LOGO_COLORS$l.primary, secondary = _BOLETO_LOGO_COLORS$l.secondary;
            return Object(jsx.c)("svg", {
                width: "50px",
                height: "23px",
                viewBox: "0 0 50 23",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.c)("g", {
                id: "Page-1",
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd"
            }, Object(jsx.c)("g", {
                id: "SPB_&_AltPay_NewAssets",
                transform: "translate(-100.000000, -159.000000)"
            }, Object(jsx.c)("g", {
                id: "Group-38-Copy-2",
                transform: "translate(100.000000, 159.000000)"
            }, Object(jsx.c)("polygon", {
                id: "Fill-1",
                fill: primary,
                points: "3.77543103 22.2594828 6.12112069 22.2594828 6.12112069 0.294827586 3.77543103 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-3",
                fill: primary,
                points: "6.86077586 22.2594828 7.58793103 22.2594828 7.58793103 0.294827586 6.86077586 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-4",
                fill: primary,
                points: "8.22112069 22.2594828 9.52241379 22.2594828 9.52241379 0.294827586 8.22112069 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-5",
                fill: primary,
                points: "10.7771552 22.2594828 11.5043103 22.2594828 11.5043103 0.294827586 10.7771552 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-6",
                fill: primary,
                points: "11.8202586 22.2594828 12.3806034 22.2594828 12.3806034 0.294827586 11.8202586 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-7",
                fill: primary,
                points: "1.99181034 22.2594828 2.71896552 22.2594828 2.71896552 0.294827586 1.99181034 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-8",
                fill: primary,
                points: "0.388793103 22.2594828 1.69008621 22.2594828 1.69008621 0.294827586 0.388793103 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-9",
                fill: primary,
                points: "16.2655172 22.2594828 18.6112069 22.2594828 18.6112069 0.294827586 16.2655172 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-10",
                fill: primary,
                points: "19.350431 22.2594828 20.0775862 22.2594828 20.0775862 0.294827586 19.350431 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-11",
                fill: primary,
                points: "20.7112069 22.2594828 22.0125 22.2594828 22.0125 0.294827586 20.7112069 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-12",
                fill: primary,
                points: "23.2668103 22.2594828 23.9939655 22.2594828 23.9939655 0.294827586 23.2668103 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-13",
                fill: primary,
                points: "24.3099138 22.2594828 24.8702586 22.2594828 24.8702586 0.294827586 24.3099138 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-14",
                fill: primary,
                points: "14.4814655 22.2594828 15.2086207 22.2594828 15.2086207 0.294827586 14.4814655 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-15",
                fill: primary,
                points: "12.8784483 22.2594828 14.1797414 22.2594828 14.1797414 0.294827586 12.8784483 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-16",
                fill: primary,
                points: "25.7918103 22.2594828 27.0931034 22.2594828 27.0931034 0.294827586 25.7918103 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-17",
                fill: primary,
                points: "28.3474138 22.2594828 29.074569 22.2594828 29.074569 0.294827586 28.3474138 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-18",
                fill: primary,
                points: "29.3909483 22.2594828 29.9512931 22.2594828 29.9512931 0.294827586 29.3909483 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-19",
                fill: primary,
                points: "32.0521552 22.2594828 32.7793103 22.2594828 32.7793103 0.294827586 32.0521552 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-20",
                fill: primary,
                points: "30.4491379 22.2594828 31.750431 22.2594828 31.750431 0.294827586 30.4491379 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-21",
                fill: primary,
                points: "33.7456897 22.2594828 34.4728448 22.2594828 34.4728448 0.294827586 33.7456897 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-22",
                fill: primary,
                points: "34.7887931 22.2594828 35.3491379 22.2594828 35.3491379 0.294827586 34.7887931 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-23",
                fill: primary,
                points: "37.450431 22.2594828 38.1775862 22.2594828 38.1775862 0.294827586 37.450431 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-24",
                fill: primary,
                points: "35.8474138 22.2594828 37.1487069 22.2594828 37.1487069 0.294827586 35.8474138 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-25",
                fill: primary,
                points: "38.8112069 22.2594828 41.1568966 22.2594828 41.1568966 0.294827586 38.8112069 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-26",
                fill: primary,
                points: "41.8961207 22.2594828 42.6232759 22.2594828 42.6232759 0.294827586 41.8961207 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-27",
                fill: primary,
                points: "43.2564655 22.2594828 44.5577586 22.2594828 44.5577586 0.294827586 43.2564655 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-28",
                fill: primary,
                points: "45.8125 22.2594828 46.5396552 22.2594828 46.5396552 0.294827586 45.8125 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-29",
                fill: primary,
                points: "46.8556034 22.2594828 47.4159483 22.2594828 47.4159483 0.294827586 46.8556034 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-30",
                fill: primary,
                points: "48.3375 22.2594828 49.6387931 22.2594828 49.6387931 0.294827586 48.3375 0.294827586"
            }), Object(jsx.c)("polygon", {
                id: "Fill-31",
                fill: secondary,
                points: "3.04224138 22.3090517 48.0056034 22.3090517 48.0056034 9.9987069 3.04224138 9.9987069"
            }), Object(jsx.c)("path", {
                d: "M3.89008621,21.837069 L3.89008621,10.6991379 L8.06939655,10.6991379 C8.91982759,10.6991379 9.6012931,10.8107759 10.1172414,11.0362069 C10.6306034,11.2616379 11.0327586,11.6090517 11.3228448,12.0784483 C11.6159483,12.5452586 11.7612069,13.0349138 11.7612069,13.5482759 C11.7612069,14.0228448 11.6314655,14.4715517 11.375,14.8913793 C11.1181034,15.3116379 10.7293103,15.6512931 10.2081897,15.9103448 C10.8823276,16.1073276 11.4008621,16.4443966 11.7612069,16.9215517 C12.1241379,17.3956897 12.3056034,17.9586207 12.3056034,18.6068966 C12.3056034,19.1301724 12.1939655,19.6150862 11.9737069,20.0637931 C11.7534483,20.512069 11.4810345,20.8568966 11.1568966,21.1008621 C10.8327586,21.3418103 10.4258621,21.5258621 9.93836207,21.650431 C9.44827586,21.775 8.84956897,21.837069 8.13922414,21.837069 L3.89008621,21.837069 Z M5.36767241,15.3814655 L7.7762931,15.3814655 C8.42974138,15.3814655 8.8987069,15.3375 9.18146552,15.2517241 C9.55732759,15.1400862 9.84008621,14.9538793 10.0293103,14.6943966 C10.2185345,14.4353448 10.3146552,14.1112069 10.3146552,13.7193966 C10.3146552,13.3487069 10.2262931,13.0219828 10.0474138,12.7422414 C9.87112069,12.4594828 9.61724138,12.2650862 9.28793103,12.1612069 C8.95862069,12.0577586 8.39310345,12.0056034 7.59482759,12.0056034 L5.36767241,12.0056034 L5.36767241,15.3814655 Z M5.36767241,20.5301724 L8.14181034,20.5301724 C8.61896552,20.5301724 8.95344828,20.512069 9.14784483,20.4758621 C9.48491379,20.4163793 9.77025862,20.3150862 9.99827586,20.1724138 C10.2262931,20.0301724 10.412931,19.8228448 10.5607759,19.550431 C10.7086207,19.2780172 10.7810345,18.9646552 10.7810345,18.6094828 C10.7810345,18.1918103 10.675,17.8314655 10.4594828,17.5228448 C10.2469828,17.2142241 9.9512931,16.9991379 9.57284483,16.874569 C9.19698276,16.750431 8.65258621,16.687931 7.94482759,16.687931 L5.36767241,16.687931 L5.36767241,20.5301724 Z",
                id: "Fill-32",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M13.6435345,17.800431 C13.6435345,16.3094828 14.0581897,15.2051724 14.8905172,14.487069 C15.5827586,13.8905172 16.4306034,13.5926724 17.4288793,13.5926724 C18.5357759,13.5926724 19.4431034,13.9556034 20.1482759,14.6814655 C20.8508621,15.4047414 21.2034483,16.4081897 21.2034483,17.6862069 C21.2034483,18.7232759 21.0478448,19.5375 20.737069,20.1310345 C20.4258621,20.725 19.9719828,21.1862069 19.3758621,21.5155172 C18.7818966,21.8448276 18.1314655,22.0081897 17.4288793,22.0081897 C16.2982759,22.0081897 15.3857759,21.6478448 14.6883621,20.924569 C13.9909483,20.2012931 13.6435345,19.1590517 13.6435345,17.800431 Z M15.0435345,17.8030172 C15.0435345,18.8349138 15.2689655,19.6073276 15.7202586,20.1181034 C16.1737069,20.6314655 16.7418103,20.8883621 17.4288793,20.8883621 C18.1077586,20.8883621 18.6732759,20.6314655 19.1267241,20.1155172 C19.5780172,19.599569 19.8034483,18.8142241 19.8034483,17.7590517 C19.8034483,16.7633621 19.575431,16.0090517 19.1215517,15.4982759 C18.6681034,14.9849138 18.1030172,14.7280172 17.4288793,14.7280172 C16.7418103,14.7280172 16.1737069,14.9823276 15.7202586,15.4926724 C15.2689655,16.0034483 15.0435345,16.7737069 15.0435345,17.8030172 Z",
                id: "Fill-33",
                fill: primary
            }), Object(jsx.c)("polygon", {
                id: "Fill-34",
                fill: primary,
                points: "22.7771552 21.837069 24.1461207 21.837069 24.1461207 10.6991379 22.7771552 10.6991379"
            }), Object(jsx.c)("path", {
                d: "M31.7711207,19.2237069 L33.1866379,19.4103448 C32.9663793,20.2323276 32.5543103,20.8724138 31.9525862,21.3262931 C31.3512931,21.7801724 30.5836207,22.0081897 29.6478448,22.0081897 C28.4706897,22.0081897 27.5375,21.6452586 26.8478448,20.9193966 C26.1581897,20.1961207 25.8133621,19.1771552 25.8133621,17.8676724 C25.8133621,16.5146552 26.1607759,15.4616379 26.8581897,14.7150862 C27.5556034,13.9659483 28.4603448,13.5926724 29.5724138,13.5926724 C30.6487069,13.5926724 31.5275862,13.9581897 32.2094828,14.6918103 C32.8909483,15.425431 33.2331897,16.4573276 33.2331897,17.7875 C33.2331897,17.8676724 33.2306034,17.9896552 33.225431,18.150431 L27.2133621,18.150431 C27.2650862,19.0344828 27.5142241,19.7137931 27.9650862,20.1831897 C28.4137931,20.6521552 28.9762931,20.8883621 29.6478448,20.8883621 C30.1482759,20.8883621 30.5758621,20.7560345 30.9284483,20.4913793 C31.2836207,20.2271552 31.5637931,19.8043103 31.7711207,19.2237069 Z M27.2909483,17.0301724 L31.7866379,17.0301724 C31.7271552,16.3512931 31.5534483,15.8431034 31.2706897,15.5034483 C30.837931,14.9771552 30.2724138,14.7125 29.5801724,14.7125 C28.9530172,14.7125 28.4267241,14.9224138 27.9987069,15.3426724 C27.5737069,15.7625 27.337931,16.325 27.2909483,17.0301724 Z",
                id: "Fill-35",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M37.887069,20.6159483 L38.0737069,21.8241379 C37.6900862,21.9047414 37.3452586,21.9461207 37.0443966,21.9461207 C36.549569,21.9461207 36.1655172,21.8681034 35.8909483,21.7099138 C35.6185345,21.5517241 35.4267241,21.3469828 35.3155172,21.0905172 C35.2038793,20.8336207 35.149569,20.2943966 35.149569,19.4724138 L35.149569,14.8215517 L34.1383621,14.8215517 L34.1383621,13.7637931 L35.149569,13.7637931 L35.149569,11.7672414 L36.5181034,10.9456897 L36.5181034,13.7637931 L37.887069,13.7637931 L37.887069,14.8215517 L36.5181034,14.8215517 L36.5181034,19.550431 C36.5181034,19.9418103 36.5413793,20.1935345 36.5909483,20.3047414 C36.6375,20.4163793 36.7155172,20.5043103 36.8241379,20.5719828 C36.9331897,20.6366379 37.0887931,20.6702586 37.2909483,20.6702586 C37.4413793,20.6702586 37.6409483,20.6521552 37.887069,20.6159483",
                id: "Fill-36",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M38.724569,17.800431 C38.724569,16.3094828 39.1396552,15.2051724 39.9715517,14.487069 C40.6637931,13.8905172 41.5116379,13.5926724 42.5099138,13.5926724 C43.6168103,13.5926724 44.524569,13.9556034 45.2297414,14.6814655 C45.9323276,15.4047414 46.2849138,16.4081897 46.2849138,17.6862069 C46.2849138,18.7232759 46.1293103,19.5375 45.8181034,20.1310345 C45.5068966,20.725 45.0534483,21.1862069 44.4568966,21.5155172 C43.8633621,21.8448276 43.2125,22.0081897 42.5099138,22.0081897 C41.3797414,22.0081897 40.4668103,21.6478448 39.7693966,20.924569 C39.0719828,20.2012931 38.724569,19.1590517 38.724569,17.800431 Z M40.124569,17.8030172 C40.124569,18.8349138 40.350431,19.6073276 40.8012931,20.1181034 C41.2551724,20.6314655 41.8228448,20.8883621 42.5099138,20.8883621 C43.1892241,20.8883621 43.7543103,20.6314655 44.2081897,20.1155172 C44.6590517,19.599569 44.8849138,18.8142241 44.8849138,17.7590517 C44.8849138,16.7633621 44.6564655,16.0090517 44.2030172,15.4982759 C43.7491379,14.9849138 43.1840517,14.7280172 42.5099138,14.7280172 C41.8228448,14.7280172 41.2551724,14.9823276 40.8012931,15.4926724 C40.350431,16.0034483 40.124569,16.7737069 40.124569,17.8030172 Z",
                id: "Fill-37",
                fill: primary
            })))));
        }, _fundingLogos[constants.h.OXXO] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!OXXO_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " oxxo logo available");
            var _OXXO_LOGO_COLORS$log = OXXO_LOGO_COLORS[logoColor], primary = _OXXO_LOGO_COLORS$log.primary, secondary = _OXXO_LOGO_COLORS$log.secondary;
            return Object(jsx.c)("svg", {
                width: "42px",
                height: "20px",
                viewBox: "0 0 42 20",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.c)("g", {
                id: "Page-1",
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd"
            }, Object(jsx.c)("g", {
                id: "SPB_&_AltPay_NewAssets",
                transform: "translate(-100.000000, -159.000000)"
            }, Object(jsx.c)("g", {
                id: "logo-OXXO",
                transform: "translate(100.000000, 159.000000)"
            }, Object(jsx.c)("path", {
                d: "M0.142456528,1.48437917 C0.142456528,0.77043992 0.728159303,0.186243119 1.44446761,0.186243119 L40.6503931,0.186243119 C41.3667014,0.186243119 41.9524042,0.77043992 41.9524042,1.48437917 L41.9524042,18.1011373 C41.9524042,18.8150765 41.3667014,19.3990362 40.6503931,19.3990362 L1.44446761,19.3990362 C0.728159303,19.3990362 0.142456528,18.8150765 0.142456528,18.1011373 L0.142456528,1.48437917 Z",
                id: "Fill-2",
                fill: secondary
            }), Object(jsx.c)("polygon", {
                id: "Fill-4",
                fill: "#FEFEFE",
                points: "0.142480318 17.5124813 41.952428 17.5124813 41.952428 2.07265562 0.142480318 2.07265562"
            }), Object(jsx.c)("path", {
                d: "M35.5752619,6.08262231 C33.662331,6.08262231 32.1029152,7.63763417 32.1029152,9.54463469 C32.1029152,11.4511608 33.662331,13.0064099 35.5752619,13.0064099 C37.4877171,13.0064099 39.0471329,11.4511608 39.0471329,9.54463469 C39.0471329,7.63763417 37.4877171,6.08262231 35.5752619,6.08262231",
                id: "Fill-6",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M6.95585459,6.08262231 C5.04268574,6.08262231 3.48326994,7.63763417 3.48326994,9.54463469 C3.48326994,11.4511608 5.04268574,13.0064099 6.95585459,13.0064099 C8.86807185,13.0064099 10.4277255,11.4511608 10.4277255,9.54463469 C10.4277255,7.63763417 8.86807185,6.08262231 6.95585459,6.08262231",
                id: "Fill-7",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M35.5752619,15.0141446 C32.5537303,15.0141446 30.0893537,12.5573397 30.0893537,9.54480072 C30.0893537,6.53155015 32.5537303,4.07521964 35.5752619,4.07521964 C38.5970315,4.07521964 41.0609322,6.53155015 41.0609322,9.54480072 C41.0609322,12.5573397 38.5970315,15.0141446 35.5752619,15.0141446 Z M12.4411918,9.54480072 C12.4411918,12.5573397 9.97729109,15.0141446 6.95575943,15.0141446 C3.93351408,15.0141446 1.46985124,12.5573397 1.46985124,9.54480072 C1.46985124,6.53155015 3.93351408,4.07521964 6.95575943,4.07521964 C9.97729109,4.07521964 12.4411918,6.53155015 12.4411918,9.54480072 Z M35.3028697,3.03585692 C32.0884035,2.9620911 30.5772808,5.01709763 28.384107,7.55170056 L26.3151155,9.94232969 L29.591435,13.8526295 C30.3719756,15.0542296 28.8822636,16.2465793 27.9580332,15.1472077 L24.9288888,11.5447794 L21.9772989,14.9562705 C21.0373673,16.0421223 19.5645461,14.8288999 20.3617394,13.6386849 L23.5659761,9.92382894 L21.4667717,7.42693908 L22.8173138,5.75949957 L24.9522028,8.31639828 L26.7923372,6.18217058 C27.6953948,5.13569219 28.6162946,3.74884741 29.8098246,3.03585692 L0.142385159,3.03585692 L0.142385159,16.549707 L7.07875226,16.549707 C10.2934564,16.549707 11.7529554,14.6332189 13.8866549,12.0492806 L15.8999784,9.61097649 L12.5334959,5.77752594 C11.726073,4.59418943 13.1874752,3.36815887 14.1371606,4.44594623 L17.2483795,7.9779294 L20.1209875,4.49931378 C21.0354641,3.39164059 22.5356435,4.57118208 21.7662842,5.77942346 L18.6486421,9.56757088 L20.8051797,12.0153626 L19.4463112,13.6197098 L17.2997653,11.2058361 L15.5095892,13.3813347 C14.6310351,14.4484486 13.7415376,15.8094397 12.5646605,16.549707 L41.9523328,16.549707 L41.9523328,3.03585692 L35.3028697,3.03585692 Z",
                id: "Fill-8",
                fill: primary
            })))));
        }, _fundingLogos[constants.h.MERCADOPAGO] = function(_ref) {
            var logoColor = _ref.logoColor;
            if (!MERCADOPAGO_LOGO_COLORS[logoColor]) throw new Error("No " + logoColor + " mercadopago logo available");
            var _MERCADOPAGO_LOGO_COL2 = MERCADOPAGO_LOGO_COLORS[logoColor], primary = _MERCADOPAGO_LOGO_COL2.primary, secondary = _MERCADOPAGO_LOGO_COL2.secondary, tertiary = _MERCADOPAGO_LOGO_COL2.tertiary, quaternary = _MERCADOPAGO_LOGO_COL2.quaternary;
            return Object(jsx.c)("svg", {
                width: "98px",
                height: "26px",
                viewBox: "0 0 98 26",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg"
            }, Object(jsx.c)("title", null, "MercadoPago"), Object(jsx.c)("g", {
                id: "Page-1",
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd"
            }, Object(jsx.c)("g", {
                id: "MERCADO-PAGO-SPEC",
                transform: "translate(-1451.000000, -108.000000)"
            }, Object(jsx.c)("g", {
                id: "BTN_OXXO_SILVER",
                transform: "translate(1340.000000, 97.000000)"
            }, Object(jsx.c)("g", {
                id: "LOGO_MERCADOPAGO_2_26",
                transform: "translate(111.000000, 11.000000)"
            }, Object(jsx.c)("path", {
                d: "M35.6856062,11.9270732 C35.6856062,5.49784553 27.6975208,0.257102279 17.8434328,0.257102279 C7.98985878,0.257102279 0.00203049886,5.49784553 0.00203049886,11.9270732 C0.00203049886,12.0931114 -2.57025172e-05,12.5521584 -2.57025172e-05,12.6102461 C-2.57025172e-05,19.430666 6.98180606,24.954908 17.8411196,24.954908 C28.7677737,24.954908 35.6856062,19.4322082 35.6856062,12.6115312 L35.6856062,11.9270732 Z",
                id: "background_border",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M35.0023818,11.9212901 C35.0023818,17.9824577 27.3216986,22.8960079 17.8467227,22.8960079 C8.37200381,22.8960079 0.691577629,17.9824577 0.691577629,11.9212901 C0.691577629,5.85960846 8.37200381,0.946058252 17.8467227,0.946058252 C27.3216986,0.946058252 35.0023818,5.85960846 35.0023818,11.9212901",
                id: "background",
                fill: quaternary
            }), Object(jsx.c)("path", {
                d: "M12.1504795,8.4587241 C12.1414836,8.47594479 11.9703048,8.65303513 12.0810827,8.79542708 C12.3519872,9.14112593 13.1880901,9.33954936 14.0337029,9.14986479 C14.5372152,9.03677371 15.1826054,8.52349444 15.8076906,8.02743586 C16.485209,7.48922515 17.1573298,6.95024337 17.833049,6.73588438 C18.548607,6.50816007 19.0068829,6.60582964 19.3096586,6.6973306 C19.6419921,6.79654232 20.0326704,7.01527074 20.6559564,7.48279952 C21.8297904,8.36542396 26.5498006,12.4852804 27.3653415,13.1977542 C28.0222978,12.9008901 30.9413327,11.6442941 34.9082592,10.7698944 C34.5635885,8.65509133 33.2771775,6.72020584 31.3260994,5.13590268 C28.6070301,6.27812254 25.2839517,6.87390689 22.0343824,5.28677646 C22.0179328,5.2800938 20.2591096,4.4478463 18.5244467,4.4887133 C15.9462272,4.54834314 14.8291958,5.66434643 13.647137,6.84563412 L12.1504795,8.4587241 Z",
                id: "righthand",
                fill: secondary
            }), Object(jsx.c)("path", {
                d: "M27.1736521,13.645672 C27.1183917,13.5965802 21.6237076,8.78866731 20.3786777,7.85283866 C19.6584931,7.31257175 19.2577909,7.17480626 18.8370407,7.121088 C18.6180552,7.09281523 18.3155366,7.13342521 18.1040049,7.1915129 C17.5249272,7.34906933 16.7679881,7.85540892 16.0953532,8.3882221 C15.399329,8.94262539 14.7431438,9.46464351 14.1345082,9.60112388 C13.3562359,9.77538695 12.4062709,9.56976681 11.9726694,9.27650109 C11.7971212,9.15852654 11.6734921,9.02204617 11.6141193,8.88325258 C11.4539926,8.5118512 11.7493146,8.21498713 11.7978923,8.16538127 L13.3140838,6.52530365 C13.4904031,6.34924141 13.6680075,6.17343619 13.8494672,5.9999442 C13.3603483,6.06368644 12.907984,6.18860068 12.4676999,6.31120168 C11.9181801,6.46567381 11.3899934,6.61269221 10.855381,6.61243519 C10.6322832,6.61243519 9.43634504,6.41632498 9.20939182,6.35463894 C7.83739145,5.97912516 6.6329715,5.61337834 4.83405232,4.77342008 C2.67838221,6.37828525 1.23698504,8.38462374 0.820604265,10.5947832 C1.1303196,10.6765172 1.62920546,10.8250777 1.838938,10.8715993 C6.71701873,11.9562455 8.23629452,13.0735339 8.51208253,13.3069128 C8.81048875,12.9748363 9.24074889,12.7645897 9.72138596,12.7645897 C10.2611388,12.7653608 10.7474304,13.0365223 11.0430094,13.4557304 C11.3223958,13.2349458 11.7076765,13.0465463 12.2057913,13.0468033 C12.4319734,13.0468033 12.6666374,13.0886984 12.9033576,13.1691473 C13.4539055,13.3580608 13.7379183,13.7245787 13.8851937,14.0561412 C14.0699948,13.972608 14.296691,13.911179 14.5639972,13.9119501 C14.8266769,13.9119501 15.0998947,13.9720939 15.3754257,14.0908396 C16.2747568,14.4768914 16.4148355,15.3602869 16.3331015,16.0264961 C16.3971007,16.0187854 16.4616141,16.0159581 16.5271555,16.0159581 C17.5935529,16.0167292 18.4610129,16.8834181 18.4604988,17.9503296 C18.4604988,18.2803499 18.3759375,18.5908363 18.2291762,18.86354 C18.5193576,19.026751 19.259076,19.3955821 19.9083216,19.313334 C20.4272554,19.2480496 20.6243937,19.0704453 20.6948186,18.9709765 C20.7428823,18.9020938 20.7942874,18.8221589 20.7467377,18.7645853 L19.3703679,17.2355426 C19.3703679,17.2355426 19.1436717,17.0211836 19.2184661,16.9386785 C19.2963447,16.8536031 19.4361664,16.9754331 19.5351211,17.0581952 C20.2357717,17.6434415 21.0911515,18.5260659 21.0911515,18.5260659 C21.1055449,18.5355759 21.1620904,18.6476388 21.4784884,18.7044414 C21.750678,18.7530192 22.2323432,18.7247464 22.5662189,18.4505005 C22.6505232,18.3813608 22.7345704,18.2950003 22.8049953,18.2058126 C22.7993407,18.210182 22.7949713,18.2160936 22.7895738,18.2181498 C23.1414412,17.7678417 22.750763,17.3121361 22.750763,17.3121361 L21.1438416,15.5075623 C21.1438416,15.5075623 20.9140611,15.2952595 20.9919397,15.2096702 C21.0621076,15.1356469 21.2098971,15.2474529 21.3103939,15.3312431 C21.8193038,15.7566197 22.5382032,16.4780894 23.2272877,17.1530375 C23.3617118,17.2512211 23.9672631,17.6259638 24.7691817,17.0993192 C25.2554733,16.7800939 25.3533999,16.3881306 25.3395205,16.0922946 C25.3055932,15.7005882 25.0002473,15.4217159 25.0002473,15.4217159 L22.8049953,13.2148978 C22.8049953,13.2148978 22.5734156,13.0169884 22.6551496,12.9167486 C22.7222332,12.8324443 22.8728499,12.9540172 22.9712906,13.0365223 C23.6709131,13.6215116 25.5636465,15.3569456 25.5636465,15.3569456 C25.5906341,15.3759654 26.2447632,15.841695 27.0528503,15.3271307 C27.3417466,15.1423296 27.5265477,14.8637143 27.5424833,14.5403766 C27.569985,13.9790336 27.1736521,13.645672 27.1736521,13.645672",
                id: "lefthand",
                fill: secondary
            }), Object(jsx.c)("path", {
                d: "M16.5269242,16.4433139 C16.1866228,16.4392015 15.8144504,16.6414803 15.7656156,16.6119224 C15.738885,16.5941876 15.7864346,16.4574503 15.8183058,16.3785435 C15.850948,16.3001508 16.2991999,14.9515398 15.2065858,14.4832399 C14.370483,14.1239187 13.8595169,14.5282193 13.6837117,14.7107072 C13.6377042,14.7582568 13.6171422,14.7546585 13.6117447,14.6934865 C13.595038,14.4508547 13.4863164,13.7936414 12.7645897,13.5736278 C11.7334047,13.2577439 11.0702798,13.9776714 10.9019283,14.2375238 C10.8266199,13.6497073 10.3297902,13.1932306 9.72115464,13.1929727 C9.05957184,13.1922025 8.52316031,13.7281 8.52238914,14.3891687 C8.52213221,15.0502374 9.05828672,15.5863919 9.71961249,15.5863919 C10.041151,15.587163 10.3323605,15.4586504 10.5472335,15.2522592 C10.5541732,15.2586849 10.5567435,15.269994 10.5534021,15.2926122 C10.5030252,15.5887052 10.4102391,16.6646125 11.5370375,17.1025834 C11.9888877,17.2781316 12.3731404,17.1475628 12.6915945,16.924208 C12.7864368,16.8571244 12.8021154,16.8856542 12.788493,16.9745849 C12.7478831,17.251401 12.7992881,17.843844 13.6299934,18.180804 C14.2617613,18.4375722 14.63599,18.1746354 14.880935,17.9481962 C14.9876004,17.8510407 15.0166442,17.8667193 15.0222988,18.017079 C15.0523707,18.8177124 15.7175519,19.4535927 16.525125,19.4543644 C17.3573725,19.4551348 18.0318065,18.7822429 18.0320642,17.9502524 C18.0328346,17.1180049 17.3589146,16.4523097 16.5269242,16.4433139",
                id: "fingers",
                fill: secondary
            }), Object(jsx.c)("path", {
                d: "M16.5269242,19.3471586 C15.7725553,19.3463875 15.1595502,18.7603701 15.1317915,18.0134549 C15.1297353,17.9494557 15.1233097,17.779048 14.9793756,17.779048 C14.9200028,17.779048 14.8685977,17.8147745 14.8092249,17.8682357 C14.6437007,18.0219368 14.432426,18.1782081 14.1237388,18.1782081 C13.9839171,18.1782081 13.8322723,18.1455659 13.6721456,18.0800245 C12.8756246,17.7574579 12.8645725,17.2105083 12.8969577,16.9904948 C12.9056965,16.931893 12.9087808,16.870721 12.8684279,16.8234284 L12.8193361,16.7794771 L12.7697302,16.7794771 C12.7293772,16.7794771 12.6874821,16.7959267 12.6311936,16.8357656 C12.4006421,16.9974344 12.1798574,17.0760841 11.9552174,17.0760841 C11.8313313,17.0760841 11.7046179,17.0511527 11.5776475,17.0023179 C10.5289848,16.5941619 10.6117469,15.604358 10.6631519,15.3064658 C10.6706056,15.2463219 10.6556982,15.1992863 10.6174014,15.1681863 L10.5433782,15.1072713 L10.4739814,15.1735838 C10.2693893,15.3704651 10.0023402,15.4784157 9.72115464,15.4784157 C9.12074384,15.4776446 8.63188196,14.9898108 8.6323956,14.389143 C8.63291006,13.7882181 9.12202896,13.3006414 9.72269679,13.3014116 C10.2655339,13.3014116 10.7276652,13.7093114 10.796805,14.2516345 L10.8343307,14.5441292 L10.9949714,14.2966139 C11.0129631,14.2675701 11.4529902,13.6021319 12.2618485,13.602903 C12.4158065,13.602903 12.5746481,13.6278344 12.7345177,13.6771833 C13.3796509,13.8740645 13.4888866,14.4587968 13.5055933,14.7024567 C13.5171594,14.8443346 13.6181703,14.8512743 13.6379612,14.8512743 C13.6937357,14.8512743 13.7346027,14.8158048 13.7636465,14.7854758 C13.8854765,14.6585054 14.1504694,14.4472307 14.565308,14.4472307 C14.7549926,14.4477447 14.9572714,14.4927241 15.1657188,14.5824259 C16.1904782,15.022196 15.7257767,16.3245425 15.7201221,16.3381649 C15.6322195,16.554066 15.6286212,16.6494224 15.7113833,16.7044257 L15.7517362,16.7237026 L15.7818082,16.7237026 C15.8278157,16.7237026 15.8853893,16.7036547 15.9802316,16.6715265 C16.1197963,16.6232058 16.3302999,16.5507247 16.5271812,16.5512387 L16.5276952,16.5512387 C17.2992848,16.5594635 17.9266832,17.1876331 17.9264263,17.9502267 C17.9256551,18.7207882 17.2979997,19.3471586 16.5269242,19.3471586 M27.3862377,13.0700898 C25.6937269,11.5929662 21.7818038,8.19226611 20.722346,7.39703022 C20.1173088,6.94158162 19.7042693,6.70126308 19.3418638,6.59331251 C19.1791669,6.54396368 18.9537558,6.48818922 18.6635744,6.48793219 C18.3944691,6.48793219 18.1050587,6.53650995 17.8027971,6.63263736 C17.1180821,6.84930958 16.4359372,7.39137567 15.7761536,7.91570702 L15.7422263,7.94269466 C15.1276791,8.43104249 14.4925699,8.936611 14.0119329,9.04404752 C13.8019433,9.09134016 13.5862992,9.11550052 13.3711691,9.11550052 C12.8327014,9.11472945 12.34898,8.95948624 12.1677772,8.72842061 C12.1379623,8.69012386 12.1569822,8.6281808 12.2271501,8.53899306 L12.236403,8.5271699 L13.7253498,6.92256176 C14.891473,5.75643855 15.9930829,4.65534272 18.5286362,4.596998 C18.5702743,4.59571288 18.6131975,4.5949418 18.6550926,4.5949418 C20.2334842,4.5959699 21.8113617,5.3025321 21.988195,5.38452313 C23.4681459,6.10624981 24.9953895,6.47302473 26.5311149,6.47430986 C28.1313536,6.47482391 29.7824833,6.07874812 31.5184313,5.27939984 C31.3246344,5.11618885 31.1228696,4.95760432 30.9151933,4.80184707 C29.3902629,5.46291581 27.9372996,5.79704853 26.5352273,5.79653448 C25.1035971,5.79524935 23.672995,5.4516067 22.284031,4.77383132 C22.2107788,4.7388759 20.4686622,3.91742345 18.6558637,3.91665238 C18.608571,3.91665238 18.5602503,3.91742345 18.5129577,3.91819453 C16.3829901,3.96805741 15.1831966,4.72422546 14.3766516,5.38709338 C13.5919537,5.40611324 12.9149494,5.59528377 12.3127394,5.76337823 C11.7752998,5.91270986 11.3111123,6.04225054 10.858234,6.04199352 C10.6718907,6.04199352 10.3362159,6.02502986 10.3061439,6.02400176 C9.78541093,6.00832322 7.16272608,5.36498922 5.07645276,4.57489384 C4.86337889,4.72576762 4.65852983,4.88152487 4.4590783,5.0401094 C6.63839473,5.9335289 9.2908945,6.62492661 10.1280255,6.67890189 C10.3608903,6.69406638 10.6091766,6.72053997 10.8572059,6.72105402 C11.4110951,6.72105402 11.9636993,6.56555379 12.4985686,6.41596514 C12.8144526,6.32729146 13.1629787,6.23090702 13.5297536,6.16048212 C13.431827,6.25660954 13.3341575,6.35402208 13.2362309,6.45220569 L11.7233807,8.08868496 C11.6043781,8.20897274 11.3458107,8.52974016 11.5162184,8.92478784 C11.5840731,9.08414345 11.7215815,9.23655938 11.9140934,9.36635709 C12.2744427,9.60898885 12.9200899,9.77322794 13.5197296,9.77374199 C13.7469399,9.77399901 13.96207,9.75112377 14.1602364,9.70665842 C14.7943175,9.56426647 15.4594986,9.03453759 16.1642616,8.47422272 C16.7256046,8.02828405 17.5234107,7.46180057 18.1341026,7.29524826 C18.3047673,7.24898373 18.5142428,7.21993988 18.6828513,7.21993988 C18.7332282,7.22045393 18.7807779,7.22199608 18.8247292,7.22842171 C19.2285157,7.27956972 19.6184229,7.41682116 20.3149611,7.93961036 C21.5566497,8.87235471 27.0521049,13.6797535 27.1058232,13.7273032 C27.1096786,13.7301305 27.4600039,14.0323921 27.4355865,14.5348763 C27.4227352,14.8150337 27.266978,15.0640911 26.9965875,15.236555 C26.7621805,15.3853726 26.5200628,15.461195 26.2753749,15.461195 C25.9080859,15.4604239 25.6551731,15.2884741 25.6387235,15.2766509 C25.6184185,15.2602013 23.7357091,13.5337632 23.0432833,12.9539144 C22.9327625,12.8626705 22.825583,12.7801654 22.7171184,12.7801654 C22.6590307,12.7796514 22.6078827,12.8045828 22.5731843,12.8480201 C22.4642056,12.9821872 22.5862926,13.1682734 22.7302267,13.2908744 L24.929334,15.5012909 C24.9324183,15.5036041 25.2035799,15.757802 25.2331378,16.0968182 C25.2503585,16.4633361 25.0753243,16.7699672 24.7111197,17.0084865 C24.4515242,17.1794083 24.1888445,17.2662828 23.9315623,17.2662828 C23.5938312,17.2662828 23.356597,17.1125817 23.3041639,17.0760841 L22.988794,16.7650837 C22.4120295,16.1978291 21.8167592,15.6112977 21.3811015,15.2476071 C21.2749502,15.1591904 21.161088,15.0777134 21.0531374,15.0777134 C20.9996762,15.0777134 20.9516125,15.0975044 20.9146009,15.1363152 C20.864995,15.1915756 20.8302966,15.2910443 20.9541827,15.4555404 C21.0053307,15.5233951 21.0652176,15.5794266 21.0652176,15.5794266 L22.6700828,17.3819441 C22.6834481,17.3981367 23.0008742,17.7754496 22.7063233,18.1512204 L22.6495208,18.2231875 C22.6017141,18.2761347 22.549795,18.3247124 22.5004462,18.3671216 C22.2267144,18.5917616 21.8609675,18.6156649 21.7160053,18.6156649 C21.6388978,18.6156649 21.5641035,18.6089823 21.4993331,18.5971591 C21.3407486,18.5688863 21.2343402,18.524678 21.1829351,18.463763 L21.1636583,18.4434581 C21.0757556,18.3529852 20.2668974,17.5271633 19.5973469,16.9683906 C19.5094442,16.8943673 19.3994375,16.8013242 19.2853183,16.8013242 C19.2292868,16.8013242 19.1791669,16.8234284 19.1406131,16.8660946 C19.0079881,17.0110568 19.2069256,17.227986 19.2912299,17.3074068 L20.6601459,18.8169156 C20.6586038,18.8302809 20.6413831,18.861381 20.6082269,18.9091877 C20.559135,18.9770423 20.3930968,19.1430806 19.8965242,19.2052807 C19.8371513,19.2132484 19.7757223,19.2163327 19.7148074,19.2163327 C19.2028132,19.2163327 18.6566347,18.9677894 18.3751922,18.8184578 C18.5031907,18.5480673 18.5697602,18.2499181 18.5697602,17.9509978 C18.5702743,16.8244565 17.6555217,15.9079047 16.5289804,15.9071337 C16.50482,15.9071337 16.4791175,15.9079047 16.4552141,15.9086758 C16.4919687,15.3943684 16.4192306,14.420243 15.4194027,13.9915251 C15.1317915,13.8671249 14.8446944,13.8036397 14.5658221,13.8036397 C14.3476077,13.8036397 14.1376182,13.8409083 13.9402228,13.9167307 C13.7330605,13.5142293 13.3891609,13.2209636 12.9403949,13.0680336 C12.6926226,12.9821872 12.4458785,12.9387499 12.2073591,12.9387499 C11.7914924,12.9387499 11.4082679,13.061351 11.0664244,13.3044968 C10.7387173,12.8971119 10.2442009,12.6560223 9.72295381,12.6560223 C9.26724818,12.6560223 8.82876324,12.8385101 8.5036264,13.1603056 C8.07773569,12.8349118 6.38753816,11.7610606 1.86389514,10.733988 C1.64490969,10.6846392 1.14216846,10.540191 0.833995277,10.4502322 C0.783104293,10.6951772 0.744036467,10.9426925 0.71833395,11.1922639 C0.71833395,11.1922639 1.55263766,11.3922295 1.71687674,11.4289841 C6.3379323,12.4555426 7.86491885,13.5227111 8.12297212,13.7244759 C8.03558356,13.9342084 7.99009011,14.1609046 7.98957605,14.389143 C7.989062,15.3437345 8.76553505,16.1212356 9.72115464,16.1220067 C9.82807711,16.1220067 9.9342285,16.1127538 10.0385807,16.0934769 C10.1822578,16.7959267 10.6420758,17.3284829 11.3447826,17.6019576 C11.5501458,17.6808644 11.7578221,17.7214743 11.9616431,17.7214743 C12.093754,17.7217314 12.226379,17.7050247 12.3559197,17.6718685 C12.4854604,18.0016318 12.777698,18.412358 13.4302849,18.677608 C13.6592943,18.769623 13.8880467,18.8176867 14.1106305,18.8176867 C14.2923473,18.8176867 14.4699517,18.7858156 14.6393313,18.7236155 C14.9521309,19.4854381 15.6967329,19.9902375 16.5264101,19.9902375 C17.076444,19.9910066 17.6043737,19.7668807 17.9893974,19.3705478 C18.3194177,19.5538068 19.0151848,19.8853693 19.7181487,19.8863974 C19.8093926,19.8863974 19.894725,19.8797147 19.9800573,19.8696907 C20.6781377,19.7812741 21.0032745,19.5083133 21.1526062,19.2960105 C21.1795938,19.2589989 21.2037542,19.2196741 21.2243162,19.1788071 C21.3893264,19.2260997 21.5705291,19.2649105 21.7782054,19.2654245 C22.1596308,19.2654245 22.5256346,19.1353698 22.8954939,18.8657504 C23.2589275,18.6035847 23.5172377,18.2275569 23.5545064,17.9070465 C23.5552775,17.9029341 23.5560485,17.8980506 23.5565626,17.8934242 C23.6789066,17.9186126 23.8045919,17.9317209 23.9302772,17.9317209 C24.3227546,17.9317209 24.7090635,17.809377 25.0781516,17.5675163 C25.7898543,17.1007586 25.9137404,16.4913519 25.9019173,16.0921918 C26.0263175,16.1181513 26.1535449,16.1315166 26.2800013,16.1315166 C26.6488324,16.1315166 27.0104669,16.0207388 27.3556517,15.8007252 C27.7969639,15.5187686 28.0624709,15.0869663 28.1025668,14.5844821 C28.1303255,14.2428957 28.0455072,13.8982249 27.8653326,13.6018749 C29.0581864,13.0880816 31.7839383,12.0936512 34.9939257,11.3703824 C34.9743918,11.121325 34.9386653,10.8756089 34.8941999,10.6309209 C31.0102926,11.4927263 28.1120767,12.7470092 27.3862377,13.0700898",
                id: "handoutline",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M82.5260533,20.2673344 C82.2142818,20.68243 81.766544,20.8898493 81.1830968,20.8898493 C80.5993927,20.8898493 80.1495986,20.68243 79.8357709,20.2673344 C79.5196299,19.8535238 79.3628446,19.2636511 79.3628446,18.4995152 C79.3628446,17.7356364 79.5196299,17.1470488 79.8357709,16.7352945 C80.1495986,16.321998 80.5993927,16.1168919 81.1830968,16.1168919 C81.766544,16.1168919 82.2142818,16.321998 82.5260533,16.7352945 C82.839367,17.1470488 82.9948673,17.7356364 82.9948673,18.4995152 C82.9948673,19.2636511 82.839367,19.8535238 82.5260533,20.2673344 M84.1229507,15.6398532 C83.4778176,14.8322801 82.4998368,14.4295216 81.1882373,14.4295216 C79.8789511,14.4295216 78.9007133,14.8322801 78.2566082,15.6398532 C77.6119891,16.4461411 77.2901936,17.3989335 77.2901936,18.4995152 C77.2901936,19.6188599 77.6119891,20.5749935 78.2566082,21.3715145 C78.9007133,22.1646942 79.8789511,22.5630832 81.1882373,22.5630832 C82.4998368,22.5630832 83.4778176,22.1646942 84.1229507,21.3715145 C84.7665418,20.5749935 85.0873092,19.6188599 85.0873092,18.4995152 C85.0873092,17.3989335 84.7665418,16.4461411 84.1229507,15.6398532",
                id: "pago_o",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M71.2460667,18.5582712 C71.2460667,19.8971153 71.6331467,20.639147 72.4067924,20.7859084 C73.178896,20.9290714 73.750006,20.7496678 74.117552,20.2458985 C74.291815,20.0338527 74.4167293,19.6979208 74.4940938,19.2427292 C74.5709444,18.7870236 74.5768559,18.3354304 74.5090013,17.8892347 C74.4424318,17.4417538 74.281791,17.0438789 74.0301634,16.6945817 C73.7795639,16.3460555 73.4117608,16.1705074 72.9282965,16.1705074 C72.2705691,16.1705074 71.8269436,16.4141672 71.5943359,16.8973745 C71.360957,17.3836662 71.2460667,17.9365273 71.2460667,18.5582712 M74.5526956,21.905253 L74.5526956,21.4122787 C74.2049405,21.956658 73.7350985,22.293875 73.1457398,22.4308695 C72.555353,22.5658077 71.9708777,22.5174869 71.392057,22.2841081 C70.8114372,22.0522714 70.3128083,21.619955 69.8966846,20.9899863 C69.482103,20.3571904 69.2741696,19.5275131 69.2741696,18.4988984 C69.2741696,17.2970487 69.5497006,16.3206101 70.0999915,15.5736949 C70.6515675,14.8267798 71.5367622,14.4859644 72.7545475,14.4525511 C73.954855,14.420937 74.6526784,14.6926126 75.3358513,15.2100043 C76.0827664,15.7770018 76.5246005,16.646775 76.5246005,18.0043819 L76.5246005,22.1108731 C76.527677,23.4175891 75.6165228,25.8392803 72.7545475,25.6339171 C70.9815878,25.5054046 69.9976955,24.7780233 69.4484327,23.1299779 L71.565292,23.1299779 C71.7200212,23.4008825 71.9564843,23.6095869 72.2772517,23.754035 C72.5944208,23.9015675 72.9151882,23.9393502 73.2321002,23.8712385 C73.5508115,23.8033839 73.8415069,23.6134423 74.1039296,23.304241 C74.3635251,22.9934976 74.5131137,22.5269969 74.5526956,21.905253",
                id: "pago_g",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M66.540784,19.3679776 C66.5281898,20.0380422 66.335935,20.4981173 65.9678749,20.7515441 C65.6000719,21.0039428 65.1973135,21.1303992 64.7606277,21.1303992 C64.4840686,21.1303992 64.2501757,21.0540627 64.0579209,20.9024179 C63.865152,20.750516 63.7687676,20.5027437 63.7687676,20.1609002 C63.7687676,19.7779327 63.926324,19.494434 64.2416939,19.3114321 C64.4293223,19.2042526 64.7346682,19.1122375 65.161844,19.0392424 L65.6175496,18.9544241 C65.8455309,18.9112439 66.0241634,18.8657504 66.1531901,18.8161445 C66.2858151,18.7680808 66.4132996,18.7043386 66.540784,18.6236327 L66.540784,19.3679776 Z M67.5562905,15.0065175 C66.9026755,14.6762401 66.1552463,14.5089167 65.314774,14.5089167 C64.0206522,14.5089167 63.1089839,14.8461337 62.5774559,15.5192827 C62.2440942,15.9503139 62.0559518,16.5003478 62.0127716,17.1701554 L63.9453439,17.1701554 C63.9926365,16.8745764 64.0869647,16.6406835 64.2301277,16.4679626 C64.4293223,16.2340697 64.7683406,16.1168662 65.2461482,16.1168662 C65.6753803,16.1168662 65.9982039,16.175725 66.2189885,16.2960127 C66.4390021,16.4155294 66.5497799,16.6316876 66.5497799,16.9455154 C66.5497799,17.2030546 66.4063599,17.3924821 66.1179776,17.5145691 C65.9578509,17.584737 65.6918299,17.6430817 65.3178583,17.6901173 L64.6331432,17.7736505 C63.8556421,17.8720911 63.2647412,18.0368442 62.8655811,18.2661107 C62.1333164,18.6873749 61.7683406,19.3679776 61.7683406,20.3086897 C61.7683406,21.0337577 61.9942658,21.5951007 62.4499714,21.9904054 C62.9028498,22.3857101 63.4801283,22.5525195 64.1769235,22.5846476 C68.5442952,22.7797297 68.4954605,20.2822161 68.5352994,19.7630253 L68.5352994,16.8887128 C68.5352994,15.9667635 68.2093915,15.3398791 67.5562905,15.0065175 L67.5562905,15.0065175 Z",
                id: "pago_a",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M59.2065451,18.5572688 C59.2065451,17.7998156 59.0590126,17.2176536 58.7626626,16.8089836 C58.4675977,16.4026268 58.0445343,16.1967496 57.4932153,16.1967496 C56.9622013,16.1967496 56.5483907,16.4026268 56.2517837,16.8089836 C55.9772808,17.1785858 55.8400294,17.762804 55.8400294,18.5572688 C55.8400294,19.2977583 55.9873048,19.8488203 56.2828837,20.2184225 C56.5774346,20.6270925 57.0012691,20.8306564 57.5523311,20.8306564 C58.0635541,20.8306564 58.4675977,20.6270925 58.7626626,20.2184225 C59.0590126,19.8105235 59.2065451,19.2586905 59.2065451,18.5572688 L59.2065451,18.5572688 Z M55.8400294,23.9923231 C55.8400294,24.2642557 55.7413317,24.4976346 55.5434223,24.6914315 C55.3475691,24.8859996 55.111106,24.9831551 54.8350609,24.9831551 L53.8321487,24.9831551 L53.8321487,18.0031225 C53.8321487,16.6457726 54.2893965,15.7955333 55.0424803,15.2210821 C55.539824,14.8411989 56.2813416,14.4787934 57.6703056,14.4787934 C58.6081905,14.4787934 59.706459,14.842741 60.2999301,15.5660098 C60.9656253,16.3794945 61.2432125,17.2860223 61.2432125,18.4698802 C61.2432125,19.6946052 60.9478906,20.6826099 60.3577608,21.4421193 C59.767374,22.1810667 59.0086357,22.5488697 58.0836021,22.5488697 C57.5916559,22.5488697 57.1588255,22.4612241 56.7848539,22.2877321 C56.3898062,22.0929071 56.0764925,21.7921876 55.8400294,21.3837746 L55.8400294,23.9923231 Z",
                id: "pago_p",
                fill: tertiary
            }), Object(jsx.c)("path", {
                d: "M94.8863424,9.12010127 C94.5735428,9.5349399 94.1268331,9.74235921 93.5423578,9.74235921 C92.9591677,9.74235921 92.5098877,9.5349399 92.1950319,9.12010127 C91.879919,8.7057767 91.7226196,8.1156469 91.7226196,7.35099702 C91.7226196,6.58737523 91.879919,5.99878759 92.1950319,5.58651921 C92.5098877,5.17399381 92.9591677,4.96785962 93.5423578,4.96785962 C94.1268331,4.96785962 94.5735428,5.17399381 94.8863424,5.58651921 C95.198628,5.99878759 95.3551564,6.58737523 95.3551564,7.35099702 C95.3551564,8.1156469 95.198628,8.7057767 94.8863424,9.12010127 M96.4822117,4.49133496 C95.8381067,3.68427592 94.8606399,3.28100342 93.5485264,3.28100342 C92.2382121,3.28100342 91.2604883,3.68427592 90.6168973,4.49133496 C89.9722782,5.29787995 89.6499686,6.25118631 89.6499686,7.35099702 C89.6499686,8.47059866 89.9722782,9.42724635 90.6168973,10.2237674 C91.2604883,11.0174611 92.2382121,11.4158501 93.5485264,11.4158501 C94.8606399,11.4158501 95.8381067,11.0174611 96.4822117,10.2237674 C97.1268309,9.42724635 97.4481123,8.47059866 97.4481123,7.35099702 C97.4481123,6.25118631 97.1268309,5.29787995 96.4822117,4.49133496",
                id: "mercado_o",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M86.6429797,9.1366794 C86.349714,9.55717258 85.9191969,9.76690512 85.3552836,9.76690512 C84.7895712,9.76690512 84.368821,9.55511638 84.0917479,9.13308104 C83.8146747,8.71027464 83.6761382,8.09469935 83.6761382,7.39045038 C83.6761382,6.73683537 83.8115904,6.18962878 84.0848082,5.74857358 C84.3572549,5.30803244 84.7849448,5.08673377 85.368906,5.08673377 C85.7518735,5.08673377 86.0872913,5.20830667 86.3774727,5.45068141 C86.8488569,5.85241175 87.084292,6.57259628 87.084292,7.50534063 C87.084292,8.172835 86.9372736,8.71644324 86.6429797,9.1366794 L86.6429797,9.1366794 Z M89.0525907,0.930636741 C89.0525907,0.930636741 87.0290315,0.714478572 87.0290315,2.33990576 L87.0274894,4.49172049 C86.8036205,4.13214228 86.5124109,3.85095674 86.1530898,3.64842091 C85.7945396,3.44562805 85.3840704,3.34333203 84.9206541,3.34333203 C83.9172278,3.34333203 83.1173655,3.71730365 82.5169547,4.46344773 C81.9165439,5.21087692 81.6178806,6.28729834 81.6178806,7.58913084 C81.6178806,8.71849944 81.9221984,9.64481816 82.531091,10.3657738 C83.1399837,11.0859583 84.3343796,11.4020993 85.3951225,11.4020993 C89.0937147,11.4020993 89.0510486,8.23040864 89.0510486,8.23040864 L89.0525907,0.930636741 Z",
                id: "mercado_d",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M79.0090237,8.17810402 C78.9954014,8.84739757 78.8036606,9.30850072 78.4353435,9.56141349 C78.0667694,9.81432626 77.664268,9.94103967 77.2278393,9.94103967 C76.9512802,9.94103967 76.7173873,9.86444617 76.5246184,9.71254429 C76.3323636,9.56038539 76.2364932,9.31312718 76.2364932,8.9712837 C76.2364932,8.58780214 76.3935356,8.30481743 76.7083914,8.12181551 C76.8960198,8.01463601 77.2018797,7.92236397 77.6290556,7.8491118 L78.0852752,7.76455052 C78.3122285,7.72137029 78.490861,7.67536278 78.6214297,7.62601395 C78.7535407,7.57795024 78.8810252,7.51446503 79.0090237,7.43375912 L79.0090237,8.17810402 Z M80.0235021,3.81664388 C79.3704011,3.48533843 78.6229719,3.31827207 77.7817285,3.31827207 C76.4888919,3.31827207 75.5764525,3.65600315 75.0451815,4.32915207 C74.7107918,4.76069734 74.5236774,5.31047418 74.4799832,5.97976773 L76.4117843,5.97976773 C76.459334,5.6844458 76.5541763,5.4505529 76.6968253,5.27757496 C76.8960198,5.04368205 77.2345219,4.9267356 77.7133598,4.9267356 C78.1415638,4.9267356 78.4649014,4.98533734 78.6862001,5.10613917 C78.9062136,5.22514182 79.0169915,5.44181404 79.0169915,5.7548707 C79.0169915,6.01292397 78.8740855,6.20183747 78.5854462,6.32418146 C78.4248055,6.39460635 78.1585274,6.45295107 77.7850698,6.49972965 L77.1003548,6.5840339 C76.3223396,6.68196049 75.7319528,6.8464566 75.3317646,7.07623711 C74.600528,7.49775839 74.2350382,8.17810402 74.2350382,9.1193302 C74.2350382,9.84414118 74.4614773,10.4054842 74.9166689,10.8010459 C75.3700613,11.1966076 75.9473399,11.3626459 76.6441351,11.3950311 C81.0125349,11.5898561 80.9634431,9.0928566 81.003539,8.57340873 L81.003539,5.69883921 C81.003539,4.77740397 80.676089,4.14923445 80.0235021,3.81664388 L80.0235021,3.81664388 Z",
                id: "mercado_a",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M70.0623373,5.03054806 C70.5617372,5.03054806 70.9282551,5.18476317 71.1652323,5.49293635 C71.3279293,5.7211747 71.4291972,5.9784569 71.4690361,6.26349781 L73.6234211,6.26349781 C73.5054465,5.17628134 73.1250493,4.417286 72.4830004,3.98728289 C71.8383813,3.55907896 71.0130734,3.34343484 70.0039926,3.34343484 C68.8173074,3.34343484 67.8850771,3.70815356 67.2119282,4.43579182 C66.536723,5.16445818 66.199506,6.18253488 66.199506,7.49156408 C66.199506,8.65074761 66.5045949,9.59557214 67.1150297,10.3237244 C67.7259785,11.0513627 68.6787708,11.4158244 69.9728926,11.4158244 C71.2690705,11.4158244 72.2475653,10.9793957 72.9065779,10.1062812 C73.3203884,9.56550019 73.5522251,8.99104893 73.6010599,8.38395548 L71.4533575,8.38395548 C71.4096633,8.78517177 71.284235,9.11262184 71.0763016,9.36450651 C70.8691393,9.6156201 70.5200991,9.74233351 70.0260968,9.74233351 C69.3303296,9.74233351 68.8571463,9.42542147 68.6055186,8.7895412 C68.4680102,8.450525 68.3980993,8.00150202 68.3980993,7.4427293 C68.3980993,6.85645488 68.4680102,6.38661287 68.6055186,6.03166111 C68.8671703,5.36493781 69.3529478,5.03054806 70.0623373,5.03054806",
                id: "mercado_c",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M65.6216363,3.34333203 C61.1954058,3.34333203 61.4570575,7.26270887 61.4570575,7.26270887 L61.4570575,11.2437718 L63.4659662,11.2437718 L63.4659662,7.50971006 C63.4659662,6.89799015 63.5433308,6.44485477 63.6965178,6.15030393 C63.9720488,5.6282858 64.5102595,5.36612013 65.3139772,5.36612013 C65.3741211,5.36612013 65.4540559,5.36946146 65.5519825,5.37383088 C65.6496521,5.37871436 65.7606869,5.38745322 65.8886855,5.40236068 L65.8886855,3.35849651 C65.7992407,3.35232791 65.7416671,3.34975766 65.7164786,3.34744443 C65.6910331,3.34538823 65.659162,3.34333203 65.6216363,3.34333203",
                id: "mercado_r",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M55.542934,5.42361666 C55.8256617,5.13343524 56.2222515,4.98795899 56.7342456,4.98795899 C57.2051158,4.98795899 57.5991353,5.12443936 57.9178466,5.39919927 C58.2352726,5.6731881 58.412877,6.07568952 58.4486035,6.6043903 L55.01192,6.6043903 C55.08363,6.10756064 55.2612344,5.71456915 55.542934,5.42361666 L55.542934,5.42361666 Z M58.2432404,9.16384696 C58.1589362,9.28413474 58.0679493,9.38720183 57.9682235,9.46739368 C57.6844677,9.70128659 57.2989299,9.77222554 56.8450235,9.77222554 C56.4157915,9.77222554 56.0801166,9.70719817 55.7757988,9.51545739 C55.2748567,9.20754124 54.9926431,8.68603716 54.9625711,7.92087323 L60.5207405,7.92087323 C60.5281942,7.26211771 60.5071181,6.7575773 60.4539139,6.40648092 C60.3616419,5.80889739 60.158335,5.28199579 59.8465634,4.82886041 C59.4998365,4.31481007 59.0590383,3.93852522 58.5272532,3.69923478 C57.9957252,3.46225757 57.3978846,3.34274087 56.7342456,3.34274087 C55.614644,3.34274087 54.70606,3.69563643 54.0054094,4.40039945 C53.3045017,5.10670462 52.9526343,6.11912677 52.9526343,7.44100723 C52.9526343,8.85207542 53.3412563,9.87040915 54.1182434,10.4960084 C54.8939454,11.1218647 55.7909633,11.4354354 56.8059557,11.4354354 C58.0358211,11.4354354 58.9932399,11.0642911 59.6764128,10.3220024 C60.0449869,9.93132412 60.2757955,9.54475826 60.373208,9.16384696 L58.2432404,9.16384696 Z",
                id: "mercado_e",
                fill: primary
            }), Object(jsx.c)("path", {
                d: "M52.146372,11.2430778 L50.3114693,11.2430778 L50.3114693,6.6227933 C50.3114693,6.20075797 50.1719112,5.19681765 48.9615731,5.19681765 C48.1550281,5.19681765 47.5710669,5.77872264 47.5710669,6.6227933 L47.5710669,11.2430778 L45.7343651,11.2430778 L45.7343651,6.6227933 C45.7343651,6.20075797 45.6089368,5.19681765 44.3993763,5.19681765 C43.5784379,5.19681765 43.0078421,5.77872264 43.0078421,6.6227933 L43.0078421,11.2430778 L41.1719112,11.2430778 L41.1719112,6.6667446 C41.1719112,4.75910378 42.4375032,3.31667852 44.3993763,3.31667852 C45.3732447,3.31667852 46.1653963,3.72586259 46.6807318,4.38101975 C47.2227978,3.72586259 48.0293428,3.31667852 48.9615731,3.31667852 C50.9645703,3.31667852 52.146372,4.70075907 52.146372,6.6667446 L52.146372,11.2430778 Z",
                id: "mercado_m",
                fill: primary
            }))))));
        }, _fundingLogos);
        var _cardLogos;
        var cardLogos = ((_cardLogos = {})[constants.o.VISA] = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M0 1.927C0 .863.892 0 1.992 0h36.016C39.108 0 40 .863 40 1.927v20.146C40 23.137 39.108 24 38.008 24H1.992C.892 24 0 23.137 0 22.073V1.927z" style="fill: rgb(33, 86, 154);"/>\n  <path d="M19.596 7.885l-2.11 9.478H14.93l2.11-9.478h2.554zm10.743 6.12l1.343-3.56.773 3.56H30.34zm2.85 3.358h2.36l-2.063-9.478H31.31c-.492 0-.905.274-1.088.695l-3.832 8.783h2.682l.532-1.415h3.276l.31 1.415zm-6.667-3.094c.01-2.502-3.6-2.64-3.577-3.76.008-.338.345-.7 1.083-.793.365-.045 1.373-.08 2.517.425l.448-2.01c-.615-.214-1.405-.42-2.39-.42-2.523 0-4.3 1.288-4.313 3.133-.016 1.364 1.268 2.125 2.234 2.58.996.464 1.33.762 1.325 1.177-.006.636-.793.918-1.526.928-1.285.02-2.03-.333-2.623-.6l-.462 2.08c.598.262 1.7.49 2.84.502 2.682 0 4.437-1.273 4.445-3.243zM15.948 7.884l-4.138 9.478h-2.7L7.076 9.8c-.123-.466-.23-.637-.606-.834-.615-.32-1.63-.62-2.52-.806l.06-.275h4.345c.554 0 1.052.354 1.178.966l1.076 5.486 2.655-6.45h2.683z" style="fill: rgb(255, 255, 255);"/>\n</svg>', 
        _cardLogos[constants.o.AMEX] = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z" style="fill: rgb(20, 119, 190);"/>\n  <path d="M6.26 12.32h2.313L7.415 9.66M27.353 9.977h-3.738v1.23h3.666v1.384h-3.675v1.385h3.821v1.005c.623-.77 1.33-1.466 2.025-2.235l.707-.77c-.934-1.004-1.87-2.08-2.804-3.075v1.077z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M38.25 7h-5.605l-1.328 1.4L30.072 7H16.984l-1.017 2.416L14.877 7h-9.58L1.25 16.5h4.826l.623-1.556h1.4l.623 1.556H29.99l1.327-1.483 1.328 1.483h5.605l-4.36-4.667L38.25 7zm-17.685 8.1h-1.557V9.883L16.673 15.1h-1.33L13.01 9.883l-.084 5.217H9.73l-.623-1.556h-3.27L5.132 15.1H3.42l2.884-6.772h2.42l2.645 6.233V8.33h2.646l2.107 4.51 1.868-4.51h2.575V15.1zm14.727 0h-2.024l-2.024-2.26-2.023 2.26H22.06V8.328H29.53l1.795 2.177 2.024-2.177h2.025L32.26 11.75l3.032 3.35z" style="fill: rgb(255, 255, 255);"/>\n</svg>', 
        _cardLogos[constants.o.MASTERCARD] = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M0 1.927C0 .863.892 0 1.992 0h36.016C39.108 0 40 .863 40 1.927v20.146C40 23.137 39.108 24 38.008 24H1.992C.892 24 0 23.137 0 22.073V1.927z" style="fill: rgb(62, 57, 57);"/>\n  <path style="fill: rgb(255, 95, 0);" d="M 22.205 3.901 L 15.688 3.901 L 15.688 15.589 L 22.205 15.589"/>\n  <path d="M 16.1 9.747 C 16.1 7.371 17.218 5.265 18.935 3.901 C 17.67 2.912 16.078 2.312 14.342 2.312 C 10.223 2.312 6.892 5.636 6.892 9.746 C 6.892 13.853 10.223 17.178 14.342 17.178 C 16.078 17.178 17.67 16.58 18.935 15.588 C 17.216 14.246 16.099 12.119 16.099 9.745 Z" style="fill: rgb(235, 0, 27);"/>\n  <path d="M 30.996 9.747 C 30.996 13.854 27.663 17.179 23.547 17.179 C 21.81 17.179 20.216 16.581 18.954 15.589 C 20.691 14.227 21.788 12.12 21.788 9.746 C 21.788 7.37 20.671 5.264 18.954 3.9 C 20.216 2.911 21.81 2.311 23.547 2.311 C 27.663 2.311 30.996 5.657 30.996 9.745 Z" style="fill: rgb(247, 158, 27);"/>\n  <path d="M 7.167 22.481 L 7.167 20.43 C 7.167 19.641 6.685 19.127 5.857 19.127 C 5.443 19.127 4.993 19.262 4.683 19.71 C 4.44 19.332 4.096 19.127 3.579 19.127 C 3.233 19.127 2.888 19.23 2.612 19.607 L 2.612 19.197 L 1.886 19.197 L 1.886 22.481 L 2.612 22.481 L 2.612 20.668 C 2.612 20.086 2.921 19.812 3.406 19.812 C 3.888 19.812 4.131 20.121 4.131 20.669 L 4.131 22.481 L 4.856 22.481 L 4.856 20.668 C 4.856 20.086 5.204 19.812 5.651 19.812 C 6.137 19.812 6.377 20.121 6.377 20.669 L 6.377 22.481 L 7.171 22.481 Z M 17.909 19.197 L 16.734 19.197 L 16.734 18.204 L 16.007 18.204 L 16.007 19.197 L 15.352 19.197 L 15.352 19.845 L 16.007 19.845 L 16.007 21.351 C 16.007 22.106 16.319 22.551 17.146 22.551 C 17.459 22.551 17.804 22.449 18.044 22.309 L 17.839 21.695 C 17.632 21.831 17.389 21.867 17.216 21.867 C 16.872 21.867 16.734 21.66 16.734 21.319 L 16.734 19.847 L 17.909 19.847 L 17.909 19.198 Z M 24.053 19.127 C 23.639 19.127 23.364 19.332 23.191 19.607 L 23.191 19.197 L 22.465 19.197 L 22.465 22.481 L 23.191 22.481 L 23.191 20.633 C 23.191 20.086 23.434 19.777 23.882 19.777 C 24.018 19.777 24.192 19.812 24.33 19.847 L 24.538 19.162 C 24.401 19.127 24.192 19.127 24.052 19.127 Z M 14.765 19.469 C 14.42 19.229 13.937 19.127 13.418 19.127 C 12.588 19.127 12.036 19.538 12.036 20.188 C 12.036 20.736 12.453 21.044 13.175 21.146 L 13.524 21.181 C 13.903 21.249 14.108 21.351 14.108 21.523 C 14.108 21.765 13.832 21.934 13.35 21.934 C 12.864 21.934 12.484 21.764 12.244 21.592 L 11.898 22.139 C 12.278 22.411 12.794 22.549 13.313 22.549 C 14.28 22.549 14.831 22.105 14.831 21.488 C 14.831 20.908 14.383 20.599 13.692 20.496 L 13.348 20.462 C 13.037 20.428 12.795 20.36 12.795 20.155 C 12.795 19.914 13.038 19.777 13.418 19.777 C 13.83 19.777 14.245 19.949 14.453 20.052 L 14.764 19.469 Z M 34.033 19.127 C 33.618 19.127 33.342 19.332 33.171 19.607 L 33.171 19.197 L 32.445 19.197 L 32.445 22.481 L 33.171 22.481 L 33.171 20.633 C 33.171 20.086 33.414 19.777 33.862 19.777 C 33.998 19.777 34.17 19.812 34.307 19.847 L 34.515 19.162 C 34.38 19.127 34.172 19.127 34.033 19.127 Z M 24.779 20.838 C 24.779 21.834 25.47 22.551 26.54 22.551 C 27.025 22.551 27.369 22.449 27.715 22.173 L 27.369 21.593 C 27.092 21.798 26.816 21.901 26.504 21.901 C 25.919 21.901 25.505 21.49 25.505 20.84 C 25.505 20.226 25.919 19.813 26.507 19.78 C 26.816 19.78 27.092 19.883 27.369 20.089 L 27.715 19.507 C 27.369 19.233 27.024 19.13 26.54 19.13 C 25.47 19.13 24.779 19.85 24.779 20.841 Z M 31.478 20.838 L 31.478 19.198 L 30.75 19.198 L 30.75 19.608 C 30.51 19.3 30.165 19.128 29.717 19.128 C 28.784 19.128 28.058 19.848 28.058 20.84 C 28.058 21.835 28.784 22.552 29.716 22.552 C 30.197 22.552 30.543 22.382 30.748 22.074 L 30.748 22.484 L 31.477 22.484 L 31.477 20.84 Z M 28.818 20.838 C 28.818 20.259 29.196 19.779 29.819 19.779 C 30.406 19.779 30.821 20.224 30.821 20.84 C 30.821 21.424 30.406 21.902 29.819 21.902 C 29.196 21.869 28.818 21.424 28.818 20.841 Z M 20.148 19.128 C 19.183 19.128 18.494 19.813 18.494 20.84 C 18.494 21.869 19.183 22.552 20.185 22.552 C 20.671 22.552 21.154 22.417 21.533 22.108 L 21.188 21.595 C 20.914 21.799 20.565 21.937 20.222 21.937 C 19.772 21.937 19.323 21.732 19.219 21.149 L 21.671 21.149 L 21.671 20.878 C 21.705 19.815 21.083 19.13 20.15 19.13 Z M 20.148 19.748 C 20.6 19.748 20.911 20.019 20.98 20.532 L 19.253 20.532 C 19.321 20.087 19.633 19.748 20.148 19.748 Z M 38.141 20.84 L 38.141 17.898 L 37.412 17.898 L 37.412 19.61 C 37.173 19.302 36.828 19.13 36.38 19.13 C 35.446 19.13 34.721 19.85 34.721 20.841 C 34.721 21.837 35.446 22.554 36.379 22.554 C 36.861 22.554 37.206 22.383 37.41 22.076 L 37.41 22.486 L 38.14 22.486 L 38.14 20.841 Z M 35.481 20.84 C 35.481 20.261 35.861 19.78 36.484 19.78 C 37.069 19.78 37.486 20.226 37.486 20.841 C 37.486 21.426 37.069 21.904 36.484 21.904 C 35.861 21.87 35.481 21.426 35.481 20.843 Z M 11.237 20.84 L 11.237 19.2 L 10.515 19.2 L 10.515 19.61 C 10.272 19.302 9.928 19.13 9.478 19.13 C 8.545 19.13 7.82 19.85 7.82 20.841 C 7.82 21.837 8.545 22.554 9.477 22.554 C 9.96 22.554 10.304 22.383 10.512 22.076 L 10.512 22.486 L 11.236 22.486 L 11.236 20.841 Z M 8.546 20.84 C 8.546 20.261 8.926 19.78 9.548 19.78 C 10.134 19.78 10.55 20.226 10.55 20.841 C 10.55 21.426 10.134 21.904 9.548 21.904 C 8.926 21.87 8.546 21.426 8.546 20.843 Z" style="fill: rgb(255, 255, 255);"/>\n</svg>', 
        _cardLogos[constants.o.MAESTRO] = '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 23.999999" width="40" height="24" preserveAspectRatio="xMinYMin meet" version="1.1">\n    <path d="M 0,1.927 C 0,0.86299997 0.892,0 1.992,0 H 38.008 C 39.108,0 40,0.86299997 40,1.927 V 22.073 C 40,23.137 39.108,24 38.008,24 H 1.992 C 0.892,24 0,23.137 0,22.073 Z" style="fill:#3e3939" />\n    <path d="m 23.74623,18.221667 v 0.929759 h -0.621716 v 0.609196 h 0.621716 v 1.394324 c 0,0.71165 0.275786,1.135118 1.064369,1.135118 a 1.564348,1.564348 0 0 0 0.833339,-0.237293 l -0.192215,-0.571003 a 1.2309624,1.2309624 0 0 1 -0.589785,0.17343 c -0.333383,0 -0.442649,-0.192213 -0.442649,-0.512774 v -1.388065 h 1.086908 V 19.151426 H 24.419289 V 18.221667 Z M 10.802242,19.066278 A 1.1860835,1.1860835 0 0 0 9.8436827,19.612862 1.1251765,1.1251765 0 0 0 8.830654,19.068153 1.0129794,1.0129794 0 0 0 7.9328276,19.523328 V 19.145165 H 7.2660325 v 3.061001 H 7.939089 v -1.704869 a 0.71485573,0.71485573 0 0 1 0.7500683,-0.814556 c 0.4423764,0 0.6667964,0.288356 0.6667964,0.807671 v 1.702363 h 0.6736813 v -1.695478 a 0.72126699,0.72126699 0 0 1 0.750068,-0.814556 c 0.4552,0 0.673058,0.288356 0.673058,0.807671 v 1.702363 l 0.669926,0.0094 v -1.923369 a 1.1379991,1.1379991 0 0 0 -1.202112,-1.214633 1.1860835,1.1860835 0 0 0 -0.118329,-0.002 z m 10.549158,0.002 c -0.782176,0 -1.282253,0.372027 -1.282253,0.981097 0,0.50008 0.372102,0.80792 1.058106,0.904089 l 0.320567,0.04445 c 0.365439,0.05128 0.538444,0.147461 0.538444,0.320563 0,0.237218 -0.243528,0.371902 -0.69873,0.371902 a 1.6316662,1.6316662 0 0 1 -1.019289,-0.320606 l -0.320562,0.519663 a 2.2086798,2.2086798 0 0 0 1.323576,0.396946 c 0.881546,0 1.394948,-0.461335 1.394948,-0.999881 0,-0.538545 -0.403858,-0.820441 -1.07063,-0.916612 l -0.320563,-0.04509 c -0.288506,-0.03848 -0.519662,-0.07675 -0.519662,-0.301152 0,-0.224394 0.218082,-0.359382 0.583526,-0.359382 a 1.9714631,1.9714631 0 0 1 0.961688,0.262961 l 0.298023,-0.538445 A 2.2888207,2.2888207 0 0 0 21.3514,19.06818 Z m 6.45947,0 0.0132,0.01254 a 0.90398792,0.90398792 0 0 0 -0.80829,0.448915 v -0.371917 h -0.659908 v 3.061628 h 0.666794 v -1.714927 c 0,-0.506487 0.205162,-0.788884 0.641127,-0.788884 a 1.0835034,1.0835034 0 0 1 0.416355,0.07701 l 0.205363,-0.641127 a 1.4200945,1.4200945 0 0 0 -0.474583,-0.08326 z m 2.301544,0 a 1.7246296,1.7246296 0 0 0 -0.656779,0.13148 1.5835818,1.5835818 0 0 0 -0.519661,0.339973 1.564348,1.564348 0 0 0 -0.343103,0.509644 1.7021902,1.7021902 0 0 0 0,1.282252 1.564348,1.564348 0 0 0 0.343103,0.509647 1.5835818,1.5835818 0 0 0 0.519661,0.339972 1.8143872,1.8143872 0 0 0 1.314183,0 1.6028157,1.6028157 0 0 0 0.522793,-0.339972 1.5483199,1.5483199 0 0 0 0.345606,-0.509647 1.6989845,1.6989845 0 0 0 0,-1.282252 1.5515252,1.5515252 0 0 0 -0.345606,-0.509644 1.6028157,1.6028157 0 0 0 -0.532186,-0.343105 1.7246296,1.7246296 0 0 0 -0.641125,-0.122092 z m -15.816534,0.0025 a 1.1604384,1.1604384 0 0 0 -0.05759,6.27e-4 1.602816,1.602816 0 0 0 0,3.205632 1.1604384,1.1604384 0 0 0 0.961689,-0.448915 v 0.371903 h 0.666796 l 0.0062,-1.522675 v -1.528937 h -0.673017 v 0.371902 a 1.1604384,1.1604384 0 0 0 -0.904087,-0.449539 z m 3.747834,0.0039 a 1.6029727,1.6029727 0 0 0 0.04446,3.205629 1.859266,1.859266 0 0 0 1.253452,-0.429506 l -0.320573,-0.493394 a 1.458562,1.458562 0 0 1 -0.89094,0.320563 0.84949219,0.84949219 0 0 1 -0.917235,-0.750067 h 2.273368 c 0.0096,-0.07692 0.0094,-0.160682 0.0094,-0.250439 0,-0.961691 -0.596025,-1.602816 -1.451926,-1.602816 z m -0.05135,0.589784 a 0.78858528,0.78858528 0 0 1 0.03819,0 0.75973457,0.75973457 0 0 1 0.775738,0.743808 h -1.589666 a 0.78858528,0.78858528 0 0 1 0.775738,-0.743808 z m 12.120042,0.03256 a 0.99374563,0.99374563 0 0 1 0.385051,0.08952 0.91681058,0.91681058 0 0 1 0.320563,0.201604 0.92963292,0.92963292 0 0 1 0.201606,0.320564 1.1123539,1.1123539 0 0 1 0,0.795147 0.92642727,0.92642727 0 0 1 -0.201606,0.320562 0.91681058,0.91681058 0 0 1 -0.320563,0.202231 1.0418302,1.0418302 0 0 1 -0.760083,0 0.89757672,0.89757672 0 0 1 -0.304286,-0.202231 0.9360443,0.9360443 0 0 1 -0.202231,-0.320562 1.1123539,1.1123539 0 0 1 0,-0.795147 0.93924994,0.93924994 0 0 1 0.202231,-0.320564 0.90078228,0.90078228 0 0 1 0.304286,-0.201604 0.99374563,0.99374563 0 0 1 0.381918,-0.07073 z M 14.309018,19.80595 a 0.92642727,0.92642727 0 1 1 0.01565,1.852627 0.91681058,0.91681058 0 0 1 -0.936018,-0.981097 h 0.0069 a 0.92642727,0.92642727 0 0 1 0.913439,-0.871499 z m 18.111818,1.952179 -0.01629,0.0031 a 0.3205631,0.3205631 0 0 0 -0.10581,0.0194 0.3205631,0.3205631 0 0 0 -0.09955,0.06386 0.3205631,0.3205631 0 0 0 -0.067,0.09641 0.30132932,0.30132932 0 0 0 0,0.236665 0.3205631,0.3205631 0 0 0 0.288631,0.185952 0.30132932,0.30132932 0 0 0 0.12147,-0.02567 0.3205631,0.3205631 0 0 0 0.09956,-0.06384 0.3205631,0.3205631 0 0 0 0.06763,-0.09642 0.2981237,0.2981237 0 0 0 0,-0.236664 0.3205631,0.3205631 0 0 0 -0.06763,-0.09641 0.3205631,0.3205631 0 0 0 -0.09956,-0.06387 0.3205631,0.3205631 0 0 0 -0.12147,-0.02255 z m 0,0.067 a 0.23080544,0.23080544 0 0 1 0.09266,0.01941 0.2372167,0.2372167 0 0 1 0.07387,0.384424 0.24042232,0.24042232 0 0 1 -0.07387,0.05135 0.2275998,0.2275998 0 0 1 -0.09266,0.01941 v -0.01321 a 0.2372167,0.2372167 0 0 1 -0.170301,-0.07014 0.2372167,0.2372167 0 0 1 0,-0.320564 0.23401105,0.23401105 0 0 1 0.07701,-0.05134 0.24042232,0.24042232 0 0 1 0.09329,-0.0194 z m 0.01878,0.09329 -0.134612,0.0031 v 0.281748 h 0.06134 v -0.105802 h 0.0288 l 0.08639,0.105811 h 0.07388 l -0.09329,-0.105811 a 0.11219709,0.11219709 0 0 0 0.06761,-0.02879 0.07693513,0.07693513 0 0 0 0.02255,-0.05761 0.08014078,0.08014078 0 0 0 -0.0288,-0.067 0.12822525,0.12822525 0 0 0 -0.08391,-0.02567 z m -0.07014,0.05448 0.07014,0.01878 a 0.06731826,0.06731826 0 0 1 0.03881,0 0.03205633,0.03205633 0 0 1 0,0.02943 0.03205633,0.03205633 0 0 1 0,0.0288 0.06731826,0.06731826 0 0 1 -0.03881,0 h -0.07014 z" style="fill:#ffffff;stroke-width:0.77356213" />\n    <g transform="matrix(0.21220782,0,0,0.21220782,2.1400282,0.14227739)">\n        <rect x="68.410004" y="15.14" width="31.5" height="56.610001" style="fill:#7673c0" />\n        <path d="m 382.25,296.22 a 35.94,35.94 0 0 1 13.75,-28.3 36,36 0 1 0 0,56.61 35.94,35.94 0 0 1 -13.75,-28.31 z" transform="translate(-311.84,-252.78)" id="path8" style="fill:#eb001b" />\n        <path d="m 450.81,318.53 v -1.16 h 0.47 v -0.24 h -1.19 v 0.24 h 0.47 v 1.16 z m 2.31,0 v -1.4 h -0.36 l -0.42,1 -0.42,-1 h -0.36 v 1.4 h 0.26 v -1.05 l 0.39,0.91 h 0.27 l 0.39,-0.91 v 1.06 z" transform="translate(-311.84,-252.78)" style="fill:#00a1df" />\n        <path d="m 454.25,296.22 a 36,36 0 0 1 -58.25,28.3 36,36 0 0 0 0,-56.61 36,36 0 0 1 58.25,28.3 z" transform="translate(-311.84,-252.78)" style="fill:#00a1df" />\n    </g>\n</svg>\n', 
        _cardLogos[constants.o.DISCOVER] = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z" style="fill: rgb(17, 49, 82);"/>\n  <path d="M 5.498 13.349 C 5.16 13.654 4.722 13.787 4.028 13.787 L 3.738 13.787 L 3.738 10.141 L 4.028 10.141 C 4.722 10.141 5.143 10.265 5.498 10.587 C 5.868 10.917 6.093 11.431 6.093 11.959 C 6.093 12.489 5.869 13.019 5.498 13.349 Z M 4.243 9.206 L 2.666 9.206 L 2.666 14.721 L 4.236 14.721 C 5.069 14.721 5.671 14.524 6.199 14.084 C 6.829 13.564 7.199 12.779 7.199 11.968 C 7.199 10.34 5.985 9.206 4.243 9.206 Z M 7.696 14.721 L 8.77 14.721 L 8.77 9.207 L 7.696 9.207 M 11.393 11.323 C 10.748 11.083 10.559 10.926 10.559 10.628 C 10.559 10.281 10.897 10.018 11.359 10.018 C 11.681 10.018 11.946 10.15 12.226 10.464 L 12.788 9.727 C 12.326 9.322 11.773 9.115 11.17 9.115 C 10.195 9.115 9.452 9.793 9.452 10.695 C 9.452 11.455 9.798 11.845 10.807 12.208 C 11.227 12.356 11.442 12.455 11.55 12.522 C 11.765 12.662 11.872 12.862 11.872 13.092 C 11.872 13.54 11.518 13.872 11.038 13.872 C 10.528 13.872 10.114 13.614 9.868 13.136 L 9.173 13.806 C 9.668 14.532 10.263 14.856 11.08 14.856 C 12.196 14.856 12.98 14.111 12.98 13.044 C 12.98 12.168 12.617 11.771 11.395 11.324 Z M 13.316 11.968 C 13.316 13.588 14.586 14.845 16.223 14.845 C 16.685 14.845 17.081 14.755 17.57 14.525 L 17.57 13.258 C 17.14 13.688 16.76 13.862 16.273 13.862 C 15.191 13.862 14.423 13.077 14.423 11.962 C 14.423 10.902 15.215 10.067 16.223 10.067 C 16.735 10.067 17.123 10.25 17.57 10.687 L 17.57 9.421 C 17.098 9.181 16.71 9.081 16.248 9.081 C 14.621 9.081 13.316 10.364 13.316 11.968 Z M 26.088 12.911 L 24.62 9.206 L 23.446 9.206 L 25.783 14.862 L 26.361 14.862 L 28.741 9.207 L 27.576 9.207 M 29.226 14.721 L 32.272 14.721 L 32.272 13.787 L 30.299 13.787 L 30.299 12.299 L 32.199 12.299 L 32.199 11.365 L 30.299 11.365 L 30.299 10.141 L 32.272 10.141 L 32.272 9.206 L 29.226 9.206 M 34.373 11.745 L 34.059 11.745 L 34.059 10.075 L 34.389 10.075 C 35.059 10.075 35.423 10.355 35.423 10.893 C 35.423 11.447 35.059 11.745 34.373 11.745 Z M 36.528 10.835 C 36.528 9.802 35.818 9.207 34.578 9.207 L 32.986 9.207 L 32.986 14.721 L 34.059 14.721 L 34.059 12.506 L 34.199 12.506 L 35.686 14.721 L 37.006 14.721 L 35.273 12.398 C 36.083 12.233 36.528 11.678 36.528 10.835 Z" style="fill: rgb(255, 255, 255);"/>\n  <g id="MarkingBase_1_" transform="matrix(0.089776, 0, 0, 0.089776, 2.192296, 5.72498)">\n    <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="224.3917" y1="44.1731" x2="201.33" y2="80.2807" gradientTransform="matrix(1 0 0 -1 0 141.7323)">\n      <stop offset="0" style="stop-color:#F89F21"/>\n      <stop offset="0.2502" style="stop-color:#F79A23"/>\n      <stop offset="0.5331" style="stop-color:#F78E22"/>\n      <stop offset="0.6196" style="stop-color:#F68721"/>\n      <stop offset="0.7232" style="stop-color:#F48220"/>\n      <stop offset="1" style="stop-color:#F27623"/>\n    </linearGradient>\n    <circle fill="url(#SVGID_1_)" cx="207.343" cy="70.866" r="33.307"/>\n    <linearGradient id="SVGID_2_" gradientUnits="userSpaceOnUse" x1="220.7487" y1="44.664" x2="187.0436" y2="110.5426" gradientTransform="matrix(1 0 0 -1 0 141.7323)">\n      <stop offset="0" style="stop-color:#F68721;stop-opacity:0"/>\n      <stop offset="0.3587" style="stop-color:#E27027;stop-opacity:0.2704"/>\n      <stop offset="0.703" style="stop-color:#D4612C;stop-opacity:0.5299"/>\n      <stop offset="0.9816" style="stop-color:#D15D2D;stop-opacity:0.74"/>\n    </linearGradient>\n    <circle opacity="0.65" fill="url(#SVGID_2_)" cx="207.343" cy="70.866" r="33.307"/>\n  </g>\n  <g id="Orange_1_" enable-background="new    " transform="matrix(0.469224, 0, 0, 0.469224, 13.785085, 6.199149)">\n    <g id="Orange">\n      <g>\n        <path d="M13,38c20.1,0,40,0,40,0c1.7,0,3-1.3,3-3V18C56,18,51.2,31.8,13,38z" style="fill: rgb(255, 129, 38);"/>\n      </g>\n    </g>\n  </g>\n</svg>', 
        _cardLogos[constants.o.HIPER] = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M0 1.927C0 .863.892 0 1.992 0h36.016C39.108 0 40 .863 40 1.927v20.146C40 23.137 39.108 24 38.008 24H1.992C.892 24 0 23.137 0 22.073V1.927z" style="fill: rgb(243, 97, 24);"/>\n  <path id="path16" style="fill: rgb(255, 255, 255); fill-opacity: 1; fill-rule: nonzero; stroke: none;" d="M 3.206 6.45 L 3.206 16.929 L 5.586 16.929 L 5.586 12.545 L 9.489 12.545 L 9.489 16.929 L 11.853 16.929 L 11.853 6.45 L 9.489 6.45 L 9.489 10.477 L 5.586 10.477 L 5.586 6.45 L 3.206 6.45"/>\n  <path id="path18" style="fill: rgb(255, 255, 255); fill-opacity: 1; fill-rule: nonzero; stroke: none;" d="M 32.319 13.882 C 32.351 13.71 32.397 13.353 32.397 12.949 C 32.397 11.068 31.464 9.155 29.008 9.155 C 26.364 9.155 25.167 11.285 25.167 13.213 C 25.167 15.592 26.644 17.085 29.225 17.085 C 30.251 17.085 31.2 16.929 31.977 16.618 L 31.666 15.017 C 31.029 15.219 30.376 15.328 29.567 15.328 C 28.463 15.328 27.499 14.861 27.422 13.882 Z M 27.406 12.265 C 27.468 11.628 27.873 10.725 28.868 10.725 C 29.956 10.725 30.205 11.689 30.205 12.265 L 27.406 12.265"/>\n  <path id="path20" style="fill: rgb(255, 255, 255); fill-opacity: 1; fill-rule: nonzero; stroke: none;" d="M 33.155 16.929 L 35.519 16.929 L 35.519 13.073 C 35.519 12.887 35.533 12.7 35.565 12.545 C 35.72 11.814 36.31 11.348 37.182 11.348 C 37.446 11.348 37.648 11.378 37.819 11.41 L 37.819 9.186 C 37.648 9.155 37.539 9.155 37.321 9.155 C 36.591 9.155 35.658 9.621 35.269 10.725 L 35.207 10.725 L 35.129 9.326 L 33.092 9.326 C 33.123 9.979 33.155 10.709 33.155 11.829 L 33.155 16.929"/>\n  <path id="path22" style="fill: rgb(254, 234, 1); fill-opacity: 1; fill-rule: evenodd; stroke: none;" d="M 14.256 6.028 C 14.927 6.028 15.472 6.572 15.472 7.243 C 15.472 7.914 14.927 8.458 14.256 8.458 C 13.585 8.458 13.041 7.914 13.041 7.243 C 13.041 6.572 13.585 6.028 14.256 6.028"/>\n  <path id="path24" style="fill: rgb(255, 255, 255); fill-opacity: 1; fill-rule: evenodd; stroke: none;" d="M 19.247 15.159 L 20.433 15.159 C 21.624 15.159 22.163 14.395 22.163 13.6 C 22.163 12.805 22.106 11.006 20.633 11.006 C 18.943 11.006 19.218 13.238 19.224 14.408 C 19.226 14.658 19.24 14.908 19.247 15.159 Z M 13.041 9.315 L 15.472 9.315 L 15.472 13.6 C 15.472 14.395 15.912 15.157 16.887 15.159 C 16.894 13.229 16.886 11.243 16.822 9.315 L 18.852 9.315 C 18.896 9.687 18.936 10.059 18.973 10.432 C 19.932 8.514 22.954 8.937 23.971 10.555 C 25.022 12.228 25.379 17.017 20.433 17.017 L 19.282 17.017 C 19.293 17.988 19.295 18.963 19.295 19.936 L 16.865 19.936 C 16.865 19.001 16.871 18.022 16.878 17.016 C 14.252 17.007 13.041 15.339 13.041 13.6 L 13.041 9.315"/>\n</svg>', 
        _cardLogos[constants.o.ELO] = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <path d="M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z" style="fill: rgb(21, 21, 21);"/>\n  <path class="st0" d="M 9.229 8.55 C 9.592 8.431 9.977 8.365 10.382 8.365 C 12.14 8.365 13.602 9.613 13.939 11.268 L 16.427 10.762 C 15.855 7.946 13.365 5.824 10.379 5.824 C 9.693 5.824 9.037 5.935 8.42 6.142 L 9.229 8.55 Z" style="fill: rgb(255, 205, 5);"/>\n  <path class="st1" d="M 6.292 16.616 L 7.973 14.716 C 7.221 14.052 6.749 13.08 6.749 11.999 C 6.749 10.917 7.221 9.945 7.973 9.279 L 6.292 7.38 C 5.015 8.51 4.209 10.16 4.209 11.999 C 4.209 13.836 5.019 15.488 6.292 16.616" style="fill: rgb(0, 164, 224);"/>\n  <path class="st2" d="M 13.939 12.723 C 13.602 14.379 12.136 15.626 10.382 15.626 C 9.977 15.626 9.592 15.562 9.229 15.442 L 8.422 17.849 C 9.039 18.055 9.698 18.167 10.382 18.167 C 13.365 18.167 15.855 16.05 16.427 13.235 L 13.939 12.723 Z" style="fill: rgb(239, 66, 35);"/>\n  <path d="M 18.603 14.794 C 18.521 14.663 18.412 14.453 18.343 14.296 C 17.948 13.381 17.932 12.434 18.264 11.526 C 18.631 10.527 19.33 9.765 20.233 9.378 C 21.366 8.889 22.626 8.986 23.713 9.632 C 24.406 10.028 24.897 10.641 25.269 11.506 C 25.319 11.615 25.358 11.737 25.398 11.835 L 18.603 14.794 Z M 20.87 10.845 C 20.066 11.194 19.65 11.949 19.734 12.834 L 23.151 11.363 C 22.565 10.675 21.802 10.444 20.87 10.845 Z M 23.578 14.044 C 23.578 14.044 23.578 14.044 23.578 14.044 L 23.508 13.998 C 23.302 14.331 22.985 14.595 22.584 14.768 C 21.82 15.1 21.113 15.014 20.602 14.569 L 20.559 14.643 C 20.559 14.643 20.559 14.643 20.559 14.643 L 19.688 15.936 C 19.905 16.088 20.134 16.213 20.376 16.315 C 21.333 16.712 22.311 16.693 23.279 16.273 C 23.978 15.971 24.527 15.509 24.9 14.924 L 23.578 14.044 Z" style="fill: rgb(255, 255, 255);"/>\n  <path d="M 27.77 7.466 L 27.77 14.673 L 28.891 15.13 L 28.254 16.614 L 27.018 16.1 C 26.742 15.979 26.552 15.797 26.409 15.588 C 26.272 15.377 26.171 15.085 26.171 14.698 L 26.171 7.466 L 27.77 7.466 Z" style="fill: rgb(255, 255, 255);"/>\n  <g transform="matrix(0.037801, 0, 0, 0.037801, 1.0913, 0.089785)">\n    <path d="M782.7,337.2c0-16.2,7.2-30.8,18.5-40.7l-30.4-33.9c-20.6,18.2-33.6,44.9-33.6,74.6c0,29.7,12.9,56.4,33.6,74.7l30.4-34&#10;&#9;&#9;C789.8,367.9,782.6,353.4,782.7,337.2z" style="fill: rgb(255, 255, 255);"/>\n    <path d="M836.7,391.4c-6,0-11.8-1-17.1-2.8L805,431.7c9.9,3.3,20.6,5.1,31.6,5.2c48.2,0,88.4-34.1,97.7-79.6l-44.7-9.1&#10;&#9;&#9;C884.6,372.9,862.8,391.4,836.7,391.4z" style="fill: rgb(255, 255, 255);"/>\n    <path d="M836.8,237.6c-11,0-21.7,1.8-31.6,5.1l14.4,43.2c5.4-1.8,11.2-2.8,17.1-2.8c26.2,0,48,18.6,53,43.3l44.7-9.1&#10;&#9;&#9;C925.2,272,885,237.7,836.8,237.6z" style="fill: rgb(255, 255, 255);"/>\n  </g>\n</svg>', 
        _cardLogos[constants.o.JCB] = '<?xml version="1.0" encoding="utf-8"?>\n<svg width="40" height="24" viewBox="0 0 40 24" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg">\n  <defs>\n    <pattern id="pattern-0" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse" viewBox="0 0 100 100">\n      <path d="M 0 0 L 50 0 L 50 100 L 0 100 Z" style="fill: black;"/>\n    </pattern>\n  </defs>\n  <path d="M38.333 24H1.667C.75 24 0 23.28 0 22.4V1.6C0 .72.75 0 1.667 0h36.666C39.25 0 40 .72 40 1.6v20.8c0 .88-.75 1.6-1.667 1.6z" style="fill: rgb(255, 255, 255); stroke: rgb(233, 234, 231);"/>\n  <g transform="matrix(0.100306, 0, 0, 0.100306, 4.733743, 10.105099)" id="g6321">\n    <g transform="matrix(1.8215159,0,0,1.8215159,-8.5437653,-109.83667)" id="g6323">\n      <path style="fill:#ffffff" id="path6325" d="m 174,108.3 c 0,14 -11.4,25.4 -25.4,25.4 l -138.2,0 0,-100.6 c 0,-14 11.4,-25.4 25.4,-25.4 l 138.2,0 0,100.6 z" class="st0"/>\n      <g id="g6327">\n        <linearGradient gradientTransform="matrix(1.125,0,0,1.125,-11.9755,-13.8615)" y2="81.398598" x2="157.3299" y1="81.398598" x1="117.3856" gradientUnits="userSpaceOnUse" id="SVGID_1_">\n          <stop id="stop6330" style="stop-color:#007940" offset="0"/>\n          <stop id="stop6332" style="stop-color:#00873F" offset="0.2285"/>\n          <stop id="stop6334" style="stop-color:#40A737" offset="0.7433"/>\n          <stop id="stop6336" style="stop-color:#5CB531" offset="1"/>\n        </linearGradient>\n        <path style="fill:url(#SVGID_1_)" id="path6338" d="m 129,82.5 10.5,0 c 0.3,0 1,-0.1 1.3,-0.1 2,-0.4 3.7,-2.2 3.7,-4.7 0,-2.4 -1.7,-4.2 -3.7,-4.7 -0.3,-0.1 -0.9,-0.1 -1.3,-0.1 l -10.5,0 0,9.6 z" class="st1"/>\n        <linearGradient gradientTransform="matrix(1.125,0,0,1.125,-11.9755,-13.8615)" y2="75.171402" x2="157.3318" y1="75.171402" x1="117.3844" gradientUnits="userSpaceOnUse" id="SVGID_2_">\n          <stop id="stop6341" style="stop-color:#007940" offset="0"/>\n          <stop id="stop6343" style="stop-color:#00873F" offset="0.2285"/>\n          <stop id="stop6345" style="stop-color:#40A737" offset="0.7433"/>\n          <stop id="stop6347" style="stop-color:#5CB531" offset="1"/>\n        </linearGradient>\n        <path style="fill:url(#SVGID_2_)" id="path6349" d="m 138.3,16.2 c -10,0 -18.2,8.1 -18.2,18.2 l 0,18.9 25.7,0 c 0.6,0 1.3,0 1.8,0.1 5.8,0.3 10.1,3.3 10.1,8.5 0,4.1 -2.9,7.6 -8.3,8.3 l 0,0.2 c 5.9,0.4 10.4,3.7 10.4,8.8 0,5.5 -5,9.1 -11.6,9.1 l -28.2,0 0,37 26.7,0 c 10,0 18.2,-8.1 18.2,-18.2 l 0,-90.9 -26.6,0 z" class="st2"/>\n        <linearGradient gradientTransform="matrix(1.125,0,0,1.125,-11.9755,-13.8615)" y2="68.399101" x2="157.33051" y1="68.399101" x1="117.3846" gradientUnits="userSpaceOnUse" id="SVGID_3_">\n          <stop id="stop6352" style="stop-color:#007940" offset="0"/>\n          <stop id="stop6354" style="stop-color:#00873F" offset="0.2285"/>\n          <stop id="stop6356" style="stop-color:#40A737" offset="0.7433"/>\n          <stop id="stop6358" style="stop-color:#5CB531" offset="1"/>\n        </linearGradient>\n        <path style="fill:url(#SVGID_3_)" id="path6360" d="m 143.2,63.1 c 0,-2.4 -1.7,-4 -3.7,-4.3 -0.2,0 -0.7,-0.1 -1,-0.1 l -9.5,0 0,8.8 9.5,0 c 0.3,0 0.9,0 1,-0.1 2,-0.3 3.7,-1.9 3.7,-4.3 z" class="st3"/>\n      </g>\n      <linearGradient gradientTransform="matrix(1.125,0,0,1.125,-11.9755,-13.8615)" y2="75.171402" x2="68.522102" y1="75.171402" x1="27.9594" gradientUnits="userSpaceOnUse" id="SVGID_4_">\n        <stop id="stop6363" style="stop-color:#1F286F" offset="0"/>\n        <stop id="stop6365" style="stop-color:#004E94" offset="0.4751"/>\n        <stop id="stop6367" style="stop-color:#0066B1" offset="0.8261"/>\n        <stop id="stop6369" style="stop-color:#006FBC" offset="1"/>\n      </linearGradient>\n      <path style="fill:url(#SVGID_4_)" id="path6371" d="m 37.7,16.2 c -10,0 -18.2,8.1 -18.2,18.2 l 0,44.9 c 5.1,2.5 10.4,4.1 15.7,4.1 6.3,0 9.7,-3.8 9.7,-9 l 0,-21.2 15.6,0 0,21.1 c 0,8.2 -5.1,14.9 -22.4,14.9 -10.5,0 -18.7,-2.3 -18.7,-2.3 l 0,38.3 26.7,0 c 10,0 18.2,-8.1 18.2,-18.2 l 0,-90.8 -26.6,0 z" class="st4"/>\n      <linearGradient gradientTransform="matrix(1.125,0,0,1.125,-11.9755,-13.8615)" y2="75.171402" x2="111.8553" y1="75.171402" x1="72.459503" gradientUnits="userSpaceOnUse" id="SVGID_5_">\n        <stop id="stop6374" style="stop-color:#6C2C2F" offset="0"/>\n        <stop id="stop6376" style="stop-color:#882730" offset="0.1735"/>\n        <stop id="stop6378" style="stop-color:#BE1833" offset="0.5731"/>\n        <stop id="stop6380" style="stop-color:#DC0436" offset="0.8585"/>\n        <stop id="stop6382" style="stop-color:#E60039" offset="1"/>\n      </linearGradient>\n      <path style="fill:url(#SVGID_5_)" id="path6384" d="m 88,16.2 c -10,0 -18.2,8.1 -18.2,18.2 l 0,23.8 c 4.6,-3.9 12.6,-6.4 25.5,-5.8 6.9,0.3 14.3,2.2 14.3,2.2 l 0,7.7 c -3.7,-1.9 -8.1,-3.6 -13.8,-4 -9.8,-0.7 -15.7,4.1 -15.7,12.5 0,8.5 5.9,13.3 15.7,12.5 5.7,-0.4 10.1,-2.2 13.8,-4 l 0,7.7 c 0,0 -7.3,1.9 -14.3,2.2 -12.9,0.6 -20.9,-1.9 -25.5,-5.8 l 0,42 26.7,0 c 10,0 18.2,-8.1 18.2,-18.2 l 0,-91 -26.7,0 z" class="st5"/>\n    </g>\n    <g id="g6386"/>\n  </g>\n</svg>', 
        _cardLogos[constants.o.CUP] = '<?xml version="1.0" encoding="UTF-8"?>\n<svg width="40px" height="24px" viewBox="0 0 40 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n    \x3c!-- Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch --\x3e\n    <title>unionpay</title>\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id="unionpay" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\n        <g>\n            <path d="M38,24 L2,24 C0.9,24 0,23.1 0,22 L0,2 C0,0.9 0.9,0 2,0 L38,0 C39.1,0 40,0.9 40,2 L40,22 C40,23.1 39.1,24 38,24" id="Fill-1" fill="#FFFFFF"></path>\n            <path d="M38,0 L2,0 C0.9,0 0,0.9 0,2 L0,22 C0,23.1 0.9,24 2,24 L38,24 C39.1,24 40,23.1 40,22 L40,2 C40,0.9 39.1,0 38,0 M38,1 C38.551,1 39,1.449 39,2 L39,22 C39,22.551 38.551,23 38,23 L2,23 C1.449,23 1,22.551 1,22 L1,2 C1,1.449 1.449,1 2,1 L38,1" id="Fill-3" fill="#C8C8C8"></path>\n            <path d="M11.6294,3.3945 L18.4974,3.3945 C19.4564,3.3945 20.0524,4.1755 19.8284,5.1375 L16.6294,18.8655 C16.4054,19.8245 15.4474,20.6055 14.4904,20.6055 L7.6204,20.6055 C6.6624,20.6055 6.0664,19.8245 6.2894,18.8655 L9.4894,5.1375 C9.7124,4.1755 10.6694,3.3945 11.6294,3.3945" id="Fill-5" fill="#D80029"></path>\n            <path d="M17.9287,3.3945 L24.7967,3.3945 C25.7537,3.3945 26.3547,4.1755 26.1257,5.1375 L22.9297,18.8655 C22.7037,19.8245 21.7437,20.6055 20.7837,20.6055 L13.9177,20.6055 C12.9587,20.6055 12.3627,19.8245 12.5877,18.8655 L15.7837,5.1375 C16.0077,4.1755 16.9697,3.3945 17.9287,3.3945" id="Fill-7" fill="#0E2E62"></path>\n            <path d="M25.5161,3.3945 L32.3771,3.3945 C33.3361,3.3945 33.9351,4.1755 33.7091,5.1375 L30.5121,18.8655 C30.2891,19.8245 29.3291,20.6055 28.3711,20.6055 L21.5001,20.6055 C20.5421,20.6055 19.9431,19.8245 20.1691,18.8655 L23.3661,5.1375 C23.5901,4.1755 24.5511,3.3945 25.5161,3.3945" id="Fill-9" fill="#0C606C"></path>\n            <path d="M24.4546,16.3071 L25.1006,16.3071 L25.2466,15.6821 L24.5976,15.6821 L24.4546,16.3071 Z M24.8526,14.5921 L24.6816,15.3221 C24.6816,15.3221 24.9176,15.1981 25.0506,15.1611 C25.1796,15.1271 25.3786,15.1051 25.3786,15.1051 L25.5006,14.5921 L24.8526,14.5921 Z M25.1026,13.5291 L24.9406,14.2371 C24.9406,14.2371 25.1706,14.1281 25.3006,14.0941 C25.4316,14.0581 25.6296,14.0401 25.6296,14.0401 L25.7516,13.5291 L25.1026,13.5291 Z M26.5356,13.5291 L25.8886,16.2961 L26.1126,16.2961 L25.9756,16.8721 L25.7516,16.8721 L25.7106,17.0491 L24.9126,17.0491 L24.9556,16.8721 L23.3366,16.8721 L23.4636,16.3421 L23.6286,16.3401 L24.2886,13.5291 L24.4186,12.9631 L25.2336,12.9631 L25.1686,13.2481 C25.1686,13.2481 25.3736,13.0911 25.5716,13.0391 C25.7756,12.9841 26.9526,12.9641 26.9526,12.9641 L26.8176,13.5291 L26.5356,13.5291 Z" id="Fill-11" fill="#FFFFFF"></path>\n            <path d="M26.9966,12.9678 L27.8616,12.9678 L27.8726,13.2878 C27.8666,13.3418 27.9146,13.3668 28.0136,13.3688 L28.1616,13.3688 L28.0306,13.9018 L27.5596,13.9018 C27.1566,13.9318 27.0016,13.7578 27.0136,13.5618 L26.9966,12.9678" id="Fill-13" fill="#FFFFFF"></path>\n            <path d="M27.1436,15.4956 L26.3166,15.4956 L26.4276,15.0226 L27.3706,15.0226 L27.4736,14.5886 L26.5416,14.5886 L26.6686,14.0536 L29.2616,14.0536 L29.1336,14.5886 L28.2656,14.5886 L28.1616,15.0226 L29.0326,15.0226 L28.9216,15.4956 L27.9786,15.4956 L27.8216,15.6976 L28.2056,15.6976 L28.3396,16.2966 C28.3516,16.3536 28.3596,16.3926 28.3786,16.4196 C28.3956,16.4386 28.5126,16.4486 28.5806,16.4486 L28.6976,16.4486 L28.5596,17.0356 L28.2656,17.0356 C28.2206,17.0356 28.1526,17.0346 28.0576,17.0246 C27.9706,17.0176 27.9036,16.9636 27.8406,16.9376 C27.7836,16.9106 27.6996,16.8476 27.6706,16.7326 L27.5386,16.1376 L27.1546,16.7246 C27.0266,16.9106 26.8526,17.0496 26.5396,17.0496 L25.9386,17.0496 L26.0596,16.5326 L26.2906,16.5326 C26.3556,16.5326 26.4156,16.5056 26.4546,16.4836 C26.4986,16.4646 26.5356,16.4426 26.5796,16.3806 L27.1436,15.4956" id="Fill-15" fill="#FFFFFF"></path>\n            <path d="M18.0044,14.1973 L20.1934,14.1973 L20.0684,14.7183 L19.1874,14.7183 L19.0834,15.1663 L19.9734,15.1663 L19.8434,15.7033 L18.9514,15.7033 L18.7794,16.4263 C18.7584,16.5053 18.9974,16.5203 19.0834,16.5203 L19.5254,16.4583 L19.3824,17.0503 L18.3764,17.0503 C18.2934,17.0503 18.2344,17.0433 18.1454,17.0223 C18.0594,17.0003 18.0184,16.9613 17.9734,16.9053 C17.9374,16.8493 17.8764,16.7963 17.9074,16.6723 L18.1364,15.7123 L17.6394,15.7123 L17.7704,15.1663 L18.2714,15.1663 L18.3764,14.7183 L17.8784,14.7183 L18.0044,14.1973" id="Fill-17" fill="#FFFFFF"></path>\n            <path d="M19.4194,13.2588 L20.3174,13.2588 L20.1894,13.8018 L18.9614,13.8018 L18.8354,13.9198 C18.7844,13.9738 18.7614,13.9518 18.6914,13.9888 C18.6234,14.0278 18.4814,14.0938 18.2914,14.0938 L17.9004,14.0938 L18.0264,13.5718 L18.1414,13.5718 C18.2444,13.5718 18.3104,13.5588 18.3434,13.5378 C18.3804,13.5158 18.4214,13.4598 18.4644,13.3688 L18.6664,12.9618 L19.5584,12.9618 L19.4194,13.2588" id="Fill-19" fill="#FFFFFF"></path>\n            <path d="M21.1973,14.1572 C21.1973,14.1572 21.4273,13.9322 21.8443,13.8582 C21.9383,13.8422 22.5393,13.8462 22.5393,13.8462 L22.6063,13.5452 L21.3453,13.5452 L21.1973,14.1572 Z M22.3963,14.3842 L21.1463,14.3842 L21.0853,14.6352 L22.1703,14.6352 C22.2953,14.6232 22.3233,14.6392 22.3313,14.6342 L22.3963,14.3842 Z M20.6843,12.9632 L21.4543,12.9632 L21.3633,13.3512 C21.3633,13.3512 21.5903,13.1552 21.7603,13.0912 C21.9223,13.0252 22.3023,12.9702 22.3023,12.9702 L23.5393,12.9632 L23.2033,14.3672 C23.1463,14.6112 23.0763,14.7642 23.0263,14.8342 C22.9833,14.9052 22.9343,14.9662 22.8283,15.0262 C22.7283,15.0832 22.6333,15.1142 22.5453,15.1222 C22.4663,15.1322 22.3403,15.1322 22.1653,15.1332 L20.9773,15.1332 L20.7093,16.2452 C20.6813,16.3562 20.6723,16.4072 20.6943,16.4382 C20.7123,16.4622 20.7553,16.4932 20.8113,16.4932 L21.3323,16.4422 L21.1933,17.0552 L20.6003,17.0552 C20.4153,17.0552 20.2773,17.0502 20.1853,17.0422 C20.0933,17.0352 19.9953,17.0422 19.9293,16.9922 C19.8733,16.9412 19.7873,16.8822 19.7843,16.8172 C19.7873,16.7572 19.8063,16.6562 19.8333,16.5212 L20.6843,12.9632 Z" id="Fill-21" fill="#FFFFFF"></path>\n            <path d="M23.0562,15.2319 L23.0082,15.5689 C22.9802,15.6729 22.9602,15.7539 22.8882,15.8259 C22.8062,15.8939 22.7132,15.9679 22.4822,15.9679 L22.0622,15.9839 L22.0792,16.3649 C22.0832,16.4769 22.1092,16.4639 22.1282,16.4819 C22.1512,16.5019 22.1652,16.5079 22.1862,16.5139 L22.3222,16.5079 L22.7222,16.4829 L22.5922,17.0439 L22.1282,17.0439 C21.8022,17.0439 21.5562,17.0339 21.4752,16.9709 C21.3932,16.9189 21.3802,16.8579 21.3752,16.7559 L21.3112,15.2649 L22.0562,15.2649 L22.0642,15.5689 L22.2422,15.5689 C22.3052,15.5689 22.3442,15.5649 22.3702,15.5479 C22.3892,15.5289 22.4032,15.5069 22.4162,15.4709 L22.4692,15.2319 L23.0562,15.2319" id="Fill-23" fill="#FFFFFF"></path>\n            <path d="M12.4448,7.7773 C12.4168,7.9033 11.9418,10.0983 11.9398,10.1003 C11.8368,10.5433 11.7588,10.8603 11.5118,11.0673 C11.3628,11.1853 11.1948,11.2413 11.0048,11.2413 C10.6918,11.2413 10.5078,11.0883 10.4738,10.7923 L10.4658,10.6903 C10.4658,10.6903 10.5628,10.0983 10.5628,10.0963 C10.5628,10.0963 11.0648,8.0893 11.1558,7.8233 C11.1578,7.8083 11.1608,7.7983 11.1638,7.7903 C10.1898,7.8023 10.0168,7.7953 10.0048,7.7773 C9.9988,7.7983 9.9738,7.9253 9.9738,7.9253 L9.4628,10.1823 L9.4148,10.3743 L9.3348,10.9983 C9.3348,11.1853 9.3698,11.3383 9.4428,11.4663 C9.6748,11.8713 10.3408,11.9313 10.7158,11.9313 C11.1998,11.9313 11.6508,11.8263 11.9588,11.6443 C12.4908,11.3253 12.6318,10.8333 12.7528,10.3993 L12.8108,10.1743 C12.8108,10.1743 13.3288,8.0923 13.4158,7.8233 C13.4178,7.8083 13.4218,7.7983 13.4238,7.7903 C12.7188,7.8013 12.5118,7.7953 12.4448,7.7773" id="Fill-25" fill="#FFFFFF"></path>\n            <path d="M15.2935,11.9106 C14.9485,11.9056 14.8275,11.9056 14.4245,11.9246 L14.4055,11.8966 C14.4425,11.7416 14.4815,11.5876 14.5165,11.4346 L14.5645,11.2266 C14.6395,10.8986 14.7155,10.5206 14.7195,10.4026 C14.7285,10.3336 14.7505,10.1606 14.5525,10.1606 C14.4695,10.1606 14.3815,10.1996 14.2925,10.2416 C14.2475,10.4136 14.1445,10.9026 14.0985,11.1246 C14.0005,11.5956 13.9905,11.6496 13.9475,11.8796 L13.9185,11.9106 C13.5605,11.9056 13.4395,11.9056 13.0315,11.9246 L13.0135,11.8926 C13.0795,11.6086 13.1485,11.3326 13.2115,11.0526 C13.3855,10.2976 13.4265,10.0106 13.4725,9.6276 L13.5045,9.6006 C13.9065,9.5466 14.0015,9.5326 14.4355,9.4436 L14.4695,9.4836 L14.4035,9.7266 C14.4785,9.6846 14.5505,9.6406 14.6255,9.6006 C14.8275,9.5026 15.0535,9.4706 15.1805,9.4706 C15.3675,9.4706 15.5725,9.5256 15.6605,9.7426 C15.7475,9.9376 15.6885,10.1786 15.5805,10.6526 L15.5275,10.8916 C15.4135,11.4216 15.3975,11.5196 15.3345,11.8796 L15.2935,11.9106" id="Fill-27" fill="#FFFFFF"></path>\n            <path d="M16.6963,11.9106 C16.4873,11.9056 16.3543,11.9056 16.2243,11.9106 C16.0943,11.9106 15.9663,11.9146 15.7733,11.9246 L15.7623,11.9056 L15.7513,11.8926 C15.8033,11.6936 15.8313,11.6216 15.8583,11.5526 C15.8843,11.4806 15.9093,11.4106 15.9553,11.2066 C16.0143,10.9436 16.0533,10.7546 16.0783,10.5966 C16.1083,10.4366 16.1223,10.3066 16.1423,10.1526 L16.1613,10.1396 L16.1743,10.1236 C16.3833,10.0986 16.5133,10.0776 16.6503,10.0546 C16.7823,10.0356 16.9213,10.0106 17.1363,9.9716 L17.1423,9.9866 L17.1523,10.0046 C17.1083,10.1696 17.0713,10.3336 17.0303,10.4996 C16.9913,10.6646 16.9533,10.8296 16.9173,10.9926 C16.8353,11.3386 16.8083,11.4716 16.7883,11.5626 C16.7723,11.6526 16.7673,11.6976 16.7363,11.8796 L16.7173,11.8966 L16.6963,11.9106" id="Fill-29" fill="#FFFFFF"></path>\n            <path d="M18.8965,10.6846 C18.8765,10.7706 18.7985,11.1066 18.6915,11.2486 C18.6185,11.3496 18.5295,11.4126 18.4375,11.4126 C18.4085,11.4126 18.2365,11.4126 18.2325,11.1616 C18.2325,11.0356 18.2545,10.9076 18.2875,10.7676 C18.3775,10.3706 18.4865,10.0316 18.7585,10.0316 C18.9745,10.0316 18.9875,10.2766 18.8965,10.6846 M19.7975,10.7226 C19.9195,10.1886 19.8285,9.9396 19.7085,9.7916 C19.5255,9.5596 19.2115,9.4836 18.8795,9.4836 C18.6825,9.4836 18.2135,9.5056 17.8445,9.8486 C17.5825,10.0906 17.4525,10.4256 17.3825,10.7426 C17.3075,11.0676 17.2205,11.6586 17.7575,11.8716 C17.9245,11.9426 18.1635,11.9656 18.3155,11.9656 C18.7125,11.9656 19.1165,11.8536 19.4175,11.5286 C19.6555,11.2726 19.7605,10.8806 19.7975,10.7226" id="Fill-31" fill="#FFFFFF"></path>\n            <path d="M28.7817,9.5107 C28.3477,9.5897 28.2337,9.6107 27.8217,9.6667 L27.7857,9.6907 C27.7837,9.7247 27.7777,9.7567 27.7717,9.7927 C27.7097,9.6877 27.6207,9.5947 27.4737,9.5377 C27.2867,9.4687 26.8547,9.5587 26.4857,9.9007 C26.2207,10.1417 26.0987,10.4697 26.0217,10.7907 C25.9497,11.1087 25.8627,11.6977 26.3987,11.9057 C26.5687,11.9777 26.7237,11.9987 26.8767,11.9907 C27.0457,11.9847 27.1937,11.8967 27.3367,11.7747 C27.3217,11.8257 27.3107,11.8767 27.2967,11.9287 L27.3217,11.9577 C27.7077,11.9427 27.8277,11.9427 28.2447,11.9477 L28.2827,11.9147 C28.3417,11.5587 28.4027,11.2087 28.5587,10.5227 C28.6347,10.1967 28.7127,9.8717 28.7937,9.5467 L28.7817,9.5107 M27.4107,11.2907 C27.3417,11.3917 27.1717,11.4537 27.0787,11.4537 C27.0507,11.4537 26.8807,11.4537 26.8767,11.2057 C26.8747,11.0787 26.8977,10.9507 26.9297,10.8127 C27.0187,10.4157 27.1277,10.0797 27.4047,10.0797 C27.5797,10.0797 27.6667,10.2537 27.6427,10.5387 C27.6267,10.6017 27.6187,10.6597 27.6017,10.7337 C27.5717,10.8587 27.5367,10.9807 27.5067,11.1027 C27.4797,11.1767 27.4487,11.2457 27.4107,11.2907" id="Fill-33" fill="#FFFFFF"></path>\n            <path d="M22.1577,11.9106 C21.8087,11.9056 21.6947,11.9056 21.2867,11.9246 L21.2717,11.8966 C21.3087,11.7416 21.3477,11.5876 21.3827,11.4346 L21.4317,11.2266 C21.5037,10.8986 21.5797,10.5206 21.5897,10.4026 C21.5927,10.3336 21.6147,10.1606 21.4167,10.1606 C21.3367,10.1606 21.2457,10.1996 21.1567,10.2416 C21.1117,10.4136 21.0117,10.9026 20.9637,11.1246 C20.8677,11.5956 20.8597,11.6496 20.8157,11.8796 L20.7837,11.9106 C20.4287,11.9056 20.3077,11.9056 19.8967,11.9246 L19.8777,11.8926 C19.9477,11.6086 20.0137,11.3326 20.0777,11.0526 C20.2507,10.2976 20.2907,10.0106 20.3407,9.6276 L20.3727,9.6006 C20.7727,9.5466 20.8677,9.5326 21.3027,9.4436 L21.3367,9.4836 L21.2717,9.7266 C21.3407,9.6846 21.4147,9.6406 21.4887,9.6006 C21.6927,9.5026 21.9187,9.4706 22.0427,9.4706 C22.2317,9.4706 22.4397,9.5256 22.5257,9.7426 C22.6087,9.9376 22.5547,10.1786 22.4457,10.6526 L22.3907,10.8916 C22.2787,11.4216 22.2607,11.5196 22.1987,11.8796 L22.1577,11.9106" id="Fill-35" fill="#FFFFFF"></path>\n            <path d="M25.1504,7.7729 L24.8644,7.7789 C24.1174,7.7889 23.8204,7.7859 23.6934,7.7679 C23.6834,7.8229 23.6634,7.9199 23.6634,7.9199 L23.3994,9.1629 C23.3994,9.1629 22.7584,11.7979 22.7284,11.9239 C23.3774,11.9119 23.6474,11.9119 23.7574,11.9259 C23.7834,11.8019 23.9354,11.0669 23.9374,11.0629 C23.9374,11.0629 24.0654,10.5229 24.0744,10.5089 C24.0744,10.5089 24.1104,10.4499 24.1544,10.4269 L24.2154,10.4269 C24.7754,10.4269 25.4114,10.4269 25.9104,10.0589 C26.2474,9.8139 26.4764,9.4389 26.5834,8.9909 C26.6084,8.8799 26.6294,8.7489 26.6294,8.6159 C26.6294,8.4449 26.5944,8.2749 26.4944,8.1349 C26.2434,7.7809 25.7364,7.7789 25.1504,7.7729 M25.5254,9.0659 C25.4634,9.3409 25.2884,9.5699 25.0564,9.6849 C24.8664,9.7799 24.6384,9.7869 24.3974,9.7869 L24.2404,9.7869 L24.2554,9.7249 C24.2554,9.7249 24.5394,8.4899 24.5394,8.4919 L24.5454,8.4289 L24.5514,8.3809 L24.6664,8.3889 C24.6664,8.3889 25.2534,8.4409 25.2664,8.4449 C25.4964,8.5349 25.5934,8.7639 25.5254,9.0659" id="Fill-37" fill="#FFFFFF"></path>\n            <path d="M17.0757,9.7915 C17.3027,9.6335 17.3337,9.4145 17.1407,9.2965 C16.9457,9.1865 16.6047,9.2195 16.3747,9.3795 C16.1427,9.5355 16.1177,9.7565 16.3117,9.8725 C16.5047,9.9865 16.8457,9.9485 17.0757,9.7915" id="Fill-39" fill="#FFFFFF"></path>\n            <path d="M31.6587,9.5098 L31.6217,9.4688 C31.1967,9.5568 31.1197,9.5698 30.7267,9.6218 L30.6967,9.6478 C30.6967,9.6548 30.6967,9.6628 30.6957,9.6688 L30.6927,9.6628 C30.3997,10.3378 30.4117,10.1908 30.1737,10.7218 C30.1707,10.6958 30.1707,10.6768 30.1707,10.6558 L30.1107,9.5098 L30.0747,9.4688 C29.6287,9.5568 29.6167,9.5698 29.2057,9.6218 L29.1727,9.6478 C29.1687,9.6668 29.1667,9.6788 29.1637,9.6958 L29.1687,9.7008 C29.2187,9.9658 29.2067,9.9058 29.2597,10.3208 C29.2817,10.5228 29.3147,10.7308 29.3377,10.9338 C29.3807,11.2698 29.4037,11.4368 29.4507,11.9478 C29.1727,12.4128 29.1077,12.5858 28.8417,12.9888 L28.6527,13.2908 C28.6307,13.3238 28.6117,13.3418 28.5827,13.3548 C28.5547,13.3668 28.5127,13.3738 28.4587,13.3738 L28.3167,13.3738 L28.1927,13.9118 L28.7297,13.9018 C29.0437,13.9018 29.2417,13.7458 29.3477,13.5498 L29.6807,12.9768 L31.6587,9.5098" id="Fill-41" fill="#FFFFFF"></path>\n        </g>\n    </g>\n</svg>', 
        _cardLogos);
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return FUNDING_PRIORITY;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return FUNDING_ORDER;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return FUNDING_CONFIG;
        }));
        __webpack_require__.d(__webpack_exports__, "e", (function() {
            return getFundingConfig;
        }));
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return getCardConfig;
        }));
        var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
        var _FUNDING_CONFIG, _CARD_CONFIG;
        var FUNDING_PRIORITY = [ _constants__WEBPACK_IMPORTED_MODULE_0__.v.PAYPAL, _constants__WEBPACK_IMPORTED_MODULE_0__.v.VENMO, _constants__WEBPACK_IMPORTED_MODULE_0__.v.ITAU, _constants__WEBPACK_IMPORTED_MODULE_0__.v.CREDIT, _constants__WEBPACK_IMPORTED_MODULE_0__.v.CARD, _constants__WEBPACK_IMPORTED_MODULE_0__.v.IDEAL, _constants__WEBPACK_IMPORTED_MODULE_0__.v.ELV, _constants__WEBPACK_IMPORTED_MODULE_0__.v.BANCONTACT, _constants__WEBPACK_IMPORTED_MODULE_0__.v.GIROPAY, _constants__WEBPACK_IMPORTED_MODULE_0__.v.EPS, _constants__WEBPACK_IMPORTED_MODULE_0__.v.SOFORT, _constants__WEBPACK_IMPORTED_MODULE_0__.v.MYBANK, _constants__WEBPACK_IMPORTED_MODULE_0__.v.BLIK, _constants__WEBPACK_IMPORTED_MODULE_0__.v.P24, _constants__WEBPACK_IMPORTED_MODULE_0__.v.MAXIMA, _constants__WEBPACK_IMPORTED_MODULE_0__.v.BOLETO, _constants__WEBPACK_IMPORTED_MODULE_0__.v.OXXO, _constants__WEBPACK_IMPORTED_MODULE_0__.v.MERCADOPAGO ];
        var FUNDING_ORDER = [ _constants__WEBPACK_IMPORTED_MODULE_0__.v.PAYPAL, _constants__WEBPACK_IMPORTED_MODULE_0__.v.VENMO, _constants__WEBPACK_IMPORTED_MODULE_0__.v.ITAU, _constants__WEBPACK_IMPORTED_MODULE_0__.v.CREDIT, _constants__WEBPACK_IMPORTED_MODULE_0__.v.IDEAL, _constants__WEBPACK_IMPORTED_MODULE_0__.v.ELV, _constants__WEBPACK_IMPORTED_MODULE_0__.v.BANCONTACT, _constants__WEBPACK_IMPORTED_MODULE_0__.v.GIROPAY, _constants__WEBPACK_IMPORTED_MODULE_0__.v.EPS, _constants__WEBPACK_IMPORTED_MODULE_0__.v.SOFORT, _constants__WEBPACK_IMPORTED_MODULE_0__.v.MYBANK, _constants__WEBPACK_IMPORTED_MODULE_0__.v.BLIK, _constants__WEBPACK_IMPORTED_MODULE_0__.v.P24, _constants__WEBPACK_IMPORTED_MODULE_0__.v.MAXIMA, _constants__WEBPACK_IMPORTED_MODULE_0__.v.BOLETO, _constants__WEBPACK_IMPORTED_MODULE_0__.v.OXXO, _constants__WEBPACK_IMPORTED_MODULE_0__.v.MERCADOPAGO, _constants__WEBPACK_IMPORTED_MODULE_0__.v.CARD ];
        var FUNDING_CONFIG = ((_FUNDING_CONFIG = {})[_constants__WEBPACK_IMPORTED_MODULE_0__.s] = {
            enabled: !0,
            allowOptIn: !0,
            allowOptOut: !0,
            allowRemember: !0,
            allowHorizontal: !0,
            allowVertical: !0,
            requireCommitAsTrue: !1
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.PAYPAL] = {
            default: !0,
            allowOptIn: !1,
            allowOptOut: !1,
            allowHorizontal: !0,
            allowVertical: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.CARD] = {
            default: "undefined" == typeof __paypal_checkout__ || __paypal_checkout__.serverConfig.paypalMerchantConfiguration.creditCard.isPayPalBranded,
            allowHorizontal: !1,
            allowVertical: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.VENMO] = {
            allowOptOut: !0,
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.US ],
            allowHorizontal: !0,
            allowVertical: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.ITAU] = {
            allowOptOut: !0,
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.BR ],
            allowHorizontal: !0,
            allowVertical: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.CREDIT] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.US, _constants__WEBPACK_IMPORTED_MODULE_0__.r.GB, _constants__WEBPACK_IMPORTED_MODULE_0__.r.DE ],
            defaultVerticalCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.US ],
            platforms: [ _constants__WEBPACK_IMPORTED_MODULE_0__.D.MOBILE ],
            allowHorizontal: !0,
            allowVertical: !0,
            allowRemember: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.IDEAL] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.NL ],
            allowHorizontal: !1,
            allowVertical: !0,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.ELV] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.DE ],
            defaultVerticalCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.DE ],
            allowHorizontal: !1,
            allowVertical: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.BANCONTACT] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.BE ],
            allowHorizontal: !1,
            allowVertical: !0,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.GIROPAY] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.DE ],
            allowHorizontal: !1,
            allowVertical: !0,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.SOFORT] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.DE, _constants__WEBPACK_IMPORTED_MODULE_0__.r.AT, _constants__WEBPACK_IMPORTED_MODULE_0__.r.BE, _constants__WEBPACK_IMPORTED_MODULE_0__.r.ES, _constants__WEBPACK_IMPORTED_MODULE_0__.r.IT, _constants__WEBPACK_IMPORTED_MODULE_0__.r.NL ],
            allowHorizontal: !1,
            allowVertical: !0,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.EPS] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.AT ],
            allowHorizontal: !1,
            allowVertical: !0,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.MYBANK] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.IT ],
            allowHorizontal: !1,
            allowVertical: !0,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.P24] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.PL ],
            allowHorizontal: !1,
            allowVertical: !0,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.BLIK] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.PL ],
            allowHorizontal: !1,
            allowVertical: !0,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.MAXIMA] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.LT ],
            allowedEnvs: [ _constants__WEBPACK_IMPORTED_MODULE_0__.t.LOCAL, _constants__WEBPACK_IMPORTED_MODULE_0__.t.STAGE, _constants__WEBPACK_IMPORTED_MODULE_0__.t.TEST ],
            allowHorizontal: !1,
            allowVertical: !0,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.BOLETO] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.BR ],
            allowedEnvs: [ _constants__WEBPACK_IMPORTED_MODULE_0__.t.LOCAL, _constants__WEBPACK_IMPORTED_MODULE_0__.t.STAGE, _constants__WEBPACK_IMPORTED_MODULE_0__.t.TEST ],
            allowHorizontal: !1,
            allowVertical: !0,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.OXXO] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.MX ],
            allowedEnvs: [ _constants__WEBPACK_IMPORTED_MODULE_0__.t.LOCAL, _constants__WEBPACK_IMPORTED_MODULE_0__.t.STAGE, _constants__WEBPACK_IMPORTED_MODULE_0__.t.TEST ],
            allowHorizontal: !1,
            allowVertical: !0,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.MERCADOPAGO] = {
            allowedCountries: [ _constants__WEBPACK_IMPORTED_MODULE_0__.r.MX, _constants__WEBPACK_IMPORTED_MODULE_0__.r.BR ],
            allowedEnvs: [ _constants__WEBPACK_IMPORTED_MODULE_0__.t.LOCAL, _constants__WEBPACK_IMPORTED_MODULE_0__.t.STAGE, _constants__WEBPACK_IMPORTED_MODULE_0__.t.TEST ],
            allowHorizontal: !1,
            allowVertical: !0,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.v.ZIMPLER] = {
            allowedCountries: [],
            allowHorizontal: !1,
            allowVertical: !1,
            requireCommitAsTrue: !0
        }, _FUNDING_CONFIG);
        var CARD_CONFIG = ((_CARD_CONFIG = {})[_constants__WEBPACK_IMPORTED_MODULE_0__.s] = {
            priority: [ _constants__WEBPACK_IMPORTED_MODULE_0__.o.VISA, _constants__WEBPACK_IMPORTED_MODULE_0__.o.MASTERCARD, _constants__WEBPACK_IMPORTED_MODULE_0__.o.AMEX ]
        }, _CARD_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.r.GB] = {
            priority: [ _constants__WEBPACK_IMPORTED_MODULE_0__.o.VISA, _constants__WEBPACK_IMPORTED_MODULE_0__.o.MASTERCARD, _constants__WEBPACK_IMPORTED_MODULE_0__.o.AMEX, _constants__WEBPACK_IMPORTED_MODULE_0__.o.DISCOVER, _constants__WEBPACK_IMPORTED_MODULE_0__.o.MAESTRO ]
        }, _CARD_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.r.US] = {
            priority: [ _constants__WEBPACK_IMPORTED_MODULE_0__.o.VISA, _constants__WEBPACK_IMPORTED_MODULE_0__.o.MASTERCARD, _constants__WEBPACK_IMPORTED_MODULE_0__.o.AMEX, _constants__WEBPACK_IMPORTED_MODULE_0__.o.DISCOVER ]
        }, _CARD_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.r.BR] = {
            priority: [ _constants__WEBPACK_IMPORTED_MODULE_0__.o.VISA, _constants__WEBPACK_IMPORTED_MODULE_0__.o.MASTERCARD, _constants__WEBPACK_IMPORTED_MODULE_0__.o.AMEX, _constants__WEBPACK_IMPORTED_MODULE_0__.o.HIPER, _constants__WEBPACK_IMPORTED_MODULE_0__.o.ELO ]
        }, _CARD_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.r.JP] = {
            priority: [ _constants__WEBPACK_IMPORTED_MODULE_0__.o.VISA, _constants__WEBPACK_IMPORTED_MODULE_0__.o.MASTERCARD, _constants__WEBPACK_IMPORTED_MODULE_0__.o.AMEX, _constants__WEBPACK_IMPORTED_MODULE_0__.o.JCB ]
        }, _CARD_CONFIG[_constants__WEBPACK_IMPORTED_MODULE_0__.r.CN] = {
            priority: [ _constants__WEBPACK_IMPORTED_MODULE_0__.o.VISA, _constants__WEBPACK_IMPORTED_MODULE_0__.o.MASTERCARD, _constants__WEBPACK_IMPORTED_MODULE_0__.o.AMEX, _constants__WEBPACK_IMPORTED_MODULE_0__.o.CUP ]
        }, _CARD_CONFIG);
        function getConfig(conf, category, key, def) {
            var categoryConfig = conf[category];
            if (categoryConfig && categoryConfig.hasOwnProperty(key)) return categoryConfig[key];
            if (conf[_constants__WEBPACK_IMPORTED_MODULE_0__.s] && conf[_constants__WEBPACK_IMPORTED_MODULE_0__.s].hasOwnProperty(key)) return conf[_constants__WEBPACK_IMPORTED_MODULE_0__.s][key];
            if (arguments.length >= 4) return def;
            throw new Error("No value found for " + category + ":" + key);
        }
        function getFundingConfig(source, key, def) {
            return getConfig(FUNDING_CONFIG, source, key, def);
        }
        function getCardConfig(source, key, def) {
            return getConfig(CARD_CONFIG, source, key, def);
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return _inheritsLoose;
        }));
        var _babel_runtime_helpers_esm_setPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30);
        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            Object(_babel_runtime_helpers_esm_setPrototypeOf__WEBPACK_IMPORTED_MODULE_0__.a)(subClass, superClass);
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return create;
        }));
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return interface_destroyAll;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return src_error.b;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return CONSTANTS;
        }));
        var interface_namespaceObject = {};
        __webpack_require__.r(interface_namespaceObject);
        __webpack_require__.d(interface_namespaceObject, "create", (function() {
            return create;
        }));
        __webpack_require__.d(interface_namespaceObject, "getByTag", (function() {
            return getByTag;
        }));
        __webpack_require__.d(interface_namespaceObject, "getCurrentScriptDir", (function() {
            return lib.t;
        }));
        __webpack_require__.d(interface_namespaceObject, "destroyAll", (function() {
            return interface_destroyAll;
        }));
        __webpack_require__.d(interface_namespaceObject, "postRobot", (function() {
            return postRobot;
        }));
        __webpack_require__.d(interface_namespaceObject, "PopupOpenError", (function() {
            return src_error.b;
        }));
        __webpack_require__.d(interface_namespaceObject, "IntegrationError", (function() {
            return src_error.a;
        }));
        __webpack_require__.d(interface_namespaceObject, "RenderError", (function() {
            return src_error.c;
        }));
        __webpack_require__.d(interface_namespaceObject, "CONSTANTS", (function() {
            return CONSTANTS;
        }));
        var src = __webpack_require__(15);
        var assertThisInitialized = __webpack_require__(24);
        var inheritsLoose = __webpack_require__(21);
        function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
            var desc = {};
            Object.keys(descriptor).forEach((function(key) {
                desc[key] = descriptor[key];
            }));
            desc.enumerable = !!desc.enumerable;
            desc.configurable = !!desc.configurable;
            ("value" in desc || desc.initializer) && (desc.writable = !0);
            desc = decorators.slice().reverse().reduce((function(desc, decorator) {
                return decorator(target, property, desc) || desc;
            }), desc);
            if (context && void 0 !== desc.initializer) {
                desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
                desc.initializer = void 0;
            }
            if (void 0 === desc.initializer) {
                Object.defineProperty(target, property, desc);
                desc = null;
            }
            return desc;
        }
        var zalgo_promise_src = __webpack_require__(2);
        var cross_domain_utils_src = __webpack_require__(7);
        var lib = __webpack_require__(6);
        var base_BaseComponent = function() {
            function BaseComponent() {
                this.clean = void 0;
                this.event = void 0;
                this.component = void 0;
                this.clean = (obj = this, tasks = [], cleaned = !1, {
                    set: function(name, item) {
                        if (cleaned) return item;
                        obj[name] = item;
                        this.register((function() {
                            delete obj[name];
                        }));
                        return item;
                    },
                    register: function(name, method) {
                        if ("function" == typeof name) {
                            method = name;
                            name = "<anonymous-cleanup-handler>";
                        }
                        if ("function" != typeof method) throw new TypeError("Expected to be passed function to clean.register");
                        cleaned ? method() : tasks.push({
                            complete: !1,
                            name: name,
                            run: function() {
                                if (!this.complete) {
                                    this.complete = !0;
                                    method && method();
                                }
                            }
                        });
                    },
                    hasTasks: function() {
                        return Boolean(tasks.filter((function(item) {
                            return !item.complete;
                        })).length);
                    },
                    all: function() {
                        var results = [];
                        cleaned = !0;
                        for (;tasks.length; ) results.push(tasks.pop().run());
                        return zalgo_promise_src.a.all(results).then((function() {}));
                    },
                    run: function(name) {
                        var results = [];
                        for (var _i2 = 0; _i2 < tasks.length; _i2++) {
                            var item = tasks[_i2];
                            item.name === name && results.push(item.run());
                        }
                        return zalgo_promise_src.a.all(results).then(lib.F);
                    }
                });
                var obj, tasks, cleaned;
                this.event = Object(lib.p)();
            }
            var _proto = BaseComponent.prototype;
            _proto.addProp = function(options, name, def) {
                Object(lib.g)(options, this, name, def);
            };
            _proto.on = function(eventName, handler) {
                return this.event.on(eventName, handler);
            };
            _proto.listeners = function() {
                throw new Error("Expected listeners to be implemented");
            };
            _proto.error = function(err) {
                throw new Error("Expected error to be implemented - got " + Object(lib.S)(err));
            };
            _proto.listen = function(win, domain) {
                var _this = this;
                if (!win) throw this.component.createError("window to listen to not set");
                if (!domain) throw new Error("Must pass domain to listen to");
                if (this.listeners) {
                    var listeners = this.listeners();
                    var _loop = function(_i4, _Object$keys2) {
                        var listenerName = _Object$keys2[_i4];
                        var name = listenerName.replace(/^zoid_/, "");
                        var errorHandler = function(err) {
                            _this.error(err);
                        };
                        var listener = Object(src.on)(listenerName, {
                            window: win,
                            domain: domain,
                            errorHandler: errorHandler
                        }, (function(_ref) {
                            var source = _ref.source, data = _ref.data;
                            _this.component.log("listener_" + name);
                            return listeners[listenerName].call(_this, source, data);
                        }));
                        var errorListener = Object(src.on)(listenerName, {
                            window: win,
                            errorHandler: errorHandler
                        }, (function(_ref2) {
                            var origin = _ref2.origin;
                            _this.component.logError("unexpected_listener_" + name, {
                                origin: origin,
                                domain: domain.toString()
                            });
                            _this.error(new Error("Unexpected " + name + " message from domain " + origin + " -- expected message from " + domain.toString()));
                        }));
                        _this.clean.register((function() {
                            listener.cancel();
                            errorListener.cancel();
                        }));
                    };
                    for (var _i4 = 0, _Object$keys2 = Object.keys(listeners); _i4 < _Object$keys2.length; _i4++) _loop(_i4, _Object$keys2);
                }
            };
            return BaseComponent;
        }();
        var esm_extends = __webpack_require__(13);
        var client = __webpack_require__(5);
        var belter_src = __webpack_require__(11);
        var base32 = __webpack_require__(34);
        var base32_default = __webpack_require__.n(base32);
        var constants = __webpack_require__(8);
        function normalize(str) {
            return str.replace(/^[^a-z0-9A-Z]+|[^a-z0-9A-Z]+$/g, "").replace(/[^a-z0-9A-Z]+/g, "_");
        }
        var isZoidComponentWindow = Object(lib.D)((function() {
            return !!window.name && "xcomponent" === window.name.split("__")[0];
        }));
        var getComponentMeta = Object(lib.D)((function() {
            if (!window.name) throw new Error("Can not get component meta without window name");
            var _window$name$split2 = window.name.split("__"), zoidcomp = _window$name$split2[0], name = _window$name$split2[1], version = _window$name$split2[2], encodedOptions = _window$name$split2[3];
            if ("xcomponent" !== zoidcomp) throw new Error("Window not rendered by zoid - got " + zoidcomp);
            var componentMeta;
            try {
                componentMeta = JSON.parse(base32_default.a.decode(encodedOptions.toUpperCase()));
            } catch (err) {
                throw new Error("Can not decode component-meta: " + encodedOptions + " " + Object(lib.S)(err));
            }
            componentMeta.name = name;
            componentMeta.version = version.replace(/_/g, ".");
            return componentMeta;
        }));
        function window_getParentDomain() {
            return getComponentMeta().domain;
        }
        function getWindowByRef(_ref) {
            var ref = _ref.ref, uid = _ref.uid, distance = _ref.distance;
            var result;
            ref === constants.WINDOW_REFERENCES.OPENER ? result = Object(cross_domain_utils_src.m)(window) : ref === constants.WINDOW_REFERENCES.TOP ? result = Object(cross_domain_utils_src.o)(window) : ref === constants.WINDOW_REFERENCES.PARENT && (result = distance ? Object(cross_domain_utils_src.l)(window, distance) : Object(cross_domain_utils_src.n)(window));
            if (ref === constants.WINDOW_REFERENCES.GLOBAL) {
                var ancestor = Object(cross_domain_utils_src.f)(window);
                if (ancestor) for (var _i2 = 0, _getAllFramesInWindow2 = Object(cross_domain_utils_src.e)(ancestor); _i2 < _getAllFramesInWindow2.length; _i2++) {
                    var frame = _getAllFramesInWindow2[_i2];
                    var global = Object(lib.w)(frame);
                    if (global && global.windows && global.windows[uid]) {
                        result = global.windows[uid];
                        break;
                    }
                }
            }
            if (!result) throw new Error("Unable to find window by ref");
            return result;
        }
        var window_getParentComponentWindow = Object(lib.D)((function() {
            var componentMeta = getComponentMeta();
            if (!componentMeta) throw new Error("Can not get parent component window - window not rendered by zoid");
            return getWindowByRef(componentMeta.componentParent);
        }));
        var window_getParentRenderWindow = Object(lib.D)((function() {
            var componentMeta = getComponentMeta();
            if (!componentMeta) throw new Error("Can not get parent component window - window not rendered by zoid");
            return getWindowByRef(componentMeta.renderParent);
        }));
        var src_error = __webpack_require__(25);
        function normalizeChildProp(component, props, key, value) {
            var prop = component.getProp(key);
            return prop ? "function" == typeof prop.childDecorate ? prop.childDecorate(value) : value : component.looseProps ? value : void 0;
        }
        var child_ChildComponent = function(_BaseComponent) {
            Object(inheritsLoose.a)(ChildComponent, _BaseComponent);
            function ChildComponent(component) {
                var _this;
                (_this = _BaseComponent.call(this) || this).component = void 0;
                _this.props = void 0;
                _this.context = void 0;
                _this.onPropHandlers = void 0;
                _this.onInit = void 0;
                _this.watchingForResize = void 0;
                _this.autoResize = void 0;
                _this.component = component;
                if (!_this.hasValidParentDomain()) {
                    _this.error(new src_error.c("Can not be rendered by domain: " + _this.getParentDomain()));
                    return Object(assertThisInitialized.a)(_this);
                }
                _this.component.log("construct_child");
                _this.onPropHandlers = [];
                var _loop = function(_i2, _ref2) {
                    var item = _ref2[_i2];
                    var _loop2 = function(_i4, _ref4) {
                        var _ref4$_i = _ref4[_i4], name = _ref4$_i[0], getter = _ref4$_i[1];
                        Object.defineProperty(item, name, {
                            configurable: !0,
                            get: function() {
                                _this.props || _this.setProps(_this.getInitialProps(), window_getParentDomain());
                                delete item[name];
                                item[name] = getter();
                                return item[name];
                            }
                        });
                    };
                    for (var _i4 = 0, _ref4 = [ [ "xchild", function() {
                        return Object(assertThisInitialized.a)(_this);
                    } ], [ "xprops", function() {
                        return _this.props;
                    } ] ]; _i4 < _ref4.length; _i4++) _loop2(_i4, _ref4);
                };
                for (var _i2 = 0, _ref2 = [ _this.component, window ]; _i2 < _ref2.length; _i2++) _loop(_i2, _ref2);
                _this.component.log("init_child");
                _this.setWindows();
                _this.onInit = _this.sendToParent(constants.POST_MESSAGE.INIT, {
                    exports: _this.exports()
                }).then((function(_ref5) {
                    var origin = _ref5.origin, data = _ref5.data;
                    _this.context = data.context;
                    _this.setProps(data.props, origin);
                    _this.watchForResize();
                    return Object(assertThisInitialized.a)(_this);
                })).catch((function(err) {
                    _this.error(err);
                    throw err;
                }));
                return _this;
            }
            var _proto = ChildComponent.prototype;
            _proto.hasValidParentDomain = function() {
                return Object(cross_domain_utils_src.B)(this.component.allowedParentDomains, this.getParentDomain());
            };
            _proto.init = function() {
                return this.onInit;
            };
            _proto.getParentDomain = function() {
                return window_getParentDomain();
            };
            _proto.onProps = function(handler) {
                this.onPropHandlers.push(handler);
            };
            _proto.getParentComponentWindow = function() {
                return window_getParentComponentWindow();
            };
            _proto.getParentRenderWindow = function() {
                return window_getParentRenderWindow();
            };
            _proto.getInitialProps = function() {
                var _this2 = this;
                var componentMeta = getComponentMeta();
                var props = componentMeta.props;
                if (props.type === constants.INITIAL_PROPS.RAW) props = props.value; else {
                    if (props.type !== constants.INITIAL_PROPS.UID) throw new Error("Unrecognized props type: " + props.type);
                    var parentComponentWindow = window_getParentComponentWindow();
                    if (!Object(cross_domain_utils_src.v)(parentComponentWindow)) {
                        if ("file:" === window.location.protocol) throw new Error("Can not get props from file:// domain");
                        throw new Error("Parent component window is on a different domain - expected " + Object(cross_domain_utils_src.h)() + " - can not retrieve props");
                    }
                    var global = Object(lib.w)(parentComponentWindow);
                    if (!global) throw new Error("Can not find global for parent component - can not retrieve props");
                    props = JSON.parse(global.props[componentMeta.uid]);
                }
                if (!props) throw new Error("Initial props not found");
                return Object(lib.k)(props, (function(_ref6) {
                    var fullKey = _ref6.fullKey, self = _ref6.self, args = _ref6.args;
                    return _this2.onInit.then((function() {
                        var func = Object(lib.s)(_this2.props, fullKey);
                        if ("function" != typeof func) throw new TypeError("Expected " + fullKey + " to be function, got " + typeof func);
                        return func.apply(self, args);
                    }));
                }));
            };
            _proto.setProps = function(props, origin, required) {
                void 0 === required && (required = !0);
                this.props = this.props || {};
                var normalizedProps = function(component, props, origin, required) {
                    void 0 === required && (required = !0);
                    var result = {};
                    for (var _i2 = 0, _Object$keys2 = Object.keys(props); _i2 < _Object$keys2.length; _i2++) {
                        var key = _Object$keys2[_i2];
                        var prop = component.getProp(key);
                        var value = props[key];
                        if (!prop || !prop.sameDomain || origin === Object(cross_domain_utils_src.h)(window)) {
                            result[key] = normalizeChildProp(component, 0, key, value);
                            prop && prop.alias && !result[prop.alias] && (result[prop.alias] = value);
                        }
                    }
                    if (required) for (var _i4 = 0, _component$getPropNam2 = component.getPropNames(); _i4 < _component$getPropNam2.length; _i4++) {
                        var _key = _component$getPropNam2[_i4];
                        props.hasOwnProperty(_key) || (result[_key] = normalizeChildProp(component, 0, _key, props[_key]));
                    }
                    return result;
                }(this.component, props, origin, required);
                Object(lib.q)(this.props, normalizedProps);
                this.props.logLevel && Object(lib.O)(this.props.logLevel);
                for (var _i6 = 0, _this$onPropHandlers2 = this.onPropHandlers; _i6 < _this$onPropHandlers2.length; _i6++) _this$onPropHandlers2[_i6].call(this, this.props);
            };
            _proto.sendToParent = function(name, data, options) {
                void 0 === data && (data = {});
                void 0 === options && (options = {});
                var parentWindow = window_getParentComponentWindow();
                if (!parentWindow) throw new Error("Can not find parent component window to message");
                this.component.log("send_to_parent_" + name);
                return Object(src.send)(parentWindow, name, data, Object(esm_extends.a)({
                    domain: window_getParentDomain()
                }, options));
            };
            _proto.setWindows = function() {
                if (window.__activeZoidComponent__) throw this.component.createError("Can not attach multiple components to the same window");
                window.__activeZoidComponent__ = this;
                if (!window_getParentComponentWindow()) throw this.component.createError("Can not find parent window");
                var componentMeta = getComponentMeta();
                if (componentMeta.tag !== this.component.tag) throw this.component.createError("Parent is " + componentMeta.tag + " - can not attach " + this.component.tag);
                this.watchForClose();
            };
            _proto.watchForClose = function() {
                var _this3 = this;
                window.addEventListener("unload", (function() {
                    return _this3.checkClose();
                }));
            };
            _proto.enableAutoResize = function(_temp) {
                var _ref7 = void 0 === _temp ? {} : _temp, _ref7$width = _ref7.width, _ref7$height = _ref7.height;
                this.autoResize = {
                    width: void 0 === _ref7$width || _ref7$width,
                    height: void 0 === _ref7$height || _ref7$height
                };
                this.watchForResize();
            };
            _proto.getAutoResize = function() {
                var width = !1;
                var height = !1;
                var autoResize = this.autoResize || this.component.autoResize;
                if ("object" == typeof autoResize) {
                    width = Boolean(autoResize.width);
                    height = Boolean(autoResize.height);
                } else if (autoResize) {
                    width = !0;
                    height = !0;
                }
                return {
                    width: width,
                    height: height,
                    element: autoResize.element ? Object(lib.u)(autoResize.element) : document.body
                };
            };
            _proto.watchForResize = function() {
                var _this4 = this;
                var _this$getAutoResize = this.getAutoResize(), width = _this$getAutoResize.width, height = _this$getAutoResize.height, element = _this$getAutoResize.element;
                if ((width || height) && this.context !== constants.CONTEXT_TYPES.POPUP && !this.watchingForResize) {
                    this.watchingForResize = !0;
                    Object(belter_src.r)(element, (function(_ref8) {
                        _this4.resize(width ? _ref8.width : void 0, height ? _ref8.height : void 0);
                    }), {
                        width: width,
                        height: height
                    });
                }
            };
            _proto.exports = function() {
                var self = this;
                return {
                    updateProps: function(props) {
                        var _this5 = this;
                        return zalgo_promise_src.a.try((function() {
                            return self.setProps(props, _this5.origin, !1);
                        }));
                    },
                    close: function() {
                        return zalgo_promise_src.a.try((function() {
                            return self.destroy();
                        }));
                    }
                };
            };
            _proto.resize = function(width, height) {
                var _this6 = this;
                return zalgo_promise_src.a.resolve().then((function() {
                    _this6.component.log("resize", {
                        width: Object(lib.R)(width),
                        height: Object(lib.R)(height)
                    });
                    if (_this6.context !== constants.CONTEXT_TYPES.POPUP) return _this6.sendToParent(constants.POST_MESSAGE.RESIZE, {
                        width: width,
                        height: height
                    }).then(lib.F);
                }));
            };
            _proto.hide = function() {
                return this.sendToParent(constants.POST_MESSAGE.HIDE).then(lib.F);
            };
            _proto.show = function() {
                return this.sendToParent(constants.POST_MESSAGE.SHOW).then(lib.F);
            };
            _proto.userClose = function() {
                return this.close(constants.CLOSE_REASONS.USER_CLOSED);
            };
            _proto.close = function(reason) {
                void 0 === reason && (reason = constants.CLOSE_REASONS.CHILD_CALL);
                this.component.log("close_child");
                this.sendToParent(constants.POST_MESSAGE.CLOSE, {
                    reason: reason
                });
            };
            _proto.checkClose = function() {
                this.sendToParent(constants.POST_MESSAGE.CHECK_CLOSE, {}, {
                    fireAndForget: !0
                });
            };
            _proto.destroy = function() {
                return Object(client.h)().then((function() {
                    window.close();
                }));
            };
            _proto.focus = function() {
                this.component.log("focus");
                window.focus();
            };
            _proto.error = function(err) {
                var stringifiedError = Object(lib.S)(err);
                this.component.logError("error", {
                    error: stringifiedError
                });
                return this.sendToParent(constants.POST_MESSAGE.ERROR, {
                    error: stringifiedError
                }).then(lib.F);
            };
            return ChildComponent;
        }(base_BaseComponent);
        function _defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || !1;
                descriptor.configurable = !0;
                "value" in descriptor && (descriptor.writable = !0);
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }
        function _createClass(Constructor, protoProps, staticProps) {
            protoProps && _defineProperties(Constructor.prototype, protoProps);
            staticProps && _defineProperties(Constructor, staticProps);
            return Constructor;
        }
        var RENDER_DRIVERS = {};
        RENDER_DRIVERS[constants.CONTEXT_TYPES.IFRAME] = {
            focusable: !1,
            renderedIntoContainerTemplate: !0,
            allowResize: !0,
            openOnClick: !1,
            needsBridge: !1,
            open: function(url) {
                var _this = this;
                var attributes = this.component.attributes.iframe || {};
                this.iframe = Object(lib.y)({
                    url: url,
                    attributes: Object(esm_extends.a)({
                        name: this.childWindowName,
                        title: this.component.name,
                        scrolling: this.component.scrolling ? "yes" : "no"
                    }, attributes),
                    class: [ constants.CLASS_NAMES.COMPONENT_FRAME, constants.CLASS_NAMES.INVISIBLE ]
                }, this.element);
                return Object(lib.f)(this.iframe).then((function(frameWindow) {
                    _this.window = frameWindow;
                    var detectClose = function() {
                        return zalgo_promise_src.a.try((function() {
                            return _this.props.onClose(constants.CLOSE_REASONS.CLOSE_DETECTED);
                        })).finally((function() {
                            return _this.destroy();
                        }));
                    };
                    var iframeWatcher = Object(lib.W)(_this.iframe, detectClose);
                    var elementWatcher = Object(lib.W)(_this.element, detectClose);
                    _this.clean.register("destroyWindow", (function() {
                        iframeWatcher.cancel();
                        elementWatcher.cancel();
                        Object(src.cleanUpWindow)(_this.window);
                        delete _this.window;
                        if (_this.iframe) {
                            Object(lib.l)(_this.iframe);
                            delete _this.iframe;
                        }
                    }));
                }));
            },
            openPrerender: function() {
                var _this2 = this;
                var attributes = this.component.attributes.iframe || {};
                this.prerenderIframe = Object(lib.y)({
                    attributes: Object(esm_extends.a)({
                        name: "__prerender__" + this.childWindowName,
                        scrolling: this.component.scrolling ? "yes" : "no"
                    }, attributes),
                    class: [ constants.CLASS_NAMES.PRERENDER_FRAME, constants.CLASS_NAMES.VISIBLE ]
                }, this.element);
                return Object(lib.f)(this.prerenderIframe).then((function(prerenderFrameWindow) {
                    _this2.prerenderWindow = prerenderFrameWindow;
                    _this2.clean.register("destroyPrerender", (function() {
                        if (_this2.prerenderIframe) {
                            Object(lib.l)(_this2.prerenderIframe);
                            delete _this2.prerenderIframe;
                        }
                    }));
                }));
            },
            switchPrerender: function() {
                var _this3 = this;
                Object(lib.a)(this.prerenderIframe, constants.CLASS_NAMES.INVISIBLE);
                Object(lib.L)(this.prerenderIframe, constants.CLASS_NAMES.VISIBLE);
                Object(lib.a)(this.iframe, constants.CLASS_NAMES.VISIBLE);
                Object(lib.L)(this.iframe, constants.CLASS_NAMES.INVISIBLE);
                setTimeout((function() {
                    _this3.prerenderIframe && Object(lib.l)(_this3.prerenderIframe);
                }), 1e3);
            },
            delegateOverrides: {
                openContainer: constants.DELEGATE.CALL_DELEGATE,
                destroyComponent: constants.DELEGATE.CALL_DELEGATE,
                destroyContainer: constants.DELEGATE.CALL_DELEGATE,
                cancelContainerEvents: constants.DELEGATE.CALL_DELEGATE,
                createPrerenderTemplate: constants.DELEGATE.CALL_DELEGATE,
                elementReady: constants.DELEGATE.CALL_DELEGATE,
                showContainer: constants.DELEGATE.CALL_DELEGATE,
                showComponent: constants.DELEGATE.CALL_DELEGATE,
                hideContainer: constants.DELEGATE.CALL_DELEGATE,
                hideComponent: constants.DELEGATE.CALL_DELEGATE,
                hide: constants.DELEGATE.CALL_DELEGATE,
                show: constants.DELEGATE.CALL_DELEGATE,
                resize: constants.DELEGATE.CALL_DELEGATE,
                loadUrl: constants.DELEGATE.CALL_DELEGATE,
                hijackSubmit: constants.DELEGATE.CALL_DELEGATE,
                openPrerender: constants.DELEGATE.CALL_DELEGATE,
                switchPrerender: constants.DELEGATE.CALL_DELEGATE,
                renderTemplate: constants.DELEGATE.CALL_ORIGINAL,
                openContainerFrame: constants.DELEGATE.CALL_ORIGINAL,
                getOutlet: constants.DELEGATE.CALL_ORIGINAL,
                open: function(original, override) {
                    return function() {
                        var _this4 = this;
                        return override.apply(this, arguments).then((function() {
                            _this4.clean.set("window", Object(cross_domain_utils_src.c)(window_getParentComponentWindow(), _this4.childWindowName));
                            if (!_this4.window) throw new Error("Unable to find parent component iframe window");
                        }));
                    };
                }
            },
            resize: function(width, height) {
                if (width) {
                    this.container.style.width = Object(lib.T)(width);
                    this.element.style.width = Object(lib.T)(width);
                }
                if (height) {
                    this.container.style.height = Object(lib.T)(height);
                    this.element.style.height = Object(lib.T)(height);
                }
            },
            show: function() {
                Object(lib.Q)(this.element);
            },
            hide: function() {
                Object(lib.x)(this.element);
            },
            loadUrl: function(url) {
                this.iframe.setAttribute("src", url);
            }
        };
        RENDER_DRIVERS[constants.CONTEXT_TYPES.POPUP] = {
            focusable: !0,
            renderedIntoContainerTemplate: !1,
            allowResize: !1,
            openOnClick: !0,
            needsBridge: !0,
            open: function(url) {
                var _this5 = this;
                void 0 === url && (url = "");
                return zalgo_promise_src.a.try((function() {
                    var _ref = _this5.component.dimensions || {}, _ref$width = _ref.width, width = void 0 === _ref$width ? constants.DEFAULT_DIMENSIONS.WIDTH : _ref$width, _ref$height = _ref.height, height = void 0 === _ref$height ? constants.DEFAULT_DIMENSIONS.HEIGHT : _ref$height;
                    var _getPosition = function(_ref2) {
                        var width = _ref2.width, height = _ref2.height;
                        var x = 0;
                        var y = 0;
                        width && (window.outerWidth ? x = Math.round((window.outerWidth - width) / 2) + window.screenX : window.screen.width && (x = Math.round((window.screen.width - width) / 2)));
                        height && (window.outerHeight ? y = Math.round((window.outerHeight - height) / 2) + window.screenY : window.screen.height && (y = Math.round((window.screen.height - height) / 2)));
                        return {
                            x: x,
                            y: y
                        };
                    }({
                        width: width = Object(lib.G)(width, window.outerWidth),
                        height: height = Object(lib.G)(height, window.outerWidth)
                    }), x = _getPosition.x, y = _getPosition.y;
                    var attributes = _this5.component.attributes.popup || {};
                    _this5.window = Object(lib.I)(url || "", Object(esm_extends.a)({
                        name: _this5.childWindowName,
                        width: width,
                        height: height,
                        top: y,
                        left: x,
                        status: 1,
                        toolbar: 0,
                        menubar: 0,
                        resizable: 1,
                        scrollbars: 1
                    }, attributes));
                    _this5.prerenderWindow = _this5.window;
                    _this5.clean.register("destroyWindow", (function() {
                        if (_this5.window) {
                            _this5.window.close();
                            Object(src.cleanUpWindow)(_this5.window);
                            delete _this5.window;
                            delete _this5.prerenderWindow;
                        }
                    }));
                    _this5.resize(width, height);
                }));
            },
            openPrerender: function() {
                return zalgo_promise_src.a.try(lib.F);
            },
            resize: function() {},
            hide: function() {
                throw new Error("Can not hide popup");
            },
            show: function() {
                throw new Error("Can not show popup");
            },
            delegateOverrides: {
                openContainer: constants.DELEGATE.CALL_DELEGATE,
                destroyContainer: constants.DELEGATE.CALL_DELEGATE,
                elementReady: constants.DELEGATE.CALL_DELEGATE,
                showContainer: constants.DELEGATE.CALL_DELEGATE,
                showComponent: constants.DELEGATE.CALL_DELEGATE,
                hideContainer: constants.DELEGATE.CALL_DELEGATE,
                hideComponent: constants.DELEGATE.CALL_DELEGATE,
                hide: constants.DELEGATE.CALL_DELEGATE,
                show: constants.DELEGATE.CALL_DELEGATE,
                cancelContainerEvents: constants.DELEGATE.CALL_DELEGATE,
                open: constants.DELEGATE.CALL_ORIGINAL,
                loadUrl: constants.DELEGATE.CALL_ORIGINAL,
                createPrerenderTemplate: constants.DELEGATE.CALL_ORIGINAL,
                destroyComponent: constants.DELEGATE.CALL_ORIGINAL,
                resize: constants.DELEGATE.CALL_ORIGINAL,
                renderTemplate: constants.DELEGATE.CALL_ORIGINAL,
                openContainerFrame: constants.DELEGATE.CALL_ORIGINAL,
                getOutlet: constants.DELEGATE.CALL_ORIGINAL
            },
            loadUrl: function(url) {
                if (Object(cross_domain_utils_src.v)(this.window)) try {
                    if (this.window.location && this.window.location.replace) {
                        this.window.location.replace(url);
                        return;
                    }
                } catch (err) {}
                this.window.location = url;
            }
        };
        function validateProp(prop, key, value, props, required) {
            void 0 === required && (required = !0);
            if (null != value && "" !== value) {
                if (!value || "function" != typeof value.then || !prop.promise) {
                    if ("function" === prop.type) {
                        if ("function" != typeof value) throw new TypeError("Prop is not of type function: " + key);
                    } else if ("string" === prop.type) {
                        if ("string" != typeof value) throw new TypeError("Prop is not of type string: " + key);
                    } else if ("object" === prop.type) {
                        if (!1 !== prop.sendToChild) try {
                            JSON.stringify(value);
                        } catch (err) {
                            throw new Error("Unable to serialize prop: " + key);
                        }
                    } else if ("number" === prop.type && isNaN(parseInt(value, 10))) throw new TypeError("Prop is not a number: " + key);
                    "function" == typeof prop.validate && value && prop.validate(value, props);
                }
            } else if (required && !1 !== prop.required && !prop.hasOwnProperty("def")) throw new Error("Prop is required: " + key);
        }
        function normalizeProp(component, instance, props, key, value) {
            var prop = component.getProp(key);
            var resultValue;
            !(resultValue = prop.value ? prop.value : !prop.def || props.hasOwnProperty(key) && function(value) {
                return null != value && "" !== value;
            }(value) ? value : prop.def.call(component, props)) && prop.alias && props[prop.alias] && (resultValue = props[prop.alias]);
            var decorated = !1;
            if (prop.decorate && null != resultValue) {
                resultValue = prop.decorate.call(instance, resultValue, props);
                decorated = !0;
            }
            var type = prop.type;
            if ("boolean" === type) resultValue = Boolean(resultValue); else if ("function" === type) {
                if (!resultValue && prop.noop) {
                    resultValue = lib.F;
                    !decorated && prop.decorate && (resultValue = prop.decorate.call(instance, lib.F, props));
                }
                if (resultValue && "function" == typeof resultValue) {
                    resultValue = resultValue.bind(instance);
                    prop.denodeify && (resultValue = Object(lib.j)(resultValue));
                    prop.promisify && (resultValue = Object(lib.K)(resultValue));
                    var original = resultValue;
                    resultValue = function() {
                        component.log("call_prop_" + key);
                        return original.apply(this, arguments);
                    };
                    prop.once && (resultValue = Object(lib.H)(resultValue));
                    prop.memoize && (resultValue = Object(lib.D)(resultValue));
                }
            } else "string" === type || "object" === type || "number" === type && void 0 !== resultValue && (resultValue = parseInt(resultValue, 10));
            return resultValue;
        }
        function getQueryParam(prop, key, value) {
            return zalgo_promise_src.a.try((function() {
                return "function" == typeof prop.queryParam ? prop.queryParam(value) : "string" == typeof prop.queryParam ? prop.queryParam : key;
            }));
        }
        function getQueryValue(prop, key, value) {
            return zalgo_promise_src.a.try((function() {
                return "function" == typeof prop.queryValue ? prop.queryValue(value) : value;
            }));
        }
        var _class, _class2, _temp;
        lib.v.props = lib.v.props || {};
        lib.v.windows = lib.v.windows || {};
        var parent_ParentComponent = (_applyDecoratedDescriptor((_class = (_temp = _class2 = function(_BaseComponent) {
            Object(inheritsLoose.a)(ParentComponent, _BaseComponent);
            function ParentComponent(component, context, _ref) {
                var _this;
                var props = _ref.props;
                (_this = _BaseComponent.call(this) || this).html = void 0;
                _this.context = void 0;
                _this.props = void 0;
                _this.childWindowName = void 0;
                _this.onInit = void 0;
                _this.window = void 0;
                _this.handledErrors = void 0;
                _this.container = void 0;
                _this.element = void 0;
                _this.outlet = void 0;
                _this.iframe = void 0;
                _this.prerenderIframe = void 0;
                _this.prerenderWindow = void 0;
                _this.childExports = void 0;
                _this.timeout = void 0;
                _this.component = component;
                _this.validateParentDomain();
                _this.context = context;
                try {
                    _this.setProps(props);
                } catch (err) {
                    props.onError && props.onError(err);
                    throw err;
                }
                _this.props.logLevel && Object(lib.O)(_this.props.logLevel);
                _this.childWindowName = _this.buildChildWindowName({
                    renderTo: window
                });
                _this.registerActiveComponent();
                _this.component.log("construct_parent");
                _this.watchForUnload();
                _this.onInit = new zalgo_promise_src.a;
                _this.onInit.catch((function(err) {
                    return _this.error(err);
                }));
                return _this;
            }
            var _proto = ParentComponent.prototype;
            _proto.render = function(element, loadUrl) {
                var _this2 = this;
                void 0 === loadUrl && (loadUrl = !0);
                return this.tryInit((function() {
                    _this2.component.log("render_" + _this2.context, {
                        context: _this2.context,
                        element: element,
                        loadUrl: Object(lib.R)(loadUrl)
                    });
                    var tasks = {};
                    tasks.onRender = _this2.props.onRender();
                    tasks.getDomain = _this2.getDomain();
                    tasks.elementReady = zalgo_promise_src.a.try((function() {
                        if (element) return _this2.elementReady(element);
                    }));
                    tasks.openContainer = tasks.elementReady.then((function() {
                        return _this2.openContainer(element);
                    }));
                    tasks.showContainer = tasks.openContainer.then((function() {
                        return _this2.showContainer();
                    }));
                    tasks.openPrerender = tasks.openContainer.then((function() {
                        return _this2.openPrerender();
                    }));
                    tasks.switchPrerender = zalgo_promise_src.a.all([ tasks.openPrerender, _this2.onInit ]).then((function() {
                        return _this2.switchPrerender();
                    }));
                    tasks.open = _this2.driver.openOnClick ? _this2.open() : tasks.openContainer.then((function() {
                        return _this2.open();
                    }));
                    tasks.listen = zalgo_promise_src.a.hash({
                        domain: tasks.getDomain,
                        open: tasks.open
                    }).then((function(_ref2) {
                        _this2.listen(_this2.window, _ref2.domain);
                    }));
                    tasks.watchForClose = tasks.open.then((function() {
                        return _this2.watchForClose();
                    }));
                    tasks.linkDomain = zalgo_promise_src.a.all([ tasks.getDomain, tasks.open ]).then((function(_ref3) {
                        var domain = _ref3[0];
                        if (src.bridge && "string" == typeof domain) return src.bridge.linkUrl(_this2.window, domain);
                    }));
                    if (!_this2.html) {
                        tasks.createPrerenderTemplate = tasks.openPrerender.then((function() {
                            return _this2.createPrerenderTemplate();
                        }));
                        tasks.showComponent = tasks.createPrerenderTemplate.then((function() {
                            return _this2.showComponent();
                        }));
                    }
                    tasks.openBridge = zalgo_promise_src.a.all([ tasks.getDomain, tasks.open ]).then((function(_ref4) {
                        var domain = _ref4[0];
                        return _this2.openBridge("string" == typeof domain ? domain : null);
                    }));
                    if (_this2.html) tasks.loadHTML = tasks.open.then((function() {
                        return _this2.loadHTML();
                    })); else if (loadUrl) {
                        tasks.buildUrl = _this2.buildUrl();
                        tasks.loadUrl = zalgo_promise_src.a.all([ tasks.buildUrl, tasks.open, tasks.linkDomain, tasks.listen, tasks.open, tasks.openBridge, tasks.createPrerenderTemplate ]).then((function(_ref5) {
                            return _this2.loadUrl(_ref5[0]);
                        }));
                        tasks.runTimeout = tasks.loadUrl.then((function() {
                            return _this2.runTimeout();
                        }));
                    }
                    return zalgo_promise_src.a.hash(tasks);
                })).then((function() {
                    return _this2.props.onEnter();
                })).then((function() {
                    return _this2;
                }));
            };
            _proto.getOutlet = function() {
                var outlet = document.createElement("div");
                Object(lib.a)(outlet, constants.CLASS_NAMES.OUTLET);
                return outlet;
            };
            _proto.validateParentDomain = function() {
                var domain = Object(cross_domain_utils_src.h)();
                if (!Object(cross_domain_utils_src.B)(this.component.allowedParentDomains, domain)) throw new src_error.c("Can not be rendered by domain: " + domain);
            };
            _proto.renderTo = function(win, element) {
                var _this3 = this;
                return this.tryInit((function() {
                    if (win === window) return _this3.render(element);
                    if (!Object(cross_domain_utils_src.w)(window, win)) throw new Error("Can only renderTo an adjacent frame");
                    if (element && "string" != typeof element) throw new Error("Element passed to renderTo must be a string selector, got " + typeof element + " " + element);
                    _this3.checkAllowRenderTo(win);
                    _this3.component.log("render_" + _this3.context + "_to_win", {
                        element: Object(lib.R)(element),
                        context: _this3.context
                    });
                    _this3.childWindowName = _this3.buildChildWindowName({
                        renderTo: win
                    });
                    _this3.delegate(win);
                    return _this3.render(element);
                }));
            };
            _proto.prefetch = function() {
                var _this4 = this;
                return zalgo_promise_src.a.try((function() {
                    _this4.html = _this4.buildUrl().then((function(url) {
                        return Object(lib.J)(url).then((function(html) {
                            return '\n                        <base href="' + url.split("/").slice(0, 3).join("/") + '">\n\n                        ' + html + "\n\n                        <script>\n                            if (window.history && window.history.pushState) {\n                                window.history.pushState({}, '', '/" + url.split("/").slice(3).join("/") + "');\n                            }\n                        <\/script>\n                    ";
                        }));
                    }));
                }));
            };
            _proto.loadHTML = function() {
                var _this5 = this;
                return zalgo_promise_src.a.try((function() {
                    if (!_this5.html) throw new Error("Html not prefetched");
                    return _this5.html.then((function(html) {
                        return Object(lib.Y)(_this5.window, html);
                    }));
                }));
            };
            _proto.checkAllowRenderTo = function(win) {
                if (!win) throw this.component.createError("Must pass window to renderTo");
                if (!Object(cross_domain_utils_src.v)(win)) {
                    var origin = Object(cross_domain_utils_src.h)();
                    var domain = this.component.getDomain(null, this.props.env);
                    if (!domain) throw new Error("Could not determine domain to allow remote render");
                    if (!Object(cross_domain_utils_src.B)(domain, origin)) throw new Error("Can not render remotely to " + domain.toString() + " - can only render to " + origin);
                }
            };
            _proto.registerActiveComponent = function() {
                var _this6 = this;
                ParentComponent.activeComponents.push(this);
                this.clean.register((function() {
                    ParentComponent.activeComponents.splice(ParentComponent.activeComponents.indexOf(_this6), 1);
                }));
            };
            _proto.getComponentParentRef = function() {
                if (this.component.getDomain(null, this.props.env) === Object(cross_domain_utils_src.h)(window)) {
                    var uid = Object(lib.U)();
                    lib.v.windows = lib.v.windows || {};
                    lib.v.windows[uid] = window;
                    this.clean.register((function() {
                        delete lib.v.windows[uid];
                    }));
                    return {
                        ref: constants.WINDOW_REFERENCES.GLOBAL,
                        uid: uid
                    };
                }
                return this.context === constants.CONTEXT_TYPES.POPUP ? {
                    ref: constants.WINDOW_REFERENCES.OPENER
                } : Object(cross_domain_utils_src.x)(window) ? {
                    ref: constants.WINDOW_REFERENCES.TOP
                } : {
                    ref: constants.WINDOW_REFERENCES.PARENT,
                    distance: Object(cross_domain_utils_src.g)(window)
                };
            };
            _proto.getRenderParentRef = function(renderToWindow) {
                void 0 === renderToWindow && (renderToWindow = window);
                if (renderToWindow === window) return this.getComponentParentRef();
                var uid = Object(lib.U)();
                lib.v.windows[uid] = renderToWindow;
                this.clean.register((function() {
                    delete lib.v.windows[uid];
                }));
                return {
                    ref: constants.WINDOW_REFERENCES.GLOBAL,
                    uid: uid
                };
            };
            _proto.buildChildWindowName = function(_temp2) {
                var _ref6$renderTo = (void 0 === _temp2 ? {} : _temp2).renderTo, renderTo = void 0 === _ref6$renderTo ? window : _ref6$renderTo;
                var childDomain = this.component.getDomain(null, this.props.env);
                var sameDomain = Object(cross_domain_utils_src.v)(renderTo);
                var uid = Object(lib.U)();
                var tag = this.component.tag;
                var sProps = Object(lib.N)(this.getPropsForChild());
                var componentParent = this.getComponentParentRef();
                var renderParent = this.getRenderParentRef(renderTo);
                var props = sameDomain || this.component.unsafeRenderTo ? {
                    type: constants.INITIAL_PROPS.RAW,
                    value: sProps
                } : {
                    type: constants.INITIAL_PROPS.UID,
                    uid: uid
                };
                if (props.type === constants.INITIAL_PROPS.UID) {
                    lib.v.props[uid] = JSON.stringify(sProps);
                    this.clean.register((function() {
                        delete lib.v.props[uid];
                    }));
                }
                return function(name, version, options) {
                    void 0 === options && (options = {});
                    options.id = Object(lib.U)();
                    options.domain = Object(cross_domain_utils_src.h)(window);
                    var encodedName = normalize(name);
                    var encodedVersion = normalize(version);
                    var encodedOptions = (str = JSON.stringify(options), base32_default.a.encode(str).replace(/\=/g, "").toLowerCase());
                    var str;
                    if (!encodedName) throw new Error("Invalid name: " + name + " - must contain alphanumeric characters");
                    if (!encodedVersion) throw new Error("Invalid version: " + version + " - must contain alphanumeric characters");
                    return [ "xcomponent", encodedName, encodedVersion, encodedOptions, "" ].join("__");
                }(this.component.name, this.component.version, {
                    uid: uid,
                    tag: tag,
                    componentParent: componentParent,
                    renderParent: renderParent,
                    props: props,
                    childDomain: childDomain
                });
            };
            _proto.sendToParent = function(name, data) {
                if (!window_getParentComponentWindow()) throw new Error("Can not find parent component window to message");
                this.component.log("send_to_parent_" + name);
                return Object(src.send)(window_getParentComponentWindow(), name, data, {
                    domain: window_getParentDomain()
                });
            };
            _proto.setProps = function(props, required) {
                void 0 === required && (required = !0);
                !function(component, props, required) {
                    void 0 === required && (required = !0);
                    if ((props = props || {}).env && "object" == typeof component.url && !component.url[props.env]) throw new Error("Invalid env: " + props.env);
                    for (var _i2 = 0, _component$getPropNam2 = component.getPropNames(); _i2 < _component$getPropNam2.length; _i2++) {
                        var key = _component$getPropNam2[_i2];
                        var prop = component.getProp(key);
                        if (prop.alias && props.hasOwnProperty(prop.alias)) {
                            var value = props[prop.alias];
                            delete props[prop.alias];
                            props[key] || (props[key] = value);
                        }
                    }
                    for (var _i4 = 0, _Object$keys2 = Object.keys(props); _i4 < _Object$keys2.length; _i4++) {
                        var _key = _Object$keys2[_i4];
                        var _prop = component.getProp(_key);
                        _prop && validateProp(_prop, _key, props[_key], props, required);
                    }
                    for (var _i6 = 0, _component$getPropNam4 = component.getPropNames(); _i6 < _component$getPropNam4.length; _i6++) {
                        var _key2 = _component$getPropNam4[_i6];
                        var _prop2 = component.getProp(_key2);
                        var _value2 = props[_key2];
                        _prop2 && !props.hasOwnProperty(_key2) && validateProp(_prop2, _key2, _value2, props, required);
                    }
                }(this.component, props, required);
                this.component.validate && this.component.validate(this.component, props);
                this.props = this.props || {};
                Object(lib.q)(this.props, function(component, instance, props) {
                    var result = {};
                    props = props || {};
                    for (var _i2 = 0, _Object$keys2 = Object.keys(props); _i2 < _Object$keys2.length; _i2++) {
                        var key = _Object$keys2[_i2];
                        result[key] = -1 !== component.getPropNames().indexOf(key) ? normalizeProp(component, instance, props, key, props[key]) : props[key];
                    }
                    for (var _i4 = 0, _component$getPropNam2 = component.getPropNames(); _i4 < _component$getPropNam2.length; _i4++) {
                        var _key = _component$getPropNam2[_i4];
                        if (!(props.hasOwnProperty(_key) || instance.props && instance.props.hasOwnProperty(_key))) {
                            var normalizedProp = normalizeProp(component, instance, props, _key, props[_key]);
                            void 0 !== normalizedProp && (result[_key] = normalizedProp);
                        }
                    }
                    return result;
                }(this.component, this, props));
            };
            _proto.buildUrl = function() {
                var _this7 = this;
                return zalgo_promise_src.a.all([ this.props.url, (propsDef = Object(esm_extends.a)({}, this.component.props, this.component.builtinProps), 
                props = this.props, params = {}, zalgo_promise_src.a.all(Object.keys(props).map((function(key) {
                    var prop = propsDef[key];
                    if (prop) return zalgo_promise_src.a.resolve().then((function() {
                        var value = props[key];
                        if (value && prop.queryParam) return value;
                    })).then((function(value) {
                        if (value) return zalgo_promise_src.a.all([ getQueryParam(prop, key, value), getQueryValue(prop, 0, value) ]).then((function(_ref) {
                            var queryParam = _ref[0], queryValue = _ref[1];
                            var result;
                            if ("boolean" == typeof queryValue) result = "1"; else if ("string" == typeof queryValue) result = queryValue.toString(); else {
                                if ("function" == typeof queryValue) return;
                                if ("object" == typeof queryValue && null !== queryValue) {
                                    if ("json" !== prop.serialization) {
                                        result = Object(lib.m)(queryValue, key);
                                        for (var _i6 = 0, _Object$keys4 = Object.keys(result); _i6 < _Object$keys4.length; _i6++) {
                                            var dotkey = _Object$keys4[_i6];
                                            params[dotkey] = result[dotkey];
                                        }
                                        return;
                                    }
                                    result = JSON.stringify(queryValue);
                                } else "number" == typeof queryValue && (result = queryValue.toString());
                            }
                            params[queryParam] = result;
                        }));
                    }));
                }))).then((function() {
                    Object.keys(params).forEach((function(key) {
                        params[key] = escape(params[key]);
                    }));
                    return params;
                }))) ]).then((function(_ref7) {
                    var url = _ref7[0], query = _ref7[1];
                    return url && !_this7.component.getValidDomain(url) ? url : zalgo_promise_src.a.try((function() {
                        return url || _this7.component.getUrl(_this7.props.env, _this7.props);
                    })).then((function(finalUrl) {
                        query.xcomponent = "1";
                        return Object(lib.r)(finalUrl, {
                            query: query
                        });
                    }));
                }));
                var propsDef, props, params;
            };
            _proto.getDomain = function() {
                var _this8 = this;
                return zalgo_promise_src.a.try((function() {
                    return _this8.props.url;
                })).then((function(url) {
                    return _this8.component.getDomain(url, _this8.props.env) || (_this8.component.buildUrl ? zalgo_promise_src.a.try((function() {
                        return _this8.component.buildUrl(_this8.props);
                    })).then((function(builtUrl) {
                        return _this8.component.getDomain(builtUrl, _this8.props.env);
                    })) : void 0);
                })).then((function(domain) {
                    if (!domain) throw new Error("Could not determine domain");
                    return domain;
                }));
            };
            _proto.getPropsForChild = function() {
                var result = {};
                for (var _i2 = 0, _Object$keys2 = Object.keys(this.props); _i2 < _Object$keys2.length; _i2++) {
                    var key = _Object$keys2[_i2];
                    var prop = this.component.getProp(key);
                    prop && !1 === prop.sendToChild || (result[key] = this.props[key]);
                }
                return result;
            };
            _proto.updateProps = function(props) {
                var _this9 = this;
                this.setProps(props, !1);
                return this.onInit.then((function() {
                    if (_this9.childExports) return _this9.childExports.updateProps(_this9.getPropsForChild());
                    throw new Error("Child exports were not available");
                }));
            };
            _proto.openBridge = function(domain) {
                var _this10 = this;
                return zalgo_promise_src.a.try((function() {
                    if (src.bridge && _this10.driver.needsBridge) {
                        var needsBridgeParams = {
                            win: _this10.window
                        };
                        domain && (needsBridgeParams.domain = domain);
                        var needsBridge = src.bridge.needsBridge(needsBridgeParams);
                        var bridgeUrl = _this10.component.getBridgeUrl(_this10.props.env);
                        if (bridgeUrl) {
                            bridgeUrl = Object(lib.r)(bridgeUrl, {
                                query: {
                                    version: _this10.component.version
                                }
                            });
                            var bridgeDomain = _this10.component.getBridgeDomain(_this10.props.env);
                            if (!bridgeDomain) throw new Error("Can not determine domain for bridge");
                            return needsBridge ? src.bridge.openBridge(bridgeUrl, bridgeDomain).then((function(result) {
                                if (result) return result;
                            })) : void 0;
                        }
                        if (needsBridge && domain && !src.bridge.hasBridge(domain, domain)) throw new Error("Bridge url needed to render " + _this10.context);
                    }
                }));
            };
            _proto.open = function() {
                var _this11 = this;
                return zalgo_promise_src.a.try((function() {
                    _this11.component.log("open_" + _this11.context, {
                        windowName: _this11.childWindowName
                    });
                    var win = _this11.props.win;
                    if (!win) return _this11.driver.open.call(_this11);
                    _this11.clean.set("window", win);
                    window.addEventListener("beforeunload", (function() {
                        return win.close();
                    }));
                    window.addEventListener("unload", (function() {
                        return win.close();
                    }));
                    Object(cross_domain_utils_src.b)(_this11.window).name = _this11.childWindowName;
                }));
            };
            _proto.openPrerender = function() {
                var _this12 = this;
                return zalgo_promise_src.a.try((function() {
                    if (_this12.component.prerenderTemplate) return _this12.driver.openPrerender.call(_this12);
                }));
            };
            _proto.switchPrerender = function() {
                var _this13 = this;
                return zalgo_promise_src.a.try((function() {
                    if (_this13.prerenderWindow && _this13.driver.switchPrerender) return _this13.driver.switchPrerender.call(_this13);
                }));
            };
            _proto.elementReady = function(element) {
                return Object(lib.n)(element).then(lib.F);
            };
            _proto.delegate = function(win) {
                var _this14 = this;
                this.component.log("delegate_" + this.context);
                var props = {
                    uid: this.props.uid,
                    dimensions: this.props.dimensions,
                    onClose: this.props.onClose,
                    onDisplay: this.props.onDisplay
                };
                for (var _i4 = 0, _this$component$getPr2 = this.component.getPropNames(); _i4 < _this$component$getPr2.length; _i4++) {
                    var propName = _this$component$getPr2[_i4];
                    this.component.getProp(propName).allowDelegate && (props[propName] = this.props[propName]);
                }
                var delegate = Object(src.send)(win, constants.POST_MESSAGE.DELEGATE + "_" + this.component.name, {
                    context: this.context,
                    env: this.props.env,
                    options: {
                        context: this.context,
                        childWindowName: this.childWindowName,
                        isWindowClosed: function() {
                            return Object(cross_domain_utils_src.z)(_this14.window);
                        },
                        props: props,
                        overrides: {
                            focus: function() {
                                return _this14.focus();
                            },
                            userClose: function() {
                                return _this14.userClose();
                            },
                            getDomain: function() {
                                return _this14.getDomain();
                            },
                            error: function(err) {
                                return _this14.error(err);
                            },
                            on: function(eventName, handler) {
                                return _this14.on(eventName, handler);
                            }
                        }
                    }
                }).then((function(_ref8) {
                    var data = _ref8.data;
                    _this14.clean.register(data.destroy);
                    return data;
                })).catch((function(err) {
                    throw new Error("Unable to delegate rendering. Possibly the component is not loaded in the target window.\n\n" + Object(lib.S)(err));
                }));
                var overrides = this.driver.delegateOverrides;
                var _loop = function(_i6, _Object$keys4) {
                    var key = _Object$keys4[_i6];
                    var val = overrides[key];
                    if (val === constants.DELEGATE.CALL_ORIGINAL) return "continue";
                    var original = _this14[key];
                    _this14[key] = function() {
                        var _arguments = arguments, _this15 = this;
                        return delegate.then((function(data) {
                            var override = data.overrides[key];
                            if (val === constants.DELEGATE.CALL_DELEGATE) return override.apply(_this15, _arguments);
                            if ("function" == typeof val) return val(original, override).apply(_this15, _arguments);
                            throw new Error("Expected delgate to be CALL_ORIGINAL, CALL_DELEGATE, or factory method");
                        }));
                    };
                };
                for (var _i6 = 0, _Object$keys4 = Object.keys(overrides); _i6 < _Object$keys4.length; _i6++) _loop(_i6, _Object$keys4);
            };
            _proto.watchForClose = function() {
                var _this16 = this;
                var closeWindowListener = Object(cross_domain_utils_src.C)(this.window, (function() {
                    _this16.component.log("detect_close_child");
                    return zalgo_promise_src.a.try((function() {
                        return _this16.props.onClose(constants.CLOSE_REASONS.CLOSE_DETECTED);
                    })).finally((function() {
                        return _this16.destroy();
                    }));
                }), 3e3);
                this.clean.register("destroyCloseWindowListener", closeWindowListener.cancel);
            };
            _proto.watchForUnload = function() {
                var _this17 = this;
                var onunload = Object(lib.H)((function() {
                    _this17.component.log("navigate_away");
                    Object(client.h)();
                    _this17.destroyComponent();
                }));
                var unloadWindowListener = Object(lib.b)(window, "unload", onunload);
                this.clean.register("destroyUnloadWindowListener", unloadWindowListener.cancel);
            };
            _proto.loadUrl = function(url) {
                var _this18 = this;
                return zalgo_promise_src.a.try((function() {
                    _this18.component.log("load_url");
                    if (window.location.href.split("#")[0] === url.split("#")[0]) {
                        var _query;
                        url = Object(lib.r)(url, {
                            query: (_query = {}, _query[Object(lib.U)()] = "1", _query)
                        });
                    }
                    return _this18.driver.loadUrl.call(_this18, url);
                }));
            };
            _proto.hijack = function(targetElement) {
                targetElement.target = this.childWindowName;
            };
            _proto.runTimeout = function() {
                var _this19 = this;
                var timeout = this.props.timeout;
                if (timeout) {
                    var id = this.timeout = setTimeout((function() {
                        _this19.component.log("timed_out", {
                            timeout: timeout.toString()
                        });
                        var error = _this19.component.createError("Loading component timed out after " + timeout + " milliseconds");
                        _this19.onInit.reject(error);
                        _this19.props.onTimeout(error);
                    }), timeout);
                    this.clean.register((function() {
                        clearTimeout(id);
                        delete _this19.timeout;
                    }));
                }
            };
            _proto.listeners = function() {
                var _ref9;
                return (_ref9 = {})[constants.POST_MESSAGE.INIT] = function(source, data) {
                    this.childExports = data.exports;
                    this.onInit.resolve(this);
                    this.timeout && clearTimeout(this.timeout);
                    return {
                        props: this.getPropsForChild(),
                        context: this.context
                    };
                }, _ref9[constants.POST_MESSAGE.CLOSE] = function(source, data) {
                    this.close(data.reason);
                }, _ref9[constants.POST_MESSAGE.CHECK_CLOSE] = function() {
                    this.checkClose();
                }, _ref9[constants.POST_MESSAGE.RESIZE] = function(source, data) {
                    var _this20 = this;
                    return zalgo_promise_src.a.try((function() {
                        if (_this20.driver.allowResize) return _this20.resize(data.width, data.height);
                    }));
                }, _ref9[constants.POST_MESSAGE.HIDE] = function() {
                    this.hide();
                }, _ref9[constants.POST_MESSAGE.SHOW] = function() {
                    this.show();
                }, _ref9[constants.POST_MESSAGE.ERROR] = function(source, data) {
                    this.error(new Error(data.error));
                }, _ref9;
            };
            _proto.resize = function(width, height) {
                var _this21 = this;
                return zalgo_promise_src.a.try((function() {
                    _this21.component.log("resize", {
                        height: Object(lib.R)(height),
                        width: Object(lib.R)(width)
                    });
                    _this21.driver.resize.call(_this21, width, height);
                    _this21.props.onResize && _this21.props.onResize();
                }));
            };
            _proto.hide = function() {
                this.container && Object(lib.x)(this.container);
                return this.driver.hide.call(this);
            };
            _proto.show = function() {
                this.container && Object(lib.Q)(this.container);
                return this.driver.show.call(this);
            };
            _proto.checkClose = function() {
                var _this22 = this;
                var closeWindowListener = Object(cross_domain_utils_src.C)(this.window, (function() {
                    _this22.userClose();
                }), 50, 500);
                this.clean.register(closeWindowListener.cancel);
            };
            _proto.userClose = function() {
                return this.close(constants.CLOSE_REASONS.USER_CLOSED);
            };
            _proto.close = function(reason) {
                var _this23 = this;
                void 0 === reason && (reason = constants.CLOSE_REASONS.PARENT_CALL);
                return zalgo_promise_src.a.try((function() {
                    _this23.component.log("close", {
                        reason: reason
                    });
                    _this23.event.triggerOnce(constants.EVENTS.CLOSE);
                    return _this23.props.onClose(reason);
                })).then((function() {
                    return zalgo_promise_src.a.all([ _this23.closeComponent(), _this23.closeContainer() ]);
                })).then((function() {
                    return _this23.destroy();
                }));
            };
            _proto.closeContainer = function(reason) {
                var _this24 = this;
                void 0 === reason && (reason = constants.CLOSE_REASONS.PARENT_CALL);
                return zalgo_promise_src.a.try((function() {
                    _this24.event.triggerOnce(constants.EVENTS.CLOSE);
                    return _this24.props.onClose(reason);
                })).then((function() {
                    return zalgo_promise_src.a.all([ _this24.closeComponent(reason), _this24.hideContainer() ]);
                })).then((function() {
                    return _this24.destroyContainer();
                }));
            };
            _proto.destroyContainer = function() {
                var _this25 = this;
                return zalgo_promise_src.a.try((function() {
                    _this25.clean.run("destroyContainerEvents");
                    _this25.clean.run("destroyContainerTemplate");
                }));
            };
            _proto.closeComponent = function(reason) {
                var _this26 = this;
                void 0 === reason && (reason = constants.CLOSE_REASONS.PARENT_CALL);
                var win = this.window;
                return zalgo_promise_src.a.try((function() {
                    return _this26.cancelContainerEvents();
                })).then((function() {
                    _this26.event.triggerOnce(constants.EVENTS.CLOSE);
                    return _this26.props.onClose(reason);
                })).then((function() {
                    return _this26.hideComponent();
                })).then((function() {
                    return _this26.destroyComponent();
                })).then((function() {
                    _this26.childExports && _this26.context === constants.CONTEXT_TYPES.POPUP && !Object(cross_domain_utils_src.z)(win) && _this26.childExports.close().catch(lib.F);
                }));
            };
            _proto.destroyComponent = function() {
                this.clean.run("destroyUnloadWindowListener");
                this.clean.run("destroyCloseWindowListener");
                this.clean.run("destroyContainerEvents");
                this.clean.run("destroyWindow");
            };
            _proto.showContainer = function() {
                var _this27 = this;
                return zalgo_promise_src.a.try((function() {
                    if (_this27.props.onDisplay) return _this27.props.onDisplay();
                })).then((function() {
                    if (_this27.container) return Object(lib.P)(_this27.container, constants.ANIMATION_NAMES.SHOW_CONTAINER, _this27.clean.register);
                }));
            };
            _proto.showComponent = function() {
                var _this28 = this;
                return zalgo_promise_src.a.try((function() {
                    if (_this28.props.onDisplay) return _this28.props.onDisplay();
                })).then((function() {
                    if (_this28.element) return Object(lib.P)(_this28.element, constants.ANIMATION_NAMES.SHOW_COMPONENT, _this28.clean.register);
                }));
            };
            _proto.hideContainer = function() {
                var _this29 = this;
                return zalgo_promise_src.a.try((function() {
                    return _this29.container ? Object(lib.c)(_this29.container, constants.ANIMATION_NAMES.HIDE_CONTAINER, _this29.clean.register) : zalgo_promise_src.a.resolve();
                }));
            };
            _proto.hideComponent = function() {
                var _this30 = this;
                return zalgo_promise_src.a.try((function() {
                    return _this30.element ? Object(lib.c)(_this30.element, constants.ANIMATION_NAMES.HIDE_COMPONENT, _this30.clean.register) : zalgo_promise_src.a.resolve();
                }));
            };
            _proto.focus = function() {
                if (!this.window || Object(cross_domain_utils_src.z)(this.window)) throw new Error("No window to focus");
                this.component.log("focus");
                this.window.focus();
            };
            _proto.createPrerenderTemplate = function() {
                var _this31 = this;
                return zalgo_promise_src.a.try((function() {
                    return _this31.component.prerenderTemplate ? zalgo_promise_src.a.try((function() {
                        return _this31.prerenderIframe ? Object(lib.e)(_this31.prerenderIframe).then((function() {
                            return _this31.prerenderWindow;
                        })) : _this31.prerenderWindow;
                    })).then((function(win) {
                        var doc;
                        try {
                            doc = win.document;
                        } catch (err) {
                            return;
                        }
                        var el;
                        try {
                            el = _this31.renderTemplate(_this31.component.prerenderTemplate, {
                                jsxDom: lib.C.bind(doc),
                                document: doc
                            });
                        } catch (err) {
                            _this31.component.logError("preprender_error", {
                                err: err.stack ? err.stack : err.toString()
                            });
                            console.error(err.stack ? err.stack : err);
                            return;
                        }
                        try {
                            Object(lib.X)(win, el);
                        } catch (err) {
                            _this31.component.logError("preprender_error", {
                                err: err.stack ? err.stack : err.toString()
                            });
                            console.error(err.stack ? err.stack : err);
                        }
                        var _ref10 = "object" == typeof _this31.component.autoResize && null !== _this31.component.autoResize ? _this31.component.autoResize : {}, _ref10$width = _ref10.width, width = void 0 !== _ref10$width && _ref10$width, _ref10$height = _ref10.height, height = void 0 !== _ref10$height && _ref10$height, _ref10$element = _ref10.element, element = void 0 === _ref10$element ? "body" : _ref10$element;
                        (element = Object(belter_src.b)(element, doc)) && (width || height) && Object(belter_src.r)(element, (function(_ref11) {
                            _this31.resize(width ? _ref11.width : void 0, height ? _ref11.height : void 0);
                        }), {
                            width: width,
                            height: height,
                            win: win
                        });
                    })) : zalgo_promise_src.a.resolve();
                }));
            };
            _proto.renderTemplate = function(renderer, options) {
                var _this32 = this;
                void 0 === options && (options = {});
                var _ref12 = this.component.dimensions || {}, _ref12$width = _ref12.width, width = void 0 === _ref12$width ? constants.DEFAULT_DIMENSIONS.WIDTH + "px" : _ref12$width, _ref12$height = _ref12.height, height = void 0 === _ref12$height ? constants.DEFAULT_DIMENSIONS.HEIGHT + "px" : _ref12$height;
                return renderer.call(this, Object(esm_extends.a)({
                    id: constants.CLASS_NAMES.ZOID + "-" + this.component.tag + "-" + this.props.uid,
                    props: renderer.__xdomain__ ? null : this.props,
                    tag: this.component.tag,
                    context: this.context,
                    outlet: this.getOutlet(),
                    CLASS: constants.CLASS_NAMES,
                    ANIMATION: constants.ANIMATION_NAMES,
                    CONTEXT: constants.CONTEXT_TYPES,
                    EVENT: constants.EVENTS,
                    actions: {
                        close: function() {
                            return _this32.userClose();
                        },
                        focus: function() {
                            return _this32.focus();
                        }
                    },
                    on: function(eventName, handler) {
                        return _this32.on(eventName, handler);
                    },
                    jsxDom: lib.C,
                    document: document,
                    dimensions: {
                        width: width,
                        height: height
                    }
                }, options));
            };
            _proto.openContainer = function(element) {
                var _this33 = this;
                return zalgo_promise_src.a.try((function() {
                    var el;
                    if (!(el = element ? Object(lib.u)(element) : document.body)) throw new Error("Could not find element to open container into");
                    Object(belter_src.p)(el) && (el = Object(belter_src.e)(el));
                    if (_this33.component.containerTemplate) {
                        var container = _this33.renderTemplate(_this33.component.containerTemplate, {
                            container: el
                        });
                        _this33.container = container;
                        Object(lib.x)(_this33.container);
                        Object(lib.d)(el, _this33.container);
                        if (_this33.driver.renderedIntoContainerTemplate) {
                            _this33.element = _this33.getOutlet();
                            Object(lib.x)(_this33.element);
                            if (!_this33.element) throw new Error("Could not find element to render component into");
                            Object(lib.x)(_this33.element);
                        }
                        _this33.clean.register("destroyContainerTemplate", (function() {
                            _this33.container && _this33.container.parentNode && _this33.container.parentNode.removeChild(_this33.container);
                            delete _this33.container;
                        }));
                    } else if (_this33.driver.renderedIntoContainerTemplate) throw new Error("containerTemplate needed to render " + _this33.context);
                }));
            };
            _proto.cancelContainerEvents = function() {
                this.clean.run("destroyContainerEvents");
            };
            _proto.destroy = function() {
                var _this34 = this;
                return zalgo_promise_src.a.try((function() {
                    if (_this34.clean.hasTasks()) {
                        _this34.component.log("destroy");
                        Object(client.h)();
                        return _this34.clean.all();
                    }
                })).then((function() {
                    if (_this34.props && _this34.props.onDestroy) return _this34.props.onDestroy();
                }));
            };
            _proto.tryInit = function(method) {
                var _this35 = this;
                return zalgo_promise_src.a.try(method).catch((function(err) {
                    _this35.onInit.reject(err);
                })).then((function() {
                    return _this35.onInit;
                }));
            };
            _proto.error = function(err) {
                var _this36 = this;
                return zalgo_promise_src.a.try((function() {
                    _this36.handledErrors = _this36.handledErrors || [];
                    if (-1 === _this36.handledErrors.indexOf(err)) {
                        _this36.handledErrors.push(err);
                        _this36.onInit.reject(err);
                        return _this36.destroy();
                    }
                })).then((function() {
                    if (_this36.props.onError) return _this36.props.onError(err);
                })).catch((function(errErr) {
                    throw new Error("An error was encountered while handling error:\n\n " + Object(lib.S)(err) + "\n\n" + Object(lib.S)(errErr));
                })).then((function() {
                    if (!_this36.props.onError) throw err;
                }));
            };
            ParentComponent.destroyAll = function() {
                var results = [];
                for (;ParentComponent.activeComponents.length; ) results.push(ParentComponent.activeComponents[0].destroy());
                return zalgo_promise_src.a.all(results).then(lib.F);
            };
            _createClass(ParentComponent, [ {
                key: "driver",
                get: function() {
                    if (!this.context) throw new Error("Context not set");
                    return RENDER_DRIVERS[this.context];
                }
            } ]);
            return ParentComponent;
        }(base_BaseComponent), _class2.activeComponents = [], _temp)).prototype, "getOutlet", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "getOutlet"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "prefetch", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "prefetch"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "loadHTML", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "loadHTML"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "buildUrl", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "buildUrl"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "open", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "open"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "openPrerender", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "openPrerender"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "switchPrerender", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "switchPrerender"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "close", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "closeContainer", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "closeContainer"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "destroyContainer", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "destroyContainer"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "closeComponent", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "closeComponent"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "showContainer", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "showContainer"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "showComponent", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "showComponent"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "hideContainer", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "hideContainer"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "hideComponent", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "hideComponent"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "createPrerenderTemplate", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "createPrerenderTemplate"), _class.prototype), 
        _applyDecoratedDescriptor(_class.prototype, "openContainer", [ lib.E ], Object.getOwnPropertyDescriptor(_class.prototype, "openContainer"), _class.prototype), 
        _class);
        var delegate_DelegateComponent = function(_BaseComponent) {
            Object(inheritsLoose.a)(DelegateComponent, _BaseComponent);
            function DelegateComponent(component, source, options) {
                var _this;
                (_this = _BaseComponent.call(this) || this).source = void 0;
                _this.context = void 0;
                _this.props = void 0;
                _this.focus = void 0;
                _this.userClose = void 0;
                _this.getDomain = void 0;
                _this.error = void 0;
                _this.on = void 0;
                _this.childWindowName = void 0;
                _this.isWindowClosed = void 0;
                _this.component = component;
                _this.clean.set("source", source);
                _this.context = options.context;
                _this.props = {
                    uid: options.props.uid,
                    dimensions: options.props.dimensions,
                    onClose: options.props.onClose,
                    onDisplay: options.props.onDisplay
                };
                for (var _i2 = 0, _component$getPropNam2 = component.getPropNames(); _i2 < _component$getPropNam2.length; _i2++) {
                    var propName = _component$getPropNam2[_i2];
                    _this.component.getProp(propName).allowDelegate && (_this.props[propName] = options.props[propName]);
                }
                _this.focus = function() {
                    return zalgo_promise_src.a.all([ _this.isWindowClosed().then((function(closed) {
                        closed || window.open("", _this.childWindowName);
                    })), options.overrides.focus.call(Object(assertThisInitialized.a)(_this)) ]).then(lib.F);
                };
                _this.clean.register("destroyFocusOverride", (function() {
                    _this.focus = lib.F;
                }));
                _this.userClose = options.overrides.userClose;
                _this.getDomain = options.overrides.getDomain;
                _this.error = options.overrides.error;
                _this.on = options.overrides.on;
                for (var _i4 = 0, _Object$keys2 = Object.keys(RENDER_DRIVERS[options.context].delegateOverrides); _i4 < _Object$keys2.length; _i4++) {
                    var key = _Object$keys2[_i4];
                    _this[key] = parent_ParentComponent.prototype[key];
                }
                _this.childWindowName = options.childWindowName;
                _this.isWindowClosed = options.isWindowClosed;
                parent_ParentComponent.prototype.registerActiveComponent.call(Object(assertThisInitialized.a)(_this));
                _this.watchForClose();
                return _this;
            }
            var _proto = DelegateComponent.prototype;
            _proto.watchForClose = function() {
                var _this2 = this;
                var closeWindowListener = Object(cross_domain_utils_src.C)(this.source, (function() {
                    return _this2.destroy();
                }), 3e3);
                this.clean.register("destroyCloseWindowListener", closeWindowListener.cancel);
            };
            _proto.getOverrides = function(context) {
                var overrides = {};
                var self = this;
                var _loop = function(_i6, _Object$keys4) {
                    var key = _Object$keys4[_i6];
                    overrides[key] = function() {
                        return parent_ParentComponent.prototype[key].apply(self, arguments);
                    };
                };
                for (var _i6 = 0, _Object$keys4 = Object.keys(RENDER_DRIVERS[context].delegateOverrides); _i6 < _Object$keys4.length; _i6++) _loop(_i6, _Object$keys4);
                return overrides;
            };
            _proto.destroy = function() {
                return this.clean.all();
            };
            _createClass(DelegateComponent, [ {
                key: "driver",
                get: function() {
                    if (!this.context) throw new Error("Context not set");
                    return RENDER_DRIVERS[this.context];
                }
            } ]);
            return DelegateComponent;
        }(base_BaseComponent);
        var drivers = __webpack_require__(29);
        function defaultContainerTemplate(_ref) {
            var id = _ref.id, CLASS = _ref.CLASS, outlet = _ref.outlet, jsxDom = _ref.jsxDom, _ref$dimensions = _ref.dimensions;
            return jsxDom("div", {
                id: id,
                class: CLASS.ZOID + " " + CLASS.ZOID + "-tag-" + _ref.tag + " " + CLASS.ZOID + "-context-" + _ref.context
            }, jsxDom("style", null, "\n                    #" + id + ", #" + id + " > ." + CLASS.OUTLET + " {\n                        width: " + _ref$dimensions.width + ";\n                        height: " + _ref$dimensions.height + ";\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " {\n                        display: inline-block;\n                        position: relative;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe {\n                        height: 100%;\n                        width: 100%;\n                        position: absolute;\n                        top: 0;\n                        left: 0;\n                        transition: opacity .2s ease-in-out;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe." + CLASS.VISIBLE + " {\n                        opacity: 1;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe." + CLASS.INVISIBLE + " {\n                        opacity: 0;\n                    }\n                "), outlet);
        }
        function defaultPrerenderTemplate(_ref) {
            var jsxDom = _ref.jsxDom;
            return jsxDom("html", null, jsxDom("head", null, jsxDom("style", null, "\n                        html, body {\n                            width: 100%;\n                            height: 100%;\n                            overflow: hidden;\n                            top: 0;\n                            left: 0;\n                            margin: 0;\n                            text-align: center;\n                        }\n\n                        .spinner {\n                            position: absolute;\n                            max-height: 60vmin;\n                            max-width: 60vmin;\n                            height: 40px;\n                            width: 40px;\n                            top: 50%;\n                            left: 50%;\n                            transform: translateX(-50%) translateY(-50%);\n                            z-index: 10;\n                        }\n\n                        .spinner .loader {\n                            height: 100%;\n                            width: 100%;\n                            box-sizing: border-box;\n                            border: 3px solid rgba(0, 0, 0, .2);\n                            border-top-color: rgba(33, 128, 192, 0.8);\n                            border-radius: 100%;\n                            animation: rotation .7s infinite linear;\n\n                        }\n\n                        @keyframes rotation {\n                            from {\n                                transform: rotate(0deg)\n                            }\n                            to {\n                                transform: rotate(359deg)\n                            }\n                        }\n                    ")), jsxDom("body", null, jsxDom("div", {
                class: "spinner"
            }, jsxDom("div", {
                id: "loader",
                class: "loader"
            }))));
        }
        var component_class, component_class2, component_temp;
        var component_drivers = {
            angular: drivers.angular,
            angular2: drivers.angular2,
            glimmer: drivers.glimmer,
            react: drivers.react,
            vue: drivers.vue,
            script: drivers.script
        };
        var component_Component = (_applyDecoratedDescriptor((component_class = (component_temp = component_class2 = function(_BaseComponent) {
            Object(inheritsLoose.a)(Component, _BaseComponent);
            function Component(options) {
                var _this;
                (_this = _BaseComponent.call(this) || this).name = void 0;
                _this.looseProps = void 0;
                _this.tag = void 0;
                _this.url = void 0;
                _this.domain = void 0;
                _this.bridgeUrl = void 0;
                _this.bridgeDomain = void 0;
                _this.props = void 0;
                _this.builtinProps = void 0;
                _this.dimensions = void 0;
                _this.scrolling = void 0;
                _this.autoResize = void 0;
                _this.listenForResize = void 0;
                _this.defaultLogLevel = void 0;
                _this.allowedParentDomains = void 0;
                _this.version = void 0;
                _this.defaultEnv = void 0;
                _this.buildUrl = void 0;
                _this.contexts = void 0;
                _this.defaultContext = void 0;
                _this.containerTemplate = void 0;
                _this.prerenderTemplate = void 0;
                _this.validate = void 0;
                _this.unsafeRenderTo = void 0;
                _this.driverCache = void 0;
                _this.xchild = void 0;
                _this.xprops = void 0;
                !function(options) {
                    if (!options) throw new Error("Expecred options to be passed");
                    if (!options.tag || !options.tag.match(/^[a-z0-9-]+$/)) throw new Error("Invalid options.tag: " + options.tag);
                    !function(options) {
                        if (options.props && "object" != typeof options.props) throw new Error("Expected options.props to be an object");
                        if (options.props) for (var _i2 = 0, _Object$keys2 = Object.keys(options.props); _i2 < _Object$keys2.length; _i2++) {
                            var key = _Object$keys2[_i2];
                            var prop = options.props[key];
                            if (!prop || "object" != typeof prop) throw new Error("Expected options.props." + key + " to be an object");
                            if (!prop.type) throw new Error("Expected prop.type");
                            if (-1 === constants.PROP_TYPES_LIST.indexOf(prop.type)) throw new Error("Expected prop.type to be one of " + constants.PROP_TYPES_LIST.join(", "));
                            if (prop.required && prop.def) throw new Error("Required prop can not have a default value");
                        }
                    }(options);
                    if (options.dimensions) {
                        if (options.dimensions && !Object(lib.B)(options.dimensions.width) && !Object(lib.A)(options.dimensions.width)) throw new Error("Expected options.dimensions.width to be a px or % string value");
                        if (options.dimensions && !Object(lib.B)(options.dimensions.height) && !Object(lib.A)(options.dimensions.height)) throw new Error("Expected options.dimensions.height to be a px or % string value");
                    }
                    if (options.contexts) {
                        var anyEnabled = !1;
                        for (var _i4 = 0, _Object$keys4 = Object.keys(options.contexts); _i4 < _Object$keys4.length; _i4++) {
                            var context = _Object$keys4[_i4];
                            if (-1 === constants.CONTEXT_TYPES_LIST.indexOf(context)) throw new Error("Unsupported context type: " + context);
                            (options.contexts && options.contexts[context] || options.contexts && void 0 === options.contexts[context]) && (anyEnabled = !0);
                        }
                        if (!anyEnabled) throw new Error("No context type is enabled");
                    }
                    if (options.defaultContext) {
                        if (-1 === constants.CONTEXT_TYPES_LIST.indexOf(options.defaultContext)) throw new Error("Unsupported context type: " + (options.defaultContext || "unknown"));
                        if (options.contexts && options.defaultContext && !options.contexts[options.defaultContext]) throw new Error("Disallowed default context type: " + (options.defaultContext || "unknown"));
                    }
                    if (options.url && options.buildUrl) throw new Error("Can not pass both options.url and options.buildUrl");
                    if (options.defaultEnv) {
                        if ("string" != typeof options.defaultEnv) throw new TypeError("Expected options.defaultEnv to be a string");
                        if (!options.buildUrl && "object" != typeof options.url) throw new Error("Expected options.url to be an object mapping env->url");
                        if (options.url && "object" == typeof options.url && !options.url[options.defaultEnv]) throw new Error("No url found for default env: " + options.defaultEnv);
                    }
                    if (options.url && "object" == typeof options.url) {
                        if (!options.defaultEnv) throw new Error("Must pass options.defaultEnv with env->url mapping");
                        for (var _i6 = 0, _Object$keys6 = Object.keys(options.url); _i6 < _Object$keys6.length; _i6++) {
                            var env = _Object$keys6[_i6];
                            if (!options.url[env]) throw new Error("No url specified for env: " + env);
                        }
                    }
                    if (options.prerenderTemplate && "function" != typeof options.prerenderTemplate) throw new Error("Expected options.prerenderTemplate to be a function");
                    if (options.containerTemplate && "function" != typeof options.containerTemplate) throw new Error("Expected options.containerTemplate to be a function");
                }(options);
                _this.addProp(options, "tag");
                _this.addProp(options, "defaultLogLevel", "info");
                _this.addProp(options, "allowedParentDomains", constants.WILDCARD);
                Object(lib.O)(_this.defaultLogLevel);
                if (Component.components[_this.tag]) throw new Error("Can not register multiple components with the same tag");
                _this.addProp(options, "name", _this.tag.replace(/-/g, "_"));
                _this.builtinProps = {
                    env: {
                        type: "string",
                        required: !1,
                        queryParam: !0,
                        def: function() {
                            return this.defaultEnv;
                        }
                    },
                    uid: {
                        type: "string",
                        def: function() {
                            return Object(lib.U)();
                        },
                        queryParam: !0
                    },
                    logLevel: {
                        type: "string",
                        required: !1,
                        queryParam: !0,
                        def: function() {
                            return this.defaultLogLevel;
                        }
                    },
                    url: {
                        type: "string",
                        required: !1,
                        promise: !0,
                        sendToChild: !1
                    },
                    win: {
                        type: "object",
                        required: !1,
                        sendToChild: !1
                    },
                    dimensions: {
                        type: "object",
                        required: !1
                    },
                    version: {
                        type: "string",
                        required: !1,
                        queryParam: !0,
                        def: function() {
                            return this.version;
                        }
                    },
                    timeout: {
                        type: "number",
                        required: !1,
                        sendToChild: !1
                    },
                    onDisplay: {
                        type: "function",
                        required: !1,
                        noop: !0,
                        promisify: !0,
                        memoize: !0,
                        sendToChild: !1
                    },
                    onEnter: {
                        type: "function",
                        required: !1,
                        noop: !0,
                        promisify: !0,
                        sendToChild: !1
                    },
                    onRender: {
                        type: "function",
                        required: !1,
                        noop: !0,
                        promisify: !0,
                        sendToChild: !1
                    },
                    onClose: {
                        type: "function",
                        required: !1,
                        noop: !0,
                        once: !0,
                        promisify: !0,
                        sendToChild: !1
                    },
                    onDestroy: {
                        type: "function",
                        required: !1,
                        noop: !0,
                        once: !0,
                        promisify: !0,
                        sendToChild: !1
                    },
                    onResize: {
                        type: "function",
                        required: !1,
                        noop: !0,
                        sendToChild: !1
                    },
                    onTimeout: {
                        type: "function",
                        required: !1,
                        memoize: !0,
                        promisify: !0,
                        sendToChild: !1,
                        def: function() {
                            return function(err) {
                                if (this.props.onError) return this.props.onError(err);
                                throw err;
                            };
                        }
                    },
                    onError: {
                        type: "function",
                        required: !1,
                        promisify: !0,
                        sendToChild: !0,
                        once: !0,
                        def: function() {
                            return function(err) {
                                setTimeout((function() {
                                    throw err;
                                }));
                            };
                        }
                    }
                };
                _this.props = options.props || {};
                options.props || (_this.looseProps = !0);
                _this.addProp(options, "dimensions");
                _this.addProp(options, "scrolling");
                _this.addProp(options, "listenForResize");
                _this.addProp(options, "version", "latest");
                _this.addProp(options, "defaultEnv");
                _this.addProp(options, "buildUrl");
                _this.addProp(options, "url");
                _this.addProp(options, "domain");
                _this.addProp(options, "bridgeUrl");
                _this.addProp(options, "bridgeDomain");
                _this.addProp(options, "attributes", {});
                _this.addProp(options, "contexts", {
                    iframe: !0,
                    popup: !1
                });
                _this.addProp(options, "defaultContext");
                _this.addProp(options, "autoResize", !1);
                _this.addProp(options, "containerTemplate", defaultContainerTemplate);
                _this.addProp(options, "prerenderTemplate", defaultPrerenderTemplate);
                _this.addProp(options, "validate");
                _this.addProp(options, "unsafeRenderTo", !1);
                Component.components[_this.tag] = Object(assertThisInitialized.a)(_this);
                _this.registerDrivers();
                _this.registerChild();
                _this.listenDelegate();
                return _this;
            }
            var _proto = Component.prototype;
            _proto.getPropNames = function() {
                var props = Object.keys(this.props);
                for (var _i2 = 0, _Object$keys2 = Object.keys(this.builtinProps); _i2 < _Object$keys2.length; _i2++) {
                    var key = _Object$keys2[_i2];
                    -1 === props.indexOf(key) && props.push(key);
                }
                return props;
            };
            _proto.getProp = function(name) {
                return this.props[name] || this.builtinProps[name];
            };
            _proto.registerDrivers = function() {
                this.driverCache = {};
                for (var _i4 = 0, _Object$keys4 = Object.keys(component_drivers); _i4 < _Object$keys4.length; _i4++) {
                    var driverName = _Object$keys4[_i4];
                    if (0 !== driverName.indexOf("_")) {
                        var glob = component_drivers[driverName].global();
                        glob && this.driver(driverName, glob);
                    }
                }
            };
            _proto.driver = function(name, dep) {
                if (!component_drivers[name]) throw new Error("Could not find driver for framework: " + name);
                this.driverCache[name] || (this.driverCache[name] = component_drivers[name].register(this, dep));
                return this.driverCache[name];
            };
            _proto.registerChild = function() {
                var _this2 = this;
                return zalgo_promise_src.a.try((function() {
                    if (_this2.isChild()) return new child_ChildComponent(_this2);
                }));
            };
            _proto.listenDelegate = function() {
                var _this3 = this;
                Object(src.on)(constants.POST_MESSAGE.ALLOW_DELEGATE + "_" + this.name, (function() {
                    return !0;
                }));
                Object(src.on)(constants.POST_MESSAGE.DELEGATE + "_" + this.name, (function(_ref) {
                    var source = _ref.source, origin = _ref.origin, data = _ref.data;
                    var domain = _this3.getDomain(null, data.env || _this3.defaultEnv);
                    if (!domain) throw new Error("Could not determine domain to allow remote render");
                    if (!Object(cross_domain_utils_src.B)(domain, origin)) throw new Error("Can not render from " + origin + " - expected " + domain.toString());
                    var delegate = _this3.delegate(source, data.options);
                    return {
                        overrides: delegate.getOverrides(data.context),
                        destroy: function() {
                            return delegate.destroy();
                        }
                    };
                }));
            };
            _proto.canRenderTo = function(win) {
                return Object(src.send)(win, constants.POST_MESSAGE.ALLOW_DELEGATE + "_" + this.name).then((function(_ref2) {
                    return _ref2.data;
                })).catch((function() {
                    return !1;
                }));
            };
            _proto.getValidDomain = function(url) {
                if (url) {
                    var domain = Object(cross_domain_utils_src.i)(url);
                    if ("string" == typeof this.domain && domain === this.domain) return domain;
                    var domains = this.domain;
                    if (domains && "object" == typeof domains && !(domains instanceof RegExp)) for (var _i6 = 0, _Object$keys6 = Object.keys(domains); _i6 < _Object$keys6.length; _i6++) {
                        var env = _Object$keys6[_i6];
                        if ("test" !== env && domain === domains[env]) return domain;
                    }
                }
            };
            _proto.getDomain = function(url, env) {
                var domain = this.getForEnv(this.domain, env);
                if (domain) return domain;
                if (domain = this.getValidDomain(url)) return domain;
                var envUrl = this.getForEnv(this.url, env);
                return envUrl ? Object(cross_domain_utils_src.i)(envUrl) : url ? Object(cross_domain_utils_src.i)(url) : void 0;
            };
            _proto.getBridgeUrl = function(env) {
                return this.getForEnv(this.bridgeUrl, env);
            };
            _proto.getForEnv = function(item, env) {
                if (item) {
                    if ("string" == typeof item || item instanceof RegExp) return item;
                    env || (env = this.defaultEnv);
                    if (env) return env && "object" == typeof item && item[env] ? item[env] : void 0;
                }
            };
            _proto.getBridgeDomain = function(env) {
                var bridgeDomain = this.getForEnv(this.bridgeDomain, env);
                if (bridgeDomain) return bridgeDomain;
                var bridgeUrl = this.getBridgeUrl(env);
                return bridgeUrl ? Object(cross_domain_utils_src.i)(bridgeUrl) : void 0;
            };
            _proto.getUrl = function(env, props) {
                var url = this.getForEnv(this.url, env);
                if (url) return url;
                if (this.buildUrl) return this.buildUrl(props);
                throw new Error("Unable to get url");
            };
            _proto.isZoidComponent = function() {
                return isZoidComponentWindow();
            };
            _proto.isChild = function() {
                if (!isZoidComponentWindow()) return !1;
                var _getComponentMeta = getComponentMeta(), tag = _getComponentMeta.tag, childDomain = _getComponentMeta.childDomain;
                return (!childDomain || childDomain === Object(cross_domain_utils_src.h)()) && tag === this.tag;
            };
            _proto.createError = function(message, tag) {
                return new Error("[" + (tag || this.tag) + "] " + message);
            };
            _proto.init = function(props, context, element) {
                return new parent_ParentComponent(this, this.getRenderContext(context, element), {
                    props: props
                });
            };
            _proto.delegate = function(source, options) {
                return new delegate_DelegateComponent(this, source, options);
            };
            _proto.validateRenderContext = function(context, element) {
                if (context && !this.contexts[context]) throw new Error("[" + this.tag + "] Can not render to " + context);
                if (!element && context === constants.CONTEXT_TYPES.IFRAME) throw new Error("[" + this.tag + "] Context type " + constants.CONTEXT_TYPES.IFRAME + " requires an element selector");
            };
            _proto.getDefaultContext = function() {
                if (this.defaultContext) return this.defaultContext;
                if (this.contexts[constants.CONTEXT_TYPES.IFRAME]) return constants.CONTEXT_TYPES.IFRAME;
                if (this.contexts[constants.CONTEXT_TYPES.POPUP]) return constants.CONTEXT_TYPES.POPUP;
                throw new Error("Can not determine default context");
            };
            _proto.getRenderContext = function(context, element) {
                context = context || this.getDefaultContext();
                this.validateRenderContext(context, element);
                return context;
            };
            _proto.render = function(props, element) {
                var _this4 = this;
                return zalgo_promise_src.a.try((function() {
                    return new parent_ParentComponent(_this4, _this4.getRenderContext(null, element), {
                        props: props
                    }).render(element);
                }));
            };
            _proto.renderIframe = function(props, element) {
                var _this5 = this;
                return zalgo_promise_src.a.try((function() {
                    return new parent_ParentComponent(_this5, _this5.getRenderContext(constants.CONTEXT_TYPES.IFRAME, element), {
                        props: props
                    }).render(element);
                }));
            };
            _proto.renderPopup = function(props) {
                var _this6 = this;
                return zalgo_promise_src.a.try((function() {
                    return new parent_ParentComponent(_this6, _this6.getRenderContext(constants.CONTEXT_TYPES.POPUP), {
                        props: props
                    }).render();
                }));
            };
            _proto.renderTo = function(win, props, element) {
                var _this7 = this;
                return zalgo_promise_src.a.try((function() {
                    return new parent_ParentComponent(_this7, _this7.getRenderContext(null, element), {
                        props: props
                    }).renderTo(win, element);
                }));
            };
            _proto.renderIframeTo = function(win, props, element) {
                var _this8 = this;
                return zalgo_promise_src.a.try((function() {
                    return new parent_ParentComponent(_this8, _this8.getRenderContext(constants.CONTEXT_TYPES.IFRAME, element), {
                        props: props
                    }).renderTo(win, element);
                }));
            };
            _proto.renderPopupTo = function(win, props) {
                var _this9 = this;
                return zalgo_promise_src.a.try((function() {
                    return new parent_ParentComponent(_this9, _this9.getRenderContext(constants.CONTEXT_TYPES.POPUP), {
                        props: props
                    }).renderTo(win);
                }));
            };
            _proto.prerender = function(props, element) {
                var instance = new parent_ParentComponent(this, this.getRenderContext(null, element), {
                    props: props
                });
                instance.prefetch();
                return {
                    render: function(innerProps, innerElement) {
                        innerProps && instance.updateProps(innerProps);
                        return instance.render(innerElement);
                    },
                    renderTo: function(win, innerProps, innerElement) {
                        innerProps && instance.updateProps(innerProps);
                        return instance.renderTo(win, innerElement);
                    },
                    get html() {
                        return instance.html;
                    },
                    set html(value) {
                        instance.html = value;
                    }
                };
            };
            _proto.log = function(event, payload) {
                void 0 === payload && (payload = {});
                Object(lib.z)(this.name, event, payload);
            };
            _proto.logWarning = function(event, payload) {
                Object(lib.V)(this.name, event, payload);
            };
            _proto.logError = function(event, payload) {
                Object(lib.o)(this.name, event, payload);
            };
            Component.getByTag = function(tag) {
                return Component.components[tag];
            };
            return Component;
        }(base_BaseComponent), component_class2.components = {}, component_temp)).prototype, "getPropNames", [ lib.D ], Object.getOwnPropertyDescriptor(component_class.prototype, "getPropNames"), component_class.prototype), 
        component_class);
        function create(options) {
            return new component_Component(options);
        }
        function getByTag(tag) {
            return component_Component.getByTag(tag);
        }
        function interface_destroyAll() {
            return parent_ParentComponent.destroyAll();
        }
        var postRobot = src;
        var CONSTANTS = constants;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        __webpack_require__.d(__webpack_exports__, "openTunnelToOpener", (function() {
            return openTunnelToOpener;
        }));
        __webpack_require__.d(__webpack_exports__, "needsBridgeForBrowser", (function() {
            return needsBridgeForBrowser;
        }));
        __webpack_require__.d(__webpack_exports__, "needsBridgeForWin", (function() {
            return needsBridgeForWin;
        }));
        __webpack_require__.d(__webpack_exports__, "needsBridgeForDomain", (function() {
            return needsBridgeForDomain;
        }));
        __webpack_require__.d(__webpack_exports__, "needsBridge", (function() {
            return needsBridge;
        }));
        __webpack_require__.d(__webpack_exports__, "getBridgeName", (function() {
            return getBridgeName;
        }));
        __webpack_require__.d(__webpack_exports__, "isBridge", (function() {
            return isBridge;
        }));
        __webpack_require__.d(__webpack_exports__, "documentBodyReady", (function() {
            return documentBodyReady;
        }));
        __webpack_require__.d(__webpack_exports__, "registerRemoteWindow", (function() {
            return registerRemoteWindow;
        }));
        __webpack_require__.d(__webpack_exports__, "findRemoteWindow", (function() {
            return findRemoteWindow;
        }));
        __webpack_require__.d(__webpack_exports__, "registerRemoteSendMessage", (function() {
            return registerRemoteSendMessage;
        }));
        __webpack_require__.d(__webpack_exports__, "rejectRemoteSendMessage", (function() {
            return rejectRemoteSendMessage;
        }));
        __webpack_require__.d(__webpack_exports__, "sendBridgeMessage", (function() {
            return sendBridgeMessage;
        }));
        __webpack_require__.d(__webpack_exports__, "hasBridge", (function() {
            return hasBridge;
        }));
        __webpack_require__.d(__webpack_exports__, "openBridge", (function() {
            return openBridge;
        }));
        __webpack_require__.d(__webpack_exports__, "linkUrl", (function() {
            return linkUrl;
        }));
        __webpack_require__.d(__webpack_exports__, "destroyBridges", (function() {
            return destroyBridges;
        }));
        var src = __webpack_require__(7);
        var conf = __webpack_require__(10);
        var lib = __webpack_require__(16);
        var global = __webpack_require__(9);
        global.a.tunnelWindows = global.a.tunnelWindows || {};
        global.a.tunnelWindowId = 0;
        function deleteTunnelWindow(id) {
            try {
                global.a.tunnelWindows[id] && delete global.a.tunnelWindows[id].source;
            } catch (err) {}
            delete global.a.tunnelWindows[id];
        }
        function getTunnelWindow(id) {
            return global.a.tunnelWindows[id];
        }
        global.a.openTunnelToParent = function(_ref2) {
            var name = _ref2.name, source = _ref2.source, canary = _ref2.canary, sendMessage = _ref2.sendMessage;
            var parentWindow = Object(src.n)(window);
            if (!parentWindow) throw new Error("No parent window found to open tunnel to");
            var id = function(_ref) {
                var name = _ref.name, source = _ref.source, canary = _ref.canary, sendMessage = _ref.sendMessage;
                !function() {
                    var tunnelWindows = global.a.tunnelWindows;
                    for (var _i2 = 0, _Object$keys2 = Object.keys(tunnelWindows); _i2 < _Object$keys2.length; _i2++) {
                        var key = _Object$keys2[_i2];
                        var tunnelWindow = tunnelWindows[key];
                        try {
                            Object(lib.j)(tunnelWindow.source);
                        } catch (err) {
                            deleteTunnelWindow(key);
                            continue;
                        }
                        Object(src.z)(tunnelWindow.source) && deleteTunnelWindow(key);
                    }
                }();
                global.a.tunnelWindowId += 1;
                global.a.tunnelWindows[global.a.tunnelWindowId] = {
                    name: name,
                    source: source,
                    canary: canary,
                    sendMessage: sendMessage
                };
                return global.a.tunnelWindowId;
            }({
                name: name,
                source: source,
                canary: canary,
                sendMessage: sendMessage
            });
            return global.a.send(parentWindow, conf.b.POST_MESSAGE_NAMES.OPEN_TUNNEL, {
                name: name,
                sendMessage: function() {
                    var tunnelWindow = getTunnelWindow(id);
                    try {
                        Object(lib.j)(tunnelWindow && tunnelWindow.source);
                    } catch (err) {
                        deleteTunnelWindow(id);
                        return;
                    }
                    if (tunnelWindow && tunnelWindow.source && !Object(src.z)(tunnelWindow.source)) {
                        try {
                            tunnelWindow.canary();
                        } catch (err) {
                            return;
                        }
                        tunnelWindow.sendMessage.apply(this, arguments);
                    }
                }
            }, {
                domain: conf.b.WILDCARD
            });
        };
        var zalgo_promise_src = __webpack_require__(2);
        var cross_domain_safe_weakmap_src = __webpack_require__(18);
        function needsBridgeForBrowser() {
            return !!Object(src.p)(window).match(/MSIE|trident|edge\/12|edge\/13/i) || !conf.a.ALLOW_POSTMESSAGE_POPUP;
        }
        function needsBridgeForWin(win) {
            return !Object(src.w)(window, win);
        }
        function needsBridgeForDomain(domain, win) {
            if (domain) {
                if (Object(src.h)() !== Object(src.i)(domain)) return !0;
            } else if (win && !Object(src.v)(win)) return !0;
            return !1;
        }
        function needsBridge(_ref) {
            var win = _ref.win, domain = _ref.domain;
            return !(!needsBridgeForBrowser() || domain && !needsBridgeForDomain(domain, win) || win && !needsBridgeForWin(win));
        }
        function getBridgeName(domain) {
            var sanitizedDomain = (domain = domain || Object(src.i)(domain)).replace(/[^a-zA-Z0-9]+/g, "_");
            return conf.b.BRIDGE_NAME_PREFIX + "_" + sanitizedDomain;
        }
        function isBridge() {
            return Boolean(window.name && window.name === getBridgeName(Object(src.h)()));
        }
        var documentBodyReady = new zalgo_promise_src.a((function(resolve) {
            if (window.document && window.document.body) return resolve(window.document.body);
            var interval = setInterval((function() {
                if (window.document && window.document.body) {
                    clearInterval(interval);
                    return resolve(window.document.body);
                }
            }), 10);
        }));
        global.a.remoteWindows = global.a.remoteWindows || new cross_domain_safe_weakmap_src.a;
        function registerRemoteWindow(win) {
            global.a.remoteWindows.set(win, {
                sendMessagePromise: new zalgo_promise_src.a
            });
        }
        function findRemoteWindow(win) {
            return global.a.remoteWindows.get(win);
        }
        function registerRemoteSendMessage(win, domain, sendMessage) {
            var remoteWindow = findRemoteWindow(win);
            if (!remoteWindow) throw new Error("Window not found to register sendMessage to");
            var sendMessageWrapper = function(remoteWin, message, remoteDomain) {
                if (remoteWin !== win) throw new Error("Remote window does not match window");
                if (!Object(src.B)(remoteDomain, domain)) throw new Error("Remote domain " + remoteDomain + " does not match domain " + domain);
                sendMessage(message);
            };
            remoteWindow.sendMessagePromise.resolve(sendMessageWrapper);
            remoteWindow.sendMessagePromise = zalgo_promise_src.a.resolve(sendMessageWrapper);
        }
        function rejectRemoteSendMessage(win, err) {
            var remoteWindow = findRemoteWindow(win);
            if (!remoteWindow) throw new Error("Window not found on which to reject sendMessage");
            remoteWindow.sendMessagePromise.asyncReject(err);
        }
        function sendBridgeMessage(win, message, domain) {
            var messagingChild = Object(src.t)(window, win);
            var messagingParent = Object(src.t)(win, window);
            if (!messagingChild && !messagingParent) throw new Error("Can only send messages to and from parent and popup windows");
            var remoteWindow = findRemoteWindow(win);
            if (!remoteWindow) throw new Error("Window not found to send message to");
            return remoteWindow.sendMessagePromise.then((function(sendMessage) {
                return sendMessage(win, message, domain);
            }));
        }
        var awaitRemoteBridgeForWindow = Object(lib.r)((function(win) {
            return zalgo_promise_src.a.try((function() {
                for (var _i2 = 0, _getFrames2 = Object(src.k)(win); _i2 < _getFrames2.length; _i2++) {
                    var frame = _getFrames2[_i2];
                    try {
                        if (frame && frame !== window && Object(src.v)(frame) && frame[conf.b.WINDOW_PROPS.POSTROBOT]) return frame;
                    } catch (err) {
                        continue;
                    }
                }
                try {
                    var _frame = Object(src.j)(win, getBridgeName(Object(src.h)()));
                    if (!_frame) return;
                    return Object(src.v)(_frame) && _frame[conf.b.WINDOW_PROPS.POSTROBOT] ? _frame : new zalgo_promise_src.a((function(resolve) {
                        var interval;
                        var timeout;
                        interval = setInterval((function() {
                            if (_frame && Object(src.v)(_frame) && _frame[conf.b.WINDOW_PROPS.POSTROBOT]) {
                                clearInterval(interval);
                                clearTimeout(timeout);
                                return resolve(_frame);
                            }
                        }), 100);
                        timeout = setTimeout((function() {
                            clearInterval(interval);
                            return resolve();
                        }), 2e3);
                    }));
                } catch (err) {}
            }));
        }));
        function openTunnelToOpener() {
            return zalgo_promise_src.a.try((function() {
                var opener = Object(src.m)(window);
                if (opener && needsBridge({
                    win: opener
                })) {
                    registerRemoteWindow(opener);
                    return awaitRemoteBridgeForWindow(opener).then((function(bridge) {
                        return bridge ? window.name ? bridge[conf.b.WINDOW_PROPS.POSTROBOT].openTunnelToParent({
                            name: window.name,
                            source: window,
                            canary: function() {},
                            sendMessage: function(message) {
                                try {
                                    Object(lib.j)(window);
                                } catch (err) {
                                    return;
                                }
                                if (window && !window.closed) try {
                                    global.a.receiveMessage({
                                        data: message,
                                        origin: this.origin,
                                        source: this.source
                                    });
                                } catch (err) {
                                    zalgo_promise_src.a.reject(err);
                                }
                            }
                        }).then((function(_ref) {
                            var source = _ref.source, origin = _ref.origin, data = _ref.data;
                            if (source !== opener) throw new Error("Source does not match opener");
                            registerRemoteSendMessage(source, origin, data.sendMessage);
                        })).catch((function(err) {
                            rejectRemoteSendMessage(opener, err);
                            throw err;
                        })) : rejectRemoteSendMessage(opener, new Error("Can not register with opener: window does not have a name")) : rejectRemoteSendMessage(opener, new Error("Can not register with opener: no bridge found in opener"));
                    }));
                }
            }));
        }
        global.a.bridges = global.a.bridges || {};
        global.a.bridgeFrames = global.a.bridgeFrames || {};
        global.a.popupWindowsByWin = global.a.popupWindowsByWin || new cross_domain_safe_weakmap_src.a;
        global.a.popupWindowsByName = global.a.popupWindowsByName || {};
        function hasBridge(url, domain) {
            domain = domain || Object(src.i)(url);
            return Boolean(global.a.bridges[domain]);
        }
        function openBridge(url, domain) {
            domain = domain || Object(src.i)(url);
            if (global.a.bridges[domain]) return global.a.bridges[domain];
            global.a.bridges[domain] = zalgo_promise_src.a.try((function() {
                if (Object(src.h)() === domain) throw new Error("Can not open bridge on the same domain as current domain: " + domain);
                var name = getBridgeName(domain);
                if (Object(src.j)(window, name)) throw new Error("Frame with name " + name + " already exists on page");
                var iframe = function(name, url) {
                    var iframe = document.createElement("iframe");
                    iframe.setAttribute("name", name);
                    iframe.setAttribute("id", name);
                    iframe.setAttribute("style", "display: none; margin: 0; padding: 0; border: 0px none; overflow: hidden;");
                    iframe.setAttribute("frameborder", "0");
                    iframe.setAttribute("border", "0");
                    iframe.setAttribute("scrolling", "no");
                    iframe.setAttribute("allowTransparency", "true");
                    iframe.setAttribute("tabindex", "-1");
                    iframe.setAttribute("hidden", "true");
                    iframe.setAttribute("title", "");
                    iframe.setAttribute("role", "presentation");
                    iframe.src = url;
                    return iframe;
                }(name, url);
                global.a.bridgeFrames[domain] = iframe;
                return documentBodyReady.then((function(body) {
                    body.appendChild(iframe);
                    var bridge = iframe.contentWindow;
                    !function(source, domain) {
                        global.a.on(conf.b.POST_MESSAGE_NAMES.OPEN_TUNNEL, {
                            window: source,
                            domain: domain
                        }, (function(_ref) {
                            var origin = _ref.origin, data = _ref.data;
                            if (origin !== domain) throw new Error("Domain " + domain + " does not match origin " + origin);
                            if (!data.name) throw new Error("Register window expected to be passed window name");
                            if (!data.sendMessage) throw new Error("Register window expected to be passed sendMessage method");
                            if (!global.a.popupWindowsByName[data.name]) throw new Error("Window with name " + data.name + " does not exist, or was not opened by this window");
                            if (!global.a.popupWindowsByName[data.name].domain) throw new Error("We do not have a registered domain for window " + data.name);
                            if (global.a.popupWindowsByName[data.name].domain !== origin) throw new Error("Message origin " + origin + " does not matched registered window origin " + global.a.popupWindowsByName[data.name].domain);
                            registerRemoteSendMessage(global.a.popupWindowsByName[data.name].win, domain, data.sendMessage);
                            return {
                                sendMessage: function(message) {
                                    if (window && !window.closed) {
                                        var winDetails = global.a.popupWindowsByName[data.name];
                                        if (winDetails) try {
                                            global.a.receiveMessage({
                                                data: message,
                                                origin: winDetails.domain,
                                                source: winDetails.win
                                            });
                                        } catch (err) {
                                            zalgo_promise_src.a.reject(err);
                                        }
                                    }
                                }
                            };
                        }));
                    }(bridge, domain);
                    return new zalgo_promise_src.a((function(resolve, reject) {
                        iframe.onload = resolve;
                        iframe.onerror = reject;
                    })).then((function() {
                        return Object(lib.k)(bridge, conf.a.BRIDGE_TIMEOUT, "Bridge " + url);
                    })).then((function() {
                        return bridge;
                    }));
                }));
            }));
            return global.a.bridges[domain];
        }
        var windowOpen = window.open;
        window.open = function(url, name, options, last) {
            var domain = url;
            if (url && 0 === url.indexOf(conf.b.MOCK_PROTOCOL)) {
                var _url$split = url.split("|");
                domain = _url$split[0];
                url = _url$split[1];
            }
            domain && (domain = Object(src.i)(domain));
            var win = windowOpen.call(this, url, name, options, last);
            if (!win) return win;
            url && registerRemoteWindow(win);
            for (var _i2 = 0, _Object$keys2 = Object.keys(global.a.popupWindowsByName); _i2 < _Object$keys2.length; _i2++) {
                var winName = _Object$keys2[_i2];
                Object(src.z)(global.a.popupWindowsByName[winName].win) && delete global.a.popupWindowsByName[winName];
            }
            if (name && win) {
                var winOptions = global.a.popupWindowsByWin.get(win) || global.a.popupWindowsByName[name] || {};
                winOptions.name = winOptions.name || name;
                winOptions.win = winOptions.win || win;
                winOptions.domain = winOptions.domain || domain;
                global.a.popupWindowsByWin.set(win, winOptions);
                global.a.popupWindowsByName[name] = winOptions;
            }
            return win;
        };
        function linkUrl(win, url) {
            var winOptions = global.a.popupWindowsByWin.get(win);
            if (winOptions) {
                winOptions.domain = Object(src.i)(url);
                registerRemoteWindow(win);
            }
        }
        function destroyBridges() {
            for (var _i4 = 0, _Object$keys4 = Object.keys(global.a.bridgeFrames); _i4 < _Object$keys4.length; _i4++) {
                var frame = global.a.bridgeFrames[_Object$keys4[_i4]];
                frame.parentNode && frame.parentNode.removeChild(frame);
            }
            global.a.bridgeFrames = {};
            global.a.bridges = {};
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return _assertThisInitialized;
        }));
        function _assertThisInitialized(self) {
            if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return self;
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return PopupOpenError;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return IntegrationError;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return RenderError;
        }));
        function PopupOpenError(message) {
            this.message = message;
        }
        PopupOpenError.prototype = Object.create(Error.prototype);
        function IntegrationError(message) {
            this.message = message;
        }
        IntegrationError.prototype = Object.create(Error.prototype);
        function RenderError(message) {
            this.message = message;
        }
        RenderError.prototype = Object.create(Error.prototype);
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return normalizeProps;
        }));
        var _constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
        var _funding__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27);
        var _lib_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14);
        var _funding_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20);
        var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12);
        var normalizeProps = Object(_lib_util__WEBPACK_IMPORTED_MODULE_2__.i)((function(props, defs) {
            void 0 === defs && (defs = {});
            var env = props.env, locale = props.locale, _props$style = props.style, style = void 0 === _props$style ? {} : _props$style, funding = props.funding, commit = props.commit, checkoutCustomization = props.checkoutCustomization;
            locale = locale ? function(locale) {
                var _locale$split = locale.split("_");
                return {
                    country: _locale$split[1],
                    lang: _locale$split[0]
                };
            }(locale) : defs.locale || Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)("DEFAULT", "defaultLocale");
            (funding = funding || {}).allowed = funding.allowed || [];
            funding.disallowed = funding.disallowed || [];
            funding.remembered = funding.remembered || [];
            var label = style[_constants__WEBPACK_IMPORTED_MODULE_0__.m.LABEL] || Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)("DEFAULT", style.layout === _constants__WEBPACK_IMPORTED_MODULE_0__.g.VERTICAL ? "defaultVerticalLabel" : "defaultLabel");
            var layout = style[_constants__WEBPACK_IMPORTED_MODULE_0__.m.LAYOUT] || Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)(label, "defaultLayout");
            var _style$BUTTON_STYLE_O = style[_constants__WEBPACK_IMPORTED_MODULE_0__.m.SIZE], size = void 0 === _style$BUTTON_STYLE_O ? Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)(label, layout === _constants__WEBPACK_IMPORTED_MODULE_0__.g.VERTICAL ? "defaultVerticalSize" : "defaultSize") : _style$BUTTON_STYLE_O, _style$BUTTON_STYLE_O2 = style[_constants__WEBPACK_IMPORTED_MODULE_0__.m.COLOR], color = void 0 === _style$BUTTON_STYLE_O2 ? Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)(label, "defaultColor") : _style$BUTTON_STYLE_O2, _style$BUTTON_STYLE_O3 = style[_constants__WEBPACK_IMPORTED_MODULE_0__.m.SHAPE], shape = void 0 === _style$BUTTON_STYLE_O3 ? Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)(label, "defaultShape") : _style$BUTTON_STYLE_O3, _style$BUTTON_STYLE_O4 = style[_constants__WEBPACK_IMPORTED_MODULE_0__.m.BRANDING], branding = void 0 === _style$BUTTON_STYLE_O4 ? Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)(label, layout === _constants__WEBPACK_IMPORTED_MODULE_0__.g.VERTICAL ? "defaultVerticalBranding" : "defaultBranding") : _style$BUTTON_STYLE_O4, _style$BUTTON_STYLE_O5 = style[_constants__WEBPACK_IMPORTED_MODULE_0__.m.FUNDINGICONS], fundingicons = void 0 === _style$BUTTON_STYLE_O5 ? Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)(label, "defaultFundingIcons") : _style$BUTTON_STYLE_O5, _style$BUTTON_STYLE_O6 = style[_constants__WEBPACK_IMPORTED_MODULE_0__.m.TAGLINE], tagline = void 0 === _style$BUTTON_STYLE_O6 ? Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)(label, "defaultTagline") : _style$BUTTON_STYLE_O6, max = style[_constants__WEBPACK_IMPORTED_MODULE_0__.m.MAXBUTTONS], height = style[_constants__WEBPACK_IMPORTED_MODULE_0__.m.HEIGHT], installmentperiod = style[_constants__WEBPACK_IMPORTED_MODULE_0__.m.INSTALLMENTPERIOD];
            max = function(_ref) {
                var label = _ref.label, layout = _ref.layout, max = _ref.max;
                if (!(layout === _constants__WEBPACK_IMPORTED_MODULE_0__.g.HORIZONTAL ? Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)(label, "allowPrimaryHorizontal") : Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)(label, "allowPrimaryVertical"))) return 1;
                var configMax = layout === _constants__WEBPACK_IMPORTED_MODULE_0__.g.HORIZONTAL ? Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)(label, "maxHorizontalButtons") : Object(_config__WEBPACK_IMPORTED_MODULE_4__.e)(label, "maxVerticalButtons");
                return max ? Math.min(configMax, max) : configMax;
            }({
                label: label,
                layout: layout,
                max: max
            });
            var selected = Object(_config__WEBPACK_IMPORTED_MODULE_4__.f)(label);
            var sources = Object(_funding__WEBPACK_IMPORTED_MODULE_1__.b)({
                funding: funding,
                selected: selected,
                locale: locale,
                env: env,
                layout: layout,
                commit: commit
            });
            var multiple = (sources = Object(_lib_util__WEBPACK_IMPORTED_MODULE_2__.p)(sources.slice(0, max), _funding_config__WEBPACK_IMPORTED_MODULE_3__.b)).length > 1;
            multiple && (branding = !0);
            var _ref2;
            return {
                size: size,
                label: label,
                locale: locale,
                color: color,
                shape: shape,
                branding: branding,
                fundingicons: fundingicons,
                tagline: tagline = (_ref2 = {
                    tagline: tagline,
                    branding: branding,
                    fundingicons: fundingicons,
                    layout: layout
                }, Boolean(_ref2.tagline && _ref2.branding && !_ref2.fundingicons && _ref2.layout === _constants__WEBPACK_IMPORTED_MODULE_0__.g.HORIZONTAL)),
                funding: funding,
                layout: layout,
                sources: sources,
                max: max,
                multiple: multiple,
                env: env,
                height: height,
                cards: Object(_funding__WEBPACK_IMPORTED_MODULE_1__.a)({
                    funding: funding,
                    locale: locale
                }),
                installmentperiod: installmentperiod,
                checkoutCustomization: checkoutCustomization
            };
        }));
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return isFundingIneligible;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return isFundingAutoEligible;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return determineEligibleFunding;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return determineEligibleCards;
        }));
        __webpack_require__.d(__webpack_exports__, "f", (function() {
            return validateFunding;
        }));
        __webpack_require__.d(__webpack_exports__, "e", (function() {
            return logFundingEligibility;
        }));
        var constants = __webpack_require__(0);
        var config = __webpack_require__(20);
        var fundingEligibilityReasons = [];
        function isFundingIneligible(source, _ref) {
            var locale = _ref.locale, funding = _ref.funding, commit = _ref.commit, env = _ref.env;
            var isVertical = _ref.layout === constants.g.VERTICAL;
            if (!Object(config.e)(source, isVertical ? "allowVertical" : "allowHorizontal")) return constants.x.SECONDARY_DISALLOWED;
            if (-1 !== funding.disallowed.indexOf(source) && Object(config.e)(source, "allowOptOut")) return constants.x.OPT_OUT;
            if (-1 !== funding.disallowed.indexOf(source) && source === constants.v.VENMO) return constants.x.OPT_OUT;
            if (-1 !== funding.disallowed.indexOf(source) && source === constants.v.ITAU) return constants.x.OPT_OUT;
            if (-1 === Object(config.e)(source, "allowedCountries", [ locale.country ]).indexOf(locale.country)) return constants.x.DISALLOWED_COUNTRY;
            if (Object(config.e)(source, "requireCommitAsTrue") && !commit) return constants.x.COMMIT_NOT_SET;
            var allowedEnvs = Object(config.e)(source, "allowedEnvs");
            return allowedEnvs && -1 === allowedEnvs.indexOf(env) ? constants.x.INVALID_ENV : void 0;
        }
        function isFundingAutoEligible(source, _ref2) {
            var locale = _ref2.locale, funding = _ref2.funding;
            return _ref2.layout === constants.g.VERTICAL && -1 !== Object(config.e)(source, "defaultVerticalCountries", []).indexOf(locale.country) ? constants.x.DEFAULT_COUNTRY : Object(config.e)(source, "default") ? constants.x.DEFAULT : -1 !== funding.allowed.indexOf(source) && Object(config.e)(source, "allowOptIn") ? constants.x.OPT_IN : -1 !== funding.remembered.indexOf(source) && Object(config.e)(source, "allowRemember") ? constants.x.REMEMBERED : void 0;
        }
        function determineEligibleFunding(_ref4) {
            var funding = _ref4.funding, selected = _ref4.selected, locale = _ref4.locale, env = _ref4.env, layout = _ref4.layout, commit = _ref4.commit;
            var reasons = {};
            var eligibleFunding = config.c.filter((function(source) {
                var _isFundingEligible = function(source, _ref3) {
                    var locale = _ref3.locale, funding = _ref3.funding, env = _ref3.env, layout = _ref3.layout, selected = _ref3.selected, commit = _ref3.commit;
                    if (selected && source === selected) return {
                        eligible: !0,
                        reason: constants.x.PRIMARY
                    };
                    if (!(Object(config.e)(source, "enabled") || env === constants.t.TEST && Object(config.e)(source, "test"))) return {
                        eligible: !1,
                        reason: constants.x.NOT_ENABLED
                    };
                    var ineligibleReason = isFundingIneligible(source, {
                        locale: locale,
                        funding: funding,
                        layout: layout,
                        commit: commit,
                        env: env
                    });
                    if (ineligibleReason) return {
                        eligible: !1,
                        reason: ineligibleReason
                    };
                    var autoEligibleReason = isFundingAutoEligible(source, {
                        locale: locale,
                        funding: funding,
                        layout: layout
                    });
                    return autoEligibleReason ? {
                        eligible: !0,
                        reason: autoEligibleReason
                    } : {
                        eligible: !1,
                        reason: constants.x.NEED_OPT_IN
                    };
                }(source, {
                    selected: selected,
                    locale: locale,
                    funding: funding,
                    env: env,
                    layout: layout,
                    commit: commit
                }), eligible = _isFundingEligible.eligible;
                reasons[source] = {
                    eligible: eligible,
                    reason: _isFundingEligible.reason,
                    factors: {
                        env: env,
                        locale: locale,
                        layout: layout
                    }
                };
                return eligible;
            }));
            fundingEligibilityReasons.push(reasons);
            eligibleFunding.splice(eligibleFunding.indexOf(selected), 1);
            eligibleFunding.unshift(selected);
            return eligibleFunding;
        }
        function determineEligibleCards(_ref5) {
            var funding = _ref5.funding, locale = _ref5.locale;
            return Object(config.d)(locale.country, "priority").filter((function(card) {
                return -1 === funding.disallowed.indexOf(card);
            }));
        }
        function validateFunding(funding) {
            void 0 === funding && (funding = {
                allowed: [],
                disallowed: [],
                remembered: []
            });
            if (funding.allowed) for (var _i2 = 0, _funding$allowed2 = funding.allowed; _i2 < _funding$allowed2.length; _i2++) {
                var source = _funding$allowed2[_i2];
                if (-1 === constants.p.indexOf(source)) {
                    if (!config.a.hasOwnProperty(source)) throw new Error("Invalid funding source: " + source);
                    if (!Object(config.e)(source, "allowOptIn")) throw new Error("Can not allow funding source: " + source);
                    if (funding.disallowed && -1 !== funding.disallowed.indexOf(source)) throw new Error("Can not allow and disallow funding source: " + source);
                }
            }
            if (funding.disallowed) for (var _i4 = 0, _funding$disallowed2 = funding.disallowed; _i4 < _funding$disallowed2.length; _i4++) {
                var _source = _funding$disallowed2[_i4];
                if (-1 === constants.p.indexOf(_source)) {
                    if (!config.a.hasOwnProperty(_source)) throw new Error("Invalid funding source: " + _source);
                    if (!Object(config.e)(_source, "allowOptOut")) throw new Error("Can not disallow funding source: " + _source);
                }
            }
        }
        function logFundingEligibility() {
            fundingEligibilityReasons.forEach((function(reasons, i) {
                console.log("\nButton " + (i + 1) + ":\n");
                console.table(Object.keys(reasons).map((function(source) {
                    var _reasons$source = reasons[source];
                    return {
                        Funding: source,
                        Reason: _reasons$source.reason,
                        Eligibility: _reasons$source.eligible ? "eligible" : "ineligible",
                        Factors: JSON.stringify(_reasons$source.factors)
                    };
                })));
            }));
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return checkout.a;
        }));
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return checkout.c;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return checkout.b;
        }));
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return awaitBraintreeClient;
        }));
        __webpack_require__.d(__webpack_exports__, "e", (function() {
            return mapPaymentToBraintree;
        }));
        var checkout = __webpack_require__(32);
        var src = __webpack_require__(2);
        function awaitBraintreeClient(braintree, auth) {
            return src.a.resolve(auth).then((function(authorization) {
                return braintree.client.create({
                    authorization: authorization
                });
            })).then((function(client) {
                return braintree.paypalCheckout.create({
                    client: client
                });
            }));
        }
        var SUPPORTED_REST_FIELDS = {
            intent: 1,
            transactions: [ {
                amount: {
                    total: 1,
                    currency: 1
                }
            } ],
            payer: {
                external_selected_funding_instrument_type: 1,
                shipping_address: {
                    line1: 1,
                    line2: 1,
                    city: 1,
                    state: 1,
                    postal_code: 1,
                    country_code: 1,
                    phone: 1,
                    recipient_name: 1
                }
            },
            application_context: {
                brand_name: 1,
                shipping_preference: 1,
                landing_page: 1
            }
        };
        function mapPaymentToBraintree(payment) {
            !function validate(obj, supported, name) {
                var supportedKeys = Object.keys(supported);
                for (var _i2 = 0, _Object$keys2 = Object.keys(obj); _i2 < _Object$keys2.length; _i2++) {
                    var key = _Object$keys2[_i2];
                    if (-1 === supportedKeys.indexOf(key)) throw new Error("Unsupported REST key for Braintree: " + name + "." + key);
                    "object" == typeof obj[key] && validate(obj[key], supported[key], name + "." + key);
                }
            }(payment, SUPPORTED_REST_FIELDS, "payment");
            var btPayment = {};
            btPayment.intent = payment.intent || "sale";
            btPayment.flow = "checkout";
            btPayment.amount = payment.transactions[0].amount.total;
            btPayment.currency = payment.transactions[0].amount.currency;
            if (payment.payer) {
                "CREDIT" === payment.payer.external_selected_funding_instrument_type && (btPayment.offerCredit = !0);
                payment.payer.shipping_address && (btPayment.shippingAddressOverride = {
                    line1: payment.payer.shipping_address.line1,
                    line2: payment.payer.shipping_address.line2,
                    city: payment.payer.shipping_address.city,
                    state: payment.payer.shipping_address.state,
                    postalCode: payment.payer.shipping_address.postal_code,
                    countryCode: payment.payer.shipping_address.country_code,
                    phone: payment.payer.shipping_address.phone,
                    recipientName: payment.payer.shipping_address.recipient_name
                });
            }
            if (payment.application_context) {
                btPayment.displayName = payment.application_context.brand_name;
                btPayment.landingPageType = payment.application_context.landing_page;
                if (payment.application_context) if ("NO_SHIPPING" === payment.application_context.shipping_preference) btPayment.enableShippingAddress = !1; else if ("GET_FROM_FILE" === payment.application_context.shipping_preference) {
                    btPayment.enableShippingAddress = !0;
                    btPayment.shippingAddressEditable = !0;
                } else if ("SET_PROVIDED_ADDRESS" === payment.application_context.shipping_preference) {
                    btPayment.enableShippingAddress = !0;
                    btPayment.shippingAddressEditable = !1;
                }
            }
            return btPayment;
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        var _script__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35);
        __webpack_require__.d(__webpack_exports__, "script", (function() {
            return _script__WEBPACK_IMPORTED_MODULE_0__.a;
        }));
        var _react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36);
        __webpack_require__.d(__webpack_exports__, "react", (function() {
            return _react__WEBPACK_IMPORTED_MODULE_1__.a;
        }));
        var _vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37);
        __webpack_require__.d(__webpack_exports__, "vue", (function() {
            return _vue__WEBPACK_IMPORTED_MODULE_2__.a;
        }));
        var _angular__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38);
        __webpack_require__.d(__webpack_exports__, "angular", (function() {
            return _angular__WEBPACK_IMPORTED_MODULE_3__.a;
        }));
        var _ember__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39);
        __webpack_require__.o(_ember__WEBPACK_IMPORTED_MODULE_4__, "angular2") && __webpack_require__.d(__webpack_exports__, "angular2", (function() {
            return _ember__WEBPACK_IMPORTED_MODULE_4__.angular2;
        }));
        __webpack_require__.o(_ember__WEBPACK_IMPORTED_MODULE_4__, "glimmer") && __webpack_require__.d(__webpack_exports__, "glimmer", (function() {
            return _ember__WEBPACK_IMPORTED_MODULE_4__.glimmer;
        }));
        var _glimmer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40);
        __webpack_require__.d(__webpack_exports__, "glimmer", (function() {
            return _glimmer__WEBPACK_IMPORTED_MODULE_5__.a;
        }));
        var _angular2__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41);
        __webpack_require__.d(__webpack_exports__, "angular2", (function() {
            return _angular2__WEBPACK_IMPORTED_MODULE_6__.a;
        }));
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return _setPrototypeOf;
        }));
        function _setPrototypeOf(o, p) {
            return (_setPrototypeOf = Object.setPrototypeOf || function(o, p) {
                o.__proto__ = p;
                return o;
            })(o, p);
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return componentTemplate;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return getContainerStyle;
        }));
        __webpack_require__.d(__webpack_exports__, "d", (function() {
            return getSandboxStyle;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return containerTemplate;
        }));
        function componentTemplate(_ref) {
            var jsxDom = _ref.jsxDom;
            return jsxDom("html", null, jsxDom("head", null, jsxDom("title", null, "PayPal"), jsxDom("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            })), jsxDom("body", null, jsxDom("div", {
                class: "preloader spinner"
            }, jsxDom("style", null, "\n\n    body {\n        width: 100%;\n        height: 100%;\n        overflow: hidden;\n        position: fixed;\n        top: 0;\n        left: 0;\n        margin: 0;\n    }\n\n    .spinner {\n        height: 100%;\n        width: 100%;\n        position: absolute;\n        z-index: 10\n    }\n\n    .spinner .spinWrap {\n        width: 200px;\n        height: 100px;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        margin-left: -100px;\n        margin-top: -50px\n    }\n\n    .spinner .loader,\n    .spinner .spinnerImage {\n        height: 100px;\n        width: 100px;\n        position: absolute;\n        top: 0;\n        left: 50%;\n        opacity: 1;\n        filter: alpha(opacity=100)\n    }\n\n    .spinner .spinnerImage {\n        margin: 28px 0 0 -25px;\n        background: url(https://www.paypalobjects.com/images/checkout/hermes/icon_ot_spin_lock_skinny.png) no-repeat\n    }\n\n    .spinner .loader {\n        margin: 0 0 0 -55px;\n        background-color: transparent;\n        -webkit-animation: rotation .7s infinite linear;\n        -moz-animation: rotation .7s infinite linear;\n        -o-animation: rotation .7s infinite linear;\n        animation: rotation .7s infinite linear;\n        border-left: 5px solid #cbcbca;\n        border-right: 5px solid #cbcbca;\n        border-bottom: 5px solid #cbcbca;\n        border-top: 5px solid #2380be;\n        border-radius: 100%\n    }\n\n    @-webkit-keyframes rotation {\n        from {\n            -webkit-transform: rotate(0deg)\n        }\n        to {\n            -webkit-transform: rotate(359deg)\n        }\n    }\n    @-moz-keyframes rotation {\n        from {\n            -moz-transform: rotate(0deg)\n        }\n        to {\n            -moz-transform: rotate(359deg)\n        }\n    }\n    @-o-keyframes rotation {\n        from {\n            -o-transform: rotate(0deg)\n        }\n        to {\n            -o-transform: rotate(359deg)\n        }\n    }\n    @keyframes rotation {\n        from {\n            transform: rotate(0deg)\n        }\n        to {\n            transform: rotate(359deg)\n        }\n    }\n"), jsxDom("div", {
                class: "spinWrap"
            }, jsxDom("p", {
                class: "spinnerImage"
            }), jsxDom("p", {
                class: "loader"
            })))));
        }
        var src = __webpack_require__(11);
        var zalgo_promise_src = __webpack_require__(2);
        var resources = __webpack_require__(19);
        var constants = __webpack_require__(0);
        var containerContent = __webpack_require__(33);
        function getContainerStyle(_ref) {
            var id = _ref.id, tag = _ref.tag, CONTEXT = _ref.CONTEXT, CLASS = _ref.CLASS, ANIMATION = _ref.ANIMATION;
            return "\n        #" + id + " {\n            position: absolute;\n            z-index: 2147483647;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n\n            -webkit-transform: translate3d(0, 0, 0);\n            -moz-transform: translate3d(0, 0, 0);\n            -ms-transform: translate3d(0, 0, 0);\n            -o-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n        }\n\n        #" + id + "." + tag + "-background-color-" + constants.q.BLACK + " {\n            background-color: black;\n            background-color: rgba(0, 0, 0, 0.75);\n\n            background: -webkit-radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,1) 1%, rgba(0,0,0,0.75) 100%);\n            background: -moz-radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,1) 1%, rgba(0,0,0,0.75) 100%);\n            background: -ms-radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,1) 1%, rgba(0,0,0,0.75) 100%);\n            background: radial-gradient(50% 50%, ellipse closest-corner, rgba(0,0,0,1) 1%, rgba(0,0,0,0.75) 100%);\n\n            color: #fff;\n        }\n\n        #" + id + "." + tag + "-background-color-" + constants.q.WHITE + " {\n            background-color: white;\n            background-color: rgba(255, 255, 255, 0.4);\n\n            background: -webkit-radial-gradient(50% 50%, ellipse closest-corner, rgba(255, 255, 255,1) 1%, rgba(255, 255, 255,0.4) 100%);\n            background: -moz-radial-gradient(50% 50%, ellipse closest-corner, rgba(255, 255, 255,1) 1%, rgba(255, 255, 255,0.4) 100%);\n            background: -ms-radial-gradient(50% 50%, ellipse closest-corner, rgba(255, 255, 255,1) 1%, rgba(255, 255, 255,0.4) 100%);\n            background: radial-gradient(50% 50%, ellipse closest-corner, rgba(255, 255, 255,1) 1%, rgba(255, 255, 255,0.4) 100%);\n\n            color: #333;\n        }\n\n        #" + id + "." + tag + "-background-color-" + constants.q.BLACK + " a {\n            color: #fff;\n        }\n\n        #" + id + "." + tag + "-background-color-" + constants.q.WHITE + " a {\n            color: #333;\n        }\n\n        #" + id + "." + tag + "-background-color-" + constants.q.BLACK + " .paypal-checkout-close:before,\n        #" + id + "." + tag + "-background-color-" + constants.q.BLACK + " .paypal-checkout-close:after {\n            background-color: #fff;\n        }\n\n        #" + id + "." + tag + "-background-color-" + constants.q.WHITE + " .paypal-checkout-close:before,\n        #" + id + "." + tag + "-background-color-" + constants.q.WHITE + " .paypal-checkout-close:after {\n            background-color: #111;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.POPUP + " {\n            cursor: pointer;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.POPUP + " {\n            cursor: pointer;\n        }\n\n        #" + id + " a {\n            text-decoration: none;\n        }\n\n        #" + id + ' .paypal-checkout-modal {\n            font-family: "HelveticaNeue", "HelveticaNeue-Light", "Helvetica Neue Light", helvetica, arial, sans-serif;\n            font-size: 14px;\n            text-align: center;\n\n            -webkit-box-sizing: border-box;\n            -moz-box-sizing: border-box;\n            -ms-box-sizing: border-box;\n            box-sizing: border-box;\n            max-width: 350px;\n            top: 50%;\n            left: 50%;\n            position: absolute;\n            transform: translateX(-50%) translateY(-50%);\n            -webkit-transform: translateX(-50%) translateY(-50%);\n            -moz-transform: translateX(-50%) translateY(-50%);\n            -o-transform: translateX(-50%) translateY(-50%);\n            -ms-transform: translateX(-50%) translateY(-50%);\n            cursor: pointer;\n            text-align: center;\n        }\n\n        #' + id + "." + tag + "-loading .paypal-checkout-message, #" + id + "." + tag + "-loading .paypal-checkout-continue {\n            display: none;\n        }\n\n        .paypal-checkout-loader {\n            display: none;\n        }\n\n        #" + id + "." + tag + "-loading .paypal-checkout-loader {\n            display: block;\n        }\n\n        #" + id + " .paypal-checkout-modal .paypal-checkout-logo {\n            cursor: pointer;\n            margin-bottom: 30px;\n            display: inline-block;\n        }\n\n        #" + id + " .paypal-checkout-modal .paypal-checkout-logo img {\n            height: 36px;\n        }\n\n        #" + id + " .paypal-checkout-modal .paypal-checkout-logo img.paypal-checkout-logo-pp {\n            margin-right: 10px;\n        }\n\n        #" + id + " .paypal-checkout-modal .paypal-checkout-message {\n            font-size: 15px;\n            line-height: 1.5;\n            padding: 10px 0;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-message, #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-continue {\n            display: none;\n        }\n\n        #" + id + " .paypal-checkout-modal .paypal-checkout-continue {\n            font-size: 15px;\n            line-height: 1.35;\n            padding: 10px 0;\n            font-weight: bold;\n        }\n\n        #" + id + " .paypal-checkout-modal .paypal-checkout-continue a {\n            border-bottom: 1px solid currentColor;\n        }\n\n        #" + id + " .paypal-checkout-close {\n            position: absolute;\n            right: 16px;\n            top: 16px;\n            width: 16px;\n            height: 16px;\n            opacity: 0.6;\n        }\n\n        #" + id + "." + tag + "-loading .paypal-checkout-close {\n            display: none;\n        }\n\n        #" + id + " .paypal-checkout-close:hover {\n            opacity: 1;\n        }\n\n        #" + id + " .paypal-checkout-close:before, .paypal-checkout-close:after {\n            position: absolute;\n            left: 8px;\n            content: ' ';\n            height: 16px;\n            width: 2px;\n        }\n\n        #" + id + " .paypal-checkout-close:before {\n            transform: rotate(45deg);\n            -webkit-transform: rotate(45deg);\n            -moz-transform: rotate(45deg);\n            -o-transform: rotate(45deg);\n            -ms-transform: rotate(45deg);\n        }\n\n        #" + id + " .paypal-checkout-close:after {\n            transform: rotate(-45deg);\n            -webkit-transform: rotate(-45deg);\n            -moz-transform: rotate(-45deg);\n            -o-transform: rotate(-45deg);\n            -ms-transform: rotate(-45deg);\n        }\n\n        #" + id + " .paypal-checkout-iframe-container {\n            display: none;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-iframe-container,\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-iframe-container > ." + CLASS.OUTLET + ",\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-iframe-container > ." + CLASS.OUTLET + " > iframe {\n            max-height: calc(95vh - 60px);\n            max-width: 95vw;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-iframe-container {\n\n            display: block;\n\n            position: absolute;\n\n            top: 50%;\n            left: 50%;\n\n            min-width: 450px;\n\n            transform: translate(-50%, -50%);\n            -webkit-transform: translate(-50%, -50%);\n            -moz-transform: translate(-50%, -50%);\n            -o-transform: translate(-50%, -50%);\n            -ms-transform: translate(-50%, -50%);\n\n            transform: translate3d(-50%, -50%, 0);\n            -webkit-transform: translate3d(-50%, -50%, 0);\n            -moz-transform: translate3d(-50%, -50%, 0);\n            -o-transform: translate3d(-50%, -50%, 0);\n            -ms-transform: translate3d(-50%, -50%, 0);\n\n            border-radius: 10px;\n            overflow: hidden;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " {\n\n            position: relative;\n\n            -webkit-transition: all 0.3s ease;\n            -moz-transition: all 0.3s ease;\n            -ms-transition: all 0.3s ease;\n            -o-transition: all 0.3 ease;\n            transition: all 0.3s ease;\n\n            -webkit-animation-duration: 0.3s;\n            animation-duration: 0.3s;\n            -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n\n            min-width: 450px;\n            max-width: 450px;\n            width: 450px;\n            height: 535px;\n\n            background-color: white;\n\n            overflow: auto;\n            -webkit-overflow-scrolling: touch;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " > iframe {\n            position: absolute;\n            top: 0;\n            left: 0;\n            transition: opacity .4s ease-in-out;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " > iframe." + CLASS.COMPONENT_FRAME + " {\n            z-index: 100;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " > iframe." + CLASS.PRERENDER_FRAME + " {\n            z-index: 200;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " > iframe." + CLASS.VISIBLE + " {\n            opacity: 1;\n            z-index: 200;\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " > iframe." + CLASS.INVISIBLE + " {\n            opacity: 0;\n            z-index: 100;\n        }\n\n        @media screen and (-ms-high-contrast: active) {\n            #" + id + " .paypal-checkout-close {\n                opacity: 1;\n            }\n\n            #" + id + " .paypal-checkout-close:before , .paypal-checkout-close:after {\n                background-color: currentColor;\n            }\n        }\n\n        @media screen and (max-width: 470px) {\n\n            #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-iframe-container,\n            #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " {\n                min-width: 100%;\n                min-width: calc(100% - 20px);\n                min-width: -webkit-calc(100% - 20px);\n                min-width: -moz-calc(100% - 20px);\n                min-width: -o-calc(100% - 20px);\n                min-width: -ms-calc(100% - 20px);\n\n                max-width: 100%;\n                max-width: calc(100% - 20px);\n                max-width: -webkit-calc(100% - 20px);\n                max-width: -moz-calc(100% - 20px);\n                max-width: -o-calc(100% - 20px);\n                max-width: -ms-calc(100% - 20px);\n            }\n        }\n\n        #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " iframe {\n            width: 1px;\n            min-width: 100%;\n            height: 100%;\n        }\n\n        @-webkit-keyframes " + ANIMATION.SHOW_COMPONENT + " {\n            from {\n                opacity: 0;\n                transform: scale3d(.3, .3, .3);\n                -webkit-transform: scale3d(.3, .3, .3);\n            }\n\n            to {\n                opacity: 1;\n                transform: scale3d(1, 1, 1);\n                -webkit-transform: scale3d(1, 1, 1);\n            }\n        }\n\n        @keyframes " + ANIMATION.SHOW_COMPONENT + " {\n            from {\n                opacity: 0;\n                transform: scale3d(.3, .3, .3);\n                -webkit-transform: scale3d(.3, .3, .3);\n            }\n\n            to {\n                opacity: 1;\n                transform: scale3d(1, 1, 1);\n                -webkit-transform: scale3d(1, 1, 1);\n            }\n        }\n\n        @-webkit-keyframes " + ANIMATION.HIDE_COMPONENT + " {\n            from {\n                transform: scale3d(1, 1, 1);\n                -webkit-transform: scale3d(1, 1, 1);\n            }\n\n            to {\n                opacity: 0;\n                transform: scale3d(.3, .3, .3);\n                -webkit-transform: scale3d(.3, .3, .3);\n            }\n        }\n\n        @keyframes " + ANIMATION.HIDE_COMPONENT + " {\n            from {\n                transform: scale3d(1, 1, 1);\n                -webkit-transform: scale3d(1, 1, 1);\n            }\n\n            to {\n                opacity: 0;\n                transform: scale3d(.3, .3, .3);\n                -webkit-transform: scale3d(.3, .3, .3);\n            }\n        }\n\n        .paypal-spinner {\n            height: 30px;\n            width: 30px;\n            display: inline-block;\n            box-sizing: content-box;\n            opacity: 1;\n            filter: alpha(opacity=100);\n            -webkit-animation: rotation .7s infinite linear;\n            -moz-animation: rotation .7s infinite linear;\n            -o-animation: rotation .7s infinite linear;\n            animation: rotation .7s infinite linear;\n            border-left: 8px solid rgba(0, 0, 0, .2);\n            border-right: 8px solid rgba(0, 0, 0, .2);\n            border-bottom: 8px solid rgba(0, 0, 0, .2);\n            border-top: 8px solid #fff;\n            border-radius: 100%\n        }\n\n        @-webkit-keyframes rotation {\n            from {\n                -webkit-transform: rotate(0deg)\n            }\n            to {\n                -webkit-transform: rotate(359deg)\n            }\n        }\n        @-moz-keyframes rotation {\n            from {\n                -moz-transform: rotate(0deg)\n            }\n            to {\n                -moz-transform: rotate(359deg)\n            }\n        }\n        @-o-keyframes rotation {\n            from {\n                -o-transform: rotate(0deg)\n            }\n            to {\n                -o-transform: rotate(359deg)\n            }\n        }\n        @keyframes rotation {\n            from {\n                transform: rotate(0deg)\n            }\n            to {\n                transform: rotate(359deg)\n            }\n        }\n    ";
        }
        function getSandboxStyle(_ref) {
            var id = _ref.id, ANIMATION = _ref.ANIMATION;
            return "\n        #" + id + ".paypal-checkout-sandbox {\n            display: block;\n            position: fixed;\n            top: 0;\n            left: 0;\n\n            width: 100%;\n            height: 100%;\n            width: 100vw;\n            height: 100vh;\n            max-width: 100%;\n            max-height: 100%;\n            min-width: 100%;\n            min-height: 100%;\n\n            z-index: 2147483647;\n\n            -webkit-animation-duration: 1s;\n            animation-duration: 1s;\n\n            animation-fill-mode:forwards;\n            animation-iteration-count: 1;\n\n            -webkit-animation-fill-mode:forwards;\n            -webkit-animation-iteration-count: 1;\n        }\n\n        #" + id + ".paypal-checkout-sandbox .paypal-checkout-sandbox-iframe {\n            display: block;\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n        }\n\n        @-webkit-keyframes " + ANIMATION.SHOW_CONTAINER + " {\n            from {\n                opacity: 0;\n            }\n\n            to {\n                opacity: 1;\n            }\n        }\n\n        @keyframes " + ANIMATION.SHOW_CONTAINER + " {\n            from {\n                opacity: 0;\n            }\n\n            to {\n                opacity: 1;\n            }\n        }\n\n        @-webkit-keyframes " + ANIMATION.HIDE_CONTAINER + " {\n            from {\n                opacity: 1;\n            }\n\n            50% {\n                opacity: 1;\n            }\n\n            to {\n                opacity: 0;\n            }\n        }\n\n        @keyframes " + ANIMATION.HIDE_CONTAINER + " {\n            from {\n                opacity: 1;\n            }\n\n            50% {\n                opacity: 1;\n            }\n\n            to {\n                opacity: 0;\n            }\n        }\n    ";
        }
        var _LOGO_COLOR;
        var LOGO_COLOR = ((_LOGO_COLOR = {})[constants.q.BLACK] = constants.i.WHITE, _LOGO_COLOR[constants.q.WHITE] = constants.i.BLACK, 
        _LOGO_COLOR);
        function containerTemplate(_ref) {
            var id = _ref.id, props = _ref.props, CLASS = _ref.CLASS, ANIMATION = _ref.ANIMATION, CONTEXT = _ref.CONTEXT, EVENT = _ref.EVENT, on = _ref.on, tag = _ref.tag, context = _ref.context, actions = _ref.actions, outlet = _ref.outlet, jsxDom = _ref.jsxDom;
            var _props$locale$split = props.locale.split("_");
            var content = containerContent.a[_props$locale$split[1]][_props$locale$split[0]];
            function focus(event) {
                event.preventDefault();
                event.stopPropagation();
                Object(src.l)() && Object(src.t)() ? window.alert("Please switch tabs to reactivate the PayPal window") : zalgo_promise_src.a.try(actions.focus).catch(src.q);
            }
            var overlayColor = (props.style || {}).overlayColor || constants.q.BLACK;
            var logoColor = LOGO_COLOR[overlayColor];
            var ppLogo = "function" == typeof resources.b.pp ? resources.b.pp({
                logoColor: logoColor
            }) : resources.b.pp[logoColor];
            var paypalLogo = "function" == typeof resources.b.paypal ? resources.b.paypal({
                logoColor: logoColor
            }) : resources.b.paypal[logoColor];
            var el = jsxDom("div", {
                id: id,
                onClick: focus,
                class: tag + "-context-" + context + " paypal-checkout-overlay " + tag + "-background-color-" + overlayColor + " " + tag + "-logo-color-" + logoColor
            }, jsxDom("a", {
                href: "#",
                class: "paypal-checkout-close",
                onClick: function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                    actions.close();
                },
                "aria-label": "close",
                role: "button"
            }), jsxDom("div", {
                class: "paypal-checkout-modal"
            }, jsxDom("div", {
                class: "paypal-checkout-logo"
            }, jsxDom("img", {
                class: "paypal-checkout-logo-pp",
                alt: "pp",
                src: "data:image/svg+xml;base64," + Object(src.a)(ppLogo.toString())
            }), jsxDom("img", {
                class: "paypal-checkout-logo-paypal",
                alt: "paypal",
                src: "data:image/svg+xml;base64," + Object(src.a)(paypalLogo.toString())
            })), jsxDom("div", {
                class: "paypal-checkout-message"
            }, content.windowMessage), jsxDom("div", {
                class: "paypal-checkout-continue"
            }, jsxDom("a", {
                onClick: focus,
                href: "#"
            }, content.continue)), jsxDom("div", {
                class: "paypal-checkout-loader"
            }, jsxDom("div", {
                class: "paypal-spinner"
            }))), jsxDom("div", {
                class: "paypal-checkout-iframe-container"
            }, outlet), jsxDom("style", null, getContainerStyle({
                id: id,
                tag: tag,
                CONTEXT: CONTEXT,
                CLASS: CLASS,
                ANIMATION: ANIMATION
            })));
            var container = jsxDom("html", null, jsxDom("body", null, el));
            on(EVENT.CLOSE, (function() {
                el.className += " " + tag + "-loading";
            }));
            return jsxDom("div", {
                id: id,
                class: "paypal-checkout-sandbox"
            }, jsxDom("style", null, getSandboxStyle({
                id: id,
                ANIMATION: ANIMATION
            })), jsxDom("iframe", {
                title: "PayPal Checkout Overlay",
                name: "__paypal_checkout_sandbox_" + id + "__",
                scrolling: "no",
                class: "paypal-checkout-sandbox-iframe"
            }, container));
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return determineParameterFromToken;
        }));
        __webpack_require__.d(__webpack_exports__, "c", (function() {
            return getPaymentType;
        }));
        __webpack_require__.d(__webpack_exports__, "b", (function() {
            return determineUrl;
        }));
        var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
        var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
        function determineParameterFromToken(token) {
            return token && 0 === token.indexOf("BA-") ? "ba_token" : "token";
        }
        function getPaymentType(payment) {
            return 0 === payment.indexOf("BA-") ? _constants__WEBPACK_IMPORTED_MODULE_1__.C.BA_TOKEN : 0 === payment.indexOf("PAY-") || 0 === payment.indexOf("PAYID-") ? _constants__WEBPACK_IMPORTED_MODULE_1__.C.PAY_ID : (payment.indexOf("EC-"), 
            _constants__WEBPACK_IMPORTED_MODULE_1__.C.EC_TOKEN);
        }
        function determineUrl(env, fundingSource, payment) {
            return getPaymentType(payment) === _constants__WEBPACK_IMPORTED_MODULE_1__.C.BA_TOKEN ? _config__WEBPACK_IMPORTED_MODULE_0__.a.billingUrls[env] : fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.IDEAL || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.BANCONTACT || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.GIROPAY || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.SOFORT || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.EPS || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.MYBANK || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.P24 || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.BLIK || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.MAXIMA || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.BOLETO || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.OXXO || fundingSource === _constants__WEBPACK_IMPORTED_MODULE_1__.v.MERCADOPAGO ? _config__WEBPACK_IMPORTED_MODULE_0__.a.altpayUrls[env] : _config__WEBPACK_IMPORTED_MODULE_0__.a.checkoutUrls[env];
        }
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return containerContent;
        }));
        var containerContent = {
            AT: {
                de: {
                    windowMessage: "Sie sehen das sichere Browserfenster von PayPal nicht? Hier können Sie es wieder öffnen und Ihren Einkauf abschließen.",
                    continue: "Weiter"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ZW: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ZM: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ZA: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            YT: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            YE: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            WS: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            WF: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            VU: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            VG: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            VE: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            VC: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            VA: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            UY: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            UG: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            TZ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            TV: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            TT: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            TO: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            TN: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            TM: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            TJ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            TG: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            TD: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            TC: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            SZ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SV: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            ST: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SR: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            SO: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SN: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            SM: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SL: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SJ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SH: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SC: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            SB: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SA: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            RW: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            RS: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            RE: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            QA: {
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                },
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PY: {
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            PW: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PN: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PM: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PG: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PF: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PE: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            PA: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            OM: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            NU: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            NR: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            NP: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            NI: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            NG: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            NF: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            NE: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            NC: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            NA: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MZ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MW: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MV: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MU: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MT: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MS: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            MR: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MQ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MN: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ML: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            MK: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MH: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MG: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ME: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MD: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MC: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            MA: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            LS: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            LK: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            LI: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            LC: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            LA: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            KZ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            KY: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            KW: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            KN: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            KM: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            KI: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            KH: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            KG: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            KE: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            JO: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            JM: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            IS: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            HR: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            HN: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            GY: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            GW: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            GT: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            GP: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            GN: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            GM: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            GL: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                da: {
                    windowMessage: "Kan du ikke se PayPals sikre browser? Vi hjælper dig med at genstarte vinduet, så du kan betale.",
                    continue: "Fortsæt"
                }
            },
            GI: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            GF: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            GE: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            GD: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            GA: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            FO: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                da: {
                    windowMessage: "Kan du ikke se PayPals sikre browser? Vi hjælper dig med at genstarte vinduet, så du kan betale.",
                    continue: "Fortsæt"
                }
            },
            FM: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            FK: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            FJ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ET: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ER: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            EG: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            EC: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            DZ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            DO: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            DM: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            DJ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            CY: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            CV: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            CR: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            CO: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            CM: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            CL: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            CK: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            CI: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            CG: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            CD: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            BZ: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            BY: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            BW: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            BT: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            BS: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            BO: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            BN: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            BM: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            BJ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            BI: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            BH: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            BG: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            BF: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                }
            },
            BB: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            BA: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            AZ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            AW: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            AO: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            AN: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            AM: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            AL: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            AI: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            AG: {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            AE: {
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                },
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            AD: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            CN: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成付款。  ",
                    continue: "继续"
                }
            },
            GB: {
                fr: {
                    windowMessage: "Vous ne voyez pas le navigateur sécurisé PayPal ? Nous allons vous aider à relancer la fenêtre pour effectuer votre achat.  ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We'll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            AR: {
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                }
            },
            US: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Click to Continue"
                }
            },
            VN: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            UA: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                ru: {
                    windowMessage: "Не отображается безопасная страница PayPal в браузере? Мы поможем вам повторно загрузить окно, чтобы завершить покупку.  ",
                    continue: "Продолжить"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            TW: {
                zh: {
                    windowMessage: "看不到安全連線的 PayPal 瀏覽器？我們將會重新啟動視窗以完成付款。  ",
                    continue: "繼續"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            TR: {
                tr: {
                    windowMessage: "Güvenli PayPal tarayıcısını görmüyor musunuz? Alışverişinizi tamamlamak için pencereyi yeniden başlatmanıza yardımcı olacağız.  ",
                    continue: "Devam"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            TH: {
                th: {
                    windowMessage: "ถ้าคุณไม่เห็นเบราว์เซอร์ที่มีระบบความปลอดภัยของ PayPal เราจะช่วยคุณเปิดหน้าต่างอีกครั้งเพื่อชำระเงินให้เรียบร้อย ",
                    continue: "ดำเนินการต่อ"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            SK: {
                sk: {
                    windowMessage: "Nezobrazuje sa vám zabezpečený prehliadač PayPal? Pomôžeme vám znova otvoriť okno, aby ste mohli nákup dokončiť.  ",
                    continue: "Pokračovať"
                },
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SI: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            SG: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            SE: {
                sv: {
                    windowMessage: "Ser du inte den säkra PayPal-webbläsaren? Vi hjälper dig att starta om fönstret för att slutföra ditt köp. ",
                    continue: "Fortsätt"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            RU: {
                ru: {
                    windowMessage: "Не отображается безопасная страница PayPal в браузере? Мы поможем вам повторно загрузить окно, чтобы завершить покупку.",
                    continue: "Продолжить"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            RO: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PT: {
                pt: {
                    windowMessage: "Não vê a indicação de sessão segura PayPal no browser? Vamos ajudar a reabrir a janela para que possa concluir a sua compra.",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PL: {
                pl: {
                    windowMessage: "Nie widzisz bezpiecznej przeglądarki PayPal? Pomożemy Ci ponownie uruchomić to okno w celu dokonania zakupu.  ",
                    continue: "Kontynuuj"
                },
                en: {
                    windowMessage: "You don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            PH: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            NZ: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成付款。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à relancer la fenêtre pour effectuer votre paiement.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Le ayudaremos a abrir de nuevo la ventana para completar su pago.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            NO: {
                no: {
                    windowMessage: "Ser du ikke den sikre PayPal-nettleseren? Vi hjelper deg med å starte vinduet på nytt så du kan fullføre kjøpet.  ",
                    continue: "Fortsett"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            NL: {
                nl: {
                    windowMessage: "Ziet u geen beveiligde PayPal-browser? We helpen u het venster opnieuw te openen om uw aankoop te voltooien.  ",
                    continue: "Doorgaan"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            MY: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            MX: {
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            LV: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                ru: {
                    windowMessage: "Не отображается безопасная страница PayPal в браузере? Мы поможем вам повторно загрузить окно, чтобы завершить покупку.  ",
                    continue: "Продолжить"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            LU: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                de: {
                    windowMessage: "Das PayPal-Fenster wird nicht angezeigt? Hier können Sie es wieder öffnen und Ihren Einkauf abschließen.",
                    continue: "Weiter"
                }
            },
            LT: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                ru: {
                    windowMessage: "Не отображается безопасная страница PayPal в браузере? Мы поможем вам повторно загрузить окно, чтобы завершить покупку.  ",
                    continue: "Продолжить"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            KR: {
                ko: {
                    windowMessage: "보안 PayPal 브라우저가 보이지 않으신가요? 창을 다시 실행하여 결제를 완료할 수 있도록 도와드리겠습니다.  ",
                    continue: "계속"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            JP: {
                ja: {
                    windowMessage: "セキュアなブラウザが表示されない場合は、ウィンドウを再起動して、支払いを完了できるようお手伝いいたします。",
                    continue: "続行"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            IT: {
                it: {
                    windowMessage: "Non vedi la pagina sicura di PayPal? Ti aiuteremo a riaprire la finestra per completare l'acquisto.  ",
                    continue: "Continua"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            IN: {
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            IL: {
                he: {
                    windowMessage: "לא רואה את דפדפן PayPal המאובטח? נעזור לך לפתוח מחדש את החלון כדי להשלים את הקנייה שלך.  ",
                    continue: "המשך"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            IE: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            HU: {
                hu: {
                    windowMessage: "Nem látja a biztonságos PayPal-böngészőt? Segítünk újra betölteni az ablakot, hogy befejezhesse a vásárlást.  ",
                    continue: "Folytatás"
                },
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ID: {
                id: {
                    windowMessage: "Browser PayPal yang aman tidak terlihat? Kami akan membantu menampilkan ulang jendela untuk menyelesaikan pembayaran Anda.  ",
                    continue: "Lanjutkan"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            HK: {
                zh: {
                    windowMessage: "看不到安全的 PayPal 瀏覽器視窗？我們會助你重新開啟視窗，以完成付款。",
                    continue: "繼續"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            "GROUP-LATAM": {
                zh: {
                    windowMessage: "没看到PayPal付款页面？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas la page de Paiement PayPal ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No puede ver la página de pago de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the PayPal payment page? We’ll help you re-launch the window to complete your purchase.",
                    continue: "Continue"
                }
            },
            "GROUP-EMEA": {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                ru: {
                    windowMessage: "Не отображается безопасная страница PayPal в браузере? Мы поможем вам повторно загрузить окно, чтобы завершить покупку.  ",
                    continue: "Продолжить"
                },
                pt: {
                    windowMessage: "Não vê a indicação de sessão segura PayPal no browser? Vamos ajudar a reabrir a janela para que possa concluir a sua compra.",
                    continue: "Continuar"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                de: {
                    windowMessage: "Sie sehen das sichere Browserfenster von PayPal nicht? Hier können Sie es wieder öffnen und Ihren Einkauf abschließen.",
                    continue: "Weiter"
                },
                da: {
                    windowMessage: "Kan du ikke se PayPals sikre browser? Vi hjælper dig med at genstarte vinduet, så du kan betale.",
                    continue: "Fortsæt"
                },
                ar: {
                    windowMessage: "لا ترى متصفح PayPal الآمن؟ سنساعدك في إعادة فتح النافذة لاستكمال مشترياتك.   ",
                    continue: "متابعة"
                }
            },
            "GROUP-APAC": {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。",
                    continue: "继续"
                },
                ko: {
                    windowMessage: "보안 PayPal 브라우저가 보이지 않으신가요? 창을 다시 실행하여 구매를 완료할 수 있도록 도와드리겠습니다. ",
                    continue: "계속"
                },
                id: {
                    windowMessage: "Browser PayPal yang aman tidak terlihat? Kami akan membantu menampilkan ulang jendela untuk menyelesaikan pembelian Anda. ",
                    continue: "Lanjutkan"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat. ",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda completar su compra. ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don’t see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            GR: {
                el: {
                    windowMessage: "Δεν βλέπετε το ασφαλές πρόγραμμα περιήγησης PayPal; Θα σας βοηθήσουμε να επανεκκινήσετε το παράθυρο για να ολοκληρώσετε την αγορά σας.  ",
                    continue: "Συνέχεια"
                },
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            FR: {
                fr: {
                    windowMessage: "Vous ne voyez pas le navigateur sécurisé PayPal ? Nous allons vous aider à relancer la fenêtre pour effectuer votre achat.  ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            ES: {
                es: {
                    windowMessage: "¿No ve el símbolo de navegación segura de PayPal? Le ayudaremos a abrir de nuevo la ventana para completar la compra. ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            FI: {
                fi: {
                    windowMessage: "Eikö suojattua PayPal-selainta näy? Autamme avaamaan ikkunan uudelleen oston viimeistelyä varten.  ",
                    continue: "Jatka"
                },
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            EE: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                ru: {
                    windowMessage: "Не отображается безопасная страница PayPal в браузере? Мы поможем вам повторно загрузить окно, чтобы завершить покупку.  ",
                    continue: "Продолжить"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            DK: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                da: {
                    windowMessage: "Kan du ikke se PayPals sikre browser? Vi hjælper dig med at genstarte vinduet, så du kan betale.",
                    continue: "Fortsæt"
                }
            },
            CZ: {
                cs: {
                    windowMessage: "Nezobrazuje se vám bezpečný prohlížeč PayPal? Pomůžeme vám okno znovu otevřít, abyste mohli nákup dokončit.",
                    continue: "Pokračovat"
                },
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成购物。  ",
                    continue: "继续"
                },
                fr: {
                    windowMessage: "Le navigateur sécurisé de PayPal n'apparaît pas ? Nous allons vous aider à rouvrir la fenêtre pour finaliser votre achat.",
                    continue: "Continuer"
                },
                es: {
                    windowMessage: "¿No ve el navegador seguro de PayPal? Abriremos la ventana nuevamente para que pueda concluir su compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            DE: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                de: {
                    windowMessage: "Sie sehen das sichere Browserfenster von PayPal nicht? Hier können Sie es wieder öffnen und Ihren Einkauf abschließen.",
                    continue: "Weiter"
                }
            },
            CH: {
                fr: {
                    windowMessage: "Vous ne voyez pas le navigateur sécurisé PayPal ? Nous allons vous aider à relancer la fenêtre pour effectuer votre achat.  ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                },
                de: {
                    windowMessage: "Sie sehen das sichere Browserfenster von PayPal nicht? Hier können Sie es wieder öffnen und Ihren Einkauf abschließen.",
                    continue: "Weiter"
                }
            },
            CA: {
                fr: {
                    windowMessage: "Vous ne voyez pas le navigateur sécurisé de PayPal ? Nous vous aiderons à relancer la fenêtre afin d'effectuer votre achat.  ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you relaunch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            C2: {
                zh: {
                    windowMessage: "没有找到安全的PayPal浏览器？我们将帮助您重启窗口以完成付款。  ",
                    continue: "继续"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your payment.  ",
                    continue: "Continue"
                }
            },
            BE: {
                nl: {
                    windowMessage: "Ziet u de beveiligde PayPal-browser niet? We helpen u het venster opnieuw te openen om uw aankoop te voltooien.  ",
                    continue: "Doorgaan"
                },
                fr: {
                    windowMessage: "Vous ne voyez pas le navigateur sécurisé PayPal ? Nous allons vous aider à relancer la fenêtre pour effectuer votre achat.  ",
                    continue: "Continuer"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            BR: {
                pt: {
                    windowMessage: "Não está vendo o navegador seguro do PayPal? Ajudaremos você a reabrir a janela para concluir a compra.  ",
                    continue: "Continuar"
                },
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We’ll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            },
            AU: {
                en: {
                    windowMessage: "Don't see the secure PayPal browser? We'll help you re-launch the window to complete your purchase.  ",
                    continue: "Continue"
                }
            }
        };
    }, function(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_RESULT__;
        !function() {
            "use strict";
            var root = "object" == typeof window ? window : {};
            !root.HI_BASE32_NO_NODE_JS && "object" == typeof process && process.versions && process.versions.node && (root = window);
            var COMMON_JS = !root.HI_BASE32_NO_COMMON_JS && "object" == typeof module && module.exports;
            var AMD = __webpack_require__(46);
            var BASE32_ENCODE_CHAR = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567".split("");
            var BASE32_DECODE_CHAR = {
                A: 0,
                B: 1,
                C: 2,
                D: 3,
                E: 4,
                F: 5,
                G: 6,
                H: 7,
                I: 8,
                J: 9,
                K: 10,
                L: 11,
                M: 12,
                N: 13,
                O: 14,
                P: 15,
                Q: 16,
                R: 17,
                S: 18,
                T: 19,
                U: 20,
                V: 21,
                W: 22,
                X: 23,
                Y: 24,
                Z: 25,
                2: 26,
                3: 27,
                4: 28,
                5: 29,
                6: 30,
                7: 31
            };
            var blocks = [ 0, 0, 0, 0, 0, 0, 0, 0 ];
            var throwInvalidUtf8 = function(position, partial) {
                partial.length > 10 && (partial = "..." + partial.substr(-10));
                var err = new Error("Decoded data is not valid UTF-8. Maybe try base32.decode.asBytes()? Partial data after reading " + position + " bytes: " + partial + " <-");
                err.position = position;
                throw err;
            };
            var decodeAsBytes = function(base32Str) {
                if ("" === base32Str) return [];
                if (!/^[A-Z2-7=]+$/.test(base32Str)) throw new Error("Invalid base32 characters");
                var v1, v2, v3, v4, v5, v6, v7, v8, bytes = [], index = 0, length = (base32Str = base32Str.replace(/=/g, "")).length;
                for (var i = 0, count = length >> 3 << 3; i < count; ) {
                    v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v8 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    bytes[index++] = 255 & (v1 << 3 | v2 >>> 2);
                    bytes[index++] = 255 & (v2 << 6 | v3 << 1 | v4 >>> 4);
                    bytes[index++] = 255 & (v4 << 4 | v5 >>> 1);
                    bytes[index++] = 255 & (v5 << 7 | v6 << 2 | v7 >>> 3);
                    bytes[index++] = 255 & (v7 << 5 | v8);
                }
                var remain = length - count;
                if (2 === remain) {
                    v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    bytes[index++] = 255 & (v1 << 3 | v2 >>> 2);
                } else if (4 === remain) {
                    v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    bytes[index++] = 255 & (v1 << 3 | v2 >>> 2);
                    bytes[index++] = 255 & (v2 << 6 | v3 << 1 | v4 >>> 4);
                } else if (5 === remain) {
                    v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    bytes[index++] = 255 & (v1 << 3 | v2 >>> 2);
                    bytes[index++] = 255 & (v2 << 6 | v3 << 1 | v4 >>> 4);
                    bytes[index++] = 255 & (v4 << 4 | v5 >>> 1);
                } else if (7 === remain) {
                    v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    bytes[index++] = 255 & (v1 << 3 | v2 >>> 2);
                    bytes[index++] = 255 & (v2 << 6 | v3 << 1 | v4 >>> 4);
                    bytes[index++] = 255 & (v4 << 4 | v5 >>> 1);
                    bytes[index++] = 255 & (v5 << 7 | v6 << 2 | v7 >>> 3);
                }
                return bytes;
            };
            var decode = function(base32Str, asciiOnly) {
                if (!asciiOnly) return function(bytes) {
                    var b, c, str = "", length = bytes.length, i = 0, followingChars = 0;
                    for (;i < length; ) if ((b = bytes[i++]) <= 127) str += String.fromCharCode(b); else {
                        if (b > 191 && b <= 223) {
                            c = 31 & b;
                            followingChars = 1;
                        } else if (b <= 239) {
                            c = 15 & b;
                            followingChars = 2;
                        } else if (b <= 247) {
                            c = 7 & b;
                            followingChars = 3;
                        } else throwInvalidUtf8(i, str);
                        for (var j = 0; j < followingChars; ++j) {
                            ((b = bytes[i++]) < 128 || b > 191) && throwInvalidUtf8(i, str);
                            c <<= 6;
                            c += 63 & b;
                        }
                        c >= 55296 && c <= 57343 && throwInvalidUtf8(i, str);
                        c > 1114111 && throwInvalidUtf8(i, str);
                        if (c <= 65535) str += String.fromCharCode(c); else {
                            c -= 65536;
                            str += String.fromCharCode(55296 + (c >> 10));
                            str += String.fromCharCode(56320 + (1023 & c));
                        }
                    }
                    return str;
                }(decodeAsBytes(base32Str));
                if ("" === base32Str) return "";
                if (!/^[A-Z2-7=]+$/.test(base32Str)) throw new Error("Invalid base32 characters");
                var v1, v2, v3, v4, v5, v6, v7, v8, str = "", length = base32Str.indexOf("=");
                -1 === length && (length = base32Str.length);
                for (var i = 0, count = length >> 3 << 3; i < count; ) {
                    v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v8 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2)) + String.fromCharCode(255 & (v2 << 6 | v3 << 1 | v4 >>> 4)) + String.fromCharCode(255 & (v4 << 4 | v5 >>> 1)) + String.fromCharCode(255 & (v5 << 7 | v6 << 2 | v7 >>> 3)) + String.fromCharCode(255 & (v7 << 5 | v8));
                }
                var remain = length - count;
                if (2 === remain) {
                    v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2));
                } else if (4 === remain) {
                    v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2)) + String.fromCharCode(255 & (v2 << 6 | v3 << 1 | v4 >>> 4));
                } else if (5 === remain) {
                    v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2)) + String.fromCharCode(255 & (v2 << 6 | v3 << 1 | v4 >>> 4)) + String.fromCharCode(255 & (v4 << 4 | v5 >>> 1));
                } else if (7 === remain) {
                    v1 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v2 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v3 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v4 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v5 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v6 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    v7 = BASE32_DECODE_CHAR[base32Str.charAt(i++)];
                    str += String.fromCharCode(255 & (v1 << 3 | v2 >>> 2)) + String.fromCharCode(255 & (v2 << 6 | v3 << 1 | v4 >>> 4)) + String.fromCharCode(255 & (v4 << 4 | v5 >>> 1)) + String.fromCharCode(255 & (v5 << 7 | v6 << 2 | v7 >>> 3));
                }
                return str;
            };
            var exports = {
                encode: function(input, asciiOnly) {
                    var notString = "string" != typeof input;
                    notString && input.constructor === ArrayBuffer && (input = new Uint8Array(input));
                    return notString ? function(bytes) {
                        var v1, v2, v3, v4, v5, base32Str = "", length = bytes.length;
                        for (var i = 0, count = 5 * parseInt(length / 5); i < count; ) {
                            v1 = bytes[i++];
                            v2 = bytes[i++];
                            v3 = bytes[i++];
                            v4 = bytes[i++];
                            v5 = bytes[i++];
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | v4 >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[31 & (v4 << 3 | v5 >>> 5)] + BASE32_ENCODE_CHAR[31 & v5];
                        }
                        var remain = length - count;
                        if (1 === remain) base32Str += BASE32_ENCODE_CHAR[(v1 = bytes[i]) >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======"; else if (2 === remain) {
                            v1 = bytes[i++];
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | (v2 = bytes[i]) >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
                        } else if (3 === remain) {
                            v1 = bytes[i++];
                            v2 = bytes[i++];
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | (v3 = bytes[i]) >>> 4)] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
                        } else if (4 === remain) {
                            v1 = bytes[i++];
                            v2 = bytes[i++];
                            v3 = bytes[i++];
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | (v4 = bytes[i]) >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
                        }
                        return base32Str;
                    }(input) : asciiOnly ? function(str) {
                        var v1, v2, v3, v4, v5, base32Str = "", length = str.length;
                        for (var i = 0, count = 5 * parseInt(length / 5); i < count; ) {
                            v1 = str.charCodeAt(i++);
                            v2 = str.charCodeAt(i++);
                            v3 = str.charCodeAt(i++);
                            v4 = str.charCodeAt(i++);
                            v5 = str.charCodeAt(i++);
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | v4 >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[31 & (v4 << 3 | v5 >>> 5)] + BASE32_ENCODE_CHAR[31 & v5];
                        }
                        var remain = length - count;
                        if (1 === remain) {
                            v1 = str.charCodeAt(i);
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
                        } else if (2 === remain) {
                            v1 = str.charCodeAt(i++);
                            v2 = str.charCodeAt(i);
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
                        } else if (3 === remain) {
                            v1 = str.charCodeAt(i++);
                            v2 = str.charCodeAt(i++);
                            v3 = str.charCodeAt(i);
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
                        } else if (4 === remain) {
                            v1 = str.charCodeAt(i++);
                            v2 = str.charCodeAt(i++);
                            v3 = str.charCodeAt(i++);
                            v4 = str.charCodeAt(i);
                            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | v2 >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | v3 >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | v4 >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
                        }
                        return base32Str;
                    }(input) : function(str) {
                        var v1, v2, v3, v4, v5, code, i, end = !1, base32Str = "", index = 0, start = 0, length = str.length;
                        if ("" === str) return base32Str;
                        do {
                            blocks[0] = blocks[5];
                            blocks[1] = blocks[6];
                            blocks[2] = blocks[7];
                            for (i = start; index < length && i < 5; ++index) if ((code = str.charCodeAt(index)) < 128) blocks[i++] = code; else if (code < 2048) {
                                blocks[i++] = 192 | code >> 6;
                                blocks[i++] = 128 | 63 & code;
                            } else if (code < 55296 || code >= 57344) {
                                blocks[i++] = 224 | code >> 12;
                                blocks[i++] = 128 | code >> 6 & 63;
                                blocks[i++] = 128 | 63 & code;
                            } else {
                                code = 65536 + ((1023 & code) << 10 | 1023 & str.charCodeAt(++index));
                                blocks[i++] = 240 | code >> 18;
                                blocks[i++] = 128 | code >> 12 & 63;
                                blocks[i++] = 128 | code >> 6 & 63;
                                blocks[i++] = 128 | 63 & code;
                            }
                            start = i - 5;
                            index === length && ++index;
                            index > length && i < 6 && (end = !0);
                            v1 = blocks[0];
                            base32Str += i > 4 ? BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | (v2 = blocks[1]) >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | (v3 = blocks[2]) >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | (v4 = blocks[3]) >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[31 & (v4 << 3 | (v5 = blocks[4]) >>> 5)] + BASE32_ENCODE_CHAR[31 & v5] : 1 === i ? BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======" : 2 === i ? BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | (v2 = blocks[1]) >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====" : 3 === i ? BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | (v2 = blocks[1]) >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | (v3 = blocks[2]) >>> 4)] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===" : BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[31 & (v1 << 2 | (v2 = blocks[1]) >>> 6)] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[31 & (v2 << 4 | (v3 = blocks[2]) >>> 4)] + BASE32_ENCODE_CHAR[31 & (v3 << 1 | (v4 = blocks[3]) >>> 7)] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
                        } while (!end);
                        return base32Str;
                    }(input);
                },
                decode: decode
            };
            decode.asBytes = decodeAsBytes;
            if (COMMON_JS) module.exports = exports; else {
                root.base32 = exports;
                AMD && void 0 !== (__WEBPACK_AMD_DEFINE_RESULT__ = function() {
                    return exports;
                }.call(exports, __webpack_require__, exports, module)) && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__);
            }
        }();
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return script;
        }));
        var script = {
            global: function() {
                return window.document;
            },
            register: function register(component, document) {
                function render(element) {
                    if (element && element.tagName && "script" === element.tagName.toLowerCase() && element.attributes.type && "application/x-component" === element.attributes.type.value && element.parentNode) {
                        var tag = element.getAttribute("data-component");
                        if (tag && tag === component.tag) {
                            component.log("instantiate_script_component");
                            var props = element.innerText ? eval("(" + element.innerText + ")") : {};
                            var container = document.createElement("div");
                            if (!element.parentNode) throw new Error("Element has no parent");
                            element.parentNode.replaceChild(container, element);
                            component.render(props, container);
                        }
                    }
                }
                function scan() {
                    var scriptTags = [].slice.call(document.getElementsByTagName("script"));
                    for (var _i2 = 0; _i2 < scriptTags.length; _i2++) render(scriptTags[_i2]);
                }
                scan();
                document.addEventListener("DOMContentLoaded", scan);
                window.addEventListener("load", scan);
                document.addEventListener("DOMNodeInserted", (function(event) {
                    render(event.target);
                }));
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return react;
        }));
        var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21);
        var _lib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
        var react = {
            global: function() {
                if (window.React && window.ReactDOM) return {
                    React: window.React,
                    ReactDOM: window.ReactDOM
                };
            },
            register: function(component, _ref) {
                var React = _ref.React, ReactDOM = _ref.ReactDOM;
                component.react = React.createClass ? React.createClass({
                    displayName: "react",
                    render: function() {
                        return React.createElement("div", null);
                    },
                    componentDidMount: function() {
                        component.log("instantiate_react_component");
                        var el = ReactDOM.findDOMNode(this);
                        var parent = component.init(Object(_lib__WEBPACK_IMPORTED_MODULE_1__.q)({}, this.props), null, el);
                        this.setState({
                            parent: parent
                        });
                        parent.render(el);
                    },
                    componentDidUpdate: function() {
                        this.state && this.state.parent && this.state.parent.updateProps(Object(_lib__WEBPACK_IMPORTED_MODULE_1__.q)({}, this.props));
                    },
                    componentWillUnmount: function() {
                        this.state && this.state.parent && this.state.parent.destroy();
                    }
                }) : function(_React$Component) {
                    Object(_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_0__.a)(_class, _React$Component);
                    function _class() {
                        return _React$Component.apply(this, arguments) || this;
                    }
                    var _proto = _class.prototype;
                    _proto.render = function() {
                        return React.createElement("div", null);
                    };
                    _proto.componentDidMount = function() {
                        component.log("instantiate_react_component");
                        var el = ReactDOM.findDOMNode(this);
                        var parent = component.init(Object(_lib__WEBPACK_IMPORTED_MODULE_1__.q)({}, this.props), null, el);
                        this.setState({
                            parent: parent
                        });
                        parent.render(el);
                    };
                    _proto.componentDidUpdate = function() {
                        this.state && this.state.parent && this.state.parent.updateProps(Object(_lib__WEBPACK_IMPORTED_MODULE_1__.q)({}, this.props));
                    };
                    _proto.componentWillUnmount = function() {
                        this.state && this.state.parent && this.state.parent.destroy();
                    };
                    return _class;
                }(React.Component);
                return component.react;
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return vue;
        }));
        var _lib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
        var vue = {
            global: function() {},
            register: function(component) {
                return {
                    render: function(createElement) {
                        return createElement("div");
                    },
                    inheritAttrs: !1,
                    mounted: function() {
                        var el = this.$el;
                        this.parent = component.init(Object(_lib__WEBPACK_IMPORTED_MODULE_0__.q)({}, this.$attrs), null, el);
                        this.parent.render(el);
                    },
                    beforeUpdate: function() {
                        this.parent && this.$attrs && this.parent.updateProps(Object(_lib__WEBPACK_IMPORTED_MODULE_0__.q)({}, this.$attrs));
                    }
                };
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return angular;
        }));
        var _lib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
        var angular = {
            global: function() {
                return window.angular;
            },
            register: function(component, ng) {
                return ng.module(component.tag, []).directive(Object(_lib__WEBPACK_IMPORTED_MODULE_0__.h)(component.tag), (function() {
                    var scope = {};
                    for (var _i2 = 0, _component$getPropNam2 = component.getPropNames(); _i2 < _component$getPropNam2.length; _i2++) scope[_component$getPropNam2[_i2]] = "=";
                    component.looseProps && (scope.props = "=");
                    return {
                        scope: scope,
                        restrict: "E",
                        controller: [ "$scope", "$element", function($scope, $element) {
                            if (component.looseProps && !$scope.props) throw new Error("For angular bindings to work, prop definitions must be passed to zoid.create");
                            component.log("instantiate_angular_component");
                            function safeApply() {
                                if ("$apply" !== $scope.$root.$$phase && "$digest" !== $scope.$root.$$phase) try {
                                    $scope.$apply();
                                } catch (err) {}
                            }
                            var getProps = function() {
                                var scopeProps;
                                if ($scope.props) scopeProps = $scope.props; else {
                                    scopeProps = {};
                                    for (var _i4 = 0, _Object$keys2 = Object.keys(scope); _i4 < _Object$keys2.length; _i4++) {
                                        var _key = _Object$keys2[_i4];
                                        void 0 !== $scope[_key] && (scopeProps[_key] = $scope[_key]);
                                    }
                                }
                                return Object(_lib__WEBPACK_IMPORTED_MODULE_0__.M)(scopeProps, {
                                    function: function(value) {
                                        return function() {
                                            var result = value.apply(this, arguments);
                                            safeApply();
                                            return result;
                                        };
                                    }
                                });
                            };
                            var parent = component.init(getProps(), null, $element[0]);
                            parent.render($element[0]);
                            $scope.$watch((function() {
                                parent.updateProps(getProps());
                            }));
                        } ]
                    };
                }));
            }
        };
    }, function(module, exports) {}, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return glimmer;
        }));
        var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13);
        var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21);
        var glimmer = {
            global: function() {},
            register: function(component, GlimmerComponent) {
                return function(_GlimmerComponent) {
                    Object(_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_1__.a)(_class, _GlimmerComponent);
                    function _class() {
                        return _GlimmerComponent.apply(this, arguments) || this;
                    }
                    _class.prototype.didInsertElement = function() {
                        component.render(Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__.a)({}, this.args), this.element);
                    };
                    return _class;
                }(GlimmerComponent);
            }
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.d(__webpack_exports__, "a", (function() {
            return angular2;
        }));
        var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13);
        var _lib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
        var angular2 = {
            global: function() {},
            register: function(zoid, _ref) {
                var AngularComponent = _ref.Component, NgModule = _ref.NgModule, ElementRef = _ref.ElementRef, NgZone = _ref.NgZone;
                zoid.log("initializing angular2 component");
                var getProps = function(component) {
                    return Object(_lib__WEBPACK_IMPORTED_MODULE_1__.M)(Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__.a)({}, component.internalProps, component.props), {
                        function: function(value) {
                            if ("function" == typeof value) return function() {
                                var _arguments = arguments, _this = this;
                                return component.zone.run((function() {
                                    return value.apply(_this, _arguments);
                                }));
                            };
                        }
                    });
                };
                var ComponentInstance = AngularComponent({
                    selector: zoid.tag,
                    template: "<div></div>",
                    inputs: [ "props" ]
                }).Class({
                    constructor: [ ElementRef, NgZone, function(elementRef, zone) {
                        this.elementRef = elementRef;
                        this.zone = zone;
                    } ],
                    ngOnInit: function() {
                        var targetElement = this.elementRef.nativeElement;
                        var parent = zoid.init(getProps(this), null, targetElement);
                        parent.render(targetElement);
                        this.parent = parent;
                    },
                    ngOnChanges: function() {
                        this.parent && this.parent.updateProps(getProps(this));
                    }
                });
                return NgModule({
                    declarations: [ ComponentInstance ],
                    exports: [ ComponentInstance ]
                }).Class({
                    constructor: function() {}
                });
            }
        };
    }, function(module, exports, __webpack_require__) {
        !function(e, t, n) {
            module.exports ? module.exports = n() : __webpack_require__(47)("bowser", n);
        }(0, 0, (function() {
            function t(t) {
                function n(e) {
                    var n = t.match(e);
                    return n && n.length > 1 && n[1] || "";
                }
                function r(e) {
                    var n = t.match(e);
                    return n && n.length > 1 && n[2] || "";
                }
                var N, i = n(/(ipod|iphone|ipad)/i).toLowerCase(), u = !/like android/i.test(t) && /android/i.test(t), a = /nexus\s*[0-6]\s*/i.test(t), f = !a && /nexus\s*[0-9]+/i.test(t), l = /CrOS/.test(t), c = /silk/i.test(t), h = /sailfish/i.test(t), p = /tizen/i.test(t), d = /(web|hpw)(o|0)s/i.test(t), v = /windows phone/i.test(t), g = (/SamsungBrowser/i.test(t), 
                !v && /windows/i.test(t)), y = !i && !c && /macintosh/i.test(t), b = !u && !h && !p && !d && /linux/i.test(t), w = r(/edg([ea]|ios)\/(\d+(\.\d+)?)/i), E = n(/version\/(\d+(\.\d+)?)/i), S = /tablet/i.test(t) && !/tablet pc/i.test(t), x = !S && /[^-]mobi/i.test(t), T = /xbox/i.test(t);
                /opera/i.test(t) ? N = {
                    name: "Opera",
                    opera: e,
                    version: E || n(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
                } : /opr\/|opios/i.test(t) ? N = {
                    name: "Opera",
                    opera: e,
                    version: n(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || E
                } : /SamsungBrowser/i.test(t) ? N = {
                    name: "Samsung Internet for Android",
                    samsungBrowser: e,
                    version: E || n(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
                } : /Whale/i.test(t) ? N = {
                    name: "NAVER Whale browser",
                    whale: e,
                    version: n(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
                } : /MZBrowser/i.test(t) ? N = {
                    name: "MZ Browser",
                    mzbrowser: e,
                    version: n(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
                } : /coast/i.test(t) ? N = {
                    name: "Opera Coast",
                    coast: e,
                    version: E || n(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
                } : /focus/i.test(t) ? N = {
                    name: "Focus",
                    focus: e,
                    version: n(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
                } : /yabrowser/i.test(t) ? N = {
                    name: "Yandex Browser",
                    yandexbrowser: e,
                    version: E || n(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
                } : /ucbrowser/i.test(t) ? N = {
                    name: "UC Browser",
                    ucbrowser: e,
                    version: n(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
                } : /mxios/i.test(t) ? N = {
                    name: "Maxthon",
                    maxthon: e,
                    version: n(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
                } : /epiphany/i.test(t) ? N = {
                    name: "Epiphany",
                    epiphany: e,
                    version: n(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
                } : /puffin/i.test(t) ? N = {
                    name: "Puffin",
                    puffin: e,
                    version: n(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
                } : /sleipnir/i.test(t) ? N = {
                    name: "Sleipnir",
                    sleipnir: e,
                    version: n(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
                } : /k-meleon/i.test(t) ? N = {
                    name: "K-Meleon",
                    kMeleon: e,
                    version: n(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
                } : v ? (N = {
                    name: "Windows Phone",
                    osname: "Windows Phone",
                    windowsphone: e
                }, w ? (N.msedge = e, N.version = w) : (N.msie = e, N.version = n(/iemobile\/(\d+(\.\d+)?)/i))) : /msie|trident/i.test(t) ? N = {
                    name: "Internet Explorer",
                    msie: e,
                    version: n(/(?:msie |rv:)(\d+(\.\d+)?)/i)
                } : l ? N = {
                    name: "Chrome",
                    osname: "Chrome OS",
                    chromeos: e,
                    chromeBook: e,
                    chrome: e,
                    version: n(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
                } : /edg([ea]|ios)/i.test(t) ? N = {
                    name: "Microsoft Edge",
                    msedge: e,
                    version: w
                } : /vivaldi/i.test(t) ? N = {
                    name: "Vivaldi",
                    vivaldi: e,
                    version: n(/vivaldi\/(\d+(\.\d+)?)/i) || E
                } : h ? N = {
                    name: "Sailfish",
                    osname: "Sailfish OS",
                    sailfish: e,
                    version: n(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
                } : /seamonkey\//i.test(t) ? N = {
                    name: "SeaMonkey",
                    seamonkey: e,
                    version: n(/seamonkey\/(\d+(\.\d+)?)/i)
                } : /firefox|iceweasel|fxios/i.test(t) ? (N = {
                    name: "Firefox",
                    firefox: e,
                    version: n(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
                }, /\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(t) && (N.firefoxos = e, N.osname = "Firefox OS")) : c ? N = {
                    name: "Amazon Silk",
                    silk: e,
                    version: n(/silk\/(\d+(\.\d+)?)/i)
                } : /phantom/i.test(t) ? N = {
                    name: "PhantomJS",
                    phantom: e,
                    version: n(/phantomjs\/(\d+(\.\d+)?)/i)
                } : /slimerjs/i.test(t) ? N = {
                    name: "SlimerJS",
                    slimer: e,
                    version: n(/slimerjs\/(\d+(\.\d+)?)/i)
                } : /blackberry|\bbb\d+/i.test(t) || /rim\stablet/i.test(t) ? N = {
                    name: "BlackBerry",
                    osname: "BlackBerry OS",
                    blackberry: e,
                    version: E || n(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
                } : d ? (N = {
                    name: "WebOS",
                    osname: "WebOS",
                    webos: e,
                    version: E || n(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
                }, /touchpad\//i.test(t) && (N.touchpad = e)) : /bada/i.test(t) ? N = {
                    name: "Bada",
                    osname: "Bada",
                    bada: e,
                    version: n(/dolfin\/(\d+(\.\d+)?)/i)
                } : p ? N = {
                    name: "Tizen",
                    osname: "Tizen",
                    tizen: e,
                    version: n(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || E
                } : /qupzilla/i.test(t) ? N = {
                    name: "QupZilla",
                    qupzilla: e,
                    version: n(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || E
                } : /chromium/i.test(t) ? N = {
                    name: "Chromium",
                    chromium: e,
                    version: n(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || E
                } : /chrome|crios|crmo/i.test(t) ? N = {
                    name: "Chrome",
                    chrome: e,
                    version: n(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
                } : u ? N = {
                    name: "Android",
                    version: E
                } : /safari|applewebkit/i.test(t) ? (N = {
                    name: "Safari",
                    safari: e
                }, E && (N.version = E)) : i ? (N = {
                    name: "iphone" == i ? "iPhone" : "ipad" == i ? "iPad" : "iPod"
                }, E && (N.version = E)) : N = /googlebot/i.test(t) ? {
                    name: "Googlebot",
                    googlebot: e,
                    version: n(/googlebot\/(\d+(\.\d+))/i) || E
                } : {
                    name: n(/^(.*)\/(.*) /),
                    version: r(/^(.*)\/(.*) /)
                }, !N.msedge && /(apple)?webkit/i.test(t) ? (/(apple)?webkit\/537\.36/i.test(t) ? (N.name = N.name || "Blink", 
                N.blink = e) : (N.name = N.name || "Webkit", N.webkit = e), !N.version && E && (N.version = E)) : !N.opera && /gecko\//i.test(t) && (N.name = N.name || "Gecko", 
                N.gecko = e, N.version = N.version || n(/gecko\/(\d+(\.\d+)?)/i)), N.windowsphone || !u && !N.silk ? !N.windowsphone && i ? (N[i] = e, 
                N.ios = e, N.osname = "iOS") : y ? (N.mac = e, N.osname = "macOS") : T ? (N.xbox = e, 
                N.osname = "Xbox") : g ? (N.windows = e, N.osname = "Windows") : b && (N.linux = e, 
                N.osname = "Linux") : (N.android = e, N.osname = "Android");
                var k = "";
                N.windows ? k = function(e) {
                    switch (e) {
                      case "NT":
                        return "NT";

                      case "XP":
                        return "XP";

                      case "NT 5.0":
                        return "2000";

                      case "NT 5.1":
                        return "XP";

                      case "NT 5.2":
                        return "2003";

                      case "NT 6.0":
                        return "Vista";

                      case "NT 6.1":
                        return "7";

                      case "NT 6.2":
                        return "8";

                      case "NT 6.3":
                        return "8.1";

                      case "NT 10.0":
                        return "10";

                      default:
                        return;
                    }
                }(n(/Windows ((NT|XP)( \d\d?.\d)?)/i)) : N.windowsphone ? k = n(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i) : N.mac ? k = (k = n(/Mac OS X (\d+([_\.\s]\d+)*)/i)).replace(/[_\s]/g, ".") : i ? k = (k = n(/os (\d+([_\s]\d+)*) like mac os x/i)).replace(/[_\s]/g, ".") : u ? k = n(/android[ \/-](\d+(\.\d+)*)/i) : N.webos ? k = n(/(?:web|hpw)os\/(\d+(\.\d+)*)/i) : N.blackberry ? k = n(/rim\stablet\sos\s(\d+(\.\d+)*)/i) : N.bada ? k = n(/bada\/(\d+(\.\d+)*)/i) : N.tizen && (k = n(/tizen[\/\s](\d+(\.\d+)*)/i)), 
                k && (N.osversion = k);
                var L = !N.windows && k.split(".")[0];
                S || f || "ipad" == i || u && (3 == L || L >= 4 && !x) || N.silk ? N.tablet = e : (x || "iphone" == i || "ipod" == i || u || a || N.blackberry || N.webos || N.bada) && (N.mobile = e);
                return N.msedge || N.msie && N.version >= 10 || N.yandexbrowser && N.version >= 15 || N.vivaldi && N.version >= 1 || N.chrome && N.version >= 20 || N.samsungBrowser && N.version >= 4 || N.whale && 1 === s([ N.version, "1.0" ]) || N.mzbrowser && 1 === s([ N.version, "6.0" ]) || N.focus && 1 === s([ N.version, "1.0" ]) || N.firefox && N.version >= 20 || N.safari && N.version >= 6 || N.opera && N.version >= 10 || N.ios && N.osversion && N.osversion.split(".")[0] >= 6 || N.blackberry && N.version >= 10.1 || N.chromium && N.version >= 20 ? N.a = e : N.msie && N.version < 10 || N.chrome && N.version < 20 || N.firefox && N.version < 20 || N.safari && N.version < 6 || N.opera && N.version < 10 || N.ios && N.osversion && N.osversion.split(".")[0] < 6 || N.chromium && N.version < 20 ? N.c = e : N.x = e, 
                N;
            }
            function r(e) {
                return e.split(".").length;
            }
            function i(e, t) {
                var r, n = [];
                if ([].map) return [].map.call(e, t);
                for (r = 0; r < e.length; r++) n.push(t(e[r]));
                return n;
            }
            function s(e) {
                var t = Math.max(r(e[0]), r(e[1])), n = i(e, (function(e) {
                    var n = t - r(e);
                    return i((e += new Array(n + 1).join(".0")).split("."), (function(e) {
                        return new Array(20 - e.length).join("0") + e;
                    })).reverse();
                }));
                for (;--t >= 0; ) {
                    if (n[0][t] > n[1][t]) return 1;
                    if (n[0][t] !== n[1][t]) return -1;
                    if (0 === t) return 0;
                }
            }
            function o(e, r, i) {
                var o = n;
                "string" == typeof r && (i = r, r = void 0), void 0 === r && (r = !1), i && (o = t(i));
                var u = "" + o.version;
                for (var a in e) if (e.hasOwnProperty(a) && o[a]) {
                    if ("string" != typeof e[a]) throw new Error("Browser version in the minVersion map should be a string: " + a + ": " + String(e));
                    return s([ u, e[a] ]) < 0;
                }
                return r;
            }
            var e = !0, n = t("undefined" != typeof navigator && navigator.userAgent || "");
            return n.test = function(e) {
                for (var t = 0; t < e.length; ++t) {
                    var r = e[t];
                    if ("string" == typeof r && r in n) return !0;
                }
                return !1;
            }, n.isUnsupportedBrowser = o, n.compareVersions = s, n.check = function(e, t, n) {
                return !o(e, t, n);
            }, n._detect = t, n.detect = t, n;
        }));
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        __webpack_require__.d(__webpack_exports__, "emulateIERestrictions", (function() {
            return emulateIERestrictions;
        }));
        var src = __webpack_require__(7);
        var conf = __webpack_require__(10);
        function emulateIERestrictions(sourceWindow, targetWindow) {
            if (!conf.a.ALLOW_POSTMESSAGE_POPUP && !1 === Object(src.w)(sourceWindow, targetWindow)) throw new Error("Can not send and receive post messages between two different windows (disabled to emulate IE)");
        }
    }, function(module, exports) {
        var k_r_submitter = /^(?:submit|button|image|reset|file)$/i;
        var k_r_success_contrls = /^(?:input|select|textarea|keygen)/i;
        var brackets = /(\[[^\[\]]*\])/g;
        function hash_serializer(result, key, value) {
            if (key.match(brackets)) !function hash_assign(result, keys, value) {
                if (0 === keys.length) return value;
                var key = keys.shift();
                var between = key.match(/^\[(.+?)\]$/);
                if ("[]" === key) {
                    result = result || [];
                    if (Array.isArray(result)) result.push(hash_assign(null, keys, value)); else {
                        result._values = result._values || [];
                        result._values.push(hash_assign(null, keys, value));
                    }
                    return result;
                }
                if (between) {
                    var string = between[1];
                    var index = +string;
                    isNaN(index) ? (result = result || {})[string] = hash_assign(result[string], keys, value) : (result = result || [])[index] = hash_assign(result[index], keys, value);
                } else result[key] = hash_assign(result[key], keys, value);
                return result;
            }(result, function(string) {
                var keys = [];
                var children = new RegExp(brackets);
                var match = /^([^\[\]]*)/.exec(string);
                match[1] && keys.push(match[1]);
                for (;null !== (match = children.exec(string)); ) keys.push(match[1]);
                return keys;
            }(key), value); else {
                var existing = result[key];
                if (existing) {
                    Array.isArray(existing) || (result[key] = [ existing ]);
                    result[key].push(value);
                } else result[key] = value;
            }
            return result;
        }
        function str_serialize(result, key, value) {
            value = value.replace(/(\r)?\n/g, "\r\n");
            value = (value = encodeURIComponent(value)).replace(/%20/g, "+");
            return result + (result ? "&" : "") + encodeURIComponent(key) + "=" + value;
        }
        module.exports = function(form, options) {
            "object" != typeof options ? options = {
                hash: !!options
            } : void 0 === options.hash && (options.hash = !0);
            var result = options.hash ? {} : "";
            var serializer = options.serializer || (options.hash ? hash_serializer : str_serialize);
            var elements = form && form.elements ? form.elements : [];
            var radio_store = Object.create(null);
            for (var i = 0; i < elements.length; ++i) {
                var element = elements[i];
                if ((options.disabled || !element.disabled) && element.name && k_r_success_contrls.test(element.nodeName) && !k_r_submitter.test(element.type)) {
                    var key = element.name;
                    var val = element.value;
                    "checkbox" !== element.type && "radio" !== element.type || element.checked || (val = void 0);
                    if (options.empty) {
                        "checkbox" !== element.type || element.checked || (val = "");
                        "radio" === element.type && (radio_store[element.name] || element.checked ? element.checked && (radio_store[element.name] = !0) : radio_store[element.name] = !1);
                        if (null == val && "radio" == element.type) continue;
                    } else if (!val) continue;
                    if ("select-multiple" !== element.type) result = serializer(result, key, val); else {
                        val = [];
                        var selectOptions = element.options;
                        var isSelectedOptions = !1;
                        for (var j = 0; j < selectOptions.length; ++j) {
                            var option = selectOptions[j];
                            if (option.selected && (option.value || options.empty && !option.value)) {
                                isSelectedOptions = !0;
                                result = options.hash && "[]" !== key.slice(key.length - 2) ? serializer(result, key + "[]", option.value) : serializer(result, key, option.value);
                            }
                        }
                        !isSelectedOptions && options.empty && (result = serializer(result, key, ""));
                    }
                }
            }
            if (options.empty) for (var key in radio_store) radio_store[key] || (result = serializer(result, key, ""));
            return result;
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        var _index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23);
        __webpack_require__.d(__webpack_exports__, "openBridge", (function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.openBridge;
        }));
        __webpack_require__.d(__webpack_exports__, "linkUrl", (function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.linkUrl;
        }));
        __webpack_require__.d(__webpack_exports__, "isBridge", (function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.isBridge;
        }));
        __webpack_require__.d(__webpack_exports__, "needsBridge", (function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.needsBridge;
        }));
        __webpack_require__.d(__webpack_exports__, "needsBridgeForBrowser", (function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.needsBridgeForBrowser;
        }));
        __webpack_require__.d(__webpack_exports__, "hasBridge", (function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.hasBridge;
        }));
        __webpack_require__.d(__webpack_exports__, "needsBridgeForWin", (function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.needsBridgeForWin;
        }));
        __webpack_require__.d(__webpack_exports__, "needsBridgeForDomain", (function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.needsBridgeForDomain;
        }));
        __webpack_require__.d(__webpack_exports__, "openTunnelToOpener", (function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.openTunnelToOpener;
        }));
        __webpack_require__.d(__webpack_exports__, "destroyBridges", (function() {
            return _index__WEBPACK_IMPORTED_MODULE_0__.destroyBridges;
        }));
    }, function(module, exports) {
        (function(__webpack_amd_options__) {
            module.exports = __webpack_amd_options__;
        }).call(this, {});
    }, function(module, exports) {
        module.exports = function() {
            throw new Error("define cannot be used indirect");
        };
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        __webpack_require__.d(__webpack_exports__, "postRobot", (function() {
            return postRobot;
        }));
        __webpack_require__.d(__webpack_exports__, "Promise", (function() {
            return zalgo_promise_src.a;
        }));
        __webpack_require__.d(__webpack_exports__, "PopupOpenError", (function() {
            return src.b;
        }));
        __webpack_require__.d(__webpack_exports__, "rest", (function() {
            return rest;
        }));
        __webpack_require__.d(__webpack_exports__, "Button", (function() {
            return component_Button;
        }));
        __webpack_require__.d(__webpack_exports__, "Card", (function() {
            return Card;
        }));
        __webpack_require__.d(__webpack_exports__, "setup", (function() {
            return setup;
        }));
        __webpack_require__.d(__webpack_exports__, "config", (function() {
            return config.a;
        }));
        __webpack_require__.d(__webpack_exports__, "ENV", (function() {
            return constants.t;
        }));
        __webpack_require__.d(__webpack_exports__, "USERS", (function() {
            return constants.G;
        }));
        __webpack_require__.d(__webpack_exports__, "SOURCE", (function() {
            return constants.F;
        }));
        __webpack_require__.d(__webpack_exports__, "FUNDING", (function() {
            return constants.v;
        }));
        __webpack_require__.d(__webpack_exports__, "CARD", (function() {
            return constants.o;
        }));
        __webpack_require__.d(__webpack_exports__, "request", (function() {
            return lib.Q;
        }));
        __webpack_require__.d(__webpack_exports__, "isEligible", (function() {
            return lib.C;
        }));
        __webpack_require__.d(__webpack_exports__, "isFundingRemembered", (function() {
            return lib.D;
        }));
        __webpack_require__.d(__webpack_exports__, "forceIframe", (function() {
            return lib.a;
        }));
        __webpack_require__.d(__webpack_exports__, "isWebView", (function() {
            return lib.a;
        }));
        __webpack_require__.d(__webpack_exports__, "allowIframe", (function() {
            return lib.a;
        }));
        __webpack_require__.d(__webpack_exports__, "logExperimentTreatment", (function() {
            return logExperimentTreatment;
        }));
        __webpack_require__.d(__webpack_exports__, "logFundingEligibility", (function() {
            return src_funding.e;
        }));
        __webpack_require__.d(__webpack_exports__, "onPossiblyUnhandledException", (function() {
            return onPossiblyUnhandledException;
        }));
        __webpack_require__.d(__webpack_exports__, "version", (function() {
            return interface_version;
        }));
        __webpack_require__.d(__webpack_exports__, "checkout", (function() {
            return interface_checkout;
        }));
        __webpack_require__.d(__webpack_exports__, "apps", (function() {
            return apps;
        }));
        __webpack_require__.d(__webpack_exports__, "Checkout", (function() {
            return interface_Checkout;
        }));
        __webpack_require__.d(__webpack_exports__, "BillingPage", (function() {
            return interface_BillingPage;
        }));
        __webpack_require__.d(__webpack_exports__, "PayPalCheckout", (function() {
            return PayPalCheckout;
        }));
        __webpack_require__.d(__webpack_exports__, "destroyAll", (function() {
            return destroyAll;
        }));
        __webpack_require__.d(__webpack_exports__, "enableCheckoutIframe", (function() {
            return enableCheckoutIframe;
        }));
        __webpack_require__.d(__webpack_exports__, "logger", (function() {
            return logger;
        }));
        __webpack_require__.d(__webpack_exports__, "ThreeDomainSecure", (function() {
            return interface_ThreeDomainSecure;
        }));
        var interface_namespaceObject = {};
        __webpack_require__.r(interface_namespaceObject);
        __webpack_require__.d(interface_namespaceObject, "postRobot", (function() {
            return postRobot;
        }));
        __webpack_require__.d(interface_namespaceObject, "Promise", (function() {
            return zalgo_promise_src.a;
        }));
        __webpack_require__.d(interface_namespaceObject, "PopupOpenError", (function() {
            return src.b;
        }));
        __webpack_require__.d(interface_namespaceObject, "rest", (function() {
            return rest;
        }));
        __webpack_require__.d(interface_namespaceObject, "Button", (function() {
            return component_Button;
        }));
        __webpack_require__.d(interface_namespaceObject, "Card", (function() {
            return Card;
        }));
        __webpack_require__.d(interface_namespaceObject, "setup", (function() {
            return setup;
        }));
        __webpack_require__.d(interface_namespaceObject, "config", (function() {
            return config.a;
        }));
        __webpack_require__.d(interface_namespaceObject, "ENV", (function() {
            return constants.t;
        }));
        __webpack_require__.d(interface_namespaceObject, "USERS", (function() {
            return constants.G;
        }));
        __webpack_require__.d(interface_namespaceObject, "SOURCE", (function() {
            return constants.F;
        }));
        __webpack_require__.d(interface_namespaceObject, "FUNDING", (function() {
            return constants.v;
        }));
        __webpack_require__.d(interface_namespaceObject, "CARD", (function() {
            return constants.o;
        }));
        __webpack_require__.d(interface_namespaceObject, "request", (function() {
            return lib.Q;
        }));
        __webpack_require__.d(interface_namespaceObject, "isEligible", (function() {
            return lib.C;
        }));
        __webpack_require__.d(interface_namespaceObject, "isFundingRemembered", (function() {
            return lib.D;
        }));
        __webpack_require__.d(interface_namespaceObject, "forceIframe", (function() {
            return lib.a;
        }));
        __webpack_require__.d(interface_namespaceObject, "isWebView", (function() {
            return lib.a;
        }));
        __webpack_require__.d(interface_namespaceObject, "allowIframe", (function() {
            return lib.a;
        }));
        __webpack_require__.d(interface_namespaceObject, "logExperimentTreatment", (function() {
            return logExperimentTreatment;
        }));
        __webpack_require__.d(interface_namespaceObject, "logFundingEligibility", (function() {
            return src_funding.e;
        }));
        __webpack_require__.d(interface_namespaceObject, "onPossiblyUnhandledException", (function() {
            return onPossiblyUnhandledException;
        }));
        __webpack_require__.d(interface_namespaceObject, "version", (function() {
            return interface_version;
        }));
        __webpack_require__.d(interface_namespaceObject, "checkout", (function() {
            return interface_checkout;
        }));
        __webpack_require__.d(interface_namespaceObject, "apps", (function() {
            return apps;
        }));
        __webpack_require__.d(interface_namespaceObject, "Checkout", (function() {
            return interface_Checkout;
        }));
        __webpack_require__.d(interface_namespaceObject, "BillingPage", (function() {
            return interface_BillingPage;
        }));
        __webpack_require__.d(interface_namespaceObject, "PayPalCheckout", (function() {
            return PayPalCheckout;
        }));
        __webpack_require__.d(interface_namespaceObject, "destroyAll", (function() {
            return destroyAll;
        }));
        __webpack_require__.d(interface_namespaceObject, "enableCheckoutIframe", (function() {
            return enableCheckoutIframe;
        }));
        __webpack_require__.d(interface_namespaceObject, "logger", (function() {
            return logger;
        }));
        __webpack_require__.d(interface_namespaceObject, "ThreeDomainSecure", (function() {
            return interface_ThreeDomainSecure;
        }));
        var beaver_logger_client = __webpack_require__(5);
        var src = __webpack_require__(22);
        var zalgo_promise_src = __webpack_require__(2);
        var post_robot_src = __webpack_require__(15);
        var lib = __webpack_require__(4);
        var src_checkout = __webpack_require__(17);
        var esm_extends = __webpack_require__(13);
        var belter_src = __webpack_require__(11);
        var constants = __webpack_require__(0);
        var config = __webpack_require__(3);
        var resources = __webpack_require__(19);
        var containerContent = __webpack_require__(33);
        var checkout_template = __webpack_require__(31);
        var _LOGO_COLOR;
        var LOGO_COLOR = ((_LOGO_COLOR = {})[constants.q.BLACK] = constants.i.WHITE, _LOGO_COLOR[constants.q.WHITE] = constants.i.BLACK, 
        _LOGO_COLOR);
        function containerTemplate(_ref) {
            var id = _ref.id, props = _ref.props, CLASS = _ref.CLASS, ANIMATION = _ref.ANIMATION, CONTEXT = _ref.CONTEXT, EVENT = _ref.EVENT, on = _ref.on, tag = _ref.tag, context = _ref.context, actions = _ref.actions, outlet = _ref.outlet, jsxDom = _ref.jsxDom;
            var _props$locale$split = props.locale.split("_"), lang = _props$locale$split[0], country = _props$locale$split[1];
            var containerStyle = "\n        " + Object(checkout_template.c)({
                id: id,
                tag: tag,
                CONTEXT: CONTEXT,
                CLASS: CLASS,
                ANIMATION: ANIMATION
            }) + "\n        @media screen and (max-width: 470px) {\n            #" + id + " .paypal-checkout-close {\n                position: absolute;\n                right: 20px;\n                width: 40px;\n                height: 40px;\n                opacity: 0.6;\n                top: 20px;\n                opacity: 0.6;\n                z-index: 2;\n            }\n\n            #" + id + " .paypal-checkout-close:before, .paypal-checkout-close:after {\n                position: absolute;\n                left: 20px;\n                content: ' ';\n                height: 40px;\n                width: 1px;\n                background-color: #111 !important;\n            }\n            #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " .paypal-checkout-iframe-container,\n            #" + id + "." + tag + "-context-" + CONTEXT.IFRAME + " ." + CLASS.OUTLET + " {\n                height: 100%;\n                min-height: 100%;\n                max-height: 100%;\n                min-width: 100%;\n                max-width: 100%;\n                border-radius: 0px;\n            }\n            #" + id + " ." + CLASS.OUTLET + " {\n                height: 100%;\n            }\n        }\n    ";
            var content = containerContent.a[country][lang];
            function focus(event) {
                event.preventDefault();
                event.stopPropagation();
                Object(belter_src.l)() && Object(belter_src.t)() ? window.alert("Please switch tabs to reactivate the PayPal window") : actions.focus();
            }
            var overlayColor = (props.style || {}).overlayColor || constants.q.BLACK;
            var logoColor = LOGO_COLOR[overlayColor];
            var ppLogo = "function" == typeof resources.b.pp ? resources.b.pp({
                logoColor: logoColor
            }) : resources.b.pp[logoColor];
            var paypalLogo = "function" == typeof resources.b.paypal ? resources.b.paypal({
                logoColor: logoColor
            }) : resources.b.paypal[logoColor];
            var el = jsxDom("div", {
                id: id,
                onClick: focus,
                class: tag + "-context-" + context + " paypal-checkout-overlay " + tag + "-background-color-" + overlayColor + " " + tag + "-logo-color-" + logoColor,
                role: "dialog",
                "aria-modal": "true",
                "aria-label": "PayPal Checkout Overlay"
            }, jsxDom("a", {
                href: "#",
                class: "paypal-checkout-close",
                onClick: function(event) {
                    event.preventDefault();
                    event.stopPropagation();
                    props.onCancel && props.onCancel();
                    actions.close();
                },
                "aria-label": "close",
                role: "button"
            }), jsxDom("div", {
                class: "paypal-checkout-modal"
            }, jsxDom("div", {
                class: "paypal-checkout-logo"
            }, jsxDom("img", {
                class: "paypal-checkout-logo-pp",
                alt: "pp",
                src: "data:image/svg+xml;base64," + Object(belter_src.a)(ppLogo.toString())
            }), jsxDom("img", {
                class: "paypal-checkout-logo-paypal",
                alt: "paypal",
                src: "data:image/svg+xml;base64," + Object(belter_src.a)(paypalLogo.toString())
            })), jsxDom("div", {
                class: "paypal-checkout-message"
            }, content.windowMessage), jsxDom("div", {
                class: "paypal-checkout-continue"
            }, jsxDom("a", {
                onClick: focus,
                href: "#"
            }, content.continue)), jsxDom("div", {
                class: "paypal-checkout-loader"
            }, jsxDom("div", {
                class: "paypal-spinner"
            }))), jsxDom("div", {
                class: "paypal-checkout-iframe-container"
            }, outlet), jsxDom("style", null, containerStyle));
            var container = jsxDom("html", null, jsxDom("body", null, el));
            on(EVENT.CLOSE, (function() {
                el.className += " " + tag + "-loading";
            }));
            return jsxDom("div", {
                id: id,
                class: "paypal-checkout-sandbox"
            }, jsxDom("style", null, Object(checkout_template.d)({
                id: id,
                ANIMATION: ANIMATION
            })), jsxDom("iframe", {
                title: "PayPal Checkout Overlay",
                name: "__paypal_checkout_sandbox_" + id + "__",
                scrolling: "no",
                class: "paypal-checkout-sandbox-iframe"
            }, container));
        }
        var BillingPage = Object(src.c)({
            tag: "billing-page",
            name: "billing-page",
            buildUrl: function(props) {
                return config.a.inlinedCardFieldUrls[props.env || config.a.env] + "/billing";
            },
            get domain() {
                var _extends2;
                return Object(esm_extends.a)({}, config.a.paypalDomains, ((_extends2 = {})[constants.t.LOCAL] = /^http:\/\/localhost.paypal.com:\d+$/, 
                _extends2));
            },
            scrolling: !0,
            props: {
                sessionID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.w)();
                    },
                    queryParam: !0
                },
                token: {
                    type: "string",
                    required: !0,
                    queryParam: !0
                },
                buttonSessionID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.j)();
                    },
                    queryParam: !0
                },
                commit: {
                    type: "boolean",
                    required: !1,
                    queryParam: !0
                },
                env: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return config.a.env;
                    },
                    validate: function(env) {
                        if (!config.a.paypalUrls[env]) throw new Error("Invalid env: " + env);
                    }
                },
                locale: {
                    type: "string",
                    required: !1,
                    queryParam: "locale.x",
                    allowDelegate: !0,
                    def: function() {
                        var _getBrowserLocale = Object(lib.i)();
                        return _getBrowserLocale.lang + "_" + _getBrowserLocale.country;
                    }
                },
                cardType: {
                    type: "string",
                    required: !1
                },
                prefilledZipCode: {
                    type: "string",
                    required: !1
                },
                onEvent: {
                    type: "function",
                    required: !1,
                    sameDomain: !0
                },
                dispatch: {
                    type: "object",
                    required: !1,
                    sameDomain: !0
                },
                onCancel: {
                    type: "function",
                    required: !1,
                    once: !0,
                    noop: !0
                },
                sdkMeta: {
                    type: "string",
                    queryParam: !0,
                    sendToChild: !1,
                    def: function() {
                        return Object(belter_src.a)(JSON.stringify({
                            url: Object(lib.l)()
                        }));
                    }
                }
            },
            containerTemplate: containerTemplate
        });
        var ThreeDomainSecure = Object(src.c)({
            tag: "paypal-3ds",
            name: "3ds",
            buildUrl: function(props) {
                return config.a.inlinedCardFieldUrls[props.env || config.a.env] + "/init3ds";
            },
            get domain() {
                return Object(esm_extends.a)({}, config.a.paypalDomains);
            },
            scrolling: !0,
            props: {
                sdkMeta: {
                    type: "string",
                    queryParam: !0,
                    sendToChild: !1,
                    def: function() {
                        return Object(belter_src.a)(JSON.stringify({
                            url: Object(lib.l)()
                        }));
                    }
                },
                locale: {
                    type: "string",
                    required: !1,
                    queryParam: "locale.x",
                    allowDelegate: !0,
                    def: function() {
                        var _getBrowserLocale = Object(lib.i)();
                        return _getBrowserLocale.lang + "_" + _getBrowserLocale.country;
                    }
                },
                env: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return config.a.env;
                    },
                    validate: function(env) {
                        if (!config.a.paypalUrls[env]) throw new Error("Invalid env: " + env);
                    }
                },
                challengeUrl: {
                    type: "string"
                },
                threeDomainSecureToken: {
                    type: "string"
                },
                method: {
                    type: "string"
                },
                onSuccess: {
                    type: "function",
                    required: !1
                },
                onError: {
                    type: "function",
                    required: !1
                },
                onCancel: {
                    type: "function",
                    required: !0,
                    allowDelegate: !0
                }
            },
            containerTemplate: containerTemplate
        });
        var cross_domain_utils_src = __webpack_require__(7);
        var src_lib = __webpack_require__(6);
        var pptm = (noContentFoundInContainer = !1, callback = "__pptmLoadedWithNoContent", 
        obj = {
            reloadPptmScript: function(clientId) {
                !function tryCreatePptmScript() {
                    if (obj.shouldReloadPptmScript(clientId)) {
                        obj.removePptm();
                        obj.createPptmScript(clientId);
                    } else listener = tryCreatePptmScript;
                }();
            },
            listenForLoadWithNoContent: function() {
                window[callback] = function() {
                    noContentFoundInContainer = !0;
                    if (listener) {
                        listener();
                        listener = void 0;
                    }
                };
            },
            listenForButtonRender: function() {
                window.paypalDDL = window.paypalDDL || [];
                0 === window.paypalDDL.filter((function(e) {
                    return "paypalButtonRender" === e.event;
                })).length && window.paypalDDL.push({
                    event: "paypalButtonRender"
                });
            },
            get callback() {
                return callback;
            },
            get noContentFoundInContainer() {
                return noContentFoundInContainer;
            },
            createPptmScript: function(clientId) {
                var _track;
                Object(beaver_logger_client.p)(((_track = {})[constants.u.KEY.STATE] = constants.u.STATE.PPTM, 
                _track[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.PPTM_LOAD, _track));
                var params = {
                    t: "xo",
                    id: window.location.hostname,
                    mrid: config.a.merchantID,
                    client_id: "",
                    v: config.a.version,
                    source: "checkoutjs"
                };
                clientId ? params.client_id = clientId : delete params.client_id;
                var fullUrl = Object(lib.g)(config.a.pptmUrl, params);
                Object(lib.G)(fullUrl, 0, {
                    async: !0,
                    id: constants.E
                }).then((function() {
                    var _track2;
                    window.paypalDDL && window.paypalDDL[0] && "snippetRun" === window.paypalDDL[0].event || window[callback]();
                    Object(beaver_logger_client.p)(((_track2 = {})[constants.u.KEY.STATE] = constants.u.STATE.PPTM, 
                    _track2[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.PPTM_LOADED, _track2));
                })).catch((function(err) {
                    Object(beaver_logger_client.k)("pptm_script_error", {
                        error: Object(lib.T)(err)
                    });
                }));
            },
            shouldCreateInitialPptmScript: function() {
                if (!window.location.hostname) return !1;
                if (Object(lib.E)()) return !1;
                var existingScript = Object(lib.n)(constants.E);
                if (Boolean(existingScript)) {
                    Object(beaver_logger_client.k)("pptm_tried_loading_twice");
                    return !1;
                }
                return !0;
            },
            shouldReloadPptmScript: function(clientId) {
                return !1 !== noContentFoundInContainer && !Object(lib.E)() && !config.a.merchantID && !!clientId;
            },
            removePptm: function() {
                var script = Object(lib.n)(constants.E);
                script && script.parentNode.removeChild(script);
            }
        });
        var noContentFoundInContainer, callback, listener, obj;
        var proxyRest = {};
        var createAccessToken = Object(lib.H)((function(env, client) {
            Object(beaver_logger_client.k)("rest_api_create_access_token");
            var clientID = client[env = env || config.a.env];
            if (!clientID) throw new Error("Client ID not found for env: " + env);
            if (proxyRest.createAccessToken && !proxyRest.createAccessToken.source.closed) return proxyRest.createAccessToken(env, client);
            var basicAuth = Object(belter_src.a)(clientID + ":");
            return Object(lib.Q)({
                method: "post",
                url: config.a.authApiUrls[env],
                headers: {
                    Authorization: "Basic " + basicAuth
                },
                data: {
                    grant_type: "client_credentials"
                }
            }).then((function(res) {
                if (res && "invalid_client" === res.error) throw new Error("Auth Api invalid " + env + " client id: " + clientID + ":\n\n" + JSON.stringify(res, null, 4));
                if (!res || !res.access_token) throw new Error("Auth Api response error:\n\n" + JSON.stringify(res, null, 4));
                return res.access_token;
            }));
        }), {
            time: 6e5
        });
        var createExperienceProfile = Object(lib.H)((function(env, client, experienceDetails) {
            void 0 === experienceDetails && (experienceDetails = {});
            Object(beaver_logger_client.k)("rest_api_create_experience_profile");
            if (!client[env = env || config.a.env]) throw new Error("Client ID not found for env: " + env);
            if (proxyRest.createExperienceProfile && !proxyRest.createExperienceProfile.source.closed) return proxyRest.createExperienceProfile(env, client, experienceDetails);
            experienceDetails.temporary = !0;
            experienceDetails.name = experienceDetails.name ? experienceDetails.name + "_" + Math.random().toString() : Math.random().toString();
            return createAccessToken(env, client).then((function(accessToken) {
                return Object(lib.Q)({
                    method: "post",
                    url: config.a.experienceApiUrls[env],
                    headers: {
                        Authorization: "Bearer " + accessToken
                    },
                    json: experienceDetails
                });
            })).then((function(res) {
                if (res && res.error) throw new Error(res.error);
                if (!res.id) throw new Error("No id in experience profile response:\n\n" + JSON.stringify(res, null, 4));
                return res.id;
            }));
        }), {
            time: 6e5
        });
        function logPaymentResponse(res) {
            var _track;
            if (res) {
                var paymentToken;
                var paymentID;
                res.id && (paymentID = res.id);
                if (res.links && res.links.length) for (var i = 0; i < res.links.length; i++) if ("REDIRECT" === res.links[i].method && "approval_url" === res.links[i].rel) {
                    var match = res.links[i].href.match(/token=((EC-)?[A-Z0-9]{17})/);
                    match && (paymentToken = match[1]);
                }
                Object(beaver_logger_client.p)(((_track = {})[constants.u.KEY.STATE] = constants.u.STATE.BUTTON, 
                _track[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.CREATE_PAYMENT, _track[constants.u.KEY.CONTEXT_TYPE] = constants.u.CONTEXT_TYPE[constants.C.PAY_ID], 
                _track[constants.u.KEY.PAY_ID] = paymentID, _track[constants.u.KEY.TOKEN] = paymentToken, 
                _track[constants.u.KEY.CONTEXT_ID] = paymentID, _track));
            }
        }
        function createPayment(env, client, paymentDetails) {
            Object(beaver_logger_client.k)("rest_api_create_checkout_token");
            if (!client[env = env || config.a.env]) throw new Error("Client ID not found for env: " + env);
            var payment = paymentDetails.payment, experience = paymentDetails.experience, meta = paymentDetails.meta, tracking = paymentDetails.tracking;
            if (!payment) throw new Error("Expected payment details to be passed");
            if (proxyRest.createPayment && !proxyRest.createPayment.source.closed) return proxyRest.createPayment(env, client, {
                payment: payment,
                experience: experience,
                meta: meta,
                tracking: tracking
            });
            (payment = Object(esm_extends.a)({}, payment)).intent = payment.intent || "sale";
            payment.redirect_urls = payment.redirect_urls || {};
            payment.redirect_urls.return_url = payment.redirect_urls.return_url || "https://www.paypal.com/checkoutnow/error";
            payment.redirect_urls.cancel_url = payment.redirect_urls.cancel_url || "https://www.paypal.com/checkoutnow/error";
            payment.payer = payment.payer || {};
            payment.payer.payment_method = payment.payer.payment_method || "paypal";
            return createAccessToken(env, client).then((function(accessToken) {
                return zalgo_promise_src.a.try((function() {
                    if (experience) return zalgo_promise_src.a.resolve(createExperienceProfile(env, client, experience));
                })).then((function(experienceID) {
                    return zalgo_promise_src.a.try((function() {
                        if (tracking) return zalgo_promise_src.a.resolve(function(env, client, merchantID, trackingData) {
                            if (!client[env = env || config.a.env]) throw new Error("Client ID not found for env: " + env);
                            var trackingID = Object(lib.V)();
                            return createAccessToken(env, client).then((function(accessToken) {
                                var headers = {
                                    Authorization: "Bearer " + accessToken
                                };
                                return Object(lib.Q)({
                                    method: "put",
                                    url: config.a.trackingApiUrls[env] + "/" + merchantID + "/" + trackingID,
                                    headers: headers,
                                    json: {
                                        tracking_id: trackingID,
                                        additional_data: trackingData
                                    }
                                });
                            })).then((function() {
                                return trackingID;
                            }));
                        }(env, client, tracking.id, tracking.data));
                    })).then((function(trackingID) {
                        experienceID && (payment.experience_profile_id = experienceID);
                        var headers = {
                            Authorization: "Bearer " + accessToken
                        };
                        trackingID && (headers["Paypal-Client-Metadata-Id"] = trackingID);
                        meta && meta.partner_attribution_id && (headers["PayPal-Partner-Attribution-Id"] = meta.partner_attribution_id);
                        return Object(lib.Q)({
                            method: "post",
                            url: config.a.paymentApiUrls[env],
                            headers: headers,
                            json: payment
                        });
                    }));
                }));
            })).then((function(res) {
                logPaymentResponse(res);
                if (res && res.id) return res.id;
                throw new Error("Payment Api response error:\n\n" + JSON.stringify(res, null, 4));
            }));
        }
        function createOrder(env, client, paymentDetails) {
            Object(beaver_logger_client.k)("rest_api_create_order_token");
            if (!client[env = env || config.a.env]) throw new Error("Client ID not found for env: " + env);
            var order = paymentDetails.order, meta = paymentDetails.meta;
            if (!order) throw new Error("Expected order details to be passed");
            if (proxyRest.createOrder && !proxyRest.createOrder.source.closed) return proxyRest.createOrder(env, client, {
                order: order,
                meta: meta
            });
            (order = Object(esm_extends.a)({}, order)).intent = order.intent || "CAPTURE";
            order.application_context = order.application_context || {};
            order.application_context.return_url = order.application_context.return_url || "https://www.paypal.com/checkoutnow/error";
            order.application_context.cancel_url = order.application_context.cancel_url || "https://www.paypal.com/checkoutnow/error";
            order.purchase_units = order.purchase_units || [];
            order.purchase_units[0] = order.purchase_units[0] || {};
            order.purchase_units.forEach((function(unit) {
                unit.reference_id = unit.reference_id || Math.random().toString();
            }));
            return createAccessToken(env, client).then((function(accessToken) {
                var headers = {
                    Authorization: "Bearer " + accessToken
                };
                meta && meta.partner_attribution_id && (headers["PayPal-Partner-Attribution-Id"] = meta.partner_attribution_id);
                return Object(lib.Q)({
                    method: "post",
                    url: config.a.orderApiUrls[env],
                    headers: headers,
                    json: order
                });
            })).then((function(res) {
                logPaymentResponse(res);
                if (res && res.id) return res.id;
                throw new Error("Payment Api response error:\n\n" + JSON.stringify(res, null, 4));
            }));
        }
        function createBillingAgreement(env, client, billingDetails, experienceDetails) {
            Object(beaver_logger_client.k)("rest_api_create_billing_token");
            if (!client[env = env || config.a.env]) throw new Error("Client ID not found for env: " + env);
            if (proxyRest.createBillingAgreement && !proxyRest.createBillingAgreement.source.closed) return proxyRest.createBillingAgreement(env, client, billingDetails, experienceDetails);
            (billingDetails = Object(esm_extends.a)({}, billingDetails)).plan = billingDetails.plan || {};
            billingDetails.plan.merchant_preferences = billingDetails.plan.merchant_preferences || {};
            billingDetails.plan.merchant_preferences.return_url = billingDetails.plan.merchant_preferences.return_url || "https://www.paypal.com/checkoutnow/error";
            billingDetails.plan.merchant_preferences.cancel_url = billingDetails.plan.merchant_preferences.cancel_url || "https://www.paypal.com/checkoutnow/error";
            billingDetails.payer = billingDetails.payer || {};
            billingDetails.payer.payment_method = billingDetails.payer.payment_method || "paypal";
            return createAccessToken(env, client).then((function(accessToken) {
                return zalgo_promise_src.a.try((function() {
                    if (experienceDetails) return zalgo_promise_src.a.resolve(createExperienceProfile(env, client, experienceDetails));
                })).then((function(experienceID) {
                    experienceID && (billingDetails.experience_profile_id = experienceID);
                    return Object(lib.Q)({
                        method: "post",
                        url: config.a.billingApiUrls[env],
                        headers: {
                            Authorization: "Bearer " + accessToken
                        },
                        json: billingDetails
                    });
                }));
            })).then((function(res) {
                if (res && res.token_id) return res.token_id;
                throw new Error("Billing Api response error:\n\n" + JSON.stringify(res, null, 4));
            }));
        }
        var rest = {
            payment: {
                create: createPayment
            },
            order: {
                create: createOrder
            },
            billingAgreement: {
                create: createBillingAgreement
            },
            experience: {
                create: createExperienceProfile
            }
        };
        var parentWin = Object(cross_domain_utils_src.f)();
        Object(post_robot_src.on)("proxy_rest", {
            domain: config.a.paypal_domain_regex
        }, (function(_ref) {
            proxyRest = _ref.data;
        }));
        parentWin && Object(lib.E)() && !Object(cross_domain_utils_src.v)(parentWin) && Object(post_robot_src.send)(parentWin, "proxy_rest", {
            createAccessToken: createAccessToken,
            createExperienceProfile: createExperienceProfile,
            createPayment: createPayment,
            createBillingAgreement: createBillingAgreement,
            createOrder: createOrder
        }).catch((function() {}));
        var onAuthorizeListener = Object(lib.e)();
        function log(experiment, treatment, token, state) {
            Object(lib.x)((function(session) {
                var event = experiment + "_" + treatment + "_" + state;
                var loggedEvents = session.loggedExperimentEvents = session.loggedExperimentEvents || [];
                if (-1 !== loggedEvents.indexOf(event)) Object(beaver_logger_client.k)("duplicate_" + event); else {
                    var _track;
                    Object(beaver_logger_client.k)(event);
                    loggedEvents.push(event);
                    var edge = window.navigator && window.navigator.userAgent && window.navigator.userAgent.match(/Edge\/[0-9]{2}/);
                    edge && (event = Object(beaver_logger_client.k)(edge[0].toLowerCase().replace("/", "_") + "_" + event));
                    Object(beaver_logger_client.p)(((_track = {})[constants.u.KEY.STATE] = constants.u.STATE.CHECKOUT, 
                    _track[constants.u.KEY.TRANSITION] = state, _track[constants.u.KEY.EXPERIMENT_NAME] = experiment, 
                    _track[constants.u.KEY.TREATMENT_NAME] = treatment, _track[constants.u.KEY.TOKEN] = token, 
                    _track[constants.u.KEY.CONTEXT_ID] = token, _track[constants.u.KEY.CONTEXT_TYPE] = token ? constants.u.CONTEXT_TYPE[constants.C.EC_TOKEN] : constants.u.CONTEXT_TYPE.BUTTON_SESSION_ID, 
                    _track));
                    Object(beaver_logger_client.j)();
                }
            }));
        }
        function logExperimentTreatment(_ref) {
            var experiment = _ref.experiment, treatment = _ref.treatment, state = _ref.state, token = _ref.token;
            if (experiment && treatment) {
                Object(lib.x)((function(session) {
                    session.externalExperiment = experiment;
                    session.externalExperimentTreatment = treatment;
                    token && (session.externalExperimentToken = token);
                }));
                log(experiment, treatment, token, state);
            }
        }
        function logReturn(token) {
            var _getSessionState = Object(lib.x)((function(session) {
                return session;
            })), externalExperiment = _getSessionState.externalExperiment, externalExperimentTreatment = _getSessionState.externalExperimentTreatment, externalExperimentToken = _getSessionState.externalExperimentToken;
            externalExperiment && externalExperimentTreatment && externalExperimentToken === token ? log(externalExperiment, externalExperimentTreatment, token, "complete") : Object(beaver_logger_client.k)("experiment_mismatch", {
                token: token,
                externalExperiment: externalExperiment,
                externalExperimentTreatment: externalExperimentTreatment,
                externalExperimentToken: externalExperimentToken
            });
        }
        if (Object(lib.m)("log_authorize")) {
            onAuthorizeListener.once((function(_ref2) {
                var paymentToken = _ref2.paymentToken;
                setTimeout((function() {
                    logReturn(paymentToken);
                }), 1);
            }));
            var returnToken = Object(lib.u)();
            returnToken && setTimeout((function() {
                returnToken && logReturn(returnToken);
            }), 1);
        }
        var integrations = __webpack_require__(28);
        var integrations_checkout = __webpack_require__(32);
        function normalizeCheckoutProps(props) {
            return {
                env: props.env = props.env || config.a.env,
                payment: props.payment,
                onAuthorize: Object(src_lib.H)(props.onAuthorize),
                onCancel: Object(src_lib.H)(props.onCancel || src_lib.F)
            };
        }
        function awaitPopupBridge(Button) {
            return Button.xprops && Button.xprops.awaitPopupBridge ? Button.xprops.awaitPopupBridge() : Object(lib.b)(window, "popupBridge").then((function(popupBridge) {
                return function(popupBridge) {
                    return {
                        open: function(url) {
                            return new zalgo_promise_src.a((function(resolve, reject) {
                                popupBridge.onComplete = function(err, result) {
                                    return result ? err ? reject(err) : resolve(result) : reject(new Error("No payload passed in popupBridge.onComplete"));
                                };
                                popupBridge.onCancel = function() {
                                    var err = new Error("PAYMENT_CANCELLED");
                                    err.code = "PAYMENT_CANCELLED";
                                    return reject(err);
                                };
                                popupBridge.open(Object(lib.g)(url, {
                                    redirect_uri: popupBridge.getReturnUrlPrefix()
                                }));
                            }));
                        }
                    };
                }(popupBridge);
            }));
        }
        var src_funding = __webpack_require__(27);
        var button_config = __webpack_require__(12);
        var button_props = __webpack_require__(26);
        var jsx = __webpack_require__(1);
        function validateButtonLocale(locale) {
            if (!locale) throw new Error("Expected props.locale to be set");
            if (!locale.match(/^[a-z]{2}[_][A-Z][A-Z0-9]$/)) throw new Error("Expected props.locale to be valid, got " + locale);
            var _locale$split = locale.split("_"), country = _locale$split[1];
            if (!constants.A[country] || -1 === constants.A[country].indexOf(_locale$split[0])) throw new Error("Expected props.locale to be valid");
        }
        function validateButtonStyle(style, props) {
            void 0 === style && (style = {});
            if (!style) throw new Error("Expected props.style to be set");
            var label = style[constants.m.LABEL] || Object(button_config.e)("DEFAULT", style[constants.m.LAYOUT] === constants.g.VERTICAL ? "defaultVerticalLabel" : "defaultLabel");
            if (!button_config.a[label]) throw new Error("Invalid button label: " + label + ", expected: " + Object.keys(button_config.a[label]).join(", "));
            var color = style[constants.m.COLOR], shape = style[constants.m.SHAPE], size = style[constants.m.SIZE], branding = style[constants.m.BRANDING], fundingicons = style[constants.m.FUNDINGICONS], tagline = style[constants.m.TAGLINE], layout = style[constants.m.LAYOUT], maxbuttons = style[constants.m.MAXBUTTONS], height = style[constants.m.HEIGHT];
            if (color && -1 === Object(button_config.e)(label, "colors").indexOf(color)) throw new Error("Unexpected style." + constants.m.COLOR + " for " + label + " button: " + color + ", expected " + Object(button_config.e)(label, "colors").join(", "));
            if (shape && -1 === Object(button_config.e)(label, "shapes").indexOf(shape)) throw new Error("Unexpected style." + constants.m.SHAPE + " for " + label + " button: " + shape + ", expected " + Object(button_config.e)(label, "shapes").join(", "));
            if (size && -1 === Object(button_config.e)(label, "sizes").indexOf(size)) throw new Error("Unexpected style." + constants.m.SIZE + " for " + label + " button: " + size + ", expected " + Object(button_config.e)(label, "sizes").join(", "));
            if (!1 === branding) throw new Error("style." + constants.m.BRANDING + ":false is not allowed");
            if (fundingicons && !Object(button_config.e)(label, "allowFundingIcons")) throw new Error("style." + constants.m.FUNDINGICONS + ":true is not allowed for " + label + " button");
            if (layout && -1 === Object(button_config.e)(label, "layouts").indexOf(layout)) throw new Error("Unexpected style." + constants.m.LAYOUT + " for " + label + " button: " + layout + ", expected " + Object(button_config.e)(label, "layouts").join(", "));
            if (void 0 !== maxbuttons) {
                if ("number" != typeof maxbuttons) throw new TypeError("Expected style." + constants.m.MAXBUTTONS + " to be a number, got: " + maxbuttons);
                if (maxbuttons < 1) throw new Error("Expected style." + constants.m.MAXBUTTONS + " to be a at least 1, got: " + maxbuttons);
                var minButtons = layout === constants.g.VERTICAL ? Object(button_config.e)(label, "minVerticalButtons") : Object(button_config.e)(label, "minHorizontalButtons");
                if (maxbuttons < minButtons) throw new Error("Expected style." + constants.m.MAXBUTTONS + " to be no fewer than " + minButtons + ", got " + maxbuttons);
            }
            if (void 0 !== height) {
                if ("number" != typeof height) throw new TypeError("Expected style." + constants.m.HEIGHT + " to be a number, got: " + maxbuttons);
                var buttonSize = size || Object(button_config.e)(label, style.layout === constants.g.VERTICAL ? "defaultVerticalSize" : "defaultSize");
                var _ref = size === constants.l.RESPONSIVE ? {
                    minHeight: button_config.c[constants.l.SMALL].minHeight,
                    maxHeight: button_config.c[constants.l.HUGE].maxHeight
                } : button_config.c[buttonSize], minHeight = _ref.minHeight, maxHeight = _ref.maxHeight;
                if (height < minHeight || height > maxHeight) throw new Error("Expected style." + constants.m.HEIGHT + " to be between " + minHeight + "px and " + maxHeight + "px - got " + height + "px");
            }
            if (!Object(button_config.e)(label, "allowPrimary")) throw new Error(label + " can not be used as primary button label");
            if (layout === constants.g.VERTICAL) {
                if (size && -1 === [ constants.l.MEDIUM, constants.l.LARGE, constants.l.RESPONSIVE ].indexOf(size)) throw new Error("Button must be at least " + constants.l.MEDIUM + " size for " + constants.g.VERTICAL + " layout");
                if (!Object(button_config.e)(label, "allowPrimaryVertical")) throw new Error("style." + constants.m.LABEL + " option is not allowed for " + constants.g.VERTICAL + " layout - got " + label);
                if (fundingicons) throw new Error("style." + constants.m.FUNDINGICONS + " not allowed for " + constants.g.VERTICAL + " layout - got " + fundingicons);
                if (tagline) throw new Error("style." + constants.m.TAGLINE + " is not allowed for " + constants.g.VERTICAL + " layout - got " + tagline);
            }
            !function(style, locale) {
                void 0 === style && (style = {});
                void 0 === locale && (locale = "en_US");
                var country = locale.split("_")[1];
                var isInstallmentAllowedCountry = -1 !== constants.a.indexOf(country);
                if (!isInstallmentAllowedCountry && style.label === constants.f.INSTALLMENT) throw new Error("Unexpected label: style." + style.label + " for country: " + country);
                if (!isInstallmentAllowedCountry && style[constants.m.INSTALLMENTPERIOD]) throw new Error("style." + constants.m.INSTALLMENTPERIOD + " is invalid for country: " + country);
                if (isInstallmentAllowedCountry && style[constants.m.INSTALLMENTPERIOD] && style.label !== constants.f.INSTALLMENT) throw new Error("style." + constants.m.INSTALLMENTPERIOD + " is invalid for label: style." + style.label);
                if (isInstallmentAllowedCountry && style.label === constants.f.INSTALLMENT && style[constants.m.INSTALLMENTPERIOD] && "number" != typeof style[constants.m.INSTALLMENTPERIOD]) throw new Error("style." + constants.m.INSTALLMENTPERIOD + " is expected to be a number");
                if (isInstallmentAllowedCountry && style.label === constants.f.INSTALLMENT && style[constants.m.INSTALLMENTPERIOD] && -1 === constants.b[country].indexOf(style[constants.m.INSTALLMENTPERIOD])) throw new Error("style." + constants.m.INSTALLMENTPERIOD + ": " + style[constants.m.INSTALLMENTPERIOD] + " is not a valid installment number for " + style.label);
            }(style, props.locale);
        }
        var class_CLASS = {
            SHOULD_FOCUS: "paypal-should-focus",
            CONTAINER: "paypal-button-container",
            BUTTON: "paypal-button",
            BUTTON_LABEL: "paypal-button-label-container",
            LABEL: "paypal-button-label",
            COLOR: "paypal-button-color",
            LOGO_COLOR: "paypal-button-logo-color",
            SHAPE: "paypal-button-shape",
            BRANDING: "paypal-button-branding",
            LAYOUT: "paypal-button-layout",
            NUMBER: "paypal-button-number",
            ENV: "paypal-button-env",
            TAGLINE: "paypal-button-tagline",
            TAGLINE_COLOR: "paypal-button-tagline-color",
            FUNDINGICONS: "paypal-button-fundingicons",
            TEXT: "paypal-button-text",
            LOGO: "paypal-button-logo",
            CARD: "paypal-button-card",
            SEPARATOR: "paypal-separator",
            HIDDEN: "hidden",
            DOM_READY: "dom-ready",
            PERSONALIZATION_TEXT: "personalization-text"
        };
        var pageStyle = "\n    html, body {\n        padding: 0;\n        margin: 0;\n        width: 100%;\n        overflow: hidden;\n        text-align: center;\n    }\n\n    body {\n        display: inline-block;\n        vertical-align: top;\n    }\n\n    * {\n        -webkit-touch-callout: none;\n        -webkit-user-select: none;\n        -khtml-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        user-select: none;\n        cursor: default;\n        box-sizing: border-box;\n    }\n    \n    ." + class_CLASS.HIDDEN + " {\n        position: absolute;\n        visibility: hidden;\n    }\n";
        var buttonStyle = "\n\n    ." + class_CLASS.CONTAINER + ' {\n        display: block;\n        white-space: nowrap;\n        margin: 0;\n        background: 0;\n        border: 0;\n        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;\n        text-transform: none;\n        font-weight: 500;R\n        -webkit-font-smoothing: antialiased;\n        font-smoothing: antialiased;\n        z-index: 0;\n        font-size: 0;\n        width: 100%;\n        box-sizing: border-box;\n    }\n\n    .' + class_CLASS.BUTTON + ":not(." + class_CLASS.CARD + ") {\n        border: 1px solid transparent;\n        border-radius: 0 3px 3px 0;\n        position: relative;\n        width: 100%;\n        box-sizing: border-box;\n        border: none;\n        vertical-align: top;\n        cursor: pointer;\n        outline: none;\n        overflow: hidden;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.TRANSPARENT + " {\n        cursor: auto;\n    }\n\n    ." + class_CLASS.BUTTON + " * {\n        cursor: pointer;\n    }\n\n    ." + class_CLASS.CONTAINER + "." + class_CLASS.ENV + "-" + constants.t.TEST + " ." + class_CLASS.TEXT + " {\n        font-family: Arial !important;\n        background: rgba(0, 0, 0, 0.5) !important;\n        color: transparent  !important;\n        text-shadow: none  !important;\n    }\n\n    ." + class_CLASS.BUTTON + ":hover {\n        box-shadow: inset 0 0 100px 100px rgba(255, 255, 255, 0.2);\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.GOLD + ":hover,\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.SILVER + ":hover {\n        box-shadow: inset 0 0 100px 100px rgba(0, 0, 0, 0.05);\n    }\n\n    ." + class_CLASS.CARD + ", ." + class_CLASS.CARD + " * {\n        cursor: pointer;\n    }\n\n    ." + class_CLASS.CARD + ":hover {\n        filter: brightness(1.2);\n    }\n\n    ." + class_CLASS.BUTTON + ":focus, ." + class_CLASS.CARD + ":focus {\n        outline: none;\n    }\n\n    ." + class_CLASS.SHOULD_FOCUS + " ." + class_CLASS.BUTTON + ":focus,\n    ." + class_CLASS.SHOULD_FOCUS + " ." + class_CLASS.CARD + ":focus {\n        outline: solid 2px Highlight;\n        outline: auto 5px -webkit-focus-ring-color;\n        outline-offset: -3px;\n    }\n\n    ." + class_CLASS.BUTTON + ":focus {\n        box-shadow: -1px -1px 18px 1px rgba(0, 0, 0, 0.25) inset;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.TRANSPARENT + ":focus {\n        box-shadow: none;\n        outline: none;\n    }\n\n    ." + class_CLASS.LOGO + " {\n        padding: 0;\n        display: inline-block;\n        background: none;\n        border: none;\n        width: auto;\n    }\n\n    ." + class_CLASS.TEXT + " {\n        display: inline-block;\n        white-space: pre;\n    }\n\n    ." + class_CLASS.BUTTON + " ." + class_CLASS.BUTTON_LABEL + " {\n        position: relative;\n        top: 50%;\n        transform: translateY(-50%);\n        -webkit-transform: translateY(-50%);\n        -moz-transform: translateY(-50%);\n        -ms-transform: translateY(-50%);\n        -o-transform: translateY(-50%);\n    }\n    \n    ." + class_CLASS.BUTTON + " > ." + class_CLASS.BUTTON_LABEL + " > * {\n        vertical-align: top;\n        height: 100%;\n        text-align: left;\n    }\n\n    ." + class_CLASS.BUTTON + " ." + class_CLASS.CARD + " {\n        border-radius: 4px;\n    }\n\n    .powered-by-paypal > ." + class_CLASS.TEXT + " {\n        vertical-align: top;\n        line-height: 18px;\n    }\n\n    .powered-by-paypal > ." + class_CLASS.LOGO + " {\n        height: 16px;\n        min-height: 16px;\n    }\n\n    ." + class_CLASS.TAGLINE + " {\n        max-width: 100%;\n        font-weight: normal;\n        display: block;\n        text-align: center;\n        width: auto;\n    }\n\n    ." + class_CLASS.SEPARATOR + " {\n        height: 80%;\n        border-left: 1px solid rgba(0, 0, 0, 0.15);\n        margin: 0 8px;\n        display: inline-block;\n        position: relative;\n        top: 10%;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.BLACK + " ." + class_CLASS.SEPARATOR + " {\n        border-color: rgba(255, 255, 255, 0.45);\n    }\n";
        var layoutStyle = "\n\n    ." + class_CLASS.CONTAINER + "." + class_CLASS.LAYOUT + "-" + constants.g.VERTICAL + " ." + class_CLASS.TAGLINE + " {\n        display: none;\n    }\n";
        var brandingStyle = "\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.BRANDING + "-" + constants.d.UNBRANDED + "  {\n        min-width: 60%;\n        width: auto;\n        font-weight: 900;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.BRANDING + "-" + constants.d.UNBRANDED + " ." + class_CLASS.LOGO + " {\n        display: none;\n    }\n";
        var labelStyle = "\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.LABEL + "-" + constants.f.CARD + " {\n        border-radius: 0 !important;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.LABEL + "-" + constants.f.CREDIT + " ." + class_CLASS.TEXT + " {\n        display: none !important;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.LAYOUT + "-" + constants.g.HORIZONTAL + "." + class_CLASS.NUMBER + "-" + constants.j.MULTIPLE + "." + class_CLASS.LABEL + "-" + constants.f.CREDIT + " ." + class_CLASS.LOGO + "." + class_CLASS.LOGO + "-" + constants.h.PAYPAL + " {\n        display: none;\n    }\n\n    @media only screen and (max-width : " + button_config.c[constants.l.SMALL].minWidth + "px) {\n\n        ." + class_CLASS.BUTTON + "." + class_CLASS.LABEL + "-" + constants.f.CREDIT + " ." + class_CLASS.LOGO + "." + class_CLASS.LOGO + "-" + constants.h.PAYPAL + " {\n            display: none;\n        }\n    }\n\n    @media only screen and (min-width : " + button_config.c[constants.l.SMALL].minWidth + "px) {\n\n        ." + class_CLASS.BUTTON + "." + class_CLASS.LABEL + "-" + constants.f.CREDIT + " ." + class_CLASS.LOGO + "." + class_CLASS.LOGO + "-" + constants.h.PAYPAL + " {\n            display: inline-block;\n        }\n    }\n";
        var util = __webpack_require__(14);
        var buttonColorStyle = "\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.GOLD + " {\n        background: #ffc439;\n        color: #111;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.BLUE + " {\n        background: #009cde;\n        color: #fff;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.SILVER + " {\n        background: #eee;\n        color: #111;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.BLACK + " {\n        background: #2C2E2F;\n        color: #fff;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.DARKBLUE + " {\n        background: #003087;\n        color: #fff;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.TRANSPARENT + " {\n        background: transparent;\n        color: #111;\n    }\n\n    ." + class_CLASS.BUTTON + "." + class_CLASS.COLOR + "-" + constants.e.WHITE + " {\n        background: #fff;\n        color: #2C2E2F;\n        border: 1px solid #2C2E2F;\n    }\n";
        var componentContent = {
            AD: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            AE: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                },
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                }
            },
            AG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            AI: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            AL: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            AM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            AN: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            AO: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            AR: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            AT: {
                de: {
                    checkout: "Direkt zu {logo:pp} {logo:paypal}",
                    safer_tag: "Einfach schneller und sicherer bezahlen",
                    later_tag: "Kaufen Sie jetzt und bezahlen Sie nach und nach.",
                    pay: "Mit {logo:paypal} zahlen",
                    buynow: "{logo:pp} {logo:paypal} Jetzt kaufen",
                    poweredBy: "Abgewickelt durch {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            AU: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            AW: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            AZ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BA: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            BB: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BE: {
                en: {
                    checkout: "Pay with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                nl: {
                    checkout: "Betalen met {logo:pp} {logo:paypal}",
                    safer_tag: "De veiligere en snellere manier om te betalen.",
                    later_tag: "Koop nu. Betaal later.",
                    pay: "Betalen met {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Nu kopen",
                    poweredBy: "Mogelijk gemaakt door {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Le réflexe sécurité pour payer",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                }
            },
            BF: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            BH: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BI: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BJ: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BN: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            BO: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BR: {
                pt: {
                    checkout: "{logo:pp} {logo:paypal} Finalizar",
                    safer_tag: "A maneira fácil e segura de pagar.",
                    later_tag: "Compre agora e pague depois.",
                    pay: "Pague com {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar agora",
                    installment: "{logo:pp} {logo:paypal}  Pagamentos parcelados",
                    installment_period: "{logo:pp} {logo:paypal}  Pague em até [installmentperiod]x sem juros",
                    poweredBy: "Com tecnologia {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    installment: "{logo:pp} {logo:paypal}  Interest free payments",
                    installment_period: "{logo:pp} {logo:paypal}  Pay up to [installmentperiod]x without interest",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            BS: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BT: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            BW: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            BY: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            BZ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            C2: {
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式。",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay.",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            CA: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "{logo:pp} {logo:paypal} Payer",
                    safer_tag: "Votre réflexe sécurité pour payer",
                    later_tag: "Acheter. Payer plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                }
            },
            CD: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            CG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            CH: {
                de: {
                    checkout: "Direkt zu {logo:pp} {logo:paypal}",
                    safer_tag: "Einfach schneller und sicherer bezahlen",
                    later_tag: "Kaufen Sie jetzt und bezahlen Sie nach und nach.",
                    pay: "Mit {logo:paypal} zahlen",
                    buynow: "{logo:pp} {logo:paypal} Jetzt kaufen",
                    poweredBy: "Abgewickelt durch {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Le réflexe sécurité pour payer",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            CI: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            CK: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            CL: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            CM: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            CN: {
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            CO: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            CR: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            CV: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            CY: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            CZ: {
                cs: {
                    checkout: "Zaplatit přes {logo:pp} {logo:paypal}",
                    safer_tag: "Jednodušší a bezpečnější způsob placení",
                    later_tag: "Nakupujte nyní, plaťte později.",
                    pay: "Zaplatit přes {logo: paypal}",
                    buynow: "Koupit ihned přes {logo:pp} {logo:paypal}",
                    poweredBy: "Využívá službu {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            DE: {
                de: {
                    checkout: "Direkt zu {logo:pp} {logo:paypal}",
                    safer_tag: "Überall schnell und sicher bezahlen.",
                    later_tag: "Jetzt bei uns bequem in Raten zahlen.",
                    pay: "Mit {logo:paypal} zahlen",
                    buynow: "{logo:pp} {logo:paypal} Jetzt kaufen",
                    poweredBy: "Powered by {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            DJ: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            DK: {
                da: {
                    checkout: "{logo:pp} {logo:paypal} Betal",
                    safer_tag: "Betal nemt og sikkert",
                    later_tag: "Køb nu, betal senere.",
                    pay: "Betal med {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Køb nu",
                    poweredBy: "Leveret af {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            DM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            DO: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            DZ: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            EC: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            EE: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                ru: {
                    checkout: "Оформить заказ через {logo:pp} {logo:paypal}",
                    safer_tag: "Более безопасный и простой способ оплаты.",
                    later_tag: "Покупайте сейчас, платите потом.",
                    pay: "Оплатить через {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Купить сейчас",
                    poweredBy: "Обработано {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            EG: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            ER: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            ES: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Tecnología de {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            ET: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            FI: {
                fi: {
                    checkout: "{logo:pp} {logo:paypal}-maksu",
                    safer_tag: "Turvallisempi ja helpompi maksutapa",
                    later_tag: "Osta nyt. Maksa vähitellen.",
                    pay: "{logo:paypal}-maksu",
                    buynow: "{logo:pp} {logo:paypal} Osta nyt",
                    poweredBy: "Palvelun tarjoaa {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            FJ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            FK: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            FM: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            FO: {
                da: {
                    checkout: "Betal med {logo:pp} {logo:paypal}",
                    safer_tag: "Betal nemt og sikkert",
                    later_tag: "Køb nu, betal senere.",
                    pay: "Betal med {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Køb nu",
                    poweredBy: "Leveret af {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            FR: {
                fr: {
                    checkout: "{logo:pp} {logo:paypal} Payer",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Pay",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            GA: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GB: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            GD: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GE: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GF: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GI: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GL: {
                da: {
                    checkout: "Betal med {logo:pp} {logo:paypal}",
                    safer_tag: "Betal nemt og sikkert",
                    later_tag: "Køb nu, betal senere.",
                    pay: "Betal med {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Køb nu",
                    poweredBy: "Leveret af {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GN: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GP: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GR: {
                el: {
                    checkout: "Ολοκλήρωση αγοράς μέσω {logo:pp} {logo:paypal}",
                    safer_tag: "Ο ασφαλέστερος και ευκολότερος τρόπος πληρωμής",
                    later_tag: "Αγοράστε τώρα.  Πληρώστε σε δόσεις.",
                    pay: "Πληρωμή μέσω {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Αγορά τώρα",
                    poweredBy: "Με την υποστήριξη του {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GT: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GW: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            GY: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            HK: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal} 結帳",
                    safer_tag: "更安全、更方便的付款方式",
                    later_tag: "先購買，後付款。",
                    pay: "使用 {logo:paypal} 付款",
                    buynow: "{logo:pp} {logo:paypal} 立即買",
                    poweredBy: "支援方： {logo:paypal}"
                }
            },
            HN: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            HR: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            HU: {
                hu: {
                    checkout: "{logo:pp} {logo:paypal}-fizetés",
                    safer_tag: "Biztonságosabb, könnyebb fizetési mód.",
                    later_tag: "Vásároljon most. Fizessen később.",
                    pay: "{logo:paypal}-fizetés",
                    buynow: "{logo:pp} {logo:paypal} Vásárlás",
                    poweredBy: "Üzemeltető: {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            ID: {
                id: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "Cara yang lebih mudah dan aman untuk membayar.",
                    later_tag: "Beli Sekarang. Bayar dalam Jangka Waktu Tertentu.",
                    pay: "Bayar dengan {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Beli Sekarang",
                    poweredBy: "Ditunjang teknologi {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            IE: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            IL: {
                he: {
                    checkout: "{logo:pp} {logo:paypal} שלם",
                    safer_tag: ".הדרך הקלה והבטוחה יותר לשלם",
                    later_tag: "קנה עכשיו. שלם לאורך זמן.",
                    pay: "שלם באמצעות {logo:paypal}‏",
                    buynow: "{logo:pp} {logo:paypal} קנה עכשיו",
                    poweredBy: "{logo:paypal} מופעל על-ידי"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            IN: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay.",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            IS: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            IT: {
                it: {
                    checkout: "{logo:pp} {logo:paypal} Paga adesso",
                    safer_tag: "Il modo rapido e sicuro per pagare",
                    later_tag: "Acquista ora. Paga più tardi.",
                    pay: "Paga con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Paga adesso",
                    poweredBy: "Con tecnologia {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            JM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            JO: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            JP: {
                ja: {
                    checkout: "{logo:pp} {logo:paypal}で支払う",
                    safer_tag: "より安全・簡単にお支払い",
                    later_tag: "今すぐ購入して、分割してお支払い。",
                    pay: "{logo:paypal}で支払う",
                    buynow: "{logo:pp} {logo:paypal} 購入",
                    poweredBy: "Powered by {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            KE: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            KG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            KH: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            KI: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            KM: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            KN: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            KR: {
                ko: {
                    checkout: "{logo:pp} {logo:paypal} 체크 아웃",
                    safer_tag: "더 안전하고 빠른 결제 방법",
                    later_tag: "지금 구매하고 천천히 결제하세요.",
                    pay: "{logo:paypal}로 지불하기",
                    buynow: "{logo:pp} {logo:paypal} 바로 구매",
                    poweredBy: "제공: {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay.",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            KW: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            KY: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            KZ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            LA: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            LC: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            LI: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            LK: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            LS: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            LT: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                ru: {
                    checkout: "Оформить заказ через {logo:pp} {logo:paypal}",
                    safer_tag: "Более безопасный и простой способ оплаты.",
                    later_tag: "Покупайте сейчас, платите потом.",
                    pay: "Оплатить через {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Купить сейчас",
                    poweredBy: "Обработано {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            LU: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                de: {
                    checkout: "Direkt zu {logo:pp} {logo:paypal}",
                    safer_tag: "Einfach schneller und sicherer bezahlen",
                    later_tag: "Kaufen Sie jetzt und bezahlen Sie nach und nach.",
                    pay: "Mit {logo:paypal} zahlen",
                    buynow: "{logo:pp} {logo:paypal} Jetzt kaufen",
                    poweredBy: "Abgewickelt durch {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            LV: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                ru: {
                    checkout: "Оформить заказ через {logo:pp} {logo:paypal}",
                    safer_tag: "Более безопасный и простой способ оплаты.",
                    later_tag: "Покупайте сейчас, платите потом.",
                    pay: "Оплатить через {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Купить сейчас",
                    poweredBy: "Обработано {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MA: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MC: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            MD: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            ME: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            MG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MH: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MK: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            ML: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MN: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            MQ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MR: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MS: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MT: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            MU: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MV: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            MW: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            MX: {
                es: {
                    checkout: "Pagar con {logo:pp} {logo:paypal}",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    installment: "{logo:pp} {logo:paypal}  Pagos en mensualidades",
                    installment_period: "{logo:pp} {logo:paypal}  Pague hasta en [installmentperiod]x mensualidades",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    installment: "{logo:pp} {logo:paypal}  Interest free payments",
                    installment_period: "{logo:pp} {logo:paypal}  Pay up to [installmentperiod]x without interest",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            MY: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay.",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            MZ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            NA: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            NC: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            NE: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            NF: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            NG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            NI: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            NL: {
                nl: {
                    checkout: "{logo:pp} {logo:paypal} Betalen",
                    safer_tag: "Een veilige en makkelijke manier om te betalen.",
                    later_tag: "Koop nu. Betaal later.",
                    pay: "Betalen met {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Nu kopen",
                    poweredBy: "Mogelijk gemaakt door {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            NO: {
                no: {
                    checkout: "{logo:pp} {logo:paypal} Betal",
                    safer_tag: "En trygg og enkel betalingsmetode",
                    later_tag: "Kjøp nå, betal senere.",
                    pay: "Betal med {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Kjøp nå",
                    poweredBy: "Leveres av {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            NP: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            NR: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            NU: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            NZ: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay.",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "{logo:pp} {logo:paypal} Payer",
                    safer_tag: "Un réflexe sécurité.",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar.",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式。",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            OM: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            PA: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            PE: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            PF: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            PG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            PH: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay.",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            PL: {
                pl: {
                    checkout: "{logo:pp} {logo:paypal} Do kasy",
                    safer_tag: "Płać wygodnie i bezpiecznie",
                    later_tag: "Kup teraz. Płać w ratach",
                    pay: "Zapłać z {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Kup teraz",
                    poweredBy: "Powered by {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            PM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            PN: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            PT: {
                pt: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A forma rápida e segura de pagar",
                    later_tag: "Compre agora. Vá pagando.",
                    pay: "Pagar com {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar agora",
                    poweredBy: "Powered by {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            PW: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            PY: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            QA: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                },
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                }
            },
            RE: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            RO: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            RS: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            RU: {
                ru: {
                    checkout: "{logo:pp} {logo:paypal} Оформить покупку",
                    safer_tag: "Более безопасный и простой способ оплаты.",
                    later_tag: "Покупайте сейчас, платите потом.",
                    pay: "Оплатить через {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Купить сейчас",
                    poweredBy: "Обработано {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            RW: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SA: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SB: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SC: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SE: {
                sv: {
                    checkout: "{logo:pp} {logo:paypal} Betala",
                    safer_tag: "Ett tryggt och smidigt sätt att betala",
                    later_tag: "Köp nu, betala senare",
                    pay: "Betala med {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Köp nu",
                    poweredBy: "Tillhandahålls av {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            SG: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay.",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            SH: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SI: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SJ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SK: {
                sk: {
                    checkout: "Zaplatiť cez {logo:pp} {logo:paypal}",
                    safer_tag: "Jednoduchší a bezpečnejší spôsob platby",
                    later_tag: "Nakúpte teraz, zaplaťte postupne",
                    pay: "Zaplatiť cez {logo: paypal}",
                    buynow: "{logo:pp} {logo:paypal} Kúpiť",
                    poweredBy: "Používa technológiu {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SL: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SN: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SO: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SR: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            ST: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SV: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            SZ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TC: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TD: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TG: {
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TH: {
                th: {
                    checkout: "{logo:pp} {logo:paypal} ชำระเงิน",
                    safer_tag: "วิธีชำระเงินที่ปลอดภัยและง่ายกว่า",
                    later_tag: "ซื้อวันนี้ แล้วค่อยๆ จ่ายทีหลัง",
                    pay: "ชำระเงินด้วย {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} ซื้อทันที",
                    poweredBy: "ให้บริการโดย {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            TJ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TN: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TO: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            TR: {
                tr: {
                    checkout: "{logo:pp} {logo:paypal} ile Satın Alın",
                    safer_tag: "Ödeme yapmanın daha güvenli ve kolay yolu",
                    later_tag: "Şimdi Alın. Daha Sonra Ödeyin.",
                    pay: "{logo:paypal} ile Öde",
                    buynow: "{logo:pp} {logo:paypal} Hemen Satın Alın",
                    poweredBy: "Çalıştıran {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            TT: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TV: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            TW: {
                zh: {
                    checkout: "{logo:pp} {logo:paypal} 結帳",
                    safer_tag: "更安全、更方便的付款方式",
                    later_tag: "先購買，後付款。",
                    pay: "使用 {logo:paypal} 付款",
                    buynow: "{logo:pp} {logo:paypal} 立即購",
                    poweredBy: "服務提供者： {logo:paypal}"
                },
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            TZ: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            UA: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                ru: {
                    checkout: "Оформить заказ через {logo:pp} {logo:paypal}",
                    safer_tag: "Более безопасный и простой способ оплаты.",
                    later_tag: "Покупайте сейчас, платите потом.",
                    pay: "Оплатить через {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Купить сейчас",
                    poweredBy: "Обработано {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            UG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            US: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    dual_tag: "Two easy ways to pay",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "{logo:pp} {logo:paypal} Payer",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "Pagar con {logo:pp} {logo:paypal}",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "使用{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            UY: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            VA: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            VC: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            VE: {
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            VG: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            VN: {
                en: {
                    checkout: "{logo:pp} {logo:paypal} Checkout",
                    safer_tag: "A safer, faster way to pay.",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            VU: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            WF: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            WS: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            },
            YE: {
                ar: {
                    checkout: "السداد بواسطة {logo:pp} {logo:paypal}",
                    safer_tag: "الطريقة الأسهل والأكثر أماناً في الدفع",
                    later_tag: "اشترِ الآن، وسدّد على دفعات",
                    pay: "دفع بواسطة {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} شراء الآن",
                    poweredBy: "مدعوم من {logo:paypal}"
                },
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            YT: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            ZA: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            ZM: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                },
                fr: {
                    checkout: "Payer avec {logo:pp} {logo:paypal}",
                    safer_tag: "Votre réflexe sécurité pour payer en ligne",
                    later_tag: "Achetez maintenant et payez plus tard.",
                    pay: "Payer avec {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Acheter",
                    poweredBy: "Optimisé par {logo:paypal}"
                },
                es: {
                    checkout: "{logo:pp} {logo:paypal} Pagar",
                    safer_tag: "La forma rápida y segura de pagar",
                    later_tag: "Compre ahora y pague más adelante.",
                    pay: "Pagar con {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Comprar ahora",
                    poweredBy: "Desarrollado por {logo:paypal}"
                },
                zh: {
                    checkout: "{logo:pp} {logo:paypal}结账",
                    safer_tag: "更安全、更便捷的付款方式",
                    later_tag: "立即购买，分期付款。",
                    pay: "用{logo:paypal}付款",
                    buynow: "{logo:pp} {logo:paypal} 立即购买",
                    poweredBy: "技术支持提供方： {logo:paypal}"
                }
            },
            ZW: {
                en: {
                    checkout: "Check out with {logo:pp} {logo:paypal}",
                    safer_tag: "The safer, easier way to pay",
                    later_tag: "Buy Now. Pay Over Time.",
                    pay: "Pay with {logo:paypal}",
                    buynow: "{logo:pp} {logo:paypal} Buy Now",
                    poweredBy: "Powered by {logo:paypal}"
                }
            }
        };
        var allowedPersonalizationLabels = [ constants.f.CHECKOUT, constants.f.BUYNOW, constants.f.PAY ];
        function getCommonButtonClasses(_ref) {
            return [ class_CLASS.LAYOUT + "-" + _ref.layout, class_CLASS.SHAPE + "-" + _ref.shape, class_CLASS.BRANDING + "-" + (_ref.branding ? constants.d.BRANDED : constants.d.UNBRANDED), class_CLASS.NUMBER + "-" + (_ref.multiple ? constants.j.MULTIPLE : constants.j.SINGLE), class_CLASS.ENV + "-" + _ref.env, "" + class_CLASS.SHOULD_FOCUS ].join(" ");
        }
        function getLocaleContent(locale) {
            return componentContent[locale.country][locale.lang];
        }
        function determineLabel(_ref3) {
            var label = _ref3.label, source = _ref3.source, multiple = _ref3.multiple, layout = _ref3.layout;
            var defaultLabel = Object(button_config.d)(source);
            return Object(button_config.f)(label) === source ? multiple && layout === constants.g.HORIZONTAL ? defaultLabel : label : defaultLabel;
        }
        function renderCards(_ref5) {
            var layout = _ref5.layout, size = _ref5.size;
            return _ref5.cards.map((function(name) {
                var _ref6, _ref7, _ref8;
                var logo = resources.a[name];
                return Object(jsx.c)("div", Object(esm_extends.a)({}, ((_ref6 = {})[constants.c.LAYOUT] = layout || "", 
                _ref6), ((_ref7 = {})[constants.c.SIZE] = size || "", _ref7), ((_ref8 = {})[constants.c.FUNDING_SOURCE] = "" + constants.v.CARD, 
                _ref8[constants.c.CARD] = "" + name, _ref8), {
                    class: class_CLASS.CARD + " " + class_CLASS.CARD + "-" + name,
                    tabindex: "0"
                }), Object(jsx.c)("img", {
                    style: " display: block; ",
                    src: "data:image/svg+xml;base64," + Object(belter_src.a)(logo.toString()),
                    alt: name
                }));
            }));
        }
        function renderContent(text, _ref11) {
            var label = _ref11.label, locale = _ref11.locale, color = _ref11.color, branding = _ref11.branding, logoColor = _ref11.logoColor, funding = _ref11.funding, env = _ref11.env, _cards = _ref11.cards, dynamicContent = _ref11.dynamicContent, layout = _ref11.layout, size = _ref11.size;
            var _content = getLocaleContent(locale);
            return Object(jsx.b)(text, {
                text: function(value) {
                    var className = "" + class_CLASS.TEXT;
                    return Object(jsx.c)("span", {
                        class: className,
                        optional: !0
                    }, value);
                },
                logo: function(name) {
                    if (branding) {
                        if (!logoColor) throw new Error("Can not determine logo without logo color");
                        var logo = "function" == typeof resources.b[name] ? resources.b[name]({
                            label: label,
                            locale: locale,
                            color: color,
                            branding: branding,
                            logoColor: logoColor,
                            funding: funding,
                            env: env,
                            cards: _cards
                        }) : resources.b[name][logoColor] || resources.b[name][constants.i.ANY];
                        return Object(jsx.c)("img", {
                            class: class_CLASS.LOGO + " " + class_CLASS.LOGO + "-" + name + " " + class_CLASS.LOGO + "-" + color,
                            src: "data:image/svg+xml;base64," + Object(belter_src.a)(logo.toString()),
                            alt: "",
                            "aria-label": name
                        });
                    }
                },
                content: function(name) {
                    var contentString;
                    for (var _i2 = 0, _name$split2 = name.split("|"); _i2 < _name$split2.length; _i2++) {
                        var key = _name$split2[_i2];
                        if (_content[key]) {
                            contentString = _content[key];
                            break;
                        }
                    }
                    if (!(contentString = contentString && contentString.replace(/\[([a-z]+)\]/g, (function(match, contentVariable) {
                        if (match && contentVariable) return dynamicContent && dynamicContent[contentVariable];
                    }))) && env === constants.t.TEST) throw new Error("Could not find content " + name + " for " + locale.lang + "_" + locale.country);
                    return renderContent(contentString || "", {
                        label: label,
                        locale: locale,
                        color: color,
                        branding: branding,
                        logoColor: logoColor,
                        funding: funding,
                        env: env,
                        cards: _cards
                    });
                },
                cards: function() {
                    if (!funding) throw new Error("Can not determine card types without funding");
                    return renderCards({
                        cards: _cards,
                        layout: layout,
                        size: size
                    });
                },
                separator: function() {
                    return Object(jsx.c)("span", {
                        class: class_CLASS.SEPARATOR
                    });
                },
                break: function(value) {
                    var className = "" + class_CLASS.TEXT;
                    return Object(jsx.c)("span", {
                        class: className
                    }, value.split("<br>")[0], Object(jsx.c)("br", null), value.split("<br>")[1]);
                }
            });
        }
        function componentTemplate(_ref20) {
            var _ref21;
            var props = _ref20.props;
            if (props && props.style) {
                var style = props.style;
                "generic" === style.label && (style.label = "paypal");
                "creditblue" === style.color && delete style.color;
                1 !== style.maxbuttons || !1 !== style.tagline || "responsive" !== style.size || "horizontal" !== style.layout || style.height || (style.height = 44);
            }
            !function(props) {
                if (!props) throw new Error("Expected props");
                var style = props.style;
                validateButtonLocale(props.locale);
                validateButtonStyle(style, props);
            }(props);
            var _normalizeProps = Object(button_props.a)(props), locale = _normalizeProps.locale, shape = _normalizeProps.shape, branding = _normalizeProps.branding, tagline = _normalizeProps.tagline, funding = _normalizeProps.funding, layout = _normalizeProps.layout, multiple = _normalizeProps.multiple, env = _normalizeProps.env, height = _normalizeProps.height, cards = _normalizeProps.cards, installmentperiod = _normalizeProps.installmentperiod, fundingicons = _normalizeProps.fundingicons, size = _normalizeProps.size, checkoutCustomization = _normalizeProps.checkoutCustomization;
            var buttonNodes = function(_ref4) {
                var label = _ref4.label, color = _ref4.color, multiple = _ref4.multiple, layout = _ref4.layout;
                return _ref4.sources.map((function(source, i) {
                    var buttonLabel = determineLabel({
                        label: label,
                        source: source,
                        multiple: multiple,
                        layout: layout
                    });
                    return {
                        source: source,
                        label: buttonLabel,
                        color: multiple && i > 0 ? Object(button_config.e)(buttonLabel, "secondaryColors")[color] : color
                    };
                }));
            }({
                label: _normalizeProps.label,
                color: _normalizeProps.color,
                sources: _normalizeProps.sources,
                multiple: multiple,
                layout: layout
            }).map((function(button, i) {
                return function(_ref14) {
                    var _ref15, _ref16, _ref17;
                    var size = _ref14.size, label = _ref14.label, color = _ref14.color, locale = _ref14.locale, branding = _ref14.branding, multiple = _ref14.multiple, layout = _ref14.layout, shape = _ref14.shape, source = _ref14.source, funding = _ref14.funding, i = _ref14.i, env = _ref14.env, cards = _ref14.cards, installmentperiod = _ref14.installmentperiod;
                    var logoColor = Object(button_config.e)(label, "logoColors")[color];
                    var buttonLabel = determineLabel({
                        label: label,
                        source: source,
                        multiple: multiple,
                        layout: layout
                    });
                    var contentText;
                    var allowedAnimation;
                    -1 !== allowedPersonalizationLabels.indexOf(label) && (allowedAnimation = !0);
                    var dynamicContent = {
                        installmentperiod: installmentperiod,
                        locale: locale
                    };
                    contentText = renderContent(contentText = "function" == typeof (contentText = buttonLabel !== label || label !== constants.f.BUYNOW || branding ? Object(button_config.e)(label, "logoLabel") : Object(button_config.e)(label, "label")) ? contentText(dynamicContent) : contentText, {
                        label: label,
                        locale: locale,
                        color: color,
                        branding: branding,
                        logoColor: logoColor,
                        funding: funding,
                        env: env,
                        cards: cards,
                        dynamicContent: dynamicContent,
                        layout: layout,
                        size: size
                    });
                    var title = button_config.a[label].title;
                    var buttonTitle = "string" == typeof title ? title : function(_ref13) {
                        var label = _ref13.label, branding = _ref13.branding;
                        var localeContent = getLocaleContent(_ref13.locale);
                        var labelContent = localeContent && localeContent[label];
                        if (labelContent) {
                            var str = labelContent.replace(/({logo:(pp|paypal)})+(\s)*({logo:(pp|paypal)})*/, constants.w.PAYPAL);
                            label !== constants.f.BUYNOW || branding || (str = str.replace(constants.w.PAYPAL, ""));
                            return str;
                        }
                        return label;
                    }({
                        locale: locale,
                        label: label,
                        branding: branding
                    });
                    var hasTabIndex = -1 === [ constants.v.CARD ].indexOf(source);
                    var role = source === constants.v.CARD ? {} : {
                        role: "button"
                    };
                    return Object(jsx.c)("div", Object(esm_extends.a)({}, ((_ref15 = {})[constants.c.LAYOUT] = layout || "", 
                    _ref15), ((_ref16 = {})[constants.c.SIZE] = size || "", _ref16), ((_ref17 = {})[constants.c.FUNDING_SOURCE] = source, 
                    _ref17[constants.c.BUTTON] = !0, _ref17), {
                        class: class_CLASS.BUTTON + " " + class_CLASS.NUMBER + "-" + i + " " + getCommonButtonClasses({
                            layout: layout,
                            shape: shape,
                            branding: branding,
                            multiple: multiple,
                            env: env
                        }) + " " + (_ref2 = {
                            label: label,
                            color: color,
                            logoColor: logoColor
                        }, [ class_CLASS.LABEL + "-" + _ref2.label, class_CLASS.COLOR + "-" + _ref2.color, class_CLASS.LOGO_COLOR + "-" + _ref2.logoColor ].join(" "))
                    }, role, {
                        tabindex: hasTabIndex && 0,
                        "aria-label": buttonTitle
                    }), source === constants.v.CARD ? contentText : function(_ref12) {
                        var contentText = _ref12.contentText, personalizedButtonText = _ref12.personalizedButtonText, impression = _ref12.impression, branding = _ref12.branding, allowedAnimation = _ref12.allowedAnimation;
                        return Object(jsx.c)("div", {
                            class: "" + class_CLASS.BUTTON_LABEL
                        }, function(_ref10) {
                            var personalizedButtonText = _ref10.personalizedButtonText;
                            if (_ref10.branding && _ref10.allowedAnimation) {
                                var COMPRESSED = "\n        max-width: 0%;\n        opacity: 0;\n    ";
                                var EXPANDED = "\n        max-width: 100%;\n        opacity: 1;\n    ";
                                var HIDDEN = "\n        position: absolute;\n        visibility: hidden;\n    ";
                                var VISIBLE = "\n        position: static;\n        visibility: visible;\n    ";
                                var PAYPAL_BUTTON = "." + class_CLASS.BUTTON + "[" + constants.c.FUNDING_SOURCE + "=" + constants.v.PAYPAL + "]";
                                var PAYPAL_LOGO = PAYPAL_BUTTON + " ." + class_CLASS.LOGO + "." + class_CLASS.LOGO + "-" + constants.v.PAYPAL;
                                var BUTTON_TEXT = PAYPAL_BUTTON + " ." + class_CLASS.TEXT + ":not(.personalization-text)";
                                var PERSONALIZATION_TEXT = PAYPAL_BUTTON + " .personalization-text";
                                return Object(jsx.c)("style", {
                                    innerHTML: "\n\n            " + BUTTON_TEXT + ", " + PERSONALIZATION_TEXT + " {\n                " + HIDDEN + "\n            }\n\n            .dom-ready " + BUTTON_TEXT + ":not(." + class_CLASS.HIDDEN + ") {\n                " + VISIBLE + "\n                " + COMPRESSED + "\n                animation: show-text 1s 0s forwards;\n            }\n\n            @media only screen and (max-width: 300px) {\n                .dom-ready " + PERSONALIZATION_TEXT + " {\n                    " + HIDDEN + "\n                }\n            }\n\n            @media only screen and (min-width: 300px) {\n                .dom-ready " + PAYPAL_LOGO + " {\n                    animation: " + (personalizedButtonText ? "toggle-paypal-logo 5s 0s forwards" : "none") + ";\n                }\n\n                .dom-ready " + BUTTON_TEXT + ":not(." + class_CLASS.HIDDEN + ") {\n                    " + COMPRESSED + "\n                    " + VISIBLE + "\n                    animation: " + (personalizedButtonText ? "show-text-delayed 5s 0s forwards" : "show-text 1s 0s forwards") + ";\n                }\n\n                .dom-ready " + PERSONALIZATION_TEXT + " {\n                    " + COMPRESSED + "\n                    " + VISIBLE + "\n                    animation: show-personalization-text 5s 0s forwards;\n                }\n            }\n\n            @keyframes show-text {\n                0% { " + COMPRESSED + " }\n                100% { " + EXPANDED + " }\n            }\n\n            @keyframes toggle-paypal-logo {\n                0% { " + EXPANDED + " }\n                8% { " + COMPRESSED + " }\n                85% { " + COMPRESSED + " }\n                100% { " + EXPANDED + " }\n            }\n\n            @keyframes show-text-delayed {\n                0% { " + COMPRESSED + " }\n                85% { " + COMPRESSED + " }\n                100% { " + EXPANDED + " }\n            }\n\n            @keyframes show-personalization-text {\n                0% { " + COMPRESSED + " }\n                25% { " + EXPANDED + " }\n                75% { " + EXPANDED + " }\n                100% { " + COMPRESSED + " }\n            }\n        "
                                });
                            }
                        }({
                            personalizedButtonText: personalizedButtonText,
                            branding: branding,
                            allowedAnimation: allowedAnimation
                        }), contentText, personalizedButtonText, impression && function(impression) {
                            return Object(jsx.c)("div", {
                                class: "tracking-beacon"
                            }, Object(jsx.c)("style", {
                                innerHTML: "\n            .tracking-beacon {\n                visibility: hidden;\n                position: absolute;\n                height: 1px;\n                width: 1px;\n            }\n        "
                            }), Object(jsx.c)("img", {
                                class: "tracking-beacon",
                                src: impression
                            }));
                        }(impression));
                    }({
                        contentText: contentText,
                        personalizedButtonText: void 0,
                        impression: void 0,
                        branding: branding,
                        allowedAnimation: allowedAnimation
                    }));
                    var _ref2;
                }({
                    label: button.label,
                    color: button.color,
                    source: button.source,
                    env: env,
                    i: i,
                    funding: funding,
                    multiple: multiple,
                    locale: locale,
                    branding: branding,
                    tagline: tagline,
                    layout: layout,
                    shape: shape,
                    cards: cards,
                    installmentperiod: installmentperiod,
                    size: size,
                    checkoutCustomization: checkoutCustomization
                });
            }));
            var fundingiconNode = function(_ref9) {
                var cards = _ref9.cards, size = _ref9.size, layout = _ref9.layout;
                if (_ref9.fundingicons) return Object(jsx.c)("div", {
                    class: "" + class_CLASS.FUNDINGICONS
                }, renderCards({
                    cards: cards,
                    size: size,
                    layout: layout
                }));
            }({
                cards: cards,
                fundingicons: fundingicons,
                size: size,
                layout: layout
            });
            var styleNode = function(_ref19) {
                var height = _ref19.height, cardNumber = _ref19.cardNumber;
                return Object(jsx.c)("style", {
                    innerHTML: (_ref = {
                        height: height,
                        cardNumber: cardNumber
                    }, "\n        " + pageStyle + "\n        " + buttonStyle + "\n        " + buttonColorStyle + "\n        " + layoutStyle + "\n        " + brandingStyle + "\n        " + labelStyle + "\n        " + function(_ref) {
                        var height = _ref.height, _ref$cardNumber = _ref.cardNumber, cardNumber = void 0 === _ref$cardNumber ? 4 : _ref$cardNumber;
                        return Object.keys(button_config.c).map((function(size) {
                            var style = button_config.c[size];
                            var buttonHeight = height || style.defaultHeight;
                            var buttonTextMarginTop = style.buttonTextMargin;
                            var minDualWidth = Math.round(2.8 * buttonHeight * 2);
                            return "\n\n            @media only screen and (min-width: " + style.minWidth + "px) {\n\n                ." + class_CLASS.CONTAINER + " {\n                    min-width: " + style.minWidth + "px;\n                    max-width: " + style.maxWidth + "px;\n                    font-size: " + Object(util.h)(Object(util.m)(buttonHeight, 32), 10) + "px;\n                }\n\n                ." + class_CLASS.BUTTON + ":not(." + class_CLASS.CARD + ") {\n                    height: " + buttonHeight + "px;\n                    min-height: " + (height || style.minHeight) + "px;\n                    max-height: " + (height || style.maxHeight) + "px;\n                }\n\n                ." + class_CLASS.BUTTON + "." + class_CLASS.BRANDING + "-" + constants.d.UNBRANDED + " ." + class_CLASS.BUTTON_LABEL + " {\n                    height: 100%;\n                    font-size: " + Object(util.h)(Object(util.m)(buttonHeight, 45), 10) + "px;\n                }\n\n                ." + class_CLASS.BUTTON + " ." + class_CLASS.BUTTON_LABEL + " {\n                    height: " + (Object(util.m)(buttonHeight, 35) + 5) + "px;\n                    max-height: " + Object(util.m)(buttonHeight, 60) + "px;\n                    min-height: " + Object(util.m)(buttonHeight, 40) + "px;\n                }\n                \n                ." + class_CLASS.BUTTON + " ." + class_CLASS.BUTTON_LABEL + " ." + class_CLASS.TEXT + " {\n                    margin-top: " + buttonTextMarginTop + "px;\n                }\n                \n                ." + class_CLASS.LOGO + "." + class_CLASS.LOGO + "-" + constants.f.EPS + ",\n                ." + class_CLASS.LOGO + "." + class_CLASS.LOGO + "-" + constants.f.MYBANK + " {\n                    height: " + (Object(util.m)(buttonHeight, 50) + 5) + "px;\n                    max-height: " + Object(util.m)(buttonHeight, 70) + "px;\n                    min-height: " + Object(util.m)(buttonHeight, 40) + "px;\n                }\n\n                ." + class_CLASS.BUTTON + "." + class_CLASS.SHAPE + "-" + constants.k.PILL + " {\n                    border-radius: " + Math.ceil(buttonHeight / 2) + "px;\n                }\n\n                ." + class_CLASS.BUTTON + "." + class_CLASS.SHAPE + "-" + constants.k.RECT + " {\n                    border-radius: 4px;\n                }\n\n                ." + class_CLASS.BUTTON + "." + class_CLASS.LAYOUT + "-" + constants.g.VERTICAL + " {\n                    margin-bottom: " + Object(util.m)(buttonHeight, button_config.b.VERTICAL_MARGIN) + "px;\n                }\n\n                ." + class_CLASS.SEPARATOR + " {\n                    margin: 0 " + Object(util.m)(buttonHeight, 5) + "px;\n                }\n\n                ." + class_CLASS.TAGLINE + " {\n                    display: " + (style.allowTagline ? "block" : "none") + ";\n                    height: " + Object(util.m)(buttonHeight, button_config.b.TAGLINE) + "px;\n                    line-height: " + Object(util.m)(buttonHeight, button_config.b.TAGLINE) + "px;\n                }\n\n                ." + class_CLASS.FUNDINGICONS + " {\n                    display: " + (style.allowFunding ? "block" : "none") + ";\n                    height: " + Object(util.m)(buttonHeight, button_config.b.FUNDINGICONS) + "px;\n                }\n\n                ." + class_CLASS.CARD + " {\n                    display: inline-block;\n                }\n\n                ." + class_CLASS.BUTTON + " ." + class_CLASS.CARD + " {\n                    width: " + (90 / cardNumber).toFixed(2) + "%;\n                    max-width: " + Object(util.m)(buttonHeight, 160) + "px;\n                    margin-top: 0;\n                    margin-left: " + (5 / cardNumber).toFixed(2) + "%;\n                    margin-right: " + (5 / cardNumber).toFixed(2) + "%;\n                }\n\n                ." + class_CLASS.BUTTON + " ." + class_CLASS.CARD + " img {\n                    width: 100%;\n                }\n\n                ." + class_CLASS.FUNDINGICONS + " ." + class_CLASS.CARD + " {\n                    height: " + Object(util.m)(buttonHeight, 70) + "px;\n                    margin-top: " + Object(util.m)(buttonHeight, 15) + "px;\n                    margin-left: " + Object(util.m)(buttonHeight, 7) + "px;\n                    margin-right: " + Object(util.m)(buttonHeight, 7) + "px;\n                }\n\n                ." + class_CLASS.FUNDINGICONS + " ." + class_CLASS.CARD + " img {\n                    height: 100%;\n                }\n            }\n\n            @media only screen and (min-width: " + style.minWidth + "px) and (max-width: " + minDualWidth + "px) {\n\n                ." + class_CLASS.BUTTON + "." + class_CLASS.LAYOUT + "-" + constants.g.HORIZONTAL + "." + class_CLASS.NUMBER + "-" + constants.j.MULTIPLE + "." + class_CLASS.NUMBER + "-0 {\n                    width: 100%;\n                    margin-right: 0;\n                }\n\n                ." + class_CLASS.BUTTON + "." + class_CLASS.LAYOUT + "-" + constants.g.HORIZONTAL + "." + class_CLASS.NUMBER + "-" + constants.j.MULTIPLE + "." + class_CLASS.NUMBER + "-1 {\n                    display: none;\n                }\n\n                ." + class_CLASS.CONTAINER + "." + class_CLASS.LAYOUT + "-" + constants.g.HORIZONTAL + "." + class_CLASS.NUMBER + "-" + constants.j.MULTIPLE + " ." + class_CLASS.TAGLINE + " {\n                    display: none;\n                }\n            }\n\n            @media only screen and (min-width: " + Object(util.h)(style.minWidth, minDualWidth) + "px) {\n\n                ." + class_CLASS.BUTTON + "." + class_CLASS.LAYOUT + "-" + constants.g.HORIZONTAL + "." + class_CLASS.NUMBER + "-" + constants.j.MULTIPLE + "." + class_CLASS.NUMBER + "-0 {\n                    display: inline-block;\n                    width: calc(50% - 2px);\n                    margin-right: 4px;\n                }\n\n                ." + class_CLASS.BUTTON + "." + class_CLASS.LAYOUT + "-" + constants.g.HORIZONTAL + "." + class_CLASS.NUMBER + "-" + constants.j.MULTIPLE + "." + class_CLASS.NUMBER + "-1 {\n                    display: inline-block;\n                    width: calc(50% - 2px);\n                }\n\n                ." + class_CLASS.CONTAINER + "." + class_CLASS.LAYOUT + "-" + constants.g.HORIZONTAL + "." + class_CLASS.NUMBER + "-" + constants.j.MULTIPLE + " ." + class_CLASS.TAGLINE + " {\n                    display: block;\n                }\n            }\n        ";
                        })).join("\n");
                    }({
                        height: _ref.height,
                        cardNumber: _ref.cardNumber
                    }) + "\n    ")
                });
                var _ref;
            }({
                height: height,
                cardNumber: cards.length
            });
            var scriptNode = function() {
                var script = function() {
                    var SELECTOR_ALL = "*", SELECTOR_OPTIONAL = "[optional]";
                    function toArray(item) {
                        return [].slice.call(item);
                    }
                    function getElements(selector, parent) {
                        return toArray((parent = parent || document).querySelectorAll(selector)).filter((function(el) {
                            return "style" !== el.tagName.toLowerCase();
                        }));
                    }
                    function getOptionalIndex(element) {
                        return parseInt(element.getAttribute("optional") || 0, 10);
                    }
                    function getElementsTotalWidth(elements) {
                        return function(arr) {
                            var result = 0;
                            for (var _i2 = 0; _i2 < arr.length; _i2++) result += arr[_i2];
                            return result;
                        }(elements.map((function(child) {
                            return child.offsetWidth;
                        })));
                    }
                    var children = function(arr) {
                        var result = [];
                        for (var _i4 = 0; _i4 < arr.length; _i4++) {
                            var el = arr[_i4];
                            -1 === result.indexOf(el) && result.push(el);
                        }
                        return result;
                    }([].concat(getElements(SELECTOR_OPTIONAL), getElements(".{ CLASS.FUNDINGICONS } .{ CLASS.CARD }"), getElements(".{ CLASS.BUTTON }-label-credit .{ CLASS.BUTTON }-logo-paypal")).map((function(element) {
                        return element.parentElement;
                    })).filter(Boolean)).map((function(optionalParent) {
                        return {
                            optionalParent: optionalParent,
                            allChildren: getElements(SELECTOR_ALL, optionalParent),
                            optionalChildren: toArray(getElements(SELECTOR_OPTIONAL, optionalParent)).sort((function(first, second) {
                                return getOptionalIndex(first) - getOptionalIndex(second);
                            }))
                        };
                    }));
                    function toggleOptionals() {
                        for (var _i6 = 0; _i6 < children.length; _i6++) {
                            var _children$_i = children[_i6], optionalChildren = _children$_i.optionalChildren;
                            var parentWidth = _children$_i.optionalParent.offsetWidth;
                            var usedWidth = getElementsTotalWidth(_children$_i.allChildren) - getElementsTotalWidth(optionalChildren);
                            for (var _i8 = 0; _i8 < optionalChildren.length; _i8++) {
                                var optionalChild = optionalChildren[_i8];
                                (usedWidth += optionalChild.offsetWidth) + 4 >= parentWidth ? optionalChild.classList.add("hidden") : optionalChild.classList.remove("hidden");
                            }
                        }
                    }
                    var setDomReady = function(handler) {
                        var called = !1;
                        return function() {
                            if (!called) {
                                called = !0;
                                handler.apply(void 0, arguments);
                            }
                        };
                    }(function(handler, time) {
                        void 0 === time && (time = 50);
                        var timeout;
                        return function() {
                            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
                            clearTimeout(timeout);
                            timeout = setTimeout((function() {
                                handler.apply(void 0, args);
                            }), time);
                        };
                    }((function() {
                        window.addEventListener("resize", toggleOptionals);
                        document.body && document.body.classList.add("dom-ready");
                    })));
                    var load = function() {
                        toggleOptionals();
                        setDomReady();
                    };
                    toggleOptionals();
                    !function() {
                        var buttonsContainer = document.getElementsByClassName("{ CLASS.CONTAINER }")[0];
                        function handleMouseDownOnce() {
                            buttonsContainer.classList.remove("{ CLASS.SHOULD_FOCUS }");
                            window.removeEventListener("mousedown", handleMouseDownOnce);
                            window.addEventListener("keydown", handleFirstTab);
                        }
                        function handleFirstTab(e) {
                            if (9 === e.keyCode) {
                                buttonsContainer.classList.add("{ CLASS.SHOULD_FOCUS }");
                                window.removeEventListener("keydown", handleFirstTab);
                                window.addEventListener("mousedown", handleMouseDownOnce);
                            }
                        }
                        buttonsContainer.classList.add("{ CLASS.SHOULD_FOCUS }");
                        window.addEventListener("keydown", handleFirstTab);
                    }();
                    document.addEventListener("DOMContentLoaded", load);
                    window.addEventListener("load", load);
                    window.addEventListener("resize", load);
                }.toString();
                script = script.replace(/\{\s*CLASS\.([A-Z0-9_]+)\s*\}/g, (function(match, name) {
                    return class_CLASS[name];
                }));
                return Object(jsx.c)("script", {
                    innerHTML: "(" + script + ")();"
                });
            }();
            var labelPowerByPayPal = cards.length > 0 ? function(props) {
                if (!props) return null;
                var _props$sources = props.sources;
                return props.layout !== constants.g.VERTICAL || -1 === (void 0 === _props$sources ? [] : _props$sources).indexOf(constants.v.CARD) ? null : Object(jsx.c)("div", {
                    class: "powered-by-paypal",
                    style: "\n                text-align: center;\n                margin: 10px auto;\n                height: 14px;\n                font-family: PayPal-Sans, HelveticaNeue, sans-serif;\n                font-size: 11px;\n                font-weight: normal;\n                font-style: italic;\n                font-stretch: normal;\n                color: #7b8388;\n                position: relative;\n                margin-right: 3px;\n                bottom: 3px;\n            "
                }, renderContent("{ content: poweredBy }", Object(esm_extends.a)({}, props, {
                    logoColor: "blue"
                })));
            }(Object(button_props.a)(props)) : null;
            return Object(jsx.c)("div", Object(esm_extends.a)({}, (_ref21 = {}, _ref21[constants.c.VERSION] = "4.0.331", 
            _ref21), {
                class: class_CLASS.CONTAINER + " " + getCommonButtonClasses({
                    layout: layout,
                    shape: shape,
                    branding: branding,
                    multiple: multiple,
                    env: env
                })
            }), styleNode, buttonNodes, fundingiconNode, labelPowerByPayPal, scriptNode).toString();
        }
        pptm.listenForLoadWithNoContent();
        var creditThrottle;
        var component_Button = Object(src.c)({
            tag: "paypal-button",
            name: "ppbutton",
            buildUrl: function(props) {
                return config.a.buttonUrls[props.env || config.a.env];
            },
            contexts: {
                iframe: !0,
                popup: !1
            },
            scrolling: !1,
            listenForResize: !0,
            containerTemplate: function(_ref) {
                var _ref3;
                var id = _ref.id, props = _ref.props, CLASS = _ref.CLASS, tag = _ref.tag, context = _ref.context, outlet = _ref.outlet, jsxDom = _ref.jsxDom;
                var _normalizeProps = Object(button_props.a)(props), size = _normalizeProps.size, label = _normalizeProps.label, layout = _normalizeProps.layout, buttonHeight = _normalizeProps.height;
                var minimumSize = Object(button_config.e)(label, layout === constants.g.VERTICAL ? "minimumVerticalSize" : "minimumSize");
                var maximumSize = Object(button_config.e)(label, layout === constants.g.VERTICAL ? "maximumVerticalSize" : "maximumSize");
                if (buttonHeight) {
                    var possibleSizes = Object(util.t)(constants.l).filter((function(possibleSize) {
                        return button_config.c[possibleSize] && buttonHeight && button_config.c[possibleSize].minHeight <= buttonHeight && button_config.c[possibleSize].maxHeight >= buttonHeight;
                    }));
                    possibleSizes.sort((function(sizeA, sizeB) {
                        return button_config.c[sizeA].defaultWidth - button_config.c[sizeB].defaultWidth;
                    }));
                    minimumSize = possibleSizes[0];
                    maximumSize = possibleSizes[possibleSizes.length - 1];
                }
                var _ref2 = button_config.c[size] || button_config.c[constants.l.SMALL], defaultWidth = _ref2.defaultWidth, defaultHeight = _ref2.defaultHeight;
                setTimeout((function() {
                    outlet.style.transition = "all 0.5s ease-in-out 0.3s";
                }), 3e3);
                return jsxDom("div", Object(esm_extends.a)({
                    id: id,
                    class: tag + " " + tag + "-context-" + context + " " + tag + "-label-" + label + " " + tag + "-size-" + size + " " + tag + "-layout-" + layout
                }, ((_ref3 = {})[constants.c.SMART_BUTTON_VERSION] = "4.0.331", _ref3)), jsxDom("style", null, "\n                    #" + id + " {\n                        font-size: 0;\n                        width: 100%;\n                        overflow: hidden;\n                        min-width: " + button_config.c[minimumSize].minWidth + "px;\n                    }\n\n                    #" + id + "." + tag + "-size-" + constants.l.RESPONSIVE + " {\n                        text-align: center;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " {\n                        display: inline-block;\n                        min-width: " + button_config.c[minimumSize].minWidth + "px;\n                        max-width: " + button_config.c[maximumSize].maxWidth + "px;\n                        position: relative;\n                    }\n\n                    #" + id + "." + tag + "-layout-" + constants.g.VERTICAL + " > ." + CLASS.OUTLET + " {\n                        min-width: " + button_config.c[minimumSize].minWidth + "px;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " {\n                        width:  " + defaultWidth + "px;\n                        height: " + defaultHeight + "px;\n                    }\n\n                     #" + id + "." + tag + "-size-" + constants.l.RESPONSIVE + " > ." + CLASS.OUTLET + " {\n                        width: 100%;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe {\n                        min-width: 100%;\n                        max-width: 100%;\n                        width: " + button_config.c[minimumSize].minWidth + "px;\n                        height: 100%;\n                        position: absolute;\n                        top: 0;\n                        left: 0;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe." + CLASS.COMPONENT_FRAME + " {\n                        z-index: 100;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe." + CLASS.PRERENDER_FRAME + " {\n                        transition: opacity .2s linear;\n                        z-index: 200;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe." + CLASS.VISIBLE + " {\n                        opacity: 1;\n                    }\n\n                    #" + id + " > ." + CLASS.OUTLET + " > iframe." + CLASS.INVISIBLE + " {\n                        opacity: 0;\n                        pointer-events: none;\n                    }\n                "), outlet);
            },
            autoResize: {
                height: !0,
                width: !1
            },
            prerenderTemplate: function(_ref) {
                var _this = this;
                var jsxDom = _ref.jsxDom;
                var template = jsxDom("div", {
                    innerHTML: componentTemplate({
                        props: _ref.props
                    })
                });
                template.addEventListener("click", (function() {
                    Object(beaver_logger_client.q)("button_pre_template_click");
                    if (Object(belter_src.k)()) {
                        Object(beaver_logger_client.q)("button_pre_template_click_intranet_mode");
                        Object(beaver_logger_client.h)();
                        alert("IE Intranet mode is not supported by PayPal. Please disable intranet mode, or continue in an alternate browser.");
                    }
                    if (Object(lib.m)("allow_full_page_fallback")) {
                        Object(beaver_logger_client.k)("pre_template_force_full_page");
                        _this.props.payment().then((function(token) {
                            window.top.location = Object(lib.g)(config.a.checkoutUrl, {
                                token: token
                            });
                        }));
                    }
                }));
                return jsxDom("html", null, jsxDom("body", null, template));
            },
            get version() {
                return Object(lib.v)();
            },
            get domain() {
                return config.a.paypalDomains;
            },
            attributes: {
                iframe: {
                    allowpaymentrequest: "allowpaymentrequest",
                    title: constants.w.PAYPAL
                }
            },
            validate: function() {
                Object(lib.C)() || Object(beaver_logger_client.q)("button_render_ineligible");
            },
            props: {
                domain: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return window.location.host;
                    },
                    queryParam: !0
                },
                sessionID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.w)();
                    },
                    queryParam: !0
                },
                buttonSessionID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.V)();
                    },
                    queryParam: !0
                },
                renderedButtons: {
                    type: "string",
                    required: !1,
                    def: function(props) {
                        return Object(lib.s)(props);
                    },
                    queryParam: !0
                },
                storageID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.y)();
                    },
                    queryParam: !0
                },
                env: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return config.a.env;
                    },
                    validate: function(env) {
                        if (env && !config.a.paypalUrls[env]) throw new Error("Invalid env: " + env);
                    }
                },
                meta: {
                    type: "object",
                    required: !1,
                    def: function() {
                        return {};
                    }
                },
                enableNativeCheckout: {
                    type: "boolean",
                    required: !1,
                    def: function() {
                        return !1;
                    }
                },
                client: {
                    type: "object",
                    required: !1,
                    def: function() {
                        return {};
                    },
                    validate: function(client, props) {
                        var env = props.env || config.a.env;
                        if (!client[env]) throw new Error("Client ID not found for env: " + env);
                        if ("string" == typeof client[env]) {
                            if (client[env].match(/^(.)\1+$/)) throw new Error("Invalid client ID: " + client[env]);
                        } else if (!zalgo_promise_src.a.isPromise(client[env])) throw new Error("Expected client token to be either a string or a promise");
                    },
                    decorate: function(client) {
                        client && "demo_sandbox_client_id" === client.sandbox && (client.sandbox = "AZDxjDScFpQtjWTOUtWKbyN_bDt4OgqaF4eYXlewfBP4-8aqX3PiV8e1GWU6liB2CUXlkA59kJXE7M6R");
                        return client;
                    }
                },
                source: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return constants.F.MANUAL;
                    }
                },
                prefetchLogin: {
                    type: "boolean",
                    required: !1
                },
                stage: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function(props) {
                        var env = props.env || config.a.env;
                        if (env === constants.t.STAGE || env === constants.t.LOCAL) return config.a.stage;
                    }
                },
                updateClientConfiguration: {
                    type: "boolean",
                    required: !1,
                    def: function() {
                        return !0;
                    }
                },
                stageUrl: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function(props) {
                        var env = props.env || config.a.env;
                        if (env === constants.t.STAGE || env === constants.t.LOCAL) return config.a.stageUrl;
                    }
                },
                localhostUrl: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function(props) {
                        if ((props.env || config.a.env) === constants.t.LOCAL) return config.a.localhostUrl;
                    }
                },
                checkoutUri: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return config.a.checkoutUri;
                    }
                },
                braintree: {
                    type: "object",
                    required: !1,
                    validate: function(braintree, props) {
                        if (!braintree.paypalCheckout) throw new Error("Expected Braintree paypal-checkout component to be loaded");
                        if (!props.client) throw new Error("Expected client prop to be passed with Braintree authorization keys");
                    },
                    decorate: function(braintree, props) {
                        var env = props.env || config.a.env;
                        return zalgo_promise_src.a.hash(props.client).then((function(client) {
                            return Object(integrations.a)(braintree, client[env]);
                        }));
                    }
                },
                payment: {
                    type: "function",
                    required: !0,
                    memoize: !1,
                    timeout: 1e4,
                    alias: "billingAgreement",
                    decorate: function(original) {
                        return function(data) {
                            var _this2 = this;
                            void 0 === data && (data = {});
                            var actions = {
                                request: lib.Q,
                                payment: {
                                    create: function(options) {
                                        return _this2.props.braintree ? _this2.props.braintree.then((function(client) {
                                            return client.createPayment(Object(integrations.e)(options.payment || options));
                                        })) : zalgo_promise_src.a.hash(_this2.props.client).then((function(client) {
                                            return rest.payment.create(_this2.props.env, client, options);
                                        }));
                                    }
                                },
                                order: {
                                    create: function(options) {
                                        return zalgo_promise_src.a.hash(_this2.props.client).then((function(client) {
                                            return rest.order.create(_this2.props.env, client, options);
                                        }));
                                    }
                                },
                                braintree: {
                                    create: function(options) {
                                        if (!_this2.props.braintree) throw new Error("Can not create using Braintree - no braintree client provided");
                                        return _this2.props.braintree.then((function(client) {
                                            return client.createPayment(options);
                                        }));
                                    }
                                }
                            };
                            if (Object(lib.m)("memoize_payment") && this.memoizedToken) return this.memoizedToken;
                            this.memoizedToken = zalgo_promise_src.a.try(original, this, [ data, actions ]);
                            var startTime = Date.now();
                            this.memoizedToken = this.memoizedToken.then((function(token) {
                                var _track;
                                if (!token) {
                                    Object(beaver_logger_client.g)("no_token_passed_to_payment");
                                    throw new Error("No value passed to payment");
                                }
                                var elapsed = Date.now() - startTime;
                                Object(beaver_logger_client.p)(((_track = {})[constants.u.KEY.STATE] = constants.u.STATE.CHECKOUT, 
                                _track[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.RECIEVE_PAYMENT, _track[constants.u.KEY.CONTEXT_TYPE] = constants.u.CONTEXT_TYPE[Object(integrations.d)(token)], 
                                _track[constants.u.KEY.CONTEXT_ID] = token, _track[constants.u.KEY.BUTTON_SESSION_UID] = _this2.props.buttonSessionID, 
                                _track[constants.u.KEY.RESPONSE_DURATION] = elapsed, _track[constants.u.KEY.BUTTON_VERSION] = data && data.button_version, 
                                _track));
                                Object(beaver_logger_client.h)();
                                return token;
                            }));
                            return this.memoizedToken;
                        };
                    }
                },
                authCode: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return config.a.authCode;
                    }
                },
                funding: {
                    type: "object",
                    required: !1,
                    queryParam: !0,
                    validate: function(_temp) {
                        var _ref2 = void 0 === _temp ? {} : _temp, _ref2$allowed = _ref2.allowed, allowed = void 0 === _ref2$allowed ? [] : _ref2$allowed, _ref2$disallowed = _ref2.disallowed, disallowed = void 0 === _ref2$disallowed ? [] : _ref2$disallowed;
                        Object(src_funding.f)({
                            allowed: allowed,
                            disallowed: disallowed,
                            remembered: []
                        });
                    },
                    def: function() {
                        return {};
                    },
                    decorate: function(_temp2, props) {
                        var _ref3 = void 0 === _temp2 ? {} : _temp2, _ref3$allowed = _ref3.allowed, allowed = void 0 === _ref3$allowed ? [] : _ref3$allowed, _ref3$disallowed = _ref3.disallowed, disallowed = void 0 === _ref3$disallowed ? [] : _ref3$disallowed;
                        allowed = Array.isArray(allowed) ? allowed : [];
                        disallowed = Array.isArray(disallowed) ? disallowed : [];
                        allowed && -1 !== allowed.indexOf(constants.v.ITAU) && (allowed = allowed.filter((function(source) {
                            return source !== constants.v.ITAU;
                        })));
                        (function(props) {
                            var _normalizeProps = Object(button_props.a)(props, {
                                locale: Object(lib.i)()
                            }), label = _normalizeProps.label, funding = _normalizeProps.funding, layout = _normalizeProps.layout, locale = _normalizeProps.locale, max = _normalizeProps.max, sources = _normalizeProps.sources, env = _normalizeProps.env;
                            var allowed = funding.allowed;
                            var country = locale.country;
                            if (allowed && -1 !== allowed.indexOf(constants.v.CREDIT)) return !1;
                            if (layout !== constants.g.HORIZONTAL) return !1;
                            if (1 === max) return !1;
                            if (label === constants.f.CREDIT) return !1;
                            if (country !== constants.r.US) return !1;
                            if (Object(src_funding.d)(constants.v.CREDIT, {
                                funding: funding,
                                locale: locale,
                                layout: layout,
                                env: env
                            })) return !1;
                            if (Object(src_funding.c)(constants.v.CREDIT, {
                                funding: funding,
                                locale: locale,
                                layout: layout
                            })) return !1;
                            if (-1 !== sources.indexOf(constants.v.CREDIT)) return !1;
                            var domain = Object(cross_domain_utils_src.h)().replace(/^https?:\/\//, "").replace(/^www\./, "");
                            return -1 !== config.a.creditTestDomains.indexOf(domain);
                        })(props) && (creditThrottle = Object(lib.z)("dual_credit_automatic", 50)).isEnabled() && (allowed = [].concat(allowed, [ constants.v.CREDIT ]));
                        var remembered = Object(lib.r)((function(sources) {
                            return sources;
                        }));
                        remembered && -1 !== remembered.indexOf(constants.v.VENMO) && (remembered = remembered.filter((function(source) {
                            return source !== constants.v.VENMO;
                        })));
                        Object(lib.F)() && !Object(lib.m)("disable_venmo") || disallowed && -1 === disallowed.indexOf(constants.v.VENMO) && (disallowed = [].concat(disallowed, [ constants.v.VENMO ]));
                        return {
                            allowed: allowed,
                            disallowed: disallowed,
                            remembered: remembered,
                            remember: function(sources) {
                                Object(lib.P)(sources);
                            }
                        };
                    }
                },
                commit: {
                    type: "boolean",
                    required: !1,
                    queryParam: !0,
                    queryValue: function(val) {
                        return val ? "true" : "false";
                    }
                },
                onRender: {
                    type: "function",
                    promisify: !0,
                    required: !1,
                    noop: !0,
                    decorate: function(original) {
                        return function() {
                            var _track2;
                            var _getBrowser = Object(lib.h)(), _getBrowser$browser = _getBrowser.browser, browser = void 0 === _getBrowser$browser ? "unrecognized" : _getBrowser$browser, _getBrowser$version = _getBrowser.version, version = void 0 === _getBrowser$version ? "unrecognized" : _getBrowser$version;
                            Object(beaver_logger_client.k)("button_render_browser_" + browser + "_" + (Object(belter_src.h)() ? "mobile" : "desktop") + "_" + version);
                            var style = this.props.style || {};
                            Object(beaver_logger_client.k)("button_render");
                            Object(beaver_logger_client.k)("button_render_color_" + (style.color || "default"));
                            Object(beaver_logger_client.k)("button_render_shape_" + (style.shape || "default"));
                            Object(beaver_logger_client.k)("button_render_size_" + (style.size || "default"));
                            Object(beaver_logger_client.k)("button_render_label_" + (style.label || "default"));
                            Object(beaver_logger_client.k)("button_render_branding_" + (style.branding || "default"));
                            Object(beaver_logger_client.k)("button_render_fundingicons_" + (style.fundingicons || "default"));
                            Object(beaver_logger_client.k)("button_render_tagline_" + (style.tagline || "default"));
                            pptm.listenForButtonRender();
                            pptm.reloadPptmScript(this.props.client[this.props.env]);
                            Object(beaver_logger_client.p)(((_track2 = {})[constants.u.KEY.STATE] = constants.u.STATE.LOAD, 
                            _track2[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.BUTTON_RENDER, _track2[constants.u.KEY.BUTTON_TYPE] = constants.u.BUTTON_TYPE.IFRAME, 
                            _track2[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, _track2[constants.u.KEY.BUTTON_SOURCE] = this.props.source, 
                            _track2));
                            Object(belter_src.k)() && Object(beaver_logger_client.q)("button_render_intranet_mode");
                            if (creditThrottle) {
                                var _creditThrottle$logSt;
                                creditThrottle.logStart(((_creditThrottle$logSt = {})[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, 
                                _creditThrottle$logSt));
                            }
                            Object(beaver_logger_client.h)();
                            return original.apply(this, arguments);
                        };
                    }
                },
                onAuthorize: {
                    type: "function",
                    alias: "onApprove",
                    required: !0,
                    decorate: function(original) {
                        return function(data, actions) {
                            var _track3, _this3 = this;
                            data && !data.intent && Object(beaver_logger_client.q)("button_authorize_no_intent", {
                                paymentID: data.paymentID,
                                token: data.paymentToken
                            });
                            Object(beaver_logger_client.k)("button_authorize");
                            Object(beaver_logger_client.p)(((_track3 = {})[constants.u.KEY.STATE] = constants.u.STATE.CHECKOUT, 
                            _track3[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.CHECKOUT_APPROVE, _track3[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, 
                            _track3[constants.u.KEY.BUTTON_VERSION] = data && data.button_version, _track3));
                            Object(belter_src.k)() && Object(beaver_logger_client.q)("button_authorize_intranet_mode");
                            Object(lib.C)() || Object(beaver_logger_client.k)("button_authorize_ineligible");
                            Object(lib.d)("authorize");
                            Object(beaver_logger_client.h)();
                            var restart = actions.restart;
                            actions.restart = function() {
                                return restart().then((function() {
                                    return new zalgo_promise_src.a;
                                }));
                            };
                            actions.redirect = function(win, url) {
                                return zalgo_promise_src.a.try((function() {
                                    if (actions.close) return actions.close();
                                })).then((function() {
                                    return Object(lib.O)(win || window.top, url || data.returnUrl);
                                }));
                            };
                            actions.payment.tokenize = Object(lib.H)((function() {
                                if (!_this3.props.braintree) throw new Error("Must pass in Braintree client to tokenize payment");
                                return _this3.props.braintree.then((function(client) {
                                    return client.tokenizePayment(data);
                                }));
                            }));
                            var execute = actions.payment.execute;
                            actions.payment.execute = function() {
                                return execute().then((function(result) {
                                    if (!(result && result.id && result.intent && result.state)) {
                                        Object(beaver_logger_client.q)("execute_result_missing_data");
                                        return new zalgo_promise_src.a;
                                    }
                                    return result;
                                }));
                            };
                            var get = actions.payment.get;
                            actions.payment.get = function() {
                                return get().then((function(result) {
                                    if (!(result && result.id && result.intent && result.state)) {
                                        Object(beaver_logger_client.q)("get_result_missing_data");
                                        return new zalgo_promise_src.a;
                                    }
                                    return result;
                                }));
                            };
                            actions.request = lib.Q;
                            onAuthorizeListener.trigger({
                                paymentToken: data.paymentToken
                            });
                            if (creditThrottle) {
                                var _creditThrottle$logCo;
                                creditThrottle.logComplete(((_creditThrottle$logCo = {})[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, 
                                _creditThrottle$logCo));
                            }
                            return zalgo_promise_src.a.try((function() {
                                if (_this3.props.braintree) return actions.payment.tokenize().then((function(_ref4) {
                                    var nonce = _ref4.nonce;
                                    Object.defineProperty(data, "nonce", {
                                        get: function() {
                                            Object(beaver_logger_client.k)("nonce_getter");
                                            Object(beaver_logger_client.h)();
                                            return nonce;
                                        }
                                    });
                                }));
                            })).then((function() {
                                return original.call(_this3, data, actions);
                            })).catch((function(err) {
                                if (_this3.props.onError) return _this3.props.onError(err);
                                throw err;
                            }));
                        };
                    }
                },
                onShippingChange: {
                    type: "function",
                    required: !1,
                    decorate: function(original) {
                        if (original) return function(data, actions) {
                            var _track4, _this4 = this;
                            Object(beaver_logger_client.k)("button_shipping_change");
                            Object(beaver_logger_client.p)(((_track4 = {})[constants.u.KEY.STATE] = constants.u.STATE.CHECKOUT, 
                            _track4[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.CHECKOUT_SHIPPING_CHANGE, 
                            _track4[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, _track4[constants.u.KEY.BUTTON_VERSION] = data && data.button_version, 
                            _track4));
                            Object(beaver_logger_client.h)();
                            var patch = actions.payment.patch;
                            actions.payment.patch = function(patchObject) {
                                return zalgo_promise_src.a.try((function() {
                                    return patch(patchObject);
                                }));
                            };
                            var resolve = function() {
                                return zalgo_promise_src.a.resolve();
                            };
                            var reject = actions.reject || function() {
                                throw new Error("Missing reject action callback");
                            };
                            return zalgo_promise_src.a.try((function() {
                                return original.call(_this4, data, Object(esm_extends.a)({}, actions, {
                                    resolve: resolve,
                                    reject: reject
                                }));
                            })).timeout(1e4, new Error("Timed out waiting 10000ms for payment")).catch((function(err) {
                                _this4.props.onError && _this4.props.onError(err);
                                throw err;
                            }));
                        };
                    }
                },
                onError: {
                    type: "function",
                    required: !1,
                    promisify: !0,
                    sendToChild: !0,
                    once: !0,
                    def: function() {
                        return function(err) {
                            if (Object(belter_src.k)()) {
                                Object(beaver_logger_client.q)("button_error_intranet_mode");
                                Object(beaver_logger_client.h)();
                                alert("IE Intranet mode is not supported by PayPal. Please disable intranet mode, or continue in an alternate browser.");
                            }
                            setTimeout((function() {
                                throw err;
                            }));
                        };
                    }
                },
                onCancel: {
                    type: "function",
                    required: !1,
                    noop: !0,
                    decorate: function(original) {
                        return function(data, actions) {
                            var _track5;
                            Object(beaver_logger_client.k)("button_cancel");
                            Object(beaver_logger_client.p)(((_track5 = {})[constants.u.KEY.STATE] = constants.u.STATE.CHECKOUT, 
                            _track5[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.CHECKOUT_CANCEL, _track5[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, 
                            _track5[constants.u.KEY.BUTTON_VERSION] = data && data.button_version, _track5));
                            Object(beaver_logger_client.h)();
                            return original.call(this, data, Object(esm_extends.a)({}, actions, {
                                redirect: function(win, url) {
                                    return zalgo_promise_src.a.all([ Object(lib.O)(win || window.top, url || data.cancelUrl), actions.close() ]);
                                }
                            }));
                        };
                    }
                },
                onClick: {
                    type: "function",
                    required: !1,
                    noop: !0,
                    decorate: function(original) {
                        return function(data) {
                            var _track6;
                            Object(beaver_logger_client.k)("button_click");
                            data && data.flow && Object(beaver_logger_client.k)("pay_flow_" + data.flow);
                            Object(beaver_logger_client.p)(((_track6 = {})[constants.u.KEY.STATE] = constants.u.STATE.BUTTON, 
                            _track6[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.BUTTON_CLICK, _track6[constants.u.KEY.BUTTON_TYPE] = constants.u.BUTTON_TYPE.IFRAME, 
                            _track6[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, _track6[constants.u.KEY.CHOSEN_FUNDING] = data && (data.card || data.fundingSource), 
                            _track6[constants.u.KEY.PAYMENT_FLOW] = data && data.flow, _track6[constants.u.KEY.BUTTON_VERSION] = data && data.button_version, 
                            _track6));
                            Object(belter_src.k)() && Object(beaver_logger_client.q)("button_click_intranet_mode");
                            if (creditThrottle) {
                                var _creditThrottle$log;
                                creditThrottle.log("click", ((_creditThrottle$log = {})[constants.u.KEY.STATE] = constants.u.STATE.BUTTON, 
                                _creditThrottle$log[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.BUTTON_CLICK, 
                                _creditThrottle$log[constants.u.KEY.BUTTON_SESSION_UID] = this.props.buttonSessionID, 
                                _creditThrottle$log));
                            }
                            var _ref5 = this.props.style || {}, _ref5$color = _ref5.color, color = void 0 === _ref5$color ? "default" : _ref5$color;
                            Object(beaver_logger_client.k)("button_click_color_" + color);
                            Object(beaver_logger_client.h)();
                            return original.apply(this, arguments);
                        };
                    }
                },
                onResize: {
                    type: "function",
                    required: !1,
                    get value() {
                        var initialHeight;
                        var logInlineGuestOutOfViewPortOnlyOnce = Object(src_lib.H)((function(data) {
                            Object(beaver_logger_client.k)("buttons_expansion_outside_viewport", data);
                            Object(beaver_logger_client.j)();
                        }));
                        return function() {
                            var container = this.container;
                            if (container) {
                                initialHeight || (initialHeight = container.offsetHeight);
                                var isContainerExpanded = container && container.offsetHeight > initialHeight;
                                var isExpansionInViewport = function() {
                                    try {
                                        var scrollOffsetY = window.pageYOffset ? window.pageYOffset : document.documentElement ? document.documentElement.scrollTop : 0;
                                        var windowHeight = window.innerHeight;
                                        var containerOffsetY = container.getBoundingClientRect().top;
                                        return scrollOffsetY + windowHeight > initialHeight + containerOffsetY + 200;
                                    } catch (err) {
                                        Object(beaver_logger_client.k)("cannot_get_the_viewport_information");
                                        return !1;
                                    }
                                }();
                                isContainerExpanded && !isExpansionInViewport && logInlineGuestOutOfViewPortOnlyOnce({
                                    height: container.offsetHeight,
                                    window: {
                                        width: window.innerWidth,
                                        height: window.innerHeight
                                    }
                                });
                            }
                        };
                    },
                    decorate: function(original) {
                        return Object(src_lib.i)(original);
                    }
                },
                locale: {
                    type: "string",
                    required: !1,
                    queryParam: "locale.x",
                    def: function() {
                        var _getBrowserLocale = Object(lib.i)();
                        return _getBrowserLocale.lang + "_" + _getBrowserLocale.country;
                    },
                    validate: validateButtonLocale
                },
                style: {
                    type: "object",
                    required: !1,
                    queryParam: !0,
                    alias: "buttonStyle",
                    def: function() {
                        return {
                            color: constants.e.GOLD,
                            shape: constants.k.PILL,
                            size: constants.l.SMALL,
                            label: constants.f.CHECKOUT,
                            fundingicons: !1,
                            layout: constants.g.HORIZONTAL
                        };
                    },
                    decorate: function(style) {
                        var label = style.label, _style$layout = style.layout, layout = void 0 === _style$layout ? constants.g.HORIZONTAL : _style$layout;
                        if (!label && layout === constants.g.HORIZONTAL) {
                            style.label = constants.f.CHECKOUT;
                            return style;
                        }
                        if (!label && layout === constants.g.VERTICAL) {
                            style.label = constants.f.PAYPAL;
                            return style;
                        }
                        return style;
                    },
                    validate: function(style, props) {
                        void 0 === style && (style = {});
                        validateButtonStyle(style, props);
                        Object(beaver_logger_client.h)();
                    }
                },
                validate: {
                    type: "function",
                    required: !1,
                    decorate: function(validate) {
                        return function(actions) {
                            if (!this.validateCalled) {
                                this.validateCalled = !0;
                                return validate(actions);
                            }
                        };
                    }
                },
                logLevel: {
                    type: "string",
                    required: !1,
                    get value() {
                        return config.a.logLevel;
                    }
                },
                sdkMeta: {
                    type: "string",
                    queryParam: !0,
                    sendToChild: !1,
                    def: function() {
                        return Object(belter_src.a)(JSON.stringify({
                            url: Object(lib.l)()
                        }));
                    }
                },
                awaitPopupBridge: {
                    type: "object",
                    required: !1,
                    value: function() {
                        return awaitPopupBridge(component_Button);
                    }
                },
                getPageUrl: {
                    type: "function",
                    queryParam: !1,
                    required: !1,
                    def: function() {
                        return function() {
                            return window.location.href;
                        };
                    }
                },
                test: {
                    type: "object",
                    required: !1,
                    def: function() {
                        return {
                            action: "checkout"
                        };
                    }
                }
            }
        });
        var instances = component_Button.instances = [];
        var _render = component_Button.render;
        component_Button.render = function(props) {
            void 0 === props && (props = {});
            for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) args[_key - 1] = arguments[_key];
            var instance = {
                clone: function(_temp3) {
                    var _ref6$decorate = (void 0 === _temp3 ? {} : _temp3).decorate, decorate = void 0 === _ref6$decorate ? belter_src.d : _ref6$decorate;
                    return {
                        render: function(container) {
                            var decoratedProps = decorate(props);
                            return _render.call(component_Button, decoratedProps, container);
                        }
                    };
                }
            };
            instances.push(instance);
            var _props = props, _props$onDestroy = _props.onDestroy, onDestroy = void 0 === _props$onDestroy ? belter_src.q : _props$onDestroy;
            var newProps = Object(esm_extends.a)({}, props, {
                onDestroy: function() {
                    var index = instances.indexOf(instance);
                    -1 !== index && instances.splice(index, 1);
                    return onDestroy.apply(this, arguments);
                }
            });
            return _render.call.apply(_render, [ component_Button, newProps ].concat(args));
        };
        component_Button.isChild() && function(ButtonComponent) {
            !function(Checkout, Button) {
                var popupBridge;
                awaitPopupBridge(Button).then((function(bridge) {
                    popupBridge = bridge;
                }));
                function doRender(props, original) {
                    return popupBridge ? function(props, popupBridge) {
                        return zalgo_promise_src.a.try((function() {
                            !function(props) {
                                if (!props.payment) throw new Error("Expected props.payment to be passed");
                                if (!props.onAuthorize) throw new Error("Expected props.onAuthorize to be passed");
                                if (props.env && !config.a.checkoutUrls[props.env]) throw new Error("Invalid props.env: " + props.env);
                            }(props);
                        })).then((function() {
                            return function(props) {
                                var _normalizeCheckoutPro = normalizeCheckoutProps(props), env = _normalizeCheckoutPro.env;
                                return zalgo_promise_src.a.try(_normalizeCheckoutPro.payment, {
                                    props: props
                                }).then((function(token) {
                                    var _extendUrl;
                                    if (!token) throw new Error("Expected props.payment to return a payment id or token");
                                    return Object(lib.g)(Object(integrations_checkout.b)(env, constants.v.PAYPAL, token), ((_extendUrl = {})[Object(integrations_checkout.a)(token)] = token, 
                                    _extendUrl.useraction = props.commit ? "commit" : "", _extendUrl.native_xo = "1", 
                                    _extendUrl));
                                }));
                            }(props);
                        })).then((function(url) {
                            return popupBridge.open(url);
                        })).then((function(payload) {
                            var opType = payload.queryItems.opType;
                            var _normalizeCheckoutPro2 = normalizeCheckoutProps(props), onAuthorize = _normalizeCheckoutPro2.onAuthorize, onCancel = _normalizeCheckoutPro2.onCancel;
                            var data = function(query) {
                                var data = {
                                    paymentToken: query.token,
                                    billingToken: query.ba_token,
                                    paymentID: query.paymentId,
                                    payerID: query.PayerID,
                                    intent: query.intent
                                };
                                var opType = query.opType, cancel_uri = query.cancel_uri;
                                "payment" === opType ? data.returnUrl = query.return_uri : "cancel" === opType && (data.cancelUrl = cancel_uri);
                                return data;
                            }(payload.queryItems);
                            var actions = function(query) {
                                var actions = {
                                    close: src_lib.F,
                                    closeComponent: src_lib.F
                                };
                                var opType = query.opType, return_uri = query.return_uri, cancel_uri = query.cancel_uri;
                                "payment" === opType ? actions.redirect = function(win, redirectUrl) {
                                    void 0 === win && (win = window);
                                    void 0 === redirectUrl && (redirectUrl = return_uri);
                                    return Object(lib.O)(win, redirectUrl);
                                } : "cancel" === opType && (actions.redirect = function(win, redirectUrl) {
                                    void 0 === win && (win = window);
                                    void 0 === redirectUrl && (redirectUrl = cancel_uri);
                                    return Object(lib.O)(win, redirectUrl);
                                });
                                return actions;
                            }(payload.queryItems);
                            if ("payment" === opType) return onAuthorize(data, actions);
                            if ("cancel" === opType) return onCancel(data, actions);
                            throw new Error("Invalid opType: " + opType);
                        })).catch((function(err) {
                            if (err && "PAYMENT_CANCELLED" === err.code) return (0, normalizeCheckoutProps(props).onCancel)({}, {});
                            throw err;
                        }));
                    }(props, popupBridge).catch((function(err) {
                        Object(beaver_logger_client.g)("popup_bridge_error", {
                            err: Object(lib.T)(err)
                        });
                        return original();
                    })) : original();
                }
                var render = Checkout.render;
                Checkout.render = function(props) {
                    var _arguments = arguments, _this = this;
                    return doRender(props, (function() {
                        return render.apply(_this, _arguments);
                    }));
                };
                var renderTo = Checkout.renderTo;
                Checkout.renderTo = function(win, props) {
                    var _arguments2 = arguments, _this2 = this;
                    return doRender(props, (function() {
                        return renderTo.apply(_this2, _arguments2);
                    }));
                };
                var renderPopupTo = Checkout.renderPopupTo;
                Checkout.renderPopupTo = function(win, props) {
                    var _arguments3 = arguments, _this3 = this;
                    return doRender(props, (function() {
                        return renderPopupTo.apply(_this3, _arguments3);
                    }));
                };
            }(src_checkout.a, ButtonComponent);
            Object(lib.p)().then((function(pageRenderTime) {
                var _track;
                var fundingSources = [].slice.call(document.querySelectorAll("[" + constants.c.FUNDING_SOURCE + "]")).map((function(el) {
                    return el.getAttribute(constants.c.CARD) || el.getAttribute(constants.c.FUNDING_SOURCE);
                })).filter((function(source) {
                    return source && source !== constants.v.CARD;
                }));
                var xprops = ButtonComponent.xprops;
                if (xprops) {
                    var _ref = xprops.style || {}, _ref$layout = _ref.layout, layout = void 0 === _ref$layout ? constants.g.HORIZONTAL : _ref$layout, _ref$color = _ref.color, color = void 0 === _ref$color ? constants.e.GOLD : _ref$color, _ref$size = _ref.size, size = void 0 === _ref$size ? constants.l.SMALL : _ref$size, _ref$shape = _ref.shape, shape = void 0 === _ref$shape ? constants.k.PILL : _ref$shape, _ref$label = _ref.label, label = void 0 === _ref$label ? constants.f.CHECKOUT : _ref$label, maxbuttons = _ref.maxbuttons, tagline = _ref.tagline;
                    Object(beaver_logger_client.p)(((_track = {})[constants.u.KEY.STATE] = constants.u.STATE.BUTTON, 
                    _track[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.BUTTON_LOAD, _track[constants.u.KEY.BUTTON_TYPE] = constants.u.BUTTON_TYPE.IFRAME, 
                    _track[constants.u.KEY.FUNDING_LIST] = fundingSources.join(":"), _track[constants.u.KEY.FUNDING_COUNT] = fundingSources.length, 
                    _track[constants.u.KEY.PAGE_LOAD_TIME] = pageRenderTime, _track[constants.u.KEY.BUTTON_LAYOUT] = layout, 
                    _track[constants.u.KEY.BUTTON_COLOR] = color, _track[constants.u.KEY.BUTTON_SIZE] = size, 
                    _track[constants.u.KEY.BUTTON_SHAPE] = shape, _track[constants.u.KEY.BUTTON_LABEL] = label, 
                    _track[constants.u.KEY.BUTTON_WIDTH] = window.innerWidth, _track[constants.u.KEY.MAX_BUTTONS] = maxbuttons, 
                    _track[constants.u.KEY.BUTTON_TAGLINE_ENABLED] = tagline ? "1" : "0", _track));
                    Object(beaver_logger_client.h)();
                }
            }));
            var xprops = ButtonComponent.xprops || src_checkout.a.xprops;
            xprops && xprops.logLevel && Object(lib.S)(xprops.logLevel);
            xprops.payment && !xprops.createOrder && (xprops.createOrder = xprops.payment);
            xprops.onAuthorize && !xprops.onApprove && (xprops.onApprove = xprops.onAuthorize);
            try {
                xprops && xprops.onShippingChange && window.pre && window.pre.inlineGuest && window.pre.inlineGuest.res && window.pre.inlineGuest.res.data && window.pre.inlineGuest.res.data.treatments && (window.pre.inlineGuest.res.data.treatments = []);
            } catch (err) {}
        }(component_Button);
        Object(belter_src.i)() && Object(lib.m)("ie_full_page") && (src_checkout.a.renderTo = function(win) {
            Object(beaver_logger_client.k)("force_ie_full_page");
            Object(beaver_logger_client.h)();
            var checkout = src_checkout.a.init({
                onAuthorize: belter_src.q
            });
            checkout.delegate(win);
            checkout.openContainer().then((function() {
                checkout.event.triggerOnce(src.a.EVENTS.CLOSE);
                checkout.showContainer();
            }));
            component_Button.xprops.payment().then((function(token) {
                window.top.location = Object(lib.g)(config.a.checkoutUrl, {
                    token: token
                });
            })).catch((function(err) {
                checkout.error(err);
            }));
        });
        var hacks_parent = Object(cross_domain_utils_src.n)(window);
        var hacks_top = Object(cross_domain_utils_src.o)(window);
        if (hacks_top && hacks_parent) {
            var canRenderTop = hacks_top === hacks_parent;
            if (!canRenderTop) {
                src_checkout.a.canRenderTo(hacks_top).then((function(result) {
                    canRenderTop = result;
                }));
                Object(lib.M)(src_checkout.a, "renderTo", (function(_ref) {
                    var _ref$args = _ref.args, win = _ref$args[0], props = _ref$args[1], el = _ref$args[2], original = _ref.original, context = _ref.context;
                    canRenderTop || (win = Object(cross_domain_utils_src.n)(window));
                    return original.call(context, win, props, el);
                }));
            }
        }
        Object(lib.M)(src_checkout.a, "renderTo", (function(_ref2) {
            var callOriginal = _ref2.callOriginal, props = _ref2.args[1];
            if (Object(lib.m)("allow_full_page_fallback")) {
                var handleError = Object(lib.K)((function(err) {
                    try {
                        console.error(err && err.stack);
                    } catch (err2) {}
                    return component_Button.xprops.payment().then((function(token) {
                        window.top.location = Object(lib.g)(config.a.checkoutUrl, {
                            token: token
                        });
                    }));
                }));
                props.onError = handleError;
                return callOriginal().catch(handleError);
            }
            return callOriginal();
        }));
        var debounce = !1;
        Object(lib.M)(src_checkout.a, "renderTo", (function(_ref3) {
            var callOriginal = _ref3.callOriginal, props = _ref3.args[1];
            if (debounce) {
                Object(beaver_logger_client.q)("button_mutliple_click_debounce");
                return new zalgo_promise_src.a(belter_src.q);
            }
            debounce = !0;
            var _loop = function(_i2, _ref5) {
                var methodName = _ref5[_i2];
                var original = props[methodName];
                props[methodName] = function() {
                    debounce = !1;
                    if (original) return original.apply(this, arguments);
                };
            };
            for (var _i2 = 0, _ref5 = [ "onAuthorize", "onCancel", "onError", "onClose" ]; _i2 < _ref5.length; _i2++) _loop(_i2, _ref5);
            return callOriginal();
        }));
        Object(lib.M)(rest.payment, "create", (function(_ref6) {
            var _ref6$args = _ref6.args, options = _ref6$args[2];
            options.payment || (options = {
                payment: options,
                experience: _ref6$args[3]
            });
            return _ref6.original.call(_ref6.context, _ref6$args[0], _ref6$args[1], options);
        }));
        Object(lib.M)(component_Button.props.style, "validate", (function(_ref7) {
            var callOriginal = _ref7.callOriginal, style = _ref7.args[0];
            if (!style) return callOriginal();
            style && "creditblue" === style.color && (style.color = constants.e.DARKBLUE);
            style && "generic" === style.label && (style.label = constants.f.PAYPAL);
            if (style && (!style.label || style.label === constants.f.CHECKOUT) && "tiny" === style.size) {
                Object(beaver_logger_client.q)("unsupported_button_size_tiny");
                style.size = constants.l.SMALL;
            }
            return callOriginal();
        }));
        Object(lib.M)(component_Button, "render", (function(_ref8) {
            var callOriginal = _ref8.callOriginal, props = _ref8.args[0];
            if (props.billingAgreement) {
                props.payment = props.billingAgreement;
                delete props.billingAgreement;
            }
            return callOriginal();
        }));
        Object(lib.M)(component_Button.props.payment, "decorate", (function(_ref9) {
            var originalPayment = _ref9.args[0];
            return _ref9.original.call(_ref9.context, (function(data, actions) {
                var _this = this;
                return new zalgo_promise_src.a((function(resolve, reject) {
                    Object(lib.M)(actions.payment, "create", (function(_ref10) {
                        var _ref10$args = _ref10.args, options = _ref10$args[0];
                        options.payment || (options = {
                            payment: options,
                            experience: _ref10$args[1]
                        });
                        return _ref10.original.call(_ref10.context, options);
                    }));
                    function resolveData(token) {
                        resolve(token);
                    }
                    function rejectActions(err) {
                        reject(err);
                    }
                    Object(lib.f)(resolveData, data);
                    Object(lib.f)(resolveData, actions);
                    Object(lib.f)(rejectActions, actions);
                    var ctx = {
                        props: {
                            env: _this.props.env,
                            client: _this.props.client
                        }
                    };
                    var result;
                    try {
                        result = originalPayment.call(ctx, resolveData, rejectActions);
                    } catch (err) {
                        return reject(err);
                    }
                    return result && "function" == typeof result.then ? result.then(resolve, reject) : void 0 !== result ? resolve(result) : void 0;
                }));
            }));
        }));
        component_Button.isChild() && (window.Promise || (window.Promise = zalgo_promise_src.a));
        var Card = Object(src.c)({
            tag: "card-fields",
            name: "ppcard",
            buildUrl: function(props) {
                return config.a.inlinedCardFieldUrls[props.env || config.a.env];
            },
            contexts: {
                iframe: !0,
                popup: !1
            },
            dimensions: {
                height: "300px",
                width: "100%"
            },
            autoResize: {
                height: !0,
                width: !1
            },
            props: {
                sessionID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.w)();
                    },
                    queryParam: !0
                },
                token: {
                    type: "string",
                    required: !0,
                    queryParam: !0
                },
                buttonSessionID: {
                    type: "string",
                    required: !1,
                    def: function() {
                        return Object(lib.j)();
                    },
                    queryParam: !0
                },
                commit: {
                    type: "boolean",
                    required: !1,
                    queryParam: !0
                },
                env: {
                    type: "string",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return config.a.env;
                    },
                    validate: function(env) {
                        if (!config.a.paypalUrls[env]) throw new Error("Invalid env: " + env);
                    }
                },
                locale: {
                    type: "string",
                    required: !1,
                    queryParam: "locale.x",
                    allowDelegate: !0,
                    def: function() {
                        var _getBrowserLocale = Object(lib.i)();
                        return _getBrowserLocale.lang + "_" + _getBrowserLocale.country;
                    }
                },
                initialFormValues: {
                    type: "object",
                    required: !1
                },
                onAuthorize: {
                    type: "function",
                    required: !0,
                    once: !0
                },
                onAuth: {
                    type: "function",
                    required: !1,
                    sameDomain: !0
                },
                onEvent: {
                    type: "function",
                    required: !1,
                    sameDomain: !0
                },
                getState: {
                    type: "function",
                    required: !1,
                    sameDomain: !0
                },
                dispatch: {
                    type: "object",
                    required: !1,
                    sameDomain: !0
                },
                onCancel: {
                    type: "function",
                    required: !1,
                    once: !0,
                    noop: !0
                },
                sdkMeta: {
                    type: "string",
                    queryParam: !0,
                    sendToChild: !1,
                    def: function() {
                        return Object(belter_src.a)(JSON.stringify({
                            url: Object(lib.l)()
                        }));
                    }
                },
                style: {
                    type: "object",
                    required: !1,
                    queryParam: !0,
                    def: function() {
                        return {
                            cardIcons: {
                                display: !1
                            },
                            submitButton: {
                                display: !0
                            },
                            currencyConversion: {
                                display: !0
                            }
                        };
                    }
                }
            }
        });
        (currentDomainEnv = function(domain) {
            for (var _i2 = 0, _Object$keys2 = Object.keys(config.a.paypalUrls); _i2 < _Object$keys2.length; _i2++) {
                var env = _Object$keys2[_i2];
                if (config.a.paypalUrls[env] === domain) return env;
            }
        }(window.location.protocol + "//" + window.location.host)) && "test" !== currentDomainEnv && (config.a.env = currentDomainEnv);
        var currentDomainEnv;
        zalgo_promise_src.a.onPossiblyUnhandledException((function(err) {
            var _track;
            Object(beaver_logger_client.g)("unhandled_error", {
                stack: Object(lib.T)(err),
                errtype: {}.toString.call(err)
            });
            Object(beaver_logger_client.p)(((_track = {})[constants.u.KEY.ERROR_CODE] = "checkoutjs_error", 
            _track[constants.u.KEY.ERROR_DESC] = Object(lib.U)(err), _track));
            return Object(beaver_logger_client.h)().catch((function(err2) {
                if (window.console) try {
                    window.console.error ? window.console.error("Error flushing:", Object(lib.T)(err2)) : window.console.log && window.console.log("Error flushing:", Object(lib.T)(err2));
                } catch (err3) {
                    setTimeout((function() {
                        throw err3;
                    }), 1);
                }
            }));
        }));
        var currentScript = Object(lib.k)();
        var currentProtocol = window.location.protocol.split(":")[0];
        var init = Object(lib.K)((function(_ref2) {
            var precacheRemembered = _ref2.precacheRemembered;
            Object(lib.C)() || Object(beaver_logger_client.q)("ineligible");
            Object(lib.c)();
            Object(lib.A)();
            pptm.shouldCreateInitialPptmScript() && pptm.createPptmScript();
            precacheRemembered && Object(lib.N)();
            Object(lib.m)("force_bridge") && !Object(lib.E)() && Object(lib.L)(config.a.env);
            Object(beaver_logger_client.k)("setup_" + config.a.env);
            Object(beaver_logger_client.f)("current_protocol_" + currentProtocol);
        }));
        function setup(options) {
            void 0 === options && (options = {});
            !function(_temp) {
                var _ref = void 0 === _temp ? {} : _temp, env = _ref.env, stage = _ref.stage, stageUrl = _ref.stageUrl, apiStage = _ref.apiStage, localhostUrl = _ref.localhostUrl, checkoutUri = _ref.checkoutUri, state = _ref.state, logLevel = _ref.logLevel, merchantID = _ref.merchantID, authCode = _ref.authCode;
                if (env) {
                    if (!config.a.paypalUrls[env]) throw new Error("Invalid env: " + env);
                    delete config.a.env;
                    config.a.env = env;
                } else if (component_Button.xprops && component_Button.xprops.env) {
                    delete config.a.env;
                    config.a.env = component_Button.xprops.env;
                } else if (src_checkout.a.xprops && src_checkout.a.xprops.env) {
                    delete config.a.env;
                    config.a.env = src_checkout.a.xprops.env;
                }
                if (stage) {
                    delete config.a.stage;
                    config.a.stage = stage;
                } else if (component_Button.xprops && component_Button.xprops.stage) {
                    delete config.a.stage;
                    config.a.stage = component_Button.xprops.stage;
                } else if (src_checkout.a.xprops && src_checkout.a.xprops.stage) {
                    delete config.a.stage;
                    config.a.stage = src_checkout.a.xprops.stage;
                }
                if (stageUrl) {
                    delete config.a.stageUrl;
                    config.a.stageUrl = stageUrl;
                } else if (component_Button.xprops && component_Button.xprops.stageUrl) {
                    delete config.a.stageUrl;
                    config.a.stageUrl = component_Button.xprops.stageUrl;
                } else if (src_checkout.a.xprops && src_checkout.a.xprops.stageUrl) {
                    delete config.a.stageUrl;
                    config.a.stageUrl = src_checkout.a.xprops.stageUrl;
                }
                if (authCode = authCode || component_Button.xprops && component_Button.xprops.authCode || src_checkout.a.xprops && src_checkout.a.xprops.authCode) {
                    delete config.a.authCode;
                    config.a.authCode = authCode;
                }
                if (apiStage) {
                    delete config.a.apiStage;
                    config.a.apiStage = apiStage;
                }
                (localhostUrl = localhostUrl || component_Button.xprops && component_Button.xprops.localhostUrl || src_checkout.a.xprops && src_checkout.a.xprops.localhostUrl) && (config.a.localhostUrl = localhostUrl);
                (checkoutUri = checkoutUri || component_Button.xprops && component_Button.xprops.checkoutUri || src_checkout.a.xprops && src_checkout.a.xprops.checkoutUri) && (config.a.checkoutUri = checkoutUri);
                if (state) {
                    delete config.a.state;
                    config.a.state = state;
                }
                merchantID && (config.a.merchantID = merchantID);
                logLevel ? Object(lib.S)(logLevel) : Object(lib.S)(config.a.logLevel);
            }(options);
            init(options);
        }
        currentScript ? setup({
            env: currentScript.getAttribute("data-env"),
            stage: currentScript.getAttribute("data-stage"),
            apiStage: currentScript.getAttribute("data-api-stage"),
            stageUrl: currentScript.getAttribute("data-stage-url"),
            localhostUrl: Object(lib.E)() ? currentScript.getAttribute("data-localhost-url") : void 0,
            checkoutUri: Object(lib.E)() ? currentScript.getAttribute("data-checkout-uri") : void 0,
            state: currentScript.getAttribute("data-state"),
            logLevel: currentScript.getAttribute("data-log-level"),
            merchantID: currentScript.getAttribute("data-merchant-id"),
            authCode: currentScript.getAttribute("data-auth-code"),
            precacheRemembered: currentScript.hasAttribute("data-precache-remembered-funding")
        }) : setup();
        if (!Object(lib.E)()) if (currentScript) {
            var setup_track2;
            var scriptProtocol = currentScript.src.split(":")[0];
            var loadTime = Object(lib.t)(currentScript.src);
            Object(beaver_logger_client.f)("current_script_protocol_" + scriptProtocol);
            Object(beaver_logger_client.f)("current_script_protocol_" + (currentProtocol === scriptProtocol ? "match" : "mismatch"));
            Object(beaver_logger_client.f)("current_script_version_" + config.a.version.replace(/[^0-9a-zA-Z]+/g, "_"));
            if (loadTime) {
                Object(beaver_logger_client.f)("current_script_time", {
                    loadTime: loadTime
                });
                Object(beaver_logger_client.f)("current_script_time_" + Math.floor(loadTime / 1e3));
            }
            Object(beaver_logger_client.p)(((setup_track2 = {})[constants.u.KEY.STATE] = constants.u.STATE.LOAD, 
            setup_track2[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.SCRIPT_LOAD, setup_track2[constants.u.KEY.TRANSITION_TIME] = loadTime, 
            setup_track2[constants.u.KEY.FUNDING_REMEMBERED] = Object(lib.r)().join(","), setup_track2));
        } else {
            var setup_track3;
            Object(beaver_logger_client.f)("no_current_script");
            Object(beaver_logger_client.f)("no_current_script_version_" + config.a.version.replace(/[^0-9a-zA-Z]+/g, "_"));
            document.currentScript && Object(beaver_logger_client.f)("current_script_not_recognized", {
                src: document.currentScript.src
            });
            Object(beaver_logger_client.p)(((setup_track3 = {})[constants.u.KEY.STATE] = constants.u.STATE.LOAD, 
            setup_track3[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.SCRIPT_LOAD, setup_track3));
        }
        var postRobot = post_robot_src;
        var onPossiblyUnhandledException = zalgo_promise_src.a.onPossiblyUnhandledException;
        var interface_version = "4.0.331";
        var interface_checkout;
        var apps;
        var legacy = __webpack_require__(49);
        interface_checkout = legacy.checkout;
        apps = legacy.apps;
        var interface_Checkout;
        var interface_BillingPage;
        var PayPalCheckout;
        var destroyAll;
        var enableCheckoutIframe;
        var logger;
        var interface_ThreeDomainSecure;
        if (Object(lib.E)()) {
            interface_Checkout = src_checkout.a;
            interface_BillingPage = BillingPage;
            interface_ThreeDomainSecure = ThreeDomainSecure;
            PayPalCheckout = src_checkout.a;
            enableCheckoutIframe = function() {
                src_checkout.a.contexts.iframe = !0;
            };
            destroyAll = src.d;
            logger = {
                debug: beaver_logger_client.f,
                info: beaver_logger_client.k,
                warn: beaver_logger_client.q,
                error: beaver_logger_client.g,
                track: beaver_logger_client.p,
                flush: beaver_logger_client.h
            };
        }
        __webpack_exports__.default = interface_namespaceObject;
    }, function(module, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        __webpack_require__.d(__webpack_exports__, "renderButtons", (function() {
            return renderButtons;
        }));
        __webpack_require__.d(__webpack_exports__, "getHijackTargetElement", (function() {
            return getHijackTargetElement;
        }));
        __webpack_require__.d(__webpack_exports__, "LOG_PREFIX", (function() {
            return LOG_PREFIX;
        }));
        __webpack_require__.d(__webpack_exports__, "ATTRIBUTES", (function() {
            return ATTRIBUTES;
        }));
        __webpack_require__.d(__webpack_exports__, "CLASSES", (function() {
            return CLASSES;
        }));
        __webpack_require__.d(__webpack_exports__, "checkout", (function() {
            return interface_checkout;
        }));
        __webpack_require__.d(__webpack_exports__, "apps", (function() {
            return apps;
        }));
        __webpack_require__.d(__webpack_exports__, "reset", (function() {
            return interface_reset;
        }));
        __webpack_require__.d(__webpack_exports__, "setup", (function() {
            return setup;
        }));
        var client = __webpack_require__(5);
        var lib = __webpack_require__(4);
        var constants = __webpack_require__(0);
        var LOG_PREFIX = "paypal_legacy";
        var ATTRIBUTES = {
            BUTTON: "data-paypal-button",
            MERCHANT_ID: "data-paypal-id",
            ENV: "data-env",
            SANDBOX: "data-sandbox"
        };
        var CLASSES = {
            HIDDEN_BUTTON: "paypal-button-hidden"
        };
        var esm_extends = __webpack_require__(13);
        var src = __webpack_require__(2);
        var form_serialize = __webpack_require__(44);
        var form_serialize_default = __webpack_require__.n(form_serialize);
        var belter_src = __webpack_require__(11);
        var checkout = __webpack_require__(17);
        var config = __webpack_require__(3);
        var post_robot_src = __webpack_require__(15);
        function isLegacyEligible() {
            return !!Object(lib.C)() && !!Object(belter_src.t)() && !Object(belter_src.h)();
        }
        var warn = Object(client.n)(LOG_PREFIX).warn;
        var DEFAULT_COUNTRY = constants.r.US;
        var DEFAULT_LANG = constants.y.EN;
        function normalizeLocale(locale) {
            var _locale$split = locale.split("_"), lang = _locale$split[0], country = _locale$split[1];
            if (!country) if (constants.A[lang]) {
                country = lang;
                lang = null;
            } else country = DEFAULT_COUNTRY;
            if (!constants.A[country]) {
                warn("invalid_user_country", {
                    country: country
                });
                country = DEFAULT_COUNTRY;
            }
            lang || (lang = DEFAULT_LANG);
            if (-1 === constants.A[country].indexOf(lang)) {
                warn("invalid_user_lang", {
                    lang: lang
                });
                lang = -1 !== constants.A[country].indexOf(DEFAULT_LANG) ? DEFAULT_LANG : constants.A[country][0];
            }
            return {
                country: country,
                lang: lang
            };
        }
        var button_prefix = Object(client.n)(LOG_PREFIX), info = button_prefix.info, debug = button_prefix.debug, error = button_prefix.error;
        var loadButtonJS = Object(lib.H)((function() {
            debug("buttonjs_load");
            return Object(lib.G)(config.a.buttonJSUrl).catch((function(err) {
                info("buttonjs_load_error_retry", {
                    error: Object(lib.T)(err)
                });
                return Object(lib.G)(config.a.buttonJSUrl);
            })).then((function(result) {
                debug("buttonjs_load_success");
                return result;
            })).catch((function(err) {
                error("buttonjs_load_error", {
                    error: Object(lib.T)(err)
                });
                throw err;
            }));
        }));
        function renderButtons(id, buttons) {
            return src.a.map(buttons, (function(button) {
                return src.a.try((function() {
                    return button.container ? function(id, _ref) {
                        var container = _ref.container, locale = _ref.locale, type = _ref.type, color = _ref.color, shape = _ref.shape, size = _ref.size;
                        return loadButtonJS().then((function() {
                            if (locale) {
                                var _normalizeLocale = normalizeLocale(locale);
                                locale = _normalizeLocale.lang + "_" + _normalizeLocale.country;
                            }
                            color = color || constants.e.GOLD;
                            shape = shape || constants.k.PILL;
                            size = size || constants.l.SMALL;
                            type = type || constants.f.CHECKOUT;
                            debug("render_button_lc_" + (locale = locale || config.a.locale.lang + "_" + config.a.locale.country));
                            debug("render_button_color_" + color);
                            debug("render_button_shape_" + shape);
                            debug("render_button_size_" + size);
                            debug("render_button_label_" + type);
                            var el = window.paypal.button.create(id, {
                                lc: locale,
                                color: color,
                                shape: shape,
                                size: size
                            }, {
                                type: "button",
                                label: type
                            }).el;
                            container.appendChild(el);
                            try {
                                info("in_page_button_" + (Object(lib.B)(el) ? "visible" : "not_visible"));
                            } catch (err) {}
                            return el.childNodes[0];
                        }));
                    }(id, button) : button.button;
                })).then((function(element) {
                    var container;
                    var type;
                    if (button.container) {
                        container = button.container;
                        type = constants.u.BUTTON_TYPE.HTML;
                    } else {
                        container = button.button;
                        type = constants.u.BUTTON_TYPE.CUSTOM;
                    }
                    return {
                        container: container,
                        element: element,
                        type: type,
                        condition: button.condition,
                        click: button.click
                    };
                }));
            }));
        }
        function getHijackTargetElement(button) {
            var form = button.form;
            if (form) {
                debug("target_element_button_form");
                return form;
            }
            var tagName = button.tagName && button.tagName.toLowerCase();
            if ("a" === tagName) {
                debug("target_element_link");
                return button;
            }
            var parentElement = button.parentElement;
            var parentTagName = parentElement && parentElement.tagName && parentElement.tagName.toLowerCase();
            if (("img" === tagName || "button" === tagName) && "a" === parentTagName) {
                debug("target_element_parent_link");
                return parentElement;
            }
            var grandparentElement = parentElement && parentElement.parentElement;
            var grandparentTagName = grandparentElement && grandparentElement.tagName && grandparentElement.tagName.toLowerCase();
            if ("button" === tagName && "a" === grandparentTagName) {
                debug("target_element_grandparent_link");
                return button.parentElement && button.parentElement.parentElement;
            }
        }
        var util_warn = Object(client.n)(LOG_PREFIX).warn;
        var redirected = !1;
        function logRedirect(location) {
            redirected && util_warn("multiple_redirects");
            Object(lib.W)(location) && (redirected = !0);
            Object(client.h)();
        }
        function redirect(url) {
            return src.a.try((function() {
                if (!url) throw new Error("Redirect url undefined");
                if (config.a.env === constants.t.TEST && Object(lib.W)(url)) return Object(lib.O)(window, "#fullpageRedirect?url=" + url);
                logRedirect(url);
                return Object(lib.O)(window, url);
            }));
        }
        var options_prefix = Object(client.n)(LOG_PREFIX), options_info = options_prefix.info, options_warn = options_prefix.warn;
        var interface_prefix = Object(client.n)(LOG_PREFIX), interface_info = interface_prefix.info, interface_debug = interface_prefix.debug, interface_warn = interface_prefix.warn, interface_error = interface_prefix.error, track = interface_prefix.track;
        var interface_checkout = {};
        var apps = {
            checkout: interface_checkout,
            Checkout: interface_checkout
        };
        function interface_reset() {
            interface_debug("reset");
            interface_checkout.initXO = initXO;
            interface_checkout.startFlow = startFlow;
            interface_checkout.closeFlow = closeFlow;
        }
        interface_checkout.reset = interface_reset;
        Object.defineProperty(interface_checkout, "urlPrefix", {
            get: function() {
                return config.a.checkoutUrl + (-1 === config.a.checkoutUrl.indexOf("?") ? "?" : "&") + "token=";
            }
        });
        function matchUrlAndPaymentToken(item) {
            if (!item || !item.trim()) {
                interface_error("startflow_no_url_or_token", {
                    item: item
                });
                throw new Error("startflow_no_url_or_token");
            }
            var paymentToken = function(token) {
                if (token) {
                    if ((token = decodeURIComponent(decodeURIComponent(token))).match(/^(EC-)?[A-Z0-9]{17}$/)) return token;
                    var match = token.match(/token=((EC-)?[A-Z0-9]{17})/);
                    return match || (match = token.match(/(EC-[A-Z0-9]{17})/)) ? match[1] : void 0;
                }
            }(item);
            var url = paymentToken && paymentToken === item ? "" : item;
            if (url) if (url.match(/^https?:\/\/|^\//)) paymentToken ? -1 !== url.indexOf(".paypal.com") ? interface_debug("startflow_paypalurl_with_token", {
                url: url
            }) : interface_debug("startflow_url_with_token", {
                url: url
            }) : interface_debug("startflow_url_no_token", {
                url: url
            }); else {
                interface_info(paymentToken ? "startflow_relative_url_with_token" : "startflow_relative_url_no_token", {
                    url: url
                });
                0 === url.toLowerCase().indexOf("ec-") && paymentToken && (url = "" + config.a.checkoutUrl + url);
            } else {
                if (!paymentToken) {
                    interface_error("startflow_no_url_or_token", {
                        url: url
                    });
                    throw new Error('Could not determine url or token from "' + item + '"');
                }
                url = Object(lib.g)(config.a.checkoutUrl, {
                    token: paymentToken
                });
                interface_debug("startflow_with_token", {
                    url: url
                });
            }
            return {
                paymentToken: paymentToken,
                url: url
            };
        }
        function checkUrlAgainstEnv(url) {
            var paypalUrls = config.a.paypalUrls;
            for (var _i2 = 0, _Object$keys2 = Object.keys(paypalUrls); _i2 < _Object$keys2.length; _i2++) {
                var env = _Object$keys2[_i2];
                var paypalUrl = paypalUrls[env];
                if (env !== constants.t.TEST && env !== constants.t.DEMO && env !== config.a.env && (0 === url.indexOf(paypalUrl) || 0 === url.indexOf(paypalUrl.replace("//www.", "//")))) {
                    interface_warn("mismatched_env_startflow_url", {
                        env: config.a.env,
                        url: url
                    });
                    redirect(url);
                    throw new Error(url + " is not a " + config.a.env + " url");
                }
            }
        }
        function awaitPaymentTokenAndUrl(event, targetElement) {
            var paymentTokenAndUrl = new src.a((function(resolve) {
                if (event && targetElement && (Math.random() < .001 || window.enablev3ajax)) {
                    var method;
                    var _url;
                    var body;
                    var contentType;
                    interface_info("gettoken_targetelement_start");
                    Object(client.h)();
                    if ("a" === targetElement.tagName.toLowerCase()) {
                        method = "get";
                        _url = targetElement.getAttribute("href");
                    } else if ("form" === targetElement.tagName.toLowerCase()) {
                        method = (targetElement.getAttribute("method") || "get").toLowerCase();
                        _url = targetElement.getAttribute("action");
                        body = form_serialize_default()(targetElement);
                        contentType = targetElement.getAttribute("enctype") || "application/x-www-form-urlencoded";
                    }
                    if (method && _url) {
                        event.preventDefault();
                        Object(lib.Q)({
                            method: method,
                            url: _url,
                            body: body,
                            headers: {
                                Accept: "application/paypal-json-token",
                                "Content-type": contentType || ""
                            }
                        }).then((function(json) {
                            var urlAndPaymentToken = matchUrlAndPaymentToken(json.token);
                            resolve(urlAndPaymentToken);
                            interface_info("gettoken_targetelement_success", urlAndPaymentToken);
                            Object(client.h)();
                        })).catch((function(err) {
                            interface_warn("gettoken_targetelement_error", {
                                err: err.stack || err.toString()
                            });
                            Object(client.h)();
                        }));
                    } else {
                        interface_warn("gettoken_targetelement_no_method_or_url");
                        Object(client.h)();
                    }
                }
                interface_checkout.initXO = function() {
                    interface_warn("gettoken_initxo");
                };
                interface_checkout.startFlow = Object(lib.K)((function(item) {
                    interface_debug("gettoken_startflow", {
                        item: item
                    });
                    var _matchUrlAndPaymentTo = matchUrlAndPaymentToken(item), url = _matchUrlAndPaymentTo.url, paymentToken = _matchUrlAndPaymentTo.paymentToken;
                    checkUrlAgainstEnv(url);
                    return resolve({
                        url: url,
                        paymentToken: paymentToken
                    });
                }));
            }));
            return {
                url: paymentTokenAndUrl.then((function(result) {
                    return result.url;
                })),
                paymentToken: paymentTokenAndUrl.then((function(result) {
                    return result.paymentToken;
                }))
            };
        }
        var paypalCheckoutInited = !1;
        var closeFlowCalled = !1;
        function initPayPalCheckout(props) {
            void 0 === props && (props = {});
            interface_info("init_checkout");
            paypalCheckoutInited && config.a.env !== constants.t.TEST && interface_warn("multiple_init_paypal_checkout");
            closeFlowCalled && interface_debug("init_after_closeflow");
            paypalCheckoutInited = !0;
            var paypalCheckout = checkout.a.init(Object(esm_extends.a)({
                onAuthorize: function(data, actions) {
                    interface_info("payment_authorized");
                    logRedirect(data.returnUrl);
                    return actions.redirect(window);
                },
                onCancel: function(data, actions) {
                    if (data.cancelUrl) {
                        interface_info("payment_canceled");
                        logRedirect(data.cancelUrl);
                        return actions.redirect(window);
                    }
                },
                fallback: function(url) {
                    interface_error("fallback_handler", {
                        url: url
                    });
                    this.destroy();
                    return redirect(url);
                }
            }, props));
            interface_checkout.closeFlow = function(closeUrl) {
                interface_warn("closeflow");
                closeFlowCalled = !0;
                interface_reset();
                paypalCheckout.destroy();
                if (closeUrl) {
                    interface_warn("closeflow_with_url", {
                        closeUrl: closeUrl
                    });
                    return redirect(closeUrl);
                }
            };
            return paypalCheckout;
        }
        function renderPayPalCheckout(props, hijackTarget) {
            void 0 === props && (props = {});
            var urlProp = src.a.resolve(props.url);
            var paymentToken = new src.a((function(resolve) {
                props.init = function(data) {
                    resolve(data.paymentToken);
                };
            }));
            var errorHandler = Object(lib.K)((function(err) {
                interface_error("component_error", {
                    error: Object(lib.T)(err)
                });
                if (hijackTarget) {
                    interface_warn("render_error_hijack_revert_target");
                    hijackTarget.removeAttribute("target");
                }
                urlProp.then((function(url) {
                    interface_warn("render_error_redirect_using_url");
                    return redirect(url);
                }));
                paymentToken.then((function(token) {
                    interface_warn("render_error_redirect_using_token");
                    return redirect(Object(lib.g)(config.a.checkoutUrl, {
                        token: token
                    }));
                }));
            }));
            props.onError = errorHandler;
            var paypalCheckout;
            if (hijackTarget) {
                delete props.url;
                (paypalCheckout = initPayPalCheckout(props)).hijack(hijackTarget);
                paypalCheckout.runTimeout();
                urlProp.then((function(url) {
                    interface_warn("hijack_then_url_passed");
                    paypalCheckout.loadUrl(url);
                }));
            } else paypalCheckout = initPayPalCheckout(props);
            var render = paypalCheckout.render(null, !hijackTarget);
            interface_checkout.win = paypalCheckout.window;
            return render.catch(errorHandler);
        }
        function instrumentButtonRender(type) {
            var _track;
            interface_info("render_" + type + "_button");
            track(((_track = {})[constants.u.KEY.STATE] = constants.u.STATE.LOAD, _track[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.BUTTON_RENDER, 
            _track[constants.u.KEY.BUTTON_TYPE] = type, _track));
            Object(client.h)();
        }
        var setupCalled = !1;
        function setup(id, options) {
            void 0 === options && (options = {});
            interface_info("setup", {
                id: id = id || "merchant",
                env: options.environment,
                options: Object(lib.R)(options)
            });
            setupCalled && interface_debug("setup_called_multiple_times");
            setupCalled = !0;
            !function(options) {
                if (options.environment) {
                    "live" === options.environment && (options.environment = constants.t.PRODUCTION);
                    if (!config.a.paypalUrls[options.environment]) {
                        options_warn("invalid_env", {
                            badenv: options.environment
                        });
                        options.environment = config.a.env;
                    }
                }
                if (options.button && !Array.isArray(options.button)) {
                    options_info("options_button_single_button_passed");
                    options.button = [ options.button ];
                }
                if (options.buttons && Object(lib.o)(options.buttons).length) {
                    options_info("options_buttons_with_elements_passed");
                    options.button = options.buttons;
                    delete options.buttons;
                }
                if (options.button && 0 === options.button.length) {
                    options_info("options_button_empty");
                    delete options.button;
                }
                if (options.button && options.container) {
                    options_info("options_button_and_container_passed", {
                        button: options.button,
                        container: options.container
                    });
                    options.button = options.button.concat(options.container);
                    delete options.container;
                }
                if (options.button) {
                    var button = Object(lib.o)(options.button);
                    if (button.length) options.button = button; else {
                        options_warn("options_button_element_not_found", {
                            element: JSON.stringify(options.button)
                        });
                        delete options.button;
                    }
                }
                if (options.button) {
                    options.buttons = options.button.map((function(button) {
                        return {
                            button: button,
                            click: options.click,
                            condition: options.condition
                        };
                    }));
                    delete options.click;
                    delete options.condition;
                    delete options.button;
                } else if (options.buttons && Array.isArray(options.buttons)) {
                    var buttons = [];
                    options.buttons.forEach((function(button) {
                        if (button) {
                            button.container && button.container !== options.container && options_warn("mismatched_container_and_button_passed", {
                                options: options.container,
                                button: button.container
                            });
                            Object(lib.o)(button.container || button.button).forEach((function(element) {
                                var _buttons$push;
                                buttons.push(((_buttons$push = {})[button.container ? "container" : "button"] = element, 
                                _buttons$push.click = button.click || options.click, _buttons$push.condition = button.condition || options.condition, 
                                _buttons$push.type = button.type || options.type, _buttons$push.locale = button.locale || options.locale, 
                                _buttons$push.color = button.color || options.color, _buttons$push.shape = button.shape || options.shape, 
                                _buttons$push.size = button.size || options.size, _buttons$push));
                            }));
                        }
                    }));
                    delete options.buttons;
                    delete options.click;
                    delete options.condition;
                    delete options.button;
                    delete options.type;
                    delete options.locale;
                    delete options.color;
                    delete options.shape;
                    delete options.size;
                    buttons.length && (options.buttons = buttons);
                } else if (options.container && !Array.isArray(options.buttons)) {
                    var _buttons = [];
                    Object(lib.o)(options.container).forEach((function(container, i) {
                        _buttons.push({
                            container: container,
                            click: options.click,
                            condition: options.condition,
                            type: Array.isArray(options.type) ? options.type[i] : options.type,
                            locale: Array.isArray(options.locale) ? options.locale[i] : options.locale,
                            color: Array.isArray(options.color) ? options.color[i] : options.color,
                            shape: Array.isArray(options.shape) ? options.shape[i] : options.shape,
                            size: Array.isArray(options.size) ? options.size[i] : options.size
                        });
                    }));
                    delete options.container;
                    delete options.buttons;
                    delete options.click;
                    delete options.condition;
                    delete options.button;
                    delete options.type;
                    delete options.locale;
                    delete options.color;
                    delete options.shape;
                    delete options.size;
                    _buttons.length && (options.buttons = _buttons);
                }
                options.buttons || (options.buttons = []);
            }(options);
            !function(options) {
                options.environment && config.a.paypalUrls[options.environment] && (config.a.env = options.environment);
                if (options.locale) {
                    config.a.locale = normalizeLocale(options.locale);
                    config.a.customCountry = !0;
                }
            }(options);
            env = config.a.env, src.a.try((function() {
                if (!post_robot_src.bridge || !post_robot_src.bridge.needsBridge({
                    domain: config.a.paypalDomains[env]
                })) return Object(client.f)("post_bridge_not_required", {
                    env: env
                });
                Object(client.f)("setup_post_bridge", {
                    env: env
                });
                return Object(lib.L)(env).then(lib.I);
            }));
            var env;
            return src.a.try((function() {
                return options.buttons.length ? renderButtons(id, options.buttons).then((function(buttons) {
                    buttons.forEach((function(button) {
                        instrumentButtonRender(button.type);
                        !function(container, button, clickHandler, condition, tracker) {
                            var element = "a" === container.tagName.toLowerCase() ? container : button;
                            var isClick = "function" == typeof clickHandler;
                            if (element.hasAttribute("data-paypal-click-listener")) return interface_warn("button_already_has_paypal_click_listener");
                            element.setAttribute("data-paypal-click-listener", "");
                            getHijackTargetElement(element) && isClick && interface_info("button_link_or_form");
                            element.addEventListener("click", (function(event) {
                                tracker();
                                var eligible = isLegacyEligible();
                                if (Object(belter_src.t)()) {
                                    interface_debug("click_popups_supported");
                                    eligible || interface_debug("click_popups_supported_but_ineligible");
                                } else {
                                    interface_debug("click_popups_not_supported");
                                    eligible && interface_debug("click_popups_not_supported_but_eligible");
                                }
                                if (!isClick && !eligible) return interface_debug("ineligible_listenclick");
                                interface_info("button_click");
                                if ("function" == typeof condition) {
                                    if (!condition.call()) return interface_info("button_click_condition_disabled");
                                    interface_info("button_click_condition_enabled");
                                }
                                return isClick ? function(clickHandler, event) {
                                    interface_debug("button_click_handler");
                                    try {
                                        clickHandler(event);
                                    } catch (err) {
                                        interface_error("click_handler_error", {
                                            error: Object(lib.T)(err)
                                        });
                                    }
                                }(clickHandler, event) : function(event, element) {
                                    var targetElement = getHijackTargetElement(element);
                                    if (!targetElement) return interface_error("target_element_not_found");
                                    interface_info("init_paypal_checkout_hijack");
                                    var _awaitPaymentTokenAnd = awaitPaymentTokenAndUrl(event, targetElement), url = _awaitPaymentTokenAnd.url;
                                    var token;
                                    _awaitPaymentTokenAnd.paymentToken.then((function(result) {
                                        token = result;
                                    }));
                                    renderPayPalCheckout({
                                        url: url,
                                        payment: function() {
                                            return src.a.resolve(token);
                                        }
                                    }, targetElement);
                                }(event, element);
                            }));
                        }(button.container, button.element, button.click, button.condition, (function() {
                            !function(type) {
                                var _track2;
                                track(((_track2 = {})[constants.u.KEY.STATE] = constants.u.STATE.LOAD, _track2[constants.u.KEY.TRANSITION] = constants.u.TRANSITION.BUTTON_CLICK, 
                                _track2[constants.u.KEY.BUTTON_TYPE] = type, _track2));
                                Object(client.h)();
                            }(button.type);
                        }));
                    }));
                })) : instrumentButtonRender(constants.u.BUTTON_TYPE.CUSTOM);
            }));
        }
        interface_checkout.setup = setup;
        function initXO() {
            interface_debug("initxo");
            if (!isLegacyEligible()) return interface_debug("ineligible_initxo");
            var _awaitPaymentTokenAnd2 = awaitPaymentTokenAndUrl(), url = _awaitPaymentTokenAnd2.url, paymentToken = _awaitPaymentTokenAnd2.paymentToken;
            interface_info("init_paypal_checkout_initxo");
            renderPayPalCheckout({
                url: url,
                payment: function() {
                    return paymentToken;
                }
            });
        }
        interface_checkout.initXO = initXO;
        function startFlow(item) {
            interface_debug("startflow", {
                item: item
            });
            var _matchUrlAndPaymentTo2 = matchUrlAndPaymentToken(item), paymentToken = _matchUrlAndPaymentTo2.paymentToken, url = _matchUrlAndPaymentTo2.url;
            checkUrlAgainstEnv(url);
            if (isLegacyEligible()) {
                interface_info("init_paypal_checkout_startflow");
                renderPayPalCheckout({
                    url: url,
                    payment: function() {
                        return src.a.resolve(paymentToken);
                    }
                });
            } else {
                interface_debug("ineligible_startflow_global", {
                    url: url
                });
                redirect(url);
            }
        }
        interface_checkout.startFlow = startFlow;
        function closeFlow(closeUrl) {
            interface_warn("closeflow_not_opened");
            if (closeUrl) {
                interface_warn("closeflow_with_url", {
                    closeUrl: closeUrl
                });
                redirect(closeUrl);
            }
        }
        interface_checkout.closeFlow = closeFlow;
        var ready_prefix = Object(client.n)(LOG_PREFIX), ready_error = ready_prefix.error, ready_debug = ready_prefix.debug;
        !function(obj, key, callback) {
            if (obj) {
                var value = obj[key];
                value && (value = callback(value) || value);
                try {
                    delete obj[key];
                    Object.defineProperty(obj, key, {
                        configurable: !0,
                        set: function(item) {
                            (value = item) && (value = callback(value) || value);
                        },
                        get: function() {
                            return value;
                        }
                    });
                } catch (err) {}
            }
        }(window, "paypalCheckoutReady", (function(method) {
            if ("function" == typeof method) {
                var oneTimeReady = function() {
                    if (!method.called) {
                        method.called = !0;
                        return method.apply(this, arguments);
                    }
                };
                !function(method) {
                    Object(lib.J)((function() {
                        ready_debug("paypal_checkout_ready");
                        setTimeout((function() {
                            window.paypal || ready_error("paypal_checkout_ready_no_window_paypal");
                            method();
                        }), 1);
                    }));
                }(oneTimeReady);
                return oneTimeReady;
            }
        }));
        Object(lib.J)((function() {
            var buttons = [].slice.call(document.querySelectorAll("[" + ATTRIBUTES.BUTTON + "]"));
            if (buttons && buttons.length) {
                ready_debug("data_paypal_button", {
                    number: buttons.length
                });
                for (var _i2 = 0; _i2 < buttons.length; _i2++) {
                    var button = buttons[_i2];
                    var id = button.getAttribute(ATTRIBUTES.MERCHANT_ID);
                    var environment = void 0;
                    button.hasAttribute(ATTRIBUTES.ENV) ? environment = button.getAttribute(ATTRIBUTES.ENV) : button.hasAttribute(ATTRIBUTES.SANDBOX) && (environment = constants.t.SANDBOX);
                    setup(id, {
                        environment: environment,
                        button: button
                    });
                }
            }
            [].slice.call(document.getElementsByClassName(CLASSES.HIDDEN_BUTTON)).forEach((function(el) {
                el.className = el.className.replace(CLASSES.HIDDEN_BUTTON, "");
            }));
        }));
    } ]);
}));


//////////////////
// WEBPACK FOOTER
// ./~/paypal-checkout/dist/checkout.lib.js
// module id = 495
// module chunks = 1